var pv = Object.defineProperty;
var mv = (e, t, r) => t in e ? pv(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var gi = (e, t, r) => mv(e, typeof t != "symbol" ? t + "" : t, r);
function Le(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var gv = typeof Symbol == "function" && Symbol.observable || "@@observable", qc = gv, bi = () => Math.random().toString(36).substring(7).split("").join("."), bv = {
  INIT: `@@redux/INIT${/* @__PURE__ */ bi()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ bi()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${bi()}`
}, jt = bv;
function nn(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function vv(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  const t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (_v(e))
    return "date";
  if (wv(e))
    return "error";
  const r = yv(e);
  switch (r) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return r;
  }
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function yv(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function wv(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function _v(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function xt(e) {
  let t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = vv(e)), t;
}
function ym(e, t, r) {
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? Le(2) : `Expected the root reducer to be a function. Instead, received: '${xt(e)}'`);
  if (typeof t == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? Le(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof r > "u" && (r = t, t = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Le(1) : `Expected the enhancer to be a function. Instead, received: '${xt(r)}'`);
    return r(ym)(e, t);
  }
  let i = e, n = t, o = /* @__PURE__ */ new Map(), s = o, a = 0, u = !1;
  function l() {
    s === o && (s = /* @__PURE__ */ new Map(), o.forEach((w, v) => {
      s.set(v, w);
    }));
  }
  function c() {
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? Le(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return n;
  }
  function d(w) {
    if (typeof w != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Le(4) : `Expected the listener to be a function. Instead, received: '${xt(w)}'`);
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? Le(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    let v = !0;
    l();
    const g = a++;
    return s.set(g, w), function() {
      if (v) {
        if (u)
          throw new Error(process.env.NODE_ENV === "production" ? Le(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        v = !1, l(), s.delete(g), o = null;
      }
    };
  }
  function h(w) {
    if (!nn(w))
      throw new Error(process.env.NODE_ENV === "production" ? Le(7) : `Actions must be plain objects. Instead, the actual type was: '${xt(w)}'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.`);
    if (typeof w.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Le(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (typeof w.type != "string")
      throw new Error(process.env.NODE_ENV === "production" ? Le(17) : `Action "type" property must be a string. Instead, the actual type was: '${xt(w.type)}'. Value was: '${w.type}' (stringified)`);
    if (u)
      throw new Error(process.env.NODE_ENV === "production" ? Le(9) : "Reducers may not dispatch actions.");
    try {
      u = !0, n = i(n, w);
    } finally {
      u = !1;
    }
    return (o = s).forEach((g) => {
      g();
    }), w;
  }
  function f(w) {
    if (typeof w != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Le(10) : `Expected the nextReducer to be a function. Instead, received: '${xt(w)}`);
    i = w, h({
      type: jt.REPLACE
    });
  }
  function p() {
    const w = d;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(v) {
        if (typeof v != "object" || v === null)
          throw new Error(process.env.NODE_ENV === "production" ? Le(11) : `Expected the observer to be an object. Instead, received: '${xt(v)}'`);
        function g() {
          const b = v;
          b.next && b.next(c());
        }
        return g(), {
          unsubscribe: w(g)
        };
      },
      [qc]() {
        return this;
      }
    };
  }
  return h({
    type: jt.INIT
  }), {
    dispatch: h,
    subscribe: d,
    getState: c,
    replaceReducer: f,
    [qc]: p
  };
}
function zc(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function kv(e, t, r, i) {
  const n = Object.keys(t), o = r && r.type === jt.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (n.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!nn(e))
    return `The ${o} has unexpected type of "${xt(e)}". Expected argument to be an object with the following keys: "${n.join('", "')}"`;
  const s = Object.keys(e).filter((a) => !t.hasOwnProperty(a) && !i[a]);
  if (s.forEach((a) => {
    i[a] = !0;
  }), !(r && r.type === jt.REPLACE) && s.length > 0)
    return `Unexpected ${s.length > 1 ? "keys" : "key"} "${s.join('", "')}" found in ${o}. Expected to find one of the known reducer keys instead: "${n.join('", "')}". Unexpected keys will be ignored.`;
}
function xv(e) {
  Object.keys(e).forEach((t) => {
    const r = e[t];
    if (typeof r(void 0, {
      type: jt.INIT
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Le(12) : `The slice reducer for key "${t}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof r(void 0, {
      type: jt.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Le(13) : `The slice reducer for key "${t}" returned undefined when probed with a random type. Don't try to handle '${jt.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
  });
}
function wm(e) {
  const t = Object.keys(e), r = {};
  for (let s = 0; s < t.length; s++) {
    const a = t[s];
    process.env.NODE_ENV !== "production" && typeof e[a] > "u" && zc(`No reducer provided for key "${a}"`), typeof e[a] == "function" && (r[a] = e[a]);
  }
  const i = Object.keys(r);
  let n;
  process.env.NODE_ENV !== "production" && (n = {});
  let o;
  try {
    xv(r);
  } catch (s) {
    o = s;
  }
  return function(a = {}, u) {
    if (o)
      throw o;
    if (process.env.NODE_ENV !== "production") {
      const d = kv(a, r, u, n);
      d && zc(d);
    }
    let l = !1;
    const c = {};
    for (let d = 0; d < i.length; d++) {
      const h = i[d], f = r[h], p = a[h], m = f(p, u);
      if (typeof m > "u") {
        const w = u && u.type;
        throw new Error(process.env.NODE_ENV === "production" ? Le(14) : `When called with an action of type ${w ? `"${String(w)}"` : "(unknown type)"}, the slice reducer for key "${h}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      c[h] = m, l = l || m !== p;
    }
    return l = l || i.length !== Object.keys(a).length, l ? c : a;
  };
}
function jn(...e) {
  return e.length === 0 ? (t) => t : e.length === 1 ? e[0] : e.reduce((t, r) => (...i) => t(r(...i)));
}
function Sv(...e) {
  return (t) => (r, i) => {
    const n = t(r, i);
    let o = () => {
      throw new Error(process.env.NODE_ENV === "production" ? Le(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
    };
    const s = {
      getState: n.getState,
      dispatch: (u, ...l) => o(u, ...l)
    }, a = e.map((u) => u(s));
    return o = jn(...a)(n.dispatch), {
      ...n,
      dispatch: o
    };
  };
}
function _m(e) {
  return nn(e) && "type" in e && typeof e.type == "string";
}
var km = Symbol.for("immer-nothing"), Uc = Symbol.for("immer-draftable"), qe = Symbol.for("immer-state"), Ev = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function He(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const r = Ev[e], i = Mt(r) ? r.apply(null, t) : r;
    throw new Error(`[Immer] ${i}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var Ke = Object, Yt = Ke.getPrototypeOf, Fn = "constructor", Gn = "prototype", yu = "configurable", $n = "enumerable", On = "writable", Kr = "value", pt = (e) => !!e && !!e[qe];
function Ze(e) {
  var t;
  return e ? xm(e) || Wn(e) || !!e[Uc] || !!((t = e[Fn]) != null && t[Uc]) || Hn(e) || Kn(e) : !1;
}
var Av = Ke[Gn][Fn].toString(), Vc = /* @__PURE__ */ new WeakMap();
function xm(e) {
  if (!e || !Nu(e))
    return !1;
  const t = Yt(e);
  if (t === null || t === Ke[Gn])
    return !0;
  const r = Ke.hasOwnProperty.call(t, Fn) && t[Fn];
  if (r === Object)
    return !0;
  if (!Mt(r))
    return !1;
  let i = Vc.get(r);
  return i === void 0 && (i = Function.toString.call(r), Vc.set(r, i)), i === Av;
}
function on(e, t, r = !0) {
  an(e) === 0 ? (r ? Reflect.ownKeys(e) : Ke.keys(e)).forEach((n) => {
    t(n, e[n], e);
  }) : e.forEach((i, n) => t(n, i, e));
}
function an(e) {
  const t = e[qe];
  return t ? t.type_ : Wn(e) ? 1 : Hn(e) ? 2 : Kn(e) ? 3 : 0;
}
var Gc = (e, t, r = an(e)) => r === 2 ? e.has(t) : Ke[Gn].hasOwnProperty.call(e, t), wu = (e, t, r = an(e)) => (
  // @ts-ignore
  r === 2 ? e.get(t) : e[t]
), Ln = (e, t, r, i = an(e)) => {
  i === 2 ? e.set(t, r) : i === 3 ? e.add(r) : e[t] = r;
};
function Tv(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var Wn = Array.isArray, Hn = (e) => e instanceof Map, Kn = (e) => e instanceof Set, Nu = (e) => typeof e == "object", Mt = (e) => typeof e == "function", vi = (e) => typeof e == "boolean", ft = (e) => e.copy_ || e.base_, Bu = (e) => e.modified_ ? e.copy_ : e.base_;
function _u(e, t) {
  if (Hn(e))
    return new Map(e);
  if (Kn(e))
    return new Set(e);
  if (Wn(e))
    return Array[Gn].slice.call(e);
  const r = xm(e);
  if (t === !0 || t === "class_only" && !r) {
    const i = Ke.getOwnPropertyDescriptors(e);
    delete i[qe];
    let n = Reflect.ownKeys(i);
    for (let o = 0; o < n.length; o++) {
      const s = n[o], a = i[s];
      a[On] === !1 && (a[On] = !0, a[yu] = !0), (a.get || a.set) && (i[s] = {
        [yu]: !0,
        [On]: !0,
        // could live with !!desc.set as well here...
        [$n]: a[$n],
        [Kr]: e[s]
      });
    }
    return Ke.create(Yt(e), i);
  } else {
    const i = Yt(e);
    if (i !== null && r)
      return { ...e };
    const n = Ke.create(i);
    return Ke.assign(n, e);
  }
}
function qu(e, t = !1) {
  return Qn(e) || pt(e) || !Ze(e) || (an(e) > 1 && Ke.defineProperties(e, {
    set: vn,
    add: vn,
    clear: vn,
    delete: vn
  }), Ke.freeze(e), t && on(
    e,
    (r, i) => {
      qu(i, !0);
    },
    !1
  )), e;
}
function Cv() {
  He(2);
}
var vn = {
  [Kr]: Cv
};
function Qn(e) {
  return e === null || !Nu(e) ? !0 : Ke.isFrozen(e);
}
var Nn = "MapSet", ku = "Patches", Sm = {};
function Jt(e) {
  const t = Sm[e];
  return t || He(0, e), t;
}
var Rv = (e) => !!Sm[e], Qr, Em = () => Qr, Ov = (e, t) => ({
  drafts_: [],
  parent_: e,
  immer_: t,
  // Whenever the modified draft contains a draft from another scope, we
  // need to prevent auto-freezing so the unowned draft can be finalized.
  canAutoFreeze_: !0,
  unfinalizedDrafts_: 0,
  handledSet_: /* @__PURE__ */ new Set(),
  processedForPatches_: /* @__PURE__ */ new Set(),
  mapSetPlugin_: Rv(Nn) ? Jt(Nn) : void 0
});
function Wc(e, t) {
  t && (e.patchPlugin_ = Jt(ku), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function xu(e) {
  Su(e), e.drafts_.forEach(Dv), e.drafts_ = null;
}
function Su(e) {
  e === Qr && (Qr = e.parent_);
}
var Hc = (e) => Qr = Ov(Qr, e);
function Dv(e) {
  const t = e[qe];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function Kc(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const r = t.drafts_[0];
  if (e !== void 0 && e !== r) {
    r[qe].modified_ && (xu(t), He(4)), Ze(e) && (e = Qc(t, e));
    const { patchPlugin_: n } = t;
    n && n.generateReplacementPatches_(
      r[qe].base_,
      e,
      t
    );
  } else
    e = Qc(t, r);
  return Pv(t, e, !0), xu(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== km ? e : void 0;
}
function Qc(e, t) {
  if (Qn(t))
    return t;
  const r = t[qe];
  if (!r)
    return zu(t, e.handledSet_, e);
  if (!Yn(r, e))
    return t;
  if (!r.modified_)
    return r.base_;
  if (!r.finalized_) {
    const { callbacks_: i } = r;
    if (i)
      for (; i.length > 0; )
        i.pop()(e);
    Cm(r, e);
  }
  return r.copy_;
}
function Pv(e, t, r = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && qu(t, r);
}
function Am(e) {
  e.finalized_ = !0, e.scope_.unfinalizedDrafts_--;
}
var Yn = (e, t) => e.scope_ === t, Iv = [];
function Tm(e, t, r, i) {
  const n = ft(e), o = e.type_;
  if (i !== void 0 && wu(n, i, o) === t) {
    Ln(n, i, r, o);
    return;
  }
  if (!e.draftLocations_) {
    const a = e.draftLocations_ = /* @__PURE__ */ new Map();
    on(n, (u, l) => {
      if (pt(l)) {
        const c = a.get(l) || [];
        c.push(u), a.set(l, c);
      }
    });
  }
  const s = e.draftLocations_.get(t) ?? Iv;
  for (const a of s)
    Ln(n, a, r, o);
}
function Mv(e, t, r) {
  e.callbacks_.push(function(n) {
    var a;
    const o = t;
    if (!o || !Yn(o, n))
      return;
    (a = n.mapSetPlugin_) == null || a.fixSetContents(o);
    const s = Bu(o);
    Tm(e, o.draft_ ?? o, s, r), Cm(o, n);
  });
}
function Cm(e, t) {
  var i;
  if (e.modified_ && !e.finalized_ && (e.type_ === 3 || (((i = e.assigned_) == null ? void 0 : i.size) ?? 0) > 0)) {
    const { patchPlugin_: n } = t;
    if (n) {
      const o = n.getPath(e);
      o && n.generatePatches_(e, o, t);
    }
    Am(e);
  }
}
function jv(e, t, r) {
  const { scope_: i } = e;
  if (pt(r)) {
    const n = r[qe];
    Yn(n, i) && n.callbacks_.push(function() {
      Dn(e);
      const s = Bu(n);
      Tm(e, r, s, t);
    });
  } else Ze(r) && e.callbacks_.push(function() {
    const o = ft(e);
    wu(o, t, e.type_) === r && i.drafts_.length > 1 && (e.assigned_.get(t) ?? !1) === !0 && e.copy_ && zu(
      wu(e.copy_, t, e.type_),
      i.handledSet_,
      i
    );
  });
}
function zu(e, t, r) {
  return !r.immer_.autoFreeze_ && r.unfinalizedDrafts_ < 1 || pt(e) || t.has(e) || !Ze(e) || Qn(e) || (t.add(e), on(e, (i, n) => {
    if (pt(n)) {
      const o = n[qe];
      if (Yn(o, r)) {
        const s = Bu(o);
        Ln(e, i, s, e.type_), Am(o);
      }
    } else Ze(n) && zu(n, t, r);
  })), e;
}
function Fv(e, t) {
  const r = Wn(e), i = {
    type_: r ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : Em(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    // actually instantiated in `prepareCopy()`
    assigned_: void 0,
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1,
    // `callbacks` actually gets assigned in `createProxy`
    callbacks_: void 0
  };
  let n = i, o = Uu;
  r && (n = [i], o = Yr);
  const { revoke: s, proxy: a } = Proxy.revocable(n, o);
  return i.draft_ = a, i.revoke_ = s, [a, i];
}
var Uu = {
  get(e, t) {
    if (t === qe)
      return e;
    const r = ft(e);
    if (!Gc(r, t, e.type_))
      return $v(e, r, t);
    const i = r[t];
    if (e.finalized_ || !Ze(i))
      return i;
    if (i === yi(e.base_, t)) {
      Dn(e);
      const n = e.type_ === 1 ? +t : t, o = Au(e.scope_, i, e, n);
      return e.copy_[n] = o;
    }
    return i;
  },
  has(e, t) {
    return t in ft(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(ft(e));
  },
  set(e, t, r) {
    const i = Rm(ft(e), t);
    if (i != null && i.set)
      return i.set.call(e.draft_, r), !0;
    if (!e.modified_) {
      const n = yi(ft(e), t), o = n == null ? void 0 : n[qe];
      if (o && o.base_ === r)
        return e.copy_[t] = r, e.assigned_.set(t, !1), !0;
      if (Tv(r, n) && (r !== void 0 || Gc(e.base_, t, e.type_)))
        return !0;
      Dn(e), Eu(e);
    }
    return e.copy_[t] === r && // special case: handle new props with value 'undefined'
    (r !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(r) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = r, e.assigned_.set(t, !0), jv(e, t, r)), !0;
  },
  deleteProperty(e, t) {
    return Dn(e), yi(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_.set(t, !1), Eu(e)) : e.assigned_.delete(t), e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const r = ft(e), i = Reflect.getOwnPropertyDescriptor(r, t);
    return i && {
      [On]: !0,
      [yu]: e.type_ !== 1 || t !== "length",
      [$n]: i[$n],
      [Kr]: r[t]
    };
  },
  defineProperty() {
    He(11);
  },
  getPrototypeOf(e) {
    return Yt(e.base_);
  },
  setPrototypeOf() {
    He(12);
  }
}, Yr = {};
on(Uu, (e, t) => {
  Yr[e] = function() {
    const r = arguments;
    return r[0] = r[0][0], t.apply(this, r);
  };
});
Yr.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && He(13), Yr.set.call(this, e, t, void 0);
};
Yr.set = function(e, t, r) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && He(14), Uu.set.call(this, e[0], t, r, e[0]);
};
function yi(e, t) {
  const r = e[qe];
  return (r ? ft(r) : e)[t];
}
function $v(e, t, r) {
  var n;
  const i = Rm(t, r);
  return i ? Kr in i ? i[Kr] : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (n = i.get) == null ? void 0 : n.call(e.draft_)
  ) : void 0;
}
function Rm(e, t) {
  if (!(t in e))
    return;
  let r = Yt(e);
  for (; r; ) {
    const i = Object.getOwnPropertyDescriptor(r, t);
    if (i)
      return i;
    r = Yt(r);
  }
}
function Eu(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && Eu(e.parent_));
}
function Dn(e) {
  e.copy_ || (e.assigned_ = /* @__PURE__ */ new Map(), e.copy_ = _u(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var Lv = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !1, this.produce = (t, r, i) => {
      if (Mt(t) && !Mt(r)) {
        const o = r;
        r = t;
        const s = this;
        return function(u = o, ...l) {
          return s.produce(u, (c) => r.call(this, c, ...l));
        };
      }
      Mt(r) || He(6), i !== void 0 && !Mt(i) && He(7);
      let n;
      if (Ze(t)) {
        const o = Hc(this), s = Au(o, t, void 0);
        let a = !0;
        try {
          n = r(s), a = !1;
        } finally {
          a ? xu(o) : Su(o);
        }
        return Wc(o, i), Kc(n, o);
      } else if (!t || !Nu(t)) {
        if (n = r(t), n === void 0 && (n = t), n === km && (n = void 0), this.autoFreeze_ && qu(n, !0), i) {
          const o = [], s = [];
          Jt(ku).generateReplacementPatches_(t, n, {
            patches_: o,
            inversePatches_: s
          }), i(o, s);
        }
        return n;
      } else
        He(1, t);
    }, this.produceWithPatches = (t, r) => {
      if (Mt(t))
        return (s, ...a) => this.produceWithPatches(s, (u) => t(u, ...a));
      let i, n;
      return [this.produce(t, r, (s, a) => {
        i = s, n = a;
      }), i, n];
    }, vi(e == null ? void 0 : e.autoFreeze) && this.setAutoFreeze(e.autoFreeze), vi(e == null ? void 0 : e.useStrictShallowCopy) && this.setUseStrictShallowCopy(e.useStrictShallowCopy), vi(e == null ? void 0 : e.useStrictIteration) && this.setUseStrictIteration(e.useStrictIteration);
  }
  createDraft(e) {
    Ze(e) || He(8), pt(e) && (e = Nv(e));
    const t = Hc(this), r = Au(t, e, void 0);
    return r[qe].isManual_ = !0, Su(t), r;
  }
  finishDraft(e, t) {
    const r = e && e[qe];
    (!r || !r.isManual_) && He(9);
    const { scope_: i } = r;
    return Wc(i, t), Kc(void 0, i);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(e) {
    this.useStrictIteration_ = e;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(e, t) {
    let r;
    for (r = t.length - 1; r >= 0; r--) {
      const n = t[r];
      if (n.path.length === 0 && n.op === "replace") {
        e = n.value;
        break;
      }
    }
    r > -1 && (t = t.slice(r + 1));
    const i = Jt(ku).applyPatches_;
    return pt(e) ? i(e, t) : this.produce(
      e,
      (n) => i(n, t)
    );
  }
};
function Au(e, t, r, i) {
  const [n, o] = Hn(t) ? Jt(Nn).proxyMap_(t, r) : Kn(t) ? Jt(Nn).proxySet_(t, r) : Fv(t, r);
  return ((r == null ? void 0 : r.scope_) ?? Em()).drafts_.push(n), o.callbacks_ = (r == null ? void 0 : r.callbacks_) ?? [], o.key_ = i, r && i !== void 0 ? Mv(r, o, i) : o.callbacks_.push(function(u) {
    var c;
    (c = u.mapSetPlugin_) == null || c.fixSetContents(o);
    const { patchPlugin_: l } = u;
    o.modified_ && l && l.generatePatches_(o, [], u);
  }), n;
}
function Nv(e) {
  return pt(e) || He(10, e), Om(e);
}
function Om(e) {
  if (!Ze(e) || Qn(e))
    return e;
  const t = e[qe];
  let r, i = !0;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, r = _u(e, t.scope_.immer_.useStrictShallowCopy_), i = t.scope_.immer_.shouldUseStrictIteration();
  } else
    r = _u(e, !0);
  return on(
    r,
    (n, o) => {
      Ln(r, n, Om(o));
    },
    i
  ), t && (t.finalized_ = !1), r;
}
var Bv = new Lv(), Dm = Bv.produce;
function Pm(e) {
  return ({ dispatch: r, getState: i }) => (n) => (o) => typeof o == "function" ? o(r, i, e) : n(o);
}
var qv = Pm(), zv = Pm, Uv = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? jn : jn.apply(null, arguments);
}, Im = (e) => e && typeof e.match == "function";
function Wr(e, t) {
  function r(...i) {
    if (t) {
      let n = t(...i);
      if (!n)
        throw new Error(process.env.NODE_ENV === "production" ? Ce(0) : "prepareAction did not return an object");
      return {
        type: e,
        payload: n.payload,
        ..."meta" in n && {
          meta: n.meta
        },
        ..."error" in n && {
          error: n.error
        }
      };
    }
    return {
      type: e,
      payload: i[0]
    };
  }
  return r.toString = () => `${e}`, r.type = e, r.match = (i) => _m(i) && i.type === e, r;
}
function Vv(e) {
  return typeof e == "function" && "type" in e && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
  Im(e);
}
function Gv(e) {
  const t = e ? `${e}`.split("/") : [], r = t[t.length - 1] || "actionCreator";
  return `Detected an action creator with type "${e || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${r}())\` instead of \`dispatch(${r})\`. This is necessary even if the action has no payload.`;
}
function Wv(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (r) => (i) => r(i);
  const {
    isActionCreator: t = Vv
  } = e;
  return () => (r) => (i) => (t(i) && console.warn(Gv(i.type)), r(i));
}
function Mm(e, t) {
  let r = 0;
  return {
    measureTime(i) {
      const n = Date.now();
      try {
        return i();
      } finally {
        const o = Date.now();
        r += o - n;
      }
    },
    warnIfExceeded() {
      r > e && console.warn(`${t} took ${r}ms, which is more than the warning threshold of ${e}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var jm = class Ur extends Array {
  constructor(...t) {
    super(...t), Object.setPrototypeOf(this, Ur.prototype);
  }
  static get [Symbol.species]() {
    return Ur;
  }
  concat(...t) {
    return super.concat.apply(this, t);
  }
  prepend(...t) {
    return t.length === 1 && Array.isArray(t[0]) ? new Ur(...t[0].concat(this)) : new Ur(...t.concat(this));
  }
};
function Yc(e) {
  return Ze(e) ? Dm(e, () => {
  }) : e;
}
function yn(e, t, r) {
  return e.has(t) ? e.get(t) : e.set(t, r(t)).get(t);
}
function Hv(e) {
  return typeof e != "object" || e == null || Object.isFrozen(e);
}
function Kv(e, t, r) {
  const i = Fm(e, t, r);
  return {
    detectMutations() {
      return $m(e, t, i, r);
    }
  };
}
function Fm(e, t = [], r, i = "", n = /* @__PURE__ */ new Set()) {
  const o = {
    value: r
  };
  if (!e(r) && !n.has(r)) {
    n.add(r), o.children = {};
    const s = t.length > 0;
    for (const a in r) {
      const u = i ? i + "." + a : a;
      s && t.some((c) => c instanceof RegExp ? c.test(u) : u === c) || (o.children[a] = Fm(e, t, r[a], u));
    }
  }
  return o;
}
function $m(e, t = [], r, i, n = !1, o = "") {
  const s = r ? r.value : void 0, a = s === i;
  if (n && !a && !Number.isNaN(i))
    return {
      wasMutated: !0,
      path: o
    };
  if (e(s) || e(i))
    return {
      wasMutated: !1
    };
  const u = {};
  for (let c in r.children)
    u[c] = !0;
  for (let c in i)
    u[c] = !0;
  const l = t.length > 0;
  for (let c in u) {
    const d = o ? o + "." + c : c;
    if (l && t.some((p) => p instanceof RegExp ? p.test(d) : d === p))
      continue;
    const h = $m(e, t, r.children[c], i[c], a, d);
    if (h.wasMutated)
      return h;
  }
  return {
    wasMutated: !1
  };
}
function Qv(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (t) => (r) => t(r);
  {
    let t = function(a, u, l, c) {
      return JSON.stringify(a, r(u, c), l);
    }, r = function(a, u) {
      let l = [], c = [];
      return u || (u = function(d, h) {
        return l[0] === h ? "[Circular ~]" : "[Circular ~." + c.slice(0, l.indexOf(h)).join(".") + "]";
      }), function(d, h) {
        if (l.length > 0) {
          var f = l.indexOf(this);
          ~f ? l.splice(f + 1) : l.push(this), ~f ? c.splice(f, 1 / 0, d) : c.push(d), ~l.indexOf(h) && (h = u.call(this, d, h));
        } else l.push(h);
        return a == null ? h : a.call(this, d, h);
      };
    }, {
      isImmutable: i = Hv,
      ignoredPaths: n,
      warnAfter: o = 32
    } = e;
    const s = Kv.bind(null, i, n);
    return ({
      getState: a
    }) => {
      let u = a(), l = s(u), c;
      return (d) => (h) => {
        const f = Mm(o, "ImmutableStateInvariantMiddleware");
        f.measureTime(() => {
          if (u = a(), c = l.detectMutations(), l = s(u), c.wasMutated)
            throw new Error(process.env.NODE_ENV === "production" ? Ce(19) : `A state mutation was detected between dispatches, in the path '${c.path || ""}'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
        });
        const p = d(h);
        return f.measureTime(() => {
          if (u = a(), c = l.detectMutations(), l = s(u), c.wasMutated)
            throw new Error(process.env.NODE_ENV === "production" ? Ce(20) : `A state mutation was detected inside a dispatch, in the path: ${c.path || ""}. Take a look at the reducer(s) handling the action ${t(h)}. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
        }), f.warnIfExceeded(), p;
      };
    };
  }
}
function Lm(e) {
  const t = typeof e;
  return e == null || t === "string" || t === "boolean" || t === "number" || Array.isArray(e) || nn(e);
}
function Tu(e, t = "", r = Lm, i, n = [], o) {
  let s;
  if (!r(e))
    return {
      keyPath: t || "<root>",
      value: e
    };
  if (typeof e != "object" || e === null || o != null && o.has(e)) return !1;
  const a = i != null ? i(e) : Object.entries(e), u = n.length > 0;
  for (const [l, c] of a) {
    const d = t ? t + "." + l : l;
    if (!(u && n.some((f) => f instanceof RegExp ? f.test(d) : d === f))) {
      if (!r(c))
        return {
          keyPath: d,
          value: c
        };
      if (typeof c == "object" && (s = Tu(c, d, r, i, n, o), s))
        return s;
    }
  }
  return o && Nm(e) && o.add(e), !1;
}
function Nm(e) {
  if (!Object.isFrozen(e)) return !1;
  for (const t of Object.values(e))
    if (!(typeof t != "object" || t === null) && !Nm(t))
      return !1;
  return !0;
}
function Yv(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (t) => (r) => t(r);
  {
    const {
      isSerializable: t = Lm,
      getEntries: r,
      ignoredActions: i = [],
      ignoredActionPaths: n = ["meta.arg", "meta.baseQueryMeta"],
      ignoredPaths: o = [],
      warnAfter: s = 32,
      ignoreState: a = !1,
      ignoreActions: u = !1,
      disableCache: l = !1
    } = e, c = !l && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
    return (d) => (h) => (f) => {
      if (!_m(f))
        return h(f);
      const p = h(f), m = Mm(s, "SerializableStateInvariantMiddleware");
      return !u && !(i.length && i.indexOf(f.type) !== -1) && m.measureTime(() => {
        const w = Tu(f, "", t, r, n, c);
        if (w) {
          const {
            keyPath: v,
            value: g
          } = w;
          console.error(`A non-serializable value was detected in an action, in the path: \`${v}\`. Value:`, g, `
Take a look at the logic that dispatched this action: `, f, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
        }
      }), a || (m.measureTime(() => {
        const w = d.getState(), v = Tu(w, "", t, r, o, c);
        if (v) {
          const {
            keyPath: g,
            value: A
          } = v;
          console.error(`A non-serializable value was detected in the state, in the path: \`${g}\`. Value:`, A, `
Take a look at the reducer(s) handling this action type: ${f.type}.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
        }
      }), m.warnIfExceeded()), p;
    };
  }
}
function wn(e) {
  return typeof e == "boolean";
}
var Jv = () => function(t) {
  const {
    thunk: r = !0,
    immutableCheck: i = !0,
    serializableCheck: n = !0,
    actionCreatorCheck: o = !0
  } = t ?? {};
  let s = new jm();
  if (r && (wn(r) ? s.push(qv) : s.push(zv(r.extraArgument))), process.env.NODE_ENV !== "production") {
    if (i) {
      let a = {};
      wn(i) || (a = i), s.unshift(Qv(a));
    }
    if (n) {
      let a = {};
      wn(n) || (a = n), s.push(Yv(a));
    }
    if (o) {
      let a = {};
      wn(o) || (a = o), s.unshift(Wv(a));
    }
  }
  return s;
}, Zv = "RTK_autoBatch", Jc = (e) => (t) => {
  setTimeout(t, e);
}, Xv = (e = {
  type: "raf"
}) => (t) => (...r) => {
  const i = t(...r);
  let n = !0, o = !1, s = !1;
  const a = /* @__PURE__ */ new Set(), u = e.type === "tick" ? queueMicrotask : e.type === "raf" ? (
    // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
    typeof window < "u" && window.requestAnimationFrame ? window.requestAnimationFrame : Jc(10)
  ) : e.type === "callback" ? e.queueNotification : Jc(e.timeout), l = () => {
    s = !1, o && (o = !1, a.forEach((c) => c()));
  };
  return Object.assign({}, i, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(c) {
      const d = () => n && c(), h = i.subscribe(d);
      return a.add(c), () => {
        h(), a.delete(c);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(c) {
      var d;
      try {
        return n = !((d = c == null ? void 0 : c.meta) != null && d[Zv]), o = !n, o && (s || (s = !0, u(l))), i.dispatch(c);
      } finally {
        n = !0;
      }
    }
  });
}, ey = (e) => function(r) {
  const {
    autoBatch: i = !0
  } = r ?? {};
  let n = new jm(e);
  return i && n.push(Xv(typeof i == "object" ? i : void 0)), n;
};
function ty(e) {
  const t = Jv(), {
    reducer: r = void 0,
    middleware: i,
    devTools: n = !0,
    duplicateMiddlewareCheck: o = !0,
    preloadedState: s = void 0,
    enhancers: a = void 0
  } = e || {};
  let u;
  if (typeof r == "function")
    u = r;
  else if (nn(r))
    u = wm(r);
  else
    throw new Error(process.env.NODE_ENV === "production" ? Ce(1) : "`reducer` is a required argument, and must be a function or an object of functions that can be passed to combineReducers");
  if (process.env.NODE_ENV !== "production" && i && typeof i != "function")
    throw new Error(process.env.NODE_ENV === "production" ? Ce(2) : "`middleware` field must be a callback");
  let l;
  if (typeof i == "function") {
    if (l = i(t), process.env.NODE_ENV !== "production" && !Array.isArray(l))
      throw new Error(process.env.NODE_ENV === "production" ? Ce(3) : "when using a middleware builder function, an array of middleware must be returned");
  } else
    l = t();
  if (process.env.NODE_ENV !== "production" && l.some((m) => typeof m != "function"))
    throw new Error(process.env.NODE_ENV === "production" ? Ce(4) : "each middleware provided to configureStore must be a function");
  if (process.env.NODE_ENV !== "production" && o) {
    let m = /* @__PURE__ */ new Set();
    l.forEach((w) => {
      if (m.has(w))
        throw new Error(process.env.NODE_ENV === "production" ? Ce(42) : "Duplicate middleware references found when creating the store. Ensure that each middleware is only included once.");
      m.add(w);
    });
  }
  let c = jn;
  n && (c = Uv({
    // Enable capture of stack traces for dispatched Redux actions
    trace: process.env.NODE_ENV !== "production",
    ...typeof n == "object" && n
  }));
  const d = Sv(...l), h = ey(d);
  if (process.env.NODE_ENV !== "production" && a && typeof a != "function")
    throw new Error(process.env.NODE_ENV === "production" ? Ce(5) : "`enhancers` field must be a callback");
  let f = typeof a == "function" ? a(h) : h();
  if (process.env.NODE_ENV !== "production" && !Array.isArray(f))
    throw new Error(process.env.NODE_ENV === "production" ? Ce(6) : "`enhancers` callback must return an array");
  if (process.env.NODE_ENV !== "production" && f.some((m) => typeof m != "function"))
    throw new Error(process.env.NODE_ENV === "production" ? Ce(7) : "each enhancer provided to configureStore must be a function");
  process.env.NODE_ENV !== "production" && l.length && !f.includes(d) && console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
  const p = c(...f);
  return ym(u, s, p);
}
function Bm(e) {
  const t = {}, r = [];
  let i;
  const n = {
    addCase(o, s) {
      if (process.env.NODE_ENV !== "production") {
        if (r.length > 0)
          throw new Error(process.env.NODE_ENV === "production" ? Ce(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (i)
          throw new Error(process.env.NODE_ENV === "production" ? Ce(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      const a = typeof o == "string" ? o : o.type;
      if (!a)
        throw new Error(process.env.NODE_ENV === "production" ? Ce(28) : "`builder.addCase` cannot be called with an empty action type");
      if (a in t)
        throw new Error(process.env.NODE_ENV === "production" ? Ce(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${a}'`);
      return t[a] = s, n;
    },
    addAsyncThunk(o, s) {
      if (process.env.NODE_ENV !== "production" && i)
        throw new Error(process.env.NODE_ENV === "production" ? Ce(43) : "`builder.addAsyncThunk` should only be called before calling `builder.addDefaultCase`");
      return s.pending && (t[o.pending.type] = s.pending), s.rejected && (t[o.rejected.type] = s.rejected), s.fulfilled && (t[o.fulfilled.type] = s.fulfilled), s.settled && r.push({
        matcher: o.settled,
        reducer: s.settled
      }), n;
    },
    addMatcher(o, s) {
      if (process.env.NODE_ENV !== "production" && i)
        throw new Error(process.env.NODE_ENV === "production" ? Ce(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return r.push({
        matcher: o,
        reducer: s
      }), n;
    },
    addDefaultCase(o) {
      if (process.env.NODE_ENV !== "production" && i)
        throw new Error(process.env.NODE_ENV === "production" ? Ce(31) : "`builder.addDefaultCase` can only be called once");
      return i = o, n;
    }
  };
  return e(n), [t, r, i];
}
function ry(e) {
  return typeof e == "function";
}
function ny(e, t) {
  if (process.env.NODE_ENV !== "production" && typeof t == "object")
    throw new Error(process.env.NODE_ENV === "production" ? Ce(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
  let [r, i, n] = Bm(t), o;
  if (ry(e))
    o = () => Yc(e());
  else {
    const a = Yc(e);
    o = () => a;
  }
  function s(a = o(), u) {
    let l = [r[u.type], ...i.filter(({
      matcher: c
    }) => c(u)).map(({
      reducer: c
    }) => c)];
    return l.filter((c) => !!c).length === 0 && (l = [n]), l.reduce((c, d) => {
      if (d)
        if (pt(c)) {
          const f = d(c, u);
          return f === void 0 ? c : f;
        } else {
          if (Ze(c))
            return Dm(c, (h) => d(h, u));
          {
            const h = d(c, u);
            if (h === void 0) {
              if (c === null)
                return c;
              throw Error("A case reducer on a non-draftable value must not return undefined");
            }
            return h;
          }
        }
      return c;
    }, a);
  }
  return s.getInitialState = o, s;
}
var iy = (e, t) => Im(e) ? e.match(t) : e(t);
function oy(...e) {
  return (t) => e.some((r) => iy(r, t));
}
var ay = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", sy = (e = 21) => {
  let t = "", r = e;
  for (; r--; )
    t += ay[Math.random() * 64 | 0];
  return t;
}, uy = ["name", "message", "stack", "code"], wi = class {
  constructor(e, t) {
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */
    gi(this, "_type");
    this.payload = e, this.meta = t;
  }
}, Zc = class {
  constructor(e, t) {
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */
    gi(this, "_type");
    this.payload = e, this.meta = t;
  }
}, cy = (e) => {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const r of uy)
      typeof e[r] == "string" && (t[r] = e[r]);
    return t;
  }
  return {
    message: String(e)
  };
}, Xc = "External signal was aborted", Ae = /* @__PURE__ */ (() => {
  function e(t, r, i) {
    const n = Wr(t + "/fulfilled", (u, l, c, d) => ({
      payload: u,
      meta: {
        ...d || {},
        arg: c,
        requestId: l,
        requestStatus: "fulfilled"
      }
    })), o = Wr(t + "/pending", (u, l, c) => ({
      payload: void 0,
      meta: {
        ...c || {},
        arg: l,
        requestId: u,
        requestStatus: "pending"
      }
    })), s = Wr(t + "/rejected", (u, l, c, d, h) => ({
      payload: d,
      error: (i && i.serializeError || cy)(u || "Rejected"),
      meta: {
        ...h || {},
        arg: c,
        requestId: l,
        rejectedWithValue: !!d,
        requestStatus: "rejected",
        aborted: (u == null ? void 0 : u.name) === "AbortError",
        condition: (u == null ? void 0 : u.name) === "ConditionError"
      }
    }));
    function a(u, {
      signal: l
    } = {}) {
      return (c, d, h) => {
        const f = i != null && i.idGenerator ? i.idGenerator(u) : sy(), p = new AbortController();
        let m, w;
        function v(A) {
          w = A, p.abort();
        }
        l && (l.aborted ? v(Xc) : l.addEventListener("abort", () => v(Xc), {
          once: !0
        }));
        const g = (async function() {
          var k, y;
          let A;
          try {
            let x = (k = i == null ? void 0 : i.condition) == null ? void 0 : k.call(i, u, {
              getState: d,
              extra: h
            });
            if (dy(x) && (x = await x), x === !1 || p.signal.aborted)
              throw {
                name: "ConditionError",
                message: "Aborted due to condition callback returning false."
              };
            const C = new Promise((I, M) => {
              m = () => {
                M({
                  name: "AbortError",
                  message: w || "Aborted"
                });
              }, p.signal.addEventListener("abort", m, {
                once: !0
              });
            });
            c(o(f, u, (y = i == null ? void 0 : i.getPendingMeta) == null ? void 0 : y.call(i, {
              requestId: f,
              arg: u
            }, {
              getState: d,
              extra: h
            }))), A = await Promise.race([C, Promise.resolve(r(u, {
              dispatch: c,
              getState: d,
              extra: h,
              requestId: f,
              signal: p.signal,
              abort: v,
              rejectWithValue: (I, M) => new wi(I, M),
              fulfillWithValue: (I, M) => new Zc(I, M)
            })).then((I) => {
              if (I instanceof wi)
                throw I;
              return I instanceof Zc ? n(I.payload, f, u, I.meta) : n(I, f, u);
            })]);
          } catch (x) {
            A = x instanceof wi ? s(null, f, u, x.payload, x.meta) : s(x, f, u);
          } finally {
            m && p.signal.removeEventListener("abort", m);
          }
          return i && !i.dispatchConditionRejection && s.match(A) && A.meta.condition || c(A), A;
        })();
        return Object.assign(g, {
          abort: v,
          requestId: f,
          arg: u,
          unwrap() {
            return g.then(ly);
          }
        });
      };
    }
    return Object.assign(a, {
      pending: o,
      rejected: s,
      fulfilled: n,
      settled: oy(s, n),
      typePrefix: t
    });
  }
  return e.withTypes = () => e, e;
})();
function ly(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function dy(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var fy = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function hy(e, t) {
  return `${e}/${t}`;
}
function py({
  creators: e
} = {}) {
  var r;
  const t = (r = e == null ? void 0 : e.asyncThunk) == null ? void 0 : r[fy];
  return function(n) {
    const {
      name: o,
      reducerPath: s = o
    } = n;
    if (!o)
      throw new Error(process.env.NODE_ENV === "production" ? Ce(11) : "`name` is a required option for createSlice");
    typeof process < "u" && process.env.NODE_ENV === "development" && n.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    const a = (typeof n.reducers == "function" ? n.reducers(gy()) : n.reducers) || {}, u = Object.keys(a), l = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, c = {
      addCase(b, k) {
        const y = typeof b == "string" ? b : b.type;
        if (!y)
          throw new Error(process.env.NODE_ENV === "production" ? Ce(12) : "`context.addCase` cannot be called with an empty action type");
        if (y in l.sliceCaseReducersByType)
          throw new Error(process.env.NODE_ENV === "production" ? Ce(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + y);
        return l.sliceCaseReducersByType[y] = k, c;
      },
      addMatcher(b, k) {
        return l.sliceMatchers.push({
          matcher: b,
          reducer: k
        }), c;
      },
      exposeAction(b, k) {
        return l.actionCreators[b] = k, c;
      },
      exposeCaseReducer(b, k) {
        return l.sliceCaseReducersByName[b] = k, c;
      }
    };
    u.forEach((b) => {
      const k = a[b], y = {
        reducerName: b,
        type: hy(o, b),
        createNotation: typeof n.reducers == "function"
      };
      vy(k) ? wy(y, k, c, t) : by(y, k, c);
    });
    function d() {
      if (process.env.NODE_ENV !== "production" && typeof n.extraReducers == "object")
        throw new Error(process.env.NODE_ENV === "production" ? Ce(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
      const [b = {}, k = [], y = void 0] = typeof n.extraReducers == "function" ? Bm(n.extraReducers) : [n.extraReducers], x = {
        ...b,
        ...l.sliceCaseReducersByType
      };
      return ny(n.initialState, (C) => {
        for (let I in x)
          C.addCase(I, x[I]);
        for (let I of l.sliceMatchers)
          C.addMatcher(I.matcher, I.reducer);
        for (let I of k)
          C.addMatcher(I.matcher, I.reducer);
        y && C.addDefaultCase(y);
      });
    }
    const h = (b) => b, f = /* @__PURE__ */ new Map(), p = /* @__PURE__ */ new WeakMap();
    let m;
    function w(b, k) {
      return m || (m = d()), m(b, k);
    }
    function v() {
      return m || (m = d()), m.getInitialState();
    }
    function g(b, k = !1) {
      function y(C) {
        let I = C[b];
        if (typeof I > "u") {
          if (k)
            I = yn(p, y, v);
          else if (process.env.NODE_ENV !== "production")
            throw new Error(process.env.NODE_ENV === "production" ? Ce(15) : "selectSlice returned undefined for an uninjected slice reducer");
        }
        return I;
      }
      function x(C = h) {
        const I = yn(f, k, () => /* @__PURE__ */ new WeakMap());
        return yn(I, C, () => {
          const M = {};
          for (const [Q, H] of Object.entries(n.selectors ?? {}))
            M[Q] = my(H, C, () => yn(p, C, v), k);
          return M;
        });
      }
      return {
        reducerPath: b,
        getSelectors: x,
        get selectors() {
          return x(y);
        },
        selectSlice: y
      };
    }
    const A = {
      name: o,
      reducer: w,
      actions: l.actionCreators,
      caseReducers: l.sliceCaseReducersByName,
      getInitialState: v,
      ...g(s),
      injectInto(b, {
        reducerPath: k,
        ...y
      } = {}) {
        const x = k ?? s;
        return b.inject({
          reducerPath: x,
          reducer: w
        }, y), {
          ...A,
          ...g(x, !0)
        };
      }
    };
    return A;
  };
}
function my(e, t, r, i) {
  function n(o, ...s) {
    let a = t(o);
    if (typeof a > "u") {
      if (i)
        a = r();
      else if (process.env.NODE_ENV !== "production")
        throw new Error(process.env.NODE_ENV === "production" ? Ce(16) : "selectState returned undefined for an uninjected slice reducer");
    }
    return e(a, ...s);
  }
  return n.unwrapped = e, n;
}
var mt = /* @__PURE__ */ py();
function gy() {
  function e(t, r) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: t,
      ...r
    };
  }
  return e.withTypes = () => e, {
    reducer(t) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [t.name](...r) {
          return t(...r);
        }
      }[t.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(t, r) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: t,
        reducer: r
      };
    },
    asyncThunk: e
  };
}
function by({
  type: e,
  reducerName: t,
  createNotation: r
}, i, n) {
  let o, s;
  if ("reducer" in i) {
    if (r && !yy(i))
      throw new Error(process.env.NODE_ENV === "production" ? Ce(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    o = i.reducer, s = i.prepare;
  } else
    o = i;
  n.addCase(e, o).exposeCaseReducer(t, o).exposeAction(t, s ? Wr(e, s) : Wr(e));
}
function vy(e) {
  return e._reducerDefinitionType === "asyncThunk";
}
function yy(e) {
  return e._reducerDefinitionType === "reducerWithPrepare";
}
function wy({
  type: e,
  reducerName: t
}, r, i, n) {
  if (!n)
    throw new Error(process.env.NODE_ENV === "production" ? Ce(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  const {
    payloadCreator: o,
    fulfilled: s,
    pending: a,
    rejected: u,
    settled: l,
    options: c
  } = r, d = n(e, o, c);
  i.exposeAction(t, d), s && i.addCase(d.fulfilled, s), a && i.addCase(d.pending, a), u && i.addCase(d.rejected, u), l && i.addMatcher(d.settled, l), i.exposeCaseReducer(t, {
    fulfilled: s || _n,
    pending: a || _n,
    rejected: u || _n,
    settled: l || _n
  });
}
function _n() {
}
function Ce(e) {
  return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var Ne = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function _y(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function ky(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function i() {
      return this instanceof i ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(i) {
    var n = Object.getOwnPropertyDescriptor(e, i);
    Object.defineProperty(r, i, n.get ? n : {
      enumerable: !0,
      get: function() {
        return e[i];
      }
    });
  }), r;
}
var _i = {}, ki = { exports: {} }, el;
function sn() {
  return el || (el = 1, (function(e) {
    function t(r) {
      return r && r.__esModule ? r : {
        default: r
      };
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(ki)), ki.exports;
}
var xi = { exports: {} }, tl;
function nr() {
  return tl || (tl = 1, (function(e) {
    function t(r) {
      "@babel/helpers - typeof";
      return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
        return typeof i;
      } : function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(xi)), xi.exports;
}
var Si = { exports: {} }, Ei = { exports: {} }, rl;
function xy() {
  return rl || (rl = 1, (function(e) {
    function t(r, i) {
      if (r == null) return {};
      var n = {};
      for (var o in r) if ({}.hasOwnProperty.call(r, o)) {
        if (i.indexOf(o) !== -1) continue;
        n[o] = r[o];
      }
      return n;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Ei)), Ei.exports;
}
var nl;
function qm() {
  return nl || (nl = 1, (function(e) {
    var t = xy();
    function r(i, n) {
      if (i == null) return {};
      var o, s, a = t(i, n);
      if (Object.getOwnPropertySymbols) {
        var u = Object.getOwnPropertySymbols(i);
        for (s = 0; s < u.length; s++) o = u[s], n.indexOf(o) === -1 && {}.propertyIsEnumerable.call(i, o) && (a[o] = i[o]);
      }
      return a;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Si)), Si.exports;
}
var Ai = { exports: {} }, il;
function Vu() {
  return il || (il = 1, (function(e) {
    function t(r, i) {
      if (!(r instanceof i)) throw new TypeError("Cannot call a class as a function");
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Ai)), Ai.exports;
}
var Ti = { exports: {} }, Ci = { exports: {} }, Ri = { exports: {} }, ol;
function Sy() {
  return ol || (ol = 1, (function(e) {
    var t = nr().default;
    function r(i, n) {
      if (t(i) != "object" || !i) return i;
      var o = i[Symbol.toPrimitive];
      if (o !== void 0) {
        var s = o.call(i, n || "default");
        if (t(s) != "object") return s;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (n === "string" ? String : Number)(i);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Ri)), Ri.exports;
}
var al;
function zm() {
  return al || (al = 1, (function(e) {
    var t = nr().default, r = Sy();
    function i(n) {
      var o = r(n, "string");
      return t(o) == "symbol" ? o : o + "";
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Ci)), Ci.exports;
}
var sl;
function Gu() {
  return sl || (sl = 1, (function(e) {
    var t = zm();
    function r(n, o) {
      for (var s = 0; s < o.length; s++) {
        var a = o[s];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(n, t(a.key), a);
      }
    }
    function i(n, o, s) {
      return o && r(n.prototype, o), s && r(n, s), Object.defineProperty(n, "prototype", {
        writable: !1
      }), n;
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Ti)), Ti.exports;
}
var Oi = { exports: {} }, ul;
function Um() {
  return ul || (ul = 1, (function(e) {
    var t = zm();
    function r(i, n, o) {
      return (n = t(n)) in i ? Object.defineProperty(i, n, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : i[n] = o, i;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Oi)), Oi.exports;
}
var cl = {}, Di, ll;
function $e() {
  if (ll) return Di;
  ll = 1;
  var e = function(t) {
    return t && t.Math == Math && t;
  };
  return Di = // eslint-disable-next-line es/no-global-this -- safe
  e(typeof globalThis == "object" && globalThis) || e(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  e(typeof self == "object" && self) || e(typeof Ne == "object" && Ne) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ (function() {
    return this;
  })() || Function("return this")(), Di;
}
var Pi = {}, Ii, dl;
function gt() {
  return dl || (dl = 1, Ii = function(e) {
    try {
      return !!e();
    } catch {
      return !0;
    }
  }), Ii;
}
var Mi, fl;
function ir() {
  if (fl) return Mi;
  fl = 1;
  var e = gt();
  return Mi = !e(function() {
    return Object.defineProperty({}, 1, { get: function() {
      return 7;
    } })[1] != 7;
  }), Mi;
}
var ji = {}, hl;
function Ey() {
  if (hl) return ji;
  hl = 1;
  var e = {}.propertyIsEnumerable, t = Object.getOwnPropertyDescriptor, r = t && !e.call({ 1: 2 }, 1);
  return ji.f = r ? function(n) {
    var o = t(this, n);
    return !!o && o.enumerable;
  } : e, ji;
}
var Fi, pl;
function Jn() {
  return pl || (pl = 1, Fi = function(e, t) {
    return {
      enumerable: !(e & 1),
      configurable: !(e & 2),
      writable: !(e & 4),
      value: t
    };
  }), Fi;
}
var $i, ml;
function Wu() {
  if (ml) return $i;
  ml = 1;
  var e = {}.toString;
  return $i = function(t) {
    return e.call(t).slice(8, -1);
  }, $i;
}
var Li, gl;
function Ay() {
  if (gl) return Li;
  gl = 1;
  var e = gt(), t = Wu(), r = "".split;
  return Li = e(function() {
    return !Object("z").propertyIsEnumerable(0);
  }) ? function(i) {
    return t(i) == "String" ? r.call(i, "") : Object(i);
  } : Object, Li;
}
var Ni, bl;
function Hu() {
  return bl || (bl = 1, Ni = function(e) {
    if (e == null) throw TypeError("Can't call method on " + e);
    return e;
  }), Ni;
}
var Bi, vl;
function Zn() {
  if (vl) return Bi;
  vl = 1;
  var e = Ay(), t = Hu();
  return Bi = function(r) {
    return e(t(r));
  }, Bi;
}
var qi, yl;
function $t() {
  return yl || (yl = 1, qi = function(e) {
    return typeof e == "object" ? e !== null : typeof e == "function";
  }), qi;
}
var zi, wl;
function Vm() {
  if (wl) return zi;
  wl = 1;
  var e = $t();
  return zi = function(t, r) {
    if (!e(t)) return t;
    var i, n;
    if (r && typeof (i = t.toString) == "function" && !e(n = i.call(t)) || typeof (i = t.valueOf) == "function" && !e(n = i.call(t)) || !r && typeof (i = t.toString) == "function" && !e(n = i.call(t))) return n;
    throw TypeError("Can't convert object to primitive value");
  }, zi;
}
var Ui, _l;
function Gm() {
  if (_l) return Ui;
  _l = 1;
  var e = Hu();
  return Ui = function(t) {
    return Object(e(t));
  }, Ui;
}
var Vi, kl;
function bt() {
  if (kl) return Vi;
  kl = 1;
  var e = Gm(), t = {}.hasOwnProperty;
  return Vi = Object.hasOwn || function(i, n) {
    return t.call(e(i), n);
  }, Vi;
}
var Gi, xl;
function Ku() {
  if (xl) return Gi;
  xl = 1;
  var e = $e(), t = $t(), r = e.document, i = t(r) && t(r.createElement);
  return Gi = function(n) {
    return i ? r.createElement(n) : {};
  }, Gi;
}
var Wi, Sl;
function Wm() {
  if (Sl) return Wi;
  Sl = 1;
  var e = ir(), t = gt(), r = Ku();
  return Wi = !e && !t(function() {
    return Object.defineProperty(r("div"), "a", {
      get: function() {
        return 7;
      }
    }).a != 7;
  }), Wi;
}
var El;
function Qu() {
  if (El) return Pi;
  El = 1;
  var e = ir(), t = Ey(), r = Jn(), i = Zn(), n = Vm(), o = bt(), s = Wm(), a = Object.getOwnPropertyDescriptor;
  return Pi.f = e ? a : function(l, c) {
    if (l = i(l), c = n(c, !0), s) try {
      return a(l, c);
    } catch {
    }
    if (o(l, c)) return r(!t.f.call(l, c), l[c]);
  }, Pi;
}
var Hi = {}, Ki, Al;
function vt() {
  if (Al) return Ki;
  Al = 1;
  var e = $t();
  return Ki = function(t) {
    if (!e(t))
      throw TypeError(String(t) + " is not an object");
    return t;
  }, Ki;
}
var Tl;
function or() {
  if (Tl) return Hi;
  Tl = 1;
  var e = ir(), t = Wm(), r = vt(), i = Vm(), n = Object.defineProperty;
  return Hi.f = e ? n : function(s, a, u) {
    if (r(s), a = i(a, !0), r(u), t) try {
      return n(s, a, u);
    } catch {
    }
    if ("get" in u || "set" in u) throw TypeError("Accessors not supported");
    return "value" in u && (s[a] = u.value), s;
  }, Hi;
}
var Qi, Cl;
function Ct() {
  if (Cl) return Qi;
  Cl = 1;
  var e = ir(), t = or(), r = Jn();
  return Qi = e ? function(i, n, o) {
    return t.f(i, n, r(1, o));
  } : function(i, n, o) {
    return i[n] = o, i;
  }, Qi;
}
var Yi = { exports: {} }, Ji, Rl;
function Yu() {
  if (Rl) return Ji;
  Rl = 1;
  var e = $e(), t = Ct();
  return Ji = function(r, i) {
    try {
      t(e, r, i);
    } catch {
      e[r] = i;
    }
    return i;
  }, Ji;
}
var Zi, Ol;
function Ju() {
  if (Ol) return Zi;
  Ol = 1;
  var e = $e(), t = Yu(), r = "__core-js_shared__", i = e[r] || t(r, {});
  return Zi = i, Zi;
}
var Xi, Dl;
function Zu() {
  if (Dl) return Xi;
  Dl = 1;
  var e = Ju(), t = Function.toString;
  return typeof e.inspectSource != "function" && (e.inspectSource = function(r) {
    return t.call(r);
  }), Xi = e.inspectSource, Xi;
}
var eo, Pl;
function Ty() {
  if (Pl) return eo;
  Pl = 1;
  var e = $e(), t = Zu(), r = e.WeakMap;
  return eo = typeof r == "function" && /native code/.test(t(r)), eo;
}
var to = { exports: {} }, ro, Il;
function un() {
  return Il || (Il = 1, ro = !1), ro;
}
var Ml;
function Hm() {
  if (Ml) return to.exports;
  Ml = 1;
  var e = un(), t = Ju();
  return (to.exports = function(r, i) {
    return t[r] || (t[r] = i !== void 0 ? i : {});
  })("versions", []).push({
    version: "3.15.2",
    mode: e ? "pure" : "global",
    copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
  }), to.exports;
}
var no, jl;
function Km() {
  if (jl) return no;
  jl = 1;
  var e = 0, t = Math.random();
  return no = function(r) {
    return "Symbol(" + String(r === void 0 ? "" : r) + ")_" + (++e + t).toString(36);
  }, no;
}
var io, Fl;
function Xu() {
  if (Fl) return io;
  Fl = 1;
  var e = Hm(), t = Km(), r = e("keys");
  return io = function(i) {
    return r[i] || (r[i] = t(i));
  }, io;
}
var oo, $l;
function ec() {
  return $l || ($l = 1, oo = {}), oo;
}
var ao, Ll;
function Xn() {
  if (Ll) return ao;
  Ll = 1;
  var e = Ty(), t = $e(), r = $t(), i = Ct(), n = bt(), o = Ju(), s = Xu(), a = ec(), u = "Object already initialized", l = t.WeakMap, c, d, h, f = function(b) {
    return h(b) ? d(b) : c(b, {});
  }, p = function(b) {
    return function(k) {
      var y;
      if (!r(k) || (y = d(k)).type !== b)
        throw TypeError("Incompatible receiver, " + b + " required");
      return y;
    };
  };
  if (e || o.state) {
    var m = o.state || (o.state = new l()), w = m.get, v = m.has, g = m.set;
    c = function(b, k) {
      if (v.call(m, b)) throw new TypeError(u);
      return k.facade = b, g.call(m, b, k), k;
    }, d = function(b) {
      return w.call(m, b) || {};
    }, h = function(b) {
      return v.call(m, b);
    };
  } else {
    var A = s("state");
    a[A] = !0, c = function(b, k) {
      if (n(b, A)) throw new TypeError(u);
      return k.facade = b, i(b, A, k), k;
    }, d = function(b) {
      return n(b, A) ? b[A] : {};
    }, h = function(b) {
      return n(b, A);
    };
  }
  return ao = {
    set: c,
    get: d,
    has: h,
    enforce: f,
    getterFor: p
  }, ao;
}
var Nl;
function ar() {
  if (Nl) return Yi.exports;
  Nl = 1;
  var e = $e(), t = Ct(), r = bt(), i = Yu(), n = Zu(), o = Xn(), s = o.get, a = o.enforce, u = String(String).split("String");
  return (Yi.exports = function(l, c, d, h) {
    var f = h ? !!h.unsafe : !1, p = h ? !!h.enumerable : !1, m = h ? !!h.noTargetGet : !1, w;
    if (typeof d == "function" && (typeof c == "string" && !r(d, "name") && t(d, "name", c), w = a(d), w.source || (w.source = u.join(typeof c == "string" ? c : ""))), l === e) {
      p ? l[c] = d : i(c, d);
      return;
    } else f ? !m && l[c] && (p = !0) : delete l[c];
    p ? l[c] = d : t(l, c, d);
  })(Function.prototype, "toString", function() {
    return typeof this == "function" && s(this).source || n(this);
  }), Yi.exports;
}
var so, Bl;
function Qm() {
  if (Bl) return so;
  Bl = 1;
  var e = $e();
  return so = e, so;
}
var uo, ql;
function Lt() {
  if (ql) return uo;
  ql = 1;
  var e = Qm(), t = $e(), r = function(i) {
    return typeof i == "function" ? i : void 0;
  };
  return uo = function(i, n) {
    return arguments.length < 2 ? r(e[i]) || r(t[i]) : e[i] && e[i][n] || t[i] && t[i][n];
  }, uo;
}
var co = {}, lo, zl;
function tc() {
  if (zl) return lo;
  zl = 1;
  var e = Math.ceil, t = Math.floor;
  return lo = function(r) {
    return isNaN(r = +r) ? 0 : (r > 0 ? t : e)(r);
  }, lo;
}
var fo, Ul;
function Ym() {
  if (Ul) return fo;
  Ul = 1;
  var e = tc(), t = Math.min;
  return fo = function(r) {
    return r > 0 ? t(e(r), 9007199254740991) : 0;
  }, fo;
}
var ho, Vl;
function Cy() {
  if (Vl) return ho;
  Vl = 1;
  var e = tc(), t = Math.max, r = Math.min;
  return ho = function(i, n) {
    var o = e(i);
    return o < 0 ? t(o + n, 0) : r(o, n);
  }, ho;
}
var po, Gl;
function Ry() {
  if (Gl) return po;
  Gl = 1;
  var e = Zn(), t = Ym(), r = Cy(), i = function(n) {
    return function(o, s, a) {
      var u = e(o), l = t(u.length), c = r(a, l), d;
      if (n && s != s) {
        for (; l > c; )
          if (d = u[c++], d != d) return !0;
      } else for (; l > c; c++)
        if ((n || c in u) && u[c] === s) return n || c || 0;
      return !n && -1;
    };
  };
  return po = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: i(!0),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: i(!1)
  }, po;
}
var mo, Wl;
function Jm() {
  if (Wl) return mo;
  Wl = 1;
  var e = bt(), t = Zn(), r = Ry().indexOf, i = ec();
  return mo = function(n, o) {
    var s = t(n), a = 0, u = [], l;
    for (l in s) !e(i, l) && e(s, l) && u.push(l);
    for (; o.length > a; ) e(s, l = o[a++]) && (~r(u, l) || u.push(l));
    return u;
  }, mo;
}
var go, Hl;
function rc() {
  return Hl || (Hl = 1, go = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
  ]), go;
}
var Kl;
function Oy() {
  if (Kl) return co;
  Kl = 1;
  var e = Jm(), t = rc(), r = t.concat("length", "prototype");
  return co.f = Object.getOwnPropertyNames || function(n) {
    return e(n, r);
  }, co;
}
var bo = {}, Ql;
function Dy() {
  return Ql || (Ql = 1, bo.f = Object.getOwnPropertySymbols), bo;
}
var vo, Yl;
function Py() {
  if (Yl) return vo;
  Yl = 1;
  var e = Lt(), t = Oy(), r = Dy(), i = vt();
  return vo = e("Reflect", "ownKeys") || function(o) {
    var s = t.f(i(o)), a = r.f;
    return a ? s.concat(a(o)) : s;
  }, vo;
}
var yo, Jl;
function Iy() {
  if (Jl) return yo;
  Jl = 1;
  var e = bt(), t = Py(), r = Qu(), i = or();
  return yo = function(n, o) {
    for (var s = t(o), a = i.f, u = r.f, l = 0; l < s.length; l++) {
      var c = s[l];
      e(n, c) || a(n, c, u(o, c));
    }
  }, yo;
}
var wo, Zl;
function Zm() {
  if (Zl) return wo;
  Zl = 1;
  var e = gt(), t = /#|\.prototype\./, r = function(a, u) {
    var l = n[i(a)];
    return l == s ? !0 : l == o ? !1 : typeof u == "function" ? e(u) : !!u;
  }, i = r.normalize = function(a) {
    return String(a).replace(t, ".").toLowerCase();
  }, n = r.data = {}, o = r.NATIVE = "N", s = r.POLYFILL = "P";
  return wo = r, wo;
}
var _o, Xl;
function Nt() {
  if (Xl) return _o;
  Xl = 1;
  var e = $e(), t = Qu().f, r = Ct(), i = ar(), n = Yu(), o = Iy(), s = Zm();
  return _o = function(a, u) {
    var l = a.target, c = a.global, d = a.stat, h, f, p, m, w, v;
    if (c ? f = e : d ? f = e[l] || n(l, {}) : f = (e[l] || {}).prototype, f) for (p in u) {
      if (w = u[p], a.noTargetGet ? (v = t(f, p), m = v && v.value) : m = f[p], h = s(c ? p : l + (d ? "." : "#") + p, a.forced), !h && m !== void 0) {
        if (typeof w == typeof m) continue;
        o(w, m);
      }
      (a.sham || m && m.sham) && r(w, "sham", !0), i(f, p, w, a);
    }
  }, _o;
}
var ko, ed;
function My() {
  if (ed) return ko;
  ed = 1;
  var e = gt();
  return ko = !e(function() {
    function t() {
    }
    return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
  }), ko;
}
var xo, td;
function nc() {
  if (td) return xo;
  td = 1;
  var e = bt(), t = Gm(), r = Xu(), i = My(), n = r("IE_PROTO"), o = Object.prototype;
  return xo = i ? Object.getPrototypeOf : function(s) {
    return s = t(s), e(s, n) ? s[n] : typeof s.constructor == "function" && s instanceof s.constructor ? s.constructor.prototype : s instanceof Object ? o : null;
  }, xo;
}
var So, rd;
function jy() {
  if (rd) return So;
  rd = 1;
  var e = $t();
  return So = function(t) {
    if (!e(t) && t !== null)
      throw TypeError("Can't set " + String(t) + " as a prototype");
    return t;
  }, So;
}
var Eo, nd;
function ic() {
  if (nd) return Eo;
  nd = 1;
  var e = vt(), t = jy();
  return Eo = Object.setPrototypeOf || ("__proto__" in {} ? (function() {
    var r = !1, i = {}, n;
    try {
      n = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set, n.call(i, []), r = i instanceof Array;
    } catch {
    }
    return function(s, a) {
      return e(s), t(a), r ? n.call(s, a) : s.__proto__ = a, s;
    };
  })() : void 0), Eo;
}
var Ao, id;
function Fy() {
  if (id) return Ao;
  id = 1;
  var e = Jm(), t = rc();
  return Ao = Object.keys || function(i) {
    return e(i, t);
  }, Ao;
}
var To, od;
function $y() {
  if (od) return To;
  od = 1;
  var e = ir(), t = or(), r = vt(), i = Fy();
  return To = e ? Object.defineProperties : function(o, s) {
    r(o);
    for (var a = i(s), u = a.length, l = 0, c; u > l; ) t.f(o, c = a[l++], s[c]);
    return o;
  }, To;
}
var Co, ad;
function Xm() {
  if (ad) return Co;
  ad = 1;
  var e = Lt();
  return Co = e("document", "documentElement"), Co;
}
var Ro, sd;
function oc() {
  if (sd) return Ro;
  sd = 1;
  var e = vt(), t = $y(), r = rc(), i = ec(), n = Xm(), o = Ku(), s = Xu(), a = ">", u = "<", l = "prototype", c = "script", d = s("IE_PROTO"), h = function() {
  }, f = function(g) {
    return u + c + a + g + u + "/" + c + a;
  }, p = function(g) {
    g.write(f("")), g.close();
    var A = g.parentWindow.Object;
    return g = null, A;
  }, m = function() {
    var g = o("iframe"), A = "java" + c + ":", b;
    return g.style.display = "none", n.appendChild(g), g.src = String(A), b = g.contentWindow.document, b.open(), b.write(f("document.F=Object")), b.close(), b.F;
  }, w, v = function() {
    try {
      w = document.domain && new ActiveXObject("htmlfile");
    } catch {
    }
    v = w ? p(w) : m();
    for (var g = r.length; g--; ) delete v[l][r[g]];
    return v();
  };
  return i[d] = !0, Ro = Object.create || function(A, b) {
    var k;
    return A !== null ? (h[l] = e(A), k = new h(), h[l] = null, k[d] = A) : k = v(), b === void 0 ? k : t(k, b);
  }, Ro;
}
var Oo, ud;
function ac() {
  if (ud) return Oo;
  ud = 1;
  var e = Lt();
  return Oo = e("navigator", "userAgent") || "", Oo;
}
var Do, cd;
function eg() {
  if (cd) return Do;
  cd = 1;
  var e = $e(), t = ac(), r = e.process, i = r && r.versions, n = i && i.v8, o, s;
  return n ? (o = n.split("."), s = o[0] < 4 ? 1 : o[0] + o[1]) : t && (o = t.match(/Edge\/(\d+)/), (!o || o[1] >= 74) && (o = t.match(/Chrome\/(\d+)/), o && (s = o[1]))), Do = s && +s, Do;
}
var Po, ld;
function tg() {
  if (ld) return Po;
  ld = 1;
  var e = eg(), t = gt();
  return Po = !!Object.getOwnPropertySymbols && !t(function() {
    var r = Symbol();
    return !String(r) || !(Object(r) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && e && e < 41;
  }), Po;
}
var Io, dd;
function Ly() {
  if (dd) return Io;
  dd = 1;
  var e = tg();
  return Io = e && !Symbol.sham && typeof Symbol.iterator == "symbol", Io;
}
var Mo, fd;
function Ye() {
  if (fd) return Mo;
  fd = 1;
  var e = $e(), t = Hm(), r = bt(), i = Km(), n = tg(), o = Ly(), s = t("wks"), a = e.Symbol, u = o ? a : a && a.withoutSetter || i;
  return Mo = function(l) {
    return (!r(s, l) || !(n || typeof s[l] == "string")) && (n && r(a, l) ? s[l] = a[l] : s[l] = u("Symbol." + l)), s[l];
  }, Mo;
}
var jo, hd;
function cn() {
  return hd || (hd = 1, jo = {}), jo;
}
var Fo, pd;
function Ny() {
  if (pd) return Fo;
  pd = 1;
  var e = Ye(), t = cn(), r = e("iterator"), i = Array.prototype;
  return Fo = function(n) {
    return n !== void 0 && (t.Array === n || i[r] === n);
  }, Fo;
}
var $o, md;
function sr() {
  return md || (md = 1, $o = function(e) {
    if (typeof e != "function")
      throw TypeError(String(e) + " is not a function");
    return e;
  }), $o;
}
var Lo, gd;
function rg() {
  if (gd) return Lo;
  gd = 1;
  var e = sr();
  return Lo = function(t, r, i) {
    if (e(t), r === void 0) return t;
    switch (i) {
      case 0:
        return function() {
          return t.call(r);
        };
      case 1:
        return function(n) {
          return t.call(r, n);
        };
      case 2:
        return function(n, o) {
          return t.call(r, n, o);
        };
      case 3:
        return function(n, o, s) {
          return t.call(r, n, o, s);
        };
    }
    return function() {
      return t.apply(r, arguments);
    };
  }, Lo;
}
var No, bd;
function sc() {
  if (bd) return No;
  bd = 1;
  var e = Ye(), t = e("toStringTag"), r = {};
  return r[t] = "z", No = String(r) === "[object z]", No;
}
var Bo, vd;
function ng() {
  if (vd) return Bo;
  vd = 1;
  var e = sc(), t = Wu(), r = Ye(), i = r("toStringTag"), n = t(/* @__PURE__ */ (function() {
    return arguments;
  })()) == "Arguments", o = function(s, a) {
    try {
      return s[a];
    } catch {
    }
  };
  return Bo = e ? t : function(s) {
    var a, u, l;
    return s === void 0 ? "Undefined" : s === null ? "Null" : typeof (u = o(a = Object(s), i)) == "string" ? u : n ? t(a) : (l = t(a)) == "Object" && typeof a.callee == "function" ? "Arguments" : l;
  }, Bo;
}
var qo, yd;
function By() {
  if (yd) return qo;
  yd = 1;
  var e = ng(), t = cn(), r = Ye(), i = r("iterator");
  return qo = function(n) {
    if (n != null) return n[i] || n["@@iterator"] || t[e(n)];
  }, qo;
}
var zo, wd;
function qy() {
  if (wd) return zo;
  wd = 1;
  var e = vt();
  return zo = function(t) {
    var r = t.return;
    if (r !== void 0)
      return e(r.call(t)).value;
  }, zo;
}
var Uo, _d;
function ei() {
  if (_d) return Uo;
  _d = 1;
  var e = vt(), t = Ny(), r = Ym(), i = rg(), n = By(), o = qy(), s = function(a, u) {
    this.stopped = a, this.result = u;
  };
  return Uo = function(a, u, l) {
    var c = l && l.that, d = !!(l && l.AS_ENTRIES), h = !!(l && l.IS_ITERATOR), f = !!(l && l.INTERRUPTED), p = i(u, c, 1 + d + f), m, w, v, g, A, b, k, y = function(C) {
      return m && o(m), new s(!0, C);
    }, x = function(C) {
      return d ? (e(C), f ? p(C[0], C[1], y) : p(C[0], C[1])) : f ? p(C, y) : p(C);
    };
    if (h)
      m = a;
    else {
      if (w = n(a), typeof w != "function") throw TypeError("Target is not iterable");
      if (t(w)) {
        for (v = 0, g = r(a.length); g > v; v++)
          if (A = x(a[v]), A && A instanceof s) return A;
        return new s(!1);
      }
      m = w.call(a);
    }
    for (b = m.next; !(k = b.call(m)).done; ) {
      try {
        A = x(k.value);
      } catch (C) {
        throw o(m), C;
      }
      if (typeof A == "object" && A && A instanceof s) return A;
    }
    return new s(!1);
  }, Uo;
}
var kd;
function ig() {
  if (kd) return cl;
  kd = 1;
  var e = Nt(), t = nc(), r = ic(), i = oc(), n = Ct(), o = Jn(), s = ei(), a = function(l, c) {
    var d = this;
    if (!(d instanceof a)) return new a(l, c);
    r && (d = r(new Error(void 0), t(d))), c !== void 0 && n(d, "message", String(c));
    var h = [];
    return s(l, h.push, { that: h }), n(d, "errors", h), d;
  };
  return a.prototype = i(Error.prototype, {
    constructor: o(5, a),
    message: o(5, ""),
    name: o(5, "AggregateError")
  }), e({ global: !0 }, {
    AggregateError: a
  }), cl;
}
var xd = {}, Vo, Sd;
function zy() {
  if (Sd) return Vo;
  Sd = 1;
  var e = sc(), t = ng();
  return Vo = e ? {}.toString : function() {
    return "[object " + t(this) + "]";
  }, Vo;
}
var Ed;
function Uy() {
  if (Ed) return xd;
  Ed = 1;
  var e = sc(), t = ar(), r = zy();
  return e || t(Object.prototype, "toString", r, { unsafe: !0 }), xd;
}
var Ad = {}, Go, Td;
function og() {
  if (Td) return Go;
  Td = 1;
  var e = $e();
  return Go = e.Promise, Go;
}
var Wo, Cd;
function Vy() {
  if (Cd) return Wo;
  Cd = 1;
  var e = ar();
  return Wo = function(t, r, i) {
    for (var n in r) e(t, n, r[n], i);
    return t;
  }, Wo;
}
var Ho, Rd;
function uc() {
  if (Rd) return Ho;
  Rd = 1;
  var e = or().f, t = bt(), r = Ye(), i = r("toStringTag");
  return Ho = function(n, o, s) {
    n && !t(n = s ? n : n.prototype, i) && e(n, i, { configurable: !0, value: o });
  }, Ho;
}
var Ko, Od;
function Gy() {
  if (Od) return Ko;
  Od = 1;
  var e = Lt(), t = or(), r = Ye(), i = ir(), n = r("species");
  return Ko = function(o) {
    var s = e(o), a = t.f;
    i && s && !s[n] && a(s, n, {
      configurable: !0,
      get: function() {
        return this;
      }
    });
  }, Ko;
}
var Qo, Dd;
function Wy() {
  return Dd || (Dd = 1, Qo = function(e, t, r) {
    if (!(e instanceof t))
      throw TypeError("Incorrect " + (r ? r + " " : "") + "invocation");
    return e;
  }), Qo;
}
var Yo, Pd;
function Hy() {
  if (Pd) return Yo;
  Pd = 1;
  var e = Ye(), t = e("iterator"), r = !1;
  try {
    var i = 0, n = {
      next: function() {
        return { done: !!i++ };
      },
      return: function() {
        r = !0;
      }
    };
    n[t] = function() {
      return this;
    }, Array.from(n, function() {
      throw 2;
    });
  } catch {
  }
  return Yo = function(o, s) {
    if (!s && !r) return !1;
    var a = !1;
    try {
      var u = {};
      u[t] = function() {
        return {
          next: function() {
            return { done: a = !0 };
          }
        };
      }, o(u);
    } catch {
    }
    return a;
  }, Yo;
}
var Jo, Id;
function ag() {
  if (Id) return Jo;
  Id = 1;
  var e = vt(), t = sr(), r = Ye(), i = r("species");
  return Jo = function(n, o) {
    var s = e(n).constructor, a;
    return s === void 0 || (a = e(s)[i]) == null ? o : t(a);
  }, Jo;
}
var Zo, Md;
function sg() {
  if (Md) return Zo;
  Md = 1;
  var e = ac();
  return Zo = /(?:iphone|ipod|ipad).*applewebkit/i.test(e), Zo;
}
var Xo, jd;
function cc() {
  if (jd) return Xo;
  jd = 1;
  var e = Wu(), t = $e();
  return Xo = e(t.process) == "process", Xo;
}
var ea, Fd;
function ug() {
  if (Fd) return ea;
  Fd = 1;
  var e = $e(), t = gt(), r = rg(), i = Xm(), n = Ku(), o = sg(), s = cc(), a = e.location, u = e.setImmediate, l = e.clearImmediate, c = e.process, d = e.MessageChannel, h = e.Dispatch, f = 0, p = {}, m = "onreadystatechange", w, v, g, A = function(x) {
    if (p.hasOwnProperty(x)) {
      var C = p[x];
      delete p[x], C();
    }
  }, b = function(x) {
    return function() {
      A(x);
    };
  }, k = function(x) {
    A(x.data);
  }, y = function(x) {
    e.postMessage(x + "", a.protocol + "//" + a.host);
  };
  return (!u || !l) && (u = function(C) {
    for (var I = [], M = 1; arguments.length > M; ) I.push(arguments[M++]);
    return p[++f] = function() {
      (typeof C == "function" ? C : Function(C)).apply(void 0, I);
    }, w(f), f;
  }, l = function(C) {
    delete p[C];
  }, s ? w = function(x) {
    c.nextTick(b(x));
  } : h && h.now ? w = function(x) {
    h.now(b(x));
  } : d && !o ? (v = new d(), g = v.port2, v.port1.onmessage = k, w = r(g.postMessage, g, 1)) : e.addEventListener && typeof postMessage == "function" && !e.importScripts && a && a.protocol !== "file:" && !t(y) ? (w = y, e.addEventListener("message", k, !1)) : m in n("script") ? w = function(x) {
    i.appendChild(n("script"))[m] = function() {
      i.removeChild(this), A(x);
    };
  } : w = function(x) {
    setTimeout(b(x), 0);
  }), ea = {
    set: u,
    clear: l
  }, ea;
}
var ta, $d;
function Ky() {
  if ($d) return ta;
  $d = 1;
  var e = ac();
  return ta = /web0s(?!.*chrome)/i.test(e), ta;
}
var ra, Ld;
function Qy() {
  if (Ld) return ra;
  Ld = 1;
  var e = $e(), t = Qu().f, r = ug().set, i = sg(), n = Ky(), o = cc(), s = e.MutationObserver || e.WebKitMutationObserver, a = e.document, u = e.process, l = e.Promise, c = t(e, "queueMicrotask"), d = c && c.value, h, f, p, m, w, v, g, A;
  return d || (h = function() {
    var b, k;
    for (o && (b = u.domain) && b.exit(); f; ) {
      k = f.fn, f = f.next;
      try {
        k();
      } catch (y) {
        throw f ? m() : p = void 0, y;
      }
    }
    p = void 0, b && b.enter();
  }, !i && !o && !n && s && a ? (w = !0, v = a.createTextNode(""), new s(h).observe(v, { characterData: !0 }), m = function() {
    v.data = w = !w;
  }) : l && l.resolve ? (g = l.resolve(void 0), g.constructor = l, A = g.then, m = function() {
    A.call(g, h);
  }) : o ? m = function() {
    u.nextTick(h);
  } : m = function() {
    r.call(e, h);
  }), ra = d || function(b) {
    var k = { fn: b, next: void 0 };
    p && (p.next = k), f || (f = k, m()), p = k;
  }, ra;
}
var na = {}, Nd;
function ln() {
  if (Nd) return na;
  Nd = 1;
  var e = sr(), t = function(r) {
    var i, n;
    this.promise = new r(function(o, s) {
      if (i !== void 0 || n !== void 0) throw TypeError("Bad Promise constructor");
      i = o, n = s;
    }), this.resolve = e(i), this.reject = e(n);
  };
  return na.f = function(r) {
    return new t(r);
  }, na;
}
var ia, Bd;
function cg() {
  if (Bd) return ia;
  Bd = 1;
  var e = vt(), t = $t(), r = ln();
  return ia = function(i, n) {
    if (e(i), t(n) && n.constructor === i) return n;
    var o = r.f(i), s = o.resolve;
    return s(n), o.promise;
  }, ia;
}
var oa, qd;
function Yy() {
  if (qd) return oa;
  qd = 1;
  var e = $e();
  return oa = function(t, r) {
    var i = e.console;
    i && i.error && (arguments.length === 1 ? i.error(t) : i.error(t, r));
  }, oa;
}
var aa, zd;
function ti() {
  return zd || (zd = 1, aa = function(e) {
    try {
      return { error: !1, value: e() };
    } catch (t) {
      return { error: !0, value: t };
    }
  }), aa;
}
var sa, Ud;
function Jy() {
  return Ud || (Ud = 1, sa = typeof window == "object"), sa;
}
var Vd;
function Zy() {
  if (Vd) return Ad;
  Vd = 1;
  var e = Nt(), t = un(), r = $e(), i = Lt(), n = og(), o = ar(), s = Vy(), a = ic(), u = uc(), l = Gy(), c = $t(), d = sr(), h = Wy(), f = Zu(), p = ei(), m = Hy(), w = ag(), v = ug().set, g = Qy(), A = cg(), b = Yy(), k = ln(), y = ti(), x = Xn(), C = Zm(), I = Ye(), M = Jy(), Q = cc(), H = eg(), J = I("species"), W = "Promise", P = x.get, R = x.set, V = x.getterFor(W), X = n && n.prototype, N = n, U = X, G = r.TypeError, re = r.document, oe = r.process, ie = k.f, le = ie, he = !!(re && re.createEvent && r.dispatchEvent), ye = typeof PromiseRejectionEvent == "function", be = "unhandledrejection", we = "rejectionhandled", ve = 0, Re = 1, De = 2, te = 1, Z = 2, ue = !1, pe, me, L, B, D = C(W, function() {
    var $ = f(N), K = $ !== String(N);
    if (!K && H === 66 || t && !U.finally) return !0;
    if (H >= 51 && /native code/.test($)) return !1;
    var ee = new N(function(ke) {
      ke(1);
    }), de = function(ke) {
      ke(function() {
      }, function() {
      });
    }, ge = ee.constructor = {};
    return ge[J] = de, ue = ee.then(function() {
    }) instanceof de, ue ? !K && M && !ye : !0;
  }), E = D || !m(function($) {
    N.all($).catch(function() {
    });
  }), T = function($) {
    var K;
    return c($) && typeof (K = $.then) == "function" ? K : !1;
  }, j = function($, K) {
    if (!$.notified) {
      $.notified = !0;
      var ee = $.reactions;
      g(function() {
        for (var de = $.value, ge = $.state == Re, ke = 0; ee.length > ke; ) {
          var Ee = ee[ke++], xe = ge ? Ee.ok : Ee.fail, tt = Ee.resolve, rt = Ee.reject, We = Ee.domain, nt, Ut, Rt;
          try {
            xe ? (ge || ($.rejection === Z && O($), $.rejection = te), xe === !0 ? nt = de : (We && We.enter(), nt = xe(de), We && (We.exit(), Rt = !0)), nt === Ee.promise ? rt(G("Promise-chain cycle")) : (Ut = T(nt)) ? Ut.call(nt, tt, rt) : tt(nt)) : rt(de);
          } catch (Vt) {
            We && !Rt && We.exit(), rt(Vt);
          }
        }
        $.reactions = [], $.notified = !1, K && !$.rejection && ae($);
      });
    }
  }, Y = function($, K, ee) {
    var de, ge;
    he ? (de = re.createEvent("Event"), de.promise = K, de.reason = ee, de.initEvent($, !1, !0), r.dispatchEvent(de)) : de = { promise: K, reason: ee }, !ye && (ge = r["on" + $]) ? ge(de) : $ === be && b("Unhandled promise rejection", ee);
  }, ae = function($) {
    v.call(r, function() {
      var K = $.facade, ee = $.value, de = se($), ge;
      if (de && (ge = y(function() {
        Q ? oe.emit("unhandledRejection", ee, K) : Y(be, K, ee);
      }), $.rejection = Q || se($) ? Z : te, ge.error))
        throw ge.value;
    });
  }, se = function($) {
    return $.rejection !== te && !$.parent;
  }, O = function($) {
    v.call(r, function() {
      var K = $.facade;
      Q ? oe.emit("rejectionHandled", K) : Y(we, K, $.value);
    });
  }, _ = function($, K, ee) {
    return function(de) {
      $(K, de, ee);
    };
  }, S = function($, K, ee) {
    $.done || ($.done = !0, ee && ($ = ee), $.value = K, $.state = De, j($, !0));
  }, F = function($, K, ee) {
    if (!$.done) {
      $.done = !0, ee && ($ = ee);
      try {
        if ($.facade === K) throw G("Promise can't be resolved itself");
        var de = T(K);
        de ? g(function() {
          var ge = { done: !1 };
          try {
            de.call(
              K,
              _(F, ge, $),
              _(S, ge, $)
            );
          } catch (ke) {
            S(ge, ke, $);
          }
        }) : ($.value = K, $.state = Re, j($, !1));
      } catch (ge) {
        S({ done: !1 }, ge, $);
      }
    }
  };
  if (D && (N = function(K) {
    h(this, N, W), d(K), pe.call(this);
    var ee = P(this);
    try {
      K(_(F, ee), _(S, ee));
    } catch (de) {
      S(ee, de);
    }
  }, U = N.prototype, pe = function(K) {
    R(this, {
      type: W,
      done: !1,
      notified: !1,
      parent: !1,
      reactions: [],
      rejection: !1,
      state: ve,
      value: void 0
    });
  }, pe.prototype = s(U, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function(K, ee) {
      var de = V(this), ge = ie(w(this, N));
      return ge.ok = typeof K == "function" ? K : !0, ge.fail = typeof ee == "function" && ee, ge.domain = Q ? oe.domain : void 0, de.parent = !0, de.reactions.push(ge), de.state != ve && j(de, !1), ge.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    catch: function($) {
      return this.then(void 0, $);
    }
  }), me = function() {
    var $ = new pe(), K = P($);
    this.promise = $, this.resolve = _(F, K), this.reject = _(S, K);
  }, k.f = ie = function($) {
    return $ === N || $ === L ? new me($) : le($);
  }, !t && typeof n == "function" && X !== Object.prototype)) {
    B = X.then, ue || (o(X, "then", function(K, ee) {
      var de = this;
      return new N(function(ge, ke) {
        B.call(de, ge, ke);
      }).then(K, ee);
    }, { unsafe: !0 }), o(X, "catch", U.catch, { unsafe: !0 }));
    try {
      delete X.constructor;
    } catch {
    }
    a && a(X, U);
  }
  return e({ global: !0, wrap: !0, forced: D }, {
    Promise: N
  }), u(N, W, !1, !0), l(W), L = i(W), e({ target: W, stat: !0, forced: D }, {
    // `Promise.reject` method
    // https://tc39.es/ecma262/#sec-promise.reject
    reject: function(K) {
      var ee = ie(this);
      return ee.reject.call(void 0, K), ee.promise;
    }
  }), e({ target: W, stat: !0, forced: t || D }, {
    // `Promise.resolve` method
    // https://tc39.es/ecma262/#sec-promise.resolve
    resolve: function(K) {
      return A(t && this === L ? N : this, K);
    }
  }), e({ target: W, stat: !0, forced: E }, {
    // `Promise.all` method
    // https://tc39.es/ecma262/#sec-promise.all
    all: function(K) {
      var ee = this, de = ie(ee), ge = de.resolve, ke = de.reject, Ee = y(function() {
        var xe = d(ee.resolve), tt = [], rt = 0, We = 1;
        p(K, function(nt) {
          var Ut = rt++, Rt = !1;
          tt.push(void 0), We++, xe.call(ee, nt).then(function(Vt) {
            Rt || (Rt = !0, tt[Ut] = Vt, --We || ge(tt));
          }, ke);
        }), --We || ge(tt);
      });
      return Ee.error && ke(Ee.value), de.promise;
    },
    // `Promise.race` method
    // https://tc39.es/ecma262/#sec-promise.race
    race: function(K) {
      var ee = this, de = ie(ee), ge = de.reject, ke = y(function() {
        var Ee = d(ee.resolve);
        p(K, function(xe) {
          Ee.call(ee, xe).then(de.resolve, ge);
        });
      });
      return ke.error && ge(ke.value), de.promise;
    }
  }), Ad;
}
var Gd = {}, Wd;
function lg() {
  if (Wd) return Gd;
  Wd = 1;
  var e = Nt(), t = sr(), r = ln(), i = ti(), n = ei();
  return e({ target: "Promise", stat: !0 }, {
    allSettled: function(s) {
      var a = this, u = r.f(a), l = u.resolve, c = u.reject, d = i(function() {
        var h = t(a.resolve), f = [], p = 0, m = 1;
        n(s, function(w) {
          var v = p++, g = !1;
          f.push(void 0), m++, h.call(a, w).then(function(A) {
            g || (g = !0, f[v] = { status: "fulfilled", value: A }, --m || l(f));
          }, function(A) {
            g || (g = !0, f[v] = { status: "rejected", reason: A }, --m || l(f));
          });
        }), --m || l(f);
      });
      return d.error && c(d.value), u.promise;
    }
  }), Gd;
}
var Hd = {}, Kd;
function dg() {
  if (Kd) return Hd;
  Kd = 1;
  var e = Nt(), t = sr(), r = Lt(), i = ln(), n = ti(), o = ei(), s = "No one promise resolved";
  return e({ target: "Promise", stat: !0 }, {
    any: function(u) {
      var l = this, c = i.f(l), d = c.resolve, h = c.reject, f = n(function() {
        var p = t(l.resolve), m = [], w = 0, v = 1, g = !1;
        o(u, function(A) {
          var b = w++, k = !1;
          m.push(void 0), v++, p.call(l, A).then(function(y) {
            k || g || (g = !0, d(y));
          }, function(y) {
            k || g || (k = !0, m[b] = y, --v || h(new (r("AggregateError"))(m, s)));
          });
        }), --v || h(new (r("AggregateError"))(m, s));
      });
      return f.error && h(f.value), c.promise;
    }
  }), Hd;
}
var Qd = {}, Yd;
function Xy() {
  if (Yd) return Qd;
  Yd = 1;
  var e = Nt(), t = un(), r = og(), i = gt(), n = Lt(), o = ag(), s = cg(), a = ar(), u = !!r && i(function() {
    r.prototype.finally.call({ then: function() {
    } }, function() {
    });
  });
  if (e({ target: "Promise", proto: !0, real: !0, forced: u }, {
    finally: function(c) {
      var d = o(this, n("Promise")), h = typeof c == "function";
      return this.then(
        h ? function(f) {
          return s(d, c()).then(function() {
            return f;
          });
        } : c,
        h ? function(f) {
          return s(d, c()).then(function() {
            throw f;
          });
        } : c
      );
    }
  }), !t && typeof r == "function") {
    var l = n("Promise").prototype.finally;
    r.prototype.finally !== l && a(r.prototype, "finally", l, { unsafe: !0 });
  }
  return Qd;
}
var Jd = {}, ua, Zd;
function e1() {
  if (Zd) return ua;
  Zd = 1;
  var e = tc(), t = Hu(), r = function(i) {
    return function(n, o) {
      var s = String(t(n)), a = e(o), u = s.length, l, c;
      return a < 0 || a >= u ? i ? "" : void 0 : (l = s.charCodeAt(a), l < 55296 || l > 56319 || a + 1 === u || (c = s.charCodeAt(a + 1)) < 56320 || c > 57343 ? i ? s.charAt(a) : l : i ? s.slice(a, a + 2) : (l - 55296 << 10) + (c - 56320) + 65536);
    };
  };
  return ua = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: r(!1),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: r(!0)
  }, ua;
}
var ca, Xd;
function fg() {
  if (Xd) return ca;
  Xd = 1;
  var e = gt(), t = nc(), r = Ct(), i = bt(), n = Ye(), o = un(), s = n("iterator"), a = !1, u = function() {
    return this;
  }, l, c, d;
  [].keys && (d = [].keys(), "next" in d ? (c = t(t(d)), c !== Object.prototype && (l = c)) : a = !0);
  var h = l == null || e(function() {
    var f = {};
    return l[s].call(f) !== f;
  });
  return h && (l = {}), (!o || h) && !i(l, s) && r(l, s, u), ca = {
    IteratorPrototype: l,
    BUGGY_SAFARI_ITERATORS: a
  }, ca;
}
var la, ef;
function t1() {
  if (ef) return la;
  ef = 1;
  var e = fg().IteratorPrototype, t = oc(), r = Jn(), i = uc(), n = cn(), o = function() {
    return this;
  };
  return la = function(s, a, u) {
    var l = a + " Iterator";
    return s.prototype = t(e, { next: r(1, u) }), i(s, l, !1, !0), n[l] = o, s;
  }, la;
}
var da, tf;
function hg() {
  if (tf) return da;
  tf = 1;
  var e = Nt(), t = t1(), r = nc(), i = ic(), n = uc(), o = Ct(), s = ar(), a = Ye(), u = un(), l = cn(), c = fg(), d = c.IteratorPrototype, h = c.BUGGY_SAFARI_ITERATORS, f = a("iterator"), p = "keys", m = "values", w = "entries", v = function() {
    return this;
  };
  return da = function(g, A, b, k, y, x, C) {
    t(b, A, k);
    var I = function(N) {
      if (N === y && W) return W;
      if (!h && N in H) return H[N];
      switch (N) {
        case p:
          return function() {
            return new b(this, N);
          };
        case m:
          return function() {
            return new b(this, N);
          };
        case w:
          return function() {
            return new b(this, N);
          };
      }
      return function() {
        return new b(this);
      };
    }, M = A + " Iterator", Q = !1, H = g.prototype, J = H[f] || H["@@iterator"] || y && H[y], W = !h && J || I(y), P = A == "Array" && H.entries || J, R, V, X;
    if (P && (R = r(P.call(new g())), d !== Object.prototype && R.next && (!u && r(R) !== d && (i ? i(R, d) : typeof R[f] != "function" && o(R, f, v)), n(R, M, !0, !0), u && (l[M] = v))), y == m && J && J.name !== m && (Q = !0, W = function() {
      return J.call(this);
    }), (!u || C) && H[f] !== W && o(H, f, W), l[A] = W, y)
      if (V = {
        values: I(m),
        keys: x ? W : I(p),
        entries: I(w)
      }, C) for (X in V)
        (h || Q || !(X in H)) && s(H, X, V[X]);
      else e({ target: A, proto: !0, forced: h || Q }, V);
    return V;
  }, da;
}
var rf;
function r1() {
  if (rf) return Jd;
  rf = 1;
  var e = e1().charAt, t = Xn(), r = hg(), i = "String Iterator", n = t.set, o = t.getterFor(i);
  return r(String, "String", function(s) {
    n(this, {
      type: i,
      string: String(s),
      index: 0
    });
  }, function() {
    var a = o(this), u = a.string, l = a.index, c;
    return l >= u.length ? { value: void 0, done: !0 } : (c = e(u, l), a.index += c.length, { value: c, done: !1 });
  }), Jd;
}
var nf = {}, fa, of;
function n1() {
  return of || (of = 1, fa = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  }), fa;
}
var ha, af;
function i1() {
  if (af) return ha;
  af = 1;
  var e = Ye(), t = oc(), r = or(), i = e("unscopables"), n = Array.prototype;
  return n[i] == null && r.f(n, i, {
    configurable: !0,
    value: t(null)
  }), ha = function(o) {
    n[i][o] = !0;
  }, ha;
}
var pa, sf;
function o1() {
  if (sf) return pa;
  sf = 1;
  var e = Zn(), t = i1(), r = cn(), i = Xn(), n = hg(), o = "Array Iterator", s = i.set, a = i.getterFor(o);
  return pa = n(Array, "Array", function(u, l) {
    s(this, {
      type: o,
      target: e(u),
      // target
      index: 0,
      // next index
      kind: l
      // kind
    });
  }, function() {
    var u = a(this), l = u.target, c = u.kind, d = u.index++;
    return !l || d >= l.length ? (u.target = void 0, { value: void 0, done: !0 }) : c == "keys" ? { value: d, done: !1 } : c == "values" ? { value: l[d], done: !1 } : { value: [d, l[d]], done: !1 };
  }, "values"), r.Arguments = r.Array, t("keys"), t("values"), t("entries"), pa;
}
var uf;
function a1() {
  if (uf) return nf;
  uf = 1;
  var e = $e(), t = n1(), r = o1(), i = Ct(), n = Ye(), o = n("iterator"), s = n("toStringTag"), a = r.values;
  for (var u in t) {
    var l = e[u], c = l && l.prototype;
    if (c) {
      if (c[o] !== a) try {
        i(c, o, a);
      } catch {
        c[o] = a;
      }
      if (c[s] || i(c, s, u), t[u]) {
        for (var d in r)
          if (c[d] !== r[d]) try {
            i(c, d, r[d]);
          } catch {
            c[d] = r[d];
          }
      }
    }
  }
  return nf;
}
var ma, cf;
function s1() {
  if (cf) return ma;
  cf = 1, ig(), Uy(), Zy(), lg(), dg(), Xy(), r1(), a1();
  var e = Qm();
  return ma = e.Promise, ma;
}
var lf = {}, df;
function u1() {
  return df || (df = 1, ig()), lf;
}
var ff = {}, hf;
function c1() {
  return hf || (hf = 1, lg()), ff;
}
var pf = {}, mf;
function l1() {
  if (mf) return pf;
  mf = 1;
  var e = Nt(), t = ln(), r = ti();
  return e({ target: "Promise", stat: !0 }, {
    try: function(i) {
      var n = t.f(this), o = r(i);
      return (o.error ? n.reject : n.resolve)(o.value), n.promise;
    }
  }), pf;
}
var gf = {}, bf;
function d1() {
  return bf || (bf = 1, dg()), gf;
}
var ga, vf;
function f1() {
  if (vf) return ga;
  vf = 1;
  var e = s1();
  return u1(), c1(), l1(), d1(), ga = e, ga;
}
var ba = {}, yf;
function h1() {
  return yf || (yf = 1, (function(e) {
    var t = (function() {
      try {
        if (e.URLSearchParams && new e.URLSearchParams("foo=bar").get("foo") === "bar")
          return e.URLSearchParams;
      } catch {
      }
      return null;
    })(), r = t && new t({ a: 1 }).toString() === "a=1", i = t && new t("s=%2B").get("s") === "+", n = "__URLSearchParams__", o = t ? (function() {
      var b = new t();
      return b.append("s", " &"), b.toString() === "s=+%26";
    })() : !0, s = u.prototype, a = !!(e.Symbol && e.Symbol.iterator);
    if (t && r && i && o)
      return;
    function u(b) {
      b = b || "", (b instanceof URLSearchParams || b instanceof u) && (b = b.toString()), this[n] = w(b);
    }
    s.append = function(b, k) {
      v(this[n], b, k);
    }, s.delete = function(b) {
      delete this[n][b];
    }, s.get = function(b) {
      var k = this[n];
      return this.has(b) ? k[b][0] : null;
    }, s.getAll = function(b) {
      var k = this[n];
      return this.has(b) ? k[b].slice(0) : [];
    }, s.has = function(b) {
      return A(this[n], b);
    }, s.set = function(k, y) {
      this[n][k] = ["" + y];
    }, s.toString = function() {
      var b = this[n], k = [], y, x, C, I;
      for (x in b)
        for (C = f(x), y = 0, I = b[x]; y < I.length; y++)
          k.push(C + "=" + f(I[y]));
      return k.join("&");
    };
    var l = !i, c = !l && t && !r && e.Proxy, d;
    c ? (d = new Proxy(t, {
      construct: function(b, k) {
        return new b(new u(k[0]).toString());
      }
    }), d.toString = Function.prototype.toString.bind(u)) : d = u, Object.defineProperty(e, "URLSearchParams", {
      value: d
    });
    var h = e.URLSearchParams.prototype;
    h.polyfill = !0, h.forEach = h.forEach || function(b, k) {
      var y = w(this.toString());
      Object.getOwnPropertyNames(y).forEach(function(x) {
        y[x].forEach(function(C) {
          b.call(k, C, x, this);
        }, this);
      }, this);
    }, h.sort = h.sort || function() {
      var b = w(this.toString()), k = [], y, x, C;
      for (y in b)
        k.push(y);
      for (k.sort(), x = 0; x < k.length; x++)
        this.delete(k[x]);
      for (x = 0; x < k.length; x++) {
        var I = k[x], M = b[I];
        for (C = 0; C < M.length; C++)
          this.append(I, M[C]);
      }
    }, h.keys = h.keys || function() {
      var b = [];
      return this.forEach(function(k, y) {
        b.push(y);
      }), m(b);
    }, h.values = h.values || function() {
      var b = [];
      return this.forEach(function(k) {
        b.push(k);
      }), m(b);
    }, h.entries = h.entries || function() {
      var b = [];
      return this.forEach(function(k, y) {
        b.push([y, k]);
      }), m(b);
    }, a && (h[e.Symbol.iterator] = h[e.Symbol.iterator] || h.entries);
    function f(b) {
      var k = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
      };
      return encodeURIComponent(b).replace(/[!'\(\)~]|%20|%00/g, function(y) {
        return k[y];
      });
    }
    function p(b) {
      return b.replace(/[ +]/g, "%20").replace(/(%[a-f0-9]{2})+/ig, function(k) {
        return decodeURIComponent(k);
      });
    }
    function m(b) {
      var k = {
        next: function() {
          var y = b.shift();
          return { done: y === void 0, value: y };
        }
      };
      return a && (k[e.Symbol.iterator] = function() {
        return k;
      }), k;
    }
    function w(b) {
      var k = {};
      if (typeof b == "object")
        if (g(b))
          for (var y = 0; y < b.length; y++) {
            var x = b[y];
            if (g(x) && x.length === 2)
              v(k, x[0], x[1]);
            else
              throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
          }
        else
          for (var C in b)
            b.hasOwnProperty(C) && v(k, C, b[C]);
      else {
        b.indexOf("?") === 0 && (b = b.slice(1));
        for (var I = b.split("&"), M = 0; M < I.length; M++) {
          var Q = I[M], H = Q.indexOf("=");
          -1 < H ? v(k, p(Q.slice(0, H)), p(Q.slice(H + 1))) : Q && v(k, p(Q), "");
        }
      }
      return k;
    }
    function v(b, k, y) {
      var x = typeof y == "string" ? y : y != null && typeof y.toString == "function" ? y.toString() : JSON.stringify(y);
      A(b, k) ? b[k].push(x) : b[k] = [x];
    }
    function g(b) {
      return !!b && Object.prototype.toString.call(b) === "[object Array]";
    }
    function A(b, k) {
      return Object.prototype.hasOwnProperty.call(b, k);
    }
  })(typeof Ne < "u" ? Ne : typeof window < "u" ? window : ba)), ba;
}
var lr = {}, Ot = {}, va = {}, ya = {}, wf;
function yt() {
  if (wf) return ya;
  wf = 1;
  var e = typeof window < "u" && window, t = typeof self < "u" && typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && self, r = typeof Ne < "u" && Ne, i = e || r || t;
  return ya.root = i, (function() {
    if (!i)
      throw new Error("RxJS could not find any global context (window, self, global)");
  })(), ya;
}
var wa = {}, dr = {}, _a = {}, _f;
function pg() {
  if (_f) return _a;
  _f = 1;
  function e(t) {
    return typeof t == "function";
  }
  return _a.isFunction = e, _a;
}
var ka = {}, xa = {}, kf;
function ri() {
  return kf || (kf = 1, xa.isArray = Array.isArray || (function(e) {
    return e && typeof e.length == "number";
  })), xa;
}
var Sa = {}, xf;
function mg() {
  if (xf) return Sa;
  xf = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return Sa.isObject = e, Sa;
}
var Ea = {}, Aa = {}, Sf;
function ni() {
  return Sf || (Sf = 1, Aa.errorObject = { e: {} }), Aa;
}
var Ef;
function lc() {
  if (Ef) return Ea;
  Ef = 1;
  var e = ni(), t;
  function r() {
    try {
      return t.apply(this, arguments);
    } catch (n) {
      return e.errorObject.e = n, e.errorObject;
    }
  }
  function i(n) {
    return t = n, r;
  }
  return Ea.tryCatch = i, Ea;
}
var fr = {}, Af;
function p1() {
  if (Af) return fr;
  Af = 1;
  var e = fr && fr.__extends || function(r, i) {
    for (var n in i) i.hasOwnProperty(n) && (r[n] = i[n]);
    function o() {
      this.constructor = r;
    }
    r.prototype = i === null ? Object.create(i) : (o.prototype = i.prototype, new o());
  }, t = (function(r) {
    e(i, r);
    function i(n) {
      r.call(this), this.errors = n;
      var o = Error.call(this, n ? n.length + ` errors occurred during unsubscription:
  ` + n.map(function(s, a) {
        return a + 1 + ") " + s.toString();
      }).join(`
  `) : "");
      this.name = o.name = "UnsubscriptionError", this.stack = o.stack, this.message = o.message;
    }
    return i;
  })(Error);
  return fr.UnsubscriptionError = t, fr;
}
var Tf;
function dn() {
  if (Tf) return ka;
  Tf = 1;
  var e = ri(), t = mg(), r = pg(), i = lc(), n = ni(), o = p1(), s = (function() {
    function u(l) {
      this.closed = !1, this._parent = null, this._parents = null, this._subscriptions = null, l && (this._unsubscribe = l);
    }
    return u.prototype.unsubscribe = function() {
      var l = !1, c;
      if (!this.closed) {
        var d = this, h = d._parent, f = d._parents, p = d._unsubscribe, m = d._subscriptions;
        this.closed = !0, this._parent = null, this._parents = null, this._subscriptions = null;
        for (var w = -1, v = f ? f.length : 0; h; )
          h.remove(this), h = ++w < v && f[w] || null;
        if (r.isFunction(p)) {
          var g = i.tryCatch(p).call(this);
          g === n.errorObject && (l = !0, c = c || (n.errorObject.e instanceof o.UnsubscriptionError ? a(n.errorObject.e.errors) : [n.errorObject.e]));
        }
        if (e.isArray(m))
          for (w = -1, v = m.length; ++w < v; ) {
            var A = m[w];
            if (t.isObject(A)) {
              var g = i.tryCatch(A.unsubscribe).call(A);
              if (g === n.errorObject) {
                l = !0, c = c || [];
                var b = n.errorObject.e;
                b instanceof o.UnsubscriptionError ? c = c.concat(a(b.errors)) : c.push(b);
              }
            }
          }
        if (l)
          throw new o.UnsubscriptionError(c);
      }
    }, u.prototype.add = function(l) {
      if (!l || l === u.EMPTY)
        return u.EMPTY;
      if (l === this)
        return this;
      var c = l;
      switch (typeof l) {
        case "function":
          c = new u(l);
        case "object":
          if (c.closed || typeof c.unsubscribe != "function")
            return c;
          if (this.closed)
            return c.unsubscribe(), c;
          if (typeof c._addParent != "function") {
            var d = c;
            c = new u(), c._subscriptions = [d];
          }
          break;
        default:
          throw new Error("unrecognized teardown " + l + " added to Subscription.");
      }
      var h = this._subscriptions || (this._subscriptions = []);
      return h.push(c), c._addParent(this), c;
    }, u.prototype.remove = function(l) {
      var c = this._subscriptions;
      if (c) {
        var d = c.indexOf(l);
        d !== -1 && c.splice(d, 1);
      }
    }, u.prototype._addParent = function(l) {
      var c = this, d = c._parent, h = c._parents;
      !d || d === l ? this._parent = l : h ? h.indexOf(l) === -1 && h.push(l) : this._parents = [l];
    }, u.EMPTY = (function(l) {
      return l.closed = !0, l;
    })(new u()), u;
  })();
  ka.Subscription = s;
  function a(u) {
    return u.reduce(function(l, c) {
      return l.concat(c instanceof o.UnsubscriptionError ? c.errors : c);
    }, []);
  }
  return ka;
}
var Ta = {}, Cf;
function gg() {
  return Cf || (Cf = 1, Ta.empty = {
    closed: !0,
    next: function(e) {
    },
    error: function(e) {
      throw e;
    },
    complete: function() {
    }
  }), Ta;
}
var Ca = {}, Rf;
function dc() {
  return Rf || (Rf = 1, (function(e) {
    var t = yt(), r = t.root.Symbol;
    e.rxSubscriber = typeof r == "function" && typeof r.for == "function" ? r.for("rxSubscriber") : "@@rxSubscriber", e.$$rxSubscriber = e.rxSubscriber;
  })(Ca)), Ca;
}
var Of;
function Ge() {
  if (Of) return dr;
  Of = 1;
  var e = dr && dr.__extends || function(u, l) {
    for (var c in l) l.hasOwnProperty(c) && (u[c] = l[c]);
    function d() {
      this.constructor = u;
    }
    u.prototype = l === null ? Object.create(l) : (d.prototype = l.prototype, new d());
  }, t = pg(), r = dn(), i = gg(), n = dc(), o = (function(u) {
    e(l, u);
    function l(c, d, h) {
      switch (u.call(this), this.syncErrorValue = null, this.syncErrorThrown = !1, this.syncErrorThrowable = !1, this.isStopped = !1, arguments.length) {
        case 0:
          this.destination = i.empty;
          break;
        case 1:
          if (!c) {
            this.destination = i.empty;
            break;
          }
          if (typeof c == "object") {
            if (a(c)) {
              var f = c[n.rxSubscriber]();
              this.syncErrorThrowable = f.syncErrorThrowable, this.destination = f, f.add(this);
            } else
              this.syncErrorThrowable = !0, this.destination = new s(this, c);
            break;
          }
        default:
          this.syncErrorThrowable = !0, this.destination = new s(this, c, d, h);
          break;
      }
    }
    return l.prototype[n.rxSubscriber] = function() {
      return this;
    }, l.create = function(c, d, h) {
      var f = new l(c, d, h);
      return f.syncErrorThrowable = !1, f;
    }, l.prototype.next = function(c) {
      this.isStopped || this._next(c);
    }, l.prototype.error = function(c) {
      this.isStopped || (this.isStopped = !0, this._error(c));
    }, l.prototype.complete = function() {
      this.isStopped || (this.isStopped = !0, this._complete());
    }, l.prototype.unsubscribe = function() {
      this.closed || (this.isStopped = !0, u.prototype.unsubscribe.call(this));
    }, l.prototype._next = function(c) {
      this.destination.next(c);
    }, l.prototype._error = function(c) {
      this.destination.error(c), this.unsubscribe();
    }, l.prototype._complete = function() {
      this.destination.complete(), this.unsubscribe();
    }, l.prototype._unsubscribeAndRecycle = function() {
      var c = this, d = c._parent, h = c._parents;
      return this._parent = null, this._parents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parent = d, this._parents = h, this;
    }, l;
  })(r.Subscription);
  dr.Subscriber = o;
  var s = (function(u) {
    e(l, u);
    function l(c, d, h, f) {
      u.call(this), this._parentSubscriber = c;
      var p, m = this;
      t.isFunction(d) ? p = d : d && (p = d.next, h = d.error, f = d.complete, d !== i.empty && (m = Object.create(d), t.isFunction(m.unsubscribe) && this.add(m.unsubscribe.bind(m)), m.unsubscribe = this.unsubscribe.bind(this))), this._context = m, this._next = p, this._error = h, this._complete = f;
    }
    return l.prototype.next = function(c) {
      if (!this.isStopped && this._next) {
        var d = this._parentSubscriber;
        d.syncErrorThrowable ? this.__tryOrSetError(d, this._next, c) && this.unsubscribe() : this.__tryOrUnsub(this._next, c);
      }
    }, l.prototype.error = function(c) {
      if (!this.isStopped) {
        var d = this._parentSubscriber;
        if (this._error)
          d.syncErrorThrowable ? (this.__tryOrSetError(d, this._error, c), this.unsubscribe()) : (this.__tryOrUnsub(this._error, c), this.unsubscribe());
        else if (d.syncErrorThrowable)
          d.syncErrorValue = c, d.syncErrorThrown = !0, this.unsubscribe();
        else
          throw this.unsubscribe(), c;
      }
    }, l.prototype.complete = function() {
      var c = this;
      if (!this.isStopped) {
        var d = this._parentSubscriber;
        if (this._complete) {
          var h = function() {
            return c._complete.call(c._context);
          };
          d.syncErrorThrowable ? (this.__tryOrSetError(d, h), this.unsubscribe()) : (this.__tryOrUnsub(h), this.unsubscribe());
        } else
          this.unsubscribe();
      }
    }, l.prototype.__tryOrUnsub = function(c, d) {
      try {
        c.call(this._context, d);
      } catch (h) {
        throw this.unsubscribe(), h;
      }
    }, l.prototype.__tryOrSetError = function(c, d, h) {
      try {
        d.call(this._context, h);
      } catch (f) {
        return c.syncErrorValue = f, c.syncErrorThrown = !0, !0;
      }
      return !1;
    }, l.prototype._unsubscribe = function() {
      var c = this._parentSubscriber;
      this._context = null, this._parentSubscriber = null, c.unsubscribe();
    }, l;
  })(o);
  function a(u) {
    return u instanceof o || "syncErrorThrowable" in u && u[n.rxSubscriber];
  }
  return dr;
}
var Df;
function m1() {
  if (Df) return wa;
  Df = 1;
  var e = Ge(), t = dc(), r = gg();
  function i(n, o, s) {
    if (n) {
      if (n instanceof e.Subscriber)
        return n;
      if (n[t.rxSubscriber])
        return n[t.rxSubscriber]();
    }
    return !n && !o && !s ? new e.Subscriber(r.empty) : new e.Subscriber(n, o, s);
  }
  return wa.toSubscriber = i, wa;
}
var Ra = {}, Pf;
function fc() {
  return Pf || (Pf = 1, (function(e) {
    var t = yt();
    function r(i) {
      var n, o = i.Symbol;
      return typeof o == "function" ? o.observable ? n = o.observable : (n = o("observable"), o.observable = n) : n = "@@observable", n;
    }
    e.getSymbolObservable = r, e.observable = r(t.root), e.$$observable = e.observable;
  })(Ra)), Ra;
}
var kn = {}, Oa = {}, If;
function g1() {
  if (If) return Oa;
  If = 1;
  function e() {
  }
  return Oa.noop = e, Oa;
}
var Mf;
function b1() {
  if (Mf) return kn;
  Mf = 1;
  var e = g1();
  function t() {
    for (var i = [], n = 0; n < arguments.length; n++)
      i[n - 0] = arguments[n];
    return r(i);
  }
  kn.pipe = t;
  function r(i) {
    return i ? i.length === 1 ? i[0] : function(o) {
      return i.reduce(function(s, a) {
        return a(s);
      }, o);
    } : e.noop;
  }
  return kn.pipeFromArray = r, kn;
}
var jf;
function Te() {
  if (jf) return va;
  jf = 1;
  var e = yt(), t = m1(), r = fc(), i = b1(), n = (function() {
    function o(s) {
      this._isScalar = !1, s && (this._subscribe = s);
    }
    return o.prototype.lift = function(s) {
      var a = new o();
      return a.source = this, a.operator = s, a;
    }, o.prototype.subscribe = function(s, a, u) {
      var l = this.operator, c = t.toSubscriber(s, a, u);
      if (l ? l.call(c, this.source) : c.add(this.source || !c.syncErrorThrowable ? this._subscribe(c) : this._trySubscribe(c)), c.syncErrorThrowable && (c.syncErrorThrowable = !1, c.syncErrorThrown))
        throw c.syncErrorValue;
      return c;
    }, o.prototype._trySubscribe = function(s) {
      try {
        return this._subscribe(s);
      } catch (a) {
        s.syncErrorThrown = !0, s.syncErrorValue = a, s.error(a);
      }
    }, o.prototype.forEach = function(s, a) {
      var u = this;
      if (a || (e.root.Rx && e.root.Rx.config && e.root.Rx.config.Promise ? a = e.root.Rx.config.Promise : e.root.Promise && (a = e.root.Promise)), !a)
        throw new Error("no Promise impl found");
      return new a(function(l, c) {
        var d;
        d = u.subscribe(function(h) {
          if (d)
            try {
              s(h);
            } catch (f) {
              c(f), d.unsubscribe();
            }
          else
            s(h);
        }, c, l);
      });
    }, o.prototype._subscribe = function(s) {
      return this.source.subscribe(s);
    }, o.prototype[r.observable] = function() {
      return this;
    }, o.prototype.pipe = function() {
      for (var s = [], a = 0; a < arguments.length; a++)
        s[a - 0] = arguments[a];
      return s.length === 0 ? this : i.pipeFromArray(s)(this);
    }, o.prototype.toPromise = function(s) {
      var a = this;
      if (s || (e.root.Rx && e.root.Rx.config && e.root.Rx.config.Promise ? s = e.root.Rx.config.Promise : e.root.Promise && (s = e.root.Promise)), !s)
        throw new Error("no Promise impl found");
      return new s(function(u, l) {
        var c;
        a.subscribe(function(d) {
          return c = d;
        }, function(d) {
          return l(d);
        }, function() {
          return u(c);
        });
      });
    }, o.create = function(s) {
      return new o(s);
    }, o;
  })();
  return va.Observable = n, va;
}
var hr = {}, Ff;
function bg() {
  if (Ff) return hr;
  Ff = 1;
  var e = hr && hr.__extends || function(r, i) {
    for (var n in i) i.hasOwnProperty(n) && (r[n] = i[n]);
    function o() {
      this.constructor = r;
    }
    r.prototype = i === null ? Object.create(i) : (o.prototype = i.prototype, new o());
  }, t = (function(r) {
    e(i, r);
    function i() {
      var n = r.call(this, "object unsubscribed");
      this.name = n.name = "ObjectUnsubscribedError", this.stack = n.stack, this.message = n.message;
    }
    return i;
  })(Error);
  return hr.ObjectUnsubscribedError = t, hr;
}
var pr = {}, $f;
function v1() {
  if ($f) return pr;
  $f = 1;
  var e = pr && pr.__extends || function(i, n) {
    for (var o in n) n.hasOwnProperty(o) && (i[o] = n[o]);
    function s() {
      this.constructor = i;
    }
    i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
  }, t = dn(), r = (function(i) {
    e(n, i);
    function n(o, s) {
      i.call(this), this.subject = o, this.subscriber = s, this.closed = !1;
    }
    return n.prototype.unsubscribe = function() {
      if (!this.closed) {
        this.closed = !0;
        var o = this.subject, s = o.observers;
        if (this.subject = null, !(!s || s.length === 0 || o.isStopped || o.closed)) {
          var a = s.indexOf(this.subscriber);
          a !== -1 && s.splice(a, 1);
        }
      }
    }, n;
  })(t.Subscription);
  return pr.SubjectSubscription = r, pr;
}
var Lf;
function ii() {
  if (Lf) return Ot;
  Lf = 1;
  var e = Ot && Ot.__extends || function(c, d) {
    for (var h in d) d.hasOwnProperty(h) && (c[h] = d[h]);
    function f() {
      this.constructor = c;
    }
    c.prototype = d === null ? Object.create(d) : (f.prototype = d.prototype, new f());
  }, t = Te(), r = Ge(), i = dn(), n = bg(), o = v1(), s = dc(), a = (function(c) {
    e(d, c);
    function d(h) {
      c.call(this, h), this.destination = h;
    }
    return d;
  })(r.Subscriber);
  Ot.SubjectSubscriber = a;
  var u = (function(c) {
    e(d, c);
    function d() {
      c.call(this), this.observers = [], this.closed = !1, this.isStopped = !1, this.hasError = !1, this.thrownError = null;
    }
    return d.prototype[s.rxSubscriber] = function() {
      return new a(this);
    }, d.prototype.lift = function(h) {
      var f = new l(this, this);
      return f.operator = h, f;
    }, d.prototype.next = function(h) {
      if (this.closed)
        throw new n.ObjectUnsubscribedError();
      if (!this.isStopped)
        for (var f = this.observers, p = f.length, m = f.slice(), w = 0; w < p; w++)
          m[w].next(h);
    }, d.prototype.error = function(h) {
      if (this.closed)
        throw new n.ObjectUnsubscribedError();
      this.hasError = !0, this.thrownError = h, this.isStopped = !0;
      for (var f = this.observers, p = f.length, m = f.slice(), w = 0; w < p; w++)
        m[w].error(h);
      this.observers.length = 0;
    }, d.prototype.complete = function() {
      if (this.closed)
        throw new n.ObjectUnsubscribedError();
      this.isStopped = !0;
      for (var h = this.observers, f = h.length, p = h.slice(), m = 0; m < f; m++)
        p[m].complete();
      this.observers.length = 0;
    }, d.prototype.unsubscribe = function() {
      this.isStopped = !0, this.closed = !0, this.observers = null;
    }, d.prototype._trySubscribe = function(h) {
      if (this.closed)
        throw new n.ObjectUnsubscribedError();
      return c.prototype._trySubscribe.call(this, h);
    }, d.prototype._subscribe = function(h) {
      if (this.closed)
        throw new n.ObjectUnsubscribedError();
      return this.hasError ? (h.error(this.thrownError), i.Subscription.EMPTY) : this.isStopped ? (h.complete(), i.Subscription.EMPTY) : (this.observers.push(h), new o.SubjectSubscription(this, h));
    }, d.prototype.asObservable = function() {
      var h = new t.Observable();
      return h.source = this, h;
    }, d.create = function(h, f) {
      return new l(h, f);
    }, d;
  })(t.Observable);
  Ot.Subject = u;
  var l = (function(c) {
    e(d, c);
    function d(h, f) {
      c.call(this), this.destination = h, this.source = f;
    }
    return d.prototype.next = function(h) {
      var f = this.destination;
      f && f.next && f.next(h);
    }, d.prototype.error = function(h) {
      var f = this.destination;
      f && f.error && this.destination.error(h);
    }, d.prototype.complete = function() {
      var h = this.destination;
      h && h.complete && this.destination.complete();
    }, d.prototype._subscribe = function(h) {
      var f = this.source;
      return f ? this.source.subscribe(h) : i.Subscription.EMPTY;
    }, d;
  })(u);
  return Ot.AnonymousSubject = l, Ot;
}
var Nf;
function vg() {
  if (Nf) return lr;
  Nf = 1;
  var e = lr && lr.__extends || function(n, o) {
    for (var s in o) o.hasOwnProperty(s) && (n[s] = o[s]);
    function a() {
      this.constructor = n;
    }
    n.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
  }, t = ii(), r = bg(), i = (function(n) {
    e(o, n);
    function o(s) {
      n.call(this), this._value = s;
    }
    return Object.defineProperty(o.prototype, "value", {
      get: function() {
        return this.getValue();
      },
      enumerable: !0,
      configurable: !0
    }), o.prototype._subscribe = function(s) {
      var a = n.prototype._subscribe.call(this, s);
      return a && !a.closed && s.next(this._value), a;
    }, o.prototype.getValue = function() {
      if (this.hasError)
        throw this.thrownError;
      if (this.closed)
        throw new r.ObjectUnsubscribedError();
      return this._value;
    }, o.prototype.next = function(s) {
      n.prototype.next.call(this, this._value = s);
    }, o;
  })(t.Subject);
  return lr.BehaviorSubject = i, lr;
}
var Da = {}, mr = {}, gr = {}, Bf;
function y1() {
  if (Bf) return gr;
  Bf = 1;
  var e = gr && gr.__extends || function(i, n) {
    for (var o in n) n.hasOwnProperty(o) && (i[o] = n[o]);
    function s() {
      this.constructor = i;
    }
    i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
  }, t = dn(), r = (function(i) {
    e(n, i);
    function n(o, s) {
      i.call(this);
    }
    return n.prototype.schedule = function(o, s) {
      return this;
    }, n;
  })(t.Subscription);
  return gr.Action = r, gr;
}
var qf;
function w1() {
  if (qf) return mr;
  qf = 1;
  var e = mr && mr.__extends || function(n, o) {
    for (var s in o) o.hasOwnProperty(s) && (n[s] = o[s]);
    function a() {
      this.constructor = n;
    }
    n.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
  }, t = yt(), r = y1(), i = (function(n) {
    e(o, n);
    function o(s, a) {
      n.call(this, s, a), this.scheduler = s, this.pending = !1, this.work = a;
    }
    return o.prototype.schedule = function(s, a) {
      if (a === void 0 && (a = 0), this.closed)
        return this;
      this.state = s, this.pending = !0;
      var u = this.id, l = this.scheduler;
      return u != null && (this.id = this.recycleAsyncId(l, u, a)), this.delay = a, this.id = this.id || this.requestAsyncId(l, this.id, a), this;
    }, o.prototype.requestAsyncId = function(s, a, u) {
      return u === void 0 && (u = 0), t.root.setInterval(s.flush.bind(s, this), u);
    }, o.prototype.recycleAsyncId = function(s, a, u) {
      return u === void 0 && (u = 0), u !== null && this.delay === u && this.pending === !1 ? a : t.root.clearInterval(a) && void 0 || void 0;
    }, o.prototype.execute = function(s, a) {
      if (this.closed)
        return new Error("executing a cancelled action");
      this.pending = !1;
      var u = this._execute(s, a);
      if (u)
        return u;
      this.pending === !1 && this.id != null && (this.id = this.recycleAsyncId(this.scheduler, this.id, null));
    }, o.prototype._execute = function(s, a) {
      var u = !1, l = void 0;
      try {
        this.work(s);
      } catch (c) {
        u = !0, l = !!c && c || new Error(c);
      }
      if (u)
        return this.unsubscribe(), l;
    }, o.prototype._unsubscribe = function() {
      var s = this.id, a = this.scheduler, u = a.actions, l = u.indexOf(this);
      this.work = null, this.state = null, this.pending = !1, this.scheduler = null, l !== -1 && u.splice(l, 1), s != null && (this.id = this.recycleAsyncId(a, s, null)), this.delay = null;
    }, o;
  })(r.Action);
  return mr.AsyncAction = i, mr;
}
var br = {}, Pa = {}, zf;
function _1() {
  if (zf) return Pa;
  zf = 1;
  var e = (function() {
    function t(r, i) {
      i === void 0 && (i = t.now), this.SchedulerAction = r, this.now = i;
    }
    return t.prototype.schedule = function(r, i, n) {
      return i === void 0 && (i = 0), new this.SchedulerAction(this, r).schedule(n, i);
    }, t.now = Date.now ? Date.now : function() {
      return +/* @__PURE__ */ new Date();
    }, t;
  })();
  return Pa.Scheduler = e, Pa;
}
var Uf;
function k1() {
  if (Uf) return br;
  Uf = 1;
  var e = br && br.__extends || function(i, n) {
    for (var o in n) n.hasOwnProperty(o) && (i[o] = n[o]);
    function s() {
      this.constructor = i;
    }
    i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
  }, t = _1(), r = (function(i) {
    e(n, i);
    function n() {
      i.apply(this, arguments), this.actions = [], this.active = !1, this.scheduled = void 0;
    }
    return n.prototype.flush = function(o) {
      var s = this.actions;
      if (this.active) {
        s.push(o);
        return;
      }
      var a;
      this.active = !0;
      do
        if (a = o.execute(o.state, o.delay))
          break;
      while (o = s.shift());
      if (this.active = !1, a) {
        for (; o = s.shift(); )
          o.unsubscribe();
        throw a;
      }
    }, n;
  })(t.Scheduler);
  return br.AsyncScheduler = r, br;
}
var Vf;
function oi() {
  if (Vf) return Da;
  Vf = 1;
  var e = w1(), t = k1();
  return Da.async = new t.AsyncScheduler(e.AsyncAction), Da;
}
function Cu(e) {
  this.message = e;
}
Cu.prototype = new Error(), Cu.prototype.name = "InvalidCharacterError";
var Gf = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new Cu("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var r, i, n = 0, o = 0, s = ""; i = t.charAt(o++); ~i && (r = n % 4 ? 64 * r + i : i, n++ % 4) ? s += String.fromCharCode(255 & r >> (-2 * n & 6)) : 0) i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(i);
  return s;
};
function x1(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return (function(r) {
      return decodeURIComponent(Gf(r).replace(/(.)/g, (function(i, n) {
        var o = n.charCodeAt(0).toString(16).toUpperCase();
        return o.length < 2 && (o = "0" + o), "%" + o;
      })));
    })(t);
  } catch {
    return Gf(t);
  }
}
function Jr(e) {
  this.message = e;
}
function S1(e, t) {
  if (typeof e != "string") throw new Jr("Invalid token specified");
  var r = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(x1(e.split(".")[r]));
  } catch (i) {
    throw new Jr("Invalid token specified: " + i.message);
  }
}
Jr.prototype = new Error(), Jr.prototype.name = "InvalidTokenError";
const E1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  InvalidTokenError: Jr,
  default: S1
}, Symbol.toStringTag, { value: "Module" })), A1 = /* @__PURE__ */ ky(E1);
var Wf = {}, Ia = {}, vr = {}, yr = {}, Hf;
function ai() {
  if (Hf) return yr;
  Hf = 1;
  var e = yr && yr.__extends || function(i, n) {
    for (var o in n) n.hasOwnProperty(o) && (i[o] = n[o]);
    function s() {
      this.constructor = i;
    }
    i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
  }, t = Ge(), r = (function(i) {
    e(n, i);
    function n() {
      i.apply(this, arguments);
    }
    return n.prototype.notifyNext = function(o, s, a, u, l) {
      this.destination.next(s);
    }, n.prototype.notifyError = function(o, s) {
      this.destination.error(o);
    }, n.prototype.notifyComplete = function(o) {
      this.destination.complete();
    }, n;
  })(t.Subscriber);
  return yr.OuterSubscriber = r, yr;
}
var Ma = {}, ja = {}, Kf;
function yg() {
  return Kf || (Kf = 1, ja.isArrayLike = (function(e) {
    return e && typeof e.length == "number";
  })), ja;
}
var Fa = {}, Qf;
function wg() {
  if (Qf) return Fa;
  Qf = 1;
  function e(t) {
    return t && typeof t.subscribe != "function" && typeof t.then == "function";
  }
  return Fa.isPromise = e, Fa;
}
var $a = {}, Yf;
function hc() {
  return Yf || (Yf = 1, (function(e) {
    var t = yt();
    function r(i) {
      var n = i.Symbol;
      if (typeof n == "function")
        return n.iterator || (n.iterator = n("iterator polyfill")), n.iterator;
      var o = i.Set;
      if (o && typeof new o()["@@iterator"] == "function")
        return "@@iterator";
      var s = i.Map;
      if (s)
        for (var a = Object.getOwnPropertyNames(s.prototype), u = 0; u < a.length; ++u) {
          var l = a[u];
          if (l !== "entries" && l !== "size" && s.prototype[l] === s.prototype.entries)
            return l;
        }
      return "@@iterator";
    }
    e.symbolIteratorPonyfill = r, e.iterator = r(t.root), e.$$iterator = e.iterator;
  })($a)), $a;
}
var wr = {}, Jf;
function T1() {
  if (Jf) return wr;
  Jf = 1;
  var e = wr && wr.__extends || function(i, n) {
    for (var o in n) n.hasOwnProperty(o) && (i[o] = n[o]);
    function s() {
      this.constructor = i;
    }
    i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
  }, t = Ge(), r = (function(i) {
    e(n, i);
    function n(o, s, a) {
      i.call(this), this.parent = o, this.outerValue = s, this.outerIndex = a, this.index = 0;
    }
    return n.prototype._next = function(o) {
      this.parent.notifyNext(this.outerValue, o, this.outerIndex, this.index++, this);
    }, n.prototype._error = function(o) {
      this.parent.notifyError(o, this), this.unsubscribe();
    }, n.prototype._complete = function() {
      this.parent.notifyComplete(this), this.unsubscribe();
    }, n;
  })(t.Subscriber);
  return wr.InnerSubscriber = r, wr;
}
var Zf;
function si() {
  if (Zf) return Ma;
  Zf = 1;
  var e = yt(), t = yg(), r = wg(), i = mg(), n = Te(), o = hc(), s = T1(), a = fc();
  function u(l, c, d, h) {
    var f = new s.InnerSubscriber(l, d, h);
    if (f.closed)
      return null;
    if (c instanceof n.Observable)
      return c._isScalar ? (f.next(c.value), f.complete(), null) : (f.syncErrorThrowable = !0, c.subscribe(f));
    if (t.isArrayLike(c)) {
      for (var p = 0, m = c.length; p < m && !f.closed; p++)
        f.next(c[p]);
      f.closed || f.complete();
    } else {
      if (r.isPromise(c))
        return c.then(function(k) {
          f.closed || (f.next(k), f.complete());
        }, function(k) {
          return f.error(k);
        }).then(null, function(k) {
          e.root.setTimeout(function() {
            throw k;
          });
        }), f;
      if (c && typeof c[o.iterator] == "function") {
        var w = c[o.iterator]();
        do {
          var v = w.next();
          if (v.done) {
            f.complete();
            break;
          }
          if (f.next(v.value), f.closed)
            break;
        } while (!0);
      } else if (c && typeof c[a.observable] == "function") {
        var g = c[a.observable]();
        if (typeof g.subscribe != "function")
          f.error(new TypeError("Provided object does not correctly implement Symbol.observable"));
        else
          return g.subscribe(new s.InnerSubscriber(l, d, h));
      } else {
        var A = i.isObject(c) ? "an invalid object" : "'" + c + "'", b = "You provided " + A + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.";
        f.error(new TypeError(b));
      }
    }
    return null;
  }
  return Ma.subscribeToResult = u, Ma;
}
var Xf;
function C1() {
  if (Xf) return vr;
  Xf = 1;
  var e = vr && vr.__extends || function(s, a) {
    for (var u in a) a.hasOwnProperty(u) && (s[u] = a[u]);
    function l() {
      this.constructor = s;
    }
    s.prototype = a === null ? Object.create(a) : (l.prototype = a.prototype, new l());
  }, t = ai(), r = si();
  function i(s) {
    return function(u) {
      var l = new n(s), c = u.lift(l);
      return l.caught = c;
    };
  }
  vr.catchError = i;
  var n = (function() {
    function s(a) {
      this.selector = a;
    }
    return s.prototype.call = function(a, u) {
      return u.subscribe(new o(a, this.selector, this.caught));
    }, s;
  })(), o = (function(s) {
    e(a, s);
    function a(u, l, c) {
      s.call(this, u), this.selector = l, this.caught = c;
    }
    return a.prototype.error = function(u) {
      if (!this.isStopped) {
        var l = void 0;
        try {
          l = this.selector(u, this.caught);
        } catch (c) {
          s.prototype.error.call(this, c);
          return;
        }
        this._unsubscribeAndRecycle(), this.add(r.subscribeToResult(this, l));
      }
    }, a;
  })(t.OuterSubscriber);
  return vr;
}
var eh;
function R1() {
  if (eh) return Ia;
  eh = 1;
  var e = C1();
  function t(r) {
    return e.catchError(r)(this);
  }
  return Ia._catch = t, Ia;
}
var th;
function O1() {
  if (th) return Wf;
  th = 1;
  var e = Te(), t = R1();
  return e.Observable.prototype.catch = t._catch, e.Observable.prototype._catch = t._catch, Wf;
}
var rh = {}, La = {}, Dt = {}, _r = {}, kr = {}, nh;
function _g() {
  if (nh) return kr;
  nh = 1;
  var e = kr && kr.__extends || function(i, n) {
    for (var o in n) n.hasOwnProperty(o) && (i[o] = n[o]);
    function s() {
      this.constructor = i;
    }
    i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
  }, t = Te(), r = (function(i) {
    e(n, i);
    function n(o, s) {
      i.call(this), this.value = o, this.scheduler = s, this._isScalar = !0, s && (this._isScalar = !1);
    }
    return n.create = function(o, s) {
      return new n(o, s);
    }, n.dispatch = function(o) {
      var s = o.done, a = o.value, u = o.subscriber;
      if (s) {
        u.complete();
        return;
      }
      u.next(a), !u.closed && (o.done = !0, this.schedule(o));
    }, n.prototype._subscribe = function(o) {
      var s = this.value, a = this.scheduler;
      if (a)
        return a.schedule(n.dispatch, 0, {
          done: !1,
          value: s,
          subscriber: o
        });
      o.next(s), o.closed || o.complete();
    }, n;
  })(t.Observable);
  return kr.ScalarObservable = r, kr;
}
var xr = {}, ih;
function ui() {
  if (ih) return xr;
  ih = 1;
  var e = xr && xr.__extends || function(i, n) {
    for (var o in n) n.hasOwnProperty(o) && (i[o] = n[o]);
    function s() {
      this.constructor = i;
    }
    i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
  }, t = Te(), r = (function(i) {
    e(n, i);
    function n(o) {
      i.call(this), this.scheduler = o;
    }
    return n.create = function(o) {
      return new n(o);
    }, n.dispatch = function(o) {
      var s = o.subscriber;
      s.complete();
    }, n.prototype._subscribe = function(o) {
      var s = this.scheduler;
      if (s)
        return s.schedule(n.dispatch, 0, { subscriber: o });
      o.complete();
    }, n;
  })(t.Observable);
  return xr.EmptyObservable = r, xr;
}
var Na = {}, oh;
function D1() {
  if (oh) return Na;
  oh = 1;
  function e(t) {
    return t && typeof t.schedule == "function";
  }
  return Na.isScheduler = e, Na;
}
var ah;
function pc() {
  if (ah) return _r;
  ah = 1;
  var e = _r && _r.__extends || function(s, a) {
    for (var u in a) a.hasOwnProperty(u) && (s[u] = a[u]);
    function l() {
      this.constructor = s;
    }
    s.prototype = a === null ? Object.create(a) : (l.prototype = a.prototype, new l());
  }, t = Te(), r = _g(), i = ui(), n = D1(), o = (function(s) {
    e(a, s);
    function a(u, l) {
      s.call(this), this.array = u, this.scheduler = l, !l && u.length === 1 && (this._isScalar = !0, this.value = u[0]);
    }
    return a.create = function(u, l) {
      return new a(u, l);
    }, a.of = function() {
      for (var u = [], l = 0; l < arguments.length; l++)
        u[l - 0] = arguments[l];
      var c = u[u.length - 1];
      n.isScheduler(c) ? u.pop() : c = null;
      var d = u.length;
      return d > 1 ? new a(u, c) : d === 1 ? new r.ScalarObservable(u[0], c) : new i.EmptyObservable(c);
    }, a.dispatch = function(u) {
      var l = u.array, c = u.index, d = u.count, h = u.subscriber;
      if (c >= d) {
        h.complete();
        return;
      }
      h.next(l[c]), !h.closed && (u.index = c + 1, this.schedule(u));
    }, a.prototype._subscribe = function(u) {
      var l = 0, c = this.array, d = c.length, h = this.scheduler;
      if (h)
        return h.schedule(a.dispatch, 0, {
          array: c,
          index: l,
          count: d,
          subscriber: u
        });
      for (var f = 0; f < d && !u.closed; f++)
        u.next(c[f]);
      u.complete();
    }, a;
  })(t.Observable);
  return _r.ArrayObservable = o, _r;
}
var sh;
function P1() {
  if (sh) return Dt;
  sh = 1;
  var e = Dt && Dt.__extends || function(l, c) {
    for (var d in c) c.hasOwnProperty(d) && (l[d] = c[d]);
    function h() {
      this.constructor = l;
    }
    l.prototype = c === null ? Object.create(c) : (h.prototype = c.prototype, new h());
  }, t = pc(), r = ri(), i = ai(), n = si(), o = {};
  function s() {
    for (var l = [], c = 0; c < arguments.length; c++)
      l[c - 0] = arguments[c];
    var d = null;
    return typeof l[l.length - 1] == "function" && (d = l.pop()), l.length === 1 && r.isArray(l[0]) && (l = l[0].slice()), function(h) {
      return h.lift.call(new t.ArrayObservable([h].concat(l)), new a(d));
    };
  }
  Dt.combineLatest = s;
  var a = (function() {
    function l(c) {
      this.project = c;
    }
    return l.prototype.call = function(c, d) {
      return d.subscribe(new u(c, this.project));
    }, l;
  })();
  Dt.CombineLatestOperator = a;
  var u = (function(l) {
    e(c, l);
    function c(d, h) {
      l.call(this, d), this.project = h, this.active = 0, this.values = [], this.observables = [];
    }
    return c.prototype._next = function(d) {
      this.values.push(o), this.observables.push(d);
    }, c.prototype._complete = function() {
      var d = this.observables, h = d.length;
      if (h === 0)
        this.destination.complete();
      else {
        this.active = h, this.toRespond = h;
        for (var f = 0; f < h; f++) {
          var p = d[f];
          this.add(n.subscribeToResult(this, p, p, f));
        }
      }
    }, c.prototype.notifyComplete = function(d) {
      (this.active -= 1) === 0 && this.destination.complete();
    }, c.prototype.notifyNext = function(d, h, f, p, m) {
      var w = this.values, v = w[f], g = this.toRespond ? v === o ? --this.toRespond : this.toRespond : 0;
      w[f] = h, g === 0 && (this.project ? this._tryProject(w) : this.destination.next(w.slice()));
    }, c.prototype._tryProject = function(d) {
      var h;
      try {
        h = this.project.apply(this, d);
      } catch (f) {
        this.destination.error(f);
        return;
      }
      this.destination.next(h);
    }, c;
  })(i.OuterSubscriber);
  return Dt.CombineLatestSubscriber = u, Dt;
}
var uh;
function I1() {
  if (uh) return La;
  uh = 1;
  var e = P1();
  function t() {
    for (var r = [], i = 0; i < arguments.length; i++)
      r[i - 0] = arguments[i];
    return e.combineLatest.apply(void 0, r)(this);
  }
  return La.combineLatest = t, La;
}
var ch;
function M1() {
  if (ch) return rh;
  ch = 1;
  var e = Te(), t = I1();
  return e.Observable.prototype.combineLatest = t.combineLatest, rh;
}
var lh = {}, Ba = {}, Sr = {}, dh;
function j1() {
  if (dh) return Sr;
  dh = 1;
  var e = Sr && Sr.__extends || function(o, s) {
    for (var a in s) s.hasOwnProperty(a) && (o[a] = s[a]);
    function u() {
      this.constructor = o;
    }
    o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
  }, t = Ge();
  function r(o) {
    return function(s) {
      return s.lift(new i(o, s));
    };
  }
  Sr.count = r;
  var i = (function() {
    function o(s, a) {
      this.predicate = s, this.source = a;
    }
    return o.prototype.call = function(s, a) {
      return a.subscribe(new n(s, this.predicate, this.source));
    }, o;
  })(), n = (function(o) {
    e(s, o);
    function s(a, u, l) {
      o.call(this, a), this.predicate = u, this.source = l, this.count = 0, this.index = 0;
    }
    return s.prototype._next = function(a) {
      this.predicate ? this._tryPredicate(a) : this.count++;
    }, s.prototype._tryPredicate = function(a) {
      var u;
      try {
        u = this.predicate(a, this.index++, this.source);
      } catch (l) {
        this.destination.error(l);
        return;
      }
      u && this.count++;
    }, s.prototype._complete = function() {
      this.destination.next(this.count), this.destination.complete();
    }, s;
  })(t.Subscriber);
  return Sr;
}
var fh;
function F1() {
  if (fh) return Ba;
  fh = 1;
  var e = j1();
  function t(r) {
    return e.count(r)(this);
  }
  return Ba.count = t, Ba;
}
var hh;
function $1() {
  if (hh) return lh;
  hh = 1;
  var e = Te(), t = F1();
  return e.Observable.prototype.count = t.count, lh;
}
var ph = {}, qa = {}, Er = {}, za = {}, mh;
function L1() {
  if (mh) return za;
  mh = 1;
  function e(t) {
    return t instanceof Date && !isNaN(+t);
  }
  return za.isDate = e, za;
}
var Ua = {}, gh;
function kg() {
  if (gh) return Ua;
  gh = 1;
  var e = Te(), t = (function() {
    function r(i, n, o) {
      this.kind = i, this.value = n, this.error = o, this.hasValue = i === "N";
    }
    return r.prototype.observe = function(i) {
      switch (this.kind) {
        case "N":
          return i.next && i.next(this.value);
        case "E":
          return i.error && i.error(this.error);
        case "C":
          return i.complete && i.complete();
      }
    }, r.prototype.do = function(i, n, o) {
      var s = this.kind;
      switch (s) {
        case "N":
          return i && i(this.value);
        case "E":
          return n && n(this.error);
        case "C":
          return o && o();
      }
    }, r.prototype.accept = function(i, n, o) {
      return i && typeof i.next == "function" ? this.observe(i) : this.do(i, n, o);
    }, r.prototype.toObservable = function() {
      var i = this.kind;
      switch (i) {
        case "N":
          return e.Observable.of(this.value);
        case "E":
          return e.Observable.throw(this.error);
        case "C":
          return e.Observable.empty();
      }
      throw new Error("unexpected notification kind value");
    }, r.createNext = function(i) {
      return typeof i < "u" ? new r("N", i) : r.undefinedValueNotification;
    }, r.createError = function(i) {
      return new r("E", void 0, i);
    }, r.createComplete = function() {
      return r.completeNotification;
    }, r.completeNotification = new r("C"), r.undefinedValueNotification = new r("N", void 0), r;
  })();
  return Ua.Notification = t, Ua;
}
var bh;
function N1() {
  if (bh) return Er;
  bh = 1;
  var e = Er && Er.__extends || function(l, c) {
    for (var d in c) c.hasOwnProperty(d) && (l[d] = c[d]);
    function h() {
      this.constructor = l;
    }
    l.prototype = c === null ? Object.create(c) : (h.prototype = c.prototype, new h());
  }, t = oi(), r = L1(), i = Ge(), n = kg();
  function o(l, c) {
    c === void 0 && (c = t.async);
    var d = r.isDate(l), h = d ? +l - c.now() : Math.abs(l);
    return function(f) {
      return f.lift(new s(h, c));
    };
  }
  Er.delay = o;
  var s = (function() {
    function l(c, d) {
      this.delay = c, this.scheduler = d;
    }
    return l.prototype.call = function(c, d) {
      return d.subscribe(new a(c, this.delay, this.scheduler));
    }, l;
  })(), a = (function(l) {
    e(c, l);
    function c(d, h, f) {
      l.call(this, d), this.delay = h, this.scheduler = f, this.queue = [], this.active = !1, this.errored = !1;
    }
    return c.dispatch = function(d) {
      for (var h = d.source, f = h.queue, p = d.scheduler, m = d.destination; f.length > 0 && f[0].time - p.now() <= 0; )
        f.shift().notification.observe(m);
      if (f.length > 0) {
        var w = Math.max(0, f[0].time - p.now());
        this.schedule(d, w);
      } else
        this.unsubscribe(), h.active = !1;
    }, c.prototype._schedule = function(d) {
      this.active = !0, this.add(d.schedule(c.dispatch, this.delay, {
        source: this,
        destination: this.destination,
        scheduler: d
      }));
    }, c.prototype.scheduleNotification = function(d) {
      if (this.errored !== !0) {
        var h = this.scheduler, f = new u(h.now() + this.delay, d);
        this.queue.push(f), this.active === !1 && this._schedule(h);
      }
    }, c.prototype._next = function(d) {
      this.scheduleNotification(n.Notification.createNext(d));
    }, c.prototype._error = function(d) {
      this.errored = !0, this.queue = [], this.destination.error(d);
    }, c.prototype._complete = function() {
      this.scheduleNotification(n.Notification.createComplete());
    }, c;
  })(i.Subscriber), u = /* @__PURE__ */ (function() {
    function l(c, d) {
      this.time = c, this.notification = d;
    }
    return l;
  })();
  return Er;
}
var vh;
function B1() {
  if (vh) return qa;
  vh = 1;
  var e = oi(), t = N1();
  function r(i, n) {
    return n === void 0 && (n = e.async), t.delay(i, n)(this);
  }
  return qa.delay = r, qa;
}
var yh;
function q1() {
  if (yh) return ph;
  yh = 1;
  var e = Te(), t = B1();
  return e.Observable.prototype.delay = t.delay, ph;
}
var wh = {}, Va = {}, Ar = {}, _h;
function z1() {
  if (_h) return Ar;
  _h = 1;
  var e = Ar && Ar.__extends || function(o, s) {
    for (var a in s) s.hasOwnProperty(a) && (o[a] = s[a]);
    function u() {
      this.constructor = o;
    }
    o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
  }, t = Ge();
  function r(o, s, a) {
    return function(l) {
      return l.lift(new i(o, s, a));
    };
  }
  Ar.tap = r;
  var i = (function() {
    function o(s, a, u) {
      this.nextOrObserver = s, this.error = a, this.complete = u;
    }
    return o.prototype.call = function(s, a) {
      return a.subscribe(new n(s, this.nextOrObserver, this.error, this.complete));
    }, o;
  })(), n = (function(o) {
    e(s, o);
    function s(a, u, l, c) {
      o.call(this, a);
      var d = new t.Subscriber(u, l, c);
      d.syncErrorThrowable = !0, this.add(d), this.safeSubscriber = d;
    }
    return s.prototype._next = function(a) {
      var u = this.safeSubscriber;
      u.next(a), u.syncErrorThrown ? this.destination.error(u.syncErrorValue) : this.destination.next(a);
    }, s.prototype._error = function(a) {
      var u = this.safeSubscriber;
      u.error(a), u.syncErrorThrown ? this.destination.error(u.syncErrorValue) : this.destination.error(a);
    }, s.prototype._complete = function() {
      var a = this.safeSubscriber;
      a.complete(), a.syncErrorThrown ? this.destination.error(a.syncErrorValue) : this.destination.complete();
    }, s;
  })(t.Subscriber);
  return Ar;
}
var kh;
function U1() {
  if (kh) return Va;
  kh = 1;
  var e = z1();
  function t(r, i, n) {
    return e.tap(r, i, n)(this);
  }
  return Va._do = t, Va;
}
var xh;
function V1() {
  if (xh) return wh;
  xh = 1;
  var e = Te(), t = U1();
  return e.Observable.prototype.do = t._do, e.Observable.prototype._do = t._do, wh;
}
var Sh = {}, Ga = {}, Tr = {}, Eh;
function G1() {
  if (Eh) return Tr;
  Eh = 1;
  var e = Tr && Tr.__extends || function(o, s) {
    for (var a in s) s.hasOwnProperty(a) && (o[a] = s[a]);
    function u() {
      this.constructor = o;
    }
    o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
  }, t = Ge();
  function r(o, s) {
    return function(u) {
      return u.lift(new i(o, s));
    };
  }
  Tr.filter = r;
  var i = (function() {
    function o(s, a) {
      this.predicate = s, this.thisArg = a;
    }
    return o.prototype.call = function(s, a) {
      return a.subscribe(new n(s, this.predicate, this.thisArg));
    }, o;
  })(), n = (function(o) {
    e(s, o);
    function s(a, u, l) {
      o.call(this, a), this.predicate = u, this.thisArg = l, this.count = 0;
    }
    return s.prototype._next = function(a) {
      var u;
      try {
        u = this.predicate.call(this.thisArg, a, this.count++);
      } catch (l) {
        this.destination.error(l);
        return;
      }
      u && this.destination.next(a);
    }, s;
  })(t.Subscriber);
  return Tr;
}
var Ah;
function W1() {
  if (Ah) return Ga;
  Ah = 1;
  var e = G1();
  function t(r, i) {
    return e.filter(r, i)(this);
  }
  return Ga.filter = t, Ga;
}
var Th;
function H1() {
  if (Th) return Sh;
  Th = 1;
  var e = Te(), t = W1();
  return e.Observable.prototype.filter = t.filter, Sh;
}
var Ch = {}, Wa = {}, Gt = {}, Rh;
function xg() {
  if (Rh) return Gt;
  Rh = 1;
  var e = Gt && Gt.__extends || function(o, s) {
    for (var a in s) s.hasOwnProperty(a) && (o[a] = s[a]);
    function u() {
      this.constructor = o;
    }
    o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
  }, t = Ge();
  function r(o, s) {
    return function(u) {
      if (typeof o != "function")
        throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
      return u.lift(new i(o, s));
    };
  }
  Gt.map = r;
  var i = (function() {
    function o(s, a) {
      this.project = s, this.thisArg = a;
    }
    return o.prototype.call = function(s, a) {
      return a.subscribe(new n(s, this.project, this.thisArg));
    }, o;
  })();
  Gt.MapOperator = i;
  var n = (function(o) {
    e(s, o);
    function s(a, u, l) {
      o.call(this, a), this.project = u, this.count = 0, this.thisArg = l || this;
    }
    return s.prototype._next = function(a) {
      var u;
      try {
        u = this.project.call(this.thisArg, a, this.count++);
      } catch (l) {
        this.destination.error(l);
        return;
      }
      this.destination.next(u);
    }, s;
  })(t.Subscriber);
  return Gt;
}
var Oh;
function K1() {
  if (Oh) return Wa;
  Oh = 1;
  var e = xg();
  function t(r, i) {
    return e.map(r, i)(this);
  }
  return Wa.map = t, Wa;
}
var Dh;
function Q1() {
  if (Dh) return Ch;
  Dh = 1;
  var e = Te(), t = K1();
  return e.Observable.prototype.map = t.map, Ch;
}
var Ph = {}, Ha = {}, Pt = {}, Ih;
function Sg() {
  if (Ih) return Pt;
  Ih = 1;
  var e = Pt && Pt.__extends || function(s, a) {
    for (var u in a) a.hasOwnProperty(u) && (s[u] = a[u]);
    function l() {
      this.constructor = s;
    }
    s.prototype = a === null ? Object.create(a) : (l.prototype = a.prototype, new l());
  }, t = si(), r = ai();
  function i(s, a, u) {
    return u === void 0 && (u = Number.POSITIVE_INFINITY), function(c) {
      return typeof a == "number" && (u = a, a = null), c.lift(new n(s, a, u));
    };
  }
  Pt.mergeMap = i;
  var n = (function() {
    function s(a, u, l) {
      l === void 0 && (l = Number.POSITIVE_INFINITY), this.project = a, this.resultSelector = u, this.concurrent = l;
    }
    return s.prototype.call = function(a, u) {
      return u.subscribe(new o(a, this.project, this.resultSelector, this.concurrent));
    }, s;
  })();
  Pt.MergeMapOperator = n;
  var o = (function(s) {
    e(a, s);
    function a(u, l, c, d) {
      d === void 0 && (d = Number.POSITIVE_INFINITY), s.call(this, u), this.project = l, this.resultSelector = c, this.concurrent = d, this.hasCompleted = !1, this.buffer = [], this.active = 0, this.index = 0;
    }
    return a.prototype._next = function(u) {
      this.active < this.concurrent ? this._tryNext(u) : this.buffer.push(u);
    }, a.prototype._tryNext = function(u) {
      var l, c = this.index++;
      try {
        l = this.project(u, c);
      } catch (d) {
        this.destination.error(d);
        return;
      }
      this.active++, this._innerSub(l, u, c);
    }, a.prototype._innerSub = function(u, l, c) {
      this.add(t.subscribeToResult(this, u, l, c));
    }, a.prototype._complete = function() {
      this.hasCompleted = !0, this.active === 0 && this.buffer.length === 0 && this.destination.complete();
    }, a.prototype.notifyNext = function(u, l, c, d, h) {
      this.resultSelector ? this._notifyResultSelector(u, l, c, d) : this.destination.next(l);
    }, a.prototype._notifyResultSelector = function(u, l, c, d) {
      var h;
      try {
        h = this.resultSelector(u, l, c, d);
      } catch (f) {
        this.destination.error(f);
        return;
      }
      this.destination.next(h);
    }, a.prototype.notifyComplete = function(u) {
      var l = this.buffer;
      this.remove(u), this.active--, l.length > 0 ? this._next(l.shift()) : this.active === 0 && this.hasCompleted && this.destination.complete();
    }, a;
  })(r.OuterSubscriber);
  return Pt.MergeMapSubscriber = o, Pt;
}
var Mh;
function Y1() {
  if (Mh) return Ha;
  Mh = 1;
  var e = Sg();
  function t(r, i, n) {
    return n === void 0 && (n = Number.POSITIVE_INFINITY), e.mergeMap(r, i, n)(this);
  }
  return Ha.mergeMap = t, Ha;
}
var jh;
function J1() {
  if (jh) return Ph;
  jh = 1;
  var e = Te(), t = Y1();
  return e.Observable.prototype.mergeMap = t.mergeMap, e.Observable.prototype.flatMap = t.mergeMap, Ph;
}
var Fh = {}, Ka = {}, Qa = {}, $h;
function Z1() {
  if ($h) return Qa;
  $h = 1;
  var e = Sg();
  function t(r, i) {
    return e.mergeMap(r, i, 1);
  }
  return Qa.concatMap = t, Qa;
}
var Lh;
function X1() {
  if (Lh) return Ka;
  Lh = 1;
  var e = Z1();
  function t(r, i) {
    return e.concatMap(r, i)(this);
  }
  return Ka.concatMap = t, Ka;
}
var Nh;
function ew() {
  if (Nh) return Fh;
  Nh = 1;
  var e = Te(), t = X1();
  return e.Observable.prototype.concatMap = t.concatMap, Fh;
}
var Bh = {}, Ya = {}, Cr = {}, qh;
function tw() {
  if (qh) return Cr;
  qh = 1;
  var e = Cr && Cr.__extends || function(l, c) {
    for (var d in c) c.hasOwnProperty(d) && (l[d] = c[d]);
    function h() {
      this.constructor = l;
    }
    l.prototype = c === null ? Object.create(c) : (h.prototype = c.prototype, new h());
  }, t = ii(), r = lc(), i = ni(), n = ai(), o = si();
  function s(l) {
    return function(c) {
      return c.lift(new a(l, c));
    };
  }
  Cr.retryWhen = s;
  var a = (function() {
    function l(c, d) {
      this.notifier = c, this.source = d;
    }
    return l.prototype.call = function(c, d) {
      return d.subscribe(new u(c, this.notifier, this.source));
    }, l;
  })(), u = (function(l) {
    e(c, l);
    function c(d, h, f) {
      l.call(this, d), this.notifier = h, this.source = f;
    }
    return c.prototype.error = function(d) {
      if (!this.isStopped) {
        var h = this.errors, f = this.retries, p = this.retriesSubscription;
        if (f)
          this.errors = null, this.retriesSubscription = null;
        else {
          if (h = new t.Subject(), f = r.tryCatch(this.notifier)(h), f === i.errorObject)
            return l.prototype.error.call(this, i.errorObject.e);
          p = o.subscribeToResult(this, f);
        }
        this._unsubscribeAndRecycle(), this.errors = h, this.retries = f, this.retriesSubscription = p, h.next(d);
      }
    }, c.prototype._unsubscribe = function() {
      var d = this, h = d.errors, f = d.retriesSubscription;
      h && (h.unsubscribe(), this.errors = null), f && (f.unsubscribe(), this.retriesSubscription = null), this.retries = null;
    }, c.prototype.notifyNext = function(d, h, f, p, m) {
      var w = this, v = w.errors, g = w.retries, A = w.retriesSubscription;
      this.errors = null, this.retries = null, this.retriesSubscription = null, this._unsubscribeAndRecycle(), this.errors = v, this.retries = g, this.retriesSubscription = A, this.source.subscribe(this);
    }, c;
  })(n.OuterSubscriber);
  return Cr;
}
var zh;
function rw() {
  if (zh) return Ya;
  zh = 1;
  var e = tw();
  function t(r) {
    return e.retryWhen(r)(this);
  }
  return Ya.retryWhen = t, Ya;
}
var Uh;
function nw() {
  if (Uh) return Bh;
  Uh = 1;
  var e = Te(), t = rw();
  return e.Observable.prototype.retryWhen = t.retryWhen, Bh;
}
var Vh = {}, Ja = {}, Za = {}, xn = {}, Wt = {}, Rr = {}, Gh;
function Eg() {
  if (Gh) return Rr;
  Gh = 1;
  var e = Rr && Rr.__extends || function(o, s) {
    for (var a in s) s.hasOwnProperty(a) && (o[a] = s[a]);
    function u() {
      this.constructor = o;
    }
    o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
  }, t = Ge();
  function r() {
    return function(s) {
      return s.lift(new i(s));
    };
  }
  Rr.refCount = r;
  var i = (function() {
    function o(s) {
      this.connectable = s;
    }
    return o.prototype.call = function(s, a) {
      var u = this.connectable;
      u._refCount++;
      var l = new n(s, u), c = a.subscribe(l);
      return l.closed || (l.connection = u.connect()), c;
    }, o;
  })(), n = (function(o) {
    e(s, o);
    function s(a, u) {
      o.call(this, a), this.connectable = u;
    }
    return s.prototype._unsubscribe = function() {
      var a = this.connectable;
      if (!a) {
        this.connection = null;
        return;
      }
      this.connectable = null;
      var u = a._refCount;
      if (u <= 0) {
        this.connection = null;
        return;
      }
      if (a._refCount = u - 1, u > 1) {
        this.connection = null;
        return;
      }
      var l = this.connection, c = a._connection;
      this.connection = null, c && (!l || c === l) && c.unsubscribe();
    }, s;
  })(t.Subscriber);
  return Rr;
}
var Wh;
function iw() {
  if (Wh) return Wt;
  Wh = 1;
  var e = Wt && Wt.__extends || function(l, c) {
    for (var d in c) c.hasOwnProperty(d) && (l[d] = c[d]);
    function h() {
      this.constructor = l;
    }
    l.prototype = c === null ? Object.create(c) : (h.prototype = c.prototype, new h());
  }, t = ii(), r = Te(), i = Ge(), n = dn(), o = Eg(), s = (function(l) {
    e(c, l);
    function c(d, h) {
      l.call(this), this.source = d, this.subjectFactory = h, this._refCount = 0, this._isComplete = !1;
    }
    return c.prototype._subscribe = function(d) {
      return this.getSubject().subscribe(d);
    }, c.prototype.getSubject = function() {
      var d = this._subject;
      return (!d || d.isStopped) && (this._subject = this.subjectFactory()), this._subject;
    }, c.prototype.connect = function() {
      var d = this._connection;
      return d || (this._isComplete = !1, d = this._connection = new n.Subscription(), d.add(this.source.subscribe(new u(this.getSubject(), this))), d.closed ? (this._connection = null, d = n.Subscription.EMPTY) : this._connection = d), d;
    }, c.prototype.refCount = function() {
      return o.refCount()(this);
    }, c;
  })(r.Observable);
  Wt.ConnectableObservable = s;
  var a = s.prototype;
  Wt.connectableObservableDescriptor = {
    operator: { value: null },
    _refCount: { value: 0, writable: !0 },
    _subject: { value: null, writable: !0 },
    _connection: { value: null, writable: !0 },
    _subscribe: { value: a._subscribe },
    _isComplete: { value: a._isComplete, writable: !0 },
    getSubject: { value: a.getSubject },
    connect: { value: a.connect },
    refCount: { value: a.refCount }
  };
  var u = (function(l) {
    e(c, l);
    function c(d, h) {
      l.call(this, d), this.connectable = h;
    }
    return c.prototype._error = function(d) {
      this._unsubscribe(), l.prototype._error.call(this, d);
    }, c.prototype._complete = function() {
      this.connectable._isComplete = !0, this._unsubscribe(), l.prototype._complete.call(this);
    }, c.prototype._unsubscribe = function() {
      var d = this.connectable;
      if (d) {
        this.connectable = null;
        var h = d._connection;
        d._refCount = 0, d._subject = null, d._connection = null, h && h.unsubscribe();
      }
    }, c;
  })(t.SubjectSubscriber);
  return (function(l) {
    e(c, l);
    function c(d, h) {
      l.call(this, d), this.connectable = h;
    }
    return c.prototype._unsubscribe = function() {
      var d = this.connectable;
      if (!d) {
        this.connection = null;
        return;
      }
      this.connectable = null;
      var h = d._refCount;
      if (h <= 0) {
        this.connection = null;
        return;
      }
      if (d._refCount = h - 1, h > 1) {
        this.connection = null;
        return;
      }
      var f = this.connection, p = d._connection;
      this.connection = null, p && (!f || p === f) && p.unsubscribe();
    }, c;
  })(i.Subscriber), Wt;
}
var Hh;
function ow() {
  if (Hh) return xn;
  Hh = 1;
  var e = iw();
  function t(i, n) {
    return function(s) {
      var a;
      if (typeof i == "function" ? a = i : a = function() {
        return i;
      }, typeof n == "function")
        return s.lift(new r(a, n));
      var u = Object.create(s, e.connectableObservableDescriptor);
      return u.source = s, u.subjectFactory = a, u;
    };
  }
  xn.multicast = t;
  var r = (function() {
    function i(n, o) {
      this.subjectFactory = n, this.selector = o;
    }
    return i.prototype.call = function(n, o) {
      var s = this.selector, a = this.subjectFactory(), u = s(a).subscribe(n);
      return u.add(o.subscribe(a)), u;
    }, i;
  })();
  return xn.MulticastOperator = r, xn;
}
var Kh;
function aw() {
  if (Kh) return Za;
  Kh = 1;
  var e = ow(), t = Eg(), r = ii();
  function i() {
    return new r.Subject();
  }
  function n() {
    return function(o) {
      return t.refCount()(e.multicast(i)(o));
    };
  }
  return Za.share = n, Za;
}
var Qh;
function sw() {
  if (Qh) return Ja;
  Qh = 1;
  var e = aw();
  function t() {
    return e.share()(this);
  }
  return Ja.share = t, Ja;
}
var Yh;
function uw() {
  if (Yh) return Vh;
  Yh = 1;
  var e = Te(), t = sw();
  return e.Observable.prototype.share = t.share, Vh;
}
var Jh = {}, Xa = {}, Or = {}, Dr = {}, Zh;
function cw() {
  if (Zh) return Dr;
  Zh = 1;
  var e = Dr && Dr.__extends || function(r, i) {
    for (var n in i) i.hasOwnProperty(n) && (r[n] = i[n]);
    function o() {
      this.constructor = r;
    }
    r.prototype = i === null ? Object.create(i) : (o.prototype = i.prototype, new o());
  }, t = (function(r) {
    e(i, r);
    function i() {
      var n = r.call(this, "argument out of range");
      this.name = n.name = "ArgumentOutOfRangeError", this.stack = n.stack, this.message = n.message;
    }
    return i;
  })(Error);
  return Dr.ArgumentOutOfRangeError = t, Dr;
}
var Xh;
function lw() {
  if (Xh) return Or;
  Xh = 1;
  var e = Or && Or.__extends || function(a, u) {
    for (var l in u) u.hasOwnProperty(l) && (a[l] = u[l]);
    function c() {
      this.constructor = a;
    }
    a.prototype = u === null ? Object.create(u) : (c.prototype = u.prototype, new c());
  }, t = Ge(), r = cw(), i = ui();
  function n(a) {
    return function(u) {
      return a === 0 ? new i.EmptyObservable() : u.lift(new o(a));
    };
  }
  Or.take = n;
  var o = (function() {
    function a(u) {
      if (this.total = u, this.total < 0)
        throw new r.ArgumentOutOfRangeError();
    }
    return a.prototype.call = function(u, l) {
      return l.subscribe(new s(u, this.total));
    }, a;
  })(), s = (function(a) {
    e(u, a);
    function u(l, c) {
      a.call(this, l), this.total = c, this.count = 0;
    }
    return u.prototype._next = function(l) {
      var c = this.total, d = ++this.count;
      d <= c && (this.destination.next(l), d === c && (this.destination.complete(), this.unsubscribe()));
    }, u;
  })(t.Subscriber);
  return Or;
}
var ep;
function dw() {
  if (ep) return Xa;
  ep = 1;
  var e = lw();
  function t(r) {
    return e.take(r)(this);
  }
  return Xa.take = t, Xa;
}
var tp;
function fw() {
  if (tp) return Jh;
  tp = 1;
  var e = Te(), t = dw();
  return e.Observable.prototype.take = t.take, Jh;
}
var rp = {}, es = {}, Be = {}, np;
function hw() {
  if (np) return Be;
  np = 1;
  var e = Be && Be.__extends || function(y, x) {
    for (var C in x) x.hasOwnProperty(C) && (y[C] = x[C]);
    function I() {
      this.constructor = y;
    }
    y.prototype = x === null ? Object.create(x) : (I.prototype = x.prototype, new I());
  }, t = yt(), r = lc(), i = ni(), n = Te(), o = Ge(), s = xg();
  function a() {
    if (t.root.XMLHttpRequest)
      return new t.root.XMLHttpRequest();
    if (t.root.XDomainRequest)
      return new t.root.XDomainRequest();
    throw new Error("CORS is not supported by your browser");
  }
  function u() {
    if (t.root.XMLHttpRequest)
      return new t.root.XMLHttpRequest();
    var y = void 0;
    try {
      for (var x = ["Msxml2.XMLHTTP", "Microsoft.XMLHTTP", "Msxml2.XMLHTTP.4.0"], C = 0; C < 3; C++)
        try {
          if (y = x[C], new t.root.ActiveXObject(y))
            break;
        } catch {
        }
      return new t.root.ActiveXObject(y);
    } catch {
      throw new Error("XMLHttpRequest is not supported by your browser");
    }
  }
  function l(y, x) {
    return x === void 0 && (x = null), new w({ method: "GET", url: y, headers: x });
  }
  Be.ajaxGet = l;
  function c(y, x, C) {
    return new w({ method: "POST", url: y, body: x, headers: C });
  }
  Be.ajaxPost = c;
  function d(y, x) {
    return new w({ method: "DELETE", url: y, headers: x });
  }
  Be.ajaxDelete = d;
  function h(y, x, C) {
    return new w({ method: "PUT", url: y, body: x, headers: C });
  }
  Be.ajaxPut = h;
  function f(y, x, C) {
    return new w({ method: "PATCH", url: y, body: x, headers: C });
  }
  Be.ajaxPatch = f;
  var p = s.map(function(y, x) {
    return y.response;
  });
  function m(y, x) {
    return p(new w({
      method: "GET",
      url: y,
      responseType: "json",
      headers: x
    }));
  }
  Be.ajaxGetJSON = m;
  var w = (function(y) {
    e(x, y);
    function x(C) {
      y.call(this);
      var I = {
        async: !0,
        createXHR: function() {
          return this.crossDomain ? a.call(this) : u();
        },
        crossDomain: !1,
        withCredentials: !1,
        headers: {},
        method: "GET",
        responseType: "json",
        timeout: 0
      };
      if (typeof C == "string")
        I.url = C;
      else
        for (var M in C)
          C.hasOwnProperty(M) && (I[M] = C[M]);
      this.request = I;
    }
    return x.prototype._subscribe = function(C) {
      return new v(C, this.request);
    }, x.create = (function() {
      var C = function(I) {
        return new x(I);
      };
      return C.get = l, C.post = c, C.delete = d, C.put = h, C.patch = f, C.getJSON = m, C;
    })(), x;
  })(n.Observable);
  Be.AjaxObservable = w;
  var v = (function(y) {
    e(x, y);
    function x(C, I) {
      y.call(this, C), this.request = I, this.done = !1;
      var M = I.headers = I.headers || {};
      !I.crossDomain && !M["X-Requested-With"] && (M["X-Requested-With"] = "XMLHttpRequest"), !("Content-Type" in M) && !(t.root.FormData && I.body instanceof t.root.FormData) && typeof I.body < "u" && (M["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8"), I.body = this.serializeBody(I.body, I.headers["Content-Type"]), this.send();
    }
    return x.prototype.next = function(C) {
      this.done = !0;
      var I = this, M = I.xhr, Q = I.request, H = I.destination, J = new g(C, M, Q);
      H.next(J);
    }, x.prototype.send = function() {
      var C = this, I = C.request, M = C.request, Q = M.user, H = M.method, J = M.url, W = M.async, P = M.password, R = M.headers, V = M.body, X = I.createXHR, N = r.tryCatch(X).call(I);
      if (N === i.errorObject)
        this.error(i.errorObject.e);
      else {
        this.xhr = N, this.setupEvents(N, I);
        var U = void 0;
        if (Q ? U = r.tryCatch(N.open).call(N, H, J, W, Q, P) : U = r.tryCatch(N.open).call(N, H, J, W), U === i.errorObject)
          return this.error(i.errorObject.e), null;
        if (W && (N.timeout = I.timeout, N.responseType = I.responseType), "withCredentials" in N && (N.withCredentials = !!I.withCredentials), this.setHeaders(N, R), U = V ? r.tryCatch(N.send).call(N, V) : r.tryCatch(N.send).call(N), U === i.errorObject)
          return this.error(i.errorObject.e), null;
      }
      return N;
    }, x.prototype.serializeBody = function(C, I) {
      if (!C || typeof C == "string")
        return C;
      if (t.root.FormData && C instanceof t.root.FormData)
        return C;
      if (I) {
        var M = I.indexOf(";");
        M !== -1 && (I = I.substring(0, M));
      }
      switch (I) {
        case "application/x-www-form-urlencoded":
          return Object.keys(C).map(function(Q) {
            return encodeURIComponent(Q) + "=" + encodeURIComponent(C[Q]);
          }).join("&");
        case "application/json":
          return JSON.stringify(C);
        default:
          return C;
      }
    }, x.prototype.setHeaders = function(C, I) {
      for (var M in I)
        I.hasOwnProperty(M) && C.setRequestHeader(M, I[M]);
    }, x.prototype.setupEvents = function(C, I) {
      var M = I.progressSubscriber;
      function Q(P) {
        var R = Q, V = R.subscriber, X = R.progressSubscriber, N = R.request;
        X && X.error(P), V.error(new k(this, N));
      }
      if (C.ontimeout = Q, Q.request = I, Q.subscriber = this, Q.progressSubscriber = M, C.upload && "withCredentials" in C) {
        if (M) {
          var H;
          H = function(P) {
            var R = H.progressSubscriber;
            R.next(P);
          }, t.root.XDomainRequest ? C.onprogress = H : C.upload.onprogress = H, H.progressSubscriber = M;
        }
        var J;
        J = function(P) {
          var R = J, V = R.progressSubscriber, X = R.subscriber, N = R.request;
          V && V.error(P), X.error(new A("ajax error", this, N));
        }, C.onerror = J, J.request = I, J.subscriber = this, J.progressSubscriber = M;
      }
      function W(P) {
        var R = W, V = R.subscriber, X = R.progressSubscriber, N = R.request;
        if (this.readyState === 4) {
          var U = this.status === 1223 ? 204 : this.status, G = this.responseType === "text" ? this.response || this.responseText : this.response;
          U === 0 && (U = G ? 200 : 0), 200 <= U && U < 300 ? (X && X.complete(), V.next(P), V.complete()) : (X && X.error(P), V.error(new A("ajax error " + U, this, N)));
        }
      }
      C.onreadystatechange = W, W.subscriber = this, W.progressSubscriber = M, W.request = I;
    }, x.prototype.unsubscribe = function() {
      var C = this, I = C.done, M = C.xhr;
      !I && M && M.readyState !== 4 && typeof M.abort == "function" && M.abort(), y.prototype.unsubscribe.call(this);
    }, x;
  })(o.Subscriber);
  Be.AjaxSubscriber = v;
  var g = /* @__PURE__ */ (function() {
    function y(x, C, I) {
      this.originalEvent = x, this.xhr = C, this.request = I, this.status = C.status, this.responseType = C.responseType || I.responseType, this.response = b(this.responseType, C);
    }
    return y;
  })();
  Be.AjaxResponse = g;
  var A = (function(y) {
    e(x, y);
    function x(C, I, M) {
      y.call(this, C), this.message = C, this.xhr = I, this.request = M, this.status = I.status, this.responseType = I.responseType || M.responseType, this.response = b(this.responseType, I);
    }
    return x;
  })(Error);
  Be.AjaxError = A;
  function b(y, x) {
    switch (y) {
      case "json":
        return "response" in x ? x.responseType ? x.response : JSON.parse(x.response || x.responseText || "null") : JSON.parse(x.responseText || "null");
      case "xml":
        return x.responseXML;
      case "text":
      default:
        return "response" in x ? x.response : x.responseText;
    }
  }
  var k = (function(y) {
    e(x, y);
    function x(C, I) {
      y.call(this, "ajax timeout", C, I);
    }
    return x;
  })(A);
  return Be.AjaxTimeoutError = k, Be;
}
var ip;
function pw() {
  if (ip) return es;
  ip = 1;
  var e = hw();
  return es.ajax = e.AjaxObservable.create, es;
}
var op;
function mw() {
  if (op) return rp;
  op = 1;
  var e = Te(), t = pw();
  return e.Observable.ajax = t.ajax, rp;
}
var ap = {}, ts = {}, sp;
function gw() {
  if (sp) return ts;
  sp = 1;
  var e = ui();
  return ts.empty = e.EmptyObservable.create, ts;
}
var up;
function bw() {
  if (up) return ap;
  up = 1;
  var e = Te(), t = gw();
  return e.Observable.empty = t.empty, ap;
}
var cp = {}, rs = {}, Pr = {}, Ir = {}, lp;
function vw() {
  if (lp) return Ir;
  lp = 1;
  var e = Ir && Ir.__extends || function(s, a) {
    for (var u in a) a.hasOwnProperty(u) && (s[u] = a[u]);
    function l() {
      this.constructor = s;
    }
    s.prototype = a === null ? Object.create(a) : (l.prototype = a.prototype, new l());
  }, t = yt(), r = Te(), i = (function(s) {
    e(a, s);
    function a(u, l) {
      s.call(this), this.promise = u, this.scheduler = l;
    }
    return a.create = function(u, l) {
      return new a(u, l);
    }, a.prototype._subscribe = function(u) {
      var l = this, c = this.promise, d = this.scheduler;
      if (d == null)
        this._isScalar ? u.closed || (u.next(this.value), u.complete()) : c.then(function(h) {
          l.value = h, l._isScalar = !0, u.closed || (u.next(h), u.complete());
        }, function(h) {
          u.closed || u.error(h);
        }).then(null, function(h) {
          t.root.setTimeout(function() {
            throw h;
          });
        });
      else if (this._isScalar) {
        if (!u.closed)
          return d.schedule(n, 0, { value: this.value, subscriber: u });
      } else
        c.then(function(h) {
          l.value = h, l._isScalar = !0, u.closed || u.add(d.schedule(n, 0, { value: h, subscriber: u }));
        }, function(h) {
          u.closed || u.add(d.schedule(o, 0, { err: h, subscriber: u }));
        }).then(null, function(h) {
          t.root.setTimeout(function() {
            throw h;
          });
        });
    }, a;
  })(r.Observable);
  Ir.PromiseObservable = i;
  function n(s) {
    var a = s.value, u = s.subscriber;
    u.closed || (u.next(a), u.complete());
  }
  function o(s) {
    var a = s.err, u = s.subscriber;
    u.closed || u.error(a);
  }
  return Ir;
}
var Mr = {}, dp;
function yw() {
  if (dp) return Mr;
  dp = 1;
  var e = Mr && Mr.__extends || function(h, f) {
    for (var p in f) f.hasOwnProperty(p) && (h[p] = f[p]);
    function m() {
      this.constructor = h;
    }
    h.prototype = f === null ? Object.create(f) : (m.prototype = f.prototype, new m());
  }, t = yt(), r = Te(), i = hc(), n = (function(h) {
    e(f, h);
    function f(p, m) {
      if (h.call(this), this.scheduler = m, p == null)
        throw new Error("iterator cannot be null.");
      this.iterator = a(p);
    }
    return f.create = function(p, m) {
      return new f(p, m);
    }, f.dispatch = function(p) {
      var m = p.index, w = p.hasError, v = p.iterator, g = p.subscriber;
      if (w) {
        g.error(p.error);
        return;
      }
      var A = v.next();
      if (A.done) {
        g.complete();
        return;
      }
      if (g.next(A.value), p.index = m + 1, g.closed) {
        typeof v.return == "function" && v.return();
        return;
      }
      this.schedule(p);
    }, f.prototype._subscribe = function(p) {
      var m = 0, w = this, v = w.iterator, g = w.scheduler;
      if (g)
        return g.schedule(f.dispatch, 0, {
          index: m,
          iterator: v,
          subscriber: p
        });
      do {
        var A = v.next();
        if (A.done) {
          p.complete();
          break;
        } else
          p.next(A.value);
        if (p.closed) {
          typeof v.return == "function" && v.return();
          break;
        }
      } while (!0);
    }, f;
  })(r.Observable);
  Mr.IteratorObservable = n;
  var o = (function() {
    function h(f, p, m) {
      p === void 0 && (p = 0), m === void 0 && (m = f.length), this.str = f, this.idx = p, this.len = m;
    }
    return h.prototype[i.iterator] = function() {
      return this;
    }, h.prototype.next = function() {
      return this.idx < this.len ? {
        done: !1,
        value: this.str.charAt(this.idx++)
      } : {
        done: !0,
        value: void 0
      };
    }, h;
  })(), s = (function() {
    function h(f, p, m) {
      p === void 0 && (p = 0), m === void 0 && (m = l(f)), this.arr = f, this.idx = p, this.len = m;
    }
    return h.prototype[i.iterator] = function() {
      return this;
    }, h.prototype.next = function() {
      return this.idx < this.len ? {
        done: !1,
        value: this.arr[this.idx++]
      } : {
        done: !0,
        value: void 0
      };
    }, h;
  })();
  function a(h) {
    var f = h[i.iterator];
    if (!f && typeof h == "string")
      return new o(h);
    if (!f && h.length !== void 0)
      return new s(h);
    if (!f)
      throw new TypeError("object is not iterable");
    return h[i.iterator]();
  }
  var u = Math.pow(2, 53) - 1;
  function l(h) {
    var f = +h.length;
    return isNaN(f) ? 0 : f === 0 || !c(f) ? f : (f = d(f) * Math.floor(Math.abs(f)), f <= 0 ? 0 : f > u ? u : f);
  }
  function c(h) {
    return typeof h == "number" && t.root.isFinite(h);
  }
  function d(h) {
    var f = +h;
    return f === 0 || isNaN(f) ? f : f < 0 ? -1 : 1;
  }
  return Mr;
}
var jr = {}, fp;
function ww() {
  if (fp) return jr;
  fp = 1;
  var e = jr && jr.__extends || function(o, s) {
    for (var a in s) s.hasOwnProperty(a) && (o[a] = s[a]);
    function u() {
      this.constructor = o;
    }
    o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
  }, t = Te(), r = _g(), i = ui(), n = (function(o) {
    e(s, o);
    function s(a, u) {
      o.call(this), this.arrayLike = a, this.scheduler = u, !u && a.length === 1 && (this._isScalar = !0, this.value = a[0]);
    }
    return s.create = function(a, u) {
      var l = a.length;
      return l === 0 ? new i.EmptyObservable() : l === 1 ? new r.ScalarObservable(a[0], u) : new s(a, u);
    }, s.dispatch = function(a) {
      var u = a.arrayLike, l = a.index, c = a.length, d = a.subscriber;
      if (!d.closed) {
        if (l >= c) {
          d.complete();
          return;
        }
        d.next(u[l]), a.index = l + 1, this.schedule(a);
      }
    }, s.prototype._subscribe = function(a) {
      var u = 0, l = this, c = l.arrayLike, d = l.scheduler, h = c.length;
      if (d)
        return d.schedule(s.dispatch, 0, {
          arrayLike: c,
          index: u,
          length: h,
          subscriber: a
        });
      for (var f = 0; f < h && !a.closed; f++)
        a.next(c[f]);
      a.complete();
    }, s;
  })(t.Observable);
  return jr.ArrayLikeObservable = n, jr;
}
var _t = {}, hp;
function _w() {
  if (hp) return _t;
  hp = 1;
  var e = _t && _t.__extends || function(a, u) {
    for (var l in u) u.hasOwnProperty(l) && (a[l] = u[l]);
    function c() {
      this.constructor = a;
    }
    a.prototype = u === null ? Object.create(u) : (c.prototype = u.prototype, new c());
  }, t = Ge(), r = kg();
  function i(a, u) {
    return u === void 0 && (u = 0), function(c) {
      return c.lift(new n(a, u));
    };
  }
  _t.observeOn = i;
  var n = (function() {
    function a(u, l) {
      l === void 0 && (l = 0), this.scheduler = u, this.delay = l;
    }
    return a.prototype.call = function(u, l) {
      return l.subscribe(new o(u, this.scheduler, this.delay));
    }, a;
  })();
  _t.ObserveOnOperator = n;
  var o = (function(a) {
    e(u, a);
    function u(l, c, d) {
      d === void 0 && (d = 0), a.call(this, l), this.scheduler = c, this.delay = d;
    }
    return u.dispatch = function(l) {
      var c = l.notification, d = l.destination;
      c.observe(d), this.unsubscribe();
    }, u.prototype.scheduleMessage = function(l) {
      this.add(this.scheduler.schedule(u.dispatch, this.delay, new s(l, this.destination)));
    }, u.prototype._next = function(l) {
      this.scheduleMessage(r.Notification.createNext(l));
    }, u.prototype._error = function(l) {
      this.scheduleMessage(r.Notification.createError(l));
    }, u.prototype._complete = function() {
      this.scheduleMessage(r.Notification.createComplete());
    }, u;
  })(t.Subscriber);
  _t.ObserveOnSubscriber = o;
  var s = /* @__PURE__ */ (function() {
    function a(u, l) {
      this.notification = u, this.destination = l;
    }
    return a;
  })();
  return _t.ObserveOnMessage = s, _t;
}
var pp;
function kw() {
  if (pp) return Pr;
  pp = 1;
  var e = Pr && Pr.__extends || function(f, p) {
    for (var m in p) p.hasOwnProperty(m) && (f[m] = p[m]);
    function w() {
      this.constructor = f;
    }
    f.prototype = p === null ? Object.create(p) : (w.prototype = p.prototype, new w());
  }, t = ri(), r = yg(), i = wg(), n = vw(), o = yw(), s = pc(), a = ww(), u = hc(), l = Te(), c = _w(), d = fc(), h = (function(f) {
    e(p, f);
    function p(m, w) {
      f.call(this, null), this.ish = m, this.scheduler = w;
    }
    return p.create = function(m, w) {
      if (m != null) {
        if (typeof m[d.observable] == "function")
          return m instanceof l.Observable && !w ? m : new p(m, w);
        if (t.isArray(m))
          return new s.ArrayObservable(m, w);
        if (i.isPromise(m))
          return new n.PromiseObservable(m, w);
        if (typeof m[u.iterator] == "function" || typeof m == "string")
          return new o.IteratorObservable(m, w);
        if (r.isArrayLike(m))
          return new a.ArrayLikeObservable(m, w);
      }
      throw new TypeError((m !== null && typeof m || m) + " is not observable");
    }, p.prototype._subscribe = function(m) {
      var w = this.ish, v = this.scheduler;
      return v == null ? w[d.observable]().subscribe(m) : w[d.observable]().subscribe(new c.ObserveOnSubscriber(m, v, 0));
    }, p;
  })(l.Observable);
  return Pr.FromObservable = h, Pr;
}
var mp;
function xw() {
  if (mp) return rs;
  mp = 1;
  var e = kw();
  return rs.from = e.FromObservable.create, rs;
}
var gp;
function Sw() {
  if (gp) return cp;
  gp = 1;
  var e = Te(), t = xw();
  return e.Observable.from = t.from, cp;
}
var bp = {}, ns = {}, Fr = {}, is = {}, vp;
function Ew() {
  if (vp) return is;
  vp = 1;
  var e = ri();
  function t(r) {
    return !e.isArray(r) && r - parseFloat(r) + 1 >= 0;
  }
  return is.isNumeric = t, is;
}
var yp;
function Aw() {
  if (yp) return Fr;
  yp = 1;
  var e = Fr && Fr.__extends || function(o, s) {
    for (var a in s) s.hasOwnProperty(a) && (o[a] = s[a]);
    function u() {
      this.constructor = o;
    }
    o.prototype = s === null ? Object.create(s) : (u.prototype = s.prototype, new u());
  }, t = Ew(), r = Te(), i = oi(), n = (function(o) {
    e(s, o);
    function s(a, u) {
      a === void 0 && (a = 0), u === void 0 && (u = i.async), o.call(this), this.period = a, this.scheduler = u, (!t.isNumeric(a) || a < 0) && (this.period = 0), (!u || typeof u.schedule != "function") && (this.scheduler = i.async);
    }
    return s.create = function(a, u) {
      return a === void 0 && (a = 0), u === void 0 && (u = i.async), new s(a, u);
    }, s.dispatch = function(a) {
      var u = a.index, l = a.subscriber, c = a.period;
      l.next(u), !l.closed && (a.index += 1, this.schedule(a, c));
    }, s.prototype._subscribe = function(a) {
      var u = 0, l = this.period, c = this.scheduler;
      a.add(c.schedule(s.dispatch, l, {
        index: u,
        subscriber: a,
        period: l
      }));
    }, s;
  })(r.Observable);
  return Fr.IntervalObservable = n, Fr;
}
var wp;
function Tw() {
  if (wp) return ns;
  wp = 1;
  var e = Aw();
  return ns.interval = e.IntervalObservable.create, ns;
}
var _p;
function Cw() {
  if (_p) return bp;
  _p = 1;
  var e = Te(), t = Tw();
  return e.Observable.interval = t.interval, bp;
}
var kp = {}, os = {}, xp;
function Rw() {
  if (xp) return os;
  xp = 1;
  var e = pc();
  return os.of = e.ArrayObservable.of, os;
}
var Sp;
function Ow() {
  if (Sp) return kp;
  Sp = 1;
  var e = Te(), t = Rw();
  return e.Observable.of = t.of, kp;
}
var Ep = {}, as = {}, $r = {}, Ap;
function Dw() {
  if (Ap) return $r;
  Ap = 1;
  var e = $r && $r.__extends || function(i, n) {
    for (var o in n) n.hasOwnProperty(o) && (i[o] = n[o]);
    function s() {
      this.constructor = i;
    }
    i.prototype = n === null ? Object.create(n) : (s.prototype = n.prototype, new s());
  }, t = Te(), r = (function(i) {
    e(n, i);
    function n(o, s) {
      i.call(this), this.error = o, this.scheduler = s;
    }
    return n.create = function(o, s) {
      return new n(o, s);
    }, n.dispatch = function(o) {
      var s = o.error, a = o.subscriber;
      a.error(s);
    }, n.prototype._subscribe = function(o) {
      var s = this.error, a = this.scheduler;
      if (o.syncErrorThrowable = !0, a)
        return a.schedule(n.dispatch, 0, {
          error: s,
          subscriber: o
        });
      o.error(s);
    }, n;
  })(t.Observable);
  return $r.ErrorObservable = r, $r;
}
var Tp;
function Pw() {
  if (Tp) return as;
  Tp = 1;
  var e = Dw();
  return as._throw = e.ErrorObservable.create, as;
}
var Cp;
function Iw() {
  if (Cp) return Ep;
  Cp = 1;
  var e = Te(), t = Pw();
  return e.Observable.throw = t._throw, Ep;
}
var ss = {}, us = {}, cs = { exports: {} }, ls = { exports: {} }, Rp;
function Mw() {
  return Rp || (Rp = 1, (function(e) {
    function t(r) {
      if (Array.isArray(r)) return r;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(ls)), ls.exports;
}
var ds = { exports: {} }, Op;
function Ag() {
  return Op || (Op = 1, (function(e) {
    function t(r) {
      if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(ds)), ds.exports;
}
var fs = { exports: {} }, hs = { exports: {} }, Dp;
function Tg() {
  return Dp || (Dp = 1, (function(e) {
    function t(r, i) {
      (i == null || i > r.length) && (i = r.length);
      for (var n = 0, o = Array(i); n < i; n++) o[n] = r[n];
      return o;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(hs)), hs.exports;
}
var Pp;
function Cg() {
  return Pp || (Pp = 1, (function(e) {
    var t = Tg();
    function r(i, n) {
      if (i) {
        if (typeof i == "string") return t(i, n);
        var o = {}.toString.call(i).slice(8, -1);
        return o === "Object" && i.constructor && (o = i.constructor.name), o === "Map" || o === "Set" ? Array.from(i) : o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? t(i, n) : void 0;
      }
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(fs)), fs.exports;
}
var ps = { exports: {} }, Ip;
function jw() {
  return Ip || (Ip = 1, (function(e) {
    function t() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(ps)), ps.exports;
}
var Mp;
function Fw() {
  return Mp || (Mp = 1, (function(e) {
    var t = Mw(), r = Ag(), i = Cg(), n = jw();
    function o(s) {
      return t(s) || r(s) || i(s) || n();
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(cs)), cs.exports;
}
var jp;
function $w() {
  return jp || (jp = 1, (function(e) {
    var t = sn();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var r = t(Fw());
    function i(n) {
      if (n)
        if (~n.indexOf(".")) {
          var o = n.split(".").reverse(), s = (0, r.default)(o), a = s[0], u = s.slice(1);
          return {
            extname: "." + a,
            name: u.reverse().join(".")
          };
        } else
          return {
            extname: "",
            name: n
          };
      else return {
        extname: "",
        name: ""
      };
    }
  })(us)), us;
}
var Fp;
function Lw() {
  return Fp || (Fp = 1, (function(e) {
    var t = sn();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = i;
    var r = t($w());
    function i(n) {
      var o = [];
      return n.forEach(function(s) {
        for (var a = (0, r.default)(s), u = a.extname, l = a.name, c = 0, d = s; o.includes(d); )
          d = [l, "(".concat(++c, ")")].filter(function(h) {
            return h;
          }).join(" ") + u;
        o.push(d);
      }), o;
    }
  })(ss)), ss;
}
var Lr = {}, ms = { exports: {} }, $p;
function Nw() {
  return $p || ($p = 1, (function(e) {
    var t = nr().default;
    function r() {
      e.exports = r = function() {
        return n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports;
      var i, n = {}, o = Object.prototype, s = o.hasOwnProperty, a = Object.defineProperty || function(N, U, G) {
        N[U] = G.value;
      }, u = typeof Symbol == "function" ? Symbol : {}, l = u.iterator || "@@iterator", c = u.asyncIterator || "@@asyncIterator", d = u.toStringTag || "@@toStringTag";
      function h(N, U, G) {
        return Object.defineProperty(N, U, {
          value: G,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), N[U];
      }
      try {
        h({}, "");
      } catch {
        h = function(G, re, oe) {
          return G[re] = oe;
        };
      }
      function f(N, U, G, re) {
        var oe = U && U.prototype instanceof b ? U : b, ie = Object.create(oe.prototype), le = new V(re || []);
        return a(ie, "_invoke", {
          value: J(N, G, le)
        }), ie;
      }
      function p(N, U, G) {
        try {
          return {
            type: "normal",
            arg: N.call(U, G)
          };
        } catch (re) {
          return {
            type: "throw",
            arg: re
          };
        }
      }
      n.wrap = f;
      var m = "suspendedStart", w = "suspendedYield", v = "executing", g = "completed", A = {};
      function b() {
      }
      function k() {
      }
      function y() {
      }
      var x = {};
      h(x, l, function() {
        return this;
      });
      var C = Object.getPrototypeOf, I = C && C(C(X([])));
      I && I !== o && s.call(I, l) && (x = I);
      var M = y.prototype = b.prototype = Object.create(x);
      function Q(N) {
        ["next", "throw", "return"].forEach(function(U) {
          h(N, U, function(G) {
            return this._invoke(U, G);
          });
        });
      }
      function H(N, U) {
        function G(oe, ie, le, he) {
          var ye = p(N[oe], N, ie);
          if (ye.type !== "throw") {
            var be = ye.arg, we = be.value;
            return we && t(we) == "object" && s.call(we, "__await") ? U.resolve(we.__await).then(function(ve) {
              G("next", ve, le, he);
            }, function(ve) {
              G("throw", ve, le, he);
            }) : U.resolve(we).then(function(ve) {
              be.value = ve, le(be);
            }, function(ve) {
              return G("throw", ve, le, he);
            });
          }
          he(ye.arg);
        }
        var re;
        a(this, "_invoke", {
          value: function(ie, le) {
            function he() {
              return new U(function(ye, be) {
                G(ie, le, ye, be);
              });
            }
            return re = re ? re.then(he, he) : he();
          }
        });
      }
      function J(N, U, G) {
        var re = m;
        return function(oe, ie) {
          if (re === v) throw Error("Generator is already running");
          if (re === g) {
            if (oe === "throw") throw ie;
            return {
              value: i,
              done: !0
            };
          }
          for (G.method = oe, G.arg = ie; ; ) {
            var le = G.delegate;
            if (le) {
              var he = W(le, G);
              if (he) {
                if (he === A) continue;
                return he;
              }
            }
            if (G.method === "next") G.sent = G._sent = G.arg;
            else if (G.method === "throw") {
              if (re === m) throw re = g, G.arg;
              G.dispatchException(G.arg);
            } else G.method === "return" && G.abrupt("return", G.arg);
            re = v;
            var ye = p(N, U, G);
            if (ye.type === "normal") {
              if (re = G.done ? g : w, ye.arg === A) continue;
              return {
                value: ye.arg,
                done: G.done
              };
            }
            ye.type === "throw" && (re = g, G.method = "throw", G.arg = ye.arg);
          }
        };
      }
      function W(N, U) {
        var G = U.method, re = N.iterator[G];
        if (re === i) return U.delegate = null, G === "throw" && N.iterator.return && (U.method = "return", U.arg = i, W(N, U), U.method === "throw") || G !== "return" && (U.method = "throw", U.arg = new TypeError("The iterator does not provide a '" + G + "' method")), A;
        var oe = p(re, N.iterator, U.arg);
        if (oe.type === "throw") return U.method = "throw", U.arg = oe.arg, U.delegate = null, A;
        var ie = oe.arg;
        return ie ? ie.done ? (U[N.resultName] = ie.value, U.next = N.nextLoc, U.method !== "return" && (U.method = "next", U.arg = i), U.delegate = null, A) : ie : (U.method = "throw", U.arg = new TypeError("iterator result is not an object"), U.delegate = null, A);
      }
      function P(N) {
        var U = {
          tryLoc: N[0]
        };
        1 in N && (U.catchLoc = N[1]), 2 in N && (U.finallyLoc = N[2], U.afterLoc = N[3]), this.tryEntries.push(U);
      }
      function R(N) {
        var U = N.completion || {};
        U.type = "normal", delete U.arg, N.completion = U;
      }
      function V(N) {
        this.tryEntries = [{
          tryLoc: "root"
        }], N.forEach(P, this), this.reset(!0);
      }
      function X(N) {
        if (N || N === "") {
          var U = N[l];
          if (U) return U.call(N);
          if (typeof N.next == "function") return N;
          if (!isNaN(N.length)) {
            var G = -1, re = function oe() {
              for (; ++G < N.length; ) if (s.call(N, G)) return oe.value = N[G], oe.done = !1, oe;
              return oe.value = i, oe.done = !0, oe;
            };
            return re.next = re;
          }
        }
        throw new TypeError(t(N) + " is not iterable");
      }
      return k.prototype = y, a(M, "constructor", {
        value: y,
        configurable: !0
      }), a(y, "constructor", {
        value: k,
        configurable: !0
      }), k.displayName = h(y, d, "GeneratorFunction"), n.isGeneratorFunction = function(N) {
        var U = typeof N == "function" && N.constructor;
        return !!U && (U === k || (U.displayName || U.name) === "GeneratorFunction");
      }, n.mark = function(N) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(N, y) : (N.__proto__ = y, h(N, d, "GeneratorFunction")), N.prototype = Object.create(M), N;
      }, n.awrap = function(N) {
        return {
          __await: N
        };
      }, Q(H.prototype), h(H.prototype, c, function() {
        return this;
      }), n.AsyncIterator = H, n.async = function(N, U, G, re, oe) {
        oe === void 0 && (oe = Promise);
        var ie = new H(f(N, U, G, re), oe);
        return n.isGeneratorFunction(U) ? ie : ie.next().then(function(le) {
          return le.done ? le.value : ie.next();
        });
      }, Q(M), h(M, d, "Generator"), h(M, l, function() {
        return this;
      }), h(M, "toString", function() {
        return "[object Generator]";
      }), n.keys = function(N) {
        var U = Object(N), G = [];
        for (var re in U) G.push(re);
        return G.reverse(), function oe() {
          for (; G.length; ) {
            var ie = G.pop();
            if (ie in U) return oe.value = ie, oe.done = !1, oe;
          }
          return oe.done = !0, oe;
        };
      }, n.values = X, V.prototype = {
        constructor: V,
        reset: function(U) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = i, this.done = !1, this.delegate = null, this.method = "next", this.arg = i, this.tryEntries.forEach(R), !U) for (var G in this) G.charAt(0) === "t" && s.call(this, G) && !isNaN(+G.slice(1)) && (this[G] = i);
        },
        stop: function() {
          this.done = !0;
          var U = this.tryEntries[0].completion;
          if (U.type === "throw") throw U.arg;
          return this.rval;
        },
        dispatchException: function(U) {
          if (this.done) throw U;
          var G = this;
          function re(be, we) {
            return le.type = "throw", le.arg = U, G.next = be, we && (G.method = "next", G.arg = i), !!we;
          }
          for (var oe = this.tryEntries.length - 1; oe >= 0; --oe) {
            var ie = this.tryEntries[oe], le = ie.completion;
            if (ie.tryLoc === "root") return re("end");
            if (ie.tryLoc <= this.prev) {
              var he = s.call(ie, "catchLoc"), ye = s.call(ie, "finallyLoc");
              if (he && ye) {
                if (this.prev < ie.catchLoc) return re(ie.catchLoc, !0);
                if (this.prev < ie.finallyLoc) return re(ie.finallyLoc);
              } else if (he) {
                if (this.prev < ie.catchLoc) return re(ie.catchLoc, !0);
              } else {
                if (!ye) throw Error("try statement without catch or finally");
                if (this.prev < ie.finallyLoc) return re(ie.finallyLoc);
              }
            }
          }
        },
        abrupt: function(U, G) {
          for (var re = this.tryEntries.length - 1; re >= 0; --re) {
            var oe = this.tryEntries[re];
            if (oe.tryLoc <= this.prev && s.call(oe, "finallyLoc") && this.prev < oe.finallyLoc) {
              var ie = oe;
              break;
            }
          }
          ie && (U === "break" || U === "continue") && ie.tryLoc <= G && G <= ie.finallyLoc && (ie = null);
          var le = ie ? ie.completion : {};
          return le.type = U, le.arg = G, ie ? (this.method = "next", this.next = ie.finallyLoc, A) : this.complete(le);
        },
        complete: function(U, G) {
          if (U.type === "throw") throw U.arg;
          return U.type === "break" || U.type === "continue" ? this.next = U.arg : U.type === "return" ? (this.rval = this.arg = U.arg, this.method = "return", this.next = "end") : U.type === "normal" && G && (this.next = G), A;
        },
        finish: function(U) {
          for (var G = this.tryEntries.length - 1; G >= 0; --G) {
            var re = this.tryEntries[G];
            if (re.finallyLoc === U) return this.complete(re.completion, re.afterLoc), R(re), A;
          }
        },
        catch: function(U) {
          for (var G = this.tryEntries.length - 1; G >= 0; --G) {
            var re = this.tryEntries[G];
            if (re.tryLoc === U) {
              var oe = re.completion;
              if (oe.type === "throw") {
                var ie = oe.arg;
                R(re);
              }
              return ie;
            }
          }
          throw Error("illegal catch attempt");
        },
        delegateYield: function(U, G, re) {
          return this.delegate = {
            iterator: X(U),
            resultName: G,
            nextLoc: re
          }, this.method === "next" && (this.arg = i), A;
        }
      }, n;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(ms)), ms.exports;
}
var gs, Lp;
function Bw() {
  if (Lp) return gs;
  Lp = 1;
  var e = Nw()();
  gs = e;
  try {
    regeneratorRuntime = e;
  } catch {
    typeof globalThis == "object" ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e);
  }
  return gs;
}
var bs = { exports: {} }, vs = { exports: {} }, Np;
function qw() {
  return Np || (Np = 1, (function(e) {
    function t(r, i) {
      return i.get ? i.get.call(r) : i.value;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(vs)), vs.exports;
}
var ys = { exports: {} }, ws = { exports: {} }, Bp;
function zw() {
  return Bp || (Bp = 1, (function(e) {
    function t(r, i, n) {
      if (typeof r == "function" ? r === i : r.has(i)) return arguments.length < 3 ? i : n;
      throw new TypeError("Private element is not present on this object");
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(ws)), ws.exports;
}
var qp;
function Rg() {
  return qp || (qp = 1, (function(e) {
    var t = zw();
    function r(i, n) {
      return i.get(t(i, n));
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(ys)), ys.exports;
}
var zp;
function Og() {
  return zp || (zp = 1, (function(e) {
    var t = qw(), r = Rg();
    function i(n, o) {
      var s = r(o, n);
      return t(n, s);
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(bs)), bs.exports;
}
var _s = { exports: {} }, ks = { exports: {} }, Up;
function Uw() {
  return Up || (Up = 1, (function(e) {
    function t(r, i, n) {
      if (i.set) i.set.call(r, n);
      else {
        if (!i.writable) throw new TypeError("attempted to set read only private field");
        i.value = n;
      }
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(ks)), ks.exports;
}
var Vp;
function Dg() {
  return Vp || (Vp = 1, (function(e) {
    var t = Uw(), r = Rg();
    function i(n, o, s) {
      var a = r(o, n);
      return t(n, a, s), s;
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(_s)), _s.exports;
}
var xs = { exports: {} }, Ss = { exports: {} }, Gp;
function Vw() {
  return Gp || (Gp = 1, (function(e) {
    var t = Tg();
    function r(i) {
      if (Array.isArray(i)) return t(i);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Ss)), Ss.exports;
}
var Es = { exports: {} }, Wp;
function Gw() {
  return Wp || (Wp = 1, (function(e) {
    function t() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Es)), Es.exports;
}
var Hp;
function Ww() {
  return Hp || (Hp = 1, (function(e) {
    var t = Vw(), r = Ag(), i = Cg(), n = Gw();
    function o(s) {
      return t(s) || r(s) || i(s) || n();
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(xs)), xs.exports;
}
var As = { exports: {} }, Kp;
function Hw() {
  return Kp || (Kp = 1, (function(e) {
    function t(i, n, o, s, a, u, l) {
      try {
        var c = i[u](l), d = c.value;
      } catch (h) {
        return void o(h);
      }
      c.done ? n(d) : Promise.resolve(d).then(s, a);
    }
    function r(i) {
      return function() {
        var n = this, o = arguments;
        return new Promise(function(s, a) {
          var u = i.apply(n, o);
          function l(d) {
            t(u, s, a, l, c, "next", d);
          }
          function c(d) {
            t(u, s, a, l, c, "throw", d);
          }
          l(void 0);
        });
      };
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(As)), As.exports;
}
var Ts = {}, Nr = {}, Qp;
function Kw() {
  if (Qp) return Nr;
  Qp = 1, Nr.byteLength = a, Nr.toByteArray = l, Nr.fromByteArray = h;
  for (var e = [], t = [], r = typeof Uint8Array < "u" ? Uint8Array : Array, i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = 0, o = i.length; n < o; ++n)
    e[n] = i[n], t[i.charCodeAt(n)] = n;
  t[45] = 62, t[95] = 63;
  function s(f) {
    var p = f.length;
    if (p % 4 > 0)
      throw new Error("Invalid string. Length must be a multiple of 4");
    var m = f.indexOf("=");
    m === -1 && (m = p);
    var w = m === p ? 0 : 4 - m % 4;
    return [m, w];
  }
  function a(f) {
    var p = s(f), m = p[0], w = p[1];
    return (m + w) * 3 / 4 - w;
  }
  function u(f, p, m) {
    return (p + m) * 3 / 4 - m;
  }
  function l(f) {
    var p, m = s(f), w = m[0], v = m[1], g = new r(u(f, w, v)), A = 0, b = v > 0 ? w - 4 : w, k;
    for (k = 0; k < b; k += 4)
      p = t[f.charCodeAt(k)] << 18 | t[f.charCodeAt(k + 1)] << 12 | t[f.charCodeAt(k + 2)] << 6 | t[f.charCodeAt(k + 3)], g[A++] = p >> 16 & 255, g[A++] = p >> 8 & 255, g[A++] = p & 255;
    return v === 2 && (p = t[f.charCodeAt(k)] << 2 | t[f.charCodeAt(k + 1)] >> 4, g[A++] = p & 255), v === 1 && (p = t[f.charCodeAt(k)] << 10 | t[f.charCodeAt(k + 1)] << 4 | t[f.charCodeAt(k + 2)] >> 2, g[A++] = p >> 8 & 255, g[A++] = p & 255), g;
  }
  function c(f) {
    return e[f >> 18 & 63] + e[f >> 12 & 63] + e[f >> 6 & 63] + e[f & 63];
  }
  function d(f, p, m) {
    for (var w, v = [], g = p; g < m; g += 3)
      w = (f[g] << 16 & 16711680) + (f[g + 1] << 8 & 65280) + (f[g + 2] & 255), v.push(c(w));
    return v.join("");
  }
  function h(f) {
    for (var p, m = f.length, w = m % 3, v = [], g = 16383, A = 0, b = m - w; A < b; A += g)
      v.push(d(f, A, A + g > b ? b : A + g));
    return w === 1 ? (p = f[m - 1], v.push(
      e[p >> 2] + e[p << 4 & 63] + "=="
    )) : w === 2 && (p = (f[m - 2] << 8) + f[m - 1], v.push(
      e[p >> 10] + e[p >> 4 & 63] + e[p << 2 & 63] + "="
    )), v.join("");
  }
  return Nr;
}
var Sn = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
var Yp;
function Qw() {
  return Yp || (Yp = 1, Sn.read = function(e, t, r, i, n) {
    var o, s, a = n * 8 - i - 1, u = (1 << a) - 1, l = u >> 1, c = -7, d = r ? n - 1 : 0, h = r ? -1 : 1, f = e[t + d];
    for (d += h, o = f & (1 << -c) - 1, f >>= -c, c += a; c > 0; o = o * 256 + e[t + d], d += h, c -= 8)
      ;
    for (s = o & (1 << -c) - 1, o >>= -c, c += i; c > 0; s = s * 256 + e[t + d], d += h, c -= 8)
      ;
    if (o === 0)
      o = 1 - l;
    else {
      if (o === u)
        return s ? NaN : (f ? -1 : 1) * (1 / 0);
      s = s + Math.pow(2, i), o = o - l;
    }
    return (f ? -1 : 1) * s * Math.pow(2, o - i);
  }, Sn.write = function(e, t, r, i, n, o) {
    var s, a, u, l = o * 8 - n - 1, c = (1 << l) - 1, d = c >> 1, h = n === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, f = i ? 0 : o - 1, p = i ? 1 : -1, m = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
    for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, s = c) : (s = Math.floor(Math.log(t) / Math.LN2), t * (u = Math.pow(2, -s)) < 1 && (s--, u *= 2), s + d >= 1 ? t += h / u : t += h * Math.pow(2, 1 - d), t * u >= 2 && (s++, u /= 2), s + d >= c ? (a = 0, s = c) : s + d >= 1 ? (a = (t * u - 1) * Math.pow(2, n), s = s + d) : (a = t * Math.pow(2, d - 1) * Math.pow(2, n), s = 0)); n >= 8; e[r + f] = a & 255, f += p, a /= 256, n -= 8)
      ;
    for (s = s << n | a, l += n; l > 0; e[r + f] = s & 255, f += p, s /= 256, l -= 8)
      ;
    e[r + f - p] |= m * 128;
  }), Sn;
}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var Jp;
function Yw() {
  return Jp || (Jp = 1, (function(e) {
    const t = Kw(), r = Qw(), i = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
    e.Buffer = a, e.SlowBuffer = g, e.INSPECT_MAX_BYTES = 50;
    const n = 2147483647;
    e.kMaxLength = n, a.TYPED_ARRAY_SUPPORT = o(), !a.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
      "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
    );
    function o() {
      try {
        const O = new Uint8Array(1), _ = { foo: function() {
          return 42;
        } };
        return Object.setPrototypeOf(_, Uint8Array.prototype), Object.setPrototypeOf(O, _), O.foo() === 42;
      } catch {
        return !1;
      }
    }
    Object.defineProperty(a.prototype, "parent", {
      enumerable: !0,
      get: function() {
        if (a.isBuffer(this))
          return this.buffer;
      }
    }), Object.defineProperty(a.prototype, "offset", {
      enumerable: !0,
      get: function() {
        if (a.isBuffer(this))
          return this.byteOffset;
      }
    });
    function s(O) {
      if (O > n)
        throw new RangeError('The value "' + O + '" is invalid for option "size"');
      const _ = new Uint8Array(O);
      return Object.setPrototypeOf(_, a.prototype), _;
    }
    function a(O, _, S) {
      if (typeof O == "number") {
        if (typeof _ == "string")
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        return d(O);
      }
      return u(O, _, S);
    }
    a.poolSize = 8192;
    function u(O, _, S) {
      if (typeof O == "string")
        return h(O, _);
      if (ArrayBuffer.isView(O))
        return p(O);
      if (O == null)
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof O
        );
      if (T(O, ArrayBuffer) || O && T(O.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (T(O, SharedArrayBuffer) || O && T(O.buffer, SharedArrayBuffer)))
        return m(O, _, S);
      if (typeof O == "number")
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      const F = O.valueOf && O.valueOf();
      if (F != null && F !== O)
        return a.from(F, _, S);
      const $ = w(O);
      if ($) return $;
      if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof O[Symbol.toPrimitive] == "function")
        return a.from(O[Symbol.toPrimitive]("string"), _, S);
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof O
      );
    }
    a.from = function(O, _, S) {
      return u(O, _, S);
    }, Object.setPrototypeOf(a.prototype, Uint8Array.prototype), Object.setPrototypeOf(a, Uint8Array);
    function l(O) {
      if (typeof O != "number")
        throw new TypeError('"size" argument must be of type number');
      if (O < 0)
        throw new RangeError('The value "' + O + '" is invalid for option "size"');
    }
    function c(O, _, S) {
      return l(O), O <= 0 ? s(O) : _ !== void 0 ? typeof S == "string" ? s(O).fill(_, S) : s(O).fill(_) : s(O);
    }
    a.alloc = function(O, _, S) {
      return c(O, _, S);
    };
    function d(O) {
      return l(O), s(O < 0 ? 0 : v(O) | 0);
    }
    a.allocUnsafe = function(O) {
      return d(O);
    }, a.allocUnsafeSlow = function(O) {
      return d(O);
    };
    function h(O, _) {
      if ((typeof _ != "string" || _ === "") && (_ = "utf8"), !a.isEncoding(_))
        throw new TypeError("Unknown encoding: " + _);
      const S = A(O, _) | 0;
      let F = s(S);
      const $ = F.write(O, _);
      return $ !== S && (F = F.slice(0, $)), F;
    }
    function f(O) {
      const _ = O.length < 0 ? 0 : v(O.length) | 0, S = s(_);
      for (let F = 0; F < _; F += 1)
        S[F] = O[F] & 255;
      return S;
    }
    function p(O) {
      if (T(O, Uint8Array)) {
        const _ = new Uint8Array(O);
        return m(_.buffer, _.byteOffset, _.byteLength);
      }
      return f(O);
    }
    function m(O, _, S) {
      if (_ < 0 || O.byteLength < _)
        throw new RangeError('"offset" is outside of buffer bounds');
      if (O.byteLength < _ + (S || 0))
        throw new RangeError('"length" is outside of buffer bounds');
      let F;
      return _ === void 0 && S === void 0 ? F = new Uint8Array(O) : S === void 0 ? F = new Uint8Array(O, _) : F = new Uint8Array(O, _, S), Object.setPrototypeOf(F, a.prototype), F;
    }
    function w(O) {
      if (a.isBuffer(O)) {
        const _ = v(O.length) | 0, S = s(_);
        return S.length === 0 || O.copy(S, 0, 0, _), S;
      }
      if (O.length !== void 0)
        return typeof O.length != "number" || j(O.length) ? s(0) : f(O);
      if (O.type === "Buffer" && Array.isArray(O.data))
        return f(O.data);
    }
    function v(O) {
      if (O >= n)
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + n.toString(16) + " bytes");
      return O | 0;
    }
    function g(O) {
      return +O != O && (O = 0), a.alloc(+O);
    }
    a.isBuffer = function(_) {
      return _ != null && _._isBuffer === !0 && _ !== a.prototype;
    }, a.compare = function(_, S) {
      if (T(_, Uint8Array) && (_ = a.from(_, _.offset, _.byteLength)), T(S, Uint8Array) && (S = a.from(S, S.offset, S.byteLength)), !a.isBuffer(_) || !a.isBuffer(S))
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      if (_ === S) return 0;
      let F = _.length, $ = S.length;
      for (let K = 0, ee = Math.min(F, $); K < ee; ++K)
        if (_[K] !== S[K]) {
          F = _[K], $ = S[K];
          break;
        }
      return F < $ ? -1 : $ < F ? 1 : 0;
    }, a.isEncoding = function(_) {
      switch (String(_).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;
        default:
          return !1;
      }
    }, a.concat = function(_, S) {
      if (!Array.isArray(_))
        throw new TypeError('"list" argument must be an Array of Buffers');
      if (_.length === 0)
        return a.alloc(0);
      let F;
      if (S === void 0)
        for (S = 0, F = 0; F < _.length; ++F)
          S += _[F].length;
      const $ = a.allocUnsafe(S);
      let K = 0;
      for (F = 0; F < _.length; ++F) {
        let ee = _[F];
        if (T(ee, Uint8Array))
          K + ee.length > $.length ? (a.isBuffer(ee) || (ee = a.from(ee)), ee.copy($, K)) : Uint8Array.prototype.set.call(
            $,
            ee,
            K
          );
        else if (a.isBuffer(ee))
          ee.copy($, K);
        else
          throw new TypeError('"list" argument must be an Array of Buffers');
        K += ee.length;
      }
      return $;
    };
    function A(O, _) {
      if (a.isBuffer(O))
        return O.length;
      if (ArrayBuffer.isView(O) || T(O, ArrayBuffer))
        return O.byteLength;
      if (typeof O != "string")
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof O
        );
      const S = O.length, F = arguments.length > 2 && arguments[2] === !0;
      if (!F && S === 0) return 0;
      let $ = !1;
      for (; ; )
        switch (_) {
          case "ascii":
          case "latin1":
          case "binary":
            return S;
          case "utf8":
          case "utf-8":
            return me(O).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return S * 2;
          case "hex":
            return S >>> 1;
          case "base64":
            return D(O).length;
          default:
            if ($)
              return F ? -1 : me(O).length;
            _ = ("" + _).toLowerCase(), $ = !0;
        }
    }
    a.byteLength = A;
    function b(O, _, S) {
      let F = !1;
      if ((_ === void 0 || _ < 0) && (_ = 0), _ > this.length || ((S === void 0 || S > this.length) && (S = this.length), S <= 0) || (S >>>= 0, _ >>>= 0, S <= _))
        return "";
      for (O || (O = "utf8"); ; )
        switch (O) {
          case "hex":
            return N(this, _, S);
          case "utf8":
          case "utf-8":
            return W(this, _, S);
          case "ascii":
            return V(this, _, S);
          case "latin1":
          case "binary":
            return X(this, _, S);
          case "base64":
            return J(this, _, S);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return U(this, _, S);
          default:
            if (F) throw new TypeError("Unknown encoding: " + O);
            O = (O + "").toLowerCase(), F = !0;
        }
    }
    a.prototype._isBuffer = !0;
    function k(O, _, S) {
      const F = O[_];
      O[_] = O[S], O[S] = F;
    }
    a.prototype.swap16 = function() {
      const _ = this.length;
      if (_ % 2 !== 0)
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      for (let S = 0; S < _; S += 2)
        k(this, S, S + 1);
      return this;
    }, a.prototype.swap32 = function() {
      const _ = this.length;
      if (_ % 4 !== 0)
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      for (let S = 0; S < _; S += 4)
        k(this, S, S + 3), k(this, S + 1, S + 2);
      return this;
    }, a.prototype.swap64 = function() {
      const _ = this.length;
      if (_ % 8 !== 0)
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      for (let S = 0; S < _; S += 8)
        k(this, S, S + 7), k(this, S + 1, S + 6), k(this, S + 2, S + 5), k(this, S + 3, S + 4);
      return this;
    }, a.prototype.toString = function() {
      const _ = this.length;
      return _ === 0 ? "" : arguments.length === 0 ? W(this, 0, _) : b.apply(this, arguments);
    }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(_) {
      if (!a.isBuffer(_)) throw new TypeError("Argument must be a Buffer");
      return this === _ ? !0 : a.compare(this, _) === 0;
    }, a.prototype.inspect = function() {
      let _ = "";
      const S = e.INSPECT_MAX_BYTES;
      return _ = this.toString("hex", 0, S).replace(/(.{2})/g, "$1 ").trim(), this.length > S && (_ += " ... "), "<Buffer " + _ + ">";
    }, i && (a.prototype[i] = a.prototype.inspect), a.prototype.compare = function(_, S, F, $, K) {
      if (T(_, Uint8Array) && (_ = a.from(_, _.offset, _.byteLength)), !a.isBuffer(_))
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof _
        );
      if (S === void 0 && (S = 0), F === void 0 && (F = _ ? _.length : 0), $ === void 0 && ($ = 0), K === void 0 && (K = this.length), S < 0 || F > _.length || $ < 0 || K > this.length)
        throw new RangeError("out of range index");
      if ($ >= K && S >= F)
        return 0;
      if ($ >= K)
        return -1;
      if (S >= F)
        return 1;
      if (S >>>= 0, F >>>= 0, $ >>>= 0, K >>>= 0, this === _) return 0;
      let ee = K - $, de = F - S;
      const ge = Math.min(ee, de), ke = this.slice($, K), Ee = _.slice(S, F);
      for (let xe = 0; xe < ge; ++xe)
        if (ke[xe] !== Ee[xe]) {
          ee = ke[xe], de = Ee[xe];
          break;
        }
      return ee < de ? -1 : de < ee ? 1 : 0;
    };
    function y(O, _, S, F, $) {
      if (O.length === 0) return -1;
      if (typeof S == "string" ? (F = S, S = 0) : S > 2147483647 ? S = 2147483647 : S < -2147483648 && (S = -2147483648), S = +S, j(S) && (S = $ ? 0 : O.length - 1), S < 0 && (S = O.length + S), S >= O.length) {
        if ($) return -1;
        S = O.length - 1;
      } else if (S < 0)
        if ($) S = 0;
        else return -1;
      if (typeof _ == "string" && (_ = a.from(_, F)), a.isBuffer(_))
        return _.length === 0 ? -1 : x(O, _, S, F, $);
      if (typeof _ == "number")
        return _ = _ & 255, typeof Uint8Array.prototype.indexOf == "function" ? $ ? Uint8Array.prototype.indexOf.call(O, _, S) : Uint8Array.prototype.lastIndexOf.call(O, _, S) : x(O, [_], S, F, $);
      throw new TypeError("val must be string, number or Buffer");
    }
    function x(O, _, S, F, $) {
      let K = 1, ee = O.length, de = _.length;
      if (F !== void 0 && (F = String(F).toLowerCase(), F === "ucs2" || F === "ucs-2" || F === "utf16le" || F === "utf-16le")) {
        if (O.length < 2 || _.length < 2)
          return -1;
        K = 2, ee /= 2, de /= 2, S /= 2;
      }
      function ge(Ee, xe) {
        return K === 1 ? Ee[xe] : Ee.readUInt16BE(xe * K);
      }
      let ke;
      if ($) {
        let Ee = -1;
        for (ke = S; ke < ee; ke++)
          if (ge(O, ke) === ge(_, Ee === -1 ? 0 : ke - Ee)) {
            if (Ee === -1 && (Ee = ke), ke - Ee + 1 === de) return Ee * K;
          } else
            Ee !== -1 && (ke -= ke - Ee), Ee = -1;
      } else
        for (S + de > ee && (S = ee - de), ke = S; ke >= 0; ke--) {
          let Ee = !0;
          for (let xe = 0; xe < de; xe++)
            if (ge(O, ke + xe) !== ge(_, xe)) {
              Ee = !1;
              break;
            }
          if (Ee) return ke;
        }
      return -1;
    }
    a.prototype.includes = function(_, S, F) {
      return this.indexOf(_, S, F) !== -1;
    }, a.prototype.indexOf = function(_, S, F) {
      return y(this, _, S, F, !0);
    }, a.prototype.lastIndexOf = function(_, S, F) {
      return y(this, _, S, F, !1);
    };
    function C(O, _, S, F) {
      S = Number(S) || 0;
      const $ = O.length - S;
      F ? (F = Number(F), F > $ && (F = $)) : F = $;
      const K = _.length;
      F > K / 2 && (F = K / 2);
      let ee;
      for (ee = 0; ee < F; ++ee) {
        const de = parseInt(_.substr(ee * 2, 2), 16);
        if (j(de)) return ee;
        O[S + ee] = de;
      }
      return ee;
    }
    function I(O, _, S, F) {
      return E(me(_, O.length - S), O, S, F);
    }
    function M(O, _, S, F) {
      return E(L(_), O, S, F);
    }
    function Q(O, _, S, F) {
      return E(D(_), O, S, F);
    }
    function H(O, _, S, F) {
      return E(B(_, O.length - S), O, S, F);
    }
    a.prototype.write = function(_, S, F, $) {
      if (S === void 0)
        $ = "utf8", F = this.length, S = 0;
      else if (F === void 0 && typeof S == "string")
        $ = S, F = this.length, S = 0;
      else if (isFinite(S))
        S = S >>> 0, isFinite(F) ? (F = F >>> 0, $ === void 0 && ($ = "utf8")) : ($ = F, F = void 0);
      else
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      const K = this.length - S;
      if ((F === void 0 || F > K) && (F = K), _.length > 0 && (F < 0 || S < 0) || S > this.length)
        throw new RangeError("Attempt to write outside buffer bounds");
      $ || ($ = "utf8");
      let ee = !1;
      for (; ; )
        switch ($) {
          case "hex":
            return C(this, _, S, F);
          case "utf8":
          case "utf-8":
            return I(this, _, S, F);
          case "ascii":
          case "latin1":
          case "binary":
            return M(this, _, S, F);
          case "base64":
            return Q(this, _, S, F);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return H(this, _, S, F);
          default:
            if (ee) throw new TypeError("Unknown encoding: " + $);
            $ = ("" + $).toLowerCase(), ee = !0;
        }
    }, a.prototype.toJSON = function() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function J(O, _, S) {
      return _ === 0 && S === O.length ? t.fromByteArray(O) : t.fromByteArray(O.slice(_, S));
    }
    function W(O, _, S) {
      S = Math.min(O.length, S);
      const F = [];
      let $ = _;
      for (; $ < S; ) {
        const K = O[$];
        let ee = null, de = K > 239 ? 4 : K > 223 ? 3 : K > 191 ? 2 : 1;
        if ($ + de <= S) {
          let ge, ke, Ee, xe;
          switch (de) {
            case 1:
              K < 128 && (ee = K);
              break;
            case 2:
              ge = O[$ + 1], (ge & 192) === 128 && (xe = (K & 31) << 6 | ge & 63, xe > 127 && (ee = xe));
              break;
            case 3:
              ge = O[$ + 1], ke = O[$ + 2], (ge & 192) === 128 && (ke & 192) === 128 && (xe = (K & 15) << 12 | (ge & 63) << 6 | ke & 63, xe > 2047 && (xe < 55296 || xe > 57343) && (ee = xe));
              break;
            case 4:
              ge = O[$ + 1], ke = O[$ + 2], Ee = O[$ + 3], (ge & 192) === 128 && (ke & 192) === 128 && (Ee & 192) === 128 && (xe = (K & 15) << 18 | (ge & 63) << 12 | (ke & 63) << 6 | Ee & 63, xe > 65535 && xe < 1114112 && (ee = xe));
          }
        }
        ee === null ? (ee = 65533, de = 1) : ee > 65535 && (ee -= 65536, F.push(ee >>> 10 & 1023 | 55296), ee = 56320 | ee & 1023), F.push(ee), $ += de;
      }
      return R(F);
    }
    const P = 4096;
    function R(O) {
      const _ = O.length;
      if (_ <= P)
        return String.fromCharCode.apply(String, O);
      let S = "", F = 0;
      for (; F < _; )
        S += String.fromCharCode.apply(
          String,
          O.slice(F, F += P)
        );
      return S;
    }
    function V(O, _, S) {
      let F = "";
      S = Math.min(O.length, S);
      for (let $ = _; $ < S; ++$)
        F += String.fromCharCode(O[$] & 127);
      return F;
    }
    function X(O, _, S) {
      let F = "";
      S = Math.min(O.length, S);
      for (let $ = _; $ < S; ++$)
        F += String.fromCharCode(O[$]);
      return F;
    }
    function N(O, _, S) {
      const F = O.length;
      (!_ || _ < 0) && (_ = 0), (!S || S < 0 || S > F) && (S = F);
      let $ = "";
      for (let K = _; K < S; ++K)
        $ += Y[O[K]];
      return $;
    }
    function U(O, _, S) {
      const F = O.slice(_, S);
      let $ = "";
      for (let K = 0; K < F.length - 1; K += 2)
        $ += String.fromCharCode(F[K] + F[K + 1] * 256);
      return $;
    }
    a.prototype.slice = function(_, S) {
      const F = this.length;
      _ = ~~_, S = S === void 0 ? F : ~~S, _ < 0 ? (_ += F, _ < 0 && (_ = 0)) : _ > F && (_ = F), S < 0 ? (S += F, S < 0 && (S = 0)) : S > F && (S = F), S < _ && (S = _);
      const $ = this.subarray(_, S);
      return Object.setPrototypeOf($, a.prototype), $;
    };
    function G(O, _, S) {
      if (O % 1 !== 0 || O < 0) throw new RangeError("offset is not uint");
      if (O + _ > S) throw new RangeError("Trying to access beyond buffer length");
    }
    a.prototype.readUintLE = a.prototype.readUIntLE = function(_, S, F) {
      _ = _ >>> 0, S = S >>> 0, F || G(_, S, this.length);
      let $ = this[_], K = 1, ee = 0;
      for (; ++ee < S && (K *= 256); )
        $ += this[_ + ee] * K;
      return $;
    }, a.prototype.readUintBE = a.prototype.readUIntBE = function(_, S, F) {
      _ = _ >>> 0, S = S >>> 0, F || G(_, S, this.length);
      let $ = this[_ + --S], K = 1;
      for (; S > 0 && (K *= 256); )
        $ += this[_ + --S] * K;
      return $;
    }, a.prototype.readUint8 = a.prototype.readUInt8 = function(_, S) {
      return _ = _ >>> 0, S || G(_, 1, this.length), this[_];
    }, a.prototype.readUint16LE = a.prototype.readUInt16LE = function(_, S) {
      return _ = _ >>> 0, S || G(_, 2, this.length), this[_] | this[_ + 1] << 8;
    }, a.prototype.readUint16BE = a.prototype.readUInt16BE = function(_, S) {
      return _ = _ >>> 0, S || G(_, 2, this.length), this[_] << 8 | this[_ + 1];
    }, a.prototype.readUint32LE = a.prototype.readUInt32LE = function(_, S) {
      return _ = _ >>> 0, S || G(_, 4, this.length), (this[_] | this[_ + 1] << 8 | this[_ + 2] << 16) + this[_ + 3] * 16777216;
    }, a.prototype.readUint32BE = a.prototype.readUInt32BE = function(_, S) {
      return _ = _ >>> 0, S || G(_, 4, this.length), this[_] * 16777216 + (this[_ + 1] << 16 | this[_ + 2] << 8 | this[_ + 3]);
    }, a.prototype.readBigUInt64LE = ae(function(_) {
      _ = _ >>> 0, te(_, "offset");
      const S = this[_], F = this[_ + 7];
      (S === void 0 || F === void 0) && Z(_, this.length - 8);
      const $ = S + this[++_] * 2 ** 8 + this[++_] * 2 ** 16 + this[++_] * 2 ** 24, K = this[++_] + this[++_] * 2 ** 8 + this[++_] * 2 ** 16 + F * 2 ** 24;
      return BigInt($) + (BigInt(K) << BigInt(32));
    }), a.prototype.readBigUInt64BE = ae(function(_) {
      _ = _ >>> 0, te(_, "offset");
      const S = this[_], F = this[_ + 7];
      (S === void 0 || F === void 0) && Z(_, this.length - 8);
      const $ = S * 2 ** 24 + this[++_] * 2 ** 16 + this[++_] * 2 ** 8 + this[++_], K = this[++_] * 2 ** 24 + this[++_] * 2 ** 16 + this[++_] * 2 ** 8 + F;
      return (BigInt($) << BigInt(32)) + BigInt(K);
    }), a.prototype.readIntLE = function(_, S, F) {
      _ = _ >>> 0, S = S >>> 0, F || G(_, S, this.length);
      let $ = this[_], K = 1, ee = 0;
      for (; ++ee < S && (K *= 256); )
        $ += this[_ + ee] * K;
      return K *= 128, $ >= K && ($ -= Math.pow(2, 8 * S)), $;
    }, a.prototype.readIntBE = function(_, S, F) {
      _ = _ >>> 0, S = S >>> 0, F || G(_, S, this.length);
      let $ = S, K = 1, ee = this[_ + --$];
      for (; $ > 0 && (K *= 256); )
        ee += this[_ + --$] * K;
      return K *= 128, ee >= K && (ee -= Math.pow(2, 8 * S)), ee;
    }, a.prototype.readInt8 = function(_, S) {
      return _ = _ >>> 0, S || G(_, 1, this.length), this[_] & 128 ? (255 - this[_] + 1) * -1 : this[_];
    }, a.prototype.readInt16LE = function(_, S) {
      _ = _ >>> 0, S || G(_, 2, this.length);
      const F = this[_] | this[_ + 1] << 8;
      return F & 32768 ? F | 4294901760 : F;
    }, a.prototype.readInt16BE = function(_, S) {
      _ = _ >>> 0, S || G(_, 2, this.length);
      const F = this[_ + 1] | this[_] << 8;
      return F & 32768 ? F | 4294901760 : F;
    }, a.prototype.readInt32LE = function(_, S) {
      return _ = _ >>> 0, S || G(_, 4, this.length), this[_] | this[_ + 1] << 8 | this[_ + 2] << 16 | this[_ + 3] << 24;
    }, a.prototype.readInt32BE = function(_, S) {
      return _ = _ >>> 0, S || G(_, 4, this.length), this[_] << 24 | this[_ + 1] << 16 | this[_ + 2] << 8 | this[_ + 3];
    }, a.prototype.readBigInt64LE = ae(function(_) {
      _ = _ >>> 0, te(_, "offset");
      const S = this[_], F = this[_ + 7];
      (S === void 0 || F === void 0) && Z(_, this.length - 8);
      const $ = this[_ + 4] + this[_ + 5] * 2 ** 8 + this[_ + 6] * 2 ** 16 + (F << 24);
      return (BigInt($) << BigInt(32)) + BigInt(S + this[++_] * 2 ** 8 + this[++_] * 2 ** 16 + this[++_] * 2 ** 24);
    }), a.prototype.readBigInt64BE = ae(function(_) {
      _ = _ >>> 0, te(_, "offset");
      const S = this[_], F = this[_ + 7];
      (S === void 0 || F === void 0) && Z(_, this.length - 8);
      const $ = (S << 24) + // Overflow
      this[++_] * 2 ** 16 + this[++_] * 2 ** 8 + this[++_];
      return (BigInt($) << BigInt(32)) + BigInt(this[++_] * 2 ** 24 + this[++_] * 2 ** 16 + this[++_] * 2 ** 8 + F);
    }), a.prototype.readFloatLE = function(_, S) {
      return _ = _ >>> 0, S || G(_, 4, this.length), r.read(this, _, !0, 23, 4);
    }, a.prototype.readFloatBE = function(_, S) {
      return _ = _ >>> 0, S || G(_, 4, this.length), r.read(this, _, !1, 23, 4);
    }, a.prototype.readDoubleLE = function(_, S) {
      return _ = _ >>> 0, S || G(_, 8, this.length), r.read(this, _, !0, 52, 8);
    }, a.prototype.readDoubleBE = function(_, S) {
      return _ = _ >>> 0, S || G(_, 8, this.length), r.read(this, _, !1, 52, 8);
    };
    function re(O, _, S, F, $, K) {
      if (!a.isBuffer(O)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (_ > $ || _ < K) throw new RangeError('"value" argument is out of bounds');
      if (S + F > O.length) throw new RangeError("Index out of range");
    }
    a.prototype.writeUintLE = a.prototype.writeUIntLE = function(_, S, F, $) {
      if (_ = +_, S = S >>> 0, F = F >>> 0, !$) {
        const de = Math.pow(2, 8 * F) - 1;
        re(this, _, S, F, de, 0);
      }
      let K = 1, ee = 0;
      for (this[S] = _ & 255; ++ee < F && (K *= 256); )
        this[S + ee] = _ / K & 255;
      return S + F;
    }, a.prototype.writeUintBE = a.prototype.writeUIntBE = function(_, S, F, $) {
      if (_ = +_, S = S >>> 0, F = F >>> 0, !$) {
        const de = Math.pow(2, 8 * F) - 1;
        re(this, _, S, F, de, 0);
      }
      let K = F - 1, ee = 1;
      for (this[S + K] = _ & 255; --K >= 0 && (ee *= 256); )
        this[S + K] = _ / ee & 255;
      return S + F;
    }, a.prototype.writeUint8 = a.prototype.writeUInt8 = function(_, S, F) {
      return _ = +_, S = S >>> 0, F || re(this, _, S, 1, 255, 0), this[S] = _ & 255, S + 1;
    }, a.prototype.writeUint16LE = a.prototype.writeUInt16LE = function(_, S, F) {
      return _ = +_, S = S >>> 0, F || re(this, _, S, 2, 65535, 0), this[S] = _ & 255, this[S + 1] = _ >>> 8, S + 2;
    }, a.prototype.writeUint16BE = a.prototype.writeUInt16BE = function(_, S, F) {
      return _ = +_, S = S >>> 0, F || re(this, _, S, 2, 65535, 0), this[S] = _ >>> 8, this[S + 1] = _ & 255, S + 2;
    }, a.prototype.writeUint32LE = a.prototype.writeUInt32LE = function(_, S, F) {
      return _ = +_, S = S >>> 0, F || re(this, _, S, 4, 4294967295, 0), this[S + 3] = _ >>> 24, this[S + 2] = _ >>> 16, this[S + 1] = _ >>> 8, this[S] = _ & 255, S + 4;
    }, a.prototype.writeUint32BE = a.prototype.writeUInt32BE = function(_, S, F) {
      return _ = +_, S = S >>> 0, F || re(this, _, S, 4, 4294967295, 0), this[S] = _ >>> 24, this[S + 1] = _ >>> 16, this[S + 2] = _ >>> 8, this[S + 3] = _ & 255, S + 4;
    };
    function oe(O, _, S, F, $) {
      De(_, F, $, O, S, 7);
      let K = Number(_ & BigInt(4294967295));
      O[S++] = K, K = K >> 8, O[S++] = K, K = K >> 8, O[S++] = K, K = K >> 8, O[S++] = K;
      let ee = Number(_ >> BigInt(32) & BigInt(4294967295));
      return O[S++] = ee, ee = ee >> 8, O[S++] = ee, ee = ee >> 8, O[S++] = ee, ee = ee >> 8, O[S++] = ee, S;
    }
    function ie(O, _, S, F, $) {
      De(_, F, $, O, S, 7);
      let K = Number(_ & BigInt(4294967295));
      O[S + 7] = K, K = K >> 8, O[S + 6] = K, K = K >> 8, O[S + 5] = K, K = K >> 8, O[S + 4] = K;
      let ee = Number(_ >> BigInt(32) & BigInt(4294967295));
      return O[S + 3] = ee, ee = ee >> 8, O[S + 2] = ee, ee = ee >> 8, O[S + 1] = ee, ee = ee >> 8, O[S] = ee, S + 8;
    }
    a.prototype.writeBigUInt64LE = ae(function(_, S = 0) {
      return oe(this, _, S, BigInt(0), BigInt("0xffffffffffffffff"));
    }), a.prototype.writeBigUInt64BE = ae(function(_, S = 0) {
      return ie(this, _, S, BigInt(0), BigInt("0xffffffffffffffff"));
    }), a.prototype.writeIntLE = function(_, S, F, $) {
      if (_ = +_, S = S >>> 0, !$) {
        const ge = Math.pow(2, 8 * F - 1);
        re(this, _, S, F, ge - 1, -ge);
      }
      let K = 0, ee = 1, de = 0;
      for (this[S] = _ & 255; ++K < F && (ee *= 256); )
        _ < 0 && de === 0 && this[S + K - 1] !== 0 && (de = 1), this[S + K] = (_ / ee >> 0) - de & 255;
      return S + F;
    }, a.prototype.writeIntBE = function(_, S, F, $) {
      if (_ = +_, S = S >>> 0, !$) {
        const ge = Math.pow(2, 8 * F - 1);
        re(this, _, S, F, ge - 1, -ge);
      }
      let K = F - 1, ee = 1, de = 0;
      for (this[S + K] = _ & 255; --K >= 0 && (ee *= 256); )
        _ < 0 && de === 0 && this[S + K + 1] !== 0 && (de = 1), this[S + K] = (_ / ee >> 0) - de & 255;
      return S + F;
    }, a.prototype.writeInt8 = function(_, S, F) {
      return _ = +_, S = S >>> 0, F || re(this, _, S, 1, 127, -128), _ < 0 && (_ = 255 + _ + 1), this[S] = _ & 255, S + 1;
    }, a.prototype.writeInt16LE = function(_, S, F) {
      return _ = +_, S = S >>> 0, F || re(this, _, S, 2, 32767, -32768), this[S] = _ & 255, this[S + 1] = _ >>> 8, S + 2;
    }, a.prototype.writeInt16BE = function(_, S, F) {
      return _ = +_, S = S >>> 0, F || re(this, _, S, 2, 32767, -32768), this[S] = _ >>> 8, this[S + 1] = _ & 255, S + 2;
    }, a.prototype.writeInt32LE = function(_, S, F) {
      return _ = +_, S = S >>> 0, F || re(this, _, S, 4, 2147483647, -2147483648), this[S] = _ & 255, this[S + 1] = _ >>> 8, this[S + 2] = _ >>> 16, this[S + 3] = _ >>> 24, S + 4;
    }, a.prototype.writeInt32BE = function(_, S, F) {
      return _ = +_, S = S >>> 0, F || re(this, _, S, 4, 2147483647, -2147483648), _ < 0 && (_ = 4294967295 + _ + 1), this[S] = _ >>> 24, this[S + 1] = _ >>> 16, this[S + 2] = _ >>> 8, this[S + 3] = _ & 255, S + 4;
    }, a.prototype.writeBigInt64LE = ae(function(_, S = 0) {
      return oe(this, _, S, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    }), a.prototype.writeBigInt64BE = ae(function(_, S = 0) {
      return ie(this, _, S, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function le(O, _, S, F, $, K) {
      if (S + F > O.length) throw new RangeError("Index out of range");
      if (S < 0) throw new RangeError("Index out of range");
    }
    function he(O, _, S, F, $) {
      return _ = +_, S = S >>> 0, $ || le(O, _, S, 4), r.write(O, _, S, F, 23, 4), S + 4;
    }
    a.prototype.writeFloatLE = function(_, S, F) {
      return he(this, _, S, !0, F);
    }, a.prototype.writeFloatBE = function(_, S, F) {
      return he(this, _, S, !1, F);
    };
    function ye(O, _, S, F, $) {
      return _ = +_, S = S >>> 0, $ || le(O, _, S, 8), r.write(O, _, S, F, 52, 8), S + 8;
    }
    a.prototype.writeDoubleLE = function(_, S, F) {
      return ye(this, _, S, !0, F);
    }, a.prototype.writeDoubleBE = function(_, S, F) {
      return ye(this, _, S, !1, F);
    }, a.prototype.copy = function(_, S, F, $) {
      if (!a.isBuffer(_)) throw new TypeError("argument should be a Buffer");
      if (F || (F = 0), !$ && $ !== 0 && ($ = this.length), S >= _.length && (S = _.length), S || (S = 0), $ > 0 && $ < F && ($ = F), $ === F || _.length === 0 || this.length === 0) return 0;
      if (S < 0)
        throw new RangeError("targetStart out of bounds");
      if (F < 0 || F >= this.length) throw new RangeError("Index out of range");
      if ($ < 0) throw new RangeError("sourceEnd out of bounds");
      $ > this.length && ($ = this.length), _.length - S < $ - F && ($ = _.length - S + F);
      const K = $ - F;
      return this === _ && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(S, F, $) : Uint8Array.prototype.set.call(
        _,
        this.subarray(F, $),
        S
      ), K;
    }, a.prototype.fill = function(_, S, F, $) {
      if (typeof _ == "string") {
        if (typeof S == "string" ? ($ = S, S = 0, F = this.length) : typeof F == "string" && ($ = F, F = this.length), $ !== void 0 && typeof $ != "string")
          throw new TypeError("encoding must be a string");
        if (typeof $ == "string" && !a.isEncoding($))
          throw new TypeError("Unknown encoding: " + $);
        if (_.length === 1) {
          const ee = _.charCodeAt(0);
          ($ === "utf8" && ee < 128 || $ === "latin1") && (_ = ee);
        }
      } else typeof _ == "number" ? _ = _ & 255 : typeof _ == "boolean" && (_ = Number(_));
      if (S < 0 || this.length < S || this.length < F)
        throw new RangeError("Out of range index");
      if (F <= S)
        return this;
      S = S >>> 0, F = F === void 0 ? this.length : F >>> 0, _ || (_ = 0);
      let K;
      if (typeof _ == "number")
        for (K = S; K < F; ++K)
          this[K] = _;
      else {
        const ee = a.isBuffer(_) ? _ : a.from(_, $), de = ee.length;
        if (de === 0)
          throw new TypeError('The value "' + _ + '" is invalid for argument "value"');
        for (K = 0; K < F - S; ++K)
          this[K + S] = ee[K % de];
      }
      return this;
    };
    const be = {};
    function we(O, _, S) {
      be[O] = class extends S {
        constructor() {
          super(), Object.defineProperty(this, "message", {
            value: _.apply(this, arguments),
            writable: !0,
            configurable: !0
          }), this.name = `${this.name} [${O}]`, this.stack, delete this.name;
        }
        get code() {
          return O;
        }
        set code($) {
          Object.defineProperty(this, "code", {
            configurable: !0,
            enumerable: !0,
            value: $,
            writable: !0
          });
        }
        toString() {
          return `${this.name} [${O}]: ${this.message}`;
        }
      };
    }
    we(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(O) {
        return O ? `${O} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
      },
      RangeError
    ), we(
      "ERR_INVALID_ARG_TYPE",
      function(O, _) {
        return `The "${O}" argument must be of type number. Received type ${typeof _}`;
      },
      TypeError
    ), we(
      "ERR_OUT_OF_RANGE",
      function(O, _, S) {
        let F = `The value of "${O}" is out of range.`, $ = S;
        return Number.isInteger(S) && Math.abs(S) > 2 ** 32 ? $ = ve(String(S)) : typeof S == "bigint" && ($ = String(S), (S > BigInt(2) ** BigInt(32) || S < -(BigInt(2) ** BigInt(32))) && ($ = ve($)), $ += "n"), F += ` It must be ${_}. Received ${$}`, F;
      },
      RangeError
    );
    function ve(O) {
      let _ = "", S = O.length;
      const F = O[0] === "-" ? 1 : 0;
      for (; S >= F + 4; S -= 3)
        _ = `_${O.slice(S - 3, S)}${_}`;
      return `${O.slice(0, S)}${_}`;
    }
    function Re(O, _, S) {
      te(_, "offset"), (O[_] === void 0 || O[_ + S] === void 0) && Z(_, O.length - (S + 1));
    }
    function De(O, _, S, F, $, K) {
      if (O > S || O < _) {
        const ee = typeof _ == "bigint" ? "n" : "";
        let de;
        throw _ === 0 || _ === BigInt(0) ? de = `>= 0${ee} and < 2${ee} ** ${(K + 1) * 8}${ee}` : de = `>= -(2${ee} ** ${(K + 1) * 8 - 1}${ee}) and < 2 ** ${(K + 1) * 8 - 1}${ee}`, new be.ERR_OUT_OF_RANGE("value", de, O);
      }
      Re(F, $, K);
    }
    function te(O, _) {
      if (typeof O != "number")
        throw new be.ERR_INVALID_ARG_TYPE(_, "number", O);
    }
    function Z(O, _, S) {
      throw Math.floor(O) !== O ? (te(O, S), new be.ERR_OUT_OF_RANGE("offset", "an integer", O)) : _ < 0 ? new be.ERR_BUFFER_OUT_OF_BOUNDS() : new be.ERR_OUT_OF_RANGE(
        "offset",
        `>= 0 and <= ${_}`,
        O
      );
    }
    const ue = /[^+/0-9A-Za-z-_]/g;
    function pe(O) {
      if (O = O.split("=")[0], O = O.trim().replace(ue, ""), O.length < 2) return "";
      for (; O.length % 4 !== 0; )
        O = O + "=";
      return O;
    }
    function me(O, _) {
      _ = _ || 1 / 0;
      let S;
      const F = O.length;
      let $ = null;
      const K = [];
      for (let ee = 0; ee < F; ++ee) {
        if (S = O.charCodeAt(ee), S > 55295 && S < 57344) {
          if (!$) {
            if (S > 56319) {
              (_ -= 3) > -1 && K.push(239, 191, 189);
              continue;
            } else if (ee + 1 === F) {
              (_ -= 3) > -1 && K.push(239, 191, 189);
              continue;
            }
            $ = S;
            continue;
          }
          if (S < 56320) {
            (_ -= 3) > -1 && K.push(239, 191, 189), $ = S;
            continue;
          }
          S = ($ - 55296 << 10 | S - 56320) + 65536;
        } else $ && (_ -= 3) > -1 && K.push(239, 191, 189);
        if ($ = null, S < 128) {
          if ((_ -= 1) < 0) break;
          K.push(S);
        } else if (S < 2048) {
          if ((_ -= 2) < 0) break;
          K.push(
            S >> 6 | 192,
            S & 63 | 128
          );
        } else if (S < 65536) {
          if ((_ -= 3) < 0) break;
          K.push(
            S >> 12 | 224,
            S >> 6 & 63 | 128,
            S & 63 | 128
          );
        } else if (S < 1114112) {
          if ((_ -= 4) < 0) break;
          K.push(
            S >> 18 | 240,
            S >> 12 & 63 | 128,
            S >> 6 & 63 | 128,
            S & 63 | 128
          );
        } else
          throw new Error("Invalid code point");
      }
      return K;
    }
    function L(O) {
      const _ = [];
      for (let S = 0; S < O.length; ++S)
        _.push(O.charCodeAt(S) & 255);
      return _;
    }
    function B(O, _) {
      let S, F, $;
      const K = [];
      for (let ee = 0; ee < O.length && !((_ -= 2) < 0); ++ee)
        S = O.charCodeAt(ee), F = S >> 8, $ = S % 256, K.push($), K.push(F);
      return K;
    }
    function D(O) {
      return t.toByteArray(pe(O));
    }
    function E(O, _, S, F) {
      let $;
      for ($ = 0; $ < F && !($ + S >= _.length || $ >= O.length); ++$)
        _[$ + S] = O[$];
      return $;
    }
    function T(O, _) {
      return O instanceof _ || O != null && O.constructor != null && O.constructor.name != null && O.constructor.name === _.name;
    }
    function j(O) {
      return O !== O;
    }
    const Y = (function() {
      const O = "0123456789abcdef", _ = new Array(256);
      for (let S = 0; S < 16; ++S) {
        const F = S * 16;
        for (let $ = 0; $ < 16; ++$)
          _[F + $] = O[S] + O[$];
      }
      return _;
    })();
    function ae(O) {
      return typeof BigInt > "u" ? se : O;
    }
    function se() {
      throw new Error("BigInt not supported");
    }
  })(Ts)), Ts;
}
function En(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Cs = { exports: {} }, Zp;
function Pg() {
  return Zp || (Zp = 1, (function(e, t) {
    (function(r) {
      e.exports = r();
    })(function() {
      return (/* @__PURE__ */ (function() {
        function r(i, n, o) {
          function s(l, c) {
            if (!n[l]) {
              if (!i[l]) {
                var d = typeof En == "function" && En;
                if (!c && d) return d(l, !0);
                if (a) return a(l, !0);
                var h = new Error("Cannot find module '" + l + "'");
                throw h.code = "MODULE_NOT_FOUND", h;
              }
              var f = n[l] = { exports: {} };
              i[l][0].call(f.exports, function(p) {
                var m = i[l][1][p];
                return s(m || p);
              }, f, f.exports, r, i, n, o);
            }
            return n[l].exports;
          }
          for (var a = typeof En == "function" && En, u = 0; u < o.length; u++) s(o[u]);
          return s;
        }
        return r;
      })())({ 1: [function(r, i, n) {
        var o = this && this.__awaiter || function(d, h, f, p) {
          function m(w) {
            return w instanceof f ? w : new f(function(v) {
              v(w);
            });
          }
          return new (f || (f = Promise))(function(w, v) {
            function g(k) {
              try {
                b(p.next(k));
              } catch (y) {
                v(y);
              }
            }
            function A(k) {
              try {
                b(p.throw(k));
              } catch (y) {
                v(y);
              }
            }
            function b(k) {
              k.done ? w(k.value) : m(k.value).then(g, A);
            }
            b((p = p.apply(d, h || [])).next());
          });
        }, s = this && this.__generator || function(d, h) {
          var f = { label: 0, sent: function() {
            if (w[0] & 1) throw w[1];
            return w[1];
          }, trys: [], ops: [] }, p, m, w, v;
          return v = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
            return this;
          }), v;
          function g(b) {
            return function(k) {
              return A([b, k]);
            };
          }
          function A(b) {
            if (p) throw new TypeError("Generator is already executing.");
            for (; v && (v = 0, b[0] && (f = 0)), f; ) try {
              if (p = 1, m && (w = b[0] & 2 ? m.return : b[0] ? m.throw || ((w = m.return) && w.call(m), 0) : m.next) && !(w = w.call(m, b[1])).done) return w;
              switch (m = 0, w && (b = [b[0] & 2, w.value]), b[0]) {
                case 0:
                case 1:
                  w = b;
                  break;
                case 4:
                  return f.label++, { value: b[1], done: !1 };
                case 5:
                  f.label++, m = b[1], b = [0];
                  continue;
                case 7:
                  b = f.ops.pop(), f.trys.pop();
                  continue;
                default:
                  if (w = f.trys, !(w = w.length > 0 && w[w.length - 1]) && (b[0] === 6 || b[0] === 2)) {
                    f = 0;
                    continue;
                  }
                  if (b[0] === 3 && (!w || b[1] > w[0] && b[1] < w[3])) {
                    f.label = b[1];
                    break;
                  }
                  if (b[0] === 6 && f.label < w[1]) {
                    f.label = w[1], w = b;
                    break;
                  }
                  if (w && f.label < w[2]) {
                    f.label = w[2], f.ops.push(b);
                    break;
                  }
                  w[2] && f.ops.pop(), f.trys.pop();
                  continue;
              }
              b = h.call(d, f);
            } catch (k) {
              b = [6, k], m = 0;
            } finally {
              p = w = 0;
            }
            if (b[0] & 5) throw b[1];
            return { value: b[0] ? b[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(n, "__esModule", { value: !0 }), n.PayloadAssembler = void 0;
        var a = r("../subscribableStream"), u = r("../payloads"), l = r("../contentStream"), c = (
          /** @class */
          (function() {
            function d(h, f) {
              if (this.streamManager = h, this._byteOrderMark = 65279, this._utf = "utf8", f.header ? (this.id = f.header.id, this.payloadType = f.header.payloadType, this.contentLength = f.header.payloadLength, this.end = f.header.end) : this.id = f.id, !this.id)
                throw Error("An ID must be supplied when creating an assembler.");
              this._onCompleted = f.onCompleted;
            }
            return d.prototype.getPayloadStream = function() {
              return this.stream || (this.stream = this.createPayloadStream()), this.stream;
            }, d.prototype.onReceive = function(h, f, p) {
              this.end = h.end, h.payloadType === u.PayloadTypes.response || h.payloadType === u.PayloadTypes.request ? this.process(f).then().catch() : h.end && f.end();
            }, d.prototype.close = function() {
              this.streamManager.closeStream(this.id);
            }, d.prototype.createPayloadStream = function() {
              return new a.SubscribableStream();
            }, d.prototype.payloadFromJson = function(h) {
              return JSON.parse(h.charCodeAt(0) === this._byteOrderMark ? h.slice(1) : h);
            }, d.prototype.stripBOM = function(h) {
              return h.charCodeAt(0) === this._byteOrderMark ? h.slice(1) : h;
            }, d.prototype.process = function(h) {
              return o(this, void 0, void 0, function() {
                var f, p;
                return s(this, function(m) {
                  switch (m.label) {
                    case 0:
                      return f = h.read(h.length), f ? (p = f.toString(this._utf), this.payloadType !== u.PayloadTypes.request ? [3, 2] : [4, this.processRequest(p)]) : [
                        2
                        /*return*/
                      ];
                    case 1:
                      return m.sent(), [3, 4];
                    case 2:
                      return this.payloadType !== u.PayloadTypes.response ? [3, 4] : [4, this.processResponse(p)];
                    case 3:
                      m.sent(), m.label = 4;
                    case 4:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, d.prototype.processResponse = function(h) {
              return o(this, void 0, void 0, function() {
                var f, p;
                return s(this, function(m) {
                  switch (m.label) {
                    case 0:
                      return f = this.payloadFromJson(this.stripBOM(h)), p = { streams: [], statusCode: f.statusCode }, [4, this.processStreams(f, p)];
                    case 1:
                      return m.sent(), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, d.prototype.processRequest = function(h) {
              return o(this, void 0, void 0, function() {
                var f, p;
                return s(this, function(m) {
                  switch (m.label) {
                    case 0:
                      return f = this.payloadFromJson(h), p = { streams: [], path: f.path, verb: f.verb }, [4, this.processStreams(f, p)];
                    case 1:
                      return m.sent(), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, d.prototype.processStreams = function(h, f) {
              var p;
              return o(this, void 0, void 0, function() {
                var m = this;
                return s(this, function(w) {
                  switch (w.label) {
                    case 0:
                      return (p = h.streams) === null || p === void 0 || p.forEach(function(v) {
                        var g, A = (g = v.type) !== null && g !== void 0 ? g : v.contentType, b = m.streamManager.getPayloadAssembler(v.id);
                        b.payloadType = A, b.contentLength = v.length, f.streams.push(new l.ContentStream(v.id, b));
                      }), [4, this._onCompleted(this.id, f)];
                    case 1:
                      return w.sent(), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, d;
          })()
        );
        n.PayloadAssembler = c;
      }, { "../contentStream": 2, "../payloads": 16, "../subscribableStream": 27 }], 2: [function(r, i, n) {
        var o = this && this.__awaiter || function(u, l, c, d) {
          function h(f) {
            return f instanceof c ? f : new c(function(p) {
              p(f);
            });
          }
          return new (c || (c = Promise))(function(f, p) {
            function m(g) {
              try {
                v(d.next(g));
              } catch (A) {
                p(A);
              }
            }
            function w(g) {
              try {
                v(d.throw(g));
              } catch (A) {
                p(A);
              }
            }
            function v(g) {
              g.done ? f(g.value) : h(g.value).then(m, w);
            }
            v((d = d.apply(u, l || [])).next());
          });
        }, s = this && this.__generator || function(u, l) {
          var c = { label: 0, sent: function() {
            if (f[0] & 1) throw f[1];
            return f[1];
          }, trys: [], ops: [] }, d, h, f, p;
          return p = { next: m(0), throw: m(1), return: m(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
            return this;
          }), p;
          function m(v) {
            return function(g) {
              return w([v, g]);
            };
          }
          function w(v) {
            if (d) throw new TypeError("Generator is already executing.");
            for (; p && (p = 0, v[0] && (c = 0)), c; ) try {
              if (d = 1, h && (f = v[0] & 2 ? h.return : v[0] ? h.throw || ((f = h.return) && f.call(h), 0) : h.next) && !(f = f.call(h, v[1])).done) return f;
              switch (h = 0, f && (v = [v[0] & 2, f.value]), v[0]) {
                case 0:
                case 1:
                  f = v;
                  break;
                case 4:
                  return c.label++, { value: v[1], done: !1 };
                case 5:
                  c.label++, h = v[1], v = [0];
                  continue;
                case 7:
                  v = c.ops.pop(), c.trys.pop();
                  continue;
                default:
                  if (f = c.trys, !(f = f.length > 0 && f[f.length - 1]) && (v[0] === 6 || v[0] === 2)) {
                    c = 0;
                    continue;
                  }
                  if (v[0] === 3 && (!f || v[1] > f[0] && v[1] < f[3])) {
                    c.label = v[1];
                    break;
                  }
                  if (v[0] === 6 && c.label < f[1]) {
                    c.label = f[1], f = v;
                    break;
                  }
                  if (f && c.label < f[2]) {
                    c.label = f[2], c.ops.push(v);
                    break;
                  }
                  f[2] && c.ops.pop(), c.trys.pop();
                  continue;
              }
              v = l.call(u, c);
            } catch (g) {
              v = [6, g], h = 0;
            } finally {
              d = f = 0;
            }
            if (v[0] & 5) throw v[1];
            return { value: v[0] ? v[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(n, "__esModule", { value: !0 }), n.ContentStream = void 0;
        var a = (
          /** @class */
          (function() {
            function u(l, c) {
              if (!c)
                throw Error("Null Argument Exception");
              this.id = l, this.assembler = c;
            }
            return Object.defineProperty(u.prototype, "contentType", {
              /**
               * Gets the name of the type of the object contained within this [ContentStream](xref:botframework-streaming.ContentStream).
               *
               * @returns The [PayloadType](xref:botframework-streaming.PayloadType) of this [ContentStream](xref:botframework-streaming.ContentStream).
               */
              get: function() {
                return this.assembler.payloadType;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(u.prototype, "length", {
              /**
               * Gets the length of this [ContentStream](xref:botframework-streaming.ContentStream).
               *
               * @returns A number representing the length of this [ContentStream](xref:botframework-streaming.ContentStream).
               */
              get: function() {
                return this.assembler.contentLength;
              },
              enumerable: !1,
              configurable: !0
            }), u.prototype.getStream = function() {
              return this.stream || (this.stream = this.assembler.getPayloadStream()), this.stream;
            }, u.prototype.cancel = function() {
              this.assembler.close();
            }, u.prototype.readAsString = function() {
              return o(this, void 0, void 0, function() {
                var l;
                return s(this, function(c) {
                  switch (c.label) {
                    case 0:
                      return [4, this.readAll()];
                    case 1:
                      return l = c.sent().bufferArray, [2, (l || []).map(function(d) {
                        return d.toString("utf8");
                      }).join("")];
                  }
                });
              });
            }, u.prototype.readAsJson = function() {
              return o(this, void 0, void 0, function() {
                var l;
                return s(this, function(c) {
                  switch (c.label) {
                    case 0:
                      return [4, this.readAsString()];
                    case 1:
                      return l = c.sent(), [2, JSON.parse(l)];
                  }
                });
              });
            }, u.prototype.readAll = function() {
              return o(this, void 0, void 0, function() {
                var l, c, d, h, f, p = this;
                return s(this, function(m) {
                  switch (m.label) {
                    case 0:
                      for (l = [], c = 0, d = this.getStream(); c < d.length; )
                        h = d.read(d.length), l.push(h), c += h.length;
                      return c < this.length ? (f = new Promise(function(w) {
                        var v = function(g) {
                          return function(A) {
                            l.push(A), c += A.length, c === g.length && w(!0);
                          };
                        };
                        d.subscribe(v(p));
                      }), [4, f]) : [3, 2];
                    case 1:
                      m.sent(), m.label = 2;
                    case 2:
                      return [2, { bufferArray: l, size: c }];
                  }
                });
              });
            }, u;
          })()
        );
        n.ContentStream = a;
      }, {}], 3: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 }), n.CancelDisassembler = void 0;
        var o = (
          /** @class */
          (function() {
            function s(a, u, l) {
              this.sender = a, this.id = u, this.payloadType = l;
            }
            return s.prototype.disassemble = function() {
              var a = {
                payloadType: this.payloadType,
                payloadLength: 0,
                id: this.id,
                end: !0
              };
              this.sender.sendPayload(a);
            }, s;
          })()
        );
        n.CancelDisassembler = o;
      }, {}], 4: [function(r, i, n) {
        var o = this && this.__extends || /* @__PURE__ */ (function() {
          var d = function(h, f) {
            return d = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
              p.__proto__ = m;
            } || function(p, m) {
              for (var w in m) Object.prototype.hasOwnProperty.call(m, w) && (p[w] = m[w]);
            }, d(h, f);
          };
          return function(h, f) {
            if (typeof f != "function" && f !== null)
              throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
            d(h, f);
            function p() {
              this.constructor = h;
            }
            h.prototype = f === null ? Object.create(f) : (p.prototype = f.prototype, new p());
          };
        })(), s = this && this.__awaiter || function(d, h, f, p) {
          function m(w) {
            return w instanceof f ? w : new f(function(v) {
              v(w);
            });
          }
          return new (f || (f = Promise))(function(w, v) {
            function g(k) {
              try {
                b(p.next(k));
              } catch (y) {
                v(y);
              }
            }
            function A(k) {
              try {
                b(p.throw(k));
              } catch (y) {
                v(y);
              }
            }
            function b(k) {
              k.done ? w(k.value) : m(k.value).then(g, A);
            }
            b((p = p.apply(d, h || [])).next());
          });
        }, a = this && this.__generator || function(d, h) {
          var f = { label: 0, sent: function() {
            if (w[0] & 1) throw w[1];
            return w[1];
          }, trys: [], ops: [] }, p, m, w, v;
          return v = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
            return this;
          }), v;
          function g(b) {
            return function(k) {
              return A([b, k]);
            };
          }
          function A(b) {
            if (p) throw new TypeError("Generator is already executing.");
            for (; v && (v = 0, b[0] && (f = 0)), f; ) try {
              if (p = 1, m && (w = b[0] & 2 ? m.return : b[0] ? m.throw || ((w = m.return) && w.call(m), 0) : m.next) && !(w = w.call(m, b[1])).done) return w;
              switch (m = 0, w && (b = [b[0] & 2, w.value]), b[0]) {
                case 0:
                case 1:
                  w = b;
                  break;
                case 4:
                  return f.label++, { value: b[1], done: !1 };
                case 5:
                  f.label++, m = b[1], b = [0];
                  continue;
                case 7:
                  b = f.ops.pop(), f.trys.pop();
                  continue;
                default:
                  if (w = f.trys, !(w = w.length > 0 && w[w.length - 1]) && (b[0] === 6 || b[0] === 2)) {
                    f = 0;
                    continue;
                  }
                  if (b[0] === 3 && (!w || b[1] > w[0] && b[1] < w[3])) {
                    f.label = b[1];
                    break;
                  }
                  if (b[0] === 6 && f.label < w[1]) {
                    f.label = w[1], w = b;
                    break;
                  }
                  if (w && f.label < w[2]) {
                    f.label = w[2], f.ops.push(b);
                    break;
                  }
                  w[2] && f.ops.pop(), f.trys.pop();
                  continue;
              }
              b = h.call(d, f);
            } catch (k) {
              b = [6, k], m = 0;
            } finally {
              p = w = 0;
            }
            if (b[0] & 5) throw b[1];
            return { value: b[0] ? b[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(n, "__esModule", { value: !0 }), n.HttpContentStreamDisassembler = void 0;
        var u = r("./payloadDisassembler"), l = r("../payloads"), c = (
          /** @class */
          (function(d) {
            o(h, d);
            function h(f, p) {
              var m = d.call(this, f, p.id) || this;
              return m.payloadType = l.PayloadTypes.stream, m.contentStream = p, m;
            }
            return h.prototype.getStream = function() {
              return s(this, void 0, void 0, function() {
                var f;
                return a(this, function(p) {
                  return f = this.contentStream.content.getStream(), [2, { stream: f, streamLength: f.length }];
                });
              });
            }, h;
          })(u.PayloadDisassembler)
        );
        n.HttpContentStreamDisassembler = c;
      }, { "../payloads": 16, "./payloadDisassembler": 5 }], 5: [function(r, i, n) {
        var o = this && this.__awaiter || function(l, c, d, h) {
          function f(p) {
            return p instanceof d ? p : new d(function(m) {
              m(p);
            });
          }
          return new (d || (d = Promise))(function(p, m) {
            function w(A) {
              try {
                g(h.next(A));
              } catch (b) {
                m(b);
              }
            }
            function v(A) {
              try {
                g(h.throw(A));
              } catch (b) {
                m(b);
              }
            }
            function g(A) {
              A.done ? p(A.value) : f(A.value).then(w, v);
            }
            g((h = h.apply(l, c || [])).next());
          });
        }, s = this && this.__generator || function(l, c) {
          var d = { label: 0, sent: function() {
            if (p[0] & 1) throw p[1];
            return p[1];
          }, trys: [], ops: [] }, h, f, p, m;
          return m = { next: w(0), throw: w(1), return: w(2) }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
            return this;
          }), m;
          function w(g) {
            return function(A) {
              return v([g, A]);
            };
          }
          function v(g) {
            if (h) throw new TypeError("Generator is already executing.");
            for (; m && (m = 0, g[0] && (d = 0)), d; ) try {
              if (h = 1, f && (p = g[0] & 2 ? f.return : g[0] ? f.throw || ((p = f.return) && p.call(f), 0) : f.next) && !(p = p.call(f, g[1])).done) return p;
              switch (f = 0, p && (g = [g[0] & 2, p.value]), g[0]) {
                case 0:
                case 1:
                  p = g;
                  break;
                case 4:
                  return d.label++, { value: g[1], done: !1 };
                case 5:
                  d.label++, f = g[1], g = [0];
                  continue;
                case 7:
                  g = d.ops.pop(), d.trys.pop();
                  continue;
                default:
                  if (p = d.trys, !(p = p.length > 0 && p[p.length - 1]) && (g[0] === 6 || g[0] === 2)) {
                    d = 0;
                    continue;
                  }
                  if (g[0] === 3 && (!p || g[1] > p[0] && g[1] < p[3])) {
                    d.label = g[1];
                    break;
                  }
                  if (g[0] === 6 && d.label < p[1]) {
                    d.label = p[1], p = g;
                    break;
                  }
                  if (p && d.label < p[2]) {
                    d.label = p[2], d.ops.push(g);
                    break;
                  }
                  p[2] && d.ops.pop(), d.trys.pop();
                  continue;
              }
              g = c.call(l, d);
            } catch (A) {
              g = [6, A], f = 0;
            } finally {
              h = p = 0;
            }
            if (g[0] & 5) throw g[1];
            return { value: g[0] ? g[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(n, "__esModule", { value: !0 }), n.PayloadDisassembler = void 0;
        var a = r("../subscribableStream"), u = (
          /** @class */
          (function() {
            function l(c, d) {
              this.sender = c, this.id = d;
            }
            return l.serialize = function(c) {
              var d = new a.SubscribableStream();
              return d.write(JSON.stringify(c)), d.end(), { stream: d, streamLength: d.length };
            }, l.prototype.disassemble = function() {
              return o(this, void 0, void 0, function() {
                var c, d, h;
                return s(this, function(f) {
                  switch (f.label) {
                    case 0:
                      return [4, this.getStream()];
                    case 1:
                      return c = f.sent(), d = c.stream, h = c.streamLength, this.stream = d, this.streamLength = h, [2, this.send()];
                  }
                });
              });
            }, l.prototype.send = function() {
              return o(this, void 0, void 0, function() {
                var c;
                return s(this, function(d) {
                  return c = {
                    payloadType: this.payloadType,
                    payloadLength: this.streamLength,
                    id: this.id,
                    end: !0
                  }, this.sender.sendPayload(c, this.stream), [
                    2
                    /*return*/
                  ];
                });
              });
            }, l;
          })()
        );
        n.PayloadDisassembler = u;
      }, { "../subscribableStream": 27 }], 6: [function(r, i, n) {
        var o = this && this.__extends || /* @__PURE__ */ (function() {
          var d = function(h, f) {
            return d = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
              p.__proto__ = m;
            } || function(p, m) {
              for (var w in m) Object.prototype.hasOwnProperty.call(m, w) && (p[w] = m[w]);
            }, d(h, f);
          };
          return function(h, f) {
            if (typeof f != "function" && f !== null)
              throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
            d(h, f);
            function p() {
              this.constructor = h;
            }
            h.prototype = f === null ? Object.create(f) : (p.prototype = f.prototype, new p());
          };
        })(), s = this && this.__awaiter || function(d, h, f, p) {
          function m(w) {
            return w instanceof f ? w : new f(function(v) {
              v(w);
            });
          }
          return new (f || (f = Promise))(function(w, v) {
            function g(k) {
              try {
                b(p.next(k));
              } catch (y) {
                v(y);
              }
            }
            function A(k) {
              try {
                b(p.throw(k));
              } catch (y) {
                v(y);
              }
            }
            function b(k) {
              k.done ? w(k.value) : m(k.value).then(g, A);
            }
            b((p = p.apply(d, h || [])).next());
          });
        }, a = this && this.__generator || function(d, h) {
          var f = { label: 0, sent: function() {
            if (w[0] & 1) throw w[1];
            return w[1];
          }, trys: [], ops: [] }, p, m, w, v;
          return v = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
            return this;
          }), v;
          function g(b) {
            return function(k) {
              return A([b, k]);
            };
          }
          function A(b) {
            if (p) throw new TypeError("Generator is already executing.");
            for (; v && (v = 0, b[0] && (f = 0)), f; ) try {
              if (p = 1, m && (w = b[0] & 2 ? m.return : b[0] ? m.throw || ((w = m.return) && w.call(m), 0) : m.next) && !(w = w.call(m, b[1])).done) return w;
              switch (m = 0, w && (b = [b[0] & 2, w.value]), b[0]) {
                case 0:
                case 1:
                  w = b;
                  break;
                case 4:
                  return f.label++, { value: b[1], done: !1 };
                case 5:
                  f.label++, m = b[1], b = [0];
                  continue;
                case 7:
                  b = f.ops.pop(), f.trys.pop();
                  continue;
                default:
                  if (w = f.trys, !(w = w.length > 0 && w[w.length - 1]) && (b[0] === 6 || b[0] === 2)) {
                    f = 0;
                    continue;
                  }
                  if (b[0] === 3 && (!w || b[1] > w[0] && b[1] < w[3])) {
                    f.label = b[1];
                    break;
                  }
                  if (b[0] === 6 && f.label < w[1]) {
                    f.label = w[1], w = b;
                    break;
                  }
                  if (w && f.label < w[2]) {
                    f.label = w[2], f.ops.push(b);
                    break;
                  }
                  w[2] && f.ops.pop(), f.trys.pop();
                  continue;
              }
              b = h.call(d, f);
            } catch (k) {
              b = [6, k], m = 0;
            } finally {
              p = w = 0;
            }
            if (b[0] & 5) throw b[1];
            return { value: b[0] ? b[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(n, "__esModule", { value: !0 }), n.RequestDisassembler = void 0;
        var u = r("../payloads/payloadTypes"), l = r("./payloadDisassembler"), c = (
          /** @class */
          (function(d) {
            o(h, d);
            function h(f, p, m) {
              var w = d.call(this, f, p) || this;
              return w.request = m, w.payloadType = u.PayloadTypes.request, w;
            }
            return h.prototype.getStream = function() {
              var f, p, m, w;
              return s(this, void 0, void 0, function() {
                var v;
                return a(this, function(g) {
                  return v = { verb: (f = this.request) === null || f === void 0 ? void 0 : f.verb, path: (p = this.request) === null || p === void 0 ? void 0 : p.path, streams: [] }, (w = (m = this.request) === null || m === void 0 ? void 0 : m.streams) === null || w === void 0 || w.forEach(function(A) {
                    v.streams.push(A.description);
                  }), [2, l.PayloadDisassembler.serialize(v)];
                });
              });
            }, h;
          })(l.PayloadDisassembler)
        );
        n.RequestDisassembler = c;
      }, { "../payloads/payloadTypes": 19, "./payloadDisassembler": 5 }], 7: [function(r, i, n) {
        var o = this && this.__extends || /* @__PURE__ */ (function() {
          var d = function(h, f) {
            return d = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(p, m) {
              p.__proto__ = m;
            } || function(p, m) {
              for (var w in m) Object.prototype.hasOwnProperty.call(m, w) && (p[w] = m[w]);
            }, d(h, f);
          };
          return function(h, f) {
            if (typeof f != "function" && f !== null)
              throw new TypeError("Class extends value " + String(f) + " is not a constructor or null");
            d(h, f);
            function p() {
              this.constructor = h;
            }
            h.prototype = f === null ? Object.create(f) : (p.prototype = f.prototype, new p());
          };
        })(), s = this && this.__awaiter || function(d, h, f, p) {
          function m(w) {
            return w instanceof f ? w : new f(function(v) {
              v(w);
            });
          }
          return new (f || (f = Promise))(function(w, v) {
            function g(k) {
              try {
                b(p.next(k));
              } catch (y) {
                v(y);
              }
            }
            function A(k) {
              try {
                b(p.throw(k));
              } catch (y) {
                v(y);
              }
            }
            function b(k) {
              k.done ? w(k.value) : m(k.value).then(g, A);
            }
            b((p = p.apply(d, h || [])).next());
          });
        }, a = this && this.__generator || function(d, h) {
          var f = { label: 0, sent: function() {
            if (w[0] & 1) throw w[1];
            return w[1];
          }, trys: [], ops: [] }, p, m, w, v;
          return v = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (v[Symbol.iterator] = function() {
            return this;
          }), v;
          function g(b) {
            return function(k) {
              return A([b, k]);
            };
          }
          function A(b) {
            if (p) throw new TypeError("Generator is already executing.");
            for (; v && (v = 0, b[0] && (f = 0)), f; ) try {
              if (p = 1, m && (w = b[0] & 2 ? m.return : b[0] ? m.throw || ((w = m.return) && w.call(m), 0) : m.next) && !(w = w.call(m, b[1])).done) return w;
              switch (m = 0, w && (b = [b[0] & 2, w.value]), b[0]) {
                case 0:
                case 1:
                  w = b;
                  break;
                case 4:
                  return f.label++, { value: b[1], done: !1 };
                case 5:
                  f.label++, m = b[1], b = [0];
                  continue;
                case 7:
                  b = f.ops.pop(), f.trys.pop();
                  continue;
                default:
                  if (w = f.trys, !(w = w.length > 0 && w[w.length - 1]) && (b[0] === 6 || b[0] === 2)) {
                    f = 0;
                    continue;
                  }
                  if (b[0] === 3 && (!w || b[1] > w[0] && b[1] < w[3])) {
                    f.label = b[1];
                    break;
                  }
                  if (b[0] === 6 && f.label < w[1]) {
                    f.label = w[1], w = b;
                    break;
                  }
                  if (w && f.label < w[2]) {
                    f.label = w[2], f.ops.push(b);
                    break;
                  }
                  w[2] && f.ops.pop(), f.trys.pop();
                  continue;
              }
              b = h.call(d, f);
            } catch (k) {
              b = [6, k], m = 0;
            } finally {
              p = w = 0;
            }
            if (b[0] & 5) throw b[1];
            return { value: b[0] ? b[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(n, "__esModule", { value: !0 }), n.ResponseDisassembler = void 0;
        var u = r("../payloads/payloadTypes"), l = r("./payloadDisassembler"), c = (
          /** @class */
          (function(d) {
            o(h, d);
            function h(f, p, m) {
              var w = d.call(this, f, p) || this;
              return w.payloadType = u.PayloadTypes.response, w.response = m, w;
            }
            return h.prototype.getStream = function() {
              var f;
              return s(this, void 0, void 0, function() {
                var p;
                return a(this, function(m) {
                  return p = { statusCode: this.response.statusCode, streams: [] }, (f = this.response.streams) === null || f === void 0 || f.forEach(function(w) {
                    var v = w.description;
                    p.streams.push({
                      id: v.id,
                      contentType: v.type,
                      length: v.length
                    });
                  }), [2, l.PayloadDisassembler.serialize(p)];
                });
              });
            }, h;
          })(l.PayloadDisassembler)
        );
        n.ResponseDisassembler = c;
      }, { "../payloads/payloadTypes": 19, "./payloadDisassembler": 5 }], 8: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 }), n.HttpContent = n.HttpContentStream = void 0;
        var o = r("./utilities/protocol-base"), s = (
          /** @class */
          /* @__PURE__ */ (function() {
            function u(l) {
              var c, d, h, f, p, m;
              this.content = l, this.id = (0, o.generateGuid)(), this.description = {
                id: this.id,
                type: (h = (d = (c = this.content) === null || c === void 0 ? void 0 : c.headers) === null || d === void 0 ? void 0 : d.type) !== null && h !== void 0 ? h : "unknown",
                length: (m = (p = (f = this.content) === null || f === void 0 ? void 0 : f.headers) === null || p === void 0 ? void 0 : p.contentLength) !== null && m !== void 0 ? m : 0
              };
            }
            return u;
          })()
        );
        n.HttpContentStream = s;
        var a = (
          /** @class */
          (function() {
            function u(l, c) {
              this.headers = l, this.stream = c;
            }
            return u.prototype.getStream = function() {
              return this.stream;
            }, u;
          })()
        );
        n.HttpContent = a;
      }, { "./utilities/protocol-base": 28 }], 9: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 }), n.WebSocketClient = n.BrowserWebSocket = n.SubscribableStream = n.StreamingResponse = n.StreamingRequest = n.RequestHandler = n.HttpContent = n.ContentStream = void 0;
        var o = r("./contentStream");
        Object.defineProperty(n, "ContentStream", { enumerable: !0, get: function() {
          return o.ContentStream;
        } });
        var s = r("./httpContentStream");
        Object.defineProperty(n, "HttpContent", { enumerable: !0, get: function() {
          return s.HttpContent;
        } });
        var a = r("./requestHandler");
        Object.defineProperty(n, "RequestHandler", { enumerable: !0, get: function() {
          return a.RequestHandler;
        } });
        var u = r("./streamingRequest");
        Object.defineProperty(n, "StreamingRequest", { enumerable: !0, get: function() {
          return u.StreamingRequest;
        } });
        var l = r("./streamingResponse");
        Object.defineProperty(n, "StreamingResponse", { enumerable: !0, get: function() {
          return l.StreamingResponse;
        } });
        var c = r("./subscribableStream");
        Object.defineProperty(n, "SubscribableStream", { enumerable: !0, get: function() {
          return c.SubscribableStream;
        } });
        var d = r("./webSocket/index-browser");
        Object.defineProperty(n, "BrowserWebSocket", { enumerable: !0, get: function() {
          return d.BrowserWebSocket;
        } }), Object.defineProperty(n, "WebSocketClient", { enumerable: !0, get: function() {
          return d.WebSocketClient;
        } });
      }, { "./contentStream": 2, "./httpContentStream": 8, "./requestHandler": 24, "./streamingRequest": 25, "./streamingResponse": 26, "./subscribableStream": 27, "./webSocket/index-browser": 31 }], 10: [function(r, i, n) {
        var o = this && this.__createBinding || (Object.create ? (function(a, u, l, c) {
          c === void 0 && (c = l);
          var d = Object.getOwnPropertyDescriptor(u, l);
          (!d || ("get" in d ? !u.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
            return u[l];
          } }), Object.defineProperty(a, c, d);
        }) : (function(a, u, l, c) {
          c === void 0 && (c = l), a[c] = u[l];
        })), s = this && this.__exportStar || function(a, u) {
          for (var l in a) l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && o(u, a, l);
        };
        Object.defineProperty(n, "__esModule", { value: !0 }), s(r("./payloadReceiver"), n), s(r("./payloadSender"), n), s(r("./transportDisconnectedEvent"), n), s(r("./transportDisconnectedEventHandler"), n);
      }, { "./payloadReceiver": 11, "./payloadSender": 12, "./transportDisconnectedEvent": 13, "./transportDisconnectedEventHandler": 14 }], 11: [function(r, i, n) {
        var o = this && this.__awaiter || function(h, f, p, m) {
          function w(v) {
            return v instanceof p ? v : new p(function(g) {
              g(v);
            });
          }
          return new (p || (p = Promise))(function(v, g) {
            function A(y) {
              try {
                k(m.next(y));
              } catch (x) {
                g(x);
              }
            }
            function b(y) {
              try {
                k(m.throw(y));
              } catch (x) {
                g(x);
              }
            }
            function k(y) {
              y.done ? v(y.value) : w(y.value).then(A, b);
            }
            k((m = m.apply(h, f || [])).next());
          });
        }, s = this && this.__generator || function(h, f) {
          var p = { label: 0, sent: function() {
            if (v[0] & 1) throw v[1];
            return v[1];
          }, trys: [], ops: [] }, m, w, v, g;
          return g = { next: A(0), throw: A(1), return: A(2) }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
            return this;
          }), g;
          function A(k) {
            return function(y) {
              return b([k, y]);
            };
          }
          function b(k) {
            if (m) throw new TypeError("Generator is already executing.");
            for (; g && (g = 0, k[0] && (p = 0)), p; ) try {
              if (m = 1, w && (v = k[0] & 2 ? w.return : k[0] ? w.throw || ((v = w.return) && v.call(w), 0) : w.next) && !(v = v.call(w, k[1])).done) return v;
              switch (w = 0, v && (k = [k[0] & 2, v.value]), k[0]) {
                case 0:
                case 1:
                  v = k;
                  break;
                case 4:
                  return p.label++, { value: k[1], done: !1 };
                case 5:
                  p.label++, w = k[1], k = [0];
                  continue;
                case 7:
                  k = p.ops.pop(), p.trys.pop();
                  continue;
                default:
                  if (v = p.trys, !(v = v.length > 0 && v[v.length - 1]) && (k[0] === 6 || k[0] === 2)) {
                    p = 0;
                    continue;
                  }
                  if (k[0] === 3 && (!v || k[1] > v[0] && k[1] < v[3])) {
                    p.label = k[1];
                    break;
                  }
                  if (k[0] === 6 && p.label < v[1]) {
                    p.label = v[1], v = k;
                    break;
                  }
                  if (v && p.label < v[2]) {
                    p.label = v[2], p.ops.push(k);
                    break;
                  }
                  v[2] && p.ops.pop(), p.trys.pop();
                  continue;
              }
              k = f.call(h, p);
            } catch (y) {
              k = [6, y], w = 0;
            } finally {
              m = v = 0;
            }
            if (k[0] & 5) throw k[1];
            return { value: k[0] ? k[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(n, "__esModule", { value: !0 }), n.PayloadReceiver = void 0;
        var a = r("../payloads/payloadTypes"), u = r("../payloads/headerSerializer"), l = r("../payloads/payloadConstants"), c = r("./transportDisconnectedEvent"), d = (
          /** @class */
          (function() {
            function h() {
            }
            return Object.defineProperty(h.prototype, "isConnected", {
              /**
               * Get current connected state
               *
               * @returns true if connected to a transport sender.
               */
              get: function() {
                return this._receiver != null;
              },
              enumerable: !1,
              configurable: !0
            }), h.prototype.connect = function(f) {
              return this._receiver = f, this.receivePackets();
            }, h.prototype.subscribe = function(f, p) {
              this._getStream = f, this._receiveAction = p;
            }, h.prototype.disconnect = function(f) {
              var p, m;
              if (f === void 0 && (f = c.TransportDisconnectedEvent.Empty), !!this.isConnected)
                try {
                  this._receiver.close(), (p = this.disconnected) === null || p === void 0 || p.call(this, this, f);
                } catch (w) {
                  (m = this.disconnected) === null || m === void 0 || m.call(this, this, new c.TransportDisconnectedEvent(w.message));
                } finally {
                  this._receiver = null;
                }
            }, h.prototype.receivePackets = function() {
              return o(this, void 0, void 0, function() {
                var f, p, m, w, v, g, A, b, k;
                return s(this, function(y) {
                  switch (y.label) {
                    case 0:
                      if (!this.isConnected) return [3, 11];
                      y.label = 1;
                    case 1:
                      y.trys.push([1, 9, , 10]), f = 0, y.label = 2;
                    case 2:
                      return f < l.PayloadConstants.MaxHeaderLength ? (p = this, [4, this._receiver.receive(l.PayloadConstants.MaxHeaderLength - f)]) : [3, 4];
                    case 3:
                      return p._receiveHeaderBuffer = y.sent(), this._receiveHeaderBuffer && (f += this._receiveHeaderBuffer.length), [3, 2];
                    case 4:
                      if (m = u.HeaderSerializer.deserialize(this._receiveHeaderBuffer), w = m.payloadType === a.PayloadTypes.stream, !(m.payloadLength > 0)) return [3, 8];
                      v = 0, g = this._getStream(m), y.label = 5;
                    case 5:
                      return v < m.payloadLength && v < l.PayloadConstants.MaxPayloadLength ? (A = Math.min(m.payloadLength - v, l.PayloadConstants.MaxPayloadLength), b = this, [4, this._receiver.receive(A)]) : [3, 7];
                    case 6:
                      return b._receivePayloadBuffer = y.sent(), v += this._receivePayloadBuffer.byteLength, g.write(this._receivePayloadBuffer), w && this._receiveAction(m, g, v), [3, 5];
                    case 7:
                      w || this._receiveAction(m, g, v), y.label = 8;
                    case 8:
                      return [3, 10];
                    case 9:
                      return k = y.sent(), this.disconnect(new c.TransportDisconnectedEvent(k.message)), [3, 10];
                    case 10:
                      return [3, 0];
                    case 11:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, h;
          })()
        );
        n.PayloadReceiver = d;
      }, { "../payloads/headerSerializer": 15, "../payloads/payloadConstants": 18, "../payloads/payloadTypes": 19, "./transportDisconnectedEvent": 13 }], 12: [function(r, i, n) {
        (function(o) {
          (function() {
            Object.defineProperty(n, "__esModule", { value: !0 }), n.PayloadSender = void 0;
            var s = r("../payloads/headerSerializer"), a = r("../payloads/payloadConstants"), u = r("./transportDisconnectedEvent"), l = (
              /** @class */
              (function() {
                function c() {
                }
                return Object.defineProperty(c.prototype, "isConnected", {
                  /**
                   * Get current connected state
                   *
                   * @returns true if connected to a transport sender.
                   */
                  get: function() {
                    return this._sender != null;
                  },
                  enumerable: !1,
                  configurable: !0
                }), c.prototype.connect = function(d) {
                  this._sender = d;
                }, c.prototype.sendPayload = function(d, h, f) {
                  var p = { header: d, payload: h, sentCallback: f };
                  this.writePacket(p);
                }, c.prototype.disconnect = function(d) {
                  var h, f;
                  if (d === void 0 && (d = u.TransportDisconnectedEvent.Empty), !!this.isConnected)
                    try {
                      this._sender.close(), (h = this.disconnected) === null || h === void 0 || h.call(this, this, d);
                    } catch (p) {
                      (f = this.disconnected) === null || f === void 0 || f.call(this, this, new u.TransportDisconnectedEvent(p.message));
                    } finally {
                      this._sender = null;
                    }
                }, c.prototype.writePacket = function(d) {
                  try {
                    if (d.header.payloadLength > 0 && d.payload) {
                      for (var h = d.header.payloadLength; h > 0; ) {
                        var f = h <= a.PayloadConstants.MaxPayloadLength ? h : a.PayloadConstants.MaxPayloadLength, p = d.payload.read(f), m = d.header;
                        m.payloadLength = f, m.end = h <= a.PayloadConstants.MaxPayloadLength;
                        var w = o.alloc(a.PayloadConstants.MaxHeaderLength);
                        s.HeaderSerializer.serialize(m, w), this._sender.send(w), this._sender.send(p), h -= p.length;
                      }
                      d.sentCallback && d.sentCallback();
                    }
                  } catch (v) {
                    this.disconnect(new u.TransportDisconnectedEvent(v.message));
                  }
                }, c;
              })()
            );
            n.PayloadSender = l;
          }).call(this);
        }).call(this, r("buffer").Buffer);
      }, { "../payloads/headerSerializer": 15, "../payloads/payloadConstants": 18, "./transportDisconnectedEvent": 13, buffer: 35 }], 13: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 }), n.TransportDisconnectedEvent = void 0;
        var o = (
          /** @class */
          (function() {
            function s(a) {
              this.reason = a;
            }
            return s.Empty = new s(), s;
          })()
        );
        n.TransportDisconnectedEvent = o;
      }, {}], 14: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 });
      }, {}], 15: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 }), n.HeaderSerializer = void 0;
        var o = r("./payloadConstants"), s = (
          /** @class */
          (function() {
            function a() {
            }
            return a.serialize = function(u, l) {
              l.write(u.payloadType, this.TypeOffset, 1, this.Encoding), l.write(this.Delimiter, this.TypeDelimiterOffset, 1, this.Encoding), l.write(this.headerLengthPadder(u.payloadLength, this.LengthLength, "0"), this.LengthOffset, this.LengthLength, this.Encoding), l.write(this.Delimiter, this.LengthDelimeterOffset, 1, this.Encoding), l.write(u.id, this.IdOffset), l.write(this.Delimiter, this.IdDelimeterOffset, 1, this.Encoding), l.write(u.end ? this.End : this.NotEnd, this.EndOffset), l.write(this.Terminator, this.TerminatorOffset);
            }, a.deserialize = function(u) {
              var l = u.toString(this.Encoding), c = l.split(this.Delimiter);
              if (c.length !== 4)
                throw Error("Cannot parse header, header is malformed. Header: ".concat(l));
              var d = c[0], h = c[1], f = c[2], p = c[3], m = p === `1
`, w = Number(h), v = { end: m, payloadLength: w, payloadType: d, id: f };
              if (!(v.payloadLength <= o.PayloadConstants.MaxPayloadLength && v.payloadLength >= o.PayloadConstants.MinLength))
                throw Error("Header length of ".concat(v.payloadLength, " is missing or malformed"));
              if (v.payloadType.length !== this.TypeDelimiterOffset)
                throw Error("Header type '".concat(v.payloadType.length, "' is missing or malformed."));
              if (!v.id || !v.id.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i) || v.id.length !== this.IdLength)
                throw Error("Header ID '".concat(v.id, "' is missing or malformed."));
              if (!(p === `0
` || p === `1
`))
                throw Error("Header End is missing or not a valid value. Header end: '".concat(p, "'"));
              return v;
            }, a.headerLengthPadder = function(u, l, c) {
              var d = Array(l + 1).join(c), h = u.toString();
              return (d + h).slice(h.length);
            }, a.Delimiter = ".", a.Terminator = `
`, a.End = "1", a.NotEnd = "0", a.TypeOffset = 0, a.TypeDelimiterOffset = 1, a.LengthOffset = 2, a.LengthLength = 6, a.LengthDelimeterOffset = 8, a.IdOffset = 9, a.IdLength = 36, a.IdDelimeterOffset = 45, a.EndOffset = 46, a.TerminatorOffset = 47, a.Encoding = "utf8", a;
          })()
        );
        n.HeaderSerializer = s;
      }, { "./payloadConstants": 18 }], 16: [function(r, i, n) {
        var o = this && this.__createBinding || (Object.create ? (function(a, u, l, c) {
          c === void 0 && (c = l);
          var d = Object.getOwnPropertyDescriptor(u, l);
          (!d || ("get" in d ? !u.__esModule : d.writable || d.configurable)) && (d = { enumerable: !0, get: function() {
            return u[l];
          } }), Object.defineProperty(a, c, d);
        }) : (function(a, u, l, c) {
          c === void 0 && (c = l), a[c] = u[l];
        })), s = this && this.__exportStar || function(a, u) {
          for (var l in a) l !== "default" && !Object.prototype.hasOwnProperty.call(u, l) && o(u, a, l);
        };
        Object.defineProperty(n, "__esModule", { value: !0 }), s(r("./headerSerializer"), n), s(r("./streamManager"), n), s(r("./payloadAssemblerManager"), n), s(r("./payloadTypes"), n), s(r("./requestManager"), n), s(r("./sendOperations"), n), s(r("./streamManager"), n);
      }, { "./headerSerializer": 15, "./payloadAssemblerManager": 17, "./payloadTypes": 19, "./requestManager": 20, "./sendOperations": 21, "./streamManager": 22 }], 17: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 }), n.PayloadAssemblerManager = void 0;
        var o = r("../assemblers/payloadAssembler"), s = r("./payloadTypes"), a = (
          /** @class */
          (function() {
            function u(l, c, d) {
              this.streamManager = l, this.onReceiveResponse = c, this.onReceiveRequest = d, this.activeAssemblers = {};
            }
            return u.prototype.getPayloadStream = function(l) {
              if (l.payloadType === s.PayloadTypes.stream)
                return this.streamManager.getPayloadStream(l);
              if (!this.activeAssemblers[l.id]) {
                var c = this.createPayloadAssembler(l);
                if (c)
                  return this.activeAssemblers[l.id] = c, c.getPayloadStream();
              }
            }, u.prototype.onReceive = function(l, c, d) {
              if (l.payloadType === s.PayloadTypes.stream)
                this.streamManager.onReceive(l, c, d);
              else {
                if (this.activeAssemblers && this.activeAssemblers[l.id]) {
                  var h = this.activeAssemblers[l.id];
                  h.onReceive(l, c, d);
                }
                l.end && delete this.activeAssemblers[l.id];
              }
            }, u.prototype.createPayloadAssembler = function(l) {
              if (l.payloadType === s.PayloadTypes.request)
                return new o.PayloadAssembler(this.streamManager, {
                  header: l,
                  onCompleted: this.onReceiveRequest
                });
              if (l.payloadType === s.PayloadTypes.response)
                return new o.PayloadAssembler(this.streamManager, {
                  header: l,
                  onCompleted: this.onReceiveResponse
                });
            }, u;
          })()
        );
        n.PayloadAssemblerManager = a;
      }, { "../assemblers/payloadAssembler": 1, "./payloadTypes": 19 }], 18: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 }), n.PayloadConstants = void 0, (function(o) {
          o[o.MaxPayloadLength = 4096] = "MaxPayloadLength", o[o.MaxHeaderLength = 48] = "MaxHeaderLength", o[o.MaxLength = 999999] = "MaxLength", o[o.MinLength = 0] = "MinLength";
        })(n.PayloadConstants || (n.PayloadConstants = {}));
      }, {}], 19: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 }), n.PayloadTypes = void 0, (function(o) {
          o.request = "A", o.response = "B", o.stream = "S", o.cancelAll = "X", o.cancelStream = "C";
        })(n.PayloadTypes || (n.PayloadTypes = {}));
      }, {}], 20: [function(r, i, n) {
        var o = this && this.__awaiter || function(l, c, d, h) {
          function f(p) {
            return p instanceof d ? p : new d(function(m) {
              m(p);
            });
          }
          return new (d || (d = Promise))(function(p, m) {
            function w(A) {
              try {
                g(h.next(A));
              } catch (b) {
                m(b);
              }
            }
            function v(A) {
              try {
                g(h.throw(A));
              } catch (b) {
                m(b);
              }
            }
            function g(A) {
              A.done ? p(A.value) : f(A.value).then(w, v);
            }
            g((h = h.apply(l, c || [])).next());
          });
        }, s = this && this.__generator || function(l, c) {
          var d = { label: 0, sent: function() {
            if (p[0] & 1) throw p[1];
            return p[1];
          }, trys: [], ops: [] }, h, f, p, m;
          return m = { next: w(0), throw: w(1), return: w(2) }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
            return this;
          }), m;
          function w(g) {
            return function(A) {
              return v([g, A]);
            };
          }
          function v(g) {
            if (h) throw new TypeError("Generator is already executing.");
            for (; m && (m = 0, g[0] && (d = 0)), d; ) try {
              if (h = 1, f && (p = g[0] & 2 ? f.return : g[0] ? f.throw || ((p = f.return) && p.call(f), 0) : f.next) && !(p = p.call(f, g[1])).done) return p;
              switch (f = 0, p && (g = [g[0] & 2, p.value]), g[0]) {
                case 0:
                case 1:
                  p = g;
                  break;
                case 4:
                  return d.label++, { value: g[1], done: !1 };
                case 5:
                  d.label++, f = g[1], g = [0];
                  continue;
                case 7:
                  g = d.ops.pop(), d.trys.pop();
                  continue;
                default:
                  if (p = d.trys, !(p = p.length > 0 && p[p.length - 1]) && (g[0] === 6 || g[0] === 2)) {
                    d = 0;
                    continue;
                  }
                  if (g[0] === 3 && (!p || g[1] > p[0] && g[1] < p[3])) {
                    d.label = g[1];
                    break;
                  }
                  if (g[0] === 6 && d.label < p[1]) {
                    d.label = p[1], p = g;
                    break;
                  }
                  if (p && d.label < p[2]) {
                    d.label = p[2], d.ops.push(g);
                    break;
                  }
                  p[2] && d.ops.pop(), d.trys.pop();
                  continue;
              }
              g = c.call(l, d);
            } catch (A) {
              g = [6, A], f = 0;
            } finally {
              h = p = 0;
            }
            if (g[0] & 5) throw g[1];
            return { value: g[0] ? g[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(n, "__esModule", { value: !0 }), n.RequestManager = void 0;
        var a = (
          /** @class */
          /* @__PURE__ */ (function() {
            function l() {
            }
            return l;
          })()
        ), u = (
          /** @class */
          (function() {
            function l() {
              this._pendingRequests = {};
            }
            return l.prototype.pendingRequestCount = function() {
              return Object.keys(this._pendingRequests).length;
            }, l.prototype.signalResponse = function(c, d) {
              return o(this, void 0, void 0, function() {
                var h;
                return s(this, function(f) {
                  return h = this._pendingRequests[c], h ? (h.resolve(d), delete this._pendingRequests[c], [2, !0]) : [2, !1];
                });
              });
            }, l.prototype.getResponse = function(c) {
              var d = this._pendingRequests[c];
              if (d)
                return Promise.reject("requestId '".concat(c, "' already exists in RequestManager"));
              d = new a(), d.requestId = c;
              var h = new Promise(function(f, p) {
                d.resolve = f, d.reject = p;
              });
              return this._pendingRequests[c] = d, h;
            }, l.prototype.rejectAllResponses = function(c) {
              var d = this;
              Object.entries(this._pendingRequests).forEach(function(h) {
                var f = h[0], p = h[1].reject;
                p(c), delete d._pendingRequests[f];
              });
            }, l;
          })()
        );
        n.RequestManager = u;
      }, {}], 21: [function(r, i, n) {
        var o = this && this.__awaiter || function(f, p, m, w) {
          function v(g) {
            return g instanceof m ? g : new m(function(A) {
              A(g);
            });
          }
          return new (m || (m = Promise))(function(g, A) {
            function b(x) {
              try {
                y(w.next(x));
              } catch (C) {
                A(C);
              }
            }
            function k(x) {
              try {
                y(w.throw(x));
              } catch (C) {
                A(C);
              }
            }
            function y(x) {
              x.done ? g(x.value) : v(x.value).then(b, k);
            }
            y((w = w.apply(f, p || [])).next());
          });
        }, s = this && this.__generator || function(f, p) {
          var m = { label: 0, sent: function() {
            if (g[0] & 1) throw g[1];
            return g[1];
          }, trys: [], ops: [] }, w, v, g, A;
          return A = { next: b(0), throw: b(1), return: b(2) }, typeof Symbol == "function" && (A[Symbol.iterator] = function() {
            return this;
          }), A;
          function b(y) {
            return function(x) {
              return k([y, x]);
            };
          }
          function k(y) {
            if (w) throw new TypeError("Generator is already executing.");
            for (; A && (A = 0, y[0] && (m = 0)), m; ) try {
              if (w = 1, v && (g = y[0] & 2 ? v.return : y[0] ? v.throw || ((g = v.return) && g.call(v), 0) : v.next) && !(g = g.call(v, y[1])).done) return g;
              switch (v = 0, g && (y = [y[0] & 2, g.value]), y[0]) {
                case 0:
                case 1:
                  g = y;
                  break;
                case 4:
                  return m.label++, { value: y[1], done: !1 };
                case 5:
                  m.label++, v = y[1], y = [0];
                  continue;
                case 7:
                  y = m.ops.pop(), m.trys.pop();
                  continue;
                default:
                  if (g = m.trys, !(g = g.length > 0 && g[g.length - 1]) && (y[0] === 6 || y[0] === 2)) {
                    m = 0;
                    continue;
                  }
                  if (y[0] === 3 && (!g || y[1] > g[0] && y[1] < g[3])) {
                    m.label = y[1];
                    break;
                  }
                  if (y[0] === 6 && m.label < g[1]) {
                    m.label = g[1], g = y;
                    break;
                  }
                  if (g && m.label < g[2]) {
                    m.label = g[2], m.ops.push(y);
                    break;
                  }
                  g[2] && m.ops.pop(), m.trys.pop();
                  continue;
              }
              y = p.call(f, m);
            } catch (x) {
              y = [6, x], v = 0;
            } finally {
              w = g = 0;
            }
            if (y[0] & 5) throw y[1];
            return { value: y[0] ? y[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(n, "__esModule", { value: !0 }), n.SendOperations = void 0;
        var a = r("../disassemblers/cancelDisassembler"), u = r("../disassemblers/httpContentStreamDisassembler"), l = r("../disassemblers/requestDisassembler"), c = r("../disassemblers/responseDisassembler"), d = r("./payloadTypes"), h = (
          /** @class */
          (function() {
            function f(p) {
              this.payloadSender = p;
            }
            return f.prototype.sendRequest = function(p, m) {
              return o(this, void 0, void 0, function() {
                var w, v = this;
                return s(this, function(g) {
                  switch (g.label) {
                    case 0:
                      return w = new l.RequestDisassembler(this.payloadSender, p, m), [4, w.disassemble()];
                    case 1:
                      return g.sent(), m.streams && m.streams.forEach(function(A) {
                        return o(v, void 0, void 0, function() {
                          return s(this, function(b) {
                            switch (b.label) {
                              case 0:
                                return [4, new u.HttpContentStreamDisassembler(this.payloadSender, A).disassemble()];
                              case 1:
                                return b.sent(), [
                                  2
                                  /*return*/
                                ];
                            }
                          });
                        });
                      }), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, f.prototype.sendResponse = function(p, m) {
              return o(this, void 0, void 0, function() {
                var w, v = this;
                return s(this, function(g) {
                  switch (g.label) {
                    case 0:
                      return w = new c.ResponseDisassembler(this.payloadSender, p, m), [4, w.disassemble()];
                    case 1:
                      return g.sent(), m.streams && m.streams.forEach(function(A) {
                        return o(v, void 0, void 0, function() {
                          return s(this, function(b) {
                            switch (b.label) {
                              case 0:
                                return [4, new u.HttpContentStreamDisassembler(this.payloadSender, A).disassemble()];
                              case 1:
                                return b.sent(), [
                                  2
                                  /*return*/
                                ];
                            }
                          });
                        });
                      }), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, f.prototype.sendCancelStream = function(p) {
              return o(this, void 0, void 0, function() {
                var m;
                return s(this, function(w) {
                  return m = new a.CancelDisassembler(this.payloadSender, p, d.PayloadTypes.cancelStream), m.disassemble(), [
                    2
                    /*return*/
                  ];
                });
              });
            }, f;
          })()
        );
        n.SendOperations = h;
      }, { "../disassemblers/cancelDisassembler": 3, "../disassemblers/httpContentStreamDisassembler": 4, "../disassemblers/requestDisassembler": 6, "../disassemblers/responseDisassembler": 7, "./payloadTypes": 19 }], 22: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 }), n.StreamManager = void 0;
        var o = r("../assemblers/payloadAssembler"), s = (
          /** @class */
          (function() {
            function a(u) {
              this.onCancelStream = u, this.activeAssemblers = [];
            }
            return a.prototype.getPayloadAssembler = function(u) {
              if (this.activeAssemblers[u])
                return this.activeAssemblers[u];
              var l = new o.PayloadAssembler(this, { id: u });
              return this.activeAssemblers[u] = l, l;
            }, a.prototype.getPayloadStream = function(u) {
              var l = this.getPayloadAssembler(u.id);
              return l.getPayloadStream();
            }, a.prototype.onReceive = function(u, l, c) {
              this.activeAssemblers[u.id] && this.activeAssemblers[u.id].onReceive(u, l, c);
            }, a.prototype.closeStream = function(u) {
              if (this.activeAssemblers[u]) {
                var l = this.activeAssemblers[u];
                this.activeAssemblers.splice(this.activeAssemblers.indexOf(u), 1);
                var c = l.getPayloadStream();
                (l.contentLength && c.length < l.contentLength || !l.end) && this.onCancelStream(l);
              } else
                return;
            }, a;
          })()
        );
        n.StreamManager = s;
      }, { "../assemblers/payloadAssembler": 1 }], 23: [function(r, i, n) {
        var o = this && this.__awaiter || function(h, f, p, m) {
          function w(v) {
            return v instanceof p ? v : new p(function(g) {
              g(v);
            });
          }
          return new (p || (p = Promise))(function(v, g) {
            function A(y) {
              try {
                k(m.next(y));
              } catch (x) {
                g(x);
              }
            }
            function b(y) {
              try {
                k(m.throw(y));
              } catch (x) {
                g(x);
              }
            }
            function k(y) {
              y.done ? v(y.value) : w(y.value).then(A, b);
            }
            k((m = m.apply(h, f || [])).next());
          });
        }, s = this && this.__generator || function(h, f) {
          var p = { label: 0, sent: function() {
            if (v[0] & 1) throw v[1];
            return v[1];
          }, trys: [], ops: [] }, m, w, v, g;
          return g = { next: A(0), throw: A(1), return: A(2) }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
            return this;
          }), g;
          function A(k) {
            return function(y) {
              return b([k, y]);
            };
          }
          function b(k) {
            if (m) throw new TypeError("Generator is already executing.");
            for (; g && (g = 0, k[0] && (p = 0)), p; ) try {
              if (m = 1, w && (v = k[0] & 2 ? w.return : k[0] ? w.throw || ((v = w.return) && v.call(w), 0) : w.next) && !(v = v.call(w, k[1])).done) return v;
              switch (w = 0, v && (k = [k[0] & 2, v.value]), k[0]) {
                case 0:
                case 1:
                  v = k;
                  break;
                case 4:
                  return p.label++, { value: k[1], done: !1 };
                case 5:
                  p.label++, w = k[1], k = [0];
                  continue;
                case 7:
                  k = p.ops.pop(), p.trys.pop();
                  continue;
                default:
                  if (v = p.trys, !(v = v.length > 0 && v[v.length - 1]) && (k[0] === 6 || k[0] === 2)) {
                    p = 0;
                    continue;
                  }
                  if (k[0] === 3 && (!v || k[1] > v[0] && k[1] < v[3])) {
                    p.label = k[1];
                    break;
                  }
                  if (k[0] === 6 && p.label < v[1]) {
                    p.label = v[1], v = k;
                    break;
                  }
                  if (v && p.label < v[2]) {
                    p.label = v[2], p.ops.push(k);
                    break;
                  }
                  v[2] && p.ops.pop(), p.trys.pop();
                  continue;
              }
              k = f.call(h, p);
            } catch (y) {
              k = [6, y], w = 0;
            } finally {
              m = v = 0;
            }
            if (k[0] & 5) throw k[1];
            return { value: k[0] ? k[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(n, "__esModule", { value: !0 }), n.ProtocolAdapter = void 0;
        var a = r("./payloads/payloadAssemblerManager"), u = r("./payloads/sendOperations"), l = r("./payloads/streamManager"), c = r("./utilities/protocol-base"), d = (
          /** @class */
          (function() {
            function h(f, p, m, w) {
              var v = this;
              this.requestHandler = f, this.requestManager = p, this.payloadSender = m, this.payloadReceiver = w, this.sendOperations = new u.SendOperations(this.payloadSender), this.streamManager = new l.StreamManager(this.onCancelStream), this.assemblerManager = new a.PayloadAssemblerManager(this.streamManager, function(g, A) {
                return v.onReceiveResponse(g, A);
              }, function(g, A) {
                return v.onReceiveRequest(g, A);
              }), this.payloadReceiver.subscribe(function(g) {
                return v.assemblerManager.getPayloadStream(g);
              }, function(g, A, b) {
                return v.assemblerManager.onReceive(g, A, b);
              });
            }
            return h.prototype.sendRequest = function(f) {
              return o(this, void 0, void 0, function() {
                var p, m;
                return s(this, function(w) {
                  switch (w.label) {
                    case 0:
                      return p = (0, c.generateGuid)(), m = this.requestManager.getResponse(p), [4, this.sendOperations.sendRequest(p, f)];
                    case 1:
                      return w.sent(), [2, m];
                  }
                });
              });
            }, h.prototype.onReceiveRequest = function(f, p) {
              return o(this, void 0, void 0, function() {
                var m;
                return s(this, function(w) {
                  switch (w.label) {
                    case 0:
                      return this.requestHandler ? [4, this.requestHandler.processRequest(p)] : [3, 3];
                    case 1:
                      return m = w.sent(), m ? [4, this.sendOperations.sendResponse(f, m)] : [3, 3];
                    case 2:
                      w.sent(), w.label = 3;
                    case 3:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, h.prototype.onReceiveResponse = function(f, p) {
              return o(this, void 0, void 0, function() {
                return s(this, function(m) {
                  switch (m.label) {
                    case 0:
                      return [4, this.requestManager.signalResponse(f, p)];
                    case 1:
                      return m.sent(), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, h.prototype.onCancelStream = function(f) {
              this.sendOperations.sendCancelStream(f.id).catch();
            }, h;
          })()
        );
        n.ProtocolAdapter = d;
      }, { "./payloads/payloadAssemblerManager": 17, "./payloads/sendOperations": 21, "./payloads/streamManager": 22, "./utilities/protocol-base": 28 }], 24: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 }), n.RequestHandler = void 0;
        var o = (
          /** @class */
          /* @__PURE__ */ (function() {
            function s() {
            }
            return s;
          })()
        );
        n.RequestHandler = o;
      }, {}], 25: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 }), n.StreamingRequest = void 0;
        var o = r("./httpContentStream"), s = r("./subscribableStream"), a = (
          /** @class */
          (function() {
            function u() {
              this.streams = [];
            }
            return u.create = function(l, c, d) {
              var h = new u();
              return h.verb = l, h.path = c, d && h.setBody(d), h;
            }, u.prototype.addStream = function(l) {
              if (!l)
                throw new Error("Argument Undefined Exception: content undefined.");
              this.streams.push(new o.HttpContentStream(l));
            }, u.prototype.setBody = function(l) {
              if (typeof l == "string") {
                var c = new s.SubscribableStream();
                c.write(l, "utf8"), this.addStream(new o.HttpContent({
                  type: "application/json; charset=utf-8",
                  contentLength: c.length
                }, c));
              } else typeof l == "object" && this.addStream(l);
            }, u;
          })()
        );
        n.StreamingRequest = a;
      }, { "./httpContentStream": 8, "./subscribableStream": 27 }], 26: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 }), n.StreamingResponse = void 0;
        var o = r("./httpContentStream"), s = r("./subscribableStream"), a = (
          /** @class */
          (function() {
            function u() {
              this.streams = [];
            }
            return u.create = function(l, c) {
              var d = new u();
              return d.statusCode = l, c && d.addStream(c), d;
            }, u.prototype.addStream = function(l) {
              this.streams.push(new o.HttpContentStream(l));
            }, u.prototype.setBody = function(l) {
              var c = new s.SubscribableStream();
              c.write(JSON.stringify(l), "utf8"), this.addStream(new o.HttpContent({
                type: "application/json; charset=utf-8",
                contentLength: c.length
              }, c));
            }, u;
          })()
        );
        n.StreamingResponse = a;
      }, { "./httpContentStream": 8, "./subscribableStream": 27 }], 27: [function(r, i, n) {
        (function(o) {
          (function() {
            var s = this && this.__extends || /* @__PURE__ */ (function() {
              var l = function(c, d) {
                return l = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(h, f) {
                  h.__proto__ = f;
                } || function(h, f) {
                  for (var p in f) Object.prototype.hasOwnProperty.call(f, p) && (h[p] = f[p]);
                }, l(c, d);
              };
              return function(c, d) {
                if (typeof d != "function" && d !== null)
                  throw new TypeError("Class extends value " + String(d) + " is not a constructor or null");
                l(c, d);
                function h() {
                  this.constructor = c;
                }
                c.prototype = d === null ? Object.create(d) : (h.prototype = d.prototype, new h());
              };
            })();
            Object.defineProperty(n, "__esModule", { value: !0 }), n.SubscribableStream = void 0;
            var a = r("stream"), u = (
              /** @class */
              (function(l) {
                s(c, l);
                function c(d) {
                  var h = l.call(this, d) || this;
                  return h.length = 0, h.bufferList = [], h;
                }
                return c.prototype._write = function(d, h, f) {
                  var p = o.from(d);
                  this.bufferList.push(p), this.length += d.length, this._onData && this._onData(p), f();
                }, c.prototype._read = function(d) {
                  if (this.bufferList.length === 0)
                    this.push(null);
                  else
                    for (var h = 0; h < d && this.bufferList.length > 0; ) {
                      var f = this.bufferList[0];
                      this.push(f), this.bufferList.splice(0, 1), h += f.length;
                    }
                }, c.prototype.subscribe = function(d) {
                  this._onData = d;
                }, c;
              })(a.Duplex)
            );
            n.SubscribableStream = u;
          }).call(this);
        }).call(this, r("buffer").Buffer);
      }, { buffer: 35, stream: 41 }], 28: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 }), n.generateGuid = void 0;
        var o = r("uuid");
        function s() {
          return (0, o.v4)();
        }
        n.generateGuid = s;
      }, { uuid: 58 }], 29: [function(r, i, n) {
        var o = this && this.__awaiter || function(u, l, c, d) {
          function h(f) {
            return f instanceof c ? f : new c(function(p) {
              p(f);
            });
          }
          return new (c || (c = Promise))(function(f, p) {
            function m(g) {
              try {
                v(d.next(g));
              } catch (A) {
                p(A);
              }
            }
            function w(g) {
              try {
                v(d.throw(g));
              } catch (A) {
                p(A);
              }
            }
            function v(g) {
              g.done ? f(g.value) : h(g.value).then(m, w);
            }
            v((d = d.apply(u, l || [])).next());
          });
        }, s = this && this.__generator || function(u, l) {
          var c = { label: 0, sent: function() {
            if (f[0] & 1) throw f[1];
            return f[1];
          }, trys: [], ops: [] }, d, h, f, p;
          return p = { next: m(0), throw: m(1), return: m(2) }, typeof Symbol == "function" && (p[Symbol.iterator] = function() {
            return this;
          }), p;
          function m(v) {
            return function(g) {
              return w([v, g]);
            };
          }
          function w(v) {
            if (d) throw new TypeError("Generator is already executing.");
            for (; p && (p = 0, v[0] && (c = 0)), c; ) try {
              if (d = 1, h && (f = v[0] & 2 ? h.return : v[0] ? h.throw || ((f = h.return) && f.call(h), 0) : h.next) && !(f = f.call(h, v[1])).done) return f;
              switch (h = 0, f && (v = [v[0] & 2, f.value]), v[0]) {
                case 0:
                case 1:
                  f = v;
                  break;
                case 4:
                  return c.label++, { value: v[1], done: !1 };
                case 5:
                  c.label++, h = v[1], v = [0];
                  continue;
                case 7:
                  v = c.ops.pop(), c.trys.pop();
                  continue;
                default:
                  if (f = c.trys, !(f = f.length > 0 && f[f.length - 1]) && (v[0] === 6 || v[0] === 2)) {
                    c = 0;
                    continue;
                  }
                  if (v[0] === 3 && (!f || v[1] > f[0] && v[1] < f[3])) {
                    c.label = v[1];
                    break;
                  }
                  if (v[0] === 6 && c.label < f[1]) {
                    c.label = f[1], f = v;
                    break;
                  }
                  if (f && c.label < f[2]) {
                    c.label = f[2], c.ops.push(v);
                    break;
                  }
                  f[2] && c.ops.pop(), c.trys.pop();
                  continue;
              }
              v = l.call(u, c);
            } catch (g) {
              v = [6, g], h = 0;
            } finally {
              d = f = 0;
            }
            if (v[0] & 5) throw v[1];
            return { value: v[0] ? v[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(n, "__esModule", { value: !0 }), n.BrowserWebSocket = void 0;
        var a = (
          /** @class */
          (function() {
            function u(l) {
              l && (this.webSocket = l);
            }
            return u.prototype.connect = function(l) {
              return o(this, void 0, void 0, function() {
                var c, d;
                return s(this, function(h) {
                  return this.webSocket || (this.webSocket = new WebSocket(l)), this.webSocket.onerror = function(f) {
                    d(f);
                  }, this.webSocket.onopen = function(f) {
                    c(f);
                  }, [2, new Promise(function(f, p) {
                    c = f, d = p;
                  })];
                });
              });
            }, Object.defineProperty(u.prototype, "isConnected", {
              /**
               * Indicates if the [BrowserWebSocket's](xref:botframework-streaming.BrowserWebSocket) underlying websocket is currently connected.
               *
               * @returns `true` if the underlying websocket is ready and availble to send messages, otherwise `false`.
               */
              get: function() {
                return this.webSocket.readyState === 1;
              },
              enumerable: !1,
              configurable: !0
            }), u.prototype.write = function(l) {
              this.webSocket.send(l);
            }, u.prototype.close = function() {
              this.webSocket.close();
            }, u.prototype.setOnMessageHandler = function(l) {
              var c = "buffer", d = [];
              this.webSocket.onmessage = function(h) {
                var f = new FileReader(), p = { buffer: null };
                d.push(p), f.onload = function(m) {
                  var w = m.target;
                  if (p[c] = w.result, d[0] === p)
                    for (; 0 < d.length && d[0][c]; )
                      l(d[0][c]), d.splice(0, 1);
                }, f.readAsArrayBuffer(h.data);
              };
            }, u.prototype.setOnErrorHandler = function(l) {
              this.webSocket.onerror = function(c) {
                c && l(c);
              };
            }, u.prototype.setOnCloseHandler = function(l) {
              this.webSocket.onclose = l;
            }, u;
          })()
        );
        n.BrowserWebSocket = a;
      }, {}], 30: [function(r, i, n) {
        var o = this && this.__awaiter || function(f, p, m, w) {
          function v(g) {
            return g instanceof m ? g : new m(function(A) {
              A(g);
            });
          }
          return new (m || (m = Promise))(function(g, A) {
            function b(x) {
              try {
                y(w.next(x));
              } catch (C) {
                A(C);
              }
            }
            function k(x) {
              try {
                y(w.throw(x));
              } catch (C) {
                A(C);
              }
            }
            function y(x) {
              x.done ? g(x.value) : v(x.value).then(b, k);
            }
            y((w = w.apply(f, p || [])).next());
          });
        }, s = this && this.__generator || function(f, p) {
          var m = { label: 0, sent: function() {
            if (g[0] & 1) throw g[1];
            return g[1];
          }, trys: [], ops: [] }, w, v, g, A;
          return A = { next: b(0), throw: b(1), return: b(2) }, typeof Symbol == "function" && (A[Symbol.iterator] = function() {
            return this;
          }), A;
          function b(y) {
            return function(x) {
              return k([y, x]);
            };
          }
          function k(y) {
            if (w) throw new TypeError("Generator is already executing.");
            for (; A && (A = 0, y[0] && (m = 0)), m; ) try {
              if (w = 1, v && (g = y[0] & 2 ? v.return : y[0] ? v.throw || ((g = v.return) && g.call(v), 0) : v.next) && !(g = g.call(v, y[1])).done) return g;
              switch (v = 0, g && (y = [y[0] & 2, g.value]), y[0]) {
                case 0:
                case 1:
                  g = y;
                  break;
                case 4:
                  return m.label++, { value: y[1], done: !1 };
                case 5:
                  m.label++, v = y[1], y = [0];
                  continue;
                case 7:
                  y = m.ops.pop(), m.trys.pop();
                  continue;
                default:
                  if (g = m.trys, !(g = g.length > 0 && g[g.length - 1]) && (y[0] === 6 || y[0] === 2)) {
                    m = 0;
                    continue;
                  }
                  if (y[0] === 3 && (!g || y[1] > g[0] && y[1] < g[3])) {
                    m.label = y[1];
                    break;
                  }
                  if (y[0] === 6 && m.label < g[1]) {
                    m.label = g[1], g = y;
                    break;
                  }
                  if (g && m.label < g[2]) {
                    m.label = g[2], m.ops.push(y);
                    break;
                  }
                  g[2] && m.ops.pop(), m.trys.pop();
                  continue;
              }
              y = p.call(f, m);
            } catch (x) {
              y = [6, x], v = 0;
            } finally {
              w = g = 0;
            }
            if (y[0] & 5) throw y[1];
            return { value: y[0] ? y[1] : void 0, done: !0 };
          }
        };
        Object.defineProperty(n, "__esModule", { value: !0 }), n.WebSocketClient = void 0;
        var a = r("./browserWebSocket"), u = r("../payloadTransport"), l = r("../protocolAdapter"), c = r("../payloads"), d = r("./webSocketTransport"), h = (
          /** @class */
          (function() {
            function f(p) {
              var m = p.url, w = p.requestHandler, v = p.disconnectionHandler, g = v === void 0 ? null : v;
              this._url = m, this._requestHandler = w, this._disconnectionHandler = g, this._requestManager = new c.RequestManager(), this._sender = new u.PayloadSender(), this._sender.disconnected = this.onConnectionDisconnected.bind(this), this._receiver = new u.PayloadReceiver(), this._receiver.disconnected = this.onConnectionDisconnected.bind(this), this._protocolAdapter = new l.ProtocolAdapter(this._requestHandler, this._requestManager, this._sender, this._receiver);
            }
            return f.prototype.connect = function() {
              return o(this, void 0, void 0, function() {
                var p, m;
                return s(this, function(w) {
                  switch (w.label) {
                    case 0:
                      return p = new a.BrowserWebSocket(), [4, p.connect(this._url)];
                    case 1:
                      return w.sent(), m = new d.WebSocketTransport(p), this._sender.connect(m), this._receiver.connect(m), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, f.prototype.disconnect = function() {
              this._sender.disconnect(new u.TransportDisconnectedEvent("Disconnect was called.")), this._receiver.disconnect(new u.TransportDisconnectedEvent("Disconnect was called."));
            }, f.prototype.send = function(p) {
              return o(this, void 0, void 0, function() {
                return s(this, function(m) {
                  return [2, this._protocolAdapter.sendRequest(p)];
                });
              });
            }, f.prototype.onConnectionDisconnected = function(p, m) {
              if (this._requestManager.rejectAllResponses(new Error("Disconnect was called.")), this._disconnectionHandler != null) {
                this._disconnectionHandler("Disconnected");
                return;
              }
              throw new Error("Unable to re-connect client to transport for url ".concat(this._url, ". Sender: '").concat(JSON.stringify(p), "'. Args:' ").concat(JSON.stringify(m)));
            }, f;
          })()
        );
        n.WebSocketClient = h;
      }, { "../payloadTransport": 10, "../payloads": 16, "../protocolAdapter": 23, "./browserWebSocket": 29, "./webSocketTransport": 32 }], 31: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", { value: !0 }), n.WebSocketTransport = n.WebSocketClient = n.BrowserWebSocket = void 0;
        var o = r("./browserWebSocket");
        Object.defineProperty(n, "BrowserWebSocket", { enumerable: !0, get: function() {
          return o.BrowserWebSocket;
        } });
        var s = r("./browserWebSocketClient");
        Object.defineProperty(n, "WebSocketClient", { enumerable: !0, get: function() {
          return s.WebSocketClient;
        } });
        var a = r("./webSocketTransport");
        Object.defineProperty(n, "WebSocketTransport", { enumerable: !0, get: function() {
          return a.WebSocketTransport;
        } });
      }, { "./browserWebSocket": 29, "./browserWebSocketClient": 30, "./webSocketTransport": 32 }], 32: [function(r, i, n) {
        (function(o) {
          (function() {
            var s = this && this.__awaiter || function(l, c, d, h) {
              function f(p) {
                return p instanceof d ? p : new d(function(m) {
                  m(p);
                });
              }
              return new (d || (d = Promise))(function(p, m) {
                function w(A) {
                  try {
                    g(h.next(A));
                  } catch (b) {
                    m(b);
                  }
                }
                function v(A) {
                  try {
                    g(h.throw(A));
                  } catch (b) {
                    m(b);
                  }
                }
                function g(A) {
                  A.done ? p(A.value) : f(A.value).then(w, v);
                }
                g((h = h.apply(l, c || [])).next());
              });
            }, a = this && this.__generator || function(l, c) {
              var d = { label: 0, sent: function() {
                if (p[0] & 1) throw p[1];
                return p[1];
              }, trys: [], ops: [] }, h, f, p, m;
              return m = { next: w(0), throw: w(1), return: w(2) }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
                return this;
              }), m;
              function w(g) {
                return function(A) {
                  return v([g, A]);
                };
              }
              function v(g) {
                if (h) throw new TypeError("Generator is already executing.");
                for (; m && (m = 0, g[0] && (d = 0)), d; ) try {
                  if (h = 1, f && (p = g[0] & 2 ? f.return : g[0] ? f.throw || ((p = f.return) && p.call(f), 0) : f.next) && !(p = p.call(f, g[1])).done) return p;
                  switch (f = 0, p && (g = [g[0] & 2, p.value]), g[0]) {
                    case 0:
                    case 1:
                      p = g;
                      break;
                    case 4:
                      return d.label++, { value: g[1], done: !1 };
                    case 5:
                      d.label++, f = g[1], g = [0];
                      continue;
                    case 7:
                      g = d.ops.pop(), d.trys.pop();
                      continue;
                    default:
                      if (p = d.trys, !(p = p.length > 0 && p[p.length - 1]) && (g[0] === 6 || g[0] === 2)) {
                        d = 0;
                        continue;
                      }
                      if (g[0] === 3 && (!p || g[1] > p[0] && g[1] < p[3])) {
                        d.label = g[1];
                        break;
                      }
                      if (g[0] === 6 && d.label < p[1]) {
                        d.label = p[1], p = g;
                        break;
                      }
                      if (p && d.label < p[2]) {
                        d.label = p[2], d.ops.push(g);
                        break;
                      }
                      p[2] && d.ops.pop(), d.trys.pop();
                      continue;
                  }
                  g = c.call(l, d);
                } catch (A) {
                  g = [6, A], f = 0;
                } finally {
                  h = p = 0;
                }
                if (g[0] & 5) throw g[1];
                return { value: g[0] ? g[1] : void 0, done: !0 };
              }
            };
            Object.defineProperty(n, "__esModule", { value: !0 }), n.WebSocketTransport = void 0;
            var u = (
              /** @class */
              (function() {
                function l(c) {
                  var d = this;
                  this.ws = c, this._queue = [], this._activeOffset = 0, this._activeReceiveCount = 0, this.ws.setOnMessageHandler(function(h) {
                    d.onReceive(h);
                  }), this.ws.setOnErrorHandler(function(h) {
                    d.onError(h);
                  }), this.ws.setOnCloseHandler(function() {
                    d.onClose();
                  });
                }
                return l.prototype.send = function(c) {
                  var d;
                  return !((d = this.ws) === null || d === void 0) && d.isConnected ? (this.ws.write(c), c.length) : 0;
                }, Object.defineProperty(l.prototype, "isConnected", {
                  /**
                   * Returns true if the transport is connected to a socket.
                   *
                   * @returns `true` if the the transport is connected and ready to send data, `false` otherwise.
                   */
                  get: function() {
                    var c;
                    return !!(!((c = this.ws) === null || c === void 0) && c.isConnected);
                  },
                  enumerable: !1,
                  configurable: !0
                }), l.prototype.close = function() {
                  var c;
                  !((c = this.ws) === null || c === void 0) && c.isConnected && this.ws.close();
                }, l.prototype.receive = function(c) {
                  return s(this, void 0, void 0, function() {
                    var d, h = this;
                    return a(this, function(f) {
                      if (this._activeReceiveResolve)
                        throw new Error("Cannot call receive more than once before it has returned.");
                      return this._activeReceiveCount = c, d = new Promise(function(p, m) {
                        h._activeReceiveResolve = p, h._activeReceiveReject = m;
                      }), this.trySignalData(), [2, d];
                    });
                  });
                }, l.prototype.onReceive = function(c) {
                  this._queue && c && c.byteLength > 0 && (this._queue.push(o.from(c)), this.trySignalData());
                }, l.prototype.onClose = function() {
                  this._activeReceiveReject && this._activeReceiveReject(new Error("Socket was closed.")), this._active = null, this._activeOffset = 0, this._activeReceiveResolve = null, this._activeReceiveReject = null, this._activeReceiveCount = 0, this.ws = null;
                }, l.prototype.onError = function(c) {
                  this._activeReceiveReject && this._activeReceiveReject(c), this.onClose();
                }, l.prototype.trySignalData = function() {
                  if (this._activeReceiveResolve && (!this._active && this._queue.length > 0 && (this._active = this._queue.shift(), this._activeOffset = 0), this._active)) {
                    if (this._activeOffset === 0 && this._active.length === this._activeReceiveCount) {
                      var c = this._active;
                      this._active = null, this._activeReceiveResolve(c);
                    } else {
                      var d = Math.min(this._activeReceiveCount, this._active.length - this._activeOffset), c = o.alloc(d);
                      this._active.copy(c, 0, this._activeOffset, this._activeOffset + d), this._activeOffset += d, this._activeOffset >= this._active.length && (this._active = null, this._activeOffset = 0), this._activeReceiveResolve(c);
                    }
                    this._activeReceiveCount = 0, this._activeReceiveReject = null, this._activeReceiveResolve = null;
                  }
                }, l;
              })()
            );
            n.WebSocketTransport = u;
          }).call(this);
        }).call(this, r("buffer").Buffer);
      }, { buffer: 35 }], 33: [function(r, i, n) {
      }, {}], 34: [function(r, i, n) {
        n.byteLength = h, n.toByteArray = p, n.fromByteArray = v;
        for (var o = [], s = [], a = typeof Uint8Array < "u" ? Uint8Array : Array, u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", l = 0, c = u.length; l < c; ++l)
          o[l] = u[l], s[u.charCodeAt(l)] = l;
        s[45] = 62, s[95] = 63;
        function d(g) {
          var A = g.length;
          if (A % 4 > 0)
            throw new Error("Invalid string. Length must be a multiple of 4");
          var b = g.indexOf("=");
          b === -1 && (b = A);
          var k = b === A ? 0 : 4 - b % 4;
          return [b, k];
        }
        function h(g) {
          var A = d(g), b = A[0], k = A[1];
          return (b + k) * 3 / 4 - k;
        }
        function f(g, A, b) {
          return (A + b) * 3 / 4 - b;
        }
        function p(g) {
          var A, b = d(g), k = b[0], y = b[1], x = new a(f(g, k, y)), C = 0, I = y > 0 ? k - 4 : k, M;
          for (M = 0; M < I; M += 4)
            A = s[g.charCodeAt(M)] << 18 | s[g.charCodeAt(M + 1)] << 12 | s[g.charCodeAt(M + 2)] << 6 | s[g.charCodeAt(M + 3)], x[C++] = A >> 16 & 255, x[C++] = A >> 8 & 255, x[C++] = A & 255;
          return y === 2 && (A = s[g.charCodeAt(M)] << 2 | s[g.charCodeAt(M + 1)] >> 4, x[C++] = A & 255), y === 1 && (A = s[g.charCodeAt(M)] << 10 | s[g.charCodeAt(M + 1)] << 4 | s[g.charCodeAt(M + 2)] >> 2, x[C++] = A >> 8 & 255, x[C++] = A & 255), x;
        }
        function m(g) {
          return o[g >> 18 & 63] + o[g >> 12 & 63] + o[g >> 6 & 63] + o[g & 63];
        }
        function w(g, A, b) {
          for (var k, y = [], x = A; x < b; x += 3)
            k = (g[x] << 16 & 16711680) + (g[x + 1] << 8 & 65280) + (g[x + 2] & 255), y.push(m(k));
          return y.join("");
        }
        function v(g) {
          for (var A, b = g.length, k = b % 3, y = [], x = 16383, C = 0, I = b - k; C < I; C += x)
            y.push(w(
              g,
              C,
              C + x > I ? I : C + x
            ));
          return k === 1 ? (A = g[b - 1], y.push(
            o[A >> 2] + o[A << 4 & 63] + "=="
          )) : k === 2 && (A = (g[b - 2] << 8) + g[b - 1], y.push(
            o[A >> 10] + o[A >> 4 & 63] + o[A << 2 & 63] + "="
          )), y.join("");
        }
      }, {}], 35: [function(r, i, n) {
        (function(o) {
          (function() {
            var s = r("base64-js"), a = r("ieee754");
            n.Buffer = d, n.SlowBuffer = k, n.INSPECT_MAX_BYTES = 50;
            var u = 2147483647;
            n.kMaxLength = u, d.TYPED_ARRAY_SUPPORT = l(), !d.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
              "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
            );
            function l() {
              try {
                var D = new Uint8Array(1);
                return D.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
                  return 42;
                } }, D.foo() === 42;
              } catch {
                return !1;
              }
            }
            Object.defineProperty(d.prototype, "parent", {
              enumerable: !0,
              get: function() {
                if (d.isBuffer(this))
                  return this.buffer;
              }
            }), Object.defineProperty(d.prototype, "offset", {
              enumerable: !0,
              get: function() {
                if (d.isBuffer(this))
                  return this.byteOffset;
              }
            });
            function c(D) {
              if (D > u)
                throw new RangeError('The value "' + D + '" is invalid for option "size"');
              var E = new Uint8Array(D);
              return E.__proto__ = d.prototype, E;
            }
            function d(D, E, T) {
              if (typeof D == "number") {
                if (typeof E == "string")
                  throw new TypeError(
                    'The "string" argument must be of type string. Received type number'
                  );
                return m(D);
              }
              return h(D, E, T);
            }
            typeof Symbol < "u" && Symbol.species != null && d[Symbol.species] === d && Object.defineProperty(d, Symbol.species, {
              value: null,
              configurable: !0,
              enumerable: !1,
              writable: !1
            }), d.poolSize = 8192;
            function h(D, E, T) {
              if (typeof D == "string")
                return w(D, E);
              if (ArrayBuffer.isView(D))
                return v(D);
              if (D == null)
                throw TypeError(
                  "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof D
                );
              if (L(D, ArrayBuffer) || D && L(D.buffer, ArrayBuffer))
                return g(D, E, T);
              if (typeof D == "number")
                throw new TypeError(
                  'The "value" argument must not be of type number. Received type number'
                );
              var j = D.valueOf && D.valueOf();
              if (j != null && j !== D)
                return d.from(j, E, T);
              var Y = A(D);
              if (Y) return Y;
              if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof D[Symbol.toPrimitive] == "function")
                return d.from(
                  D[Symbol.toPrimitive]("string"),
                  E,
                  T
                );
              throw new TypeError(
                "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof D
              );
            }
            d.from = function(D, E, T) {
              return h(D, E, T);
            }, d.prototype.__proto__ = Uint8Array.prototype, d.__proto__ = Uint8Array;
            function f(D) {
              if (typeof D != "number")
                throw new TypeError('"size" argument must be of type number');
              if (D < 0)
                throw new RangeError('The value "' + D + '" is invalid for option "size"');
            }
            function p(D, E, T) {
              return f(D), D <= 0 ? c(D) : E !== void 0 ? typeof T == "string" ? c(D).fill(E, T) : c(D).fill(E) : c(D);
            }
            d.alloc = function(D, E, T) {
              return p(D, E, T);
            };
            function m(D) {
              return f(D), c(D < 0 ? 0 : b(D) | 0);
            }
            d.allocUnsafe = function(D) {
              return m(D);
            }, d.allocUnsafeSlow = function(D) {
              return m(D);
            };
            function w(D, E) {
              if ((typeof E != "string" || E === "") && (E = "utf8"), !d.isEncoding(E))
                throw new TypeError("Unknown encoding: " + E);
              var T = y(D, E) | 0, j = c(T), Y = j.write(D, E);
              return Y !== T && (j = j.slice(0, Y)), j;
            }
            function v(D) {
              for (var E = D.length < 0 ? 0 : b(D.length) | 0, T = c(E), j = 0; j < E; j += 1)
                T[j] = D[j] & 255;
              return T;
            }
            function g(D, E, T) {
              if (E < 0 || D.byteLength < E)
                throw new RangeError('"offset" is outside of buffer bounds');
              if (D.byteLength < E + (T || 0))
                throw new RangeError('"length" is outside of buffer bounds');
              var j;
              return E === void 0 && T === void 0 ? j = new Uint8Array(D) : T === void 0 ? j = new Uint8Array(D, E) : j = new Uint8Array(D, E, T), j.__proto__ = d.prototype, j;
            }
            function A(D) {
              if (d.isBuffer(D)) {
                var E = b(D.length) | 0, T = c(E);
                return T.length === 0 || D.copy(T, 0, 0, E), T;
              }
              if (D.length !== void 0)
                return typeof D.length != "number" || B(D.length) ? c(0) : v(D);
              if (D.type === "Buffer" && Array.isArray(D.data))
                return v(D.data);
            }
            function b(D) {
              if (D >= u)
                throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + u.toString(16) + " bytes");
              return D | 0;
            }
            function k(D) {
              return +D != D && (D = 0), d.alloc(+D);
            }
            d.isBuffer = function(E) {
              return E != null && E._isBuffer === !0 && E !== d.prototype;
            }, d.compare = function(E, T) {
              if (L(E, Uint8Array) && (E = d.from(E, E.offset, E.byteLength)), L(T, Uint8Array) && (T = d.from(T, T.offset, T.byteLength)), !d.isBuffer(E) || !d.isBuffer(T))
                throw new TypeError(
                  'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
                );
              if (E === T) return 0;
              for (var j = E.length, Y = T.length, ae = 0, se = Math.min(j, Y); ae < se; ++ae)
                if (E[ae] !== T[ae]) {
                  j = E[ae], Y = T[ae];
                  break;
                }
              return j < Y ? -1 : Y < j ? 1 : 0;
            }, d.isEncoding = function(E) {
              switch (String(E).toLowerCase()) {
                case "hex":
                case "utf8":
                case "utf-8":
                case "ascii":
                case "latin1":
                case "binary":
                case "base64":
                case "ucs2":
                case "ucs-2":
                case "utf16le":
                case "utf-16le":
                  return !0;
                default:
                  return !1;
              }
            }, d.concat = function(E, T) {
              if (!Array.isArray(E))
                throw new TypeError('"list" argument must be an Array of Buffers');
              if (E.length === 0)
                return d.alloc(0);
              var j;
              if (T === void 0)
                for (T = 0, j = 0; j < E.length; ++j)
                  T += E[j].length;
              var Y = d.allocUnsafe(T), ae = 0;
              for (j = 0; j < E.length; ++j) {
                var se = E[j];
                if (L(se, Uint8Array) && (se = d.from(se)), !d.isBuffer(se))
                  throw new TypeError('"list" argument must be an Array of Buffers');
                se.copy(Y, ae), ae += se.length;
              }
              return Y;
            };
            function y(D, E) {
              if (d.isBuffer(D))
                return D.length;
              if (ArrayBuffer.isView(D) || L(D, ArrayBuffer))
                return D.byteLength;
              if (typeof D != "string")
                throw new TypeError(
                  'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof D
                );
              var T = D.length, j = arguments.length > 2 && arguments[2] === !0;
              if (!j && T === 0) return 0;
              for (var Y = !1; ; )
                switch (E) {
                  case "ascii":
                  case "latin1":
                  case "binary":
                    return T;
                  case "utf8":
                  case "utf-8":
                    return te(D).length;
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return T * 2;
                  case "hex":
                    return T >>> 1;
                  case "base64":
                    return pe(D).length;
                  default:
                    if (Y)
                      return j ? -1 : te(D).length;
                    E = ("" + E).toLowerCase(), Y = !0;
                }
            }
            d.byteLength = y;
            function x(D, E, T) {
              var j = !1;
              if ((E === void 0 || E < 0) && (E = 0), E > this.length || ((T === void 0 || T > this.length) && (T = this.length), T <= 0) || (T >>>= 0, E >>>= 0, T <= E))
                return "";
              for (D || (D = "utf8"); ; )
                switch (D) {
                  case "hex":
                    return oe(this, E, T);
                  case "utf8":
                  case "utf-8":
                    return X(this, E, T);
                  case "ascii":
                    return G(this, E, T);
                  case "latin1":
                  case "binary":
                    return re(this, E, T);
                  case "base64":
                    return V(this, E, T);
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return ie(this, E, T);
                  default:
                    if (j) throw new TypeError("Unknown encoding: " + D);
                    D = (D + "").toLowerCase(), j = !0;
                }
            }
            d.prototype._isBuffer = !0;
            function C(D, E, T) {
              var j = D[E];
              D[E] = D[T], D[T] = j;
            }
            d.prototype.swap16 = function() {
              var E = this.length;
              if (E % 2 !== 0)
                throw new RangeError("Buffer size must be a multiple of 16-bits");
              for (var T = 0; T < E; T += 2)
                C(this, T, T + 1);
              return this;
            }, d.prototype.swap32 = function() {
              var E = this.length;
              if (E % 4 !== 0)
                throw new RangeError("Buffer size must be a multiple of 32-bits");
              for (var T = 0; T < E; T += 4)
                C(this, T, T + 3), C(this, T + 1, T + 2);
              return this;
            }, d.prototype.swap64 = function() {
              var E = this.length;
              if (E % 8 !== 0)
                throw new RangeError("Buffer size must be a multiple of 64-bits");
              for (var T = 0; T < E; T += 8)
                C(this, T, T + 7), C(this, T + 1, T + 6), C(this, T + 2, T + 5), C(this, T + 3, T + 4);
              return this;
            }, d.prototype.toString = function() {
              var E = this.length;
              return E === 0 ? "" : arguments.length === 0 ? X(this, 0, E) : x.apply(this, arguments);
            }, d.prototype.toLocaleString = d.prototype.toString, d.prototype.equals = function(E) {
              if (!d.isBuffer(E)) throw new TypeError("Argument must be a Buffer");
              return this === E ? !0 : d.compare(this, E) === 0;
            }, d.prototype.inspect = function() {
              var E = "", T = n.INSPECT_MAX_BYTES;
              return E = this.toString("hex", 0, T).replace(/(.{2})/g, "$1 ").trim(), this.length > T && (E += " ... "), "<Buffer " + E + ">";
            }, d.prototype.compare = function(E, T, j, Y, ae) {
              if (L(E, Uint8Array) && (E = d.from(E, E.offset, E.byteLength)), !d.isBuffer(E))
                throw new TypeError(
                  'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof E
                );
              if (T === void 0 && (T = 0), j === void 0 && (j = E ? E.length : 0), Y === void 0 && (Y = 0), ae === void 0 && (ae = this.length), T < 0 || j > E.length || Y < 0 || ae > this.length)
                throw new RangeError("out of range index");
              if (Y >= ae && T >= j)
                return 0;
              if (Y >= ae)
                return -1;
              if (T >= j)
                return 1;
              if (T >>>= 0, j >>>= 0, Y >>>= 0, ae >>>= 0, this === E) return 0;
              for (var se = ae - Y, O = j - T, _ = Math.min(se, O), S = this.slice(Y, ae), F = E.slice(T, j), $ = 0; $ < _; ++$)
                if (S[$] !== F[$]) {
                  se = S[$], O = F[$];
                  break;
                }
              return se < O ? -1 : O < se ? 1 : 0;
            };
            function I(D, E, T, j, Y) {
              if (D.length === 0) return -1;
              if (typeof T == "string" ? (j = T, T = 0) : T > 2147483647 ? T = 2147483647 : T < -2147483648 && (T = -2147483648), T = +T, B(T) && (T = Y ? 0 : D.length - 1), T < 0 && (T = D.length + T), T >= D.length) {
                if (Y) return -1;
                T = D.length - 1;
              } else if (T < 0)
                if (Y) T = 0;
                else return -1;
              if (typeof E == "string" && (E = d.from(E, j)), d.isBuffer(E))
                return E.length === 0 ? -1 : M(D, E, T, j, Y);
              if (typeof E == "number")
                return E = E & 255, typeof Uint8Array.prototype.indexOf == "function" ? Y ? Uint8Array.prototype.indexOf.call(D, E, T) : Uint8Array.prototype.lastIndexOf.call(D, E, T) : M(D, [E], T, j, Y);
              throw new TypeError("val must be string, number or Buffer");
            }
            function M(D, E, T, j, Y) {
              var ae = 1, se = D.length, O = E.length;
              if (j !== void 0 && (j = String(j).toLowerCase(), j === "ucs2" || j === "ucs-2" || j === "utf16le" || j === "utf-16le")) {
                if (D.length < 2 || E.length < 2)
                  return -1;
                ae = 2, se /= 2, O /= 2, T /= 2;
              }
              function _(ee, de) {
                return ae === 1 ? ee[de] : ee.readUInt16BE(de * ae);
              }
              var S;
              if (Y) {
                var F = -1;
                for (S = T; S < se; S++)
                  if (_(D, S) === _(E, F === -1 ? 0 : S - F)) {
                    if (F === -1 && (F = S), S - F + 1 === O) return F * ae;
                  } else
                    F !== -1 && (S -= S - F), F = -1;
              } else
                for (T + O > se && (T = se - O), S = T; S >= 0; S--) {
                  for (var $ = !0, K = 0; K < O; K++)
                    if (_(D, S + K) !== _(E, K)) {
                      $ = !1;
                      break;
                    }
                  if ($) return S;
                }
              return -1;
            }
            d.prototype.includes = function(E, T, j) {
              return this.indexOf(E, T, j) !== -1;
            }, d.prototype.indexOf = function(E, T, j) {
              return I(this, E, T, j, !0);
            }, d.prototype.lastIndexOf = function(E, T, j) {
              return I(this, E, T, j, !1);
            };
            function Q(D, E, T, j) {
              T = Number(T) || 0;
              var Y = D.length - T;
              j ? (j = Number(j), j > Y && (j = Y)) : j = Y;
              var ae = E.length;
              j > ae / 2 && (j = ae / 2);
              for (var se = 0; se < j; ++se) {
                var O = parseInt(E.substr(se * 2, 2), 16);
                if (B(O)) return se;
                D[T + se] = O;
              }
              return se;
            }
            function H(D, E, T, j) {
              return me(te(E, D.length - T), D, T, j);
            }
            function J(D, E, T, j) {
              return me(Z(E), D, T, j);
            }
            function W(D, E, T, j) {
              return J(D, E, T, j);
            }
            function P(D, E, T, j) {
              return me(pe(E), D, T, j);
            }
            function R(D, E, T, j) {
              return me(ue(E, D.length - T), D, T, j);
            }
            d.prototype.write = function(E, T, j, Y) {
              if (T === void 0)
                Y = "utf8", j = this.length, T = 0;
              else if (j === void 0 && typeof T == "string")
                Y = T, j = this.length, T = 0;
              else if (isFinite(T))
                T = T >>> 0, isFinite(j) ? (j = j >>> 0, Y === void 0 && (Y = "utf8")) : (Y = j, j = void 0);
              else
                throw new Error(
                  "Buffer.write(string, encoding, offset[, length]) is no longer supported"
                );
              var ae = this.length - T;
              if ((j === void 0 || j > ae) && (j = ae), E.length > 0 && (j < 0 || T < 0) || T > this.length)
                throw new RangeError("Attempt to write outside buffer bounds");
              Y || (Y = "utf8");
              for (var se = !1; ; )
                switch (Y) {
                  case "hex":
                    return Q(this, E, T, j);
                  case "utf8":
                  case "utf-8":
                    return H(this, E, T, j);
                  case "ascii":
                    return J(this, E, T, j);
                  case "latin1":
                  case "binary":
                    return W(this, E, T, j);
                  case "base64":
                    return P(this, E, T, j);
                  case "ucs2":
                  case "ucs-2":
                  case "utf16le":
                  case "utf-16le":
                    return R(this, E, T, j);
                  default:
                    if (se) throw new TypeError("Unknown encoding: " + Y);
                    Y = ("" + Y).toLowerCase(), se = !0;
                }
            }, d.prototype.toJSON = function() {
              return {
                type: "Buffer",
                data: Array.prototype.slice.call(this._arr || this, 0)
              };
            };
            function V(D, E, T) {
              return E === 0 && T === D.length ? s.fromByteArray(D) : s.fromByteArray(D.slice(E, T));
            }
            function X(D, E, T) {
              T = Math.min(D.length, T);
              for (var j = [], Y = E; Y < T; ) {
                var ae = D[Y], se = null, O = ae > 239 ? 4 : ae > 223 ? 3 : ae > 191 ? 2 : 1;
                if (Y + O <= T) {
                  var _, S, F, $;
                  switch (O) {
                    case 1:
                      ae < 128 && (se = ae);
                      break;
                    case 2:
                      _ = D[Y + 1], (_ & 192) === 128 && ($ = (ae & 31) << 6 | _ & 63, $ > 127 && (se = $));
                      break;
                    case 3:
                      _ = D[Y + 1], S = D[Y + 2], (_ & 192) === 128 && (S & 192) === 128 && ($ = (ae & 15) << 12 | (_ & 63) << 6 | S & 63, $ > 2047 && ($ < 55296 || $ > 57343) && (se = $));
                      break;
                    case 4:
                      _ = D[Y + 1], S = D[Y + 2], F = D[Y + 3], (_ & 192) === 128 && (S & 192) === 128 && (F & 192) === 128 && ($ = (ae & 15) << 18 | (_ & 63) << 12 | (S & 63) << 6 | F & 63, $ > 65535 && $ < 1114112 && (se = $));
                  }
                }
                se === null ? (se = 65533, O = 1) : se > 65535 && (se -= 65536, j.push(se >>> 10 & 1023 | 55296), se = 56320 | se & 1023), j.push(se), Y += O;
              }
              return U(j);
            }
            var N = 4096;
            function U(D) {
              var E = D.length;
              if (E <= N)
                return String.fromCharCode.apply(String, D);
              for (var T = "", j = 0; j < E; )
                T += String.fromCharCode.apply(
                  String,
                  D.slice(j, j += N)
                );
              return T;
            }
            function G(D, E, T) {
              var j = "";
              T = Math.min(D.length, T);
              for (var Y = E; Y < T; ++Y)
                j += String.fromCharCode(D[Y] & 127);
              return j;
            }
            function re(D, E, T) {
              var j = "";
              T = Math.min(D.length, T);
              for (var Y = E; Y < T; ++Y)
                j += String.fromCharCode(D[Y]);
              return j;
            }
            function oe(D, E, T) {
              var j = D.length;
              (!E || E < 0) && (E = 0), (!T || T < 0 || T > j) && (T = j);
              for (var Y = "", ae = E; ae < T; ++ae)
                Y += De(D[ae]);
              return Y;
            }
            function ie(D, E, T) {
              for (var j = D.slice(E, T), Y = "", ae = 0; ae < j.length; ae += 2)
                Y += String.fromCharCode(j[ae] + j[ae + 1] * 256);
              return Y;
            }
            d.prototype.slice = function(E, T) {
              var j = this.length;
              E = ~~E, T = T === void 0 ? j : ~~T, E < 0 ? (E += j, E < 0 && (E = 0)) : E > j && (E = j), T < 0 ? (T += j, T < 0 && (T = 0)) : T > j && (T = j), T < E && (T = E);
              var Y = this.subarray(E, T);
              return Y.__proto__ = d.prototype, Y;
            };
            function le(D, E, T) {
              if (D % 1 !== 0 || D < 0) throw new RangeError("offset is not uint");
              if (D + E > T) throw new RangeError("Trying to access beyond buffer length");
            }
            d.prototype.readUIntLE = function(E, T, j) {
              E = E >>> 0, T = T >>> 0, j || le(E, T, this.length);
              for (var Y = this[E], ae = 1, se = 0; ++se < T && (ae *= 256); )
                Y += this[E + se] * ae;
              return Y;
            }, d.prototype.readUIntBE = function(E, T, j) {
              E = E >>> 0, T = T >>> 0, j || le(E, T, this.length);
              for (var Y = this[E + --T], ae = 1; T > 0 && (ae *= 256); )
                Y += this[E + --T] * ae;
              return Y;
            }, d.prototype.readUInt8 = function(E, T) {
              return E = E >>> 0, T || le(E, 1, this.length), this[E];
            }, d.prototype.readUInt16LE = function(E, T) {
              return E = E >>> 0, T || le(E, 2, this.length), this[E] | this[E + 1] << 8;
            }, d.prototype.readUInt16BE = function(E, T) {
              return E = E >>> 0, T || le(E, 2, this.length), this[E] << 8 | this[E + 1];
            }, d.prototype.readUInt32LE = function(E, T) {
              return E = E >>> 0, T || le(E, 4, this.length), (this[E] | this[E + 1] << 8 | this[E + 2] << 16) + this[E + 3] * 16777216;
            }, d.prototype.readUInt32BE = function(E, T) {
              return E = E >>> 0, T || le(E, 4, this.length), this[E] * 16777216 + (this[E + 1] << 16 | this[E + 2] << 8 | this[E + 3]);
            }, d.prototype.readIntLE = function(E, T, j) {
              E = E >>> 0, T = T >>> 0, j || le(E, T, this.length);
              for (var Y = this[E], ae = 1, se = 0; ++se < T && (ae *= 256); )
                Y += this[E + se] * ae;
              return ae *= 128, Y >= ae && (Y -= Math.pow(2, 8 * T)), Y;
            }, d.prototype.readIntBE = function(E, T, j) {
              E = E >>> 0, T = T >>> 0, j || le(E, T, this.length);
              for (var Y = T, ae = 1, se = this[E + --Y]; Y > 0 && (ae *= 256); )
                se += this[E + --Y] * ae;
              return ae *= 128, se >= ae && (se -= Math.pow(2, 8 * T)), se;
            }, d.prototype.readInt8 = function(E, T) {
              return E = E >>> 0, T || le(E, 1, this.length), this[E] & 128 ? (255 - this[E] + 1) * -1 : this[E];
            }, d.prototype.readInt16LE = function(E, T) {
              E = E >>> 0, T || le(E, 2, this.length);
              var j = this[E] | this[E + 1] << 8;
              return j & 32768 ? j | 4294901760 : j;
            }, d.prototype.readInt16BE = function(E, T) {
              E = E >>> 0, T || le(E, 2, this.length);
              var j = this[E + 1] | this[E] << 8;
              return j & 32768 ? j | 4294901760 : j;
            }, d.prototype.readInt32LE = function(E, T) {
              return E = E >>> 0, T || le(E, 4, this.length), this[E] | this[E + 1] << 8 | this[E + 2] << 16 | this[E + 3] << 24;
            }, d.prototype.readInt32BE = function(E, T) {
              return E = E >>> 0, T || le(E, 4, this.length), this[E] << 24 | this[E + 1] << 16 | this[E + 2] << 8 | this[E + 3];
            }, d.prototype.readFloatLE = function(E, T) {
              return E = E >>> 0, T || le(E, 4, this.length), a.read(this, E, !0, 23, 4);
            }, d.prototype.readFloatBE = function(E, T) {
              return E = E >>> 0, T || le(E, 4, this.length), a.read(this, E, !1, 23, 4);
            }, d.prototype.readDoubleLE = function(E, T) {
              return E = E >>> 0, T || le(E, 8, this.length), a.read(this, E, !0, 52, 8);
            }, d.prototype.readDoubleBE = function(E, T) {
              return E = E >>> 0, T || le(E, 8, this.length), a.read(this, E, !1, 52, 8);
            };
            function he(D, E, T, j, Y, ae) {
              if (!d.isBuffer(D)) throw new TypeError('"buffer" argument must be a Buffer instance');
              if (E > Y || E < ae) throw new RangeError('"value" argument is out of bounds');
              if (T + j > D.length) throw new RangeError("Index out of range");
            }
            d.prototype.writeUIntLE = function(E, T, j, Y) {
              if (E = +E, T = T >>> 0, j = j >>> 0, !Y) {
                var ae = Math.pow(2, 8 * j) - 1;
                he(this, E, T, j, ae, 0);
              }
              var se = 1, O = 0;
              for (this[T] = E & 255; ++O < j && (se *= 256); )
                this[T + O] = E / se & 255;
              return T + j;
            }, d.prototype.writeUIntBE = function(E, T, j, Y) {
              if (E = +E, T = T >>> 0, j = j >>> 0, !Y) {
                var ae = Math.pow(2, 8 * j) - 1;
                he(this, E, T, j, ae, 0);
              }
              var se = j - 1, O = 1;
              for (this[T + se] = E & 255; --se >= 0 && (O *= 256); )
                this[T + se] = E / O & 255;
              return T + j;
            }, d.prototype.writeUInt8 = function(E, T, j) {
              return E = +E, T = T >>> 0, j || he(this, E, T, 1, 255, 0), this[T] = E & 255, T + 1;
            }, d.prototype.writeUInt16LE = function(E, T, j) {
              return E = +E, T = T >>> 0, j || he(this, E, T, 2, 65535, 0), this[T] = E & 255, this[T + 1] = E >>> 8, T + 2;
            }, d.prototype.writeUInt16BE = function(E, T, j) {
              return E = +E, T = T >>> 0, j || he(this, E, T, 2, 65535, 0), this[T] = E >>> 8, this[T + 1] = E & 255, T + 2;
            }, d.prototype.writeUInt32LE = function(E, T, j) {
              return E = +E, T = T >>> 0, j || he(this, E, T, 4, 4294967295, 0), this[T + 3] = E >>> 24, this[T + 2] = E >>> 16, this[T + 1] = E >>> 8, this[T] = E & 255, T + 4;
            }, d.prototype.writeUInt32BE = function(E, T, j) {
              return E = +E, T = T >>> 0, j || he(this, E, T, 4, 4294967295, 0), this[T] = E >>> 24, this[T + 1] = E >>> 16, this[T + 2] = E >>> 8, this[T + 3] = E & 255, T + 4;
            }, d.prototype.writeIntLE = function(E, T, j, Y) {
              if (E = +E, T = T >>> 0, !Y) {
                var ae = Math.pow(2, 8 * j - 1);
                he(this, E, T, j, ae - 1, -ae);
              }
              var se = 0, O = 1, _ = 0;
              for (this[T] = E & 255; ++se < j && (O *= 256); )
                E < 0 && _ === 0 && this[T + se - 1] !== 0 && (_ = 1), this[T + se] = (E / O >> 0) - _ & 255;
              return T + j;
            }, d.prototype.writeIntBE = function(E, T, j, Y) {
              if (E = +E, T = T >>> 0, !Y) {
                var ae = Math.pow(2, 8 * j - 1);
                he(this, E, T, j, ae - 1, -ae);
              }
              var se = j - 1, O = 1, _ = 0;
              for (this[T + se] = E & 255; --se >= 0 && (O *= 256); )
                E < 0 && _ === 0 && this[T + se + 1] !== 0 && (_ = 1), this[T + se] = (E / O >> 0) - _ & 255;
              return T + j;
            }, d.prototype.writeInt8 = function(E, T, j) {
              return E = +E, T = T >>> 0, j || he(this, E, T, 1, 127, -128), E < 0 && (E = 255 + E + 1), this[T] = E & 255, T + 1;
            }, d.prototype.writeInt16LE = function(E, T, j) {
              return E = +E, T = T >>> 0, j || he(this, E, T, 2, 32767, -32768), this[T] = E & 255, this[T + 1] = E >>> 8, T + 2;
            }, d.prototype.writeInt16BE = function(E, T, j) {
              return E = +E, T = T >>> 0, j || he(this, E, T, 2, 32767, -32768), this[T] = E >>> 8, this[T + 1] = E & 255, T + 2;
            }, d.prototype.writeInt32LE = function(E, T, j) {
              return E = +E, T = T >>> 0, j || he(this, E, T, 4, 2147483647, -2147483648), this[T] = E & 255, this[T + 1] = E >>> 8, this[T + 2] = E >>> 16, this[T + 3] = E >>> 24, T + 4;
            }, d.prototype.writeInt32BE = function(E, T, j) {
              return E = +E, T = T >>> 0, j || he(this, E, T, 4, 2147483647, -2147483648), E < 0 && (E = 4294967295 + E + 1), this[T] = E >>> 24, this[T + 1] = E >>> 16, this[T + 2] = E >>> 8, this[T + 3] = E & 255, T + 4;
            };
            function ye(D, E, T, j, Y, ae) {
              if (T + j > D.length) throw new RangeError("Index out of range");
              if (T < 0) throw new RangeError("Index out of range");
            }
            function be(D, E, T, j, Y) {
              return E = +E, T = T >>> 0, Y || ye(D, E, T, 4), a.write(D, E, T, j, 23, 4), T + 4;
            }
            d.prototype.writeFloatLE = function(E, T, j) {
              return be(this, E, T, !0, j);
            }, d.prototype.writeFloatBE = function(E, T, j) {
              return be(this, E, T, !1, j);
            };
            function we(D, E, T, j, Y) {
              return E = +E, T = T >>> 0, Y || ye(D, E, T, 8), a.write(D, E, T, j, 52, 8), T + 8;
            }
            d.prototype.writeDoubleLE = function(E, T, j) {
              return we(this, E, T, !0, j);
            }, d.prototype.writeDoubleBE = function(E, T, j) {
              return we(this, E, T, !1, j);
            }, d.prototype.copy = function(E, T, j, Y) {
              if (!d.isBuffer(E)) throw new TypeError("argument should be a Buffer");
              if (j || (j = 0), !Y && Y !== 0 && (Y = this.length), T >= E.length && (T = E.length), T || (T = 0), Y > 0 && Y < j && (Y = j), Y === j || E.length === 0 || this.length === 0) return 0;
              if (T < 0)
                throw new RangeError("targetStart out of bounds");
              if (j < 0 || j >= this.length) throw new RangeError("Index out of range");
              if (Y < 0) throw new RangeError("sourceEnd out of bounds");
              Y > this.length && (Y = this.length), E.length - T < Y - j && (Y = E.length - T + j);
              var ae = Y - j;
              if (this === E && typeof Uint8Array.prototype.copyWithin == "function")
                this.copyWithin(T, j, Y);
              else if (this === E && j < T && T < Y)
                for (var se = ae - 1; se >= 0; --se)
                  E[se + T] = this[se + j];
              else
                Uint8Array.prototype.set.call(
                  E,
                  this.subarray(j, Y),
                  T
                );
              return ae;
            }, d.prototype.fill = function(E, T, j, Y) {
              if (typeof E == "string") {
                if (typeof T == "string" ? (Y = T, T = 0, j = this.length) : typeof j == "string" && (Y = j, j = this.length), Y !== void 0 && typeof Y != "string")
                  throw new TypeError("encoding must be a string");
                if (typeof Y == "string" && !d.isEncoding(Y))
                  throw new TypeError("Unknown encoding: " + Y);
                if (E.length === 1) {
                  var ae = E.charCodeAt(0);
                  (Y === "utf8" && ae < 128 || Y === "latin1") && (E = ae);
                }
              } else typeof E == "number" && (E = E & 255);
              if (T < 0 || this.length < T || this.length < j)
                throw new RangeError("Out of range index");
              if (j <= T)
                return this;
              T = T >>> 0, j = j === void 0 ? this.length : j >>> 0, E || (E = 0);
              var se;
              if (typeof E == "number")
                for (se = T; se < j; ++se)
                  this[se] = E;
              else {
                var O = d.isBuffer(E) ? E : d.from(E, Y), _ = O.length;
                if (_ === 0)
                  throw new TypeError('The value "' + E + '" is invalid for argument "value"');
                for (se = 0; se < j - T; ++se)
                  this[se + T] = O[se % _];
              }
              return this;
            };
            var ve = /[^+/0-9A-Za-z-_]/g;
            function Re(D) {
              if (D = D.split("=")[0], D = D.trim().replace(ve, ""), D.length < 2) return "";
              for (; D.length % 4 !== 0; )
                D = D + "=";
              return D;
            }
            function De(D) {
              return D < 16 ? "0" + D.toString(16) : D.toString(16);
            }
            function te(D, E) {
              E = E || 1 / 0;
              for (var T, j = D.length, Y = null, ae = [], se = 0; se < j; ++se) {
                if (T = D.charCodeAt(se), T > 55295 && T < 57344) {
                  if (!Y) {
                    if (T > 56319) {
                      (E -= 3) > -1 && ae.push(239, 191, 189);
                      continue;
                    } else if (se + 1 === j) {
                      (E -= 3) > -1 && ae.push(239, 191, 189);
                      continue;
                    }
                    Y = T;
                    continue;
                  }
                  if (T < 56320) {
                    (E -= 3) > -1 && ae.push(239, 191, 189), Y = T;
                    continue;
                  }
                  T = (Y - 55296 << 10 | T - 56320) + 65536;
                } else Y && (E -= 3) > -1 && ae.push(239, 191, 189);
                if (Y = null, T < 128) {
                  if ((E -= 1) < 0) break;
                  ae.push(T);
                } else if (T < 2048) {
                  if ((E -= 2) < 0) break;
                  ae.push(
                    T >> 6 | 192,
                    T & 63 | 128
                  );
                } else if (T < 65536) {
                  if ((E -= 3) < 0) break;
                  ae.push(
                    T >> 12 | 224,
                    T >> 6 & 63 | 128,
                    T & 63 | 128
                  );
                } else if (T < 1114112) {
                  if ((E -= 4) < 0) break;
                  ae.push(
                    T >> 18 | 240,
                    T >> 12 & 63 | 128,
                    T >> 6 & 63 | 128,
                    T & 63 | 128
                  );
                } else
                  throw new Error("Invalid code point");
              }
              return ae;
            }
            function Z(D) {
              for (var E = [], T = 0; T < D.length; ++T)
                E.push(D.charCodeAt(T) & 255);
              return E;
            }
            function ue(D, E) {
              for (var T, j, Y, ae = [], se = 0; se < D.length && !((E -= 2) < 0); ++se)
                T = D.charCodeAt(se), j = T >> 8, Y = T % 256, ae.push(Y), ae.push(j);
              return ae;
            }
            function pe(D) {
              return s.toByteArray(Re(D));
            }
            function me(D, E, T, j) {
              for (var Y = 0; Y < j && !(Y + T >= E.length || Y >= D.length); ++Y)
                E[Y + T] = D[Y];
              return Y;
            }
            function L(D, E) {
              return D instanceof E || D != null && D.constructor != null && D.constructor.name != null && D.constructor.name === E.name;
            }
            function B(D) {
              return D !== D;
            }
          }).call(this);
        }).call(this, r("buffer").Buffer);
      }, { "base64-js": 34, buffer: 35, ieee754: 37 }], 36: [function(r, i, n) {
        var o = typeof Reflect == "object" ? Reflect : null, s = o && typeof o.apply == "function" ? o.apply : function(C, I, M) {
          return Function.prototype.apply.call(C, I, M);
        }, a;
        o && typeof o.ownKeys == "function" ? a = o.ownKeys : Object.getOwnPropertySymbols ? a = function(C) {
          return Object.getOwnPropertyNames(C).concat(Object.getOwnPropertySymbols(C));
        } : a = function(C) {
          return Object.getOwnPropertyNames(C);
        };
        function u(x) {
          console && console.warn && console.warn(x);
        }
        var l = Number.isNaN || function(C) {
          return C !== C;
        };
        function c() {
          c.init.call(this);
        }
        i.exports = c, i.exports.once = y, c.EventEmitter = c, c.prototype._events = void 0, c.prototype._eventsCount = 0, c.prototype._maxListeners = void 0;
        var d = 10;
        function h(x) {
          if (typeof x != "function")
            throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof x);
        }
        Object.defineProperty(c, "defaultMaxListeners", {
          enumerable: !0,
          get: function() {
            return d;
          },
          set: function(x) {
            if (typeof x != "number" || x < 0 || l(x))
              throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + x + ".");
            d = x;
          }
        }), c.init = function() {
          (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
        }, c.prototype.setMaxListeners = function(C) {
          if (typeof C != "number" || C < 0 || l(C))
            throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + C + ".");
          return this._maxListeners = C, this;
        };
        function f(x) {
          return x._maxListeners === void 0 ? c.defaultMaxListeners : x._maxListeners;
        }
        c.prototype.getMaxListeners = function() {
          return f(this);
        }, c.prototype.emit = function(C) {
          for (var I = [], M = 1; M < arguments.length; M++) I.push(arguments[M]);
          var Q = C === "error", H = this._events;
          if (H !== void 0)
            Q = Q && H.error === void 0;
          else if (!Q)
            return !1;
          if (Q) {
            var J;
            if (I.length > 0 && (J = I[0]), J instanceof Error)
              throw J;
            var W = new Error("Unhandled error." + (J ? " (" + J.message + ")" : ""));
            throw W.context = J, W;
          }
          var P = H[C];
          if (P === void 0)
            return !1;
          if (typeof P == "function")
            s(P, this, I);
          else
            for (var R = P.length, V = A(P, R), M = 0; M < R; ++M)
              s(V[M], this, I);
          return !0;
        };
        function p(x, C, I, M) {
          var Q, H, J;
          if (h(I), H = x._events, H === void 0 ? (H = x._events = /* @__PURE__ */ Object.create(null), x._eventsCount = 0) : (H.newListener !== void 0 && (x.emit(
            "newListener",
            C,
            I.listener ? I.listener : I
          ), H = x._events), J = H[C]), J === void 0)
            J = H[C] = I, ++x._eventsCount;
          else if (typeof J == "function" ? J = H[C] = M ? [I, J] : [J, I] : M ? J.unshift(I) : J.push(I), Q = f(x), Q > 0 && J.length > Q && !J.warned) {
            J.warned = !0;
            var W = new Error("Possible EventEmitter memory leak detected. " + J.length + " " + String(C) + " listeners added. Use emitter.setMaxListeners() to increase limit");
            W.name = "MaxListenersExceededWarning", W.emitter = x, W.type = C, W.count = J.length, u(W);
          }
          return x;
        }
        c.prototype.addListener = function(C, I) {
          return p(this, C, I, !1);
        }, c.prototype.on = c.prototype.addListener, c.prototype.prependListener = function(C, I) {
          return p(this, C, I, !0);
        };
        function m() {
          if (!this.fired)
            return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
        }
        function w(x, C, I) {
          var M = { fired: !1, wrapFn: void 0, target: x, type: C, listener: I }, Q = m.bind(M);
          return Q.listener = I, M.wrapFn = Q, Q;
        }
        c.prototype.once = function(C, I) {
          return h(I), this.on(C, w(this, C, I)), this;
        }, c.prototype.prependOnceListener = function(C, I) {
          return h(I), this.prependListener(C, w(this, C, I)), this;
        }, c.prototype.removeListener = function(C, I) {
          var M, Q, H, J, W;
          if (h(I), Q = this._events, Q === void 0)
            return this;
          if (M = Q[C], M === void 0)
            return this;
          if (M === I || M.listener === I)
            --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Q[C], Q.removeListener && this.emit("removeListener", C, M.listener || I));
          else if (typeof M != "function") {
            for (H = -1, J = M.length - 1; J >= 0; J--)
              if (M[J] === I || M[J].listener === I) {
                W = M[J].listener, H = J;
                break;
              }
            if (H < 0)
              return this;
            H === 0 ? M.shift() : b(M, H), M.length === 1 && (Q[C] = M[0]), Q.removeListener !== void 0 && this.emit("removeListener", C, W || I);
          }
          return this;
        }, c.prototype.off = c.prototype.removeListener, c.prototype.removeAllListeners = function(C) {
          var I, M, Q;
          if (M = this._events, M === void 0)
            return this;
          if (M.removeListener === void 0)
            return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : M[C] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete M[C]), this;
          if (arguments.length === 0) {
            var H = Object.keys(M), J;
            for (Q = 0; Q < H.length; ++Q)
              J = H[Q], J !== "removeListener" && this.removeAllListeners(J);
            return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
          }
          if (I = M[C], typeof I == "function")
            this.removeListener(C, I);
          else if (I !== void 0)
            for (Q = I.length - 1; Q >= 0; Q--)
              this.removeListener(C, I[Q]);
          return this;
        };
        function v(x, C, I) {
          var M = x._events;
          if (M === void 0)
            return [];
          var Q = M[C];
          return Q === void 0 ? [] : typeof Q == "function" ? I ? [Q.listener || Q] : [Q] : I ? k(Q) : A(Q, Q.length);
        }
        c.prototype.listeners = function(C) {
          return v(this, C, !0);
        }, c.prototype.rawListeners = function(C) {
          return v(this, C, !1);
        }, c.listenerCount = function(x, C) {
          return typeof x.listenerCount == "function" ? x.listenerCount(C) : g.call(x, C);
        }, c.prototype.listenerCount = g;
        function g(x) {
          var C = this._events;
          if (C !== void 0) {
            var I = C[x];
            if (typeof I == "function")
              return 1;
            if (I !== void 0)
              return I.length;
          }
          return 0;
        }
        c.prototype.eventNames = function() {
          return this._eventsCount > 0 ? a(this._events) : [];
        };
        function A(x, C) {
          for (var I = new Array(C), M = 0; M < C; ++M)
            I[M] = x[M];
          return I;
        }
        function b(x, C) {
          for (; C + 1 < x.length; C++)
            x[C] = x[C + 1];
          x.pop();
        }
        function k(x) {
          for (var C = new Array(x.length), I = 0; I < C.length; ++I)
            C[I] = x[I].listener || x[I];
          return C;
        }
        function y(x, C) {
          return new Promise(function(I, M) {
            function Q() {
              H !== void 0 && x.removeListener("error", H), I([].slice.call(arguments));
            }
            var H;
            C !== "error" && (H = function(W) {
              x.removeListener(C, Q), M(W);
            }, x.once("error", H)), x.once(C, Q);
          });
        }
      }, {}], 37: [function(r, i, n) {
        /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
        n.read = function(o, s, a, u, l) {
          var c, d, h = l * 8 - u - 1, f = (1 << h) - 1, p = f >> 1, m = -7, w = a ? l - 1 : 0, v = a ? -1 : 1, g = o[s + w];
          for (w += v, c = g & (1 << -m) - 1, g >>= -m, m += h; m > 0; c = c * 256 + o[s + w], w += v, m -= 8)
            ;
          for (d = c & (1 << -m) - 1, c >>= -m, m += u; m > 0; d = d * 256 + o[s + w], w += v, m -= 8)
            ;
          if (c === 0)
            c = 1 - p;
          else {
            if (c === f)
              return d ? NaN : (g ? -1 : 1) * (1 / 0);
            d = d + Math.pow(2, u), c = c - p;
          }
          return (g ? -1 : 1) * d * Math.pow(2, c - u);
        }, n.write = function(o, s, a, u, l, c) {
          var d, h, f, p = c * 8 - l - 1, m = (1 << p) - 1, w = m >> 1, v = l === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, g = u ? 0 : c - 1, A = u ? 1 : -1, b = s < 0 || s === 0 && 1 / s < 0 ? 1 : 0;
          for (s = Math.abs(s), isNaN(s) || s === 1 / 0 ? (h = isNaN(s) ? 1 : 0, d = m) : (d = Math.floor(Math.log(s) / Math.LN2), s * (f = Math.pow(2, -d)) < 1 && (d--, f *= 2), d + w >= 1 ? s += v / f : s += v * Math.pow(2, 1 - w), s * f >= 2 && (d++, f /= 2), d + w >= m ? (h = 0, d = m) : d + w >= 1 ? (h = (s * f - 1) * Math.pow(2, l), d = d + w) : (h = s * Math.pow(2, w - 1) * Math.pow(2, l), d = 0)); l >= 8; o[a + g] = h & 255, g += A, h /= 256, l -= 8)
            ;
          for (d = d << l | h, p += l; p > 0; o[a + g] = d & 255, g += A, d /= 256, p -= 8)
            ;
          o[a + g - A] |= b * 128;
        };
      }, {}], 38: [function(r, i, n) {
        typeof Object.create == "function" ? i.exports = function(s, a) {
          a && (s.super_ = a, s.prototype = Object.create(a.prototype, {
            constructor: {
              value: s,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }));
        } : i.exports = function(s, a) {
          if (a) {
            s.super_ = a;
            var u = function() {
            };
            u.prototype = a.prototype, s.prototype = new u(), s.prototype.constructor = s;
          }
        };
      }, {}], 39: [function(r, i, n) {
        var o = i.exports = {}, s, a;
        function u() {
          throw new Error("setTimeout has not been defined");
        }
        function l() {
          throw new Error("clearTimeout has not been defined");
        }
        (function() {
          try {
            typeof setTimeout == "function" ? s = setTimeout : s = u;
          } catch {
            s = u;
          }
          try {
            typeof clearTimeout == "function" ? a = clearTimeout : a = l;
          } catch {
            a = l;
          }
        })();
        function c(b) {
          if (s === setTimeout)
            return setTimeout(b, 0);
          if ((s === u || !s) && setTimeout)
            return s = setTimeout, setTimeout(b, 0);
          try {
            return s(b, 0);
          } catch {
            try {
              return s.call(null, b, 0);
            } catch {
              return s.call(this, b, 0);
            }
          }
        }
        function d(b) {
          if (a === clearTimeout)
            return clearTimeout(b);
          if ((a === l || !a) && clearTimeout)
            return a = clearTimeout, clearTimeout(b);
          try {
            return a(b);
          } catch {
            try {
              return a.call(null, b);
            } catch {
              return a.call(this, b);
            }
          }
        }
        var h = [], f = !1, p, m = -1;
        function w() {
          !f || !p || (f = !1, p.length ? h = p.concat(h) : m = -1, h.length && v());
        }
        function v() {
          if (!f) {
            var b = c(w);
            f = !0;
            for (var k = h.length; k; ) {
              for (p = h, h = []; ++m < k; )
                p && p[m].run();
              m = -1, k = h.length;
            }
            p = null, f = !1, d(b);
          }
        }
        o.nextTick = function(b) {
          var k = new Array(arguments.length - 1);
          if (arguments.length > 1)
            for (var y = 1; y < arguments.length; y++)
              k[y - 1] = arguments[y];
          h.push(new g(b, k)), h.length === 1 && !f && c(v);
        };
        function g(b, k) {
          this.fun = b, this.array = k;
        }
        g.prototype.run = function() {
          this.fun.apply(null, this.array);
        }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {};
        function A() {
        }
        o.on = A, o.addListener = A, o.once = A, o.off = A, o.removeListener = A, o.removeAllListeners = A, o.emit = A, o.prependListener = A, o.prependOnceListener = A, o.listeners = function(b) {
          return [];
        }, o.binding = function(b) {
          throw new Error("process.binding is not supported");
        }, o.cwd = function() {
          return "/";
        }, o.chdir = function(b) {
          throw new Error("process.chdir is not supported");
        }, o.umask = function() {
          return 0;
        };
      }, {}], 40: [function(r, i, n) {
        /*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
        var o = r("buffer"), s = o.Buffer;
        function a(l, c) {
          for (var d in l)
            c[d] = l[d];
        }
        s.from && s.alloc && s.allocUnsafe && s.allocUnsafeSlow ? i.exports = o : (a(o, n), n.Buffer = u);
        function u(l, c, d) {
          return s(l, c, d);
        }
        u.prototype = Object.create(s.prototype), a(s, u), u.from = function(l, c, d) {
          if (typeof l == "number")
            throw new TypeError("Argument must not be a number");
          return s(l, c, d);
        }, u.alloc = function(l, c, d) {
          if (typeof l != "number")
            throw new TypeError("Argument must be a number");
          var h = s(l);
          return c !== void 0 ? typeof d == "string" ? h.fill(c, d) : h.fill(c) : h.fill(0), h;
        }, u.allocUnsafe = function(l) {
          if (typeof l != "number")
            throw new TypeError("Argument must be a number");
          return s(l);
        }, u.allocUnsafeSlow = function(l) {
          if (typeof l != "number")
            throw new TypeError("Argument must be a number");
          return o.SlowBuffer(l);
        };
      }, { buffer: 35 }], 41: [function(r, i, n) {
        i.exports = a;
        var o = r("events").EventEmitter, s = r("inherits");
        s(a, o), a.Readable = r("readable-stream/lib/_stream_readable.js"), a.Writable = r("readable-stream/lib/_stream_writable.js"), a.Duplex = r("readable-stream/lib/_stream_duplex.js"), a.Transform = r("readable-stream/lib/_stream_transform.js"), a.PassThrough = r("readable-stream/lib/_stream_passthrough.js"), a.finished = r("readable-stream/lib/internal/streams/end-of-stream.js"), a.pipeline = r("readable-stream/lib/internal/streams/pipeline.js"), a.Stream = a;
        function a() {
          o.call(this);
        }
        a.prototype.pipe = function(u, l) {
          var c = this;
          function d(g) {
            u.writable && u.write(g) === !1 && c.pause && c.pause();
          }
          c.on("data", d);
          function h() {
            c.readable && c.resume && c.resume();
          }
          u.on("drain", h), !u._isStdio && (!l || l.end !== !1) && (c.on("end", p), c.on("close", m));
          var f = !1;
          function p() {
            f || (f = !0, u.end());
          }
          function m() {
            f || (f = !0, typeof u.destroy == "function" && u.destroy());
          }
          function w(g) {
            if (v(), o.listenerCount(this, "error") === 0)
              throw g;
          }
          c.on("error", w), u.on("error", w);
          function v() {
            c.removeListener("data", d), u.removeListener("drain", h), c.removeListener("end", p), c.removeListener("close", m), c.removeListener("error", w), u.removeListener("error", w), c.removeListener("end", v), c.removeListener("close", v), u.removeListener("close", v);
          }
          return c.on("end", v), c.on("close", v), u.on("close", v), u.emit("pipe", c), u;
        };
      }, { events: 36, inherits: 38, "readable-stream/lib/_stream_duplex.js": 43, "readable-stream/lib/_stream_passthrough.js": 44, "readable-stream/lib/_stream_readable.js": 45, "readable-stream/lib/_stream_transform.js": 46, "readable-stream/lib/_stream_writable.js": 47, "readable-stream/lib/internal/streams/end-of-stream.js": 51, "readable-stream/lib/internal/streams/pipeline.js": 53 }], 42: [function(r, i, n) {
        function o(h, f) {
          h.prototype = Object.create(f.prototype), h.prototype.constructor = h, h.__proto__ = f;
        }
        var s = {};
        function a(h, f, p) {
          p || (p = Error);
          function m(v, g, A) {
            return typeof f == "string" ? f : f(v, g, A);
          }
          var w = /* @__PURE__ */ (function(v) {
            o(g, v);
            function g(A, b, k) {
              return v.call(this, m(A, b, k)) || this;
            }
            return g;
          })(p);
          w.prototype.name = p.name, w.prototype.code = h, s[h] = w;
        }
        function u(h, f) {
          if (Array.isArray(h)) {
            var p = h.length;
            return h = h.map(function(m) {
              return String(m);
            }), p > 2 ? "one of ".concat(f, " ").concat(h.slice(0, p - 1).join(", "), ", or ") + h[p - 1] : p === 2 ? "one of ".concat(f, " ").concat(h[0], " or ").concat(h[1]) : "of ".concat(f, " ").concat(h[0]);
          } else
            return "of ".concat(f, " ").concat(String(h));
        }
        function l(h, f, p) {
          return h.substr(0, f.length) === f;
        }
        function c(h, f, p) {
          return (p === void 0 || p > h.length) && (p = h.length), h.substring(p - f.length, p) === f;
        }
        function d(h, f, p) {
          return typeof p != "number" && (p = 0), p + f.length > h.length ? !1 : h.indexOf(f, p) !== -1;
        }
        a("ERR_INVALID_OPT_VALUE", function(h, f) {
          return 'The value "' + f + '" is invalid for option "' + h + '"';
        }, TypeError), a("ERR_INVALID_ARG_TYPE", function(h, f, p) {
          var m;
          typeof f == "string" && l(f, "not ") ? (m = "must not be", f = f.replace(/^not /, "")) : m = "must be";
          var w;
          if (c(h, " argument"))
            w = "The ".concat(h, " ").concat(m, " ").concat(u(f, "type"));
          else {
            var v = d(h, ".") ? "property" : "argument";
            w = 'The "'.concat(h, '" ').concat(v, " ").concat(m, " ").concat(u(f, "type"));
          }
          return w += ". Received type ".concat(typeof p), w;
        }, TypeError), a("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), a("ERR_METHOD_NOT_IMPLEMENTED", function(h) {
          return "The " + h + " method is not implemented";
        }), a("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), a("ERR_STREAM_DESTROYED", function(h) {
          return "Cannot call " + h + " after a stream was destroyed";
        }), a("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), a("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), a("ERR_STREAM_WRITE_AFTER_END", "write after end"), a("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), a("ERR_UNKNOWN_ENCODING", function(h) {
          return "Unknown encoding: " + h;
        }, TypeError), a("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), i.exports.codes = s;
      }, {}], 43: [function(r, i, n) {
        (function(o) {
          (function() {
            var s = Object.keys || function(m) {
              var w = [];
              for (var v in m)
                w.push(v);
              return w;
            };
            i.exports = h;
            var a = r("./_stream_readable"), u = r("./_stream_writable");
            r("inherits")(h, a);
            for (var l = s(u.prototype), c = 0; c < l.length; c++) {
              var d = l[c];
              h.prototype[d] || (h.prototype[d] = u.prototype[d]);
            }
            function h(m) {
              if (!(this instanceof h)) return new h(m);
              a.call(this, m), u.call(this, m), this.allowHalfOpen = !0, m && (m.readable === !1 && (this.readable = !1), m.writable === !1 && (this.writable = !1), m.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", f)));
            }
            Object.defineProperty(h.prototype, "writableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.highWaterMark;
              }
            }), Object.defineProperty(h.prototype, "writableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState && this._writableState.getBuffer();
              }
            }), Object.defineProperty(h.prototype, "writableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.length;
              }
            });
            function f() {
              this._writableState.ended || o.nextTick(p, this);
            }
            function p(m) {
              m.end();
            }
            Object.defineProperty(h.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
              },
              set: function(w) {
                this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = w, this._writableState.destroyed = w);
              }
            });
          }).call(this);
        }).call(this, r("_process"));
      }, { "./_stream_readable": 45, "./_stream_writable": 47, _process: 39, inherits: 38 }], 44: [function(r, i, n) {
        i.exports = s;
        var o = r("./_stream_transform");
        r("inherits")(s, o);
        function s(a) {
          if (!(this instanceof s)) return new s(a);
          o.call(this, a);
        }
        s.prototype._transform = function(a, u, l) {
          l(null, a);
        };
      }, { "./_stream_transform": 46, inherits: 38 }], 45: [function(r, i, n) {
        (function(o, s) {
          (function() {
            i.exports = R;
            var a;
            R.ReadableState = P, r("events").EventEmitter;
            var u = function(B, D) {
              return B.listeners(D).length;
            }, l = r("./internal/streams/stream"), c = r("buffer").Buffer, d = s.Uint8Array || function() {
            };
            function h(L) {
              return c.from(L);
            }
            function f(L) {
              return c.isBuffer(L) || L instanceof d;
            }
            var p = r("util"), m;
            p && p.debuglog ? m = p.debuglog("stream") : m = function() {
            };
            var w = r("./internal/streams/buffer_list"), v = r("./internal/streams/destroy"), g = r("./internal/streams/state"), A = g.getHighWaterMark, b = r("../errors").codes, k = b.ERR_INVALID_ARG_TYPE, y = b.ERR_STREAM_PUSH_AFTER_EOF, x = b.ERR_METHOD_NOT_IMPLEMENTED, C = b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, I, M, Q;
            r("inherits")(R, l);
            var H = v.errorOrDestroy, J = ["error", "close", "destroy", "pause", "resume"];
            function W(L, B, D) {
              if (typeof L.prependListener == "function") return L.prependListener(B, D);
              !L._events || !L._events[B] ? L.on(B, D) : Array.isArray(L._events[B]) ? L._events[B].unshift(D) : L._events[B] = [D, L._events[B]];
            }
            function P(L, B, D) {
              a = a || r("./_stream_duplex"), L = L || {}, typeof D != "boolean" && (D = B instanceof a), this.objectMode = !!L.objectMode, D && (this.objectMode = this.objectMode || !!L.readableObjectMode), this.highWaterMark = A(this, L, "readableHighWaterMark", D), this.buffer = new w(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = L.emitClose !== !1, this.autoDestroy = !!L.autoDestroy, this.destroyed = !1, this.defaultEncoding = L.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, L.encoding && (I || (I = r("string_decoder/").StringDecoder), this.decoder = new I(L.encoding), this.encoding = L.encoding);
            }
            function R(L) {
              if (a = a || r("./_stream_duplex"), !(this instanceof R)) return new R(L);
              var B = this instanceof a;
              this._readableState = new P(L, this, B), this.readable = !0, L && (typeof L.read == "function" && (this._read = L.read), typeof L.destroy == "function" && (this._destroy = L.destroy)), l.call(this);
            }
            Object.defineProperty(R.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState === void 0 ? !1 : this._readableState.destroyed;
              },
              set: function(B) {
                this._readableState && (this._readableState.destroyed = B);
              }
            }), R.prototype.destroy = v.destroy, R.prototype._undestroy = v.undestroy, R.prototype._destroy = function(L, B) {
              B(L);
            }, R.prototype.push = function(L, B) {
              var D = this._readableState, E;
              return D.objectMode ? E = !0 : typeof L == "string" && (B = B || D.defaultEncoding, B !== D.encoding && (L = c.from(L, B), B = ""), E = !0), V(this, L, B, !1, E);
            }, R.prototype.unshift = function(L) {
              return V(this, L, null, !0, !1);
            };
            function V(L, B, D, E, T) {
              m("readableAddChunk", B);
              var j = L._readableState;
              if (B === null)
                j.reading = !1, oe(L, j);
              else {
                var Y;
                if (T || (Y = N(j, B)), Y)
                  H(L, Y);
                else if (j.objectMode || B && B.length > 0)
                  if (typeof B != "string" && !j.objectMode && Object.getPrototypeOf(B) !== c.prototype && (B = h(B)), E)
                    j.endEmitted ? H(L, new C()) : X(L, j, B, !0);
                  else if (j.ended)
                    H(L, new y());
                  else {
                    if (j.destroyed)
                      return !1;
                    j.reading = !1, j.decoder && !D ? (B = j.decoder.write(B), j.objectMode || B.length !== 0 ? X(L, j, B, !1) : he(L, j)) : X(L, j, B, !1);
                  }
                else E || (j.reading = !1, he(L, j));
              }
              return !j.ended && (j.length < j.highWaterMark || j.length === 0);
            }
            function X(L, B, D, E) {
              B.flowing && B.length === 0 && !B.sync ? (B.awaitDrain = 0, L.emit("data", D)) : (B.length += B.objectMode ? 1 : D.length, E ? B.buffer.unshift(D) : B.buffer.push(D), B.needReadable && ie(L)), he(L, B);
            }
            function N(L, B) {
              var D;
              return !f(B) && typeof B != "string" && B !== void 0 && !L.objectMode && (D = new k("chunk", ["string", "Buffer", "Uint8Array"], B)), D;
            }
            R.prototype.isPaused = function() {
              return this._readableState.flowing === !1;
            }, R.prototype.setEncoding = function(L) {
              I || (I = r("string_decoder/").StringDecoder);
              var B = new I(L);
              this._readableState.decoder = B, this._readableState.encoding = this._readableState.decoder.encoding;
              for (var D = this._readableState.buffer.head, E = ""; D !== null; )
                E += B.write(D.data), D = D.next;
              return this._readableState.buffer.clear(), E !== "" && this._readableState.buffer.push(E), this._readableState.length = E.length, this;
            };
            var U = 1073741824;
            function G(L) {
              return L >= U ? L = U : (L--, L |= L >>> 1, L |= L >>> 2, L |= L >>> 4, L |= L >>> 8, L |= L >>> 16, L++), L;
            }
            function re(L, B) {
              return L <= 0 || B.length === 0 && B.ended ? 0 : B.objectMode ? 1 : L !== L ? B.flowing && B.length ? B.buffer.head.data.length : B.length : (L > B.highWaterMark && (B.highWaterMark = G(L)), L <= B.length ? L : B.ended ? B.length : (B.needReadable = !0, 0));
            }
            R.prototype.read = function(L) {
              m("read", L), L = parseInt(L, 10);
              var B = this._readableState, D = L;
              if (L !== 0 && (B.emittedReadable = !1), L === 0 && B.needReadable && ((B.highWaterMark !== 0 ? B.length >= B.highWaterMark : B.length > 0) || B.ended))
                return m("read: emitReadable", B.length, B.ended), B.length === 0 && B.ended ? ue(this) : ie(this), null;
              if (L = re(L, B), L === 0 && B.ended)
                return B.length === 0 && ue(this), null;
              var E = B.needReadable;
              m("need readable", E), (B.length === 0 || B.length - L < B.highWaterMark) && (E = !0, m("length less than watermark", E)), B.ended || B.reading ? (E = !1, m("reading or ended", E)) : E && (m("do read"), B.reading = !0, B.sync = !0, B.length === 0 && (B.needReadable = !0), this._read(B.highWaterMark), B.sync = !1, B.reading || (L = re(D, B)));
              var T;
              return L > 0 ? T = Z(L, B) : T = null, T === null ? (B.needReadable = B.length <= B.highWaterMark, L = 0) : (B.length -= L, B.awaitDrain = 0), B.length === 0 && (B.ended || (B.needReadable = !0), D !== L && B.ended && ue(this)), T !== null && this.emit("data", T), T;
            };
            function oe(L, B) {
              if (m("onEofChunk"), !B.ended) {
                if (B.decoder) {
                  var D = B.decoder.end();
                  D && D.length && (B.buffer.push(D), B.length += B.objectMode ? 1 : D.length);
                }
                B.ended = !0, B.sync ? ie(L) : (B.needReadable = !1, B.emittedReadable || (B.emittedReadable = !0, le(L)));
              }
            }
            function ie(L) {
              var B = L._readableState;
              m("emitReadable", B.needReadable, B.emittedReadable), B.needReadable = !1, B.emittedReadable || (m("emitReadable", B.flowing), B.emittedReadable = !0, o.nextTick(le, L));
            }
            function le(L) {
              var B = L._readableState;
              m("emitReadable_", B.destroyed, B.length, B.ended), !B.destroyed && (B.length || B.ended) && (L.emit("readable"), B.emittedReadable = !1), B.needReadable = !B.flowing && !B.ended && B.length <= B.highWaterMark, te(L);
            }
            function he(L, B) {
              B.readingMore || (B.readingMore = !0, o.nextTick(ye, L, B));
            }
            function ye(L, B) {
              for (; !B.reading && !B.ended && (B.length < B.highWaterMark || B.flowing && B.length === 0); ) {
                var D = B.length;
                if (m("maybeReadMore read 0"), L.read(0), D === B.length)
                  break;
              }
              B.readingMore = !1;
            }
            R.prototype._read = function(L) {
              H(this, new x("_read()"));
            }, R.prototype.pipe = function(L, B) {
              var D = this, E = this._readableState;
              switch (E.pipesCount) {
                case 0:
                  E.pipes = L;
                  break;
                case 1:
                  E.pipes = [E.pipes, L];
                  break;
                default:
                  E.pipes.push(L);
                  break;
              }
              E.pipesCount += 1, m("pipe count=%d opts=%j", E.pipesCount, B);
              var T = (!B || B.end !== !1) && L !== o.stdout && L !== o.stderr, j = T ? ae : ee;
              E.endEmitted ? o.nextTick(j) : D.once("end", j), L.on("unpipe", Y);
              function Y(de, ge) {
                m("onunpipe"), de === D && ge && ge.hasUnpiped === !1 && (ge.hasUnpiped = !0, _());
              }
              function ae() {
                m("onend"), L.end();
              }
              var se = be(D);
              L.on("drain", se);
              var O = !1;
              function _() {
                m("cleanup"), L.removeListener("close", $), L.removeListener("finish", K), L.removeListener("drain", se), L.removeListener("error", F), L.removeListener("unpipe", Y), D.removeListener("end", ae), D.removeListener("end", ee), D.removeListener("data", S), O = !0, E.awaitDrain && (!L._writableState || L._writableState.needDrain) && se();
              }
              D.on("data", S);
              function S(de) {
                m("ondata");
                var ge = L.write(de);
                m("dest.write", ge), ge === !1 && ((E.pipesCount === 1 && E.pipes === L || E.pipesCount > 1 && me(E.pipes, L) !== -1) && !O && (m("false write response, pause", E.awaitDrain), E.awaitDrain++), D.pause());
              }
              function F(de) {
                m("onerror", de), ee(), L.removeListener("error", F), u(L, "error") === 0 && H(L, de);
              }
              W(L, "error", F);
              function $() {
                L.removeListener("finish", K), ee();
              }
              L.once("close", $);
              function K() {
                m("onfinish"), L.removeListener("close", $), ee();
              }
              L.once("finish", K);
              function ee() {
                m("unpipe"), D.unpipe(L);
              }
              return L.emit("pipe", D), E.flowing || (m("pipe resume"), D.resume()), L;
            };
            function be(L) {
              return function() {
                var D = L._readableState;
                m("pipeOnDrain", D.awaitDrain), D.awaitDrain && D.awaitDrain--, D.awaitDrain === 0 && u(L, "data") && (D.flowing = !0, te(L));
              };
            }
            R.prototype.unpipe = function(L) {
              var B = this._readableState, D = {
                hasUnpiped: !1
              };
              if (B.pipesCount === 0) return this;
              if (B.pipesCount === 1)
                return L && L !== B.pipes ? this : (L || (L = B.pipes), B.pipes = null, B.pipesCount = 0, B.flowing = !1, L && L.emit("unpipe", this, D), this);
              if (!L) {
                var E = B.pipes, T = B.pipesCount;
                B.pipes = null, B.pipesCount = 0, B.flowing = !1;
                for (var j = 0; j < T; j++)
                  E[j].emit("unpipe", this, {
                    hasUnpiped: !1
                  });
                return this;
              }
              var Y = me(B.pipes, L);
              return Y === -1 ? this : (B.pipes.splice(Y, 1), B.pipesCount -= 1, B.pipesCount === 1 && (B.pipes = B.pipes[0]), L.emit("unpipe", this, D), this);
            }, R.prototype.on = function(L, B) {
              var D = l.prototype.on.call(this, L, B), E = this._readableState;
              return L === "data" ? (E.readableListening = this.listenerCount("readable") > 0, E.flowing !== !1 && this.resume()) : L === "readable" && !E.endEmitted && !E.readableListening && (E.readableListening = E.needReadable = !0, E.flowing = !1, E.emittedReadable = !1, m("on readable", E.length, E.reading), E.length ? ie(this) : E.reading || o.nextTick(ve, this)), D;
            }, R.prototype.addListener = R.prototype.on, R.prototype.removeListener = function(L, B) {
              var D = l.prototype.removeListener.call(this, L, B);
              return L === "readable" && o.nextTick(we, this), D;
            }, R.prototype.removeAllListeners = function(L) {
              var B = l.prototype.removeAllListeners.apply(this, arguments);
              return (L === "readable" || L === void 0) && o.nextTick(we, this), B;
            };
            function we(L) {
              var B = L._readableState;
              B.readableListening = L.listenerCount("readable") > 0, B.resumeScheduled && !B.paused ? B.flowing = !0 : L.listenerCount("data") > 0 && L.resume();
            }
            function ve(L) {
              m("readable nexttick read 0"), L.read(0);
            }
            R.prototype.resume = function() {
              var L = this._readableState;
              return L.flowing || (m("resume"), L.flowing = !L.readableListening, Re(this, L)), L.paused = !1, this;
            };
            function Re(L, B) {
              B.resumeScheduled || (B.resumeScheduled = !0, o.nextTick(De, L, B));
            }
            function De(L, B) {
              m("resume", B.reading), B.reading || L.read(0), B.resumeScheduled = !1, L.emit("resume"), te(L), B.flowing && !B.reading && L.read(0);
            }
            R.prototype.pause = function() {
              return m("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (m("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
            };
            function te(L) {
              var B = L._readableState;
              for (m("flow", B.flowing); B.flowing && L.read() !== null; )
                ;
            }
            R.prototype.wrap = function(L) {
              var B = this, D = this._readableState, E = !1;
              L.on("end", function() {
                if (m("wrapped end"), D.decoder && !D.ended) {
                  var Y = D.decoder.end();
                  Y && Y.length && B.push(Y);
                }
                B.push(null);
              }), L.on("data", function(Y) {
                if (m("wrapped data"), D.decoder && (Y = D.decoder.write(Y)), !(D.objectMode && Y == null) && !(!D.objectMode && (!Y || !Y.length))) {
                  var ae = B.push(Y);
                  ae || (E = !0, L.pause());
                }
              });
              for (var T in L)
                this[T] === void 0 && typeof L[T] == "function" && (this[T] = /* @__PURE__ */ (function(ae) {
                  return function() {
                    return L[ae].apply(L, arguments);
                  };
                })(T));
              for (var j = 0; j < J.length; j++)
                L.on(J[j], this.emit.bind(this, J[j]));
              return this._read = function(Y) {
                m("wrapped _read", Y), E && (E = !1, L.resume());
              }, this;
            }, typeof Symbol == "function" && (R.prototype[Symbol.asyncIterator] = function() {
              return M === void 0 && (M = r("./internal/streams/async_iterator")), M(this);
            }), Object.defineProperty(R.prototype, "readableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.highWaterMark;
              }
            }), Object.defineProperty(R.prototype, "readableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState && this._readableState.buffer;
              }
            }), Object.defineProperty(R.prototype, "readableFlowing", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.flowing;
              },
              set: function(B) {
                this._readableState && (this._readableState.flowing = B);
              }
            }), R._fromList = Z, Object.defineProperty(R.prototype, "readableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._readableState.length;
              }
            });
            function Z(L, B) {
              if (B.length === 0) return null;
              var D;
              return B.objectMode ? D = B.buffer.shift() : !L || L >= B.length ? (B.decoder ? D = B.buffer.join("") : B.buffer.length === 1 ? D = B.buffer.first() : D = B.buffer.concat(B.length), B.buffer.clear()) : D = B.buffer.consume(L, B.decoder), D;
            }
            function ue(L) {
              var B = L._readableState;
              m("endReadable", B.endEmitted), B.endEmitted || (B.ended = !0, o.nextTick(pe, B, L));
            }
            function pe(L, B) {
              if (m("endReadableNT", L.endEmitted, L.length), !L.endEmitted && L.length === 0 && (L.endEmitted = !0, B.readable = !1, B.emit("end"), L.autoDestroy)) {
                var D = B._writableState;
                (!D || D.autoDestroy && D.finished) && B.destroy();
              }
            }
            typeof Symbol == "function" && (R.from = function(L, B) {
              return Q === void 0 && (Q = r("./internal/streams/from")), Q(R, L, B);
            });
            function me(L, B) {
              for (var D = 0, E = L.length; D < E; D++)
                if (L[D] === B) return D;
              return -1;
            }
          }).call(this);
        }).call(this, r("_process"), typeof Ne < "u" ? Ne : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, { "../errors": 42, "./_stream_duplex": 43, "./internal/streams/async_iterator": 48, "./internal/streams/buffer_list": 49, "./internal/streams/destroy": 50, "./internal/streams/from": 52, "./internal/streams/state": 54, "./internal/streams/stream": 55, _process: 39, buffer: 35, events: 36, inherits: 38, "string_decoder/": 56, util: 33 }], 46: [function(r, i, n) {
        i.exports = h;
        var o = r("../errors").codes, s = o.ERR_METHOD_NOT_IMPLEMENTED, a = o.ERR_MULTIPLE_CALLBACK, u = o.ERR_TRANSFORM_ALREADY_TRANSFORMING, l = o.ERR_TRANSFORM_WITH_LENGTH_0, c = r("./_stream_duplex");
        r("inherits")(h, c);
        function d(m, w) {
          var v = this._transformState;
          v.transforming = !1;
          var g = v.writecb;
          if (g === null)
            return this.emit("error", new a());
          v.writechunk = null, v.writecb = null, w != null && this.push(w), g(m);
          var A = this._readableState;
          A.reading = !1, (A.needReadable || A.length < A.highWaterMark) && this._read(A.highWaterMark);
        }
        function h(m) {
          if (!(this instanceof h)) return new h(m);
          c.call(this, m), this._transformState = {
            afterTransform: d.bind(this),
            needTransform: !1,
            transforming: !1,
            writecb: null,
            writechunk: null,
            writeencoding: null
          }, this._readableState.needReadable = !0, this._readableState.sync = !1, m && (typeof m.transform == "function" && (this._transform = m.transform), typeof m.flush == "function" && (this._flush = m.flush)), this.on("prefinish", f);
        }
        function f() {
          var m = this;
          typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(w, v) {
            p(m, w, v);
          }) : p(this, null, null);
        }
        h.prototype.push = function(m, w) {
          return this._transformState.needTransform = !1, c.prototype.push.call(this, m, w);
        }, h.prototype._transform = function(m, w, v) {
          v(new s("_transform()"));
        }, h.prototype._write = function(m, w, v) {
          var g = this._transformState;
          if (g.writecb = v, g.writechunk = m, g.writeencoding = w, !g.transforming) {
            var A = this._readableState;
            (g.needTransform || A.needReadable || A.length < A.highWaterMark) && this._read(A.highWaterMark);
          }
        }, h.prototype._read = function(m) {
          var w = this._transformState;
          w.writechunk !== null && !w.transforming ? (w.transforming = !0, this._transform(w.writechunk, w.writeencoding, w.afterTransform)) : w.needTransform = !0;
        }, h.prototype._destroy = function(m, w) {
          c.prototype._destroy.call(this, m, function(v) {
            w(v);
          });
        };
        function p(m, w, v) {
          if (w) return m.emit("error", w);
          if (v != null && m.push(v), m._writableState.length) throw new l();
          if (m._transformState.transforming) throw new u();
          return m.push(null);
        }
      }, { "../errors": 42, "./_stream_duplex": 43, inherits: 38 }], 47: [function(r, i, n) {
        (function(o, s) {
          (function() {
            i.exports = P;
            function a(te) {
              var Z = this;
              this.next = null, this.entry = null, this.finish = function() {
                De(Z, te);
              };
            }
            var u;
            P.WritableState = J;
            var l = {
              deprecate: r("util-deprecate")
            }, c = r("./internal/streams/stream"), d = r("buffer").Buffer, h = s.Uint8Array || function() {
            };
            function f(te) {
              return d.from(te);
            }
            function p(te) {
              return d.isBuffer(te) || te instanceof h;
            }
            var m = r("./internal/streams/destroy"), w = r("./internal/streams/state"), v = w.getHighWaterMark, g = r("../errors").codes, A = g.ERR_INVALID_ARG_TYPE, b = g.ERR_METHOD_NOT_IMPLEMENTED, k = g.ERR_MULTIPLE_CALLBACK, y = g.ERR_STREAM_CANNOT_PIPE, x = g.ERR_STREAM_DESTROYED, C = g.ERR_STREAM_NULL_VALUES, I = g.ERR_STREAM_WRITE_AFTER_END, M = g.ERR_UNKNOWN_ENCODING, Q = m.errorOrDestroy;
            r("inherits")(P, c);
            function H() {
            }
            function J(te, Z, ue) {
              u = u || r("./_stream_duplex"), te = te || {}, typeof ue != "boolean" && (ue = Z instanceof u), this.objectMode = !!te.objectMode, ue && (this.objectMode = this.objectMode || !!te.writableObjectMode), this.highWaterMark = v(this, te, "writableHighWaterMark", ue), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
              var pe = te.decodeStrings === !1;
              this.decodeStrings = !pe, this.defaultEncoding = te.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(me) {
                oe(Z, me);
              }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = te.emitClose !== !1, this.autoDestroy = !!te.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this);
            }
            J.prototype.getBuffer = function() {
              for (var Z = this.bufferedRequest, ue = []; Z; )
                ue.push(Z), Z = Z.next;
              return ue;
            }, (function() {
              try {
                Object.defineProperty(J.prototype, "buffer", {
                  get: l.deprecate(function() {
                    return this.getBuffer();
                  }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                });
              } catch {
              }
            })();
            var W;
            typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (W = Function.prototype[Symbol.hasInstance], Object.defineProperty(P, Symbol.hasInstance, {
              value: function(Z) {
                return W.call(this, Z) ? !0 : this !== P ? !1 : Z && Z._writableState instanceof J;
              }
            })) : W = function(Z) {
              return Z instanceof this;
            };
            function P(te) {
              u = u || r("./_stream_duplex");
              var Z = this instanceof u;
              if (!Z && !W.call(P, this)) return new P(te);
              this._writableState = new J(te, this, Z), this.writable = !0, te && (typeof te.write == "function" && (this._write = te.write), typeof te.writev == "function" && (this._writev = te.writev), typeof te.destroy == "function" && (this._destroy = te.destroy), typeof te.final == "function" && (this._final = te.final)), c.call(this);
            }
            P.prototype.pipe = function() {
              Q(this, new y());
            };
            function R(te, Z) {
              var ue = new I();
              Q(te, ue), o.nextTick(Z, ue);
            }
            function V(te, Z, ue, pe) {
              var me;
              return ue === null ? me = new C() : typeof ue != "string" && !Z.objectMode && (me = new A("chunk", ["string", "Buffer"], ue)), me ? (Q(te, me), o.nextTick(pe, me), !1) : !0;
            }
            P.prototype.write = function(te, Z, ue) {
              var pe = this._writableState, me = !1, L = !pe.objectMode && p(te);
              return L && !d.isBuffer(te) && (te = f(te)), typeof Z == "function" && (ue = Z, Z = null), L ? Z = "buffer" : Z || (Z = pe.defaultEncoding), typeof ue != "function" && (ue = H), pe.ending ? R(this, ue) : (L || V(this, pe, te, ue)) && (pe.pendingcb++, me = N(this, pe, L, te, Z, ue)), me;
            }, P.prototype.cork = function() {
              this._writableState.corked++;
            }, P.prototype.uncork = function() {
              var te = this._writableState;
              te.corked && (te.corked--, !te.writing && !te.corked && !te.bufferProcessing && te.bufferedRequest && he(this, te));
            }, P.prototype.setDefaultEncoding = function(Z) {
              if (typeof Z == "string" && (Z = Z.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((Z + "").toLowerCase()) > -1)) throw new M(Z);
              return this._writableState.defaultEncoding = Z, this;
            }, Object.defineProperty(P.prototype, "writableBuffer", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState && this._writableState.getBuffer();
              }
            });
            function X(te, Z, ue) {
              return !te.objectMode && te.decodeStrings !== !1 && typeof Z == "string" && (Z = d.from(Z, ue)), Z;
            }
            Object.defineProperty(P.prototype, "writableHighWaterMark", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.highWaterMark;
              }
            });
            function N(te, Z, ue, pe, me, L) {
              if (!ue) {
                var B = X(Z, pe, me);
                pe !== B && (ue = !0, me = "buffer", pe = B);
              }
              var D = Z.objectMode ? 1 : pe.length;
              Z.length += D;
              var E = Z.length < Z.highWaterMark;
              if (E || (Z.needDrain = !0), Z.writing || Z.corked) {
                var T = Z.lastBufferedRequest;
                Z.lastBufferedRequest = {
                  chunk: pe,
                  encoding: me,
                  isBuf: ue,
                  callback: L,
                  next: null
                }, T ? T.next = Z.lastBufferedRequest : Z.bufferedRequest = Z.lastBufferedRequest, Z.bufferedRequestCount += 1;
              } else
                U(te, Z, !1, D, pe, me, L);
              return E;
            }
            function U(te, Z, ue, pe, me, L, B) {
              Z.writelen = pe, Z.writecb = B, Z.writing = !0, Z.sync = !0, Z.destroyed ? Z.onwrite(new x("write")) : ue ? te._writev(me, Z.onwrite) : te._write(me, L, Z.onwrite), Z.sync = !1;
            }
            function G(te, Z, ue, pe, me) {
              --Z.pendingcb, ue ? (o.nextTick(me, pe), o.nextTick(ve, te, Z), te._writableState.errorEmitted = !0, Q(te, pe)) : (me(pe), te._writableState.errorEmitted = !0, Q(te, pe), ve(te, Z));
            }
            function re(te) {
              te.writing = !1, te.writecb = null, te.length -= te.writelen, te.writelen = 0;
            }
            function oe(te, Z) {
              var ue = te._writableState, pe = ue.sync, me = ue.writecb;
              if (typeof me != "function") throw new k();
              if (re(ue), Z) G(te, ue, pe, Z, me);
              else {
                var L = ye(ue) || te.destroyed;
                !L && !ue.corked && !ue.bufferProcessing && ue.bufferedRequest && he(te, ue), pe ? o.nextTick(ie, te, ue, L, me) : ie(te, ue, L, me);
              }
            }
            function ie(te, Z, ue, pe) {
              ue || le(te, Z), Z.pendingcb--, pe(), ve(te, Z);
            }
            function le(te, Z) {
              Z.length === 0 && Z.needDrain && (Z.needDrain = !1, te.emit("drain"));
            }
            function he(te, Z) {
              Z.bufferProcessing = !0;
              var ue = Z.bufferedRequest;
              if (te._writev && ue && ue.next) {
                var pe = Z.bufferedRequestCount, me = new Array(pe), L = Z.corkedRequestsFree;
                L.entry = ue;
                for (var B = 0, D = !0; ue; )
                  me[B] = ue, ue.isBuf || (D = !1), ue = ue.next, B += 1;
                me.allBuffers = D, U(te, Z, !0, Z.length, me, "", L.finish), Z.pendingcb++, Z.lastBufferedRequest = null, L.next ? (Z.corkedRequestsFree = L.next, L.next = null) : Z.corkedRequestsFree = new a(Z), Z.bufferedRequestCount = 0;
              } else {
                for (; ue; ) {
                  var E = ue.chunk, T = ue.encoding, j = ue.callback, Y = Z.objectMode ? 1 : E.length;
                  if (U(te, Z, !1, Y, E, T, j), ue = ue.next, Z.bufferedRequestCount--, Z.writing)
                    break;
                }
                ue === null && (Z.lastBufferedRequest = null);
              }
              Z.bufferedRequest = ue, Z.bufferProcessing = !1;
            }
            P.prototype._write = function(te, Z, ue) {
              ue(new b("_write()"));
            }, P.prototype._writev = null, P.prototype.end = function(te, Z, ue) {
              var pe = this._writableState;
              return typeof te == "function" ? (ue = te, te = null, Z = null) : typeof Z == "function" && (ue = Z, Z = null), te != null && this.write(te, Z), pe.corked && (pe.corked = 1, this.uncork()), pe.ending || Re(this, pe, ue), this;
            }, Object.defineProperty(P.prototype, "writableLength", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState.length;
              }
            });
            function ye(te) {
              return te.ending && te.length === 0 && te.bufferedRequest === null && !te.finished && !te.writing;
            }
            function be(te, Z) {
              te._final(function(ue) {
                Z.pendingcb--, ue && Q(te, ue), Z.prefinished = !0, te.emit("prefinish"), ve(te, Z);
              });
            }
            function we(te, Z) {
              !Z.prefinished && !Z.finalCalled && (typeof te._final == "function" && !Z.destroyed ? (Z.pendingcb++, Z.finalCalled = !0, o.nextTick(be, te, Z)) : (Z.prefinished = !0, te.emit("prefinish")));
            }
            function ve(te, Z) {
              var ue = ye(Z);
              if (ue && (we(te, Z), Z.pendingcb === 0 && (Z.finished = !0, te.emit("finish"), Z.autoDestroy))) {
                var pe = te._readableState;
                (!pe || pe.autoDestroy && pe.endEmitted) && te.destroy();
              }
              return ue;
            }
            function Re(te, Z, ue) {
              Z.ending = !0, ve(te, Z), ue && (Z.finished ? o.nextTick(ue) : te.once("finish", ue)), Z.ended = !0, te.writable = !1;
            }
            function De(te, Z, ue) {
              var pe = te.entry;
              for (te.entry = null; pe; ) {
                var me = pe.callback;
                Z.pendingcb--, me(ue), pe = pe.next;
              }
              Z.corkedRequestsFree.next = te;
            }
            Object.defineProperty(P.prototype, "destroyed", {
              // making it explicit this property is not enumerable
              // because otherwise some prototype manipulation in
              // userland will fail
              enumerable: !1,
              get: function() {
                return this._writableState === void 0 ? !1 : this._writableState.destroyed;
              },
              set: function(Z) {
                this._writableState && (this._writableState.destroyed = Z);
              }
            }), P.prototype.destroy = m.destroy, P.prototype._undestroy = m.undestroy, P.prototype._destroy = function(te, Z) {
              Z(te);
            };
          }).call(this);
        }).call(this, r("_process"), typeof Ne < "u" ? Ne : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, { "../errors": 42, "./_stream_duplex": 43, "./internal/streams/destroy": 50, "./internal/streams/state": 54, "./internal/streams/stream": 55, _process: 39, buffer: 35, inherits: 38, "util-deprecate": 57 }], 48: [function(r, i, n) {
        (function(o) {
          (function() {
            var s;
            function a(x, C, I) {
              return C in x ? Object.defineProperty(x, C, { value: I, enumerable: !0, configurable: !0, writable: !0 }) : x[C] = I, x;
            }
            var u = r("./end-of-stream"), l = Symbol("lastResolve"), c = Symbol("lastReject"), d = Symbol("error"), h = Symbol("ended"), f = Symbol("lastPromise"), p = Symbol("handlePromise"), m = Symbol("stream");
            function w(x, C) {
              return {
                value: x,
                done: C
              };
            }
            function v(x) {
              var C = x[l];
              if (C !== null) {
                var I = x[m].read();
                I !== null && (x[f] = null, x[l] = null, x[c] = null, C(w(I, !1)));
              }
            }
            function g(x) {
              o.nextTick(v, x);
            }
            function A(x, C) {
              return function(I, M) {
                x.then(function() {
                  if (C[h]) {
                    I(w(void 0, !0));
                    return;
                  }
                  C[p](I, M);
                }, M);
              };
            }
            var b = Object.getPrototypeOf(function() {
            }), k = Object.setPrototypeOf((s = {
              get stream() {
                return this[m];
              },
              next: function() {
                var C = this, I = this[d];
                if (I !== null)
                  return Promise.reject(I);
                if (this[h])
                  return Promise.resolve(w(void 0, !0));
                if (this[m].destroyed)
                  return new Promise(function(J, W) {
                    o.nextTick(function() {
                      C[d] ? W(C[d]) : J(w(void 0, !0));
                    });
                  });
                var M = this[f], Q;
                if (M)
                  Q = new Promise(A(M, this));
                else {
                  var H = this[m].read();
                  if (H !== null)
                    return Promise.resolve(w(H, !1));
                  Q = new Promise(this[p]);
                }
                return this[f] = Q, Q;
              }
            }, a(s, Symbol.asyncIterator, function() {
              return this;
            }), a(s, "return", function() {
              var C = this;
              return new Promise(function(I, M) {
                C[m].destroy(null, function(Q) {
                  if (Q) {
                    M(Q);
                    return;
                  }
                  I(w(void 0, !0));
                });
              });
            }), s), b), y = function(C) {
              var I, M = Object.create(k, (I = {}, a(I, m, {
                value: C,
                writable: !0
              }), a(I, l, {
                value: null,
                writable: !0
              }), a(I, c, {
                value: null,
                writable: !0
              }), a(I, d, {
                value: null,
                writable: !0
              }), a(I, h, {
                value: C._readableState.endEmitted,
                writable: !0
              }), a(I, p, {
                value: function(H, J) {
                  var W = M[m].read();
                  W ? (M[f] = null, M[l] = null, M[c] = null, H(w(W, !1))) : (M[l] = H, M[c] = J);
                },
                writable: !0
              }), I));
              return M[f] = null, u(C, function(Q) {
                if (Q && Q.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                  var H = M[c];
                  H !== null && (M[f] = null, M[l] = null, M[c] = null, H(Q)), M[d] = Q;
                  return;
                }
                var J = M[l];
                J !== null && (M[f] = null, M[l] = null, M[c] = null, J(w(void 0, !0))), M[h] = !0;
              }), C.on("readable", g.bind(null, M)), M;
            };
            i.exports = y;
          }).call(this);
        }).call(this, r("_process"));
      }, { "./end-of-stream": 51, _process: 39 }], 49: [function(r, i, n) {
        function o(v, g) {
          var A = Object.keys(v);
          if (Object.getOwnPropertySymbols) {
            var b = Object.getOwnPropertySymbols(v);
            g && (b = b.filter(function(k) {
              return Object.getOwnPropertyDescriptor(v, k).enumerable;
            })), A.push.apply(A, b);
          }
          return A;
        }
        function s(v) {
          for (var g = 1; g < arguments.length; g++) {
            var A = arguments[g] != null ? arguments[g] : {};
            g % 2 ? o(Object(A), !0).forEach(function(b) {
              a(v, b, A[b]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(v, Object.getOwnPropertyDescriptors(A)) : o(Object(A)).forEach(function(b) {
              Object.defineProperty(v, b, Object.getOwnPropertyDescriptor(A, b));
            });
          }
          return v;
        }
        function a(v, g, A) {
          return g in v ? Object.defineProperty(v, g, { value: A, enumerable: !0, configurable: !0, writable: !0 }) : v[g] = A, v;
        }
        function u(v, g) {
          if (!(v instanceof g))
            throw new TypeError("Cannot call a class as a function");
        }
        function l(v, g) {
          for (var A = 0; A < g.length; A++) {
            var b = g[A];
            b.enumerable = b.enumerable || !1, b.configurable = !0, "value" in b && (b.writable = !0), Object.defineProperty(v, b.key, b);
          }
        }
        function c(v, g, A) {
          return g && l(v.prototype, g), v;
        }
        var d = r("buffer"), h = d.Buffer, f = r("util"), p = f.inspect, m = p && p.custom || "inspect";
        function w(v, g, A) {
          h.prototype.copy.call(v, g, A);
        }
        i.exports = /* @__PURE__ */ (function() {
          function v() {
            u(this, v), this.head = null, this.tail = null, this.length = 0;
          }
          return c(v, [{
            key: "push",
            value: function(A) {
              var b = {
                data: A,
                next: null
              };
              this.length > 0 ? this.tail.next = b : this.head = b, this.tail = b, ++this.length;
            }
          }, {
            key: "unshift",
            value: function(A) {
              var b = {
                data: A,
                next: this.head
              };
              this.length === 0 && (this.tail = b), this.head = b, ++this.length;
            }
          }, {
            key: "shift",
            value: function() {
              if (this.length !== 0) {
                var A = this.head.data;
                return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, A;
              }
            }
          }, {
            key: "clear",
            value: function() {
              this.head = this.tail = null, this.length = 0;
            }
          }, {
            key: "join",
            value: function(A) {
              if (this.length === 0) return "";
              for (var b = this.head, k = "" + b.data; b = b.next; )
                k += A + b.data;
              return k;
            }
          }, {
            key: "concat",
            value: function(A) {
              if (this.length === 0) return h.alloc(0);
              for (var b = h.allocUnsafe(A >>> 0), k = this.head, y = 0; k; )
                w(k.data, b, y), y += k.data.length, k = k.next;
              return b;
            }
            // Consumes a specified amount of bytes or characters from the buffered data.
          }, {
            key: "consume",
            value: function(A, b) {
              var k;
              return A < this.head.data.length ? (k = this.head.data.slice(0, A), this.head.data = this.head.data.slice(A)) : A === this.head.data.length ? k = this.shift() : k = b ? this._getString(A) : this._getBuffer(A), k;
            }
          }, {
            key: "first",
            value: function() {
              return this.head.data;
            }
            // Consumes a specified amount of characters from the buffered data.
          }, {
            key: "_getString",
            value: function(A) {
              var b = this.head, k = 1, y = b.data;
              for (A -= y.length; b = b.next; ) {
                var x = b.data, C = A > x.length ? x.length : A;
                if (C === x.length ? y += x : y += x.slice(0, A), A -= C, A === 0) {
                  C === x.length ? (++k, b.next ? this.head = b.next : this.head = this.tail = null) : (this.head = b, b.data = x.slice(C));
                  break;
                }
                ++k;
              }
              return this.length -= k, y;
            }
            // Consumes a specified amount of bytes from the buffered data.
          }, {
            key: "_getBuffer",
            value: function(A) {
              var b = h.allocUnsafe(A), k = this.head, y = 1;
              for (k.data.copy(b), A -= k.data.length; k = k.next; ) {
                var x = k.data, C = A > x.length ? x.length : A;
                if (x.copy(b, b.length - A, 0, C), A -= C, A === 0) {
                  C === x.length ? (++y, k.next ? this.head = k.next : this.head = this.tail = null) : (this.head = k, k.data = x.slice(C));
                  break;
                }
                ++y;
              }
              return this.length -= y, b;
            }
            // Make sure the linked list only shows the minimal necessary information.
          }, {
            key: m,
            value: function(A, b) {
              return p(this, s({}, b, {
                // Only inspect one level.
                depth: 0,
                // It should not recurse.
                customInspect: !1
              }));
            }
          }]), v;
        })();
      }, { buffer: 35, util: 33 }], 50: [function(r, i, n) {
        (function(o) {
          (function() {
            function s(h, f) {
              var p = this, m = this._readableState && this._readableState.destroyed, w = this._writableState && this._writableState.destroyed;
              return m || w ? (f ? f(h) : h && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, o.nextTick(c, this, h)) : o.nextTick(c, this, h)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(h || null, function(v) {
                !f && v ? p._writableState ? p._writableState.errorEmitted ? o.nextTick(u, p) : (p._writableState.errorEmitted = !0, o.nextTick(a, p, v)) : o.nextTick(a, p, v) : f ? (o.nextTick(u, p), f(v)) : o.nextTick(u, p);
              }), this);
            }
            function a(h, f) {
              c(h, f), u(h);
            }
            function u(h) {
              h._writableState && !h._writableState.emitClose || h._readableState && !h._readableState.emitClose || h.emit("close");
            }
            function l() {
              this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
            }
            function c(h, f) {
              h.emit("error", f);
            }
            function d(h, f) {
              var p = h._readableState, m = h._writableState;
              p && p.autoDestroy || m && m.autoDestroy ? h.destroy(f) : h.emit("error", f);
            }
            i.exports = {
              destroy: s,
              undestroy: l,
              errorOrDestroy: d
            };
          }).call(this);
        }).call(this, r("_process"));
      }, { _process: 39 }], 51: [function(r, i, n) {
        var o = r("../../../errors").codes.ERR_STREAM_PREMATURE_CLOSE;
        function s(c) {
          var d = !1;
          return function() {
            if (!d) {
              d = !0;
              for (var h = arguments.length, f = new Array(h), p = 0; p < h; p++)
                f[p] = arguments[p];
              c.apply(this, f);
            }
          };
        }
        function a() {
        }
        function u(c) {
          return c.setHeader && typeof c.abort == "function";
        }
        function l(c, d, h) {
          if (typeof d == "function") return l(c, null, d);
          d || (d = {}), h = s(h || a);
          var f = d.readable || d.readable !== !1 && c.readable, p = d.writable || d.writable !== !1 && c.writable, m = function() {
            c.writable || v();
          }, w = c._writableState && c._writableState.finished, v = function() {
            p = !1, w = !0, f || h.call(c);
          }, g = c._readableState && c._readableState.endEmitted, A = function() {
            f = !1, g = !0, p || h.call(c);
          }, b = function(C) {
            h.call(c, C);
          }, k = function() {
            var C;
            if (f && !g)
              return (!c._readableState || !c._readableState.ended) && (C = new o()), h.call(c, C);
            if (p && !w)
              return (!c._writableState || !c._writableState.ended) && (C = new o()), h.call(c, C);
          }, y = function() {
            c.req.on("finish", v);
          };
          return u(c) ? (c.on("complete", v), c.on("abort", k), c.req ? y() : c.on("request", y)) : p && !c._writableState && (c.on("end", m), c.on("close", m)), c.on("end", A), c.on("finish", v), d.error !== !1 && c.on("error", b), c.on("close", k), function() {
            c.removeListener("complete", v), c.removeListener("abort", k), c.removeListener("request", y), c.req && c.req.removeListener("finish", v), c.removeListener("end", m), c.removeListener("close", m), c.removeListener("finish", v), c.removeListener("end", A), c.removeListener("error", b), c.removeListener("close", k);
          };
        }
        i.exports = l;
      }, { "../../../errors": 42 }], 52: [function(r, i, n) {
        i.exports = function() {
          throw new Error("Readable.from is not available in the browser");
        };
      }, {}], 53: [function(r, i, n) {
        var o;
        function s(v) {
          var g = !1;
          return function() {
            g || (g = !0, v.apply(void 0, arguments));
          };
        }
        var a = r("../../../errors").codes, u = a.ERR_MISSING_ARGS, l = a.ERR_STREAM_DESTROYED;
        function c(v) {
          if (v) throw v;
        }
        function d(v) {
          return v.setHeader && typeof v.abort == "function";
        }
        function h(v, g, A, b) {
          b = s(b);
          var k = !1;
          v.on("close", function() {
            k = !0;
          }), o === void 0 && (o = r("./end-of-stream")), o(v, {
            readable: g,
            writable: A
          }, function(x) {
            if (x) return b(x);
            k = !0, b();
          });
          var y = !1;
          return function(x) {
            if (!k && !y) {
              if (y = !0, d(v)) return v.abort();
              if (typeof v.destroy == "function") return v.destroy();
              b(x || new l("pipe"));
            }
          };
        }
        function f(v) {
          v();
        }
        function p(v, g) {
          return v.pipe(g);
        }
        function m(v) {
          return !v.length || typeof v[v.length - 1] != "function" ? c : v.pop();
        }
        function w() {
          for (var v = arguments.length, g = new Array(v), A = 0; A < v; A++)
            g[A] = arguments[A];
          var b = m(g);
          if (Array.isArray(g[0]) && (g = g[0]), g.length < 2)
            throw new u("streams");
          var k, y = g.map(function(x, C) {
            var I = C < g.length - 1, M = C > 0;
            return h(x, I, M, function(Q) {
              k || (k = Q), Q && y.forEach(f), !I && (y.forEach(f), b(k));
            });
          });
          return g.reduce(p);
        }
        i.exports = w;
      }, { "../../../errors": 42, "./end-of-stream": 51 }], 54: [function(r, i, n) {
        var o = r("../../../errors").codes.ERR_INVALID_OPT_VALUE;
        function s(u, l, c) {
          return u.highWaterMark != null ? u.highWaterMark : l ? u[c] : null;
        }
        function a(u, l, c, d) {
          var h = s(l, d, c);
          if (h != null) {
            if (!(isFinite(h) && Math.floor(h) === h) || h < 0) {
              var f = d ? c : "highWaterMark";
              throw new o(f, h);
            }
            return Math.floor(h);
          }
          return u.objectMode ? 16 : 16 * 1024;
        }
        i.exports = {
          getHighWaterMark: a
        };
      }, { "../../../errors": 42 }], 55: [function(r, i, n) {
        i.exports = r("events").EventEmitter;
      }, { events: 36 }], 56: [function(r, i, n) {
        var o = r("safe-buffer").Buffer, s = o.isEncoding || function(y) {
          switch (y = "" + y, y && y.toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
            case "raw":
              return !0;
            default:
              return !1;
          }
        };
        function a(y) {
          if (!y) return "utf8";
          for (var x; ; )
            switch (y) {
              case "utf8":
              case "utf-8":
                return "utf8";
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return "utf16le";
              case "latin1":
              case "binary":
                return "latin1";
              case "base64":
              case "ascii":
              case "hex":
                return y;
              default:
                if (x) return;
                y = ("" + y).toLowerCase(), x = !0;
            }
        }
        function u(y) {
          var x = a(y);
          if (typeof x != "string" && (o.isEncoding === s || !s(y))) throw new Error("Unknown encoding: " + y);
          return x || y;
        }
        n.StringDecoder = l;
        function l(y) {
          this.encoding = u(y);
          var x;
          switch (this.encoding) {
            case "utf16le":
              this.text = w, this.end = v, x = 4;
              break;
            case "utf8":
              this.fillLast = f, x = 4;
              break;
            case "base64":
              this.text = g, this.end = A, x = 3;
              break;
            default:
              this.write = b, this.end = k;
              return;
          }
          this.lastNeed = 0, this.lastTotal = 0, this.lastChar = o.allocUnsafe(x);
        }
        l.prototype.write = function(y) {
          if (y.length === 0) return "";
          var x, C;
          if (this.lastNeed) {
            if (x = this.fillLast(y), x === void 0) return "";
            C = this.lastNeed, this.lastNeed = 0;
          } else
            C = 0;
          return C < y.length ? x ? x + this.text(y, C) : this.text(y, C) : x || "";
        }, l.prototype.end = m, l.prototype.text = p, l.prototype.fillLast = function(y) {
          if (this.lastNeed <= y.length)
            return y.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
          y.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, y.length), this.lastNeed -= y.length;
        };
        function c(y) {
          return y <= 127 ? 0 : y >> 5 === 6 ? 2 : y >> 4 === 14 ? 3 : y >> 3 === 30 ? 4 : y >> 6 === 2 ? -1 : -2;
        }
        function d(y, x, C) {
          var I = x.length - 1;
          if (I < C) return 0;
          var M = c(x[I]);
          return M >= 0 ? (M > 0 && (y.lastNeed = M - 1), M) : --I < C || M === -2 ? 0 : (M = c(x[I]), M >= 0 ? (M > 0 && (y.lastNeed = M - 2), M) : --I < C || M === -2 ? 0 : (M = c(x[I]), M >= 0 ? (M > 0 && (M === 2 ? M = 0 : y.lastNeed = M - 3), M) : 0));
        }
        function h(y, x, C) {
          if ((x[0] & 192) !== 128)
            return y.lastNeed = 0, "�";
          if (y.lastNeed > 1 && x.length > 1) {
            if ((x[1] & 192) !== 128)
              return y.lastNeed = 1, "�";
            if (y.lastNeed > 2 && x.length > 2 && (x[2] & 192) !== 128)
              return y.lastNeed = 2, "�";
          }
        }
        function f(y) {
          var x = this.lastTotal - this.lastNeed, C = h(this, y);
          if (C !== void 0) return C;
          if (this.lastNeed <= y.length)
            return y.copy(this.lastChar, x, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
          y.copy(this.lastChar, x, 0, y.length), this.lastNeed -= y.length;
        }
        function p(y, x) {
          var C = d(this, y, x);
          if (!this.lastNeed) return y.toString("utf8", x);
          this.lastTotal = C;
          var I = y.length - (C - this.lastNeed);
          return y.copy(this.lastChar, 0, I), y.toString("utf8", x, I);
        }
        function m(y) {
          var x = y && y.length ? this.write(y) : "";
          return this.lastNeed ? x + "�" : x;
        }
        function w(y, x) {
          if ((y.length - x) % 2 === 0) {
            var C = y.toString("utf16le", x);
            if (C) {
              var I = C.charCodeAt(C.length - 1);
              if (I >= 55296 && I <= 56319)
                return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = y[y.length - 2], this.lastChar[1] = y[y.length - 1], C.slice(0, -1);
            }
            return C;
          }
          return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = y[y.length - 1], y.toString("utf16le", x, y.length - 1);
        }
        function v(y) {
          var x = y && y.length ? this.write(y) : "";
          if (this.lastNeed) {
            var C = this.lastTotal - this.lastNeed;
            return x + this.lastChar.toString("utf16le", 0, C);
          }
          return x;
        }
        function g(y, x) {
          var C = (y.length - x) % 3;
          return C === 0 ? y.toString("base64", x) : (this.lastNeed = 3 - C, this.lastTotal = 3, C === 1 ? this.lastChar[0] = y[y.length - 1] : (this.lastChar[0] = y[y.length - 2], this.lastChar[1] = y[y.length - 1]), y.toString("base64", x, y.length - C));
        }
        function A(y) {
          var x = y && y.length ? this.write(y) : "";
          return this.lastNeed ? x + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : x;
        }
        function b(y) {
          return y.toString(this.encoding);
        }
        function k(y) {
          return y && y.length ? this.write(y) : "";
        }
      }, { "safe-buffer": 40 }], 57: [function(r, i, n) {
        (function(o) {
          (function() {
            i.exports = s;
            function s(u, l) {
              if (a("noDeprecation"))
                return u;
              var c = !1;
              function d() {
                if (!c) {
                  if (a("throwDeprecation"))
                    throw new Error(l);
                  a("traceDeprecation") ? console.trace(l) : console.warn(l), c = !0;
                }
                return u.apply(this, arguments);
              }
              return d;
            }
            function a(u) {
              try {
                if (!o.localStorage) return !1;
              } catch {
                return !1;
              }
              var l = o.localStorage[u];
              return l == null ? !1 : String(l).toLowerCase() === "true";
            }
          }).call(this);
        }).call(this, typeof Ne < "u" ? Ne : typeof self < "u" ? self : typeof window < "u" ? window : {});
      }, {}], 58: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), Object.defineProperty(n, "v1", {
          enumerable: !0,
          get: function() {
            return o.default;
          }
        }), Object.defineProperty(n, "v3", {
          enumerable: !0,
          get: function() {
            return s.default;
          }
        }), Object.defineProperty(n, "v4", {
          enumerable: !0,
          get: function() {
            return a.default;
          }
        }), Object.defineProperty(n, "v5", {
          enumerable: !0,
          get: function() {
            return u.default;
          }
        }), Object.defineProperty(n, "NIL", {
          enumerable: !0,
          get: function() {
            return l.default;
          }
        }), Object.defineProperty(n, "version", {
          enumerable: !0,
          get: function() {
            return c.default;
          }
        }), Object.defineProperty(n, "validate", {
          enumerable: !0,
          get: function() {
            return d.default;
          }
        }), Object.defineProperty(n, "stringify", {
          enumerable: !0,
          get: function() {
            return h.default;
          }
        }), Object.defineProperty(n, "parse", {
          enumerable: !0,
          get: function() {
            return f.default;
          }
        });
        var o = p(r("./v1.js")), s = p(r("./v3.js")), a = p(r("./v4.js")), u = p(r("./v5.js")), l = p(r("./nil.js")), c = p(r("./version.js")), d = p(r("./validate.js")), h = p(r("./stringify.js")), f = p(r("./parse.js"));
        function p(m) {
          return m && m.__esModule ? m : { default: m };
        }
      }, { "./nil.js": 60, "./parse.js": 61, "./stringify.js": 65, "./v1.js": 66, "./v3.js": 67, "./v4.js": 69, "./v5.js": 70, "./validate.js": 71, "./version.js": 72 }], 59: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = void 0;
        function o(g) {
          if (typeof g == "string") {
            const A = unescape(encodeURIComponent(g));
            g = new Uint8Array(A.length);
            for (let b = 0; b < A.length; ++b)
              g[b] = A.charCodeAt(b);
          }
          return s(u(l(g), g.length * 8));
        }
        function s(g) {
          const A = [], b = g.length * 32, k = "0123456789abcdef";
          for (let y = 0; y < b; y += 8) {
            const x = g[y >> 5] >>> y % 32 & 255, C = parseInt(k.charAt(x >>> 4 & 15) + k.charAt(x & 15), 16);
            A.push(C);
          }
          return A;
        }
        function a(g) {
          return (g + 64 >>> 9 << 4) + 14 + 1;
        }
        function u(g, A) {
          g[A >> 5] |= 128 << A % 32, g[a(A) - 1] = A;
          let b = 1732584193, k = -271733879, y = -1732584194, x = 271733878;
          for (let C = 0; C < g.length; C += 16) {
            const I = b, M = k, Q = y, H = x;
            b = f(b, k, y, x, g[C], 7, -680876936), x = f(x, b, k, y, g[C + 1], 12, -389564586), y = f(y, x, b, k, g[C + 2], 17, 606105819), k = f(k, y, x, b, g[C + 3], 22, -1044525330), b = f(b, k, y, x, g[C + 4], 7, -176418897), x = f(x, b, k, y, g[C + 5], 12, 1200080426), y = f(y, x, b, k, g[C + 6], 17, -1473231341), k = f(k, y, x, b, g[C + 7], 22, -45705983), b = f(b, k, y, x, g[C + 8], 7, 1770035416), x = f(x, b, k, y, g[C + 9], 12, -1958414417), y = f(y, x, b, k, g[C + 10], 17, -42063), k = f(k, y, x, b, g[C + 11], 22, -1990404162), b = f(b, k, y, x, g[C + 12], 7, 1804603682), x = f(x, b, k, y, g[C + 13], 12, -40341101), y = f(y, x, b, k, g[C + 14], 17, -1502002290), k = f(k, y, x, b, g[C + 15], 22, 1236535329), b = p(b, k, y, x, g[C + 1], 5, -165796510), x = p(x, b, k, y, g[C + 6], 9, -1069501632), y = p(y, x, b, k, g[C + 11], 14, 643717713), k = p(k, y, x, b, g[C], 20, -373897302), b = p(b, k, y, x, g[C + 5], 5, -701558691), x = p(x, b, k, y, g[C + 10], 9, 38016083), y = p(y, x, b, k, g[C + 15], 14, -660478335), k = p(k, y, x, b, g[C + 4], 20, -405537848), b = p(b, k, y, x, g[C + 9], 5, 568446438), x = p(x, b, k, y, g[C + 14], 9, -1019803690), y = p(y, x, b, k, g[C + 3], 14, -187363961), k = p(k, y, x, b, g[C + 8], 20, 1163531501), b = p(b, k, y, x, g[C + 13], 5, -1444681467), x = p(x, b, k, y, g[C + 2], 9, -51403784), y = p(y, x, b, k, g[C + 7], 14, 1735328473), k = p(k, y, x, b, g[C + 12], 20, -1926607734), b = m(b, k, y, x, g[C + 5], 4, -378558), x = m(x, b, k, y, g[C + 8], 11, -2022574463), y = m(y, x, b, k, g[C + 11], 16, 1839030562), k = m(k, y, x, b, g[C + 14], 23, -35309556), b = m(b, k, y, x, g[C + 1], 4, -1530992060), x = m(x, b, k, y, g[C + 4], 11, 1272893353), y = m(y, x, b, k, g[C + 7], 16, -155497632), k = m(k, y, x, b, g[C + 10], 23, -1094730640), b = m(b, k, y, x, g[C + 13], 4, 681279174), x = m(x, b, k, y, g[C], 11, -358537222), y = m(y, x, b, k, g[C + 3], 16, -722521979), k = m(k, y, x, b, g[C + 6], 23, 76029189), b = m(b, k, y, x, g[C + 9], 4, -640364487), x = m(x, b, k, y, g[C + 12], 11, -421815835), y = m(y, x, b, k, g[C + 15], 16, 530742520), k = m(k, y, x, b, g[C + 2], 23, -995338651), b = w(b, k, y, x, g[C], 6, -198630844), x = w(x, b, k, y, g[C + 7], 10, 1126891415), y = w(y, x, b, k, g[C + 14], 15, -1416354905), k = w(k, y, x, b, g[C + 5], 21, -57434055), b = w(b, k, y, x, g[C + 12], 6, 1700485571), x = w(x, b, k, y, g[C + 3], 10, -1894986606), y = w(y, x, b, k, g[C + 10], 15, -1051523), k = w(k, y, x, b, g[C + 1], 21, -2054922799), b = w(b, k, y, x, g[C + 8], 6, 1873313359), x = w(x, b, k, y, g[C + 15], 10, -30611744), y = w(y, x, b, k, g[C + 6], 15, -1560198380), k = w(k, y, x, b, g[C + 13], 21, 1309151649), b = w(b, k, y, x, g[C + 4], 6, -145523070), x = w(x, b, k, y, g[C + 11], 10, -1120210379), y = w(y, x, b, k, g[C + 2], 15, 718787259), k = w(k, y, x, b, g[C + 9], 21, -343485551), b = c(b, I), k = c(k, M), y = c(y, Q), x = c(x, H);
          }
          return [b, k, y, x];
        }
        function l(g) {
          if (g.length === 0)
            return [];
          const A = g.length * 8, b = new Uint32Array(a(A));
          for (let k = 0; k < A; k += 8)
            b[k >> 5] |= (g[k / 8] & 255) << k % 32;
          return b;
        }
        function c(g, A) {
          const b = (g & 65535) + (A & 65535);
          return (g >> 16) + (A >> 16) + (b >> 16) << 16 | b & 65535;
        }
        function d(g, A) {
          return g << A | g >>> 32 - A;
        }
        function h(g, A, b, k, y, x) {
          return c(d(c(c(A, g), c(k, x)), y), b);
        }
        function f(g, A, b, k, y, x, C) {
          return h(A & b | ~A & k, g, A, y, x, C);
        }
        function p(g, A, b, k, y, x, C) {
          return h(A & k | b & ~k, g, A, y, x, C);
        }
        function m(g, A, b, k, y, x, C) {
          return h(A ^ b ^ k, g, A, y, x, C);
        }
        function w(g, A, b, k, y, x, C) {
          return h(b ^ (A | ~k), g, A, y, x, C);
        }
        var v = o;
        n.default = v;
      }, {}], 60: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = void 0;
        var o = "00000000-0000-0000-0000-000000000000";
        n.default = o;
      }, {}], 61: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = void 0;
        var o = s(r("./validate.js"));
        function s(l) {
          return l && l.__esModule ? l : { default: l };
        }
        function a(l) {
          if (!(0, o.default)(l))
            throw TypeError("Invalid UUID");
          let c;
          const d = new Uint8Array(16);
          return d[0] = (c = parseInt(l.slice(0, 8), 16)) >>> 24, d[1] = c >>> 16 & 255, d[2] = c >>> 8 & 255, d[3] = c & 255, d[4] = (c = parseInt(l.slice(9, 13), 16)) >>> 8, d[5] = c & 255, d[6] = (c = parseInt(l.slice(14, 18), 16)) >>> 8, d[7] = c & 255, d[8] = (c = parseInt(l.slice(19, 23), 16)) >>> 8, d[9] = c & 255, d[10] = (c = parseInt(l.slice(24, 36), 16)) / 1099511627776 & 255, d[11] = c / 4294967296 & 255, d[12] = c >>> 24 & 255, d[13] = c >>> 16 & 255, d[14] = c >>> 8 & 255, d[15] = c & 255, d;
        }
        var u = a;
        n.default = u;
      }, { "./validate.js": 71 }], 62: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = void 0;
        var o = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
        n.default = o;
      }, {}], 63: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = a;
        let o;
        const s = new Uint8Array(16);
        function a() {
          if (!o && (o = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !o))
            throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
          return o(s);
        }
      }, {}], 64: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = void 0;
        function o(l, c, d, h) {
          switch (l) {
            case 0:
              return c & d ^ ~c & h;
            case 1:
              return c ^ d ^ h;
            case 2:
              return c & d ^ c & h ^ d & h;
            case 3:
              return c ^ d ^ h;
          }
        }
        function s(l, c) {
          return l << c | l >>> 32 - c;
        }
        function a(l) {
          const c = [1518500249, 1859775393, 2400959708, 3395469782], d = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
          if (typeof l == "string") {
            const m = unescape(encodeURIComponent(l));
            l = [];
            for (let w = 0; w < m.length; ++w)
              l.push(m.charCodeAt(w));
          } else Array.isArray(l) || (l = Array.prototype.slice.call(l));
          l.push(128);
          const h = l.length / 4 + 2, f = Math.ceil(h / 16), p = new Array(f);
          for (let m = 0; m < f; ++m) {
            const w = new Uint32Array(16);
            for (let v = 0; v < 16; ++v)
              w[v] = l[m * 64 + v * 4] << 24 | l[m * 64 + v * 4 + 1] << 16 | l[m * 64 + v * 4 + 2] << 8 | l[m * 64 + v * 4 + 3];
            p[m] = w;
          }
          p[f - 1][14] = (l.length - 1) * 8 / Math.pow(2, 32), p[f - 1][14] = Math.floor(p[f - 1][14]), p[f - 1][15] = (l.length - 1) * 8 & 4294967295;
          for (let m = 0; m < f; ++m) {
            const w = new Uint32Array(80);
            for (let y = 0; y < 16; ++y)
              w[y] = p[m][y];
            for (let y = 16; y < 80; ++y)
              w[y] = s(w[y - 3] ^ w[y - 8] ^ w[y - 14] ^ w[y - 16], 1);
            let v = d[0], g = d[1], A = d[2], b = d[3], k = d[4];
            for (let y = 0; y < 80; ++y) {
              const x = Math.floor(y / 20), C = s(v, 5) + o(x, g, A, b) + k + c[x] + w[y] >>> 0;
              k = b, b = A, A = s(g, 30) >>> 0, g = v, v = C;
            }
            d[0] = d[0] + v >>> 0, d[1] = d[1] + g >>> 0, d[2] = d[2] + A >>> 0, d[3] = d[3] + b >>> 0, d[4] = d[4] + k >>> 0;
          }
          return [d[0] >> 24 & 255, d[0] >> 16 & 255, d[0] >> 8 & 255, d[0] & 255, d[1] >> 24 & 255, d[1] >> 16 & 255, d[1] >> 8 & 255, d[1] & 255, d[2] >> 24 & 255, d[2] >> 16 & 255, d[2] >> 8 & 255, d[2] & 255, d[3] >> 24 & 255, d[3] >> 16 & 255, d[3] >> 8 & 255, d[3] & 255, d[4] >> 24 & 255, d[4] >> 16 & 255, d[4] >> 8 & 255, d[4] & 255];
        }
        var u = a;
        n.default = u;
      }, {}], 65: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = void 0;
        var o = s(r("./validate.js"));
        function s(c) {
          return c && c.__esModule ? c : { default: c };
        }
        const a = [];
        for (let c = 0; c < 256; ++c)
          a.push((c + 256).toString(16).substr(1));
        function u(c, d = 0) {
          const h = (a[c[d + 0]] + a[c[d + 1]] + a[c[d + 2]] + a[c[d + 3]] + "-" + a[c[d + 4]] + a[c[d + 5]] + "-" + a[c[d + 6]] + a[c[d + 7]] + "-" + a[c[d + 8]] + a[c[d + 9]] + "-" + a[c[d + 10]] + a[c[d + 11]] + a[c[d + 12]] + a[c[d + 13]] + a[c[d + 14]] + a[c[d + 15]]).toLowerCase();
          if (!(0, o.default)(h))
            throw TypeError("Stringified UUID is invalid");
          return h;
        }
        var l = u;
        n.default = l;
      }, { "./validate.js": 71 }], 66: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = void 0;
        var o = a(r("./rng.js")), s = a(r("./stringify.js"));
        function a(p) {
          return p && p.__esModule ? p : { default: p };
        }
        let u, l, c = 0, d = 0;
        function h(p, m, w) {
          let v = m && w || 0;
          const g = m || new Array(16);
          p = p || {};
          let A = p.node || u, b = p.clockseq !== void 0 ? p.clockseq : l;
          if (A == null || b == null) {
            const M = p.random || (p.rng || o.default)();
            A == null && (A = u = [M[0] | 1, M[1], M[2], M[3], M[4], M[5]]), b == null && (b = l = (M[6] << 8 | M[7]) & 16383);
          }
          let k = p.msecs !== void 0 ? p.msecs : Date.now(), y = p.nsecs !== void 0 ? p.nsecs : d + 1;
          const x = k - c + (y - d) / 1e4;
          if (x < 0 && p.clockseq === void 0 && (b = b + 1 & 16383), (x < 0 || k > c) && p.nsecs === void 0 && (y = 0), y >= 1e4)
            throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
          c = k, d = y, l = b, k += 122192928e5;
          const C = ((k & 268435455) * 1e4 + y) % 4294967296;
          g[v++] = C >>> 24 & 255, g[v++] = C >>> 16 & 255, g[v++] = C >>> 8 & 255, g[v++] = C & 255;
          const I = k / 4294967296 * 1e4 & 268435455;
          g[v++] = I >>> 8 & 255, g[v++] = I & 255, g[v++] = I >>> 24 & 15 | 16, g[v++] = I >>> 16 & 255, g[v++] = b >>> 8 | 128, g[v++] = b & 255;
          for (let M = 0; M < 6; ++M)
            g[v + M] = A[M];
          return m || (0, s.default)(g);
        }
        var f = h;
        n.default = f;
      }, { "./rng.js": 63, "./stringify.js": 65 }], 67: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = void 0;
        var o = a(r("./v35.js")), s = a(r("./md5.js"));
        function a(c) {
          return c && c.__esModule ? c : { default: c };
        }
        var l = (0, o.default)("v3", 48, s.default);
        n.default = l;
      }, { "./md5.js": 59, "./v35.js": 68 }], 68: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = d, n.URL = n.DNS = void 0;
        var o = a(r("./stringify.js")), s = a(r("./parse.js"));
        function a(h) {
          return h && h.__esModule ? h : { default: h };
        }
        function u(h) {
          h = unescape(encodeURIComponent(h));
          const f = [];
          for (let p = 0; p < h.length; ++p)
            f.push(h.charCodeAt(p));
          return f;
        }
        const l = "6ba7b810-9dad-11d1-80b4-00c04fd430c8";
        n.DNS = l;
        const c = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
        n.URL = c;
        function d(h, f, p) {
          function m(w, v, g, A) {
            if (typeof w == "string" && (w = u(w)), typeof v == "string" && (v = (0, s.default)(v)), v.length !== 16)
              throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
            let b = new Uint8Array(16 + w.length);
            if (b.set(v), b.set(w, v.length), b = p(b), b[6] = b[6] & 15 | f, b[8] = b[8] & 63 | 128, g) {
              A = A || 0;
              for (let k = 0; k < 16; ++k)
                g[A + k] = b[k];
              return g;
            }
            return (0, o.default)(b);
          }
          try {
            m.name = h;
          } catch {
          }
          return m.DNS = l, m.URL = c, m;
        }
      }, { "./parse.js": 61, "./stringify.js": 65 }], 69: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = void 0;
        var o = a(r("./rng.js")), s = a(r("./stringify.js"));
        function a(c) {
          return c && c.__esModule ? c : { default: c };
        }
        function u(c, d, h) {
          c = c || {};
          const f = c.random || (c.rng || o.default)();
          if (f[6] = f[6] & 15 | 64, f[8] = f[8] & 63 | 128, d) {
            h = h || 0;
            for (let p = 0; p < 16; ++p)
              d[h + p] = f[p];
            return d;
          }
          return (0, s.default)(f);
        }
        var l = u;
        n.default = l;
      }, { "./rng.js": 63, "./stringify.js": 65 }], 70: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = void 0;
        var o = a(r("./v35.js")), s = a(r("./sha1.js"));
        function a(c) {
          return c && c.__esModule ? c : { default: c };
        }
        var l = (0, o.default)("v5", 80, s.default);
        n.default = l;
      }, { "./sha1.js": 64, "./v35.js": 68 }], 71: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = void 0;
        var o = s(r("./regex.js"));
        function s(l) {
          return l && l.__esModule ? l : { default: l };
        }
        function a(l) {
          return typeof l == "string" && o.default.test(l);
        }
        var u = a;
        n.default = u;
      }, { "./regex.js": 62 }], 72: [function(r, i, n) {
        Object.defineProperty(n, "__esModule", {
          value: !0
        }), n.default = void 0;
        var o = s(r("./validate.js"));
        function s(l) {
          return l && l.__esModule ? l : { default: l };
        }
        function a(l) {
          if (!(0, o.default)(l))
            throw TypeError("Invalid UUID");
          return parseInt(l.substr(14, 1), 16);
        }
        var u = a;
        n.default = u;
      }, { "./validate.js": 71 }] }, {}, [9])(9);
    });
  })(Cs)), Cs.exports;
}
var Rs = {}, Xp;
function Jw() {
  return Xp || (Xp = 1, (function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    function t() {
      var i = {};
      return i.promise = new Promise(function(n, o) {
        i.reject = o, i.resolve = n;
      }), i;
    }
    var r = t;
    e.default = r;
  })(Rs)), Rs;
}
var An = { exports: {} }, e0;
function Zw() {
  return e0 || (e0 = 1, (function(e, t) {
    var r = typeof globalThis < "u" && globalThis || typeof self < "u" && self || typeof Ne < "u" && Ne, i = (function() {
      function o() {
        this.fetch = !1, this.DOMException = r.DOMException;
      }
      return o.prototype = r, new o();
    })();
    (function(o) {
      (function(s) {
        var a = typeof o < "u" && o || typeof self < "u" && self || // eslint-disable-next-line no-undef
        typeof Ne < "u" && Ne || {}, u = {
          searchParams: "URLSearchParams" in a,
          iterable: "Symbol" in a && "iterator" in Symbol,
          blob: "FileReader" in a && "Blob" in a && (function() {
            try {
              return new Blob(), !0;
            } catch {
              return !1;
            }
          })(),
          formData: "FormData" in a,
          arrayBuffer: "ArrayBuffer" in a
        };
        function l(P) {
          return P && DataView.prototype.isPrototypeOf(P);
        }
        if (u.arrayBuffer)
          var c = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ], d = ArrayBuffer.isView || function(P) {
            return P && c.indexOf(Object.prototype.toString.call(P)) > -1;
          };
        function h(P) {
          if (typeof P != "string" && (P = String(P)), /[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(P) || P === "")
            throw new TypeError('Invalid character in header field name: "' + P + '"');
          return P.toLowerCase();
        }
        function f(P) {
          return typeof P != "string" && (P = String(P)), P;
        }
        function p(P) {
          var R = {
            next: function() {
              var V = P.shift();
              return { done: V === void 0, value: V };
            }
          };
          return u.iterable && (R[Symbol.iterator] = function() {
            return R;
          }), R;
        }
        function m(P) {
          this.map = {}, P instanceof m ? P.forEach(function(R, V) {
            this.append(V, R);
          }, this) : Array.isArray(P) ? P.forEach(function(R) {
            if (R.length != 2)
              throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + R.length);
            this.append(R[0], R[1]);
          }, this) : P && Object.getOwnPropertyNames(P).forEach(function(R) {
            this.append(R, P[R]);
          }, this);
        }
        m.prototype.append = function(P, R) {
          P = h(P), R = f(R);
          var V = this.map[P];
          this.map[P] = V ? V + ", " + R : R;
        }, m.prototype.delete = function(P) {
          delete this.map[h(P)];
        }, m.prototype.get = function(P) {
          return P = h(P), this.has(P) ? this.map[P] : null;
        }, m.prototype.has = function(P) {
          return this.map.hasOwnProperty(h(P));
        }, m.prototype.set = function(P, R) {
          this.map[h(P)] = f(R);
        }, m.prototype.forEach = function(P, R) {
          for (var V in this.map)
            this.map.hasOwnProperty(V) && P.call(R, this.map[V], V, this);
        }, m.prototype.keys = function() {
          var P = [];
          return this.forEach(function(R, V) {
            P.push(V);
          }), p(P);
        }, m.prototype.values = function() {
          var P = [];
          return this.forEach(function(R) {
            P.push(R);
          }), p(P);
        }, m.prototype.entries = function() {
          var P = [];
          return this.forEach(function(R, V) {
            P.push([V, R]);
          }), p(P);
        }, u.iterable && (m.prototype[Symbol.iterator] = m.prototype.entries);
        function w(P) {
          if (!P._noBody) {
            if (P.bodyUsed)
              return Promise.reject(new TypeError("Already read"));
            P.bodyUsed = !0;
          }
        }
        function v(P) {
          return new Promise(function(R, V) {
            P.onload = function() {
              R(P.result);
            }, P.onerror = function() {
              V(P.error);
            };
          });
        }
        function g(P) {
          var R = new FileReader(), V = v(R);
          return R.readAsArrayBuffer(P), V;
        }
        function A(P) {
          var R = new FileReader(), V = v(R), X = /charset=([A-Za-z0-9_-]+)/.exec(P.type), N = X ? X[1] : "utf-8";
          return R.readAsText(P, N), V;
        }
        function b(P) {
          for (var R = new Uint8Array(P), V = new Array(R.length), X = 0; X < R.length; X++)
            V[X] = String.fromCharCode(R[X]);
          return V.join("");
        }
        function k(P) {
          if (P.slice)
            return P.slice(0);
          var R = new Uint8Array(P.byteLength);
          return R.set(new Uint8Array(P)), R.buffer;
        }
        function y() {
          return this.bodyUsed = !1, this._initBody = function(P) {
            this.bodyUsed = this.bodyUsed, this._bodyInit = P, P ? typeof P == "string" ? this._bodyText = P : u.blob && Blob.prototype.isPrototypeOf(P) ? this._bodyBlob = P : u.formData && FormData.prototype.isPrototypeOf(P) ? this._bodyFormData = P : u.searchParams && URLSearchParams.prototype.isPrototypeOf(P) ? this._bodyText = P.toString() : u.arrayBuffer && u.blob && l(P) ? (this._bodyArrayBuffer = k(P.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : u.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(P) || d(P)) ? this._bodyArrayBuffer = k(P) : this._bodyText = P = Object.prototype.toString.call(P) : (this._noBody = !0, this._bodyText = ""), this.headers.get("content-type") || (typeof P == "string" ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : u.searchParams && URLSearchParams.prototype.isPrototypeOf(P) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
          }, u.blob && (this.blob = function() {
            var P = w(this);
            if (P)
              return P;
            if (this._bodyBlob)
              return Promise.resolve(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(new Blob([this._bodyArrayBuffer]));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as blob");
            return Promise.resolve(new Blob([this._bodyText]));
          }), this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              var P = w(this);
              return P || (ArrayBuffer.isView(this._bodyArrayBuffer) ? Promise.resolve(
                this._bodyArrayBuffer.buffer.slice(
                  this._bodyArrayBuffer.byteOffset,
                  this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                )
              ) : Promise.resolve(this._bodyArrayBuffer));
            } else {
              if (u.blob)
                return this.blob().then(g);
              throw new Error("could not read as ArrayBuffer");
            }
          }, this.text = function() {
            var P = w(this);
            if (P)
              return P;
            if (this._bodyBlob)
              return A(this._bodyBlob);
            if (this._bodyArrayBuffer)
              return Promise.resolve(b(this._bodyArrayBuffer));
            if (this._bodyFormData)
              throw new Error("could not read FormData body as text");
            return Promise.resolve(this._bodyText);
          }, u.formData && (this.formData = function() {
            return this.text().then(M);
          }), this.json = function() {
            return this.text().then(JSON.parse);
          }, this;
        }
        var x = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
        function C(P) {
          var R = P.toUpperCase();
          return x.indexOf(R) > -1 ? R : P;
        }
        function I(P, R) {
          if (!(this instanceof I))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          R = R || {};
          var V = R.body;
          if (P instanceof I) {
            if (P.bodyUsed)
              throw new TypeError("Already read");
            this.url = P.url, this.credentials = P.credentials, R.headers || (this.headers = new m(P.headers)), this.method = P.method, this.mode = P.mode, this.signal = P.signal, !V && P._bodyInit != null && (V = P._bodyInit, P.bodyUsed = !0);
          } else
            this.url = String(P);
          if (this.credentials = R.credentials || this.credentials || "same-origin", (R.headers || !this.headers) && (this.headers = new m(R.headers)), this.method = C(R.method || this.method || "GET"), this.mode = R.mode || this.mode || null, this.signal = R.signal || this.signal || (function() {
            if ("AbortController" in a) {
              var U = new AbortController();
              return U.signal;
            }
          })(), this.referrer = null, (this.method === "GET" || this.method === "HEAD") && V)
            throw new TypeError("Body not allowed for GET or HEAD requests");
          if (this._initBody(V), (this.method === "GET" || this.method === "HEAD") && (R.cache === "no-store" || R.cache === "no-cache")) {
            var X = /([?&])_=[^&]*/;
            if (X.test(this.url))
              this.url = this.url.replace(X, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
            else {
              var N = /\?/;
              this.url += (N.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
            }
          }
        }
        I.prototype.clone = function() {
          return new I(this, { body: this._bodyInit });
        };
        function M(P) {
          var R = new FormData();
          return P.trim().split("&").forEach(function(V) {
            if (V) {
              var X = V.split("="), N = X.shift().replace(/\+/g, " "), U = X.join("=").replace(/\+/g, " ");
              R.append(decodeURIComponent(N), decodeURIComponent(U));
            }
          }), R;
        }
        function Q(P) {
          var R = new m(), V = P.replace(/\r?\n[\t ]+/g, " ");
          return V.split("\r").map(function(X) {
            return X.indexOf(`
`) === 0 ? X.substr(1, X.length) : X;
          }).forEach(function(X) {
            var N = X.split(":"), U = N.shift().trim();
            if (U) {
              var G = N.join(":").trim();
              try {
                R.append(U, G);
              } catch (re) {
                console.warn("Response " + re.message);
              }
            }
          }), R;
        }
        y.call(I.prototype);
        function H(P, R) {
          if (!(this instanceof H))
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          if (R || (R = {}), this.type = "default", this.status = R.status === void 0 ? 200 : R.status, this.status < 200 || this.status > 599)
            throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
          this.ok = this.status >= 200 && this.status < 300, this.statusText = R.statusText === void 0 ? "" : "" + R.statusText, this.headers = new m(R.headers), this.url = R.url || "", this._initBody(P);
        }
        y.call(H.prototype), H.prototype.clone = function() {
          return new H(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new m(this.headers),
            url: this.url
          });
        }, H.error = function() {
          var P = new H(null, { status: 200, statusText: "" });
          return P.ok = !1, P.status = 0, P.type = "error", P;
        };
        var J = [301, 302, 303, 307, 308];
        H.redirect = function(P, R) {
          if (J.indexOf(R) === -1)
            throw new RangeError("Invalid status code");
          return new H(null, { status: R, headers: { location: P } });
        }, s.DOMException = a.DOMException;
        try {
          new s.DOMException();
        } catch {
          s.DOMException = function(R, V) {
            this.message = R, this.name = V;
            var X = Error(R);
            this.stack = X.stack;
          }, s.DOMException.prototype = Object.create(Error.prototype), s.DOMException.prototype.constructor = s.DOMException;
        }
        function W(P, R) {
          return new Promise(function(V, X) {
            var N = new I(P, R);
            if (N.signal && N.signal.aborted)
              return X(new s.DOMException("Aborted", "AbortError"));
            var U = new XMLHttpRequest();
            function G() {
              U.abort();
            }
            U.onload = function() {
              var ie = {
                statusText: U.statusText,
                headers: Q(U.getAllResponseHeaders() || "")
              };
              N.url.indexOf("file://") === 0 && (U.status < 200 || U.status > 599) ? ie.status = 200 : ie.status = U.status, ie.url = "responseURL" in U ? U.responseURL : ie.headers.get("X-Request-URL");
              var le = "response" in U ? U.response : U.responseText;
              setTimeout(function() {
                V(new H(le, ie));
              }, 0);
            }, U.onerror = function() {
              setTimeout(function() {
                X(new TypeError("Network request failed"));
              }, 0);
            }, U.ontimeout = function() {
              setTimeout(function() {
                X(new TypeError("Network request timed out"));
              }, 0);
            }, U.onabort = function() {
              setTimeout(function() {
                X(new s.DOMException("Aborted", "AbortError"));
              }, 0);
            };
            function re(ie) {
              try {
                return ie === "" && a.location.href ? a.location.href : ie;
              } catch {
                return ie;
              }
            }
            if (U.open(N.method, re(N.url), !0), N.credentials === "include" ? U.withCredentials = !0 : N.credentials === "omit" && (U.withCredentials = !1), "responseType" in U && (u.blob ? U.responseType = "blob" : u.arrayBuffer && (U.responseType = "arraybuffer")), R && typeof R.headers == "object" && !(R.headers instanceof m || a.Headers && R.headers instanceof a.Headers)) {
              var oe = [];
              Object.getOwnPropertyNames(R.headers).forEach(function(ie) {
                oe.push(h(ie)), U.setRequestHeader(ie, f(R.headers[ie]));
              }), N.headers.forEach(function(ie, le) {
                oe.indexOf(le) === -1 && U.setRequestHeader(le, ie);
              });
            } else
              N.headers.forEach(function(ie, le) {
                U.setRequestHeader(le, ie);
              });
            N.signal && (N.signal.addEventListener("abort", G), U.onreadystatechange = function() {
              U.readyState === 4 && N.signal.removeEventListener("abort", G);
            }), U.send(typeof N._bodyInit > "u" ? null : N._bodyInit);
          });
        }
        return W.polyfill = !0, a.fetch || (a.fetch = W, a.Headers = m, a.Request = I, a.Response = H), s.Headers = m, s.Request = I, s.Response = H, s.fetch = W, Object.defineProperty(s, "__esModule", { value: !0 }), s;
      })({});
    })(i), i.fetch.ponyfill = !0, delete i.fetch.polyfill;
    var n = r.fetch ? r : i;
    t = n.fetch, t.default = n.fetch, t.fetch = n.fetch, t.Headers = n.Headers, t.Request = n.Request, t.Response = n.Response, e.exports = t;
  })(An, An.exports)), An.exports;
}
var Os = {}, Ds = { exports: {} }, t0;
function Ig() {
  return t0 || (t0 = 1, (function(e) {
    function t(r) {
      if (r === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return r;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Ds)), Ds.exports;
}
var Ps = { exports: {} }, Is = { exports: {} }, Ms = { exports: {} }, r0;
function Mg() {
  return r0 || (r0 = 1, (function(e) {
    function t(r) {
      return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(i) {
        return i.__proto__ || Object.getPrototypeOf(i);
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Ms)), Ms.exports;
}
var n0;
function Xw() {
  return n0 || (n0 = 1, (function(e) {
    var t = Mg();
    function r(i, n) {
      for (; !{}.hasOwnProperty.call(i, n) && (i = t(i)) !== null; ) ;
      return i;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Is)), Is.exports;
}
var i0;
function e2() {
  return i0 || (i0 = 1, (function(e) {
    var t = Xw();
    function r() {
      return e.exports = r = typeof Reflect < "u" && Reflect.get ? Reflect.get.bind() : function(i, n, o) {
        var s = t(i, n);
        if (s) {
          var a = Object.getOwnPropertyDescriptor(s, n);
          return a.get ? a.get.call(arguments.length < 3 ? i : o) : a.value;
        }
      }, e.exports.__esModule = !0, e.exports.default = e.exports, r.apply(null, arguments);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Ps)), Ps.exports;
}
var js = { exports: {} }, Fs = { exports: {} }, o0;
function t2() {
  return o0 || (o0 = 1, (function(e) {
    function t(r, i) {
      return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
        return n.__proto__ = o, n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r, i);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(Fs)), Fs.exports;
}
var a0;
function r2() {
  return a0 || (a0 = 1, (function(e) {
    var t = t2();
    function r(i, n) {
      if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
      i.prototype = Object.create(n && n.prototype, {
        constructor: {
          value: i,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(i, "prototype", {
        writable: !1
      }), n && t(i, n);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  })(js)), js.exports;
}
var $s = { exports: {} }, s0;
function n2() {
  return s0 || (s0 = 1, (function(e) {
    var t = nr().default, r = Ig();
    function i(n, o) {
      if (o && (t(o) == "object" || typeof o == "function")) return o;
      if (o !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
      return r(n);
    }
    e.exports = i, e.exports.__esModule = !0, e.exports.default = e.exports;
  })($s)), $s.exports;
}
var u0;
function i2() {
  return u0 || (u0 = 1, (function(e) {
    var t = sn();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = t(Vu()), i = t(Gu()), n = t(Ig()), o = t(e2()), s = t(r2()), a = t(n2()), u = t(Mg()), l = t(Og()), c = t(Dg()), d = Pg();
    function h(A) {
      var b = f();
      return function() {
        var y = (0, u.default)(A), x;
        if (b) {
          var C = (0, u.default)(this).constructor;
          x = Reflect.construct(y, arguments, C);
        } else
          x = y.apply(this, arguments);
        return (0, a.default)(this, x);
      };
    }
    function f() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
      if (typeof Proxy == "function") return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var p = /* @__PURE__ */ new WeakMap(), m = /* @__PURE__ */ new WeakMap(), w = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap(), g = /* @__PURE__ */ (function(A) {
      (0, s.default)(k, A);
      var b = h(k);
      function k(y) {
        var x, C = y.disconnectionHandler, I = y.networkInformation, M = y.requestHandler, Q = y.url;
        return (0, r.default)(this, k), x = b.call(this, {
          disconnectionHandler: C,
          requestHandler: M,
          url: Q
        }), p.set((0, n.default)(x), {
          writable: !0,
          value: !1
        }), m.set((0, n.default)(x), {
          writable: !0,
          value: function() {
            return (0, l.default)((0, n.default)(x), w) === (0, l.default)((0, n.default)(x), v).type || x.disconnect();
          }
        }), w.set((0, n.default)(x), {
          writable: !0,
          value: void 0
        }), v.set((0, n.default)(x), {
          writable: !0,
          value: void 0
        }), (0, c.default)((0, n.default)(x), v, I), x;
      }
      return (0, i.default)(k, [{
        key: "connect",
        value: (
          // TODO: Better, the `NetworkInformation` instance should be passed to `BrowserWebSocketClient` -> `BrowserWebSocket`.
          //       `BrowserWebSocket` is where it creates `WebSocket` object.
          //       The `NetworkInformation` instance should accompany `WebSocket` and forcibly close it on abort.
          //       Maybe `botframework-streaming` should accept ponyfills.
          function() {
            if ((0, l.default)(this, p))
              return console.warn("botframework-directlinejs: connect() can only be called once."), Promise.resolve();
            if ((0, c.default)(this, p, !0), (0, l.default)(this, v)) {
              var x = (0, l.default)(this, v), C = x.type;
              if ((0, c.default)(this, w, C), C === "none")
                return console.warn("botframework-directlinejs: Failed to connect while offline."), Promise.reject(new Error("botframework-directlinejs: Failed to connect while offline."));
              (0, l.default)(this, v).addEventListener("change", (0, l.default)(this, m));
            }
            return (0, o.default)((0, u.default)(k.prototype), "connect", this).call(this);
          }
        )
      }, {
        key: "disconnect",
        value: function() {
          var x;
          (x = (0, l.default)(this, v)) === null || x === void 0 || x.removeEventListener("change", (0, l.default)(this, m)), (0, o.default)((0, u.default)(k.prototype), "disconnect", this).call(this);
        }
      }]), k;
    })(d.WebSocketClient);
    e.default = g;
  })(Os)), Os;
}
var c0;
function o2() {
  if (c0) return Lr;
  c0 = 1;
  var e = sn(), t = nr();
  Object.defineProperty(Lr, "__esModule", {
    value: !0
  }), Lr.DirectLineStreaming = void 0;
  var r = e(qm()), i = e(Bw()), n = e(Og()), o = e(Dg()), s = e(Ww()), a = e(Hw()), u = e(Vu()), l = e(Gu()), c = e(Um()), d = vg(), h = Yw(), f = Te(), p = k(Pg()), m = e(Jw()), w = e(Zw()), v = jg(), g = e(i2()), A = ["attachments"];
  function b(J) {
    if (typeof WeakMap != "function") return null;
    var W = /* @__PURE__ */ new WeakMap(), P = /* @__PURE__ */ new WeakMap();
    return (b = function(V) {
      return V ? P : W;
    })(J);
  }
  function k(J, W) {
    if (J && J.__esModule)
      return J;
    if (J === null || t(J) !== "object" && typeof J != "function")
      return { default: J };
    var P = b(W);
    if (P && P.has(J))
      return P.get(J);
    var R = {}, V = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var X in J)
      if (X !== "default" && Object.prototype.hasOwnProperty.call(J, X)) {
        var N = V ? Object.getOwnPropertyDescriptor(J, X) : null;
        N && (N.get || N.set) ? Object.defineProperty(R, X, N) : R[X] = J[X];
      }
    return R.default = J, P && P.set(J, R), R;
  }
  var y = "DirectLine/3.0", x = 3, C = 1800 * 1e3, I = C / 2, M = /* @__PURE__ */ (function() {
    function J(W, P, R) {
      (0, u.default)(this, J), (0, c.default)(this, "activityQueue", []), this.subscriber = W, this.connectionStatus$ = P, this.shouldQueue = R;
    }
    return (0, l.default)(J, [{
      key: "setSubscriber",
      value: function(P) {
        this.subscriber = P;
      }
    }, {
      key: "processRequest",
      value: (function() {
        var W = (0, a.default)(/* @__PURE__ */ i.default.mark(function R(V, X) {
          var N, U, G, re, oe, ie, le, he, ye;
          return i.default.wrap(function(we) {
            for (; ; )
              switch (we.prev = we.next) {
                case 0:
                  return N = (0, s.default)(V.streams), U = N.shift(), we.next = 4, U.readAsString();
                case 4:
                  if (G = we.sent, re = JSON.parse(G), re.activities.length === 1) {
                    we.next = 9;
                    break;
                  }
                  return this.subscriber.error(new Error("there should be exactly one activity")), we.abrupt("return", p.StreamingResponse.create(500));
                case 9:
                  if (oe = re.activities[0], !(N.length > 0)) {
                    we.next = 21;
                    break;
                  }
                  ie = (0, s.default)(oe.attachments);
                case 12:
                  if (!(le = N.shift())) {
                    we.next = 20;
                    break;
                  }
                  return we.next = 15, le.readAsString();
                case 15:
                  he = we.sent, ye = "data:text/plain;base64," + he, ie.push({
                    contentType: le.contentType,
                    contentUrl: ye
                  }), we.next = 12;
                  break;
                case 20:
                  oe.attachments = ie;
                case 21:
                  return this.shouldQueue() ? this.activityQueue.push(oe) : this.subscriber.next(oe), we.abrupt("return", p.StreamingResponse.create(200));
                case 23:
                case "end":
                  return we.stop();
              }
          }, R, this);
        }));
        function P(R, V) {
          return W.apply(this, arguments);
        }
        return P;
      })()
    }, {
      key: "flush",
      value: function() {
        var P = this;
        this.connectionStatus$.subscribe(function() {
        }), this.activityQueue.forEach(function(R) {
          return P.subscriber.next(R);
        }), this.activityQueue = [];
      }
    }, {
      key: "end",
      value: function() {
        this.subscriber.complete();
      }
    }]), J;
  })(), Q = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ (function() {
    function J(W) {
      var P = this;
      (0, u.default)(this, J), (0, c.default)(this, "connectionStatus$", new d.BehaviorSubject(v.ConnectionStatus.Uninitialized)), (0, c.default)(this, "_botAgent", ""), Q.set(this, {
        writable: !0,
        value: void 0
      });
      var R = W == null ? void 0 : W.networkInformation;
      typeof R > "u" || typeof R.addEventListener == "function" && typeof R.removeEventListener == "function" && typeof R.type == "string" ? (0, o.default)(this, Q, R) : console.warn('botframework-directlinejs: "networkInformation" option specified must be a `NetworkInformation`-like instance extending `EventTarget` interface with a `type` property returning a string.'), this.token = W.token, this.refreshToken().catch(function() {
        P.connectionStatus$.next(v.ConnectionStatus.ExpiredToken);
      }), this.domain = W.domain, W.conversationId && (this.conversationId = W.conversationId), this._botAgent = this.getBotAgent(W.botAgent), this.queueActivities = !0, this.activity$ = f.Observable.create(/* @__PURE__ */ (function() {
        var V = (0, a.default)(/* @__PURE__ */ i.default.mark(function X(N) {
          return i.default.wrap(function(G) {
            for (; ; )
              switch (G.prev = G.next) {
                case 0:
                  P.activitySubscriber = N, P.theStreamHandler = new M(N, P.connectionStatus$, function() {
                    return P.queueActivities;
                  }), P.connectDeferred.resolve();
                case 3:
                case "end":
                  return G.stop();
              }
          }, X);
        }));
        return function(X) {
          return V.apply(this, arguments);
        };
      })()).share(), this.connectWithRetryAsync();
    }
    return (0, l.default)(J, [{
      key: "reconnect",
      value: function(P) {
        var R = P.conversationId, V = P.token;
        if (this.connectionStatus$.getValue() === v.ConnectionStatus.Ended)
          throw new Error("Connection has ended.");
        this.conversationId = R, this.token = V, this.connectDeferred.resolve();
      }
    }, {
      key: "end",
      value: function() {
        this.activitySubscriber.complete(), this.connectionStatus$.next(v.ConnectionStatus.Ended), this.connectionStatus$.complete(), this.streamConnection.disconnect();
      }
    }, {
      key: "commonHeaders",
      value: function() {
        return {
          Authorization: "Bearer ".concat(this.token),
          "x-ms-bot-agent": this._botAgent
        };
      }
    }, {
      key: "getBotAgent",
      value: function() {
        var P = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", R = "directlineStreaming";
        return P && (R += "; ".concat(P)), "".concat(y, " (").concat(R, ")");
      }
    }, {
      key: "refreshToken",
      value: (function() {
        var W = (0, a.default)(/* @__PURE__ */ i.default.mark(function R() {
          var V, X, N, U;
          return i.default.wrap(function(re) {
            for (; ; )
              switch (re.prev = re.next) {
                case 0:
                  return re.next = 4, this.waitUntilOnline();
                case 4:
                  V = 0;
                case 5:
                  if (!(V < x)) {
                    re.next = 30;
                    break;
                  }
                  return V++, re.next = 9, new Promise(function(oe) {
                    return setTimeout(oe, I);
                  });
                case 9:
                  return re.prev = 9, re.next = 12, (0, w.default)("".concat(this.domain, "/tokens/refresh"), {
                    method: "POST",
                    headers: this.commonHeaders()
                  });
                case 12:
                  if (X = re.sent, !X.ok) {
                    re.next = 22;
                    break;
                  }
                  return V = 0, re.next = 17, X.json();
                case 17:
                  N = re.sent, U = N.token, this.token = U, re.next = 23;
                  break;
                case 22:
                  X.status === 403 || X.status === 403 ? (console.error("Fatal error while refreshing the token: ".concat(X.status, " ").concat(X.statusText)), this.streamConnection.disconnect()) : console.warn("Refresh attempt #".concat(V, " failed: ").concat(X.status, " ").concat(X.statusText));
                case 23:
                  re.next = 28;
                  break;
                case 25:
                  re.prev = 25, re.t0 = re.catch(9), console.warn("Refresh attempt #".concat(V, " threw an exception: ").concat(re.t0));
                case 28:
                  re.next = 5;
                  break;
                case 30:
                  console.error("Retries exhausted"), this.streamConnection.disconnect();
                case 32:
                case "end":
                  return re.stop();
              }
          }, R, this, [[9, 25]]);
        }));
        function P() {
          return W.apply(this, arguments);
        }
        return P;
      })()
    }, {
      key: "postActivity",
      value: function(P) {
        var R = this;
        if (this.connectionStatus$.value === v.ConnectionStatus.Ended || this.connectionStatus$.value === v.ConnectionStatus.FailedToConnect)
          return f.Observable.throw(new Error("Connection is closed"));
        if (P.type === "message" && P.attachments && P.attachments.length > 0)
          return this.postMessageWithAttachments(P);
        var V = f.Observable.create(/* @__PURE__ */ (function() {
          var X = (0, a.default)(/* @__PURE__ */ i.default.mark(function N(U) {
            var G, re, oe, ie, le, he;
            return i.default.wrap(function(be) {
              for (; ; )
                switch (be.prev = be.next) {
                  case 0:
                    return G = p.StreamingRequest.create("POST", "/v3/directline/conversations/" + R.conversationId + "/activities"), G.setBody(JSON.stringify(P)), be.prev = 2, be.next = 5, R.streamConnection.send(G);
                  case 5:
                    if (re = be.sent, re.statusCode === 200) {
                      be.next = 8;
                      break;
                    }
                    throw new Error("PostActivity returned " + re.statusCode);
                  case 8:
                    if (oe = re.streams.length, oe === 1) {
                      be.next = 11;
                      break;
                    }
                    throw new Error("Expected one stream but got " + oe);
                  case 11:
                    return be.next = 13, re.streams[0].readAsString();
                  case 13:
                    return ie = be.sent, le = JSON.parse(ie), he = le.Id, U.next(he), be.abrupt("return", U.complete());
                  case 19:
                    return be.prev = 19, be.t0 = be.catch(2), console.warn(be.t0), R.streamConnection.disconnect(), be.abrupt("return", U.error(be.t0));
                  case 24:
                  case "end":
                    return be.stop();
                }
            }, N, null, [[2, 19]]);
          }));
          return function(N) {
            return X.apply(this, arguments);
          };
        })());
        return V;
      }
    }, {
      key: "postMessageWithAttachments",
      value: function(P) {
        var R = this, V = P.attachments, X = (0, r.default)(P, A);
        return f.Observable.create(function(N) {
          var U = [];
          (0, a.default)(/* @__PURE__ */ i.default.mark(function G() {
            var re, oe, ie, le, he, ye, be;
            return i.default.wrap(function(ve) {
              for (; ; )
                switch (ve.prev = ve.next) {
                  case 0:
                    return ve.prev = 0, ve.next = 3, Promise.all(V.map(/* @__PURE__ */ (function() {
                      var Re = (0, a.default)(/* @__PURE__ */ i.default.mark(function De(te) {
                        var Z, ue;
                        return i.default.wrap(function(me) {
                          for (; ; )
                            switch (me.prev = me.next) {
                              case 0:
                                return Z = te, me.next = 3, (0, w.default)(Z.contentUrl);
                              case 3:
                                if (ue = me.sent, !ue.ok) {
                                  me.next = 12;
                                  break;
                                }
                                return me.next = 7, ue.arrayBuffer();
                              case 7:
                                return me.t0 = me.sent, me.t1 = Z, me.abrupt("return", {
                                  arrayBuffer: me.t0,
                                  media: me.t1
                                });
                              case 12:
                                throw new Error("...");
                              case 13:
                              case "end":
                                return me.stop();
                            }
                        }, De);
                      }));
                      return function(De) {
                        return Re.apply(this, arguments);
                      };
                    })()));
                  case 3:
                    return re = ve.sent, re.forEach(function(Re) {
                      var De = Re.arrayBuffer, te = Re.media, Z = h.Buffer.from(De), ue = new p.SubscribableStream();
                      ue.write(Z);
                      var pe = new p.HttpContent({
                        type: te.contentType,
                        contentLength: Z.length
                      }, ue);
                      U.push(pe);
                    }), oe = "/v3/directline/conversations/".concat(R.conversationId, "/users/").concat(X.from.id, "/upload"), ie = p.StreamingRequest.create("PUT", oe), le = new p.SubscribableStream(), le.write(JSON.stringify(X), "utf-8"), ie.addStream(new p.HttpContent({
                      type: "application/vnd.microsoft.activity",
                      contentLength: le.length
                    }, le)), U.forEach(function(Re) {
                      return ie.addStream(Re);
                    }), ve.next = 13, R.streamConnection.send(ie);
                  case 13:
                    if (he = ve.sent, !(he.streams && he.streams.length !== 1)) {
                      ve.next = 18;
                      break;
                    }
                    N.error(new Error("Invalid stream count ".concat(he.streams.length))), ve.next = 24;
                    break;
                  case 18:
                    return ve.next = 20, he.streams[0].readAsJson();
                  case 20:
                    ye = ve.sent, be = ye.Id, N.next(be), N.complete();
                  case 24:
                    ve.next = 29;
                    break;
                  case 26:
                    ve.prev = 26, ve.t0 = ve.catch(0), N.error(ve.t0);
                  case 29:
                  case "end":
                    return ve.stop();
                }
            }, G, null, [[0, 26]]);
          }))();
        });
      }
    }, {
      key: "waitUntilOnline",
      value: (function() {
        var W = (0, a.default)(/* @__PURE__ */ i.default.mark(function R() {
          var V = this;
          return i.default.wrap(function(N) {
            for (; ; )
              switch (N.prev = N.next) {
                case 0:
                  return N.abrupt("return", new Promise(function(U, G) {
                    V.connectionStatus$.subscribe(function(re) {
                      if (re === v.ConnectionStatus.Online)
                        return U();
                    }, function(re) {
                      return G(re);
                    });
                  }));
                case 1:
                case "end":
                  return N.stop();
              }
          }, R);
        }));
        function P() {
          return W.apply(this, arguments);
        }
        return P;
      })()
    }, {
      key: "connectAsync",
      value: (function() {
        var W = (0, a.default)(/* @__PURE__ */ i.default.mark(function R() {
          var V = this, X, N, U, G, re;
          return i.default.wrap(function(ie) {
            for (; ; )
              switch (ie.prev = ie.next) {
                case 0:
                  if (X = new RegExp("^http(s?)"), X.test(this.domain)) {
                    ie.next = 3;
                    break;
                  }
                  throw "Domain must begin with http or https";
                case 3:
                  return N = {
                    token: this.token
                  }, this.conversationId && (N.conversationId = this.conversationId), U = new AbortController(), G = new URLSearchParams(N).toString(), re = "".concat(this.domain.replace(X, "ws$1"), "/conversations/connect?").concat(G), ie.abrupt("return", new Promise(/* @__PURE__ */ (function() {
                    var le = (0, a.default)(/* @__PURE__ */ i.default.mark(function he(ye, be) {
                      var we, ve, Re, De;
                      return i.default.wrap(function(Z) {
                        for (; ; )
                          switch (Z.prev = Z.next) {
                            case 0:
                              return Z.prev = 0, V.streamConnection = new g.default({
                                disconnectionHandler: ye,
                                networkInformation: (0, n.default)(V, Q),
                                requestHandler: {
                                  processRequest: function(pe) {
                                    if (U.signal.aborted)
                                      throw new Error("Cannot process streaming request, `streamingConnection` should be disconnected.");
                                    return V.theStreamHandler.processRequest(pe);
                                  }
                                },
                                url: re
                              }), V.queueActivities = !0, Z.next = 5, V.streamConnection.connect();
                            case 5:
                              return we = p.StreamingRequest.create("POST", "/v3/directline/conversations"), Z.next = 8, V.streamConnection.send(we);
                            case 8:
                              if (ve = Z.sent, ve.statusCode === 200) {
                                Z.next = 11;
                                break;
                              }
                              throw new Error("Connection response code " + ve.statusCode);
                            case 11:
                              if (ve.streams.length === 1) {
                                Z.next = 13;
                                break;
                              }
                              throw new Error("Expected 1 stream but got " + ve.streams.length);
                            case 13:
                              return Z.next = 15, ve.streams[0].readAsString();
                            case 15:
                              return Re = Z.sent, De = JSON.parse(Re), V.conversationId = De.conversationId, V.connectionStatus$.next(v.ConnectionStatus.Online), Z.next = 21, V.waitUntilOnline();
                            case 21:
                              V.theStreamHandler.flush(), V.queueActivities = !1, Z.next = 28;
                              break;
                            case 25:
                              Z.prev = 25, Z.t0 = Z.catch(0), be(Z.t0);
                            case 28:
                            case "end":
                              return Z.stop();
                          }
                      }, he, null, [[0, 25]]);
                    }));
                    return function(he, ye) {
                      return le.apply(this, arguments);
                    };
                  })()).finally(function() {
                    return U.abort();
                  }));
                case 9:
                case "end":
                  return ie.stop();
              }
          }, R, this);
        }));
        function P() {
          return W.apply(this, arguments);
        }
        return P;
      })()
    }, {
      key: "connectWithRetryAsync",
      value: (function() {
        var W = (0, a.default)(/* @__PURE__ */ i.default.mark(function R() {
          var V = this, X, N;
          return i.default.wrap(function(G) {
            for (; ; )
              switch (G.prev = G.next) {
                case 0:
                  return G.next = 2, (this.connectDeferred = (0, m.default)()).promise;
                case 2:
                  X = x, this.connectionStatus$.next(v.ConnectionStatus.Connecting);
                case 4:
                  if (!(X > 0)) {
                    G.next = 27;
                    break;
                  }
                  return X--, N = Date.now(), G.prev = 7, G.next = 10, this.connectAsync();
                case 10:
                  G.next = 15;
                  break;
                case 12:
                  G.prev = 12, G.t0 = G.catch(7), console.error(G.t0);
                case 15:
                  if (this.connectionStatus$.getValue() !== v.ConnectionStatus.Ended) {
                    G.next = 17;
                    break;
                  }
                  return G.abrupt("return");
                case 17:
                  if (this.connectionStatus$.getValue() !== v.ConnectionStatus.Connecting && this.connectionStatus$.next(v.ConnectionStatus.Connecting), !(6e4 < Date.now() - N)) {
                    G.next = 22;
                    break;
                  }
                  X = x, G.next = 25;
                  break;
                case 22:
                  if (!(X > 0)) {
                    G.next = 25;
                    break;
                  }
                  return G.next = 25, new Promise(function(re) {
                    return setTimeout(re, V.getRetryDelay());
                  });
                case 25:
                  G.next = 4;
                  break;
                case 27:
                  this.connectionStatus$.next(v.ConnectionStatus.FailedToConnect);
                case 28:
                  G.next = 0;
                  break;
                case 30:
                case "end":
                  return G.stop();
              }
          }, R, this, [[7, 12]]);
        }));
        function P() {
          return W.apply(this, arguments);
        }
        return P;
      })()
      // Returns the delay duration in milliseconds
    }, {
      key: "getRetryDelay",
      value: function() {
        return Math.floor(3e3 + Math.random() * 12e3);
      }
    }]), J;
  })();
  return Lr.DirectLineStreaming = H, Lr;
}
var l0;
function jg() {
  return l0 || (l0 = 1, (function(e) {
    var t = sn(), r = nr();
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "DirectLineStreaming", {
      enumerable: !0,
      get: function() {
        return h.DirectLineStreaming;
      }
    }), e.DirectLine = e.ConnectionStatus = void 0;
    var i = t(qm()), n = t(Vu()), o = t(Gu()), s = t(Um());
    f1(), h1();
    var a = vg(), u = Te(), l = oi(), c = m(A1);
    O1(), M1(), $1(), q1(), V1(), H1(), Q1(), J1(), ew(), nw(), uw(), fw(), mw(), bw(), Sw(), Cw(), Ow(), Iw();
    var d = t(Lw()), h = o2(), f = ["contentUrl"];
    function p(W) {
      if (typeof WeakMap != "function") return null;
      var P = /* @__PURE__ */ new WeakMap(), R = /* @__PURE__ */ new WeakMap();
      return (p = function(X) {
        return X ? R : P;
      })(W);
    }
    function m(W, P) {
      if (W && W.__esModule)
        return W;
      if (W === null || r(W) !== "object" && typeof W != "function")
        return { default: W };
      var R = p(P);
      if (R && R.has(W))
        return R.get(W);
      var V = {}, X = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var N in W)
        if (N !== "default" && Object.prototype.hasOwnProperty.call(W, N)) {
          var U = X ? Object.getOwnPropertyDescriptor(W, N) : null;
          U && (U.get || U.set) ? Object.defineProperty(V, N, U) : V[N] = W[N];
        }
      return V.default = W, R && R.set(W, V), V;
    }
    function w(W, P) {
      var R = Object.keys(W);
      if (Object.getOwnPropertySymbols) {
        var V = Object.getOwnPropertySymbols(W);
        P && (V = V.filter(function(X) {
          return Object.getOwnPropertyDescriptor(W, X).enumerable;
        })), R.push.apply(R, V);
      }
      return R;
    }
    function v(W) {
      for (var P = 1; P < arguments.length; P++) {
        var R = arguments[P] != null ? arguments[P] : {};
        P % 2 ? w(Object(R), !0).forEach(function(V) {
          (0, s.default)(W, V, R[V]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(W, Object.getOwnPropertyDescriptors(R)) : w(Object(R)).forEach(function(V) {
          Object.defineProperty(W, V, Object.getOwnPropertyDescriptor(R, V));
        });
      }
      return W;
    }
    var g = "DirectLine/3.0", A;
    e.ConnectionStatus = A, (function(W) {
      W[W.Uninitialized = 0] = "Uninitialized", W[W.Connecting = 1] = "Connecting", W[W.Online = 2] = "Online", W[W.ExpiredToken = 3] = "ExpiredToken", W[W.FailedToConnect = 4] = "FailedToConnect", W[W.Ended = 5] = "Ended";
    })(A || (e.ConnectionStatus = A = {}));
    var b = function(P, R) {
      var V = function() {
        throw new Error("not implemented");
      }, X = function(G) {
        return G.catch(function(re) {
          if (re.status === 429) {
            var oe = re.xhr.getResponseHeader("Retry-After"), ie = Number(oe);
            if (!isNaN(ie))
              return u.Observable.timer(ie, R).flatMap(function(le) {
                return u.Observable.throw(re, R);
              });
          }
          return u.Observable.throw(re, R);
        });
      }, N = function(G) {
        return X(P(G));
      };
      return Object.assign(N, {
        get: function(G, re) {
          return V();
        },
        post: function(G, re, oe) {
          return V();
        },
        put: function(G, re, oe) {
          return V();
        },
        patch: function(G, re, oe) {
          return V();
        },
        delete: function(G, re) {
          return V();
        },
        getJSON: function(G, re) {
          return V();
        }
      });
    }, k = function(P) {
      var R = P.scheduler || l.async;
      return {
        scheduler: R,
        ajax: b(P.ajax || u.Observable.ajax, R),
        WebSocket: P.WebSocket || WebSocket,
        random: P.random || Math.random
      };
    }, y = 1800 * 1e3, x = y / 2, C = 200, I = new Error("expired token"), M = new Error("conversation ended"), Q = new Error("failed to connect"), H = {
      log: function(P) {
        for (var R, V = arguments.length, X = new Array(V > 1 ? V - 1 : 0), N = 1; N < V; N++)
          X[N - 1] = arguments[N];
        typeof window < "u" && window.botchatDebug && P && (R = console).log.apply(R, [P].concat(X));
      }
    }, J = /* @__PURE__ */ (function() {
      function W(P) {
        (0, n.default)(this, W), (0, s.default)(this, "connectionStatus$", new a.BehaviorSubject(A.Uninitialized)), (0, s.default)(this, "domain", "https://directline.botframework.com/v3/directline"), (0, s.default)(this, "watermark", ""), (0, s.default)(this, "_botAgent", ""), (0, s.default)(this, "timeout", 20 * 1e3), (0, s.default)(this, "pollingInterval", 1e3), this.secret = P.secret, this.token = P.secret || P.token, this.webSocket = (P.webSocket === void 0 ? !0 : P.webSocket) && typeof WebSocket < "u" && WebSocket !== void 0, P.streaming && (this.streaming = P.streaming), P.conversationStartProperties && P.conversationStartProperties.locale && (Object.prototype.toString.call(P.conversationStartProperties.locale) === "[object String]" ? this.localeOnStartConversation = P.conversationStartProperties.locale : console.warn("DirectLineJS: conversationStartProperties.locale was ignored: the locale name may be a BCP 47 language tag")), P.domain && (this.domain = P.domain), P.conversationId && (this.conversationId = P.conversationId), P.watermark && (this.watermark = P.watermark), P.streamUrl && (P.token && P.conversationId ? this.streamUrl = P.streamUrl : console.warn("DirectLineJS: streamUrl was ignored: you need to provide a token and a conversationid")), P.timeout !== void 0 && (this.timeout = P.timeout), this.retries = (y - x) / this.timeout, this._botAgent = this.getBotAgent(P.botAgent), this.services = k(P);
        var R = ~~P.pollingInterval;
        R < C ? typeof P.pollingInterval < "u" && console.warn("DirectLineJS: provided pollingInterval (".concat(P.pollingInterval, ") is under lower bound (200ms), using default of 1000ms")) : this.pollingInterval = R, this.expiredTokenExhaustion = this.setConnectionStatusFallback(A.ExpiredToken, A.FailedToConnect, 5), this.activity$ = (this.webSocket ? this.webSocketActivity$() : this.pollingGetActivity$()).share();
      }
      return (0, o.default)(W, [{
        key: "checkConnection",
        value: function() {
          var R = this, V = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, X = this.connectionStatus$.flatMap(function(N) {
            return N === A.Uninitialized ? (R.connectionStatus$.next(A.Connecting), R.token && R.streamUrl ? (R.connectionStatus$.next(A.Online), u.Observable.of(N, R.services.scheduler)) : R.startConversation().do(function(U) {
              R.conversationId = U.conversationId, R.token = R.secret || U.token, R.streamUrl = U.streamUrl, R.referenceGrammarId = U.referenceGrammarId, R.secret || R.refreshTokenLoop(), R.connectionStatus$.next(A.Online);
            }, function(U) {
              R.connectionStatus$.next(A.FailedToConnect);
            }).map(function(U) {
              return N;
            })) : u.Observable.of(N, R.services.scheduler);
          }).filter(function(N) {
            return N != A.Uninitialized && N != A.Connecting;
          }).flatMap(function(N) {
            switch (N) {
              case A.Ended:
                return u.Observable.throw(M, R.services.scheduler);
              case A.FailedToConnect:
                return u.Observable.throw(Q, R.services.scheduler);
              case A.ExpiredToken:
                return u.Observable.of(N, R.services.scheduler);
              default:
                return u.Observable.of(N, R.services.scheduler);
            }
          });
          return V ? X.take(1) : X;
        }
      }, {
        key: "setConnectionStatusFallback",
        value: function(R, V) {
          var X = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
          X--;
          var N = 0, U = null;
          return function(G) {
            return G === R && U === G && N >= X ? (N = 0, V) : (N++, U = G, G);
          };
        }
      }, {
        key: "expiredToken",
        value: function() {
          var R = this.connectionStatus$.getValue();
          R != A.Ended && R != A.FailedToConnect && this.connectionStatus$.next(A.ExpiredToken);
          var V = this.expiredTokenExhaustion(this.connectionStatus$.getValue());
          this.connectionStatus$.next(V);
        }
      }, {
        key: "startConversation",
        value: function() {
          var R = this, V = this.conversationId ? "".concat(this.domain, "/conversations/").concat(this.conversationId, "?watermark=").concat(this.watermark) : "".concat(this.domain, "/conversations"), X = this.conversationId ? "GET" : "POST", N = this.conversationId ? void 0 : {
            user: {
              id: this.userIdOnStartConversation
            },
            locale: this.localeOnStartConversation
          };
          return this.services.ajax({
            method: X,
            url: V,
            body: N,
            timeout: this.timeout,
            headers: v({
              Accept: "application/json",
              "Content-Type": "application/json"
            }, this.commonHeaders())
          }).map(function(U) {
            return U.response;
          }).retryWhen(function(U) {
            return (
              // for now we deem 4xx and 5xx errors as unrecoverable
              // for everything else (timeouts), retry for a while
              U.mergeMap(function(G) {
                return G.status >= 400 && G.status < 600 ? u.Observable.throw(G, R.services.scheduler) : u.Observable.of(G, R.services.scheduler);
              }).delay(R.timeout, R.services.scheduler).take(R.retries)
            );
          });
        }
      }, {
        key: "refreshTokenLoop",
        value: function() {
          var R = this;
          this.tokenRefreshSubscription = u.Observable.interval(x, this.services.scheduler).flatMap(function(V) {
            return R.refreshToken();
          }).subscribe(function(V) {
            H.log("refreshing token", V, "at", /* @__PURE__ */ new Date()), R.token = V;
          });
        }
      }, {
        key: "refreshToken",
        value: function() {
          var R = this;
          return this.checkConnection(!0).flatMap(function(V) {
            return R.services.ajax({
              method: "POST",
              url: "".concat(R.domain, "/tokens/refresh"),
              timeout: R.timeout,
              headers: v({}, R.commonHeaders())
            }).map(function(X) {
              return X.response.token;
            }).retryWhen(function(X) {
              return X.mergeMap(function(N) {
                return N.status === 403 ? (R.expiredToken(), u.Observable.throw(N, R.services.scheduler)) : N.status === 404 ? u.Observable.throw(N, R.services.scheduler) : u.Observable.of(N, R.services.scheduler);
              }).delay(R.timeout, R.services.scheduler).take(R.retries);
            });
          });
        }
      }, {
        key: "reconnect",
        value: function(R) {
          this.token = R.token, this.streamUrl = R.streamUrl, this.connectionStatus$.getValue() === A.ExpiredToken && this.connectionStatus$.next(A.Online);
        }
      }, {
        key: "end",
        value: function() {
          this.tokenRefreshSubscription && this.tokenRefreshSubscription.unsubscribe();
          try {
            this.connectionStatus$.next(A.Ended);
          } catch (R) {
            if (R === M) return;
            throw R;
          }
        }
      }, {
        key: "getSessionId",
        value: function() {
          var R = this;
          return H.log("getSessionId"), this.checkConnection(!0).flatMap(function(V) {
            return R.services.ajax({
              method: "GET",
              url: "".concat(R.domain, "/session/getsessionid"),
              withCredentials: !0,
              timeout: R.timeout,
              headers: v({
                "Content-Type": "application/json"
              }, R.commonHeaders())
            }).map(function(X) {
              return X && X.response && X.response.sessionId ? (H.log("getSessionId response: " + X.response.sessionId), X.response.sessionId) : "";
            }).catch(function(X) {
              return H.log("getSessionId error: " + X.status), u.Observable.of("", R.services.scheduler);
            });
          }).catch(function(V) {
            return R.catchExpiredToken(V);
          });
        }
      }, {
        key: "postActivity",
        value: function(R) {
          var V = this;
          return this.streaming && (R.deliveryMode = "stream"), this.userIdOnStartConversation && R.from && R.from.id !== this.userIdOnStartConversation && (console.warn("DirectLineJS: Activity.from.id does not match with user id, ignoring activity.from.id"), R.from.id = this.userIdOnStartConversation), R.type === "message" && R.attachments && R.attachments.length > 0 ? this.postMessageWithAttachments(R) : (H.log("postActivity", R), this.checkConnection(!0).flatMap(function(X) {
            return V.services.ajax({
              method: "POST",
              url: "".concat(V.domain, "/conversations/").concat(V.conversationId, "/activities"),
              body: R,
              timeout: V.timeout,
              headers: v({
                "Content-Type": "application/json"
              }, V.commonHeaders())
            }).map(function(N) {
              return N.response.id;
            }).catch(function(N) {
              return V.catchPostError(N);
            });
          }).catch(function(X) {
            return V.catchExpiredToken(X);
          }));
        }
      }, {
        key: "postMessageWithAttachments",
        value: function(R) {
          var V = this, X = R.attachments, N = (0, d.default)(X.map(function(re) {
            return re.name || "blob";
          })), U = X.map(function(re, oe) {
            return v(v({}, re), {}, {
              name: N[oe]
            });
          }), G;
          return this.checkConnection(!0).flatMap(function(re) {
            return G = new FormData(), G.append("activity", new Blob([JSON.stringify(v(v({}, R), {}, {
              // Removing contentUrl from attachment, we will send it via multipart
              attachments: U.map(function(oe) {
                oe.contentUrl;
                var ie = (0, i.default)(oe, f);
                return v({}, ie);
              })
            }))], {
              type: "application/vnd.microsoft.activity"
            })), u.Observable.from(U, V.services.scheduler).flatMap(function(oe) {
              return V.services.ajax({
                method: "GET",
                url: oe.contentUrl,
                responseType: "arraybuffer"
              }).do(function(ie) {
                return G.append("file", new Blob([ie.response], {
                  type: oe.contentType
                }), oe.name);
              });
            }).count();
          }).flatMap(function(re) {
            return V.services.ajax({
              method: "POST",
              url: "".concat(V.domain, "/conversations/").concat(V.conversationId, "/upload?userId=").concat(R.from.id),
              body: G,
              timeout: V.timeout,
              headers: v({}, V.commonHeaders())
            }).map(function(oe) {
              return oe.response.id;
            }).catch(function(oe) {
              return V.catchPostError(oe);
            });
          }).catch(function(re) {
            return V.catchPostError(re);
          });
        }
      }, {
        key: "catchPostError",
        value: function(R) {
          if (R.status === 403)
            this.expiredToken();
          else if (R.status >= 400 && R.status < 500)
            return u.Observable.throw(R, this.services.scheduler);
          return u.Observable.of("retry", this.services.scheduler);
        }
      }, {
        key: "catchExpiredToken",
        value: function(R) {
          return R === I ? u.Observable.of("retry", this.services.scheduler) : u.Observable.throw(R, this.services.scheduler);
        }
      }, {
        key: "pollingGetActivity$",
        value: function() {
          var R = this, V = u.Observable.create(function(X) {
            var N = new a.BehaviorSubject({});
            N.subscribe(function() {
              if (R.connectionStatus$.getValue() === A.Online) {
                var U = Date.now();
                R.services.ajax({
                  headers: v({
                    Accept: "application/json"
                  }, R.commonHeaders()),
                  method: "GET",
                  url: "".concat(R.domain, "/conversations/").concat(R.conversationId, "/activities?watermark=").concat(R.watermark),
                  timeout: R.timeout
                }).subscribe(function(G) {
                  X.next(G), setTimeout(function() {
                    return N.next(null);
                  }, Math.max(0, R.pollingInterval - Date.now() + U));
                }, function(G) {
                  switch (G.status) {
                    case 403:
                      R.connectionStatus$.next(A.ExpiredToken), setTimeout(function() {
                        return N.next(null);
                      }, R.pollingInterval);
                      break;
                    case 404:
                      R.connectionStatus$.next(A.Ended);
                      break;
                    default:
                      X.error(G);
                      break;
                  }
                });
              }
            });
          });
          return this.checkConnection().flatMap(function(X) {
            return V.catch(function() {
              return u.Observable.empty();
            }).map(function(N) {
              return N.response;
            }).flatMap(function(N) {
              return R.observableFromActivityGroup(N);
            });
          });
        }
      }, {
        key: "observableFromActivityGroup",
        value: function(R) {
          return R.watermark && (this.watermark = R.watermark), u.Observable.from(R.activities, this.services.scheduler);
        }
      }, {
        key: "webSocketActivity$",
        value: function() {
          var R = this;
          return this.checkConnection().flatMap(function(V) {
            return R.observableWebSocket().retryWhen(function(X) {
              return X.delay(R.getRetryDelay(), R.services.scheduler).mergeMap(function(N) {
                return R.reconnectToConversation();
              });
            });
          }).flatMap(function(V) {
            return R.observableFromActivityGroup(V);
          });
        }
        // Returns the delay duration in milliseconds
      }, {
        key: "getRetryDelay",
        value: function() {
          return Math.floor(3e3 + this.services.random() * 12e3);
        }
        // Originally we used Observable.webSocket, but it's fairly opinionated and I ended up writing
        // a lot of code to work around their implementation details. Since WebChat is meant to be a reference
        // implementation, I decided roll the below, where the logic is more purposeful. - @billba
      }, {
        key: "observableWebSocket",
        value: function() {
          var R = this;
          return u.Observable.create(function(V) {
            H.log("creating WebSocket", R.streamUrl);
            var X = new R.services.WebSocket(R.streamUrl), N, U;
            return X.onopen = function(G) {
              H.log("WebSocket open", G), N = u.Observable.interval(R.timeout, R.services.scheduler).subscribe(function(re) {
                try {
                  X.send("");
                } catch (oe) {
                  H.log("Ping error", oe);
                }
              });
            }, X.onclose = function(G) {
              H.log("WebSocket close", G), N && N.unsubscribe(), U || V.error(G), U = !0;
            }, X.onerror = function(G) {
              H.log("WebSocket error", G), N && N.unsubscribe(), U || V.error(G), U = !0;
            }, X.onmessage = function(G) {
              return G.data && V.next(JSON.parse(G.data));
            }, function() {
              (X.readyState === 0 || X.readyState === 1) && X.close();
            };
          });
        }
      }, {
        key: "reconnectToConversation",
        value: function() {
          var R = this;
          return this.checkConnection(!0).flatMap(function(V) {
            return R.services.ajax({
              method: "GET",
              url: "".concat(R.domain, "/conversations/").concat(R.conversationId, "?watermark=").concat(R.watermark),
              timeout: R.timeout,
              headers: v({
                Accept: "application/json"
              }, R.commonHeaders())
            }).do(function(X) {
              R.secret || (R.token = X.response.token), R.streamUrl = X.response.streamUrl;
            }).map(function(X) {
              return null;
            }).retryWhen(function(X) {
              return X.mergeMap(function(N) {
                if (N.status === 403)
                  R.expiredToken();
                else if (N.status === 404)
                  return u.Observable.throw(M, R.services.scheduler);
                return u.Observable.of(N, R.services.scheduler);
              }).delay(R.timeout, R.services.scheduler).take(R.retries);
            });
          });
        }
      }, {
        key: "commonHeaders",
        value: function() {
          return {
            Authorization: "Bearer ".concat(this.token),
            "x-ms-bot-agent": this._botAgent
          };
        }
      }, {
        key: "getBotAgent",
        value: function() {
          var R = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", V = "directlinejs";
          return R && (V += "; ".concat(R)), "".concat(g, " (").concat(V, " ").concat("0.15.8", ")");
        }
      }, {
        key: "setUserId",
        value: function(R) {
          if (this.connectionStatus$.getValue() === A.Online)
            throw new Error("DirectLineJS: It is connected, we cannot set user id.");
          var V = this.parseToken(this.token);
          if (V)
            return console.warn("DirectLineJS: user id is already set in token, will ignore this user id.");
          if (/^dl_/.test(R))
            return console.warn('DirectLineJS: user id prefixed with "dl_" is reserved and must be embedded into the Direct Line token to prevent forgery.');
          this.userIdOnStartConversation = R;
        }
      }, {
        key: "parseToken",
        value: function(R) {
          try {
            var V = (0, c.default)(R), X = V.user;
            return X;
          } catch (N) {
            if (N instanceof c.InvalidTokenError)
              return;
          }
        }
      }]), W;
    })();
    e.DirectLine = J;
  })(_i)), _i;
}
var Zt = jg();
const a2 = {
  widgetDisplayType: "large",
  open: !1,
  loaded: !1
}, Fg = mt({
  name: "widget",
  initialState: a2,
  reducers: {
    openWidget: (e) => {
      e.open = !0, e.loaded = !0;
    },
    closeWidget: (e) => {
      e.open = !1, e.loaded = !0;
    },
    toggleWidget: (e) => {
      e.open = !e.open, e.loaded = !0;
    },
    toggleDisplay: (e) => {
      e.widgetDisplayType = e.widgetDisplayType === "large" ? "thumbnail" : "large";
    }
  }
}), s2 = Fg.reducer, { openWidget: u2, closeWidget: c2, toggleWidget: l2, toggleDisplay: d2 } = Fg.actions;
var $g = /* @__PURE__ */ ((e) => (e[e.agent = 1] = "agent", e[e.widget = 2] = "widget", e[e.news = 3] = "news", e))($g || {}), mc = /* @__PURE__ */ ((e) => (e[e.none = 1] = "none", e[e.history = 2] = "history", e[e.languages = 3] = "languages", e[e.weather = 4] = "weather", e[e.emergency = 5] = "emergency", e[e.map = 6] = "map", e[e.custom = 7] = "custom", e))(mc || {}), je = /* @__PURE__ */ ((e) => (e[e.mobile = 1] = "mobile", e[e.borne = 2] = "borne", e[e.landscape = 3] = "landscape", e[e.widget = 4] = "widget", e[e.widgetLandscape = 5] = "widgetLandscape", e[e.widgetBorne = 6] = "widgetBorne", e))(je || {}), Vr = /* @__PURE__ */ ((e) => (e.auto = "auto", e.always = "always", e.never = "never", e.ignore = "ignore", e))(Vr || {}), Bn = /* @__PURE__ */ ((e) => (e[e.available = 1] = "available", e[e.opened = 2] = "opened", e[e.closing = 3] = "closing", e[e.closed = 4] = "closed", e))(Bn || {}), Ft = /* @__PURE__ */ ((e) => (e[e.vocal = 1] = "vocal", e[e.text = 2] = "text", e[e.dashboard = 3] = "dashboard", e))(Ft || {}), ht = /* @__PURE__ */ ((e) => (e[e.waiting = 1] = "waiting", e[e.allowed = 2] = "allowed", e[e.refused = 3] = "refused", e[e.error = 4] = "error", e))(ht || {}), Ru = /* @__PURE__ */ ((e) => (e[e.DetailViewOpen = 1] = "DetailViewOpen", e[e.DetailViewClose = 2] = "DetailViewClose", e[e.SpeechStarted = 3] = "SpeechStarted", e[e.SpeechEnded = 4] = "SpeechEnded", e))(Ru || {}), at = /* @__PURE__ */ ((e) => (e[e.Initializing = 1] = "Initializing", e[e.Listening = 2] = "Listening", e[e.Closing = 3] = "Closing", e[e.ForceClosing = 4] = "ForceClosing", e[e.Closed = 5] = "Closed", e))(at || {}), gc = /* @__PURE__ */ ((e) => (e[e.Home = 1] = "Home", e[e.News = 2] = "News", e[e.EmptyVeille = 3] = "EmptyVeille", e[e.ScreenSaver = 4] = "ScreenSaver", e[e.SlideShow = 5] = "SlideShow", e[e.NewsInVeille = 6] = "NewsInVeille", e))(gc || {}), bc = /* @__PURE__ */ ((e) => (e[e.none = 1] = "none", e[e.agent = 2] = "agent", e[e.background = 3] = "background", e[e.remote = 4] = "remote", e[e.languages = 5] = "languages", e[e.card = 6] = "card", e[e.qroverlay = 7] = "qroverlay", e))(bc || {}), Lg = /* @__PURE__ */ ((e) => (e.dark = "dark", e.light = "light", e.auto = "auto", e))(Lg || {});
const d0 = {
  fullScreenImage: void 0,
  lastListActivity: void 0,
  listStatus: Bn.available,
  currentSubView: mc.none,
  currentCustomView: void 0,
  retorikEvent: void 0,
  displayAgent: !0,
  activityToSend: void 0,
  retorikNewsEnded: !1,
  userIsTyping: !1,
  userIsSwiping: !1,
  askedForKioskParametersOpening: 0,
  detailedAttachmentTriggers: [
    {
      type: "event",
      name: "hospitality.ShowPointOfInterest",
      linkedComponent: null
    },
    {
      type: "event",
      name: "hospitality.ShowContentItem",
      linkedComponent: null
    }
  ],
  modalFullscreenContent: null,
  modalFullscreenContentNoDisplayId: void 0,
  GDPRDisplay: !0,
  GDPRWindowData: void 0,
  GDPRUserConsent: !1,
  unlockClickedButton: !1,
  dashboardOpened: !1,
  clickedOnUI: bc.none,
  closeDetailedPOI: !1,
  closeList: 0
}, Ng = mt({
  name: "utils",
  initialState: d0,
  reducers: {
    setFullScreenImage: (e, t) => {
      e.fullScreenImage = t.payload;
    },
    setLastListActivity: (e, t) => {
      e.lastListActivity = t.payload;
    },
    setListStatus: (e, t) => {
      e.listStatus = t.payload;
    },
    setCloseList: (e, t) => {
      e.closeList = t.payload;
    },
    setCurrentSubView: (e, t) => {
      e.currentSubView = t.payload;
    },
    setCurrentCustomView: (e, t) => {
      e.currentCustomView = t.payload;
    },
    setRetorikEvent: (e, t) => {
      e.retorikEvent = t.payload;
    },
    showAgent: (e) => {
      e.displayAgent = !0;
    },
    hideAgent: (e) => {
      e.displayAgent = !1;
    },
    setRetorikNewsEnded: (e, t) => {
      e.retorikNewsEnded = t.payload;
    },
    setUserTyping: (e, t) => {
      e.userIsTyping = t.payload;
    },
    setUserSwiping: (e, t) => {
      e.userIsSwiping = t.payload;
    },
    askForKioskParametersOpening: (e) => {
      e.askedForKioskParametersOpening = e.askedForKioskParametersOpening + 1;
    },
    addDetailedAttachmentTrigger: (e, t) => {
      e.detailedAttachmentTriggers = [...e.detailedAttachmentTriggers, t.payload];
    },
    setModalFullscreenContent: (e, t) => {
      e.modalFullscreenContent = t.payload;
    },
    setModalFullscreenContentFromActivity: (e, t) => {
      t.payload.fromActivity !== e.modalFullscreenContentNoDisplayId && (e.modalFullscreenContent = t.payload.value, e.modalFullscreenContentNoDisplayId = t.payload.fromActivity);
    },
    setGDPRDisplay: (e, t) => {
      e.GDPRDisplay = t.payload;
    },
    setGDPRWindowData: (e, t) => {
      e.GDPRWindowData = t.payload;
    },
    setGDPRUserConsent: (e, t) => {
      e.GDPRUserConsent = t.payload;
    },
    lockClickedButton: (e) => {
      e.unlockClickedButton = !1;
    },
    unlockClickedButton: (e) => {
      e.unlockClickedButton = !0;
    },
    setDashboardOpened: (e, t) => {
      e.dashboardOpened = t.payload;
    },
    toggleDashboard: (e, t) => {
      t != null && t.payload || (e.currentSubView = mc.none), e.dashboardOpened = !e.dashboardOpened;
    },
    setClickedUIPart: (e, t) => {
      e.clickedOnUI = t.payload;
    },
    resetClickedOnUI: (e) => {
      e.clickedOnUI = bc.none;
    },
    setCloseDetailedPOI: (e, t) => {
      e.closeDetailedPOI = t.payload;
    },
    resetUtilsStore: () => ({ ...d0 })
  }
}), f2 = Ae("utils/setClickedOnUI", async (e, t) => {
  t.dispatch(P2(e)), setTimeout(() => {
    t.dispatch(I2());
  }, 50);
}), h2 = Ng.reducer, {
  setFullScreenImage: p2,
  setLastListActivity: Bg,
  setListStatus: qg,
  setCloseList: m2,
  setCurrentSubView: g2,
  setCurrentCustomView: b2,
  setRetorikEvent: zg,
  showAgent: v2,
  hideAgent: y2,
  setRetorikNewsEnded: w2,
  setUserTyping: Ug,
  setUserSwiping: _2,
  askForKioskParametersOpening: k2,
  addDetailedAttachmentTrigger: x2,
  setModalFullscreenContent: S2,
  setModalFullscreenContentFromActivity: E2,
  setGDPRDisplay: A2,
  setGDPRWindowData: T2,
  setGDPRUserConsent: C2,
  lockClickedButton: R2,
  unlockClickedButton: fn,
  setDashboardOpened: O2,
  toggleDashboard: D2,
  setClickedUIPart: P2,
  resetClickedOnUI: I2,
  setCloseDetailedPOI: M2,
  resetUtilsStore: j2
} = Ng.actions, F2 = 1300, Vg = "https://cdn.retorik.ai", Gg = `${Vg}/spiritenginehtml5/characters`, $2 = `${Vg}/retorik-framework/imagefiles`, f0 = {
  default: "fr-FR",
  all: ["fr-FR"]
}, L2 = [je.mobile, je.widget], N2 = [je.widget, je.widgetBorne, je.widgetLandscape], B2 = [je.landscape, je.widgetLandscape], q2 = [je.borne, je.widgetBorne], Ue = {
  primary: "#00D7FF",
  secondary: "#1999B1",
  black: "#101219",
  whereToEatColor: "#FC952E",
  whereToSleepColor: "#9F007D",
  tobeSeenColor: "#76AB2A",
  tobeDoneColor: "#E23C2A",
  localProductsColor: "#AFB942",
  servicesColor: "#00C8BC",
  agendaColor: "#865DA2",
  occupantColor: "#6DEDBC"
}, z2 = ["davi.closewindow", "setuser", "davi.gdprconsent"], U2 = ["ar", "fa", "he", "ps", "ur"], V2 = [
  "af-ZA",
  "am-ET",
  "ar-AE",
  "ar-BH",
  "ar-DZ",
  "ar-EG",
  "ar-IQ",
  "ar-JO",
  "ar-KW",
  "ar-LB",
  "ar-LY",
  "ar-MA",
  "ar-OM",
  "ar-QA",
  "ar-SA",
  "ar-SY",
  "ar-TN",
  "ar-YE",
  "as-IN",
  "az-AZ",
  "bg-BG",
  "bn-BD",
  "bn-IN",
  "bs-BA",
  "ca-ES",
  "cs-CZ",
  "cy-GB",
  "da-DK",
  "de-AT",
  "de-CH",
  "de-DE",
  "el-GR",
  "en-AU",
  "en-CA",
  "en-GB",
  "en-HK",
  "en-IE",
  "en-IN",
  "en-KE",
  "en-NG",
  "en-NZ",
  "en-PH",
  "en-SG",
  "en-TZ",
  "en-US",
  "en-ZA",
  "es-AR",
  "es-BO",
  "es-CL",
  "es-CO",
  "es-CR",
  "es-CU",
  "es-DO",
  "es-EC",
  "es-ES",
  "es-GQ",
  "es-GT",
  "es-HN",
  "es-MX",
  "es-NI",
  "es-PA",
  "es-PE",
  "es-PR",
  "es-PY",
  "es-SV",
  "es-US",
  "es-UY",
  "es-VE",
  "et-EE",
  "eu-ES",
  "fa-IR",
  "fi-FI",
  "fil-PH",
  "fr-BE",
  "fr-CA",
  "fr-CH",
  "fr-FR",
  "ga-IE",
  "gl-ES",
  "gu-IN",
  "he-IL",
  "hi-IN",
  "hr-HR",
  "hu-HU",
  "hy-AM",
  "id-ID",
  "is-IS",
  "it-IT",
  "iu-CANS-CA",
  "iu-LATN-CA",
  "ja-JP",
  "jv-ID",
  "ka-GE",
  "kk-KZ",
  "km-KH",
  "kn-IN",
  "ko-KR",
  "lo-LA",
  "lt-LT",
  "lv-LV",
  "mk-MK",
  "ml-IN",
  "mn-MN",
  "mr-IN",
  "ms-MY",
  "mt-MT",
  "my-MM",
  "nb-NO",
  "ne-NP",
  "nl-BE",
  "nl-NL",
  "or-IN",
  "pa-IN",
  "pl-PL",
  "ps-AF",
  "pt-BR",
  "pt-PT",
  "ro-RO",
  "ru-RU",
  "si-LK",
  "sk-SK",
  "sl-SI",
  "so-SO",
  "sq-AL",
  "sr-LATN-RS",
  "sr-RS",
  "su-ID",
  "sv-SE",
  "sw-KE",
  "sw-TZ",
  "ta-IN",
  "ta-LK",
  "ta-MY",
  "ta-SG",
  "te-IN",
  "th-TH",
  "tr-TR",
  "uk-UA",
  "ur-IN",
  "ur-PK",
  "uz-UZ",
  "vi-VN",
  "wuu-CN",
  "yue-CN",
  "zh-CN",
  "zh-CN-GUANGXI",
  "zh-CN-henan",
  "zh-CN-liaoning",
  "zh-CN-shaanxi",
  "zh-CN-shandong",
  "zh-CN-sichuan",
  "zh-HK",
  "zh-TW",
  "zu-ZA"
], G2 = [
  "ar-AE",
  "ar-EG",
  "ar-SA",
  "ca-ES",
  "cs-CZ",
  "da-DK",
  "de-AT",
  "de-CH",
  "de-DE",
  "en-CA",
  "en-GB",
  "en-HK",
  "en-IE",
  "en-IN",
  "en-US",
  "es-ES",
  "es-MX",
  "fi-FI",
  "fr-BE",
  "fr-CA",
  "fr-CH",
  "fr-FR",
  "hi-IN",
  "hu-HU",
  "id-ID",
  "it-IT",
  "ja-JP",
  "ko-KR",
  "nb-NO",
  "nl-BE",
  "nl-NL",
  "pl-PL",
  "pt-BR",
  "pt-PT",
  "ru-RU",
  "sv-SE",
  "th-TH",
  "tr-TR",
  "zh-CN",
  "zh-HK",
  "zh-TW"
], W2 = async (e, t) => {
  const r = `${e}api/graphql?query={siteCultures{culture,default}}`;
  return await fetch(r).then((n) => n.json()).then((n) => {
    var a, u, l;
    if (!((u = (a = n.data) == null ? void 0 : a.siteCultures) != null && u.length))
      return f0;
    const { processedDefaultLanguage: o, processedSupported: s } = H2(
      ((l = n.data.siteCultures.find((c) => c.default)) == null ? void 0 : l.culture) || n.data.siteCultures[0].culture,
      n.data.siteCultures.map((c) => c.culture)
    );
    return {
      all: s,
      default: o
    };
  }).catch((n) => (console.log(n), f0));
}, H2 = (e, t, r) => {
  const i = V2;
  let n = i.includes(e) ? e : "fr-FR";
  const o = [];
  return t.forEach((s) => {
    if (i.includes(s))
      o.push(s);
    else {
      const { dispatch: a } = p$, u = s.split("-")[0], l = t.filter((c) => c.startsWith(`${u}-`)).find((c) => i.includes(c));
      if (l)
        s === e && (n = l), a(vu.locale.addReplacementLocale({ key: s, value: l })), console.log(`Retorik Framework > invalid locale "${s}" was dumped because an existing locale for this language was found ("${l}").`);
      else {
        const c = i.find((d) => d.startsWith(`${u}-`));
        c ? (o.push(c), s === e && (n = c), a(vu.locale.addDumpedLanguageFallback({ key: c, value: s })), a(vu.locale.addReplacementLocale({ key: s, value: c })), console.log(`Retorik Framework > invalid locale "${s}" was replaced by "${c}".`)) : console.log(`Retorik Framework > invalid locale "${s}" was dumped and no replacement was found for this language.`);
      }
    }
  }), { processedDefaultLanguage: n, processedSupported: o };
}, K2 = { abort: "إلغاء", all: "الجميع", back: "خلف", close: "اغلاق", continue: "يكمل", download: "تحميل", downloadsheet: "قم بتنزيل هذه الورقة", downloadsheetmobile: "قم بتنزيل هذه الورقة على الهاتف الذكي", filter: "منقي", history: "تاريخي", knowmore: "اعرف المزيد", lang: "اللغات", menu: "القائمة", mode: "موضة", needhelp: "تحتاج مساعدة؟", parameters: "الإعدادات", print: "مطبعة", printsheet: "اطبع هذه الورقة", result: "نتيجة", results: "نتائج", singleLang: "لغة", sound: "ها", submit: "يُقدِّم", subtitle: "العنوان الفرعي", tutorial: "درس تعليمي", validate: "التحقق من صحة" }, Q2 = { shorttitle: "أرقام الطوارئ", samu: ".S.A.M.U", police: "شرطة", firefighter: "رجال الاطفاء", general: "عام", citypolice: "الشرطة المحلية", hospital: "مستشفى", homeless: "بلا مأوى (مكالمة مجانية)", poison: "مركز مراقبة السموم", emergency: "حالات الطوارئ الأوروبية" }, Y2 = { title: "حدث خطأ", button: "أعد تشغيل التطبيق" }, J2 = { shorttitle: "تاريخي", title: "تاريخ المحادثة" }, Z2 = { shorttitle: "الصفحة الرئيسية" }, X2 = { choose: "اختر إجابة", noaction: "إجراء متوقع" }, e_ = { change: "تغيير اللغة", select: "حدد اللغة التي تريد استخدامها" }, t_ = { buttontext: "عرض الوثيقة", goto: "اذهب إلى العنوان", click: "انقر هنا", scanQR: "عن طريق مسح رمز الاستجابة السريعة", scanQRTile: "مسح رمز الاستجابة السريعة لاكتشاف" }, r_ = { loader: { optimal: "للحصول على تجربة مثالية،", classic: "لتجربة أكثر كلاسيكية،", vocal: "أنا أتحدث وجها لوجه مع الوكيل.", text: "أتواصل كتابيًا مع الوكيل." }, modes: { vocal: "الوضع الصوتي", text: "وضع النص" }, loaderValidation: "ابدأ المحادثة", locale: "فحص اللغة", supported: "التحقق من اللغات المدعومة", addressdata: "استرجاع البيانات" }, n_ = { message: "أدخل رسالتك", backconversation: "العودة إلى المحادثة", answer: " يجيب على أسئلتك" }, i_ = { firstline: "للحصول على تجربة مثالية،", secondline: "اقلب شاشتك" }, o_ = { shorttitle: "قناة اخبارية حية", warningtext: "ستدخل إلى القناة الإخبارية، وسيتم تنشيط الصوت على جهازك", live: "مباشر", continuous: "لنكمل" }, a_ = { comment: "رأي العميل", route: "طريق", nodata: "لا يوجد محتوى يطابق بحثك", openinghours: "ساعات العمل", prices: "الأسعار", paymentmethods: "طرق الدفع", numberofplaces: "عدد الأماكن", openroutemobile: "افتح طريق خريطة جوجل على الهاتف الذكي", FoodEstablishment: "أين تأكل", LodgingBusiness: "أين تنام", TouristDestination: "ماذا ترى", TouristAttraction: "ما يجب القيام به", Product: "منتجات محلية", Service: "خدمات", Event: "الأحداث", City: "مدن", Wine: "النبيذ" }, s_ = { consult: "الدفع", thetutorial: "البرنامج التعليمي" }, u_ = { reset: "إعادة ضبط الجميع", showresults: "عرض النتائج", suggestiontitle: "اقتراحات البحث", reminder: `لا تنسى 
 أستطيع الإجابة على أسئلتك.` }, c_ = { listening: "أنت في انتظارك، أنا أستمع...", correct: "تصحيح", dontknow: "لا أعرف" }, l_ = { allow: "يرجى السماح للمتصفح بالوصول إلى الميكروفون للاستمرار.", rejected: "لقد رفضت الوصول إلى الميكروفون.", instructions: "لاستخدام الوضع الصوتي، يرجى السماح للمتصفح بالوصول إلى الميكروفون.", listening: "أنا أسمعك", trigger: "اضغط أو قل", triggerwithoutname: "اضغط للتحدث" }, d_ = { rejected: "لقد رفضت الوصول إلى موقعك الجغرافي.", instructions: "Để الوصول إلى البيانات الجوية أو الخريطة التفاعلية، يرجى السماح للمتصفح بالوصول إلى موقعك الجغرافي." }, f_ = { calltoaction: "اضغط على الشاشة للبدء", emptyveille: "انقر أو اضغط على الشاشة..." }, h_ = { shorttitle: "تقرير حالة ألطقس", attribution: "بيانات الطقس مقدمة من Open-Meteo.com" }, p_ = { title: "معالجة البيانات الشخصية المرسلة إلى الروبوت", message: `بقبول هذا الحوار، فإنك توافق على استخدام جميع البيانات المرسلة إلى روبوت الدردشة لأغراض تحليل استخدام الأداة وتحسين قاعدة المعرفة.

تُحفظ محادثاتك لمدة 6 أشهر قبل حذفها.`, link: "رابط لعرض سياسات الخصوصية", buttonAccept: "لقد فهمت وأوافق", buttonRefuse: "أرفض", messageAccepted: "تم أخذ موافقتك بعين الاعتبار", messageRefused: "تم أخذ رفضك بعين الاعتبار" }, m_ = {
  1: "الصفحة الرئيسية",
  2: "قناة اخبارية حية",
  3: "تقرير حالة ألطقس",
  4: "أرقام الطوارئ",
  1e3: "تاريخي",
  1001: "درس تعليمي",
  common: K2,
  emergency: Q2,
  error: Y2,
  history: J2,
  home: Z2,
  inputs: X2,
  language: e_,
  link: t_,
  loader: r_,
  menu: n_,
  mobileLandscapePreventer: i_,
  news: o_,
  poi: a_,
  suggestion: s_,
  template: u_,
  anghello: c_,
  microphone: l_,
  position: d_,
  veille: f_,
  weather: h_,
  GDPR: p_
}, g_ = { abort: "إلغاء", all: "الجميع", back: "خلف", close: "اغلاق", continue: "يكمل", download: "تحميل", downloadsheet: "قم بتنزيل هذه الورقة", downloadsheetmobile: "قم بتنزيل هذه الورقة على الهاتف الذكي", filter: "منقي", history: "تاريخي", knowmore: "اعرف المزيد", lang: "اللغات", menu: "القائمة", mode: "موضة", needhelp: "تحتاج مساعدة؟", parameters: "الإعدادات", print: "مطبعة", printsheet: "اطبع هذه الورقة", result: "نتيجة", results: "نتائج", singleLang: "لغة", sound: "ها", submit: "يُقدِّم", subtitle: "العنوان الفرعي", tutorial: "درس تعليمي", validate: "التحقق من صحة" }, b_ = { shorttitle: "أرقام الطوارئ", samu: ".S.A.M.U", police: "شرطة", firefighter: "رجال الاطفاء", general: "عام", citypolice: "الشرطة المحلية", hospital: "مستشفى", homeless: "بلا مأوى (مكالمة مجانية)", poison: "مركز مراقبة السموم", emergency: "حالات الطوارئ الأوروبية" }, v_ = { title: "حدث خطأ", button: "أعد تشغيل التطبيق" }, y_ = { shorttitle: "تاريخي", title: "تاريخ المحادثة" }, w_ = { shorttitle: "الصفحة الرئيسية" }, __ = { choose: "اختر إجابة", noaction: "إجراء متوقع" }, k_ = { change: "تغيير اللغة", select: "حدد اللغة التي تريد استخدامها" }, x_ = { buttontext: "عرض الوثيقة", goto: "اذهب إلى العنوان", click: "انقر هنا", scanQR: "عن طريق مسح رمز الاستجابة السريعة", scanQRTile: "مسح رمز الاستجابة السريعة لاكتشاف" }, S_ = { loader: { optimal: "للحصول على تجربة مثالية،", classic: "لتجربة أكثر كلاسيكية،", vocal: "أنا أتحدث وجها لوجه مع الوكيل.", text: "أتواصل كتابيًا مع الوكيل." }, modes: { vocal: "الوضع الصوتي", text: "وضع النص" }, loaderValidation: "ابدأ المحادثة", locale: "فحص اللغة", supported: "التحقق من اللغات المدعومة", addressdata: "استرجاع البيانات" }, E_ = { message: "أدخل رسالتك", backconversation: "العودة إلى المحادثة", answer: " يجيب على أسئلتك" }, A_ = { firstline: "للحصول على تجربة مثالية،", secondline: "اقلب شاشتك" }, T_ = { shorttitle: "قناة اخبارية حية", warningtext: "ستدخل إلى القناة الإخبارية، وسيتم تنشيط الصوت على جهازك", live: "مباشر", continuous: "لنكمل" }, C_ = { comment: "رأي العميل", route: "طريق", nodata: "لا يوجد محتوى يطابق بحثك", openinghours: "ساعات العمل", prices: "الأسعار", paymentmethods: "طرق الدفع", numberofplaces: "عدد الأماكن", openroutemobile: "افتح طريق خريطة جوجل على الهاتف الذكي", FoodEstablishment: "أين تأكل", LodgingBusiness: "أين تنام", TouristDestination: "ماذا ترى", TouristAttraction: "ما يجب القيام به", Product: "منتجات محلية", Service: "خدمات", Event: "الأحداث", City: "مدن", Wine: "النبيذ" }, R_ = { consult: "الدفع", thetutorial: "البرنامج التعليمي" }, O_ = { reset: "إعادة ضبط الجميع", showresults: "عرض النتائج", suggestiontitle: "اقتراحات البحث", reminder: `لا تنسى 
 أستطيع الإجابة على أسئلتك.` }, D_ = { listening: "أنت في انتظارك، أنا أستمع...", correct: "تصحيح", dontknow: "لا أعرف" }, P_ = { allow: "يرجى السماح للمتصفح بالوصول إلى الميكروفون للاستمرار.", rejected: "لقد رفضت الوصول إلى الميكروفون.", instructions: "لاستخدام الوضع الصوتي، يرجى السماح للمتصفح بالوصول إلى الميكروفون.", listening: "أنا أسمعك", trigger: "اضغط أو قل", triggerwithoutname: "اضغط للتحدث" }, I_ = { rejected: "لقد رفضت الوصول إلى موقعك الجغرافي.", instructions: "Để الوصول إلى البيانات الجوية أو الخريطة التفاعلية، يرجى السماح للمتصفح بالوصول إلى موقعك الجغرافي." }, M_ = { calltoaction: "اضغط على الشاشة للبدء", emptyveille: "انقر أو اضغط على الشاشة..." }, j_ = { shorttitle: "تقرير حالة ألطقس", attribution: "بيانات الطقس مقدمة من Open-Meteo.com" }, F_ = { title: "معالجة البيانات الشخصية المرسلة إلى الروبوت", message: `بقبول هذا الحوار، فإنك توافق على استخدام جميع البيانات المرسلة إلى روبوت الدردشة لأغراض تحليل استخدام الأداة وتحسين قاعدة المعرفة.

تُحفظ محادثاتك لمدة 6 أشهر قبل حذفها.`, link: "رابط لعرض سياسات الخصوصية", buttonAccept: "لقد فهمت وأوافق", buttonRefuse: "أرفض", messageAccepted: "تم أخذ موافقتك بعين الاعتبار", messageRefused: "تم أخذ رفضك بعين الاعتبار" }, $_ = {
  1: "الصفحة الرئيسية",
  2: "قناة اخبارية حية",
  3: "تقرير حالة ألطقس",
  4: "أرقام الطوارئ",
  1e3: "تاريخي",
  1001: "درس تعليمي",
  common: g_,
  emergency: b_,
  error: v_,
  history: y_,
  home: w_,
  inputs: __,
  language: k_,
  link: x_,
  loader: S_,
  menu: E_,
  mobileLandscapePreventer: A_,
  news: T_,
  poi: C_,
  suggestion: R_,
  template: O_,
  anghello: D_,
  microphone: P_,
  position: I_,
  veille: M_,
  weather: j_,
  GDPR: F_
}, L_ = { abort: "إلغاء", all: "الجميع", back: "خلف", close: "اغلاق", continue: "يكمل", download: "تحميل", downloadsheet: "قم بتنزيل هذه الورقة", downloadsheetmobile: "قم بتنزيل هذه الورقة على الهاتف الذكي", filter: "منقي", history: "تاريخي", knowmore: "اعرف المزيد", lang: "اللغات", menu: "القائمة", mode: "موضة", needhelp: "تحتاج مساعدة؟", parameters: "الإعدادات", print: "مطبعة", printsheet: "اطبع هذه الورقة", result: "نتيجة", results: "نتائج", singleLang: "لغة", sound: "ها", submit: "يُقدِّم", subtitle: "العنوان الفرعي", tutorial: "درس تعليمي", validate: "التحقق من صحة" }, N_ = { shorttitle: "أرقام الطوارئ", samu: ".S.A.M.U", police: "شرطة", firefighter: "رجال الاطفاء", general: "عام", citypolice: "الشرطة المحلية", hospital: "مستشفى", homeless: "بلا مأوى (مكالمة مجانية)", poison: "مركز مراقبة السموم", emergency: "حالات الطوارئ الأوروبية" }, B_ = { title: "حدث خطأ", button: "أعد تشغيل التطبيق" }, q_ = { shorttitle: "تاريخي", title: "تاريخ المحادثة" }, z_ = { shorttitle: "الصفحة الرئيسية" }, U_ = { choose: "اختر إجابة", noaction: "إجراء متوقع" }, V_ = { change: "تغيير اللغة", select: "حدد اللغة التي تريد استخدامها" }, G_ = { buttontext: "عرض الوثيقة", goto: "اذهب إلى العنوان", click: "انقر هنا", scanQR: "عن طريق مسح رمز الاستجابة السريعة", scanQRTile: "مسح رمز الاستجابة السريعة لاكتشاف" }, W_ = { loader: { optimal: "للحصول على تجربة مثالية،", classic: "لتجربة أكثر كلاسيكية،", vocal: "أنا أتحدث وجها لوجه مع الوكيل.", text: "أتواصل كتابيًا مع الوكيل." }, modes: { vocal: "الوضع الصوتي", text: "وضع النص" }, loaderValidation: "ابدأ المحادثة", locale: "فحص اللغة", supported: "التحقق من اللغات المدعومة", addressdata: "استرجاع البيانات" }, H_ = { message: "أدخل رسالتك", backconversation: "العودة إلى المحادثة", answer: " يجيب على أسئلتك" }, K_ = { firstline: "للحصول على تجربة مثالية،", secondline: "اقلب شاشتك" }, Q_ = { shorttitle: "قناة اخبارية حية", warningtext: "ستدخل إلى القناة الإخبارية، وسيتم تنشيط الصوت على جهازك", live: "مباشر", continuous: "لنكمل" }, Y_ = { comment: "رأي العميل", route: "طريق", nodata: "لا يوجد محتوى يطابق بحثك", openinghours: "ساعات العمل", prices: "الأسعار", paymentmethods: "طرق الدفع", numberofplaces: "عدد الأماكن", openroutemobile: "افتح طريق خريطة جوجل على الهاتف الذكي", FoodEstablishment: "أين تأكل", LodgingBusiness: "أين تنام", TouristDestination: "ماذا ترى", TouristAttraction: "ما يجب القيام به", Product: "منتجات محلية", Service: "خدمات", Event: "الأحداث", City: "مدن", Wine: "النبيذ" }, J_ = { consult: "الدفع", thetutorial: "البرنامج التعليمي" }, Z_ = { reset: "إعادة ضبط الجميع", showresults: "عرض النتائج", suggestiontitle: "اقتراحات البحث", reminder: `لا تنسى 
 أستطيع الإجابة على أسئلتك.` }, X_ = { listening: "أنت أمامي، أنا أستمع...", correct: "تصحيح", dontknow: "لا أعرف" }, ek = { allow: "يرجى السماح للمتصفح بالوصول إلى الميكروفون للاستمرار.", rejected: "لقد رفضت الوصول إلى الميكروفون.", instructions: "لاستخدام الوضع الصوتي، يرجى السماح للمتصفح بالوصول إلى الميكروفون.", listening: "أنا أسمعك", trigger: "اضغط أو قل", triggerwithoutname: "اضغط للتحدث" }, tk = { rejected: "لقد رفضت الوصول إلى موقعك الجغرافي.", instructions: "Để الوصول إلى البيانات الجوية أو الخريطة التفاعلية، يرجى السماح للمتصفح بالوصول إلى موقعك الجغرافي." }, rk = { calltoaction: "اضغط على الشاشة للبدء", emptyveille: "انقر أو اضغط على الشاشة..." }, nk = { shorttitle: "تقرير حالة ألطقس", attribution: "بيانات الطقس مقدمة من Open-Meteo.com" }, ik = { title: "معالجة البيانات الشخصية المرسلة إلى الروبوت", message: `بقبول هذا الحوار، فإنك توافق على استخدام جميع البيانات المرسلة إلى روبوت الدردشة لأغراض تحليل استخدام الأداة وتحسين قاعدة المعرفة.

تُحفظ محادثاتك لمدة 6 أشهر قبل حذفها.`, link: "رابط لعرض سياسات الخصوصية", buttonAccept: "لقد فهمت وأوافق", buttonRefuse: "أرفض", messageAccepted: "تم أخذ موافقتك بعين الاعتبار", messageRefused: "تم أخذ رفضك بعين الاعتبار" }, ok = {
  1: "الصفحة الرئيسية",
  2: "قناة اخبارية حية",
  3: "تقرير حالة ألطقس",
  4: "أرقام الطوارئ",
  1e3: "تاريخي",
  1001: "درس تعليمي",
  common: L_,
  emergency: N_,
  error: B_,
  history: q_,
  home: z_,
  inputs: U_,
  language: V_,
  link: G_,
  loader: W_,
  menu: H_,
  mobileLandscapePreventer: K_,
  news: Q_,
  poi: Y_,
  suggestion: J_,
  template: Z_,
  anghello: X_,
  microphone: ek,
  position: tk,
  veille: rk,
  weather: nk,
  GDPR: ik
}, ak = { abort: "cancel·lar", all: "tots", back: "esquena", close: "tanca", continue: "continua", download: "descarregar", downloadsheet: "descarregar aquest full", downloadsheetmobile: "descarregueu aquest full al telèfon intel·ligent", filter: "filtre", history: "històric", knowmore: "Més informació", lang: "idiomes", menu: "menú", mode: "moda", needhelp: "necessitar ajuda?", parameters: "configuracions", print: "imprimir", printsheet: "imprimeix aquest full", result: "resultat", results: "resultats", singleLang: "llenguatge", sound: "ella", subtitle: "subtítol", submit: "presentar", tutorial: "tutorial", validate: "validar" }, sk = { shorttitle: "Números d'emergència", samu: "S.A.M.U.", police: "policia", firefighter: "bombers", general: "general", citypolice: "Policia local", hospital: "Hospital", homeless: "Sense llar (trucada gratuïta)", poison: "Centre de control de verí", emergency: "emergències europees" }, uk = { title: "S'ha produït un error", button: "Reinicieu l'aplicació" }, ck = { shorttitle: "històric", title: "historial de converses" }, lk = { shorttitle: "pàgina d'inici" }, dk = { choose: "Tria una resposta", noaction: "S'espera una acció" }, fk = { change: "canviar l'idioma", select: "seleccioneu l'idioma que voleu utilitzar" }, hk = { buttontext: "Visualitza el document", goto: "Vés a l'adreça", click: "Clica aquí", scanQR: "escanejant el QrCode", scanQRTile: "Escaneja el codi QR per descobrir" }, pk = { loader: { optimal: "Per a una experiència òptima,", classic: "Per a una experiència més clàssica,", vocal: "Parlo cara a cara amb l'agent.", text: "Em comunico per escrit amb l'agent." }, modes: { vocal: "manera vocal", text: "mode text" }, loaderValidation: "Inicia la conversa", locale: "comprovant el llenguatge", supported: "comprovant els idiomes compatibles", addressdata: "recuperant dades" }, mk = { message: "Introduïu el vostre missatge", backconversation: "tornar a la conversa", answer: " respon les teves preguntes" }, gk = { firstline: "Per a una experiència òptima,", secondline: "gira la pantalla" }, bk = { shorttitle: "canal de notícies en directe", warningtext: "Accedeix al canal de notícies, s'activarà el so del teu dispositiu", live: "viu", continuous: "contínuament" }, vk = { comment: "revisió del client", route: "carretera", nodata: "Cap contingut coincideix amb la teva cerca", openinghours: "Horari d'obertura", prices: "Preus", paymentmethods: "Mètodes de Pagament", numberofplaces: "nombre de places", openroutemobile: "obre la ruta de Google Maps al telèfon intel·ligent", FoodEstablishment: "On menjar", LodgingBusiness: "On dormir", TouristDestination: "Què veure", TouristAttraction: "Què fer", Product: "Productes locals", Service: "Serveis", Event: "Esdeveniments", City: "Ciutats", Wine: "Vins" }, yk = { consult: "Fes una ullada", thetutorial: "el tutorial" }, wk = { reset: "restablir tot", showresults: "Mostra els resultats", suggestiontitle: "Cerca suggeriments", reminder: `No oblidis, 
 puc respondre les teves preguntes.` }, _k = { listening: "És el teu torn, t'escolto...", correct: "Corregir", dontknow: "No ho sé" }, kk = { allow: "Si us plau, autoritzeu que el vostre navegador accedeixi al micròfon per continuar.", rejected: "Heu refusat l'accés al micròfon.", instructions: "Per utilitzar el mode de veu, si us plau, autoritzeu que el vostre navegador accedeixi al micròfon.", listening: "Et estant", trigger: "Toca o diu", triggerwithoutname: "Toca per parlar" }, xk = { rejected: "Has rebutjat l'accés a la teva posició GPS.", instructions: "Per accedir als dades meteorològiques o al mapa interactiu, si us plau, autoritza el navegador per accedir a la teva posició GPS." }, Sk = { calltoaction: "Premeu la pantalla per començar", emptyveille: "Feu clic o premeu la pantalla..." }, Ek = { shorttitle: "informe del temps", attribution: "Dades meteorològiques proporcionades per Open-Meteo.com" }, Ak = { title: "tractament de les dades personals transmeses al bot", message: `en acceptar aquest diàleg, consentiu que totes les dades transmeses al chatbot s'utilitzin per a l'anàlisi de l'ús de l'eina i per millorar la base de coneixement.

Les vostres converses es conserven 6 mesos abans de ser eliminades.`, link: "enllaç per consultar les polítiques de privadesa", buttonAccept: "ho he entès i accepto", buttonRefuse: "rebutjo", messageAccepted: "el vostre consentiment ha estat pres en compte", messageRefused: "el vostre rebuig ha estat pres en compte" }, Tk = {
  1: "pàgina d'inici",
  2: "canal de notícies en directe",
  3: "informe del temps",
  4: "Números d'emergència",
  1e3: "històric",
  1001: "tutorial",
  common: ak,
  emergency: sk,
  error: uk,
  history: ck,
  home: lk,
  inputs: dk,
  language: fk,
  link: hk,
  loader: pk,
  menu: mk,
  mobileLandscapePreventer: gk,
  news: bk,
  poi: vk,
  suggestion: yk,
  template: wk,
  anghello: _k,
  microphone: kk,
  position: xk,
  veille: Sk,
  weather: Ek,
  GDPR: Ak
}, Ck = { abort: "zrušit", all: "všechno", back: "zadní", close: "zavřít", continue: "pokračovat", download: "stažení", downloadsheet: "stáhněte si tento list", downloadsheetmobile: "stáhněte si tento list na smartphone", filter: "filtr", history: "historický", knowmore: "Zjistit více", lang: "jazyky", menu: "jídelní lístek", mode: "móda", needhelp: "potřebovat pomoc?", parameters: "nastavení", print: "tisk", printsheet: "tytiskněte tento list", result: "výsledek", results: "výsledek", singleLang: "jazyk", sound: "její", submit: "předložit", subtitle: "podtitulek", tutorial: "tutorial", validate: "ověřit" }, Rk = { shorttitle: "Tísňová čísla", samu: "S.A.M.U.", police: "POLICIE", firefighter: "hasiči", general: "všeobecný", citypolice: "Místní policie", hospital: "Nemocnice", homeless: "Bezdomovci (volání zdarma)", poison: "Poison Control Center", emergency: "evropské mimořádné události" }, Ok = { title: "Došlo k chybě", button: "Znovu spusťte aplikaci" }, Dk = { shorttitle: "historický", title: "historie konverzace" }, Pk = { shorttitle: "domovská stránka" }, Ik = { choose: "Vyberte odpověď", noaction: "Očekává se akce" }, Mk = { change: "změnit jazyk", select: "vyberte jazyk, který chcete používat" }, jk = { buttontext: "Zobrazit dokument", goto: "Přejděte na adresu", click: "Klikněte zde", scanQR: "skenováním QrCode", scanQRTile: "Naskenujte QR kód a objevte" }, Fk = { loader: { optimal: "Pro optimální zážitek,", classic: "Pro klasičtější zážitek,", vocal: "Mluvím tváří v tvář s agentem.", text: "S jednatelem komunikuji písemně." }, modes: { vocal: "hlasový režim", text: "textový režim" }, loaderValidation: "Zahajte konverzaci", locale: "kontrola jazyka", supported: "kontrola podporovaných jazyků", addressdata: "načítání dat" }, $k = { message: "Zadejte svou zprávu", backconversation: "zpět k rozhovoru", answer: " odpovídá na vaše otázky" }, Lk = { firstline: "Pro optimální zážitek,", secondline: "otočte obrazovku" }, Nk = { shorttitle: "živý zpravodajský kanál", warningtext: "Vstoupíte do zpravodajského kanálu, zvuk na vašem zařízení bude aktivován", live: "žít", continuous: "nepřetržitě" }, Bk = { comment: "zákaznická recenze", route: "silnice", nodata: "Vašemu vyhledávání neodpovídá žádný obsah", openinghours: "Otevírací doba", prices: "Ceny", paymentmethods: "Platební metody", numberofplaces: "počet míst", openroutemobile: "otevřete trasu Google Maps na smartphonu", FoodEstablishment: "Kde jíst", LodgingBusiness: "Kde spát", TouristDestination: "Co vidět", TouristAttraction: "Co dělat", Product: "Místní produkty", Service: "Služby", Event: "Události", City: "Města", Wine: "Vína" }, qk = { consult: "Překontrolovat", thetutorial: "tutoriál" }, zk = { reset: "resetovat vše", showresults: "Ukaž výsledky", suggestiontitle: "Návrhy vyhledávání", reminder: `Nezapomeňte, 
 mohu odpovědět na vaše otázky.` }, Uk = { listening: "Je to na vás, poslouchám...", correct: "Opravit", dontknow: "Nevím" }, Vk = { allow: "Povolte prosím prohlížeči přístup k mikrofonu pro pokračování.", rejected: "Odmítli jste přístup k mikrofonu.", instructions: "Pro použití hlasového režimu prosím povolte prohlížeči přístup k mikrofonu.", listening: "Slyším", trigger: "Stiskněte nebo řekněte", triggerwithoutname: "Klepnutím mluvíte" }, Gk = { rejected: "Odmítl jste přístup k vaší poloze GPS.", instructions: "Chcete-li získat přístup k meteorologickým údajům nebo interaktivní mapě, povolte prosím prohlížeči přístup k vaší poloze GPS." }, Wk = { calltoaction: "Stiskněte obrazovku pro zahájení", emptyveille: "Klikněte nebo stiskněte obrazovku..." }, Hk = { shorttitle: "zpráva o počasí", attribution: "Meteorologická data poskytována společností Open-Meteo.com" }, Kk = { title: "zpracování osobních údajů předaných botovi", message: `přijetím tohoto dialogu souhlasíte s tím, aby všechna data předaná chatbotu byla využita pro analýzu používání nástroje a obohacení znalostní báze.

Vaše konverzace jsou uchovávány 6 měsíců před smazáním.`, link: "odkaz pro zobrazení zásad ochrany soukromí", buttonAccept: "rozumím a souhlasím", buttonRefuse: "odmítám", messageAccepted: "váš souhlas byl zohledněn", messageRefused: "vaše odmítnutí bylo zohledněno" }, Qk = {
  1: "domovská stránka",
  2: "živý zpravodajský kanál",
  3: "zpráva o počasí",
  4: "Tísňová čísla",
  1e3: "historický",
  1001: "tutorial",
  common: Ck,
  emergency: Rk,
  error: Ok,
  history: Dk,
  home: Pk,
  inputs: Ik,
  language: Mk,
  link: jk,
  loader: Fk,
  menu: $k,
  mobileLandscapePreventer: Lk,
  news: Nk,
  poi: Bk,
  suggestion: qk,
  template: zk,
  anghello: Uk,
  microphone: Vk,
  position: Gk,
  veille: Wk,
  weather: Hk,
  GDPR: Kk
}, Yk = { all: "alle", back: "tilbage", close: "tæt", continue: "Blive ved", download: "Hent", downloadsheet: "download dette ark", downloadsheetmobile: "download dette ark på smartphone", filter: "Filter", history: "historisk", knowmore: "Læs mere", lang: "SPROG", menu: "menu", mode: "mode", needhelp: "Brug for hjælp?", parameters: "indstillinger", print: "Print", printsheet: "Udskriv dette ark", result: "resultat", results: "resultater", singleLang: "Sprog", sound: "hende", submit: "indsend", subtitle: "undertekst", tutorial: "tutorial", validate: "validere", abort: "afbryd" }, Jk = { shorttitle: "Nødnumre", samu: "S.A.M.U.", police: "politi", firefighter: "brandmænd", general: "generel", citypolice: "Lokalt politi", hospital: "Hospital", homeless: "Hjemløs (gratis opkald)", poison: "Giftkontrolcenter", emergency: "europæiske nødsituationer" }, Zk = { title: "Der opstod en fejl", button: "Genstart applikationen" }, Xk = { shorttitle: "historisk", title: "samtale historie" }, ex = { shorttitle: "hjemmeside" }, tx = { choose: "Vælg et svar", noaction: "Afventer handling" }, rx = { change: "ændre sproget", select: "vælg det sprog, du vil bruge" }, nx = { buttontext: "Se dokumentet", goto: "Gå til adressen", click: "Klik her", scanQR: "ved at scanne QRCoden", scanQRTile: "Scan QR-koden for at opdage" }, ix = { loader: { optimal: "For en optimal oplevelse,", classic: "For en mere klassisk oplevelse,", vocal: "Jeg taler ansigt til ansigt med agenten.", text: "Jeg kommunikerer skriftligt med agenten." }, modes: { vocal: "vokal tilstand", text: "teksttilstand" }, loaderValidation: "Start samtale", locale: "kontrol af sprog", supported: "kontrol af understøttede sprog", addressdata: "hente data" }, ox = { message: "Indtast din besked", backconversation: "tilbage til samtalen", answer: " svarer på dine spørgsmål" }, ax = { firstline: "For en optimal oplevelse,", secondline: "vend din skærm" }, sx = { warningtext: "Du får adgang til nyhedskanalen, lyden på din enhed aktiveres", live: "Direkte", continuous: "løbende", shorttitle: "live nyhedskanal" }, ux = { comment: "kundeanmeldelse", route: "vej", nodata: "Intet indhold matcher din søgning", openinghours: "Åbningstider", prices: "Priser", paymentmethods: "Betalingsmetoder", numberofplaces: "antal pladser", openroutemobile: "åben Google Map-rute på smartphone", FoodEstablishment: "Hvor skal man spise", LodgingBusiness: "Hvor skal man sove", TouristDestination: "Hvad at se", TouristAttraction: "Hvad skal man gøre", Product: "Lokale produkter", Service: "Tjenester", Event: "Begivenheder", City: "Byer", Wine: "Vine" }, cx = { consult: "Tjek ud", thetutorial: "tutorialen" }, lx = { reset: "genstart alt", showresults: "Vis resultaterne", suggestiontitle: "Søgeforslag", reminder: `Glem ikke, 
 jeg kan svare på dine spørgsmål.` }, dx = { listening: "Det er op til dig, jeg lytter...", correct: "Korrigere", dontknow: "Jeg ved det ikke" }, fx = { allow: "Venligst giv din browser tilladelse til at få adgang til mikrofonen for at fortsætte.", rejected: "Du har nægtet adgangen til mikrofonen.", instructions: "For at bruge stemmetilstand, venligst giv din browser tilladelse til at få adgang til mikrofonen.", listening: "Jeg lytter", trigger: "Tryk eller siger", triggerwithoutname: "Tryk for at tale" }, hx = { rejected: "Du har afvist adgang til din GPS-position.", instructions: "For at få adgang til vejret eller interaktivt kort, skal du venligst give din browser adgang til din GPS-position." }, px = { calltoaction: "Tryk på skærmen for at starte", emptyveille: "Klik eller tryk på skærmen..." }, mx = { shorttitle: "vejrudsigt", attribution: "Vejrdata leveret af Open-Meteo.com" }, gx = { title: "behandling af personoplysninger transmitteret til botten", message: `ved at acceptere denne dialog giver du dit samtykke til, at alle data transmitteret til chatbotten kan bruges til analyse af brugen af værktøjet og forbedring af vidensbasen.

Dine samtaler opbevares i 6 måneder inden sletning.`, link: "link til at se privatlivspolitikker", buttonAccept: "jeg forstår og accepterer", buttonRefuse: "jeg afviser", messageAccepted: "dit samtykke er taget til efterretning", messageRefused: "dit afslag er taget til efterretning" }, bx = {
  1: "hjemmeside",
  2: "live nyhedskanal",
  3: "vejrudsigt",
  4: "Nødnumre",
  1e3: "historisk",
  1001: "tutorial",
  common: Yk,
  emergency: Jk,
  error: Zk,
  history: Xk,
  home: ex,
  inputs: tx,
  language: rx,
  link: nx,
  loader: ix,
  menu: ox,
  mobileLandscapePreventer: ax,
  news: sx,
  poi: ux,
  suggestion: cx,
  template: lx,
  anghello: dx,
  microphone: fx,
  position: hx,
  veille: px,
  weather: mx,
  GDPR: gx
}, vx = { all: "alle", back: "zurück", close: "schließen", continue: "Weiter", download: "herunterladen", downloadsheet: "Dieses Blatt herunterladen", downloadsheetmobile: "Laden Sie dieses Blatt auf Ihr Smartphone herunter", filter: "filter", history: "Verlauf", knowmore: "Mehr erfahren", lang: "Sprachen", menu: "Menü", mode: "Modus", needhelp: "Brauche Hilfe ?", parameters: "Parameter", print: "Ausdrucken", printsheet: "Blat ausdrucken", result: "Ergebnis", results: "Ergebnisse", singleLang: "Sprache", sound: "Ton", subtitle: "Untertitel", submit: "einreichen", tutorial: "Lernprogramm", validate: "validieren", abort: "Abbrechen" }, yx = { shorttitle: "Notrufnummern", samu: "samu", police: "polizei", firefighter: "feuerwehrleute", general: "allgemein", citypolice: "Lokale Polizeibehörde", hospital: "Krankenhaus", homeless: "Obdachlos (kostenloser Anruf)", poison: "Giftkontrollzentrum", emergency: "Europäische Notfälle" }, wx = { title: "Es ist ein Fehler aufgetreten", button: "Starten Sie die Anwendung erneut" }, _x = { shorttitle: "Geschichte", title: "Chat-Verlauf" }, kx = { shorttitle: "Startseite" }, xx = { choose: "Wählen Sie eine Antwort", noaction: "Aktion erwartet" }, Sx = { change: "die Sprache ändern", select: "Wählen Sie die gewünschte Sprache" }, Ex = { buttontext: "Sehen Sie sich das Dokument an", goto: "Zur Adresse gehen", click: "klicken Sie hier", scanQR: "durch Scannen des QrCodes", scanQRTile: "Scannen Sie den QR-Code, um zu entdecken" }, Ax = { loader: { optimal: "Für ein optimales Erlebnis,", classic: "Für ein eher klassisches Erlebnis,", vocal: "Ich kommuniziere durch Sprechen mit dem Agenten.", text: "Ich kommuniziere per Text mit dem Agenten." }, modes: { vocal: "Vokal-Modus", text: "Textmodus" }, loaderValidation: "Gespräch beginnen", locale: "Gebietsschema prüfen", supported: "Prüfung der unterstützten Gebietsschemata", store: "Speicher erstellen", directline: "Direktleitung verbinden", ponyfill: "ponyfilling", addressdata: "Abrufen von Daten" }, Tx = { message: "Geben Sie Ihre Nachricht ein", backconversation: "zurück zum Gespräch", answer: " beantwortet Ihre Fragen" }, Cx = { firstline: "Für ein optimales Erlebnis,", secondline: "drehen Sie Ihren Bildschirm um" }, Rx = { warningtext: "Sie sind dabei, den Informationskanal aufzurufen, der Ton Ihres Geräts wird aktiviert", live: "live", continuous: "fortlaufend", shorttitle: "Live-Infokanal" }, Ox = { comment: "Kundenbewertung", route: "Route", nodata: "Kein Inhalt entspricht Ihrer Suche", openinghours: "Öffnungszeiten", prices: "Preise", paymentmethods: "Zahlungsarten", numberofplaces: "Anzahl der Plätze", openroutemobile: "Öffnen Sie die Google Map-Route auf dem Smartphone", FoodEstablishment: "Wo sollen wir essen", LodgingBusiness: "Wo schlafen", TouristDestination: "Was zu sehen", TouristAttraction: "Was zu tun", Product: "Lokale Produkte", Service: "Dienstleistungen", Event: "Veranstaltungen", City: "Städte", Wine: "Weine" }, Dx = { consult: "Schauen Sie sich", thetutorial: "das Tutorial an" }, Px = { reset: "Filter zurücksetzen", showresults: "Ergebnisse anzeigen", suggestiontitle: "Forschungsvorschläge", reminder: `Vergessen Sie nicht :
 Ich kann Ihre Fragen beantworten.` }, Ix = { listening: "Es liegt an dir, ich höre...", correct: "Korrigieren", dontknow: "Ich weiß es nicht" }, Mx = { allow: "Bitte erlauben Sie Ihrem Browser den Zugriff auf das Mikrofon, um fortzufahren.", rejected: "Sie haben den Zugriff auf das Mikrofon abgelehnt.", instructions: "Um den Sprachmodus zu verwenden, erlauben Sie bitte Ihrem Browser den Zugriff auf das Mikrofon.", listening: "Ich höre", trigger: "Drücken Sie oder sagen Sie", triggerwithoutname: "Zum Sprechen tippen" }, jx = { rejected: "Sie haben den Zugriff auf Ihren GPS-Standort abgelehnt.", instructions: "Um auf die Wetterdaten oder die interaktive Karte zuzugreifen, autorisieren Sie bitte Ihren Browser, auf Ihren GPS-Standort zuzugreifen." }, Fx = { calltoaction: "Drücken Sie den Bildschirm, um zu beginnen", emptyveille: "Klicken oder tippen Sie auf den Bildschirm..." }, $x = { shorttitle: "Wetter", attribution: "Wetterdaten bereitgestellt von Open-Meteo.com" }, Lx = { title: "Verarbeitung persönlicher Daten, die an den Bot übermittelt werden", message: `Durch die Annahme dieses Dialogs stimmen Sie zu, dass alle an den Chatbot übermittelten Daten für die Analyse der Nutzung des Tools und die Verbesserung der Wissensbasis verwendet werden können.

Ihre Gespräche werden 6 Monate lang aufbewahrt, bevor sie gelöscht werden.`, link: "Link zur Ansicht der Datenschutzrichtlinien", buttonAccept: "Ich verstehe und akzeptiere", buttonRefuse: "Ich lehne ab", messageAccepted: "Ihre Zustimmung wurde berücksichtigt", messageRefused: "Ihre Ablehnung wurde berücksichtigt" }, Nx = {
  1: "Startseite",
  2: "Live-Infokanal",
  3: "Wetter",
  4: "Notrufnummern",
  1e3: "Geschichte",
  1001: "anleitung",
  common: vx,
  emergency: yx,
  error: wx,
  history: _x,
  home: kx,
  inputs: xx,
  language: Sx,
  link: Ex,
  loader: Ax,
  menu: Tx,
  mobileLandscapePreventer: Cx,
  news: Rx,
  poi: Ox,
  suggestion: Dx,
  template: Px,
  anghello: Ix,
  microphone: Mx,
  position: jx,
  veille: Fx,
  weather: $x,
  GDPR: Lx
}, Bx = { all: "alle", back: "zurück", close: "schließen", continue: "Weiter", download: "herunterladen", downloadsheet: "Dieses Blatt herunterladen", downloadsheetmobile: "Laden Sie dieses Blatt auf Ihr Smartphone herunter", filter: "filter", history: "Verlauf", knowmore: "Mehr erfahren", lang: "Sprachen", menu: "Menü", mode: "Modus", needhelp: "Brauche Hilfe ?", parameters: "Parameter", print: "Ausdrucken", printsheet: "Blat ausdrucken", result: "Ergebnis", results: "Ergebnisse", singleLang: "Sprache", sound: "Ton", subtitle: "Untertitel", submit: "einreichen", tutorial: "Lernprogramm", validate: "validieren", abort: "Abbrechen" }, qx = { shorttitle: "Notrufnummern", samu: "samu", police: "polizei", firefighter: "feuerwehrleute", general: "allgemein", citypolice: "Lokale Polizeibehörde", hospital: "Krankenhaus", homeless: "Obdachlos (kostenloser Anruf)", poison: "Giftkontrollzentrum", emergency: "Europäische Notfälle" }, zx = { title: "Es ist ein Fehler aufgetreten", button: "Starten Sie die Anwendung erneut" }, Ux = { shorttitle: "Geschichte", title: "Chat-Verlauf" }, Vx = { shorttitle: "Startseite" }, Gx = { choose: "Wählen Sie eine Antwort", noaction: "Aktion erwartet" }, Wx = { change: "die Sprache ändern", select: "Wählen Sie die gewünschte Sprache" }, Hx = { buttontext: "Sehen Sie sich das Dokument an", goto: "Zur Adresse gehen", click: "klicken Sie hier", scanQR: "durch Scannen des QrCodes", scanQRTile: "Scannen Sie den QR-Code, um zu entdecken" }, Kx = { loader: { optimal: "Für ein optimales Erlebnis,", classic: "Für ein eher klassisches Erlebnis,", vocal: "Ich kommuniziere durch Sprechen mit dem Agenten.", text: "Ich kommuniziere per Text mit dem Agenten." }, modes: { vocal: "Vokal-Modus", text: "Textmodus" }, loaderValidation: "Gespräch beginnen", locale: "Gebietsschema prüfen", supported: "Prüfung der unterstützten Gebietsschemata", store: "Speicher erstellen", directline: "Direktleitung verbinden", ponyfill: "ponyfilling", addressdata: "Abrufen von Daten" }, Qx = { message: "Geben Sie Ihre Nachricht ein", backconversation: "zurück zum Gespräch", answer: " beantwortet Ihre Fragen" }, Yx = { firstline: "Für ein optimales Erlebnis,", secondline: "drehen Sie Ihren Bildschirm um" }, Jx = { warningtext: "Sie sind dabei, den Informationskanal aufzurufen, der Ton Ihres Geräts wird aktiviert", live: "live", continuous: "fortlaufend", shorttitle: "Live-Infokanal" }, Zx = { comment: "Kundenbewertung", route: "Route", nodata: "Kein Inhalt entspricht Ihrer Suche", openinghours: "Öffnungszeiten", prices: "Preise", paymentmethods: "Zahlungsarten", numberofplaces: "Anzahl der Plätze", openroutemobile: "Öffnen Sie die Google Map-Route auf dem Smartphone", FoodEstablishment: "Wo sollen wir essen", LodgingBusiness: "Wo schlafen", TouristDestination: "Was zu sehen", TouristAttraction: "Was zu tun", Product: "Lokale Produkte", Service: "Dienstleistungen", Event: "Veranstaltungen", City: "Städte", Wine: "Weine" }, Xx = { consult: "Schauen Sie sich", thetutorial: "das Tutorial an" }, eS = { reset: "Filter zurücksetzen", showresults: "Ergebnisse anzeigen", suggestiontitle: "Forschungsvorschläge", reminder: `Vergessen Sie nicht :
 Ich kann Ihre Fragen beantworten.` }, tS = { listening: "Es liegt an dir, ich höre...", correct: "Korrigieren", dontknow: "Ich weiß es nicht" }, rS = { allow: "Bitte erlauben Sie Ihrem Browser den Zugriff auf das Mikrofon, um fortzufahren.", rejected: "Sie haben den Zugriff auf das Mikrofon abgelehnt.", instructions: "Um den Sprachmodus zu verwenden, erlauben Sie bitte Ihrem Browser den Zugriff auf das Mikrofon.", listening: "Ich höre", trigger: "Drücken Sie oder sagen Sie", triggerwithoutname: "Zum Sprechen tippen" }, nS = { rejected: "Sie haben den Zugriff auf Ihren GPS-Standort abgelehnt.", instructions: "Um auf die Wetterdaten oder die interaktive Karte zuzugreifen, autorisieren Sie bitte Ihren Browser, auf Ihren GPS-Standort zuzugreifen." }, iS = { calltoaction: "Drücken Sie den Bildschirm, um zu beginnen", emptyveille: "Klicken oder tippen Sie auf den Bildschirm..." }, oS = { shorttitle: "Wetter", attribution: "Wetterdaten bereitgestellt von Open-Meteo.com" }, aS = { title: "Verarbeitung persönlicher Daten, die an den Bot übermittelt werden", message: `Durch die Annahme dieses Dialogs stimmen Sie zu, dass alle an den Chatbot übermittelten Daten für die Analyse der Nutzung des Tools und die Verbesserung der Wissensbasis verwendet werden können.

Ihre Gespräche werden 6 Monate lang aufbewahrt, bevor sie gelöscht werden.`, link: "Link zur Ansicht der Datenschutzrichtlinien", buttonAccept: "Ich verstehe und akzeptiere", buttonRefuse: "Ich lehne ab", messageAccepted: "Ihre Zustimmung wurde berücksichtigt", messageRefused: "Ihre Ablehnung wurde berücksichtigt" }, sS = {
  1: "Startseite",
  2: "Live-Infokanal",
  3: "Wetter",
  4: "Notrufnummern",
  1e3: "Geschichte",
  1001: "anleitung",
  common: Bx,
  emergency: qx,
  error: zx,
  history: Ux,
  home: Vx,
  inputs: Gx,
  language: Wx,
  link: Hx,
  loader: Kx,
  menu: Qx,
  mobileLandscapePreventer: Yx,
  news: Jx,
  poi: Zx,
  suggestion: Xx,
  template: eS,
  anghello: tS,
  microphone: rS,
  position: nS,
  veille: iS,
  weather: oS,
  GDPR: aS
}, uS = { all: "alle", back: "zurück", close: "schließen", continue: "Weiter", download: "herunterladen", downloadsheet: "Dieses Blatt herunterladen", downloadsheetmobile: "Laden Sie dieses Blatt auf Ihr Smartphone herunter", filter: "filter", history: "Verlauf", knowmore: "Mehr erfahren", lang: "Sprachen", menu: "Menü", mode: "Modus", needhelp: "Brauche Hilfe ?", parameters: "Parameter", print: "Ausdrucken", printsheet: "Blat ausdrucken", result: "Ergebnis", results: "Ergebnisse", singleLang: "Sprache", sound: "Ton", subtitle: "Untertitel", submit: "einreichen", tutorial: "Lernprogramm", validate: "validieren", abort: "Abbrechen" }, cS = { shorttitle: "Notrufnummern", samu: "samu", police: "polizei", firefighter: "feuerwehrleute", general: "allgemein", citypolice: "Lokale Polizeibehörde", hospital: "Krankenhaus", homeless: "Obdachlos (kostenloser Anruf)", poison: "Giftkontrollzentrum", emergency: "Europäische Notfälle" }, lS = { title: "Es ist ein Fehler aufgetreten", button: "Starten Sie die Anwendung erneut" }, dS = { shorttitle: "Geschichte", title: "Chat-Verlauf" }, fS = { shorttitle: "Startseite" }, hS = { choose: "Wählen Sie eine Antwort", noaction: "Aktion erwartet" }, pS = { change: "die Sprache ändern", select: "Wählen Sie die gewünschte Sprache" }, mS = { buttontext: "Sehen Sie sich das Dokument an", goto: "Zur Adresse gehen", click: "klicken Sie hier", scanQR: "durch Scannen des QrCodes", scanQRTile: "Scannen Sie den QR-Code, um zu entdecken" }, gS = { loader: { optimal: "Für ein optimales Erlebnis,", classic: "Für ein eher klassisches Erlebnis,", vocal: "Ich kommuniziere durch Sprechen mit dem Agenten.", text: "Ich kommuniziere per Text mit dem Agenten." }, modes: { vocal: "Vokal-Modus", text: "Textmodus" }, loaderValidation: "Gespräch beginnen", locale: "Gebietsschema prüfen", supported: "Prüfung der unterstützten Gebietsschemata", store: "Speicher erstellen", directline: "Direktleitung verbinden", ponyfill: "ponyfilling", addressdata: "Abrufen von Daten" }, bS = { message: "Geben Sie Ihre Nachricht ein", backconversation: "zurück zum Gespräch", answer: " beantwortet Ihre Fragen" }, vS = { firstline: "Für ein optimales Erlebnis,", secondline: "drehen Sie Ihren Bildschirm um" }, yS = { warningtext: "Sie sind dabei, den Informationskanal aufzurufen, der Ton Ihres Geräts wird aktiviert", live: "live", continuous: "fortlaufend", shorttitle: "Live-Infokanal" }, wS = { comment: "Kundenbewertung", route: "Route", nodata: "Kein Inhalt entspricht Ihrer Suche", openinghours: "Öffnungszeiten", prices: "Preise", paymentmethods: "Zahlungsarten", numberofplaces: "Anzahl der Plätze", openroutemobile: "Öffnen Sie die Google Map-Route auf dem Smartphone", FoodEstablishment: "Wo sollen wir essen", LodgingBusiness: "Wo schlafen", TouristDestination: "Was zu sehen", TouristAttraction: "Was zu tun", Product: "Lokale Produkte", Service: "Dienstleistungen", Event: "Veranstaltungen", City: "Städte", Wine: "Weine" }, _S = { consult: "Schauen Sie sich", thetutorial: "das Tutorial an" }, kS = { reset: "Filter zurücksetzen", showresults: "Ergebnisse anzeigen", suggestiontitle: "Forschungsvorschläge", reminder: `Vergessen Sie nicht :
 Ich kann Ihre Fragen beantworten.` }, xS = { listening: "Es liegt an dir, ich höre...", correct: "Korrigieren", dontknow: "Ich weiß es nicht" }, SS = { allow: "Bitte erlauben Sie Ihrem Browser den Zugriff auf das Mikrofon, um fortzufahren.", rejected: "Sie haben den Zugriff auf das Mikrofon abgelehnt.", instructions: "Um den Sprachmodus zu verwenden, erlauben Sie bitte Ihrem Browser den Zugriff auf das Mikrofon.", listening: "Ich höre", trigger: "Drücken Sie oder sagen Sie", triggerwithoutname: "Zum Sprechen tippen" }, ES = { rejected: "Sie haben den Zugriff auf Ihren GPS-Standort abgelehnt.", instructions: "Um auf die Wetterdaten oder die interaktive Karte zuzugreifen, autorisieren Sie bitte Ihren Browser, auf Ihren GPS-Standort zuzugreifen." }, AS = { calltoaction: "Drücken Sie den Bildschirm, um zu beginnen", emptyveille: "Klicken oder tippen Sie auf den Bildschirm..." }, TS = { shorttitle: "Wetter", attribution: "Wetterdaten bereitgestellt von Open-Meteo.com" }, CS = { title: "Verarbeitung persönlicher Daten, die an den Bot übermittelt werden", message: `Durch die Annahme dieses Dialogs stimmen Sie zu, dass alle an den Chatbot übermittelten Daten für die Analyse der Nutzung des Tools und die Verbesserung der Wissensbasis verwendet werden können.

Ihre Gespräche werden 6 Monate lang aufbewahrt, bevor sie gelöscht werden.`, link: "Link zur Ansicht der Datenschutzrichtlinien", buttonAccept: "Ich verstehe und akzeptiere", buttonRefuse: "Ich lehne ab", messageAccepted: "Ihre Zustimmung wurde berücksichtigt", messageRefused: "Ihre Ablehnung wurde berücksichtigt" }, RS = {
  1: "Startseite",
  2: "Live-Infokanal",
  3: "Wetter",
  4: "Notrufnummern",
  1e3: "Geschichte",
  1001: "anleitung",
  common: uS,
  emergency: cS,
  error: lS,
  history: dS,
  home: fS,
  inputs: hS,
  language: pS,
  link: mS,
  loader: gS,
  menu: bS,
  mobileLandscapePreventer: vS,
  news: yS,
  poi: wS,
  suggestion: _S,
  template: kS,
  anghello: xS,
  microphone: SS,
  position: ES,
  veille: AS,
  weather: TS,
  GDPR: CS
}, OS = { abort: "abort", all: "all", back: "back", close: "close", continue: "continue", download: "download", downloadsheet: "download this sheet", downloadsheetmobile: "download this sheet on smartphone", filter: "filter", history: "history", knowmore: "Learn more", lang: "languages", menu: "menu", mode: "mode", needhelp: "Need help ?", parameters: "parameters", print: "print", printsheet: "print this sheet", result: "result", results: "results", singleLang: "language", sound: "sound", submit: "submit", subtitle: "subtitle", tutorial: "tutorial", validate: "validate" }, DS = { shorttitle: "emergency numbers", samu: "maeu", police: "police", firefighter: "firefighters", general: "general", citypolice: "Local police", hospital: "Hospital", homeless: "Homeless (free call)", poison: "Poison Control Center", emergency: "European emergencies" }, PS = { title: "An error occurred", button: "Launch the application again" }, IS = { title: "chat history", shorttitle: "history" }, MS = { shorttitle: "home" }, jS = { choose: "Choose an answer", noaction: "Awaiting action" }, FS = { change: "change the language", select: "select the language you want to use" }, $S = { buttontext: "View the document", goto: "Go to address", click: "Click here", scanQR: "by scanning the QrCode", scanQRTile: "Scan the QR Code to discover" }, LS = { loader: { optimal: "For an optimal experience,", classic: "For a more classical experience,", vocal: "I communicate by speaking with the agent.", text: "I communicate by text with the agent." }, modes: { vocal: "vocal mode", text: "text mode" }, loaderValidation: "Start conversation", locale: "checking language", supported: "checking supported languages", addressdata: "retrieving data", store: "store", directline: "directline", ponyfill: "ponyfill" }, NS = { message: "Enter your message", backconversation: "back to the conversation", answer: " answers your questions" }, BS = { firstline: "For an optimal experience,", secondline: "flip your screen" }, qS = { warningtext: "You are about to access the information channel, the sound of your device will be activated", live: "live", continuous: "continuous", shorttitle: "live info channel" }, zS = { comment: "customer review", route: "route", nodata: "No content corresponds to your search", openinghours: "Opening hours", prices: "Prices", paymentmethods: "Payment methods", numberofplaces: "number of places", openroutemobile: "open Google Maps route on smartphone", FoodEstablishment: "Where to eat", LodgingBusiness: "Where to sleep", TouristDestination: "What to see", TouristAttraction: "What to do", Product: "Local products", Service: "Services", Event: "Events", City: "Cities", Wine: "Wines" }, US = { consult: "Check out", thetutorial: "the tutorial" }, VS = { reset: "reset filters", showresults: "Show results", suggestiontitle: "Research suggestions", reminder: `Don't forget,
 I can answer your questions.` }, GS = { title: "processing personal data transmitted to the bot", message: `by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.

Your conversations are kept 6 month before deletion.`, link: "open confidency policy", buttonAccept: "I understand and I accept", buttonRefuse: "I refuse", messageAccepted: "your acceptation has been saved", messageRefused: "your refusal has been saved" }, WS = { listening: "It's up to you, I'm listening...", correct: "Correct", dontknow: "I don't know" }, HS = { allow: "Please allow your browser to access the microphone to continue.", rejected: "You have denied access to the microphone.", instructions: "To use voice mode, please allow your browser to access the microphone.", listening: "I'm listening", trigger: "Press or say", triggerwithoutname: "Tap to talk" }, KS = { rejected: "You have denied access to your GPS location.", instructions: "To access weather data or the interactive map, please allow your browser to access your GPS location." }, QS = { calltoaction: "Press the screen to start", emptyveille: "Click or press the screen..." }, YS = { attribution: "Weather data provided by Open-Meteo.com", shorttitle: "weather" }, JS = { shorttitle: "tutorial" }, ZS = {
  1: "home",
  2: "live info channel",
  3: "weather",
  4: "emergency numbers",
  1e3: "history",
  1001: "tutorial",
  common: OS,
  emergency: DS,
  error: PS,
  history: IS,
  home: MS,
  inputs: jS,
  language: FS,
  link: $S,
  loader: LS,
  menu: NS,
  mobileLandscapePreventer: BS,
  news: qS,
  poi: zS,
  suggestion: US,
  template: VS,
  GDPR: GS,
  anghello: WS,
  microphone: HS,
  position: KS,
  veille: QS,
  weather: YS,
  tutorial: JS
}, XS = { abort: "abort", all: "all", back: "back", close: "close", continue: "continue", download: "download", downloadsheet: "download this sheet", downloadsheetmobile: "download this sheet on smartphone", filter: "filter", history: "history", knowmore: "Learn more", lang: "languages", menu: "menu", mode: "mode", needhelp: "Need help ?", parameters: "parameters", print: "print", printsheet: "print this sheet", result: "result", results: "results", singleLang: "language", sound: "sound", submit: "submit", subtitle: "subtitle", tutorial: "tutorial", validate: "validate" }, e3 = { shorttitle: "emergency numbers", samu: "maeu", police: "police", firefighter: "firefighters", general: "general", citypolice: "Local police", hospital: "Hospital", homeless: "Homeless (free call)", poison: "Poison Control Center", emergency: "European emergencies" }, t3 = { title: "An error occurred", button: "Launch the application again" }, r3 = { title: "chat history", shorttitle: "history" }, n3 = { choose: "Choose an answer", noaction: "Awaiting action" }, i3 = { change: "change the language", select: "select the language you want to use" }, o3 = { buttontext: "View the document", goto: "Go to address", click: "Click here", scanQR: "by scanning the QrCode", scanQRTile: "Scan the QR Code to discover" }, a3 = { loader: { optimal: "For an optimal experience,", classic: "For a more classical experience,", vocal: "I communicate by speaking with the agent.", text: "I communicate by text with the agent." }, modes: { vocal: "vocal mode", text: "text mode" }, loaderValidation: "Start conversation", locale: "checking language", supported: "checking supported languages", addressdata: "retrieving data", store: "store", directline: "directline", ponyfill: "ponyfill" }, s3 = { message: "Enter your message", backconversation: "back to the conversation", answer: " answers your questions" }, u3 = { firstline: "For an optimal experience,", secondline: "flip your screen" }, c3 = { warningtext: "You are about to access the information channel, the sound of your device will be activated", live: "live", continuous: "continuous", shorttitle: "live info channel" }, l3 = { comment: "customer review", route: "route", nodata: "No content corresponds to your search", openinghours: "Opening hours", prices: "Prices", paymentmethods: "Payment methods", numberofplaces: "number of places", openroutemobile: "open Google Maps route on smartphone", FoodEstablishment: "Where to eat", LodgingBusiness: "Where to sleep", TouristDestination: "What to see", TouristAttraction: "What to do", Product: "Local products", Service: "Services", Event: "Events", City: "Cities", Wine: "Wines" }, d3 = { consult: "Check out", thetutorial: "the tutorial" }, f3 = { reset: "reset filters", showresults: "Show results", suggestiontitle: "Research suggestions", reminder: `Don't forget,
 I can answer your questions.` }, h3 = { title: "processing personal data transmitted to the bot", message: `by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.

Your conversations are kept 6 month before deletion.`, link: "open confidency policy", buttonAccept: "I understand and I accept", buttonRefuse: "I refuse", messageAccepted: "your acceptation has been saved", messageRefused: "your refusal has been saved" }, p3 = { listening: "It's up to you, I'm listening...", correct: "Correct", dontknow: "I don't know" }, m3 = { allow: "Please allow your browser to access the microphone to continue.", rejected: "You have denied access to the microphone.", instructions: "To use voice mode, please allow your browser to access the microphone.", listening: "I'm listening", trigger: "Press or say", triggerwithoutname: "Tap to talk" }, g3 = { rejected: "You have denied access to your GPS location.", instructions: "To access weather data or the interactive map, please allow your browser to access your GPS location." }, b3 = { calltoaction: "Press the screen to start", emptyveille: "Click or press the screen..." }, v3 = { attribution: "Weather data provided by Open-Meteo.com", shorttitle: "weather" }, y3 = { shorttitle: "tutorial" }, w3 = {
  1: "home",
  2: "live info channel",
  3: "weather",
  4: "emergency numbers",
  1e3: "history",
  1001: "tutorial",
  common: XS,
  emergency: e3,
  error: t3,
  history: r3,
  inputs: n3,
  language: i3,
  link: o3,
  loader: a3,
  menu: s3,
  mobileLandscapePreventer: u3,
  news: c3,
  poi: l3,
  suggestion: d3,
  template: f3,
  GDPR: h3,
  anghello: p3,
  microphone: m3,
  position: g3,
  veille: b3,
  weather: v3,
  tutorial: y3
}, _3 = { abort: "abort", all: "all", back: "back", close: "close", continue: "continue", download: "download", downloadsheet: "download this sheet", downloadsheetmobile: "download this sheet on smartphone", filter: "filter", history: "history", knowmore: "Learn more", lang: "languages", menu: "menu", mode: "mode", needhelp: "Need help ?", parameters: "parameters", print: "print", printsheet: "print this sheet", result: "result", results: "results", singleLang: "language", sound: "sound", submit: "submit", subtitle: "subtitle", tutorial: "tutorial", validate: "validate" }, k3 = { shorttitle: "emergency numbers", samu: "maeu", police: "police", firefighter: "firefighters", general: "general", citypolice: "Local police", hospital: "Hospital", homeless: "Homeless (free call)", poison: "Poison Control Center", emergency: "European emergencies" }, x3 = { title: "An error occurred", button: "Launch the application again" }, S3 = { title: "chat history", shorttitle: "history" }, E3 = { shorttitle: "home" }, A3 = { choose: "Choose an answer", noaction: "Awaiting action" }, T3 = { change: "change the language", select: "select the language you want to use" }, C3 = { buttontext: "View the document", goto: "Go to address", click: "Click here", scanQR: "by scanning the QrCode", scanQRTile: "Scan the QR Code to discover" }, R3 = { loader: { optimal: "For an optimal experience,", classic: "For a more classical experience,", vocal: "I communicate by speaking with the agent.", text: "I communicate by text with the agent." }, modes: { vocal: "vocal mode", text: "text mode" }, loaderValidation: "Start conversation", locale: "checking language", supported: "checking supported languages", addressdata: "retrieving data", store: "store", directline: "directline", ponyfill: "ponyfill" }, O3 = { message: "Enter your message", backconversation: "back to the conversation", answer: " answers your questions" }, D3 = { firstline: "For an optimal experience,", secondline: "flip your screen" }, P3 = { warningtext: "You are about to access the information channel, the sound of your device will be activated", live: "live", continuous: "continuous", shorttitle: "live info channel" }, I3 = { comment: "customer review", route: "route", nodata: "No content corresponds to your search", openinghours: "Opening hours", prices: "Prices", paymentmethods: "Payment methods", numberofplaces: "number of places", openroutemobile: "open Google Maps route on smartphone", FoodEstablishment: "Where to eat", LodgingBusiness: "Where to sleep", TouristDestination: "What to see", TouristAttraction: "What to do", Product: "Local products", Service: "Services", Event: "Events", City: "Cities", Wine: "Wines" }, M3 = { consult: "Check out", thetutorial: "the tutorial" }, j3 = { reset: "reset filters", showresults: "Show results", suggestiontitle: "Research suggestions", reminder: `Don't forget,
 I can answer your questions.` }, F3 = { title: "processing personal data transmitted to the bot", message: `by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.

Your conversations are kept 6 month before deletion.`, link: "open confidency policy", buttonAccept: "I understand and I accept", buttonRefuse: "I refuse", messageAccepted: "your acceptation has been saved", messageRefused: "your refusal has been saved" }, $3 = { listening: "It's up to you, I'm listening...", correct: "Correct", dontknow: "I don't know" }, L3 = { allow: "Please allow your browser to access the microphone to continue.", rejected: "You have denied access to the microphone.", instructions: "To use voice mode, please allow your browser to access the microphone.", listening: "I'm listening", trigger: "Press or say", triggerwithoutname: "Tap to talk" }, N3 = { rejected: "You have denied access to your GPS location.", instructions: "To access weather data or the interactive map, please allow your browser to access your GPS location." }, B3 = { calltoaction: "Press the screen to start", emptyveille: "Click or press the screen..." }, q3 = { attribution: "Weather data provided by Open-Meteo.com", shorttitle: "weather" }, z3 = { shorttitle: "tutorial" }, U3 = {
  1: "home",
  2: "live info channel",
  3: "weather",
  4: "emergency numbers",
  1e3: "history",
  1001: "tutorial",
  common: _3,
  emergency: k3,
  error: x3,
  history: S3,
  home: E3,
  inputs: A3,
  language: T3,
  link: C3,
  loader: R3,
  menu: O3,
  mobileLandscapePreventer: D3,
  news: P3,
  poi: I3,
  suggestion: M3,
  template: j3,
  GDPR: F3,
  anghello: $3,
  microphone: L3,
  position: N3,
  veille: B3,
  weather: q3,
  tutorial: z3
}, V3 = { abort: "abort", all: "all", back: "back", close: "close", continue: "continue", download: "download", downloadsheet: "download this sheet", downloadsheetmobile: "download this sheet on smartphone", filter: "filter", history: "history", knowmore: "Learn more", lang: "languages", menu: "menu", mode: "mode", needhelp: "Need help ?", parameters: "parameters", print: "print", printsheet: "print this sheet", result: "result", results: "results", singleLang: "language", sound: "sound", submit: "submit", subtitle: "subtitle", tutorial: "tutorial", validate: "validate" }, G3 = { shorttitle: "emergency numbers", samu: "maeu", police: "police", firefighter: "firefighters", general: "general", citypolice: "Local police", hospital: "Hospital", homeless: "Homeless (free call)", poison: "Poison Control Center", emergency: "European emergencies" }, W3 = { title: "An error occurred", button: "Launch the application again" }, H3 = { title: "chat history", shorttitle: "history" }, K3 = { shorttitle: "home" }, Q3 = { choose: "Choose an answer", noaction: "Awaiting action" }, Y3 = { change: "change the language", select: "select the language you want to use" }, J3 = { buttontext: "View the document", goto: "Go to address", click: "Click here", scanQR: "by scanning the QrCode", scanQRTile: "Scan the QR Code to discover" }, Z3 = { loader: { optimal: "For an optimal experience,", classic: "For a more classical experience,", vocal: "I communicate by speaking with the agent.", text: "I communicate by text with the agent." }, modes: { vocal: "vocal mode", text: "text mode" }, loaderValidation: "Start conversation", locale: "checking language", supported: "checking supported languages", addressdata: "retrieving data", store: "store", directline: "directline", ponyfill: "ponyfill" }, X3 = { message: "Enter your message", backconversation: "back to the conversation", answer: " answers your questions" }, eE = { firstline: "For an optimal experience,", secondline: "flip your screen" }, tE = { warningtext: "You are about to access the information channel, the sound of your device will be activated", live: "live", continuous: "continuous", shorttitle: "live info channel" }, rE = { comment: "customer review", route: "route", nodata: "No content corresponds to your search", openinghours: "Opening hours", prices: "Prices", paymentmethods: "Payment methods", numberofplaces: "number of places", openroutemobile: "open Google Maps route on smartphone", FoodEstablishment: "Where to eat", LodgingBusiness: "Where to sleep", TouristDestination: "What to see", TouristAttraction: "What to do", Product: "Local products", Service: "Services", Event: "Events", City: "Cities", Wine: "Wines" }, nE = { consult: "Check out", thetutorial: "the tutorial" }, iE = { reset: "reset filters", showresults: "Show results", suggestiontitle: "Research suggestions", reminder: `Don't forget,
 I can answer your questions.` }, oE = { title: "processing personal data transmitted to the bot", message: `by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.

Your conversations are kept 6 month before deletion.`, link: "open confidency policy", buttonAccept: "I understand and I accept", buttonRefuse: "I refuse", messageAccepted: "your acceptation has been saved", messageRefused: "your refusal has been saved" }, aE = { listening: "It's up to you, I'm listening...", correct: "Correct", dontknow: "I don't know" }, sE = { allow: "Please allow your browser to access the microphone to continue.", rejected: "You have denied access to the microphone.", instructions: "To use voice mode, please allow your browser to access the microphone.", listening: "I'm listening", trigger: "Press or say", triggerwithoutname: "Tap to talk" }, uE = { rejected: "You have denied access to your GPS location.", instructions: "To access weather data or the interactive map, please allow your browser to access your GPS location." }, cE = { calltoaction: "Press the screen to start", emptyveille: "Click or press the screen..." }, lE = { attribution: "Weather data provided by Open-Meteo.com", shorttitle: "weather" }, dE = { shorttitle: "tutorial" }, fE = {
  1: "home",
  2: "live info channel",
  3: "weather",
  4: "emergency numbers",
  1e3: "history",
  1001: "tutorial",
  common: V3,
  emergency: G3,
  error: W3,
  history: H3,
  home: K3,
  inputs: Q3,
  language: Y3,
  link: J3,
  loader: Z3,
  menu: X3,
  mobileLandscapePreventer: eE,
  news: tE,
  poi: rE,
  suggestion: nE,
  template: iE,
  GDPR: oE,
  anghello: aE,
  microphone: sE,
  position: uE,
  veille: cE,
  weather: lE,
  tutorial: dE
}, hE = { abort: "abort", all: "all", back: "back", close: "close", continue: "continue", download: "download", downloadsheet: "download this sheet", downloadsheetmobile: "download this sheet on smartphone", filter: "filter", history: "history", knowmore: "Learn more", lang: "languages", menu: "menu", mode: "mode", needhelp: "Need help ?", parameters: "parameters", print: "print", printsheet: "print this sheet", result: "result", results: "results", singleLang: "language", sound: "sound", submit: "submit", subtitle: "subtitle", tutorial: "tutorial", validate: "validate" }, pE = { shorttitle: "emergency numbers", samu: "maeu", police: "police", firefighter: "firefighters", general: "general", citypolice: "Local police", hospital: "Hospital", homeless: "Homeless (free call)", poison: "Poison Control Center", emergency: "European emergencies" }, mE = { title: "An error occurred", button: "Launch the application again" }, gE = { title: "chat history", shorttitle: "history" }, bE = { shorttitle: "home" }, vE = { choose: "Choose an answer", noaction: "Awaiting action" }, yE = { change: "change the language", select: "select the language you want to use" }, wE = { buttontext: "View the document", goto: "Go to address", click: "Click here", scanQR: "by scanning the QrCode", scanQRTile: "Scan the QR Code to discover" }, _E = { loader: { optimal: "For an optimal experience,", classic: "For a more classical experience,", vocal: "I communicate by speaking with the agent.", text: "I communicate by text with the agent." }, modes: { vocal: "vocal mode", text: "text mode" }, loaderValidation: "Start conversation", locale: "checking language", supported: "checking supported languages", addressdata: "retrieving data", store: "store", directline: "directline", ponyfill: "ponyfill" }, kE = { message: "Enter your message", backconversation: "back to the conversation", answer: " answers your questions" }, xE = { firstline: "For an optimal experience,", secondline: "flip your screen" }, SE = { warningtext: "You are about to access the information channel, the sound of your device will be activated", live: "live", continuous: "continuous", shorttitle: "live info channel" }, EE = { comment: "customer review", route: "route", nodata: "No content corresponds to your search", openinghours: "Opening hours", prices: "Prices", paymentmethods: "Payment methods", numberofplaces: "number of places", openroutemobile: "open Google Maps route on smartphone", FoodEstablishment: "Where to eat", LodgingBusiness: "Where to sleep", TouristDestination: "What to see", TouristAttraction: "What to do", Product: "Local products", Service: "Services", Event: "Events", City: "Cities", Wine: "Wines" }, AE = { consult: "Check out", thetutorial: "the tutorial" }, TE = { reset: "reset filters", showresults: "Show results", suggestiontitle: "Research suggestions", reminder: `Don't forget,
 I can answer your questions.` }, CE = { title: "processing personal data transmitted to the bot", message: `by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.

Your conversations are kept 6 month before deletion.`, link: "open confidency policy", buttonAccept: "I understand and I accept", buttonRefuse: "I refuse", messageAccepted: "your acceptation has been saved", messageRefused: "your refusal has been saved" }, RE = { listening: "It's up to you, I'm listening...", correct: "Correct", dontknow: "I don't know" }, OE = { allow: "Please allow your browser to access the microphone to continue.", rejected: "You have denied access to the microphone.", instructions: "To use voice mode, please allow your browser to access the microphone.", listening: "I'm listening", trigger: "Press or say", triggerwithoutname: "Tap to talk" }, DE = { rejected: "You have denied access to your GPS location.", instructions: "To access weather data or the interactive map, please allow your browser to access your GPS location." }, PE = { calltoaction: "Press the screen to start", emptyveille: "Click or press the screen..." }, IE = { attribution: "Weather data provided by Open-Meteo.com", shorttitle: "weather" }, ME = { shorttitle: "tutorial" }, jE = {
  1: "home",
  2: "live info channel",
  3: "weather",
  4: "emergency numbers",
  1e3: "history",
  1001: "tutorial",
  common: hE,
  emergency: pE,
  error: mE,
  history: gE,
  home: bE,
  inputs: vE,
  language: yE,
  link: wE,
  loader: _E,
  menu: kE,
  mobileLandscapePreventer: xE,
  news: SE,
  poi: EE,
  suggestion: AE,
  template: TE,
  GDPR: CE,
  anghello: RE,
  microphone: OE,
  position: DE,
  veille: PE,
  weather: IE,
  tutorial: ME
}, FE = { abort: "abort", all: "all", back: "back", close: "close", continue: "continue", download: "download", downloadsheet: "download this sheet", downloadsheetmobile: "download this sheet on smartphone", filter: "filter", history: "history", knowmore: "Learn more", lang: "languages", menu: "menu", mode: "mode", needhelp: "Need help ?", parameters: "parameters", print: "print", printsheet: "print this sheet", result: "result", results: "results", singleLang: "language", sound: "sound", submit: "submit", subtitle: "subtitle", tutorial: "tutorial", validate: "validate" }, $E = { shorttitle: "emergency numbers", samu: "maeu", police: "police", firefighter: "firefighters", general: "general", citypolice: "Local police", hospital: "Hospital", homeless: "Homeless (free call)", poison: "Poison Control Center", emergency: "European emergencies" }, LE = { title: "An error occurred", button: "Launch the application again" }, NE = { title: "chat history", shorttitle: "history" }, BE = { shorttitle: "home" }, qE = { choose: "Choose an answer", noaction: "Awaiting action" }, zE = { change: "change the language", select: "select the language you want to use" }, UE = { buttontext: "View the document", goto: "Go to address", click: "Click here", scanQR: "by scanning the QrCode", scanQRTile: "Scan the QR Code to discover" }, VE = { loader: { optimal: "For an optimal experience,", classic: "For a more classical experience,", vocal: "I communicate by speaking with the agent.", text: "I communicate by text with the agent." }, modes: { vocal: "vocal mode", text: "text mode" }, loaderValidation: "Start conversation", locale: "checking language", supported: "checking supported languages", addressdata: "retrieving data", store: "store", directline: "directline", ponyfill: "ponyfill" }, GE = { message: "Enter your message", backconversation: "back to the conversation", answer: " answers your questions" }, WE = { firstline: "For an optimal experience,", secondline: "flip your screen" }, HE = { warningtext: "You are about to access the information channel, the sound of your device will be activated", live: "live", continuous: "continuous", shorttitle: "live info channel" }, KE = { comment: "customer review", route: "route", nodata: "No content corresponds to your search", openinghours: "Opening hours", prices: "Prices", paymentmethods: "Payment methods", numberofplaces: "number of places", openroutemobile: "open Google Maps route on smartphone", FoodEstablishment: "Where to eat", LodgingBusiness: "Where to sleep", TouristDestination: "What to see", TouristAttraction: "What to do", Product: "Local products", Service: "Services", Event: "Events", City: "Cities", Wine: "Wines" }, QE = { consult: "Check out", thetutorial: "the tutorial" }, YE = { reset: "reset filters", showresults: "Show results", suggestiontitle: "Research suggestions", reminder: `Don't forget,
 I can answer your questions.` }, JE = { title: "processing personal data transmitted to the bot", message: `by accepting, you consent that all data transmitted to the chatbot can be used for analysis about the use of the tool, and for the improvement of the knowledge base.

Your conversations are kept 6 month before deletion.`, link: "open confidency policy", buttonAccept: "I understand and I accept", buttonRefuse: "I refuse", messageAccepted: "your acceptation has been saved", messageRefused: "your refusal has been saved" }, ZE = { listening: "It's up to you, I'm listening...", correct: "Correct", dontknow: "I don't know" }, XE = { allow: "Please allow your browser to access the microphone to continue.", rejected: "You have denied access to the microphone.", instructions: "To use voice mode, please allow your browser to access the microphone.", listening: "I'm listening", trigger: "Press or say", triggerwithoutname: "Tap to talk" }, e6 = { rejected: "You have denied access to your GPS location.", instructions: "To access weather data or the interactive map, please allow your browser to access your GPS location." }, t6 = { calltoaction: "Press the screen to start", emptyveille: "Click or press the screen..." }, r6 = { attribution: "Weather data provided by Open-Meteo.com", shorttitle: "weather" }, n6 = { shorttitle: "tutorial" }, i6 = {
  1: "home",
  2: "live info channel",
  3: "weather",
  4: "emergency numbers",
  1e3: "history",
  1001: "tutorial",
  common: FE,
  emergency: $E,
  error: LE,
  history: NE,
  home: BE,
  inputs: qE,
  language: zE,
  link: UE,
  loader: VE,
  menu: GE,
  mobileLandscapePreventer: WE,
  news: HE,
  poi: KE,
  suggestion: QE,
  template: YE,
  GDPR: JE,
  anghello: ZE,
  microphone: XE,
  position: e6,
  veille: t6,
  weather: r6,
  tutorial: n6
}, o6 = { abort: "cancelar", all: "todos", back: "volver", close: "cerrar", continue: "continuar", download: "descargar", downloadsheet: "descargar esta hoja", downloadsheetmobile: "descargar esta hoja en el teléfono inteligente", filter: "filtrar", history: "historia", knowmore: "Saber más", lang: "idiomas", menu: "menú", mode: "modo", needhelp: "necesitar ayuda ?", parameters: "parámetros", print: "imprime", printsheet: "imprime esta hoja", result: "resultado", results: "resultados", singleLang: "idioma", sound: "sonido", submit: "enviar", subtitle: "subtítulos", tutorial: "tutorial", validate: "valide" }, a6 = { shorttitle: "números de emergencia", samu: "samu", police: "policía", firefighter: "bomberos", general: "general", citypolice: "Policía Local", hospital: "Hospital", homeless: "Personas sin hogar (llamada gratuita)", poison: "Centro de control de venenos", emergency: "Emergencias europeas" }, s6 = { title: "Se ha producido un error", button: "Vuelva a iniciar la aplicación" }, u6 = { shorttitle: "historia", title: "historial de chat" }, c6 = { shorttitle: "inicio" }, l6 = { choose: "Elija una respuesta", noaction: "Se espera una acción" }, d6 = { change: "cambiar el idioma", select: "seleccione la lengua que desea utilizar" }, f6 = { buttontext: "Ver el documento", goto: "Ir a la dirección", click: "Haga clic aquí", scanQR: "escaneando el QrCode", scanQRTile: "Escanea el código QR para descubrir" }, h6 = { loader: { optimal: "Para una experiencia óptima,", classic: "Para una experiencia más clásica,", vocal: "Me comunico hablando con el agente.", text: "Me comunico por SMS con el agente." }, modes: { vocal: "modo vocal", text: "modo texto" }, loaderValidation: "Iniciar conversación", locale: "comprobar configuración regional", supported: "comprobación de las configuraciones regionales admitidas", store: "crear tienda", directline: "conexión directline", ponyfill: "creación del ponyfill", addressdata: "recuperar datos" }, p6 = { message: "Escriba su mensaje", backconversation: "volver a la conversación", answer: " responde a tus preguntas" }, m6 = { firstline: "Para una experiencia óptima", secondline: "voltea la pantalla" }, g6 = { shorttitle: "canal de información en directo", warningtext: "Está a punto de acceder al canal de información, el sonido de su dispositivo se activará", live: "en directo", continuous: "continuo" }, b6 = { comment: "revisión del cliente", route: "ruta", nodata: "Ningún contenido corresponde a su búsqueda", openinghours: "Horario de apertura", prices: "Precios", paymentmethods: "Métodos de pago", numberofplaces: "numero de lugares", openroutemobile: "abrir la ruta de Google Maps en el teléfono inteligente", FoodEstablishment: "Dónde comer", LodgingBusiness: "Dónde dormir", TouristDestination: "Qué ver", TouristAttraction: "Qué hacer", Product: "Productos locales", Service: "Servicios", Event: "Eventos", City: "Ciudades", Wine: "Vinos" }, v6 = { consult: "Mira", thetutorial: "el tutorial" }, y6 = { reset: "restablecer filtros", showresults: "Mostrar resultados", suggestiontitle: "Sugerencias de investigación", reminder: `No olvide :
 puedo responder a sus preguntas.` }, w6 = { listening: "Te toca a ti, te escucho...", correct: "Corregir", dontknow: "No lo sé" }, _6 = { allow: "Por favor, autorice a su navegador para acceder al micrófono para continuar.", rejected: "Ha denegado el acceso al micrófono.", instructions: "Para usar el modo de voz, por favor, autorice a su navegador para acceder al micrófono.", listening: "Estoy escuchando", trigger: "Pulsa o di", triggerwithoutname: "Toca para hablar" }, k6 = { rejected: "Has rechazado el acceso a tu ubicación GPS.", instructions: "Para acceder a los datos meteorológicos o al mapa interactivo, por favor permita que su navegador acceda a su ubicación GPS." }, x6 = { calltoaction: "Pulse la pantalla para empezar", emptyveille: "Haga clic o pulse la pantalla..." }, S6 = { shorttitle: "tiempo", attribution: "Datos meteorológicos proporcionados por Open-Meteo.com" }, E6 = { title: "tratamiento de datos personales transmitidos al bot", message: `al aceptar este diálogo, usted consiente que todos los datos transmitidos al chatbot sean utilizados para analizar el uso de la herramienta y enriquecer la base de conocimiento.

Sus conversaciones se conservan 6 meses antes de ser eliminadas.`, link: "enlace para consultar las políticas de privacidad", buttonAccept: "entendido y acepto", buttonRefuse: "rechazo", messageAccepted: "su consentimiento ha sido tenido en cuenta", messageRefused: "su rechazo ha sido tenido en cuenta" }, A6 = {
  1: "inicio",
  2: "canal de información en directo",
  3: "tiempo",
  4: "números de emergencia",
  1e3: "historia",
  1001: "tutorial",
  common: o6,
  emergency: a6,
  error: s6,
  history: u6,
  home: c6,
  inputs: l6,
  language: d6,
  link: f6,
  loader: h6,
  menu: p6,
  mobileLandscapePreventer: m6,
  news: g6,
  poi: b6,
  suggestion: v6,
  template: y6,
  anghello: w6,
  microphone: _6,
  position: k6,
  veille: x6,
  weather: S6,
  GDPR: E6
}, T6 = { abort: "cancelar", all: "todos", back: "volver", close: "cerrar", continue: "continuar", download: "descargar", downloadsheet: "descargar esta hoja", downloadsheetmobile: "descargar esta hoja en el teléfono inteligente", filter: "filtrar", history: "historia", knowmore: "Saber más", lang: "idiomas", menu: "menú", mode: "modo", needhelp: "necesitar ayuda ?", parameters: "parámetros", print: "imprime", printsheet: "imprime esta hoja", result: "resultado", results: "resultados", singleLang: "idioma", sound: "sonido", submit: "enviar", subtitle: "subtítulos", tutorial: "tutorial", validate: "valide" }, C6 = { shorttitle: "números de emergencia", samu: "samu", police: "policía", firefighter: "bomberos", general: "general", citypolice: "Policía Local", hospital: "Hospital", homeless: "Personas sin hogar (llamada gratuita)", poison: "Centro de control de venenos", emergency: "Emergencias europeas" }, R6 = { title: "Se ha producido un error", button: "Vuelva a iniciar la aplicación" }, O6 = { shorttitle: "historia", title: "historial de chat" }, D6 = { shorttitle: "inicio" }, P6 = { choose: "Elija una respuesta", noaction: "Se espera una acción" }, I6 = { change: "cambiar el idioma", select: "seleccione la lengua que desea utilizar" }, M6 = { buttontext: "Ver el documento", goto: "Ir a la dirección", click: "Haga clic aquí", scanQR: "escaneando el QrCode", scanQRTile: "Escanea el código QR para descubrir" }, j6 = { loader: { optimal: "Para una experiencia óptima,", classic: "Para una experiencia más clásica,", vocal: "Me comunico hablando con el agente.", text: "Me comunico por SMS con el agente." }, modes: { vocal: "modo vocal", text: "modo texto" }, loaderValidation: "Iniciar conversación", locale: "comprobar configuración regional", supported: "comprobación de las configuraciones regionales admitidas", store: "crear tienda", directline: "conexión directline", ponyfill: "creación del ponyfill", addressdata: "recuperar datos" }, F6 = { message: "Escriba su mensaje", backconversation: "volver a la conversación", answer: " responde a tus preguntas" }, $6 = { firstline: "Para una experiencia óptima", secondline: "voltea la pantalla" }, L6 = { shorttitle: "canal de información en directo", warningtext: "Está a punto de acceder al canal de información, el sonido de su dispositivo se activará", live: "en directo", continuous: "continuo" }, N6 = { comment: "revisión del cliente", route: "ruta", nodata: "Ningún contenido corresponde a su búsqueda", openinghours: "Horario de apertura", prices: "Precios", paymentmethods: "Métodos de pago", numberofplaces: "numero de lugares", openroutemobile: "abrir la ruta de Google Maps en el teléfono inteligente", FoodEstablishment: "Dónde comer", LodgingBusiness: "Dónde dormir", TouristDestination: "Qué ver", TouristAttraction: "Qué hacer", Product: "Productos locales", Service: "Servicios", Event: "Eventos", City: "Ciudades", Wine: "Vinos" }, B6 = { consult: "Mira", thetutorial: "el tutorial" }, q6 = { reset: "restablecer filtros", showresults: "Mostrar resultados", suggestiontitle: "Sugerencias de investigación", reminder: `No olvide :
 puedo responder a sus preguntas.` }, z6 = { listening: "Te toca a ti, te escucho...", correct: "Corregir", dontknow: "No lo sé" }, U6 = { allow: "Por favor, autorice a su navegador para acceder al micrófono para continuar.", rejected: "Ha denegado el acceso al micrófono.", instructions: "Para usar el modo de voz, por favor, autorice a su navegador para acceder al micrófono.", listening: "Estoy escuchando", trigger: "Pulsa o di", triggerwithoutname: "Toca para hablar" }, V6 = { rejected: "Has rechazado el acceso a tu ubicación GPS.", instructions: "Para acceder a los datos meteorológicos o al mapa interactivo, por favor permita que su navegador acceda a su ubicación GPS." }, G6 = { calltoaction: "Pulse la pantalla para empezar", emptyveille: "Haga clic o pulse la pantalla..." }, W6 = { shorttitle: "tiempo", attribution: "Datos meteorológicos proporcionados por Open-Meteo.com" }, H6 = { title: "tratamiento de datos personales transmitidos al bot", message: `al aceptar este diálogo, usted consiente que todos los datos transmitidos al chatbot sean utilizados para analizar el uso de la herramienta y enriquecer la base de conocimiento.

Sus conversaciones se conservan 6 meses antes de ser eliminadas.`, link: "enlace para consultar las políticas de privacidad", buttonAccept: "entendido y acepto", buttonRefuse: "rechazo", messageAccepted: "su consentimiento ha sido tenido en cuenta", messageRefused: "su rechazo ha sido tenido en cuenta" }, K6 = {
  1: "inicio",
  2: "canal de información en directo",
  3: "tiempo",
  4: "números de emergencia",
  1e3: "historia",
  1001: "tutorial",
  common: T6,
  emergency: C6,
  error: R6,
  history: O6,
  home: D6,
  inputs: P6,
  language: I6,
  link: M6,
  loader: j6,
  menu: F6,
  mobileLandscapePreventer: $6,
  news: L6,
  poi: N6,
  suggestion: B6,
  template: q6,
  anghello: z6,
  microphone: U6,
  position: V6,
  veille: G6,
  weather: W6,
  GDPR: H6
}, Q6 = { abort: "peruuta", all: "kaikki", back: "takaisin", close: "kiinni", continue: "Jatkaa", download: "ladata", downloadsheet: "lataa tämä taulukko", downloadsheetmobile: "lataa tämä taulukko älypuhelimeen", filter: "Suodattaa", history: "historiallinen", knowmore: "Lue lisää", lang: "KIELET", menu: "valikosta", mode: "muoti", needhelp: "Tarvitsetko apua?", parameters: "asetukset", print: "Tulosta", printsheet: "Tulosta tämä arkki", result: "tulos", results: "tuloksia", singleLang: "Kieli", sound: "hänen", submit: "Lähetä", subtitle: "alaotsikko", tutorial: "opetusohjelma", validate: "vahvistaa" }, Y6 = { shorttitle: "Hätänumerot", samu: "S.A.M.U.", police: "Poliisi", firefighter: "palomiehiä", general: "yleistä", citypolice: "Paikallinen poliisi", hospital: "Sairaala", homeless: "Asunnoton (ilmainen puhelu)", poison: "Poison Control Center", emergency: "Euroopan hätätilanteita" }, J6 = { title: "Tapahtui virhe", button: "Käynnistä sovellus uudelleen" }, Z6 = { shorttitle: "historiallinen", title: "keskusteluhistoria" }, X6 = { shorttitle: "kotisivu" }, eA = { choose: "Valitse vastaus", noaction: "Odottaa toimintoa" }, tA = { change: "vaihtaa kieltä", select: "valitse kieli, jota haluat käyttää" }, rA = { buttontext: "Näytä asiakirja", goto: "Mene osoitteeseen", click: "Klikkaa tästä", scanQR: "skannaamalla QR-koodin", scanQRTile: "Skannaa QR-koodi saadaksesi selville" }, nA = { loader: { optimal: "Optimaalisen kokemuksen saamiseksi", classic: "Klassisemman kokemuksen saamiseksi", vocal: "Puhun kasvotusten agentin kanssa.", text: "Olen yhteydessä välittäjään kirjallisesti." }, modes: { vocal: "laulutila", text: "tekstitila" }, loaderValidation: "Aloita keskustelu", locale: "kielen tarkistaminen", supported: "tuettujen kielten tarkistaminen", addressdata: "tietojen hakeminen" }, iA = { message: "Kirjoita viestisi", backconversation: "takaisin keskusteluun", answer: " vastaa kysymyksiisi" }, oA = { firstline: "Optimaalisen kokemuksen saamiseksi", secondline: "käännä näyttöäsi" }, aA = { shorttitle: "live-uutiskanava", warningtext: "Pääset uutiskanavalle, laitteesi ääni aktivoituu", live: "elää", continuous: "jatkuvasti" }, sA = { comment: "Asiakaspalaute", route: "tie", nodata: "Mikään sisältö ei vastaa hakuasi", openinghours: "Aukioloajat", prices: "hinnat", paymentmethods: "Maksutavat", numberofplaces: "paikkojen määrä", openroutemobile: "avaa Google Maps -reitti älypuhelimella", FoodEstablishment: "Missä syödä", LodgingBusiness: "Missä nukkua", TouristDestination: "Mitä nähdä", TouristAttraction: "Mitä tehdä", Product: "Paikalliset tuotteet", Service: "Palvelut", Event: "Tapahtumat", City: "kaupungit", Wine: "Viinit" }, uA = { consult: "Tarkista", thetutorial: "opetusohjelma" }, cA = { reset: "nollaa kaikki", showresults: "Näytä tulokset", suggestiontitle: "Hakuehdotukset", reminder: `Älä unohda, 
 voin vastata kysymyksiisi.` }, lA = { listening: "Se on sinusta kiinni, kuuntelen...", correct: "Korjata", dontknow: "En tiedä" }, dA = { allow: "Salli selaimesi käyttää mikrofonia jatkaaksesi.", rejected: "Olet kieltänyt pääsyn mikrofonille.", instructions: "Äänitilassa käyttämistä varten salli selaimesi käyttää mikrofonia.", listening: "Minä kuuntelen", trigger: "Napsauta tai sano", triggerwithoutname: "Napauta puhuaksesi" }, fA = { rejected: "Olet hylännyt pääsyn sijaintiisi.", instructions: "Jotta voit käyttää säädataa tai interaktiivista karttaa, anna selaimelle lupa päästä sijaintiisi." }, hA = { calltoaction: "Paina näyttöä aloittaaksesi", emptyveille: "Napsauta tai paina näyttöä..." }, pA = { shorttitle: "Säätiedotus", attribution: "Säätiedot toimittanut Open-Meteo.com" }, mA = { title: "botille lähetettyjen henkilötietojen käsittely", message: `hyväksymällä tämän dialogin suostut siihen, että kaikki chatbotille lähetetyt tiedot voidaan käyttää työkalun käytön analysointiin ja tietopohjan rikastamiseen.

Keskustelusi säilytetään 6 kuukautta ennen poistamista.`, link: "linkki tietosuojakäytäntöjen tarkasteluun", buttonAccept: "ymmärrän ja hyväksyn", buttonRefuse: "kieltäydyn", messageAccepted: "suostumuksesi on otettu huomioon", messageRefused: "kieltäytymisesi on otettu huomioon" }, gA = {
  1: "kotisivu",
  2: "live-uutiskanava",
  3: "Säätiedotus",
  4: "Hätänumerot",
  1e3: "historiallinen",
  1001: "opetusohjelma",
  common: Q6,
  emergency: Y6,
  error: J6,
  history: Z6,
  home: X6,
  inputs: eA,
  language: tA,
  link: rA,
  loader: nA,
  menu: iA,
  mobileLandscapePreventer: oA,
  news: aA,
  poi: sA,
  suggestion: uA,
  template: cA,
  anghello: lA,
  microphone: dA,
  position: fA,
  veille: hA,
  weather: pA,
  GDPR: mA
}, bA = { abort: "annuler", all: "tous", back: "retour", close: "fermer", continue: "continuer", download: "télécharger", downloadsheet: "télécharger cette fiche", downloadsheetmobile: "télécharger cette fiche sur mobile", filter: "filtrer", history: "historique", knowmore: "En savoir +", lang: "langues", menu: "menu", mode: "mode", needhelp: "Besoin d'aide ?", parameters: "paramètres", print: "imprimer", printsheet: "imprimer cette fiche", result: "résultat", results: "résultats", singleLang: "langue", sound: "son", submit: "valider", subtitle: "sous-titre", tutorial: "tutoriel", validate: "valider" }, vA = { shorttitle: "numéros d'urgence", samu: "samu", police: "police", firefighter: "pompiers", general: "général", citypolice: "Police municipale", hospital: "Hôpital", homeless: "Sans abris (appel gratuit)", poison: "Centre anti-poison", emergency: "Urgences européennes" }, yA = { title: "une erreur est survenue", button: "Relancer l'application" }, wA = { shorttitle: "historique", title: "historique de conversation" }, _A = { shorttitle: "accueil" }, kA = { choose: "Choisissez une réponse", noaction: "Une action est attendue" }, xA = { change: "changer la langue", select: "sélectionnez la langue de votre choix" }, SA = { buttontext: "Voir le document", goto: "Accéder à l'adresse", click: "Cliquez-ici", scanQR: "en scannant le QrCode", scanQRTile: "Scanner le QR Code pour découvrir" }, EA = { loader: { optimal: "Pour une expérience optimale,", classic: "Pour une expérience plus classique,", vocal: "j'échange de vive voix avec l'agent.", text: "j'échange à l'écrit avec l'agent." }, modes: { vocal: "mode vocal", text: "mode texte" }, loaderValidation: "Démarrer la conversation", locale: "vérification de la langue", supported: "vérification des langues disponibles", store: "création du store", directline: "connection au directline", ponyfill: "création du ponyfill", addressdata: "récupération des données" }, AA = { message: "Saisissez votre message", backconversation: "retour à la conversation", answer: " répond à vos questions" }, TA = { firstline: "Pour une expérience optimale,", secondline: "basculez votre écran" }, CA = { warningtext: "Vous allez accéder à la chaîne info, le son de votre appareil va être activé", live: "direct", continuous: "en continu", shorttitle: "chaîne info live" }, RA = { comment: "avis clients", route: "y Aller", nodata: "Aucun contenu ne correspond à votre recherche", openinghours: "Horaires", prices: "Tarifs", paymentmethods: "Modes de paiement", numberofplaces: "nombre de couverts", openroutemobile: "ouvrir l'itinéraire Google Maps sur mobile", FoodEstablishment: "Où manger", LodgingBusiness: "Où dormir", TouristDestination: "A voir", TouristAttraction: "A faire", Product: "Produits locaux", Service: "Services", Event: "Evènements", City: "Villes", Wine: "Vins" }, OA = { consult: "Consultez", thetutorial: "le tutoriel" }, DA = { reset: "effacer tout", showresults: "Afficher les résultats", suggestiontitle: "Suggestions de recherches", reminder: `N'oubliez pas,
 je peux répondre à vos questions.` }, PA = { title: "traitement des données personnelles transmises au bot", message: `en acceptant ce dialogue, vous consentez à ce que toutes les données transmises au chatbot soient exploitées à des fins d'analyse de l'utilisation de l'outil et d'enrichissement de la base de connaissance.

Vos conversations sont conservées 6 mois avant de faire l'objet d'une suppression.`, link: "lien pour consulter les politiques de confidentialité", buttonAccept: "j'ai compris et j'accepte", buttonRefuse: "je refuse", messageAccepted: "votre consentement est bien pris en compte", messageRefused: "votre refus est bien pris en compte" }, IA = { listening: "C'est à vous, je vous écoute...", correct: "Corriger", dontknow: "Je ne sais pas" }, MA = { allow: "Veuillez autoriser votre navigateur à accéder au micro pour continuer.", rejected: "Vous avez refusé l'accès au micro.", instructions: "Pour utiliser le mode vocal, veuillez autoriser votre navigateur à accéder au micro.", listening: "Je vous écoute", trigger: "Appuyez ou dites", triggerwithoutname: "Appuyez pour parler" }, jA = { rejected: "Vous avez refusé l'accès à votre position GPS.", instructions: "Pour accéder aux données météorologiques ou à la carte interactive, veuillez autoriser votre navigateur à accéder à votre position GPS." }, FA = { calltoaction: "Appuyez sur l'écran pour commencer", emptyveille: "Cliquez ou appuyez sur l'écran..." }, $A = { attribution: "Données météorologiques fournies par Open-Meteo.com", shorttitle: "météo" }, LA = { shorttitle: "tutoriel" }, NA = {
  1: "accueil",
  2: "chaîne info live",
  3: "météo",
  4: "numéros d'urgence",
  1e3: "historique",
  1001: "tutoriel",
  common: bA,
  emergency: vA,
  error: yA,
  history: wA,
  home: _A,
  inputs: kA,
  language: xA,
  link: SA,
  loader: EA,
  menu: AA,
  mobileLandscapePreventer: TA,
  news: CA,
  poi: RA,
  suggestion: OA,
  template: DA,
  GDPR: PA,
  anghello: IA,
  microphone: MA,
  position: jA,
  veille: FA,
  weather: $A,
  tutorial: LA
}, BA = { abort: "annuler", all: "tous", back: "retour", close: "fermer", continue: "continuer", download: "télécharger", downloadsheet: "télécharger cette fiche", downloadsheetmobile: "télécharger cette fiche sur mobile", filter: "filtrer", history: "historique", knowmore: "En savoir +", lang: "langues", menu: "menu", mode: "mode", needhelp: "Besoin d'aide ?", parameters: "paramètres", print: "imprimer", printsheet: "imprimer cette fiche", result: "résultat", results: "résultats", singleLang: "langue", sound: "son", submit: "valider", subtitle: "sous-titre", tutorial: "tutoriel", validate: "valider" }, qA = { shorttitle: "numéros d'urgence", samu: "samu", police: "police", firefighter: "pompiers", general: "général", citypolice: "Police municipale", hospital: "Hôpital", homeless: "Sans abris (appel gratuit)", poison: "Centre anti-poison", emergency: "Urgences européennes" }, zA = { title: "une erreur est survenue", button: "Relancer l'application" }, UA = { shorttitle: "historique", title: "historique de conversation" }, VA = { shorttitle: "accueil" }, GA = { choose: "Choisissez une réponse", noaction: "Une action est attendue" }, WA = { change: "changer la langue", select: "sélectionnez la langue de votre choix" }, HA = { buttontext: "Voir le document", goto: "Accéder à l'adresse", click: "Cliquez-ici", scanQR: "en scannant le QrCode", scanQRTile: "Scanner le QR Code pour découvrir" }, KA = { loader: { optimal: "Pour une expérience optimale,", classic: "Pour une expérience plus classique,", vocal: "j'échange de vive voix avec l'agent.", text: "j'échange à l'écrit avec l'agent." }, modes: { vocal: "mode vocal", text: "mode texte" }, loaderValidation: "Démarrer la conversation", locale: "vérification de la langue", supported: "vérification des langues disponibles", store: "création du store", directline: "connection au directline", ponyfill: "création du ponyfill", addressdata: "récupération des données" }, QA = { message: "Saisissez votre message", backconversation: "retour à la conversation", answer: " répond à vos questions" }, YA = { firstline: "Pour une expérience optimale,", secondline: "basculez votre écran" }, JA = { warningtext: "Vous allez accéder à la chaîne info, le son de votre appareil va être activé", live: "direct", continuous: "en continu", shorttitle: "chaîne info live" }, ZA = { comment: "avis clients", route: "y Aller", nodata: "Aucun contenu ne correspond à votre recherche", openinghours: "Horaires", prices: "Tarifs", paymentmethods: "Modes de paiement", numberofplaces: "nombre de couverts", openroutemobile: "ouvrir l'itinéraire Google Maps sur mobile", FoodEstablishment: "Où manger", LodgingBusiness: "Où dormir", TouristDestination: "A voir", TouristAttraction: "A faire", Product: "Produits locaux", Service: "Services", Event: "Evènements", City: "Villes", Wine: "Vins" }, XA = { consult: "Consultez", thetutorial: "le tutoriel" }, eT = { reset: "effacer tout", showresults: "Afficher les résultats", suggestiontitle: "Suggestions de recherches", reminder: `N'oubliez pas,
 je peux répondre à vos questions.` }, tT = { title: "traitement des données personnelles transmises au bot", message: `en acceptant ce dialogue, vous consentez à ce que toutes les données transmises au chatbot soient exploitées à des fins d'analyse de l'utilisation de l'outil et d'enrichissement de la base de connaissance.

Vos conversations sont conservées 6 mois avant de faire l'objet d'une suppression.`, link: "lien pour consulter les politiques de confidentialité", buttonAccept: "j'ai compris et j'accepte", buttonRefuse: "je refuse", messageAccepted: "votre consentement est bien pris en compte", messageRefused: "votre refus est bien pris en compte" }, rT = { listening: "C'est à vous, je vous écoute...", correct: "Corriger", dontknow: "Je ne sais pas" }, nT = { allow: "Veuillez autoriser votre navigateur à accéder au micro pour continuer.", rejected: "Vous avez refusé l'accès au micro.", instructions: "Pour utiliser le mode vocal, veuillez autoriser votre navigateur à accéder au micro.", listening: "Je vous écoute", trigger: "Appuyez ou dites", triggerwithoutname: "Appuyez pour parler" }, iT = { rejected: "Vous avez refusé l'accès à votre position GPS.", instructions: "Pour accéder aux données météorologiques ou à la carte interactive, veuillez autoriser votre navigateur à accéder à votre position GPS." }, oT = { calltoaction: "Appuyez sur l'écran pour commencer", emptyveille: "Cliquez ou appuyez sur l'écran..." }, aT = { attribution: "Données météorologiques fournies par Open-Meteo.com", shorttitle: "météo" }, sT = { shorttitle: "tutoriel" }, uT = {
  1: "accueil",
  2: "chaîne info live",
  3: "météo",
  4: "numéros d'urgence",
  1e3: "historique",
  1001: "tutoriel",
  common: BA,
  emergency: qA,
  error: zA,
  history: UA,
  home: VA,
  inputs: GA,
  language: WA,
  link: HA,
  loader: KA,
  menu: QA,
  mobileLandscapePreventer: YA,
  news: JA,
  poi: ZA,
  suggestion: XA,
  template: eT,
  GDPR: tT,
  anghello: rT,
  microphone: nT,
  position: iT,
  veille: oT,
  weather: aT,
  tutorial: sT
}, cT = { abort: "annuler", all: "tous", back: "retour", close: "fermer", continue: "continuer", download: "télécharger", downloadsheet: "télécharger cette fiche", downloadsheetmobile: "télécharger cette fiche sur mobile", filter: "filtrer", history: "historique", knowmore: "En savoir +", lang: "langues", menu: "menu", mode: "mode", needhelp: "Besoin d'aide ?", parameters: "paramètres", print: "imprimer", printsheet: "imprimer cette fiche", result: "résultat", results: "résultats", singleLang: "langue", sound: "son", submit: "valider", subtitle: "sous-titre", tutorial: "tutoriel", validate: "valider" }, lT = { shorttitle: "numéros d'urgence", samu: "samu", police: "police", firefighter: "pompiers", general: "général", citypolice: "Police municipale", hospital: "Hôpital", homeless: "Sans abris (appel gratuit)", poison: "Centre anti-poison", emergency: "Urgences européennes" }, dT = { title: "une erreur est survenue", button: "Relancer l'application" }, fT = { shorttitle: "historique", title: "historique de conversation" }, hT = { shorttitle: "accueil" }, pT = { choose: "Choisissez une réponse", noaction: "Une action est attendue" }, mT = { change: "changer la langue", select: "sélectionnez la langue de votre choix" }, gT = { buttontext: "Voir le document", goto: "Accéder à l'adresse", click: "Cliquez-ici", scanQR: "en scannant le QrCode", scanQRTile: "Scanner le QR Code pour découvrir" }, bT = { loader: { optimal: "Pour une expérience optimale,", classic: "Pour une expérience plus classique,", vocal: "j'échange de vive voix avec l'agent.", text: "j'échange à l'écrit avec l'agent." }, modes: { vocal: "mode vocal", text: "mode texte" }, loaderValidation: "Démarrer la conversation", locale: "vérification de la langue", supported: "vérification des langues disponibles", store: "création du store", directline: "connection au directline", ponyfill: "création du ponyfill", addressdata: "récupération des données" }, vT = { message: "Saisissez votre message", backconversation: "retour à la conversation", answer: " répond à vos questions" }, yT = { firstline: "Pour une expérience optimale,", secondline: "basculez votre écran" }, wT = { warningtext: "Vous allez accéder à la chaîne info, le son de votre appareil va être activé", live: "direct", continuous: "en continu", shorttitle: "chaîne info live" }, _T = { comment: "avis clients", route: "y Aller", nodata: "Aucun contenu ne correspond à votre recherche", openinghours: "Horaires", prices: "Tarifs", paymentmethods: "Modes de paiement", numberofplaces: "nombre de couverts", openroutemobile: "ouvrir l'itinéraire Google Maps sur mobile", FoodEstablishment: "Où manger", LodgingBusiness: "Où dormir", TouristDestination: "A voir", TouristAttraction: "A faire", Product: "Produits locaux", Service: "Services", Event: "Evènements", City: "Villes", Wine: "Vins" }, kT = { consult: "Consultez", thetutorial: "le tutoriel" }, xT = { reset: "effacer tout", showresults: "Afficher les résultats", suggestiontitle: "Suggestions de recherches", reminder: `N'oubliez pas,
 je peux répondre à vos questions.` }, ST = { title: "traitement des données personnelles transmises au bot", message: `en acceptant ce dialogue, vous consentez à ce que toutes les données transmises au chatbot soient exploitées à des fins d'analyse de l'utilisation de l'outil et d'enrichissement de la base de connaissance.

Vos conversations sont conservées 6 mois avant de faire l'objet d'une suppression.`, link: "lien pour consulter les politiques de confidentialité", buttonAccept: "j'ai compris et j'accepte", buttonRefuse: "je refuse", messageAccepted: "votre consentement est bien pris en compte", messageRefused: "votre refus est bien pris en compte" }, ET = { listening: "C'est à vous, je vous écoute...", correct: "Corriger", dontknow: "Je ne sais pas" }, AT = { allow: "Veuillez autoriser votre navigateur à accéder au micro pour continuer.", rejected: "Vous avez refusé l'accès au micro.", instructions: "Pour utiliser le mode vocal, veuillez autoriser votre navigateur à accéder au micro.", listening: "Je vous écoute", trigger: "Appuyez ou dites", triggerwithoutname: "Appuyez pour parler" }, TT = { rejected: "Vous avez refusé l'accès à votre position GPS.", instructions: "Pour accéder aux données météorologiques ou à la carte interactive, veuillez autoriser votre navigateur à accéder à votre position GPS." }, CT = { calltoaction: "Appuyez sur l'écran pour commencer", emptyveille: "Cliquez ou appuyez sur l'écran..." }, RT = { attribution: "Données météorologiques fournies par Open-Meteo.com", shorttitle: "météo" }, OT = { shorttitle: "tutoriel" }, DT = {
  1: "accueil",
  2: "chaîne info live",
  3: "météo",
  4: "numéros d'urgence",
  1e3: "historique",
  1001: "tutoriel",
  common: cT,
  emergency: lT,
  error: dT,
  history: fT,
  home: hT,
  inputs: pT,
  language: mT,
  link: gT,
  loader: bT,
  menu: vT,
  mobileLandscapePreventer: yT,
  news: wT,
  poi: _T,
  suggestion: kT,
  template: xT,
  GDPR: ST,
  anghello: ET,
  microphone: AT,
  position: TT,
  veille: CT,
  weather: RT,
  tutorial: OT
}, PT = { abort: "annuler", all: "tous", back: "retour", close: "fermer", continue: "continuer", download: "télécharger", downloadsheet: "télécharger cette fiche", downloadsheetmobile: "télécharger cette fiche sur mobile", filter: "filtrer", history: "historique", knowmore: "En savoir +", lang: "langues", menu: "menu", mode: "mode", needhelp: "Besoin d'aide ?", parameters: "paramètres", print: "imprimer", printsheet: "imprimer cette fiche", result: "résultat", results: "résultats", singleLang: "langue", sound: "son", submit: "valider", subtitle: "sous-titre", tutorial: "tutoriel", validate: "valider" }, IT = { shorttitle: "numéros d'urgence", samu: "samu", police: "police", firefighter: "pompiers", general: "général", citypolice: "Police municipale", hospital: "Hôpital", homeless: "Sans abris (appel gratuit)", poison: "Centre anti-poison", emergency: "Urgences européennes" }, MT = { title: "une erreur est survenue", button: "Relancer l'application" }, jT = { shorttitle: "historique", title: "historique de conversation" }, FT = { shorttitle: "accueil" }, $T = { choose: "Choisissez une réponse", noaction: "Une action est attendue" }, LT = { change: "changer la langue", select: "sélectionnez la langue de votre choix" }, NT = { buttontext: "Voir le document", goto: "Accéder à l'adresse", click: "Cliquez-ici", scanQR: "en scannant le QrCode", scanQRTile: "Scanner le QR Code pour découvrir" }, BT = { loader: { optimal: "Pour une expérience optimale,", classic: "Pour une expérience plus classique,", vocal: "j'échange de vive voix avec l'agent.", text: "j'échange à l'écrit avec l'agent." }, modes: { vocal: "mode vocal", text: "mode texte" }, loaderValidation: "Démarrer la conversation", locale: "vérification de la langue", supported: "vérification des langues disponibles", store: "création du store", directline: "connection au directline", ponyfill: "création du ponyfill", addressdata: "récupération des données" }, qT = { message: "Saisissez votre message", backconversation: "retour à la conversation", answer: " répond à vos questions" }, zT = { firstline: "Pour une expérience optimale,", secondline: "basculez votre écran" }, UT = { shorttitle: "chaîne info live", warningtext: "Vous allez accéder à la chaîne info, le son de votre appareil va être activé", live: "direct", continuous: "en continu" }, VT = { comment: "avis clients", route: "y Aller", nodata: "Aucun contenu ne correspond à votre recherche", openinghours: "Horaires", prices: "Tarifs", paymentmethods: "Modes de paiement", numberofplaces: "nombre de couverts", openroutemobile: "ouvrir l'itinéraire Google Maps sur mobile", FoodEstablishment: "Où manger", LodgingBusiness: "Où dormir", TouristDestination: "A voir", TouristAttraction: "A faire", Product: "Produits locaux", Service: "Services", Event: "Evènements", City: "Villes", Wine: "Vins" }, GT = { consult: "Consultez", thetutorial: "le tutoriel" }, WT = { reset: "effacer tout", showresults: "Afficher les résultats", suggestiontitle: "Suggestions de recherches", reminder: `N'oubliez pas,
 je peux répondre à vos questions.` }, HT = { shorttitle: "tutoriel" }, KT = { title: "traitement des données personnelles transmises au bot", message: `en acceptant ce dialogue, vous consentez à ce que toutes les données transmises au chatbot soient exploitées à des fins d'analyse de l'utilisation de l'outil et d'enrichissement de la base de connaissance.

Vos conversations sont conservées 6 mois avant de faire l'objet d'une suppression.`, link: "lien pour consulter les politiques de confidentialité", buttonAccept: "j'ai compris et j'accepte", buttonRefuse: "je refuse", messageAccepted: "votre consentement est bien pris en compte", messageRefused: "votre refus est bien pris en compte" }, QT = { listening: "C'est à vous, je vous écoute...", correct: "Corriger", dontknow: "Je ne sais pas" }, YT = { allow: "Veuillez autoriser votre navigateur à accéder au micro pour continuer.", rejected: "Vous avez refusé l'accès au micro.", instructions: "Pour utiliser le mode vocal, veuillez autoriser votre navigateur à accéder au micro.", listening: "Je vous écoute", trigger: "Appuyez ou dites", triggerwithoutname: "Appuyez pour parler" }, JT = { rejected: "Vous avez refusé l'accès à votre position GPS.", instructions: "Pour accéder aux données météorologiques ou à la carte interactive, veuillez autoriser votre navigateur à accéder à votre position GPS." }, ZT = { calltoaction: "Appuyez sur l'écran pour commencer", emptyveille: "Cliquez ou appuyez sur l'écran..." }, XT = { shorttitle: "météo", attribution: "Données météorologiques fournies par Open-Meteo.com" }, Hr = {
  1: "accueil",
  2: "chaîne info live",
  3: "météo",
  4: "numéros d'urgence",
  1e3: "historique",
  1001: "tutoriel",
  common: PT,
  emergency: IT,
  error: MT,
  history: jT,
  home: FT,
  inputs: $T,
  language: LT,
  link: NT,
  loader: BT,
  menu: qT,
  mobileLandscapePreventer: zT,
  news: UT,
  poi: VT,
  suggestion: GT,
  template: WT,
  tutorial: HT,
  GDPR: KT,
  anghello: QT,
  microphone: YT,
  position: JT,
  veille: ZT,
  weather: XT
}, eC = { abort: "रद्द करें", all: "सभी", back: "पीछे", close: "बंद करना", continue: "जारी रखना", download: "डाउनलोड करना", downloadsheet: "इस शीट को डाउनलोड करें", downloadsheetmobile: "इस शीट को स्मार्टफोन पर डाउनलोड करें", filter: "फ़िल्टर", history: "ऐतिहासिक", knowmore: "अधिक जानें", lang: "बोली", menu: "मेन्यू", mode: "पहनावा", needhelp: "मदद की ज़रूरत है?", parameters: "समायोजन", print: "छाप", printsheet: "इस शीट को प्रिंट करें", result: "परिणाम", results: "परिणाम", singleLang: "भाषा", sound: "उसकी", submit: "जमा करना", subtitle: "उपशीर्षक", tutorial: "ट्यूटोरियल", validate: "मान्य" }, tC = { shorttitle: "आपातकालीन नंबर", samu: "एस.ए.एम.यू.", police: "पुलिस", firefighter: "अग्निशमन कर्मी", general: "जनरल", citypolice: "स्थानीय पुलिस", hospital: "अस्पताल", homeless: "बेघर (निःशुल्क कॉल)", poison: "ज़हर नियंत्रण केंद्र", emergency: "यूरोपीय आपातकाल" }, rC = { title: "एक गलती हुई है", button: "एप्लिकेशन को पुनः लॉन्च करें" }, nC = { shorttitle: "ऐतिहासिक", title: "बातचीत का इतिहास" }, iC = { shorttitle: "होम पेज" }, oC = { choose: "एक उत्तर चुनें", noaction: "कार्रवाई की प्रतीक्षा है" }, aC = { change: "भाषा बदलो", select: "वह भाषा चुनें जिसका आप उपयोग करना चाहते हैं" }, sC = { buttontext: "दस्तावेज़ देखें", goto: "पते पर जाएं", click: "यहाँ क्लिक करें", scanQR: "QrCode को स्कैन करके", scanQRTile: "क्यूआर कोड स्कैन करें और जानें" }, uC = { loader: { optimal: "सर्वोत्तम अनुभव के लिए,", classic: "अधिक क्लासिक अनुभव के लिए,", vocal: "मैं एजेंट से आमने-सामने बात करता हूं।", text: "मैं एजेंट के साथ लिखित रूप से संवाद करता हूं।" }, modes: { vocal: "स्वर विधा", text: "पाठ मोड" }, loaderValidation: "बातचीत शुरू करें", locale: "भाषा की जाँच करना", supported: "समर्थित भाषाओं की जाँच करना", addressdata: "पुन: प्राप्त डेटा" }, cC = { message: "अपना संदेश दर्ज करें", backconversation: "बातचीत पर वापस", answer: " आपके प्रश्नों का उत्तर देता है" }, lC = { firstline: "सर्वोत्तम अनुभव के लिए,", secondline: "अपनी स्क्रीन पलटें" }, dC = { shorttitle: "लाइव न्यूज़ चैनल", warningtext: "आप समाचार चैनल तक पहुंच पाएंगे, आपके डिवाइस पर ध्वनि सक्रिय हो जाएगी", live: "रहना", continuous: "लगातार" }, fC = { comment: "ग्राहक समीक्षा", route: "सड़क", nodata: "कोई भी सामग्री आपकी खोज से मेल नहीं खाती", openinghours: "खुलने का समय", prices: "कीमतों", paymentmethods: "भुगतान की विधि", numberofplaces: "स्थानों की संख्या", openroutemobile: "स्मार्टफोन पर गूगल मैप रूट खोलें", FoodEstablishment: "कहाँ खाना है", LodgingBusiness: "कहाँ सोना है", TouristDestination: "क्या देखें", TouristAttraction: "क्या करें", Product: "स्थानीय उत्पाद", Service: "सेवाएं", Event: "आयोजन", City: "शहरों", Wine: "वाइन" }, hC = { consult: "चेक आउट", thetutorial: "ट्यूटोरियल" }, pC = { reset: "सभी को पुनः तैयार करना", showresults: "परिणाम दिखाएँ", suggestiontitle: "सुझाव खोजें", reminder: `मत भूलिए, 
 मैं आपके प्रश्नों का उत्तर दे सकता हूँ।` }, mC = { listening: "यह आप पर है, मैं सुन रहा हूं...", correct: "सुधारें", dontknow: "मुझे नहीं पता" }, gC = { allow: "कृपया आगे बढ़ने के लिए अपने ब्राउज़र को माइक्रोफोन का उपयोग करने की अनुमति दें।", rejected: "आपने माइक्रोफोन तक पहुंच को अस्वीकार कर दिया है।", instructions: "वॉयस मोड का उपयोग करने के लिए कृपया अपने ब्राउज़र को माइक्रोफोन का उपयोग करने की अनुमति दें।", listening: "मैं सुन रहा हूँ", trigger: "प्रेस या बोले", triggerwithoutname: "बात करने के लिए टैप करें" }, bC = { rejected: "आपने अपने जीपीएस स्थान तक पहुंच से इनकार कर दिया है।", instructions: "मौसम डेटा या इंटरएक्टिव मैप तक पहुंचने के लिए, कृपया अपने ब्राउज़र को अपने जीपीएस स्थान तक पहुंच की अनुमति दें।" }, vC = { calltoaction: "शुरू करने के लिए स्क्रीन दबाएं", emptyveille: "स्क्रीन पर क्लिक या दबाएं..." }, yC = { shorttitle: "मौसम की रिपोर्ट", attribution: "मौसम डेटा Open-Meteo.com द्वारा प्रदान किया गया" }, wC = { title: "बॉट को भेजे गए व्यक्तिगत डेटा का प्रसंस्करण", message: `इस संवाद को स्वीकार करके, आप सहमति देते हैं कि चैटबॉट को भेजे गए सभी डेटा का उपयोग उपकरण के उपयोग के विश्लेषण और ज्ञान आधार को समृद्ध करने के लिए किया जा सकता है।

आपकी बातचीत हटाने से पहले 6 महीने तक संग्रहीत की जाती है।`, link: "गोपनीयता नीतियां देखने के लिए लिंक", buttonAccept: "मैं समझ गया और स्वीकार करता हूं", buttonRefuse: "मैं अस्वीकार करता हूं", messageAccepted: "आपकी सहमति को ध्यान में रखा गया है", messageRefused: "आपका अस्वीकरण ध्यान में रखा गया है" }, _C = {
  1: "होम पेज",
  2: "लाइव न्यूज़ चैनल",
  3: "मौसम की रिपोर्ट",
  4: "आपातकालीन नंबर",
  1e3: "ऐतिहासिक",
  1001: "ट्यूटोरियल",
  common: eC,
  emergency: tC,
  error: rC,
  history: nC,
  home: iC,
  inputs: oC,
  language: aC,
  link: sC,
  loader: uC,
  menu: cC,
  mobileLandscapePreventer: lC,
  news: dC,
  poi: fC,
  suggestion: hC,
  template: pC,
  anghello: mC,
  microphone: gC,
  position: bC,
  veille: vC,
  weather: yC,
  GDPR: wC
}, kC = { abort: "megszakít", all: "minden", back: "vissza", close: "Bezárás", continue: "Folytatni", download: "Letöltés", downloadsheet: "Töltse le ezt a lapot", downloadsheetmobile: "töltse le ezt a lapot okostelefonra", filter: "Szűrő", history: "történelmi", knowmore: "Tudj meg többet", lang: "NYELVEK", menu: "menü", mode: "divat", needhelp: "Kell segítség?", parameters: "beállítások", print: "Nyomtatás", printsheet: "Nyomtassa ki ezt a lapot", result: "eredmény", results: "eredmények", singleLang: "nyelv", sound: "neki", submit: "Beküldés", subtitle: "felirat", tutorial: "oktatóanyag", validate: "érvényesít" }, xC = { shorttitle: "Segélyhívó számok", samu: "S.A.M.U.", police: "rendőrség", firefighter: "tűzoltók", general: "tábornoki", citypolice: "Helyi rendőrség", hospital: "Kórház", homeless: "Hajléktalanok (ingyenes hívás)", poison: "Méregellenőrző Központ", emergency: "európai vészhelyzetek" }, SC = { title: "Hiba történt", button: "Indítsa újra az alkalmazást" }, EC = { shorttitle: "történelmi", title: "beszélgetés előzményei" }, AC = { shorttitle: "kezdőlap" }, TC = { choose: "Válasszon egy választ", noaction: "Műveletre vár" }, CC = { change: "változtassa meg a nyelvet", select: "válassza ki a használni kívánt nyelvet" }, RC = { buttontext: "Tekintse meg a dokumentumot", goto: "Menjen a címre", click: "Kattints ide", scanQR: "a QR-kód beolvasásával", scanQRTile: "Olvassa be a QR-kódot a felfedezéshez" }, OC = { loader: { optimal: "Az optimális élmény érdekében", classic: "A klasszikusabb élmény érdekében", vocal: "Négyszemközt beszélek az ügynökkel.", text: "Írásban kommunikálok az ügynökkel." }, modes: { vocal: "vokális mód", text: "szöveges mód" }, loaderValidation: "Indítsa el a beszélgetést", locale: "nyelv ellenőrzése", supported: "támogatott nyelvek ellenőrzése", addressdata: "adatok lekérése" }, DC = { message: "Írja be üzenetét", back: "vissza", backconversation: "vissza a beszélgetéshez", close: "Bezárás", answer: " válaszol a kérdéseidre" }, PC = { firstline: "Az optimális élmény érdekében", secondline: "fordítsa meg a képernyőt" }, IC = { shorttitle: "élő hírcsatorna", warningtext: "Hozzáfér a hírcsatornához, és a készülék hangja aktiválódik", live: "élő", continuous: "folyamatosan" }, MC = { comment: "felhasználói értékelés", route: "út", nodata: "Egyetlen tartalom sem felel meg a keresésnek", openinghours: "Nyitvatartási idő", prices: "Árak", paymentmethods: "Fizetési módok", numberofplaces: "helyek száma", openroutemobile: "nyissa meg a Google Maps útvonalat az okostelefonon", FoodEstablishment: "Hol tudok enni", LodgingBusiness: "Hol kell aludni", TouristDestination: "Mit kell látni", TouristAttraction: "Mit kell tenni", Product: "Helyi termékek", Service: "Szolgáltatások", Event: "Események", City: "Városok", Wine: "Borok" }, jC = { consult: "Nézze meg", thetutorial: "az oktatóanyag" }, FC = { reset: "minden visszaállítása", showresults: "Mutasd meg az eredményeket", suggestiontitle: "Keresési javaslatok", reminder: `Ne felejtsd el, 
 tudok válaszolni a kérdéseidre.` }, $C = { listening: "Önön múlik, hallgatok...", correct: "Korrigálni", dontknow: "Nem tudom" }, LC = { allow: "Kérjük, engedélyezze a böngésző számára a mikrofonhoz való hozzáférést a folytatáshoz.", rejected: "Elutasította a mikrofonhoz való hozzáférést.", instructions: "A hang mód használatához kérjük, engedélyezze a böngésző számára a mikrofonhoz való hozzáférést.", listening: "Hallgatlak", trigger: "Nyomja vagy mondja", triggerwithoutname: "Érintse meg a beszéldhez" }, NC = { rejected: "Elutasította a hozzáférést a GPS-helyéhez.", instructions: "Az időjárási adatokhoz vagy az interaktív térképhez való hozzáféréshez engedélyezze a böngésző számára a hozzáférést a GPS-helyéhez." }, BC = { calltoaction: "Nyomja meg a képernyőt a kezdéshez", emptyveille: "Kattintson vagy nyomja meg a képernyőt..." }, qC = { shorttitle: "időjárás jelentés", attribution: "Időjárási adatokat az Open-Meteo.com biztosítja" }, zC = { title: "a botnak továbbított személyes adatok kezelése", message: `a párbeszéd elfogadásával hozzájárul ahhoz, hogy a chatbotnak továbbított összes adatot felhasználják az eszköz használatának elemzésére és a tudásbázis gazdagítására.

Beszélgetéseit 6 hónapig tároljuk törlés előtt.`, link: "link az adatvédelmi irányelvek megtekintéséhez", buttonAccept: "megértettem és elfogadom", buttonRefuse: "elutasítom", messageAccepted: "hozzájárulása figyelembe lett véve", messageRefused: "elutasítása figyelembe lett véve" }, UC = {
  1: "kezdőlap",
  2: "élő hírcsatorna",
  3: "időjárás jelentés",
  4: "Segélyhívó számok",
  1e3: "történelmi",
  1001: "oktatóanyag",
  common: kC,
  emergency: xC,
  error: SC,
  history: EC,
  home: AC,
  inputs: TC,
  language: CC,
  link: RC,
  loader: OC,
  menu: DC,
  mobileLandscapePreventer: PC,
  news: IC,
  poi: MC,
  suggestion: jC,
  template: FC,
  anghello: $C,
  microphone: LC,
  position: NC,
  veille: BC,
  weather: qC,
  GDPR: zC
}, VC = { all: "semua", continue: "Melanjutkan", download: "unduh", downloadsheet: "unduh lembar ini", downloadsheetmobile: "unduh lembar ini di ponsel pintar", filter: "Saring", history: "historis", knowmore: "Ketahui lebih lanjut", lang: "BAHASA", menu: "menu", mode: "mode", needhelp: "Butuh bantuan?", parameters: "pengaturan", print: "Mencetak", printsheet: "Cetak lembar ini", result: "hasil", results: "hasil", singleLang: "bahasa", sound: "dia", submit: "kirim", subtitle: "subjudul", tutorial: "tutorial", validate: "mengesahkan", abort: "batalkan" }, GC = { shorttitle: "Nomor darurat", samu: "S.A.M.U.", police: "POLISI", firefighter: "petugas pemadam kebakaran", general: "umum", citypolice: "Polisi setempat", hospital: "RSUD", homeless: "Tunawisma (panggilan gratis)", poison: "Pusat Pengendalian Racun", emergency: "keadaan darurat Eropa" }, WC = { title: "Sebuah kesalahan telah terjadi", button: "Luncurkan kembali aplikasi" }, HC = { shorttitle: "historis", title: "riwayat percakapan" }, KC = { shorttitle: "halaman rumah" }, QC = { choose: "Pilih jawaban", noaction: "Menunggu tindakan" }, YC = { change: "mengubah bahasa", select: "pilih bahasa yang ingin Anda gunakan" }, JC = { buttontext: "Lihat dokumennya", goto: "Pergi ke alamat", click: "klik disini", scanQR: "dengan memindai QrCode", scanQRTile: "Pindai Kode QR untuk menemukan" }, ZC = { loader: { optimal: "Untuk pengalaman optimal,", classic: "Untuk pengalaman yang lebih klasik,", vocal: "Saya berbicara tatap muka dengan agen.", text: "Saya berkomunikasi secara tertulis dengan agen." }, modes: { vocal: "modus vokal", text: "modus teks" }, loaderValidation: "Mulai percakapan", locale: "memeriksa bahasa", supported: "memeriksa bahasa yang didukung", addressdata: "mengambil data" }, XC = { message: "Masukkan pesan Anda", back: "kembali", backconversation: "kembali ke percakapan", close: "menutup", answer: " menjawab pertanyaan Anda" }, e4 = { firstline: "Untuk pengalaman optimal,", secondline: "balik layar Anda" }, t4 = { shorttitle: "saluran berita langsung", warningtext: "Anda akan mengakses saluran berita, suara di perangkat Anda akan diaktifkan", live: "hidup", continuous: "terus menerus" }, r4 = { comment: "ulasan pelanggan", route: "jalan", nodata: "Tidak ada konten yang cocok dengan pencarian Anda", openinghours: "Jam buka", prices: "Harga", paymentmethods: "Cara Pembayaran", numberofplaces: "sejumlah tempat", openroutemobile: "buka rute Google Maps di smartphone", FoodEstablishment: "Tempat makan", LodgingBusiness: "Tempat tidur", TouristDestination: "Apa yang dilihat", TouristAttraction: "Apa yang harus dilakukan", Product: "Produk lokal", Service: "Jasa", Event: "Acara", City: "kota", Wine: "Anggur" }, n4 = { consult: "Periksa", thetutorial: "tutorialnya" }, i4 = { reset: "atur ulang semua", showresults: "Tunjukkan hasilnya", suggestiontitle: "Saran pencarian", reminder: `Jangan lupa, 
 saya bisa menjawab pertanyaan Anda.` }, o4 = { listening: "Terserah Anda, saya mendengarkan...", correct: "Perbaiki", dontknow: "Saya tidak tahu" }, a4 = { allow: "Silakan izinkan browser Anda mengakses mikrofon untuk melanjutkan.", rejected: "Anda telah menolak akses ke mikrofon.", instructions: "Untuk menggunakan mode suara, silakan izinkan browser Anda mengakses mikrofon.", listening: "Saya mendengar", trigger: "Tekan atau katakan", triggerwithoutname: "Ketuk untuk berbicara" }, s4 = { rejected: "Anda telah menolak akses ke lokasi GPS Anda.", instructions: "Untuk mengakses data cuaca atau peta interaktif, silakan izinkan browser Anda untuk mengakses lokasi GPS Anda." }, u4 = { calltoaction: "Tekan layar untuk memulai", emptyveille: "Klik atau tekan layar..." }, c4 = { shorttitle: "laporan cuaca", attribution: "Data cuaca disediakan oleh Open-Meteo.com" }, l4 = { title: "pemrosesan data pribadi yang dikirimkan ke bot", message: `dengan menerima dialog ini, Anda menyetujui bahwa semua data yang dikirimkan ke chatbot dapat digunakan untuk menganalisis penggunaan alat dan memperkaya basis pengetahuan.

Percakapan Anda disimpan selama 6 bulan sebelum dihapus.`, link: "tautan untuk melihat kebijakan privasi", buttonAccept: "saya mengerti dan menerima", buttonRefuse: "saya menolak", messageAccepted: "persetujuan Anda telah dicatat", messageRefused: "penolakan Anda telah dicatat" }, d4 = {
  1: "halaman rumah",
  2: "saluran berita langsung",
  3: "laporan cuaca",
  4: "Nomor darurat",
  1e3: "historis",
  1001: "tutorial",
  common: VC,
  emergency: GC,
  error: WC,
  history: HC,
  home: KC,
  inputs: QC,
  language: YC,
  link: JC,
  loader: ZC,
  menu: XC,
  mobileLandscapePreventer: e4,
  news: t4,
  poi: r4,
  suggestion: n4,
  template: i4,
  anghello: o4,
  microphone: a4,
  position: s4,
  veille: u4,
  weather: c4,
  GDPR: l4
}, f4 = { abort: "annulla", all: "tutti", back: "Indietro", close: "chiudere", continue: "continuare", download: "scaricamento", downloadsheet: "scarica questa scheda", downloadsheetmobile: "scarica questa scheda sullo smartphone", filter: "Filtro", history: "storico", knowmore: "Scopri di più", lang: "lingua", menu: "menù", mode: "moda", needhelp: "Ho bisogno di aiuto?", parameters: "impostazioni", print: "Stampa", printsheet: "Stampa questo foglio", result: "risultato", results: "risultati", singleLang: "Lingua", sound: "suo", submit: "invia", subtitle: "sottotitolo", tutorial: "tutorial", validate: "convalidare" }, h4 = { shorttitle: "Numeri di emergenza", samu: "S.A.M.U.", police: "Polizia Stradale", firefighter: "vigili del fuoco", general: "generale", citypolice: "Polizia locale", hospital: "Ospedale", homeless: "Senzatetto (chiamata gratuita)", poison: "Centro antiveleni", emergency: "Emergenze europee" }, p4 = { title: "C'è stato un errore", button: "Riavviare l'applicazione" }, m4 = { shorttitle: "storico", title: "cronologia delle conversazioni" }, g4 = { shorttitle: "pagina iniziale" }, b4 = { choose: "Scegli una risposta", noaction: "Attesa di un'azione" }, v4 = { change: "cambiare la lingua", select: "seleziona la lingua che desideri utilizzare" }, y4 = { buttontext: "Visualizza il documento", goto: "Vai all'indirizzo", click: "clicca qui", scanQR: "scansionando il QrCode", scanQRTile: "Scansiona il QR Code per scoprire" }, w4 = { loader: { optimal: "Per un'esperienza ottimale,", classic: "Per un'esperienza più classica,", vocal: "Parlo faccia a faccia con l'agente.", text: "Comunico per iscritto con l'agente." }, modes: { vocal: "modalità vocale", text: "modalità testo" }, loaderValidation: "Inizia la conversazione", locale: "controllo della lingua", supported: "verifica delle lingue supportate", addressdata: "recupero dati" }, _4 = { message: "Inserisci il tuo messaggio", backconversation: "torniamo alla conversazione", answer: " risponde alle tue domande" }, k4 = { firstline: "Per un'esperienza ottimale,", secondline: "capovolgi lo schermo" }, x4 = { shorttitle: "canale di notizie in diretta", warningtext: "Accederai al canale delle notizie, l'audio sul tuo dispositivo verrà attivato", live: "vivere", continuous: "continuamente" }, S4 = { comment: "recensione del cliente", route: "strada", nodata: "Nessun contenuto corrisponde alla tua ricerca", openinghours: "Orari di apertura", prices: "Prezzi", paymentmethods: "Modalità di pagamento", numberofplaces: "numero di posti", openroutemobile: "apri il percorso di Google Maps sullo smartphone", FoodEstablishment: "Dove mangiare", LodgingBusiness: "Dove dormire", TouristDestination: "Cosa guardare", TouristAttraction: "Cosa fare", Product: "Prodotti locali", Service: "Servizi", Event: "Eventi", City: "Città", Wine: "Vini" }, E4 = { consult: "Guardare", thetutorial: "il tutorial" }, A4 = { reset: "resetta tutto", showresults: "Mostra i risultati", suggestiontitle: "Suggerimenti per la ricerca", reminder: `Non dimenticare, 
 posso rispondere alle tue domande.` }, T4 = { listening: "Dipende da te, ti ascolto...", correct: "Correggere", dontknow: "Non lo so" }, C4 = { allow: "Si prega di consentire al browser di accedere al microfono per continuare.", rejected: "Hai rifiutato l'accesso al microfono.", instructions: "Per utilizzare la modalità vocale, si prega di consentire al browser di accedere al microfono.", listening: "Sto ascoltando", trigger: "Premi o dica", triggerwithoutname: "Tocca per parlare" }, R4 = { rejected: "Hai rifiutato l'accesso alla tua posizione GPS.", instructions: "Per accedere ai dati meteorologici o alla mappa interattiva, si prega di autorizzare il browser a accedere alla tua posizione GPS." }, O4 = { calltoaction: "Premi lo schermo per iniziare", emptyveille: "Fai clic o premi lo schermo..." }, D4 = { shorttitle: "bollettino meteorologico", attribution: "Dati meteorologici forniti da Open-Meteo.com" }, P4 = { title: "trattamento dei dati personali trasmessi al bot", message: `accettando questo dialogo, acconsenti che tutti i dati trasmessi al chatbot vengano utilizzati per analizzare l'uso dello strumento e arricchire la base di conoscenza.

Le tue conversazioni vengono conservate 6 mesi prima di essere eliminate.`, link: "link per consultare le politiche sulla privacy", buttonAccept: "ho capito e accetto", buttonRefuse: "rifiuto", messageAccepted: "il tuo consenso è stato preso in considerazione", messageRefused: "il tuo rifiuto è stato preso in considerazione" }, I4 = {
  1: "pagina iniziale",
  2: "canale di notizie in diretta",
  3: "bollettino meteorologico",
  4: "Numeri di emergenza",
  1e3: "storico",
  1001: "tutorial",
  common: f4,
  emergency: h4,
  error: p4,
  history: m4,
  home: g4,
  inputs: b4,
  language: v4,
  link: y4,
  loader: w4,
  menu: _4,
  mobileLandscapePreventer: k4,
  news: x4,
  poi: S4,
  suggestion: E4,
  template: A4,
  anghello: T4,
  microphone: C4,
  position: R4,
  veille: O4,
  weather: D4,
  GDPR: P4
}, M4 = { abort: "キャンセル", all: "全て", back: "戻る", close: "近い", continue: "続く", download: "ダウンロード", downloadsheet: "このシートをダウンロード", downloadsheetmobile: "このシートをスマートフォンにダウンロード", filter: "フィルター", history: "歴史的な", knowmore: "もっと知る", lang: "言語", menu: "メニュー", mode: "ファッション", needhelp: "助けが必要？", parameters: "設定", print: "印刷する", printsheet: "このシートを印刷する", result: "結果", results: "結果", singleLang: "言語", sound: "彼女", submit: "提出する", subtitle: "字幕", tutorial: "チュートリアル", validate: "検証" }, j4 = { shorttitle: "緊急電話番号", samu: "S.A.M.U", police: "警察", firefighter: "消防士", general: "一般的な", citypolice: "地元警察", hospital: "病院", homeless: "ホームレス（無料通話）", poison: "毒物管理センター", emergency: "ヨーロッパの緊急事態" }, F4 = { title: "エラーが発生しました", button: "アプリケーションを再起動する" }, $4 = { shorttitle: "歴史的な", title: "会話履歴" }, L4 = { shorttitle: "ホームページ" }, N4 = { choose: "答えを選択してください", noaction: "アクションを待っています" }, B4 = { change: "言語を変える", select: "使用したい言語を選択してください" }, q4 = { buttontext: "ドキュメントを見る", goto: "住所に移動", click: "ここをクリック", scanQR: "QRコードをスキャンすることで", scanQRTile: "QRコードをスキャンして発見する" }, z4 = { loader: { optimal: "最適なエクスペリエンスを実現するために、", classic: "よりクラシックな体験をするには、", vocal: "エージェントと対面で話します。", text: "私はエージェントと書面でやり取りします。" }, modes: { vocal: "ボーカルモード", text: "テキストモード" }, loaderValidation: "会話を開始する", locale: "言語をチェックする", supported: "サポートされている言語を確認する", addressdata: "データの取得" }, U4 = { message: "メッセージを入力してください", backconversation: "会話に戻ります", answer: " あなたの質問に答えます" }, V4 = { firstline: "最適なエクスペリエンスを実現するために、", secondline: "画面を反転してください" }, G4 = { shorttitle: "ライブニュースチャンネル", warningtext: "ニュースチャンネルにアクセスすると、デバイスのサウンドがアクティブになります", live: "ライブ", continuous: "継続的に" }, W4 = { comment: "カスタマーレビュー", route: "道", nodata: "検索に一致するコンテンツはありません", openinghours: "営業時間", prices: "価格", paymentmethods: "お支払い方法", numberofplaces: "場所の数", openroutemobile: "スマホでGoogleマップのルートを開く", FoodEstablishment: "どこで食べます", LodgingBusiness: "どこで寝るか", TouristDestination: "見るべきもの", TouristAttraction: "何をするか", Product: "地元の特産品", Service: "サービス", Event: "イベント", City: "都市", Wine: "ワイン" }, H4 = { consult: "チェックアウト", thetutorial: "チュートリアル" }, K4 = { reset: "すべてリセット", showresults: "結果を表示する", suggestiontitle: "検索候補", reminder: `忘れないでください、
 あなたの質問に答えます。` }, Q4 = { listening: "あなた次第です、私は聞いています...", correct: "修正する", dontknow: "わかりません" }, Y4 = { allow: "続行するには、ブラウザにマイクへのアクセスを許可してください。", rejected: "マイクへのアクセスを拒否しました。", instructions: "音声モードを使用するには、ブラウザにマイクへのアクセスを許可してください。", listening: "聞いてますよ", trigger: "押すか言ってください", triggerwithoutname: "話すにはタップしてください" }, J4 = { rejected: "あなたはGPS位置へのアクセスを拒否しました。", instructions: "天気データやインタラクティブマップにアクセスするには、ブラウザがあなたのGPS位置にアクセスすることを許可してください。" }, Z4 = { calltoaction: "開始するには画面を押してください", emptyveille: "画面をクリックまたは押してください..." }, X4 = { shorttitle: "天気予報", attribution: "気象データはOpen-Meteo.comにより提供されています" }, e8 = { title: "ボットに送信された個人データの処理", message: `このダイアログを受け入れることで、チャットボットに送信されたすべてのデータをツールの使用分析とナレッジベースの強化に使用することに同意します。

会話は削除前6ヶ月間保存されます。`, link: "プライバシーポリシーを表示するリンク", buttonAccept: "理解して同意します", buttonRefuse: "拒否します", messageAccepted: "同意が考慮されました", messageRefused: "拒否が考慮されました" }, t8 = {
  1: "ホームページ",
  2: "ライブニュースチャンネル",
  3: "天気予報",
  4: "緊急電話番号",
  1e3: "歴史的な",
  1001: "チュートリアル",
  common: M4,
  emergency: j4,
  error: F4,
  history: $4,
  home: L4,
  inputs: N4,
  language: B4,
  link: q4,
  loader: z4,
  menu: U4,
  mobileLandscapePreventer: V4,
  news: G4,
  poi: W4,
  suggestion: H4,
  template: K4,
  anghello: Q4,
  microphone: Y4,
  position: J4,
  veille: Z4,
  weather: X4,
  GDPR: e8
}, r8 = { abort: "취소", all: "모두", back: "뒤쪽에", close: "닫다", continue: "계속하다", download: "다운로드", downloadsheet: "이 시트 다운로드", downloadsheetmobile: "이 시트를 스마트폰에 다운로드하세요", filter: "필터", history: "역사적인", knowmore: "자세히 알아보기", lang: "언어", menu: "메뉴", mode: "패션", needhelp: "도움이 필요하다?", parameters: "설정", print: "인쇄", printsheet: "이 시트를 인쇄하세요", result: "결과", results: "결과", singleLang: "언어", sound: "그녀의", submit: "제출하다", subtitle: "부제", tutorial: "지도 시간", validate: "확인" }, n8 = { shorttitle: "긴급 전화번호", samu: "S.A.M.U.", police: "경찰", firefighter: "소방관", general: "일반적인", hospital: "병원", homeless: "노숙자", poison: "독극물 관리 센터", emergency: "긴급 상황" }, i8 = { title: "오류가 발생했습니다", button: "애플리케이션을 다시 시작하세요." }, o8 = { shorttitle: "역사적인", title: "대화 기록" }, a8 = { shorttitle: "홈페이지" }, s8 = { choose: "답변을 선택하세요", noaction: "작업을 기다리는 중" }, u8 = { change: "언어를 바꿔라", select: "사용하고 싶은 언어를 선택하세요" }, c8 = { buttontext: "문서 보기", goto: "주소로 이동", click: "여기를 클릭하세요", scanQR: "QrCode를 스캔하여", scanQRTile: "QR 코드를 스캔하여 발견하다" }, l8 = { loader: { optimal: "최적의 경험을 위해,", classic: "좀 더 클래식한 경험을 원하신다면,", vocal: "저는 상담원과 직접 대면하여 이야기합니다.", text: "나는 대리인과 서면으로 의사소통합니다." }, modes: { vocal: "보컬 모드", text: "텍스트 모드" }, loaderValidation: "대화 시작", locale: "언어 확인", supported: "지원되는 언어 확인", addressdata: "데이터 검색" }, d8 = { message: "메시지를 입력하세요", backconversation: "대화로 돌아가서", answer: " 귀하의 질문에 답변" }, f8 = { firstline: "최적의 경험을 위해,", secondline: "화면을 뒤집어" }, h8 = { shorttitle: "라이브 뉴스 채널", warningtext: "뉴스 채널에 접속하게 되며 기기의 소리가 활성화됩니다.", live: "살다", continuous: "계속해서" }, p8 = { comment: "고객 리뷰", route: "도로", nodata: "검색어와 일치하는 콘텐츠가 없습니다.", openinghours: "개관 시간", prices: "물가", paymentmethods: "결제 방법", numberofplaces: "장소의 수", openroutemobile: "스마트폰에서 Google 지도 경로 열기", FoodEstablishment: "먹을 곳", LodgingBusiness: "잠을 잘 곳", TouristDestination: "무엇을 볼 것인가", TouristAttraction: "해야 할 일", Product: "지역상품", Service: "서비스", Event: "이벤트", City: "도시", Wine: "와인" }, m8 = { consult: "확인해 보세요", thetutorial: "튜토리얼" }, g8 = { reset: "모두 초기화", showresults: "결과 표시", suggestiontitle: "검색 제안", reminder: `잊지 마세요. 
 제가 귀하의 질문에 답변해드릴 수 있습니다.` }, b8 = { listening: "당신 차례입니다, 저는 듣고 있습니다...", correct: "수정", dontknow: "모르겠습니다" }, v8 = { allow: "계속하려면 브라우저에서 마이크에 접근할 수 있도록 허용해주세요.", rejected: "마이크 접근을 거부했습니다.", instructions: "음성 모드를 사용하려면 브라우저에서 마이크에 접근할 수 있도록 허용해주세요.", listening: "나는 당신의 말을 듣고 있어요", trigger: "누르거나 말하세요", triggerwithoutname: "말하려면 탭하세요" }, y8 = { rejected: "GPS 위치에 대한 액세스를 거부했습니다.", instructions: "날씨 데이터나 인터랙티브 맵에 액세스하려면 브라우저가 GPS 위치에 액세스하도록 허용하십시오." }, w8 = { calltoaction: "시작하려면 화면을 누르세요", emptyveille: "화면을 클릭하거나 누르세요..." }, _8 = { shorttitle: "일기 예보", attribution: "날씨 데이터는 Open-Meteo.com에서 제공합니다" }, k8 = { title: "봇에 전송된 개인 데이터 처리", message: `이 대화를 수락함으로써 챗봇에 전송된 모든 데이터가 도구 사용 분석 및 지식 기반 강화를 위해 사용될 수 있다는 데 동의합니다.

대화는 삭제 전 6개월간 보관됩니다.`, link: "개인정보 보호정책 보기 링크", buttonAccept: "이해하고 동의합니다", buttonRefuse: "거부합니다", messageAccepted: "동의가 기록되었습니다", messageRefused: "거부가 기록되었습니다" }, x8 = {
  1: "홈페이지",
  2: "라이브 뉴스 채널",
  3: "일기 예보",
  4: "긴급 전화번호",
  1e3: "역사적인",
  1001: "지도 시간",
  common: r8,
  emergency: n8,
  error: i8,
  history: o8,
  home: a8,
  inputs: s8,
  language: u8,
  link: c8,
  loader: l8,
  menu: d8,
  mobileLandscapePreventer: f8,
  news: h8,
  poi: p8,
  suggestion: m8,
  template: g8,
  anghello: b8,
  microphone: v8,
  position: y8,
  veille: w8,
  weather: _8,
  GDPR: k8
}, S8 = { all: "alle", back: "tilbake", close: "Lukk", continue: "Fortsette", download: "nedlasting", downloadsheet: "last ned dette arket", downloadsheetmobile: "last ned dette arket på smarttelefonen", filter: "Filter", history: "historisk", knowmore: "Les mer", lang: "språkene", menu: "Meny", mode: "mote", needhelp: "Trenger hjelp?", parameters: "innstillinger", print: "Skrive ut", printsheet: "Skriv ut dette arket", result: "resultat", results: "resultater", singleLang: "språk", sound: "henne", submit: "sende inn", subtitle: "undertekst", tutorial: "opplæringen", validate: "å validere", abort: "avbryt" }, E8 = { shorttitle: "Nødnumre", samu: "S.A.M.U.", police: "politiet", firefighter: "brannmenn", general: "generell", hospital: "Sykehus", homeless: "Hjemløs", poison: "Giftkontrollsenter", emergency: "Nødhjelp" }, A8 = { title: "Det har oppstått en feil", button: "Start applikasjonen på nytt" }, T8 = { shorttitle: "historisk", title: "samtalehistorikk" }, C8 = { shorttitle: "hjemmeside" }, R8 = { choose: "Velg et svar", noaction: "Venter på handling" }, O8 = { change: "endre språket", select: "velg språket du ønsker" }, D8 = { buttontext: "Se dokumentet", goto: "Gå til adressen", click: "Klikk her", scanQR: "ved å skanne QRCode", scanQRTile: "Skann QR-koden for å oppdage" }, P8 = { loader: { optimal: "For en optimal opplevelse,", classic: "For en mer klassisk opplevelse,", vocal: "Jeg snakker ansikt til ansikt med agenten.", text: "Jeg kommuniserer skriftlig med agenten." }, modes: { vocal: "vokalmodus", text: "tekstmodus" }, loaderValidation: "Start samtale", locale: "sjekke språk", supported: "sjekke støttede språk", addressdata: "henter data" }, I8 = { message: "Skriv inn meldingen din", backconversation: "tilbake til samtalen", answer: " svarer på spørsmålene dine" }, M8 = { firstline: "For en optimal opplevelse,", secondline: "snu skjermen" }, j8 = { shorttitle: "direktesendt nyhetskanal", warningtext: "Du får tilgang til nyhetskanalen, lyden på enheten din aktiveres", live: "bo", continuous: "kontinuerlig" }, F8 = { comment: "kundeanmeldelse", route: "vei", nodata: "Ingen innhold samsvarer med søket ditt", openinghours: "Åpningstider", prices: "Priser", paymentmethods: "Betalingsmetoder", numberofplaces: "antall plasser", openroutemobile: "åpne Google Maps-ruten på smarttelefonen", FoodEstablishment: "Hvor skal vi spise", LodgingBusiness: "Hvor skal man sove", TouristDestination: "Hva er det å se", TouristAttraction: "Hva å gjøre", Product: "Lokale produkter", Service: "Tjenester", Event: "arrangementer", City: "Byer", Wine: "Viner" }, $8 = { consult: "Sjekk ut", thetutorial: "opplæringen" }, L8 = { reset: "Tilbakestill alt", showresults: "Vis resultatene", suggestiontitle: "Søkeforslag", reminder: `Ikke glem, 
 jeg kan svare på spørsmålene dine.` }, N8 = { listening: "Det er opp til deg, jeg lytter...", correct: "Korrigere", dontknow: "Jeg vet ikke" }, B8 = { allow: "Vennligst tillat nettleseren din å få tilgang til mikrofonen for å fortsette.", rejected: "Du har nektet tilgang til mikrofonen.", instructions: "For å bruke talemodus, vennligst tillat nettleseren din å få tilgang til mikrofonen.", listening: "Jeg lytter", trigger: "Trykk eller si", triggerwithoutname: "Trykk for å snakke" }, q8 = { rejected: "Du har avvist tilgang til din GPS-posisjon.", instructions: "For å få tilgang til værdata eller interaktivt kart, vennligst gi din nettleser tilgang til din GPS-posisjon." }, z8 = { calltoaction: "Trykk på skjermen for å starte", emptyveille: "Klikk eller trykk på skjermen..." }, U8 = { shorttitle: "Værmelding", attribution: "Værdata levert av Open-Meteo.com" }, V8 = { title: "behandling av personopplysninger sendt til boten", message: `ved å akseptere denne dialogen samtykker du til at alle data sendt til chatboten kan brukes til analyse av bruken av verktøyet og berikelse av kunnskapsbasen.

Samtalene dine oppbevares i 6 måneder før sletting.`, link: "lenke for å se personvernregler", buttonAccept: "jeg forstår og aksepterer", buttonRefuse: "jeg avslår", messageAccepted: "ditt samtykke er tatt til etterretning", messageRefused: "ditt avslag er tatt til etterretning" }, G8 = {
  1: "hjemmeside",
  2: "direktesendt nyhetskanal",
  3: "Værmelding",
  4: "Nødnumre",
  1e3: "historisk",
  1001: "opplæringen",
  common: S8,
  emergency: E8,
  error: A8,
  history: T8,
  home: C8,
  inputs: R8,
  language: O8,
  link: D8,
  loader: P8,
  menu: I8,
  mobileLandscapePreventer: M8,
  news: j8,
  poi: F8,
  suggestion: $8,
  template: L8,
  anghello: N8,
  microphone: B8,
  position: q8,
  veille: z8,
  weather: U8,
  GDPR: V8
}, W8 = { all: "alle", back: "rug", close: "sluiten", continue: "doorgaan", download: "downloaden", downloadsheet: "download dit blad", downloadsheetmobile: "download dit blad op uw smartphone", filter: "Filter", history: "historisch", knowmore: "Lees meer", lang: "TALEN", menu: "menu", mode: "mode", needhelp: "Hulp nodig?", parameters: "instellingen", print: "Afdrukken", printsheet: "Druk dit blad af", result: "resultaat", results: "resultaten", singleLang: "taal", sound: "zijn", submit: "indienen", subtitle: "ondertitel", tutorial: "zelfstudie", validate: "bevestigen", abort: "annuleren" }, H8 = { shorttitle: "Nødnumre", samu: "S.A.M.U.", police: "politie", firefighter: "brandweerlieden", general: "algemeen", hospital: "Ziekenhuis", homeless: "Dakloos", poison: "Vergifcontrolecentrum", emergency: "Hulpdiensten" }, K8 = { title: "er is een fout opgetreden", button: "Start de applicatie opnieuw" }, Q8 = { shorttitle: "historisch", title: "gespreksgeschiedenis" }, Y8 = { shorttitle: "hjemmeside" }, J8 = { choose: "Kies een antwoord", noaction: "Wacht op actie" }, Z8 = { change: "verander de taal", select: "selecteer de taal van uw keuze" }, X8 = { buttontext: "Bekijk het document", goto: "Ga naar adres", click: "Klik hier", scanQR: "door de QRCode te scannen", scanQRTile: "Scan de QR-code om te ontdekken" }, eR = { loader: { optimal: "Voor een optimale ervaring,", classic: "Voor een meer klassieke ervaring,", vocal: "Ik spreek oog in oog met de agent.", text: "Ik communiceer schriftelijk met de makelaar." }, modes: { vocal: "vocale modus", text: "tekstmodus" }, loaderValidation: "Begin een gesprek", locale: "taal controleren", supported: "ondersteunde talen controleren", addressdata: "het ophalen van gegevens" }, tR = { message: "Voer uw bericht in", backconversation: "terug naar het gesprek", answer: " beantwoordt uw vragen" }, rR = { firstline: "Voor een optimale ervaring,", secondline: "draai je scherm om" }, nR = { shorttitle: "direktesendt nyhetskanal", warningtext: "U krijgt toegang tot de nieuwszender, het geluid op uw apparaat wordt geactiveerd", live: "live", continuous: "doorlopend" }, iR = { comment: "klant beoordeling", route: "weg", nodata: "Er is geen inhoud die overeenkomt met uw zoekopdracht", openinghours: "Openingstijden", prices: "Prijzen", paymentmethods: "Betaalmethoden", numberofplaces: "aantal plaatsen", openroutemobile: "open Google Maps-route op smartphone", FoodEstablishment: "Waar te eten", LodgingBusiness: "Waar te slapen", TouristDestination: "Wat te zien", TouristAttraction: "Wat moeten we doen", Product: "Regionale producten", Service: "Diensten", Event: "Evenementen", City: "Steden", Wine: "Wijnen" }, oR = { consult: "Uitchecken", thetutorial: "de tutorial" }, aR = { reset: "alles resetten", showresults: "Laat de resultaten zien", suggestiontitle: "Zoeksuggesties", reminder: "Vergeet niet dat ik je vragen kan beantwoorden." }, sR = { listening: "Het is aan jou, ik luister...", correct: "Corrigeren", dontknow: "Ik weet het niet" }, uR = { allow: "Sta uw browser toe om toegang te krijgen tot de microfoon om door te gaan.", rejected: "U hebt toegang tot de microfoon geweigerd.", instructions: "Om de spraakmodus te gebruiken, staat u uw browser toe toegang te krijgen tot de microfoon.", listening: "Ik luister", trigger: "Druk of zeg", triggerwithoutname: "Tik om te praten" }, cR = { rejected: "U hebt toegang tot uw GPS-locatie geweigerd.", instructions: "Om toegang te krijgen tot weergegevens of de interactieve kaart, staat u uw browser alstublieft toe om toegang te krijgen tot uw GPS-locatie." }, lR = { calltoaction: "Druk op het scherm om te beginnen", emptyveille: "Klik of druk op het scherm..." }, dR = { shorttitle: "Værmelding", attribution: "Weergegevens verstrekt door Open-Meteo.com" }, fR = { title: "verwerking van persoonlijke gegevens verzonden naar de bot", message: `door dit dialoogvenster te accepteren, stemt u ermee in dat alle gegevens die aan de chatbot worden verzonden, kunnen worden gebruikt voor analyse van het gebruik van het hulpmiddel en verrijking van de kennisbasis.

Uw gesprekken worden 6 maanden bewaard voor verwijdering.`, link: "koppeling om het privacybeleid te bekijken", buttonAccept: "ik begrijp het en accepteer", buttonRefuse: "ik weiger", messageAccepted: "uw toestemming is in aanmerking genomen", messageRefused: "uw weigering is in aanmerking genomen" }, hR = {
  1: "hjemmeside",
  2: "direktesendt nyhetskanal",
  3: "Værmelding",
  4: "Nødnumre",
  1e3: "historisk",
  1001: "tutorial",
  common: W8,
  emergency: H8,
  error: K8,
  history: Q8,
  home: Y8,
  inputs: J8,
  language: Z8,
  link: X8,
  loader: eR,
  menu: tR,
  mobileLandscapePreventer: rR,
  news: nR,
  poi: iR,
  suggestion: oR,
  template: aR,
  anghello: sR,
  microphone: uR,
  position: cR,
  veille: lR,
  weather: dR,
  GDPR: fR
}, pR = { all: "alle", back: "rug", close: "sluiten", continue: "doorgaan", download: "downloaden", downloadsheet: "download dit blad", downloadsheetmobile: "download dit blad op uw smartphone", filter: "Filter", history: "historisch", knowmore: "Lees meer", lang: "TALEN", menu: "menu", mode: "mode", needhelp: "Hulp nodig?", parameters: "instellingen", print: "Afdrukken", printsheet: "Druk dit blad af", result: "resultaat", results: "resultaten", singleLang: "taal", sound: "zijn", submit: "indienen", subtitle: "ondertitel", tutorial: "zelfstudie", validate: "bevestigen", abort: "annuleren" }, mR = { shorttitle: "Nødnumre", samu: "S.A.M.U.", police: "politie", firefighter: "brandweerlieden", general: "algemeen", hospital: "Ziekenhuis", homeless: "Dakloos", poison: "Vergifcontrolecentrum", emergency: "Hulpdiensten" }, gR = { title: "er is een fout opgetreden", button: "Start de applicatie opnieuw" }, bR = { shorttitle: "historisch", title: "gespreksgeschiedenis" }, vR = { shorttitle: "hjemmeside" }, yR = { choose: "Kies een antwoord", noaction: "Wacht op actie" }, wR = { change: "verander de taal", select: "selecteer de taal van uw keuze" }, _R = { buttontext: "Bekijk het document", goto: "Ga naar adres", click: "Klik hier", scanQR: "door de QRCode te scannen", scanQRTile: "Scan de QR-code om te ontdekken" }, kR = { loader: { optimal: "Voor een optimale ervaring,", classic: "Voor een meer klassieke ervaring,", vocal: "Ik spreek oog in oog met de agent.", text: "Ik communiceer schriftelijk met de makelaar." }, modes: { vocal: "vocale modus", text: "tekstmodus" }, loaderValidation: "Begin een gesprek", locale: "taal controleren", supported: "ondersteunde talen controleren", addressdata: "het ophalen van gegevens" }, xR = { message: "Voer uw bericht in", backconversation: "terug naar het gesprek", answer: " beantwoordt uw vragen" }, SR = { firstline: "Voor een optimale ervaring,", secondline: "draai je scherm om" }, ER = { shorttitle: "direktesendt nyhetskanal", warningtext: "U krijgt toegang tot de nieuwszender, het geluid op uw apparaat wordt geactiveerd", live: "live", continuous: "doorlopend" }, AR = { comment: "klant beoordeling", route: "weg", nodata: "Er is geen inhoud die overeenkomt met uw zoekopdracht", openinghours: "Openingstijden", prices: "Prijzen", paymentmethods: "Betaalmethoden", numberofplaces: "aantal plaatsen", openroutemobile: "open Google Maps-route op smartphone", FoodEstablishment: "Waar te eten", LodgingBusiness: "Waar te slapen", TouristDestination: "Wat te zien", TouristAttraction: "Wat moeten we doen", Product: "Regionale producten", Service: "Diensten", Event: "Evenementen", City: "Steden", Wine: "Wijnen" }, TR = { consult: "Uitchecken", thetutorial: "de tutorial" }, CR = { reset: "alles resetten", showresults: "Laat de resultaten zien", suggestiontitle: "Zoeksuggesties", reminder: "Vergeet niet dat ik je vragen kan beantwoorden." }, RR = { listening: "Het is aan jou, ik luister...", correct: "Corrigeren", dontknow: "Ik weet het niet" }, OR = { allow: "Sta uw browser toe om toegang te krijgen tot de microfoon om door te gaan.", rejected: "U hebt toegang tot de microfoon geweigerd.", instructions: "Om de spraakmodus te gebruiken, staat u uw browser toe toegang te krijgen tot de microfoon.", listening: "Ik luister", trigger: "Druk of zeg", triggerwithoutname: "Tik om te praten" }, DR = { rejected: "U hebt toegang tot uw GPS-locatie geweigerd.", instructions: "Om toegang te krijgen tot weergegevens of de interactieve kaart, staat u uw browser alstublieft toe om toegang te krijgen tot uw GPS-locatie." }, PR = { calltoaction: "Druk op het scherm om te beginnen", emptyveille: "Klik of druk op het scherm..." }, IR = { shorttitle: "Værmelding", attribution: "Weergegevens verstrekt door Open-Meteo.com" }, MR = { title: "verwerking van persoonlijke gegevens verzonden naar de bot", message: `door dit dialoogvenster te accepteren, stemt u ermee in dat alle gegevens die aan de chatbot worden verzonden, kunnen worden gebruikt voor analyse van het gebruik van het hulpmiddel en verrijking van de kennisbasis.

Uw gesprekken worden 6 maanden bewaard voor verwijdering.`, link: "koppeling om het privacybeleid te bekijken", buttonAccept: "ik begrijp het en accepteer", buttonRefuse: "ik weiger", messageAccepted: "uw toestemming is in aanmerking genomen", messageRefused: "uw weigering is in aanmerking genomen" }, jR = {
  1: "hjemmeside",
  2: "direktesendt nyhetskanal",
  3: "Værmelding",
  4: "Nødnumre",
  1e3: "historisk",
  1001: "tutorial",
  common: pR,
  emergency: mR,
  error: gR,
  history: bR,
  home: vR,
  inputs: yR,
  language: wR,
  link: _R,
  loader: kR,
  menu: xR,
  mobileLandscapePreventer: SR,
  news: ER,
  poi: AR,
  suggestion: TR,
  template: CR,
  anghello: RR,
  microphone: OR,
  position: DR,
  veille: PR,
  weather: IR,
  GDPR: MR
}, FR = { abort: "anuluj", all: "Wszystko", back: "z powrotem", close: "zamknąć", continue: "Kontynuować", download: "pobierać", downloadsheet: "pobierz ten arkusz", downloadsheetmobile: "pobierz ten arkusz na smartfonie", filter: "Filtr", history: "historyczny", knowmore: "Dowiedz się więcej", lang: "Języki", menu: "menu", mode: "moda", needhelp: "Potrzebuję pomocy?", parameters: "ustawienia", print: "Wydrukować", printsheet: "Wydrukuj ten arkusz", result: "wynik", results: "wyniki", singleLang: "język", sound: "jej", submit: "składać", subtitle: "podtytuł", tutorial: "instruktaż", validate: "potwierdzić" }, $R = { shorttitle: "numery alarmowe", samu: "S.A.M.U.", police: "Policja", firefighter: "strażacy", general: "ogólny", hospital: "Szpital", homeless: "Bezdomny", poison: "Centrum Kontroli Trucizn", emergency: "Służby ratunkowe" }, LR = { title: "Wystąpił błąd", button: "Uruchom ponownie aplikację" }, NR = { shorttitle: "historia", title: "Historia konwersacji" }, BR = { shorttitle: "strona główna" }, qR = { choose: "Wybierz odpowiedź", noaction: "Oczekuje na działanie" }, zR = { change: "zmienić język", select: "wybierz wybrany język" }, UR = { buttontext: "Obejrzyj dokument", goto: "Przejdź do adresu", click: "Kliknij tutaj", scanQR: "poprzez zeskanowanie kodu QR", scanQRTile: "Zeskanuj kod QR, aby odkryć" }, VR = { loader: { optimal: "Aby uzyskać optymalne wrażenia,", classic: "Aby uzyskać bardziej klasyczne wrażenia,", vocal: "Rozmawiam twarzą w twarz z agentem.", text: "Komunikuję się pisemnie z agentem." }, modes: { vocal: "tryb wokalny", text: "tryb tekstowy" }, loaderValidation: "Rozpocznij rozmowę", locale: "sprawdzanie języka", supported: "sprawdzanie obsługiwanych języków", addressdata: "pobieranie danych" }, GR = { message: "Wpisz swoją wiadomość", backconversation: "wróć do rozmowy", answer: " odpowiada na Twoje pytania" }, WR = { firstline: "Aby uzyskać optymalne wrażenia,", secondline: "obróć ekran" }, HR = { shorttitle: "kanał informacyjny na żywo", warningtext: "Uzyskasz dostęp do kanału informacyjnego, dźwięk na Twoim urządzeniu zostanie aktywowany", live: "na żywo", continuous: "bez przerwy" }, KR = { comment: "Recenzja klienta", route: "droga", nodata: "Żadna treść nie pasuje do Twojego wyszukiwania", openinghours: "Godziny otwarcia", prices: "Ceny", paymentmethods: "Metody Płatności", numberofplaces: "liczba miejsc", openroutemobile: "otwórz trasę Map Google na smartfonie", FoodEstablishment: "Gdzie zjeść", LodgingBusiness: "Gdzie spać", TouristDestination: "Co zobaczyć", TouristAttraction: "Co robić", Product: "Lokalne produkty", Service: "Usługi", Event: "Wydarzenia", City: "Miasta", Wine: "Wina" }, QR = { consult: "Wymeldować się", thetutorial: "samouczek" }, YR = { reset: "Zresetować wszystko", showresults: "Pokaż wyniki", suggestiontitle: "Wyszukaj sugestie", reminder: `Nie zapomnij, 
, że mogę odpowiedzieć na Twoje pytania.` }, JR = { listening: "To zależy od ciebie, słucham...", correct: "Poprawić", dontknow: "Nie wiem" }, ZR = { allow: "Proszę pozwolić swojej przeglądarce na dostęp do mikrofonu, aby kontynuować.", rejected: "Odmówiłeś dostępu do mikrofonu.", instructions: "Aby używać trybu głosowego, proszę pozwolić swojej przeglądarce na dostęp do mikrofonu.", listening: "Słucham", trigger: "Naciśnij lub powiedz", triggerwithoutname: "Dotknij, aby mówić" }, XR = { rejected: "Odrzuciłeś dostęp do Twojej lokalizacji GPS.", instructions: "Aby uzyskać dostęp do danych pogodowych lub mapy interaktywnej, proszę pozwól przeglądarce uzyskać dostęp do Twojej lokalizacji GPS." }, eO = { calltoaction: "Naciśnij ekran, aby rozpocząć", emptyveille: "Kliknij lub naciśnij ekran..." }, tO = { shorttitle: "pogoda", attribution: "Dane pogodowe dostarczone przez Open-Meteo.com" }, rO = { title: "przetwarzanie danych osobowych przesłanych do bota", message: `akceptując ten dialog, wyrażasz zgodę na to, że wszystkie dane przesłane do chatbota mogą być wykorzystywane do analizy korzystania z narzędzia i wzbogacania bazy wiedzy.

Twoje rozmowy są przechowywane przez 6 miesięcy przed usunięciem.`, link: "link do przeglądania zasad prywatności", buttonAccept: "rozumiem i akceptuję", buttonRefuse: "odmawiam", messageAccepted: "twoja zgoda została uwzględniona", messageRefused: "twoja odmowa została uwzględniona" }, nO = {
  1: "strona główna",
  2: "kanał informacyjny na żywo",
  3: "pogoda",
  4: "numery alarmowe",
  1e3: "historia",
  1001: "instruktaż",
  common: FR,
  emergency: $R,
  error: LR,
  history: NR,
  home: BR,
  inputs: qR,
  language: zR,
  link: UR,
  loader: VR,
  menu: GR,
  mobileLandscapePreventer: WR,
  news: HR,
  poi: KR,
  suggestion: QR,
  template: YR,
  anghello: JR,
  microphone: ZR,
  position: XR,
  veille: eO,
  weather: tO,
  GDPR: rO
}, iO = { abort: "cancelar", all: "todos", back: "voltar", close: "fechar", continue: "continuar", download: "download", downloadsheet: "baixe esta planilha", downloadsheetmobile: "baixe esta planilha no smartphone", filter: "filtro", history: "histórico", knowmore: "Saiba mais", lang: "línguas", menu: "cardápio", mode: "moda", needhelp: "Preciso de ajuda?", parameters: "configurações", print: "Imprimir", printsheet: "Imprima esta folha", result: "resultado", results: "resultados", singleLang: "linguagem", sound: "dela", submit: "enviar", subtitle: "legenda", tutorial: "tutorial", validate: "validar" }, oO = { shorttitle: "Números de emergência", samu: "S.A.M.U.", police: "polícia", firefighter: "bombeiros", general: "general", hospital: "Hospital", homeless: "Morador de rua", poison: "Centro de Controle de Venenos", emergency: "Serviços de emergência" }, aO = { title: "ocorreu um erro", button: "Reinicie o aplicativo" }, sO = { shorttitle: "história", title: "histórico de conversas" }, uO = { shorttitle: "pagina inicial" }, cO = { choose: "Escolha uma resposta", noaction: "Aguardando ação" }, lO = { change: "alterar o idioma", select: "selecione o idioma de sua preferência" }, dO = { buttontext: "Veja o documento", goto: "Ir para o endereço", click: "Clique aqui", scanQR: "digitalizando o QrCode", scanQRTile: "Escaneie o código QR para descobrir" }, fO = { loader: { optimal: "Para uma experiência ideal,", classic: "Para uma experiência mais clássica,", vocal: "Falo cara a cara com o agente.", text: "Eu me comunico por escrito com o agente." }, modes: { vocal: "modo vocal", text: "modo de texto" }, loaderValidation: "Iniciar conversa", locale: "verificando o idioma", supported: "verificando idiomas suportados", addressdata: "recuperando dados" }, hO = { message: "Digite sua mensagem", backconversation: "de volta à conversa", answer: " responde às suas perguntas" }, pO = { firstline: "Para uma experiência ideal,", secondline: "vire sua tela" }, mO = { shorttitle: "canal de informações ao vivo", warningtext: "Você acessará o canal de notícias, o som do seu aparelho será ativado", live: "ao vivo", continuous: "continuamente" }, gO = { comment: "avaliação do cliente", route: "estrada", nodata: "Nenhum conteúdo corresponde à sua pesquisa", openinghours: "Horário de funcionamento", prices: "Preços", paymentmethods: "Métodos de Pagamento", numberofplaces: "número de lugares", openroutemobile: "abra a rota do Google Maps no smartphone", FoodEstablishment: "Onde comer", LodgingBusiness: "Onde dormir", TouristDestination: "O que ver", TouristAttraction: "O que fazer", Product: "Produtos locais", Service: "Serviços", Event: "Eventos", City: "Cidades", Wine: "Vinhos" }, bO = { consult: "Confira", thetutorial: "o tutorial" }, vO = { reset: "reiniciar tudo", showresults: "Mostrar os resultados", suggestiontitle: "Sugestões de pesquisa", reminder: `Não se esqueça, 
, posso responder às suas perguntas.` }, yO = { listening: "Está com você, estou ouvindo...", correct: "Corrigir", dontknow: "Eu não sei" }, wO = { allow: "Por favor, permita que seu navegador acesse o microfone para continuar.", rejected: "Você negou o acesso ao microfone.", instructions: "Para usar o modo de voz, por favor, permita que seu navegador acesse o microfone.", listening: "Estou ouvindo", trigger: "Clique ou diga", triggerwithoutname: "Toque para falar" }, _O = { rejected: "Você recusou o acesso à sua localização GPS.", instructions: "Para acessar os dados meteorológicos ou o mapa interativo, por favor permita que o seu navegador acesse sua localização GPS." }, kO = { calltoaction: "Pressione a tela para começar", emptyveille: "Clique ou pressione a tela..." }, xO = { shorttitle: "clima", attribution: "Dados meteorológicos fornecidos por Open-Meteo.com" }, SO = { title: "processamento de dados pessoais transmitidos ao bot", message: `ao aceitar este diálogo, você consente que todos os dados transmitidos ao chatbot sejam usados para análise do uso da ferramenta e enriquecimento da base de conhecimento.

Suas conversas são mantidas por 6 meses antes de serem excluídas.`, link: "link para consultar as políticas de privacidade", buttonAccept: "entendi e aceito", buttonRefuse: "recuso", messageAccepted: "seu consentimento foi registrado", messageRefused: "sua recusa foi registrada" }, EO = {
  1: "pagina inicial",
  2: "canal de informações ao vivo",
  3: "clima",
  4: "Números de emergência",
  1e3: "história",
  1001: "tutorial",
  common: iO,
  emergency: oO,
  error: aO,
  history: sO,
  home: uO,
  inputs: cO,
  language: lO,
  link: dO,
  loader: fO,
  menu: hO,
  mobileLandscapePreventer: pO,
  news: mO,
  poi: gO,
  suggestion: bO,
  template: vO,
  anghello: yO,
  microphone: wO,
  position: _O,
  veille: kO,
  weather: xO,
  GDPR: SO
}, AO = { abort: "cancelar", all: "todos", back: "voltar", close: "fechar", continue: "continuar", download: "download", downloadsheet: "baixe esta planilha", downloadsheetmobile: "baixe esta planilha no smartphone", filter: "filtro", history: "histórico", knowmore: "Saiba mais", lang: "línguas", menu: "cardápio", mode: "moda", needhelp: "Preciso de ajuda?", parameters: "configurações", print: "Imprimir", printsheet: "Imprima esta folha", result: "resultado", results: "resultados", singleLang: "linguagem", sound: "dela", submit: "enviar", subtitle: "legenda", tutorial: "tutorial", validate: "validar" }, TO = { shorttitle: "Números de emergência", samu: "S.A.M.U.", police: "polícia", firefighter: "bombeiros", general: "general", hospital: "Hospital", homeless: "Morador de rua", poison: "Centro de Controle de Venenos", emergency: "Serviços de emergência" }, CO = { title: "ocorreu um erro", button: "Reinicie o aplicativo" }, RO = { shorttitle: "história", title: "histórico de conversas" }, OO = { shorttitle: "pagina inicial" }, DO = { choose: "Escolha uma resposta", noaction: "Aguardando ação" }, PO = { change: "alterar o idioma", select: "selecione o idioma de sua preferência" }, IO = { buttontext: "Veja o documento", goto: "Ir para o endereço", click: "Clique aqui", scanQR: "digitalizando o QrCode", scanQRTile: "Escaneie o código QR para descobrir" }, MO = { loader: { optimal: "Para uma experiência ideal,", classic: "Para uma experiência mais clássica,", vocal: "Falo cara a cara com o agente.", text: "Eu me comunico por escrito com o agente." }, modes: { vocal: "modo vocal", text: "modo de texto" }, loaderValidation: "Iniciar conversa", locale: "verificando o idioma", supported: "verificando idiomas suportados", addressdata: "recuperando dados" }, jO = { message: "Digite sua mensagem", backconversation: "de volta à conversa", answer: " responde às suas perguntas" }, FO = { firstline: "Para uma experiência ideal,", secondline: "vire sua tela" }, $O = { shorttitle: "canal de informações ao vivo", warningtext: "Você acessará o canal de notícias, o som do seu aparelho será ativado", live: "ao vivo", continuous: "continuamente" }, LO = { comment: "avaliação do cliente", route: "estrada", nodata: "Nenhum conteúdo corresponde à sua pesquisa", openinghours: "Horário de funcionamento", prices: "Preços", paymentmethods: "Métodos de Pagamento", numberofplaces: "número de lugares", openroutemobile: "abra a rota do Google Maps no smartphone", FoodEstablishment: "Onde comer", LodgingBusiness: "Onde dormir", TouristDestination: "O que ver", TouristAttraction: "O que fazer", Product: "Produtos locais", Service: "Serviços", Event: "Eventos", City: "Cidades", Wine: "Vinhos" }, NO = { consult: "Confira", thetutorial: "o tutorial" }, BO = { reset: "reiniciar tudo", showresults: "Mostrar os resultados", suggestiontitle: "Sugestões de pesquisa", reminder: `Não se esqueça, 
, posso responder às suas perguntas.` }, qO = { listening: "Está com você, estou ouvindo...", correct: "Corrigir", dontknow: "Eu não sei" }, zO = { allow: "Por favor, permita que o seu navegador aceda ao microfone para continuar.", rejected: "Negou o acesso ao microfone.", instructions: "Para usar o modo de voz, por favor, permita que o seu navegador aceda ao microfone.", listening: "Estou ouvindo", trigger: "Clique ou diga", triggerwithoutname: "Toque para falar" }, UO = { rejected: "Você recusou o acesso à sua localização GPS.", instructions: "Para acessar os dados meteorológicos ou o mapa interativo, por favor permita que o seu navegador acesse sua localização GPS." }, VO = { calltoaction: "Prima o ecrã para começar", emptyveille: "Clique ou prima o ecrã..." }, GO = { shorttitle: "clima", attribution: "Dados meteorológicos fornecidos por Open-Meteo.com" }, WO = { title: "processamento de dados pessoais transmitidos ao bot", message: `ao aceitar este diálogo, você consente que todos os dados transmitidos ao chatbot sejam usados para análise do uso da ferramenta e enriquecimento da base de conhecimento.

Suas conversas são mantidas por 6 meses antes de serem excluídas.`, link: "link para consultar as políticas de privacidade", buttonAccept: "entendi e aceito", buttonRefuse: "recuso", messageAccepted: "seu consentimento foi registrado", messageRefused: "sua recusa foi registrada" }, HO = {
  1: "pagina inicial",
  2: "canal de informações ao vivo",
  3: "clima",
  4: "Números de emergência",
  1e3: "história",
  1001: "tutorial",
  common: AO,
  emergency: TO,
  error: CO,
  history: RO,
  home: OO,
  inputs: DO,
  language: PO,
  link: IO,
  loader: MO,
  menu: jO,
  mobileLandscapePreventer: FO,
  news: $O,
  poi: LO,
  suggestion: NO,
  template: BO,
  anghello: qO,
  microphone: zO,
  position: UO,
  veille: VO,
  weather: GO,
  GDPR: WO
}, KO = { all: "все", back: "назад", close: "закрывать", continue: "Продолжать", download: "Скачать", downloadsheet: "Загрузите этот лист", downloadsheetmobile: "скачать этот лист на смартфон", filter: "Фильтр", history: "исторический", knowmore: "Узнать больше", lang: "ЯЗЫКИ", menu: "меню", mode: "мода", needhelp: "Нужна помощь?", parameters: "настройки", print: "Распечатать", printsheet: "Распечатать этот лист", result: "результат", results: "Результаты", singleLang: "язык", sound: "звук", submit: "Отправить", subtitle: "субтитры", tutorial: "руководство", validate: "подтвердить", abort: "отменить" }, QO = { shorttitle: "номера экстренных служб", samu: "С.А.М.У.", police: "полиция", firefighter: "пожарные", general: "общий", hospital: "Больница", homeless: "Бездомный", poison: "Токсикологический центр", emergency: "Аварийные службы" }, YO = { title: "произошла ошибка", button: "Перезапустите приложение" }, JO = { shorttitle: "история", title: "история разговоров" }, ZO = { shorttitle: "домашняя страница" }, XO = { choose: "Выберите ответ", noaction: "Ожидается действие" }, eD = { change: "изменить язык", select: "выберите язык по вашему выбору" }, tD = { buttontext: "Посмотреть документ", goto: "Перейти по адресу", click: "кликните сюда", scanQR: "отсканировав QrCode", scanQRTile: "Сканируйте QR-код, чтобы узнать" }, rD = { loader: { optimal: "Для оптимального опыта,", classic: "Для более классического опыта,", vocal: "Я общаюсь, разговаривая с агентом.", text: "Я общаюсь по тексту с агентом." }, modes: { vocal: "голосовой режим", text: "текстовый режим" }, loaderValidation: "Начать разговор", locale: "проверка языка", supported: "проверка поддерживаемых языков", addressdata: "Извлечение данных" }, nD = { message: "Введите ваше сообщение", backconversation: "вернуться к разговору", answer: " отвечает на ваши вопросы" }, iD = { firstline: "Для оптимального опыта,", secondline: "переверните экран" }, oD = { shorttitle: "прямой информационный канал", warningtext: "Вы получите доступ к новостному каналу, звук на вашем устройстве будет активирован.", live: "жить", continuous: "непрерывно" }, aD = { comment: "отзыв клиента", route: "дорога", nodata: "Нет контента, соответствующего вашему запросу", openinghours: "Часы работы", prices: "Цены", paymentmethods: "Способы оплаты", numberofplaces: "количество мест", openroutemobile: "открыть маршрут Google Maps на смартфоне", FoodEstablishment: "Где поесть", LodgingBusiness: "Где спать", TouristDestination: "Что посмотреть", TouristAttraction: "Что делать", Product: "Местные продукты", Service: "Услуги", Event: "События", City: "Города", Wine: "Вина" }, sD = { consult: "Проверить", thetutorial: "учебник" }, uD = { reset: "сбросить все", showresults: "Показать результаты", suggestiontitle: "Поисковые предложения", reminder: `Не забывай, 
 Я могу ответить на твои вопросы.` }, cD = { listening: "Это зависит от вас, я слушаю...", correct: "Исправить", dontknow: "Я не знаю" }, lD = { allow: "Пожалуйста, разрешите вашему браузеру доступ к микрофону для продолжения.", rejected: "Вы отказали в доступе к микрофону.", instructions: "Чтобы использовать голосовой режим, разрешите браузеру доступ к микрофону.", listening: "Я слушаю", trigger: "Нажмите или сказайте", triggerwithoutname: "Нажмите, чтобы говорить" }, dD = { rejected: "Вы отказались в доступе к вашему местоположению GPS.", instructions: "Чтобы получить доступ к погодным данным или интерактивной карте, пожалуйста, разрешите вашему браузеру доступ к вашему местоположению GPS." }, fD = { calltoaction: "Нажмите на экран, чтобы начать", emptyveille: "Нажмите или коснитесь экрана..." }, hD = { shorttitle: "погода", attribution: "Метеорологические данные предоставлены Open-Meteo.com" }, pD = { title: "обработка персональных данных, переданных боту", message: `принимая этот диалог, вы соглашаетесь на использование всех данных, переданных чат-боту, для анализа использования инструмента и обогащения базы знаний.

Ваши разговоры хранятся 6 месяцев до удаления.`, link: "ссылка для просмотра политик конфиденциальности", buttonAccept: "я понял и принимаю", buttonRefuse: "отказываюсь", messageAccepted: "ваше согласие принято во внимание", messageRefused: "ваш отказ принят во внимание" }, mD = {
  1: "домашняя страница",
  2: "прямой информационный канал",
  3: "погода",
  4: "номера экстренных служб",
  1e3: "история",
  1001: "руководство",
  common: KO,
  emergency: QO,
  error: YO,
  history: JO,
  home: ZO,
  inputs: XO,
  language: eD,
  link: tD,
  loader: rD,
  menu: nD,
  mobileLandscapePreventer: iD,
  news: oD,
  poi: aD,
  suggestion: sD,
  template: uD,
  anghello: cD,
  microphone: lD,
  position: dD,
  veille: fD,
  weather: hD,
  GDPR: pD
}, gD = { all: "vse", close: "blizu", back: "nazaj", continue: "Nadaljuj", download: "prenesi", downloadsheet: "prenesite ta list", downloadsheetmobile: "prenesite ta list na pametni telefon", filter: "Filter", history: "zgodovinski", knowmore: "Läs mer", lang: "jezikov", menu: "meni", mode: "moda", needhelp: "Rabim pomoč?", parameters: "nastavitve", print: "Tiskanje", printsheet: "Natisnite ta list", result: "rezultat", results: "rezultate", singleLang: "jezik", sound: "njo", submit: "Skicka in", subtitle: "podnaslov", tutorial: "vadnica", validate: "potrditi", abort: "avbryt" }, bD = { shorttitle: "Nødnumre", samu: "S.A.M.U.", police: "polis", firefighter: "brandmän", general: "allmän", hospital: "Sjukhus", homeless: "Hemlös", poison: "Giftkontrollcenter", emergency: "Akuttjänster" }, vD = { title: "Ett fel har uppstått", button: "Starta om programmet" }, yD = { shorttitle: "zgodovina", title: "zgodovino pogovorov" }, wD = { shorttitle: "domača stran" }, _D = { choose: "Välj ett svar", noaction: "Väntar på åtgärd" }, kD = { change: "spremenite jezik", select: "izberite jezik po vaši izbiri" }, xD = { buttontext: "Oglejte si dokument", goto: "Pojdi na naslov", click: "Klikni tukaj", scanQR: "s skeniranjem QrCode", scanQRTile: "Skanna QR-koden för att upptäcka" }, SD = { loader: { optimal: "Za optimalno izkušnjo,", classic: "Za bolj klasično izkušnjo,", vocal: "Z agentom se pogovarjam iz oči v oči.", text: "Pisno komuniciram z agentom." }, modes: { vocal: "vokalni način", text: "besedilni način" }, loaderValidation: "Začni pogovor", locale: "preverjanje jezika", supported: "preverjanje podprtih jezikov", addressdata: "pridobivanje podatkov" }, ED = { message: "Vnesite svoje sporočilo", backconversation: "nazaj k pogovoru", answer: " odgovarja na vaša vprašanja" }, AD = { firstline: "Za optimalno izkušnjo,", secondline: "obrnite zaslon" }, TD = { shorttitle: "info kanal v živo", warningtext: "Dostopili boste do kanala z novicami, zvok na vaši napravi bo aktiviran", live: "v živo", continuous: "neprekinjeno" }, CD = { comment: "pregled strank", route: "cesta", nodata: "Nobena vsebina se ne ujema z vašim iskanjem", openinghours: "Odpiralni čas", prices: "Cene", paymentmethods: "Načini plačila", numberofplaces: "število mest", openroutemobile: "odprite Google Maps route na pametnem telefonu", FoodEstablishment: "Kje jesti", LodgingBusiness: "Kje spati", TouristDestination: "Kaj videti", TouristAttraction: "Kaj storiti", Product: "Lokalni izdelki", Service: "Storitve", Event: "Dogodki", City: "Mesta", Wine: "Vina" }, RD = { consult: "Preveri", thetutorial: "vadnica" }, OD = { reset: "ponastavi vse", showresults: "Pokaži rezultate", suggestiontitle: "Predlogi za iskanje", reminder: `Ne pozabite, 
 lahko odgovorim na vaša vprašanja.` }, DD = { listening: "Det är upp till dig, jag lyssnar...", correct: "Korrigera", dontknow: "Jag vet inte" }, PD = { allow: "Vänligen tillåt din webbläsare att få åtkomst till mikrofonen för att fortsätta.", rejected: "Du har nekad åtkomst till mikrofonen.", instructions: "För att använda röstläge, vänligen tillåt din webbläsare att få åtkomst till mikrofonen.", listening: "Jag lyssnar", trigger: "Tryck eller säg", triggerwithoutname: "Tryck för att prata" }, ID = { rejected: "Du har avvisat åtkomst till din GPS-position.", instructions: "För att få tillgång till väderdata eller interaktiv karta, vänligen ge din webbläsare tillgång till din GPS-position." }, MD = { calltoaction: "Tryck på skärmen för att börja", emptyveille: "Klicka eller tryck på skärmen..." }, jD = { shorttitle: "vreme", attribution: "Väderdata tillhandahållen av Open-Meteo.com" }, FD = { title: "behandling av personuppgifter som skickas till boten", message: `genom att acceptera denna dialog samtycker du till att alla data som skickas till chatboten kan användas för analys av användningen av verktyget och berikande av kunskapsbasen.

Dina konversationer lagras i 6 månader innan de raderas.`, link: "länk för att se sekretesspolicyer", buttonAccept: "jag förstår och accepterar", buttonRefuse: "jag avböjer", messageAccepted: "ditt samtycke har beaktats", messageRefused: "ditt avslag har beaktats" }, $D = {
  1: "domača stran",
  2: "info kanal v živo",
  3: "vreme",
  4: "številke za klic v sili",
  1e3: "zgodovina",
  1001: "vadnica",
  common: gD,
  emergency: bD,
  error: vD,
  history: yD,
  home: wD,
  inputs: _D,
  language: kD,
  link: xD,
  loader: SD,
  menu: ED,
  mobileLandscapePreventer: AD,
  news: TD,
  poi: CD,
  suggestion: RD,
  template: OD,
  anghello: DD,
  microphone: PD,
  position: ID,
  veille: MD,
  weather: jD,
  GDPR: FD
}, LD = { abort: "ยกเลิก", all: "ทั้งหมด", back: "กลับ", close: "ปิด", continue: "ดำเนินการต่อ", download: "ดาวน์โหลด", downloadsheet: "ดาวน์โหลดเอกสารนี้", downloadsheetmobile: "ดาวน์โหลดเอกสารนี้บนสมาร์ทโฟน", filter: "กรอง", history: "ประวัติศาสตร์", knowmore: "อ่านเพิ่มเติม", lang: "ภาษา", menu: "เมนู", mode: "แฟชั่น", needhelp: "ต้องการความช่วยเหลือ?", parameters: "การตั้งค่า", print: "พิมพ์", printsheet: "พิมพ์แผ่นนี้", result: "ผลลัพธ์", results: "ผลลัพธ์", singleLang: "ภาษา", sound: "ของเธอ", submit: "ส่ง", subtitle: "คำบรรยาย", tutorial: "กวดวิชา", validate: "เพื่อตรวจสอบ" }, ND = { shorttitle: "หมายเลขฉุกเฉิน", samu: "S.A.M.U.", police: "ตำรวจ", firefighter: "นักดับเพลิง", general: "ทั่วไป", hospital: "โรงพยาบาล", homeless: "คนไร้บ้าน", poison: "ศูนย์ควบคุมพิษ", emergency: "บริการฉุกเฉิน" }, BD = { title: "เกิดข้อผิดพลาด", button: "เปิดแอปพลิเคชันอีกครั้ง" }, qD = { shorttitle: "ประวัติศาสตร์", title: "ประวัติการสนทนา" }, zD = { shorttitle: "หน้าแรก" }, UD = { choose: "เลือกคำตอบ", noaction: "รอการดำเนินการ" }, VD = { change: "เปลี่ยนภาษา", select: "เลือกภาษาที่คุณต้องการ" }, GD = { buttontext: "ดูเอกสาร", goto: "ไปที่ที่อยู่", click: "คลิกที่นี่", scanQR: "โดยการสแกน QrCode", scanQRTile: "สแกนรหัส QR เพื่อค้นพบ" }, WD = { loader: { optimal: "เพื่อประสบการณ์ที่ดีที่สุด", classic: "เพื่อประสบการณ์คลาสสิกยิ่งขึ้น", vocal: "ฉันสื่อสารโดยการพูดคุยกับตัวแทน", text: "ฉันสื่อสารทางข้อความกับตัวแทน" }, modes: { vocal: "โหมดเสียงพูด", text: "โหมดข้อความ" }, loaderValidation: "เริ่มการสนทนา", locale: "กำลังตรวจสอบภาษา", supported: "ตรวจสอบภาษาที่รองรับ", addressdata: "กำลังดึงข้อมูล" }, HD = { message: "ป้อนข้อความของคุณ", backconversation: "กลับไปที่การสนทนา", answer: " ตอบคำถามของคุณ" }, KD = { firstline: "เพื่อประสบการณ์ที่ดีที่สุด", secondline: "พลิกหน้าจอของคุณ" }, QD = { shorttitle: "ช่องทางข้อมูลสด", warningtext: "คุณจะเข้าถึงช่องข่าวเสียงบนอุปกรณ์ของคุณจะถูกเปิดใช้งาน", live: "สด", continuous: "อย่างต่อเนื่อง" }, YD = { comment: "รีวิวลูกค้า", route: "ถนน", nodata: "ไม่มีเนื้อหาที่ตรงกับการค้นหาของคุณ", openinghours: "เวลาทำการ", prices: "ราคา", paymentmethods: "วิธีการชำระเงิน", numberofplaces: "จำนวนสถานที่", openroutemobile: "เปิดเส้นทาง Google Maps บนสมาร์ทโฟน", FoodEstablishment: "กินที่ไหนดี", LodgingBusiness: "นอนไหน.", TouristDestination: "มีอะไรให้ดูบ้าง", TouristAttraction: "จะทำอย่างไร", Product: "สินค้าพื้นเมือง", Service: "บริการ", Event: "กิจกรรม", City: "เมือง", Wine: "ไวน์" }, JD = { consult: "เช็คเอาท์", thetutorial: "บทช่วยสอน" }, ZD = { reset: "การตั้งค่าทั้งหมด", showresults: "แสดงผล", suggestiontitle: "คำแนะนำการค้นหา", reminder: `อย่าลืม 
 ฉันสามารถตอบคำถามของคุณได้` }, XD = { listening: "ขึ้นอยู่กับคุณ, ฉันกำลังฟัง...", correct: "แก้ไข", dontknow: "ฉันไม่รู้" }, e5 = { allow: "กรุณาอนุญาตให้เบราว์เซอร์ของคุณเข้าถึงไมโครโฟนเพื่อดำเนินการต่อ", rejected: "คุณปฏิเสธการเข้าถึงไมโครโฟน", instructions: "ในการใช้โหมดเสียงโปรดอนุญาตให้เบราว์เซอร์ของคุณเข้าถึงไมโครโฟน", listening: "ฉันกำลังฟังคุณอยู่", trigger: "กดหรือพูด", triggerwithoutname: "แตะเพื่อพูด" }, t5 = { rejected: "คุณได้ปฏิเสธการเข้าถึงตำแหน่ง GPS ของคุณ", instructions: "เพื่อเข้าถึงข้อมูลสภาพอากาศหรือแผนที่แบบโต้ตอบ โปรดอนุญาตให้เบราว์เซอร์ของคุณเข้าถึงตำแหน่ง GPS ของคุณ" }, r5 = { calltoaction: "กดหน้าจอเพื่อเริ่มต้น", emptyveille: "คลิกหรือกดหน้าจอ..." }, n5 = { shorttitle: "สภาพอากาศ", attribution: "ข้อมูลสภาพอากาศได้รับการจัดหาโดย Open-Meteo.com" }, i5 = { title: "การประมวลผลข้อมูลส่วนบุคคลที่ส่งไปยังบอท", message: `โดยการยอมรับกล่องโต้ตอบนี้ คุณยินยอมให้ข้อมูลทั้งหมดที่ส่งไปยังแชทบอทถูกใช้เพื่อวิเคราะห์การใช้งานเครื่องมือและเพิ่มความสมบูรณ์ของฐานความรู้。

การสนทนาของคุณจะถูกเก็บไว้ 6 เดือนก่อนที่จะถูกลบ`, link: "ลิงก์สำหรับดูนโยบายความเป็นส่วนตัว", buttonAccept: "ฉันเข้าใจและยอมรับ", buttonRefuse: "ฉันปฏิเสธ", messageAccepted: "ความยินยอมของคุณได้รับการบันทึกแล้ว", messageRefused: "การปฏิเสธของคุณได้รับการบันทึกแล้ว" }, o5 = {
  1: "หน้าแรก",
  2: "ช่องทางข้อมูลสด",
  3: "สภาพอากาศ",
  4: "หมายเลขฉุกเฉิน",
  1e3: "ประวัติศาสตร์",
  1001: "กวดวิชา",
  common: LD,
  emergency: ND,
  error: BD,
  history: qD,
  home: zD,
  inputs: UD,
  language: VD,
  link: GD,
  loader: WD,
  menu: HD,
  mobileLandscapePreventer: KD,
  news: QD,
  poi: YD,
  suggestion: JD,
  template: ZD,
  anghello: XD,
  microphone: e5,
  position: t5,
  veille: r5,
  weather: n5,
  GDPR: i5
}, a5 = { abort: "iptal", all: "Tümü", back: "geri", close: "kapalı", continue: "Devam etmek", download: "İndirmek", downloadsheet: "bu sayfayı indir", downloadsheetmobile: "bu sayfayı akıllı telefonunuza indirin", filter: "Filtre", history: "tarihi", knowmore: "Daha fazla bilgi", lang: "Diller", menu: "Menü", mode: "moda", needhelp: "Yardıma mı ihtiyacınız var?", parameters: "ayarlar", print: "Yazdır", printsheet: "Bu sayfayı yazdır", result: "sonuç", results: "sonuçlar", singleLang: "dil", sound: "ses", submit: "göndermek", subtitle: "alt yazı", tutorial: "öğretici", validate: "Doğrulamak" }, s5 = { shorttitle: "Acil durum numaraları", samu: "S.A.M.U.", police: "polis", firefighter: "itfaiyeciler", general: "genel", hospital: "Hastane", homeless: "Evsiz", poison: "Zehir kontrol Merkezi", emergency: "Acil servisler" }, u5 = { title: "bir hata oluştu", button: "Uygulamayı yeniden başlatın" }, c5 = { shorttitle: "tarih", title: "konuşma geçmişi" }, l5 = { shorttitle: "ana sayfa" }, d5 = { choose: "Bir cevap seçin", noaction: "Eylem bekleniyor" }, f5 = { change: "dili değiştir", select: "istediğiniz dili seçin" }, h5 = { buttontext: "Belgeyi görüntüle", goto: "Adrese git", click: "buraya tıklayın", scanQR: "QrCode'u tarayarak", scanQRTile: "Keşfetmek için QR Kodu’nu tara" }, p5 = { loader: { optimal: "Optimum bir deneyim için,", classic: "Daha klasik bir deneyim için,", vocal: "Temsilciyle konuşarak iletişim kuruyorum.", text: "Temsilciyle mesaj yoluyla iletişim kuruyorum." }, modes: { vocal: "vokal modu", text: "metin modu" }, loaderValidation: "Konuşmayı başlat", locale: "dili kontrol etme", supported: "desteklenen dilleri kontrol etme", addressdata: "veri alma" }, m5 = { message: "Mesajınızı girin", backconversation: "konuşmaya geri dön", answer: " sorularınızı yanıtlıyor" }, g5 = { firstline: "Optimum bir deneyim için,", secondline: "ekranını çevir" }, b5 = { shorttitle: "canlı bilgi kanalı", warningtext: "Haber kanalına ulaşacaksınız, cihazınızdaki ses aktif hale gelecektir", live: "canlı", continuous: "devamlı olarak" }, v5 = { comment: "müşteri yorumu", route: "yol", nodata: "Aramanızla eşleşen içerik yok", openinghours: "Açılış saatleri", prices: "Fiyat:% s", paymentmethods: "Ödeme metodları", numberofplaces: "yer sayısı", openroutemobile: "akıllı telefonda Google Haritalar rotasını aç", FoodEstablishment: "Nerede yenir", LodgingBusiness: "Nerede uyumalı", TouristDestination: "Ne görmeli", TouristAttraction: "Ne yapalım", Product: "Yerel ürünler", Service: "Hizmetler", Event: "Olaylar", City: "Şehirler", Wine: "Şaraplar" }, y5 = { consult: "Çıkış yapmak", thetutorial: "öğretici" }, w5 = { reset: "hepsini sıfırla", showresults: "Sonuçları göster", suggestiontitle: "Önerileri ara", reminder: `Unutmayın, 
 sorularınızı cevaplayabilirim.` }, _5 = { listening: "Sıra sizde, dinliyorum...", correct: "Düzelt", dontknow: "Bilmiyorum" }, k5 = { allow: "Devam etmek için lütfen tarayıcınızın mikrofonunuza erişmesine izin verin.", rejected: "Mikrofon erişimini reddettiniz.", instructions: "Ses modunu kullanmak için lütfen tarayıcınızın mikrofonunuza erişmesine izin verin.", listening: "Söylüyorum", trigger: "Basma veya söyle", triggerwithoutname: "Konuşmak için dokunun" }, x5 = { rejected: "GPS konumunuza erişim reddetti.", instructions: "Hava durumu verilerine veya etkileşimli haritaya erişmek için lütfen tarayıcınıza GPS konumunuza erişim izni verin." }, S5 = { calltoaction: "Başlamak için ekrana basın", emptyveille: "Ekrana tıklayın veya basın..." }, E5 = { shorttitle: "hava durumu", attribution: "Hava durumu verileri Open-Meteo.com tarafından sağlanmaktadır" }, A5 = { title: "bota iletilen kişisel verilerin işlenmesi", message: `bu diyalogu kabul ederek, chatbota iletilen tüm verilerin aracın kullanım analizi ve bilgi tabanının zenginleştirilmesi amacıyla kullanılmasına izin vermiş olursunuz.

Konuşmalarınız silinmeden önce 6 ay saklanır.`, link: "gizlilik politikalarını görüntülemek için bağlantı", buttonAccept: "anladım ve kabul ediyorum", buttonRefuse: "reddediyorum", messageAccepted: "onayınız dikkate alındı", messageRefused: "reddiniz dikkate alındı" }, T5 = {
  1: "ana sayfa",
  2: "canlı bilgi kanalı",
  3: "hava durumu",
  4: "Acil durum numaraları",
  1e3: "tarih",
  1001: "öğretici",
  common: a5,
  emergency: s5,
  error: u5,
  history: c5,
  home: l5,
  inputs: d5,
  language: f5,
  link: h5,
  loader: p5,
  menu: m5,
  mobileLandscapePreventer: g5,
  news: b5,
  poi: v5,
  suggestion: y5,
  template: w5,
  anghello: _5,
  microphone: k5,
  position: x5,
  veille: S5,
  weather: E5,
  GDPR: A5
}, C5 = { abort: "取消", all: "全部", back: "后退", close: "关闭", continue: "继续", download: "下载", downloadsheet: "下载此表", downloadsheetmobile: "在智能手机上下载此表", filter: "筛选", history: "历史的", knowmore: "了解更多", lang: "语言", menu: "菜单", mode: "时尚", needhelp: "需要帮忙？", parameters: "设置", print: "打印", printsheet: "打印此表", result: "结果", results: "结果", singleLang: "语言", sound: "她", submit: "提交", subtitle: "字幕", tutorial: "教程", validate: "证实" }, R5 = { shorttitle: "紧急电话号码", samu: "S.A.M.U.", police: "警察", firefighter: "消防员", general: "将军", hospital: "医院", homeless: "无家可归", poison: "毒物控制中心", emergency: "紧急服务" }, O5 = { title: "发生了错误", button: "重新启动应用程序" }, D5 = { shorttitle: "历史", title: "对话历史" }, P5 = { shorttitle: "主页" }, I5 = { choose: "选择一个答案", noaction: "等待操作" }, M5 = { change: "更改语言", select: "选择您要使用的语言" }, j5 = { buttontext: "查看文档", goto: "前往地址", click: "点击这里", scanQR: "扫描二维码", scanQRTile: "扫描二维码以发现" }, F5 = { loader: { optimal: "为了获得最佳体验，", classic: "想要更经典的体验，", vocal: "我通过与代理人交谈来沟通。", text: "我通过短信与代理人沟通。" }, modes: { vocal: "声音模式", text: "文本模式" }, loaderValidation: "开始对话", locale: "检查语言", supported: "检查支持的语言", addressdata: "检索数据" }, $5 = { message: "输入您的留言", backconversation: "回到对话", answer: " 回答你的问题" }, L5 = { firstline: "为了获得最佳体验，", secondline: "翻转你的屏幕" }, N5 = { shorttitle: "实时信息频道", warningtext: "您将访问新闻频道，设备上的声音将被激活", live: "居住", continuous: "不断地" }, B5 = { comment: "客户评论", route: "路", nodata: "没有内容符合您的搜索", openinghours: "营业时间", prices: "价格", paymentmethods: "支付方式", numberofplaces: "名额", openroutemobile: "在智能手机上打开 Google 地图路线", FoodEstablishment: "去哪里吃饭", LodgingBusiness: "睡觉的地方", TouristDestination: "该看什么", TouristAttraction: "该怎么办", Product: "土特产", Service: "服务", Event: "活动", City: "城市", Wine: "葡萄酒" }, q5 = { consult: "查看", thetutorial: "教程" }, z5 = { reset: "重置全部", showresults: "显示结果", suggestiontitle: "搜索建议", reminder: `别忘了，
我可以回答你的问题。` }, U5 = { listening: "由你决定，我在听...", correct: "纠正", dontknow: "我不知道" }, V5 = { allow: "请允许您的浏览器访问麦克风以继续。", rejected: "您已拒绝麦克风访问。", instructions: "要使用语音模式，请允许您的浏览器访问麦克风。", listening: "我在听你说话", trigger: "按或说", triggerwithoutname: "点击说话" }, G5 = { rejected: "您已拒绝访问您的GPS位置。", instructions: "要访问天气数据或交互式地图，请允许您的浏览器访问您的GPS位置。" }, W5 = { calltoaction: "按下屏幕开始", emptyveille: "点击或按下屏幕..." }, H5 = { shorttitle: "天气", attribution: "天气数据由 Open-Meteo.com 提供" }, K5 = { title: "处理传输给机器人的个人数据", message: `通过接受此对话，您同意将传输给聊天机器人的所有数据用于分析工具使用情况和丰富知识库。

您的对话将保存6个月后删除。`, link: "查看隐私政策的链接", buttonAccept: "我理解并接受", buttonRefuse: "我拒绝", messageAccepted: "您的同意已被记录", messageRefused: "您的拒绝已被记录" }, Q5 = {
  1: "主页",
  2: "实时信息频道",
  3: "天气",
  4: "紧急电话号码",
  1e3: "历史",
  1001: "教程",
  common: C5,
  emergency: R5,
  error: O5,
  history: D5,
  home: P5,
  inputs: I5,
  language: M5,
  link: j5,
  loader: F5,
  menu: $5,
  mobileLandscapePreventer: L5,
  news: N5,
  poi: B5,
  suggestion: q5,
  template: z5,
  anghello: U5,
  microphone: V5,
  position: G5,
  veille: W5,
  weather: H5,
  GDPR: K5
}, Y5 = { abort: "取消", all: "全部", back: "后退", close: "关闭", continue: "继续", download: "下载", downloadsheet: "下载此表", downloadsheetmobile: "在智能手机上下载此表", filter: "筛选", history: "历史的", knowmore: "了解更多", lang: "语言", menu: "菜单", mode: "时尚", needhelp: "需要帮忙？", parameters: "设置", print: "打印", printsheet: "打印此表", result: "结果", results: "结果", singleLang: "语言", sound: "她", submit: "提交", subtitle: "字幕", tutorial: "教程", validate: "证实" }, J5 = { shorttitle: "紧急电话号码", samu: "S.A.M.U.", police: "警察", firefighter: "消防员", general: "将军", hospital: "医院", homeless: "无家可归", poison: "毒物控制中心", emergency: "紧急服务" }, Z5 = { title: "发生了错误", button: "重新启动应用程序" }, X5 = { shorttitle: "历史", title: "对话历史" }, eP = { shorttitle: "主页" }, tP = { choose: "选择一个答案", noaction: "等待操作" }, rP = { change: "更改语言", select: "选择您要使用的语言" }, nP = { buttontext: "查看文档", goto: "前往地址", click: "点击这里", scanQR: "扫描二维码", scanQRTile: "掃描 QR 碼以發現" }, iP = { loader: { optimal: "为了获得最佳体验，", classic: "想要更经典的体验，", vocal: "我通过与代理人交谈来沟通。", text: "我通过短信与代理人沟通。" }, modes: { vocal: "声音模式", text: "文本模式" }, loaderValidation: "开始对话", locale: "检查语言", supported: "检查支持的语言", addressdata: "检索数据" }, oP = { message: "输入您的留言", backconversation: "回到对话", answer: " 回答你的问题" }, aP = { firstline: "为了获得最佳体验，", secondline: "翻转你的屏幕" }, sP = { shorttitle: "实时信息频道", warningtext: "您将访问新闻频道，设备上的声音将被激活", live: "居住", continuous: "不断地" }, uP = { comment: "客户评论", route: "路", nodata: "没有内容符合您的搜索", openinghours: "营业时间", prices: "价格", paymentmethods: "支付方式", numberofplaces: "名额", openroutemobile: "在智能手机上打开 Google 地图路线", FoodEstablishment: "去哪里吃饭", LodgingBusiness: "睡觉的地方", TouristDestination: "该看什么", TouristAttraction: "该怎么办", Product: "土特产", Service: "服务", Event: "活动", City: "城市", Wine: "葡萄酒" }, cP = { consult: "查看", thetutorial: "教程" }, lP = { reset: "重置全部", showresults: "显示结果", suggestiontitle: "搜索建议", reminder: `别忘了，
我可以回答你的问题。` }, dP = { listening: "由你決定，我在聽...", correct: "更正", dontknow: "我不知道" }, fP = { allow: "請允許您的瀏覽器訪問麥克風以繼續。", rejected: "您已拒絕麥克風訪問。", instructions: "要使用語音模式，請允許您的瀏覽器訪問麥克風。", listening: "我在听你说话", trigger: "按或说", triggerwithoutname: "點擊以說話" }, hP = { rejected: "您已拒绝访问您的GPS位置。", instructions: "要访问天气数据或交互式地图，请允许您的浏览器访问您的GPS位置。" }, pP = { calltoaction: "按下螢幕開始", emptyveille: "點擊或按下螢幕..." }, mP = { shorttitle: "天气", attribution: "天氣數據由 Open-Meteo.com 提供" }, gP = { title: "處理傳輸給機器人的個人數據", message: `通過接受此對話，您同意將傳輸給聊天機器人的所有數據用於分析工具使用情況和豐富知識庫。

您的對話將保存6個月後刪除。`, link: "查看隱私政策的鏈接", buttonAccept: "我理解並接受", buttonRefuse: "我拒絕", messageAccepted: "您的同意已被記錄", messageRefused: "您的拒絕已被記錄" }, bP = {
  1: "主页",
  2: "实时信息频道",
  3: "天气",
  4: "紧急电话号码",
  1e3: "历史",
  1001: "教程",
  common: Y5,
  emergency: J5,
  error: Z5,
  history: X5,
  home: eP,
  inputs: tP,
  language: rP,
  link: nP,
  loader: iP,
  menu: oP,
  mobileLandscapePreventer: aP,
  news: sP,
  poi: uP,
  suggestion: cP,
  template: lP,
  anghello: dP,
  microphone: fP,
  position: hP,
  veille: pP,
  weather: mP,
  GDPR: gP
}, vP = { abort: "取消", all: "全部", back: "后退", close: "关闭", continue: "继续", download: "下载", downloadsheet: "下载此表", downloadsheetmobile: "在智能手机上下载此表", filter: "筛选", history: "历史的", knowmore: "了解更多", lang: "语言", menu: "菜单", mode: "时尚", needhelp: "需要帮忙？", parameters: "设置", print: "打印", printsheet: "打印此表", result: "结果", results: "结果", singleLang: "语言", sound: "她", submit: "提交", subtitle: "字幕", tutorial: "教程", validate: "证实" }, yP = { shorttitle: "紧急电话号码", samu: "S.A.M.U.", police: "警察", firefighter: "消防员", general: "将军", hospital: "医院", homeless: "无家可归", poison: "毒物控制中心", emergency: "紧急服务" }, wP = { title: "发生了错误", button: "重新启动应用程序" }, _P = { shorttitle: "历史", title: "对话历史" }, kP = { shorttitle: "主页" }, xP = { choose: "选择一个答案", noaction: "等待操作" }, SP = { change: "更改语言", select: "选择您要使用的语言" }, EP = { buttontext: "查看文档", goto: "前往地址", click: "点击这里", scanQR: "扫描二维码", scanQRTile: "掃描 QR 碼以發現" }, AP = { loader: { optimal: "为了获得最佳体验，", classic: "想要更经典的体验，", vocal: "我通过与代理人交谈来沟通。", text: "我通过短信与代理人沟通。" }, modes: { vocal: "声音模式", text: "文本模式" }, loaderValidation: "开始对话", locale: "检查语言", supported: "检查支持的语言", addressdata: "检索数据" }, TP = { message: "输入您的留言", backconversation: "回到对话", answer: " 回答你的问题" }, CP = { firstline: "为了获得最佳体验，", secondline: "翻转你的屏幕" }, RP = { shorttitle: "实时信息频道", warningtext: "您将访问新闻频道，设备上的声音将被激活", live: "居住", continuous: "不断地" }, OP = { comment: "客户评论", route: "路", nodata: "没有内容符合您的搜索", openinghours: "营业时间", prices: "价格", paymentmethods: "支付方式", numberofplaces: "名额", openroutemobile: "在智能手机上打开 Google 地图路线", FoodEstablishment: "去哪里吃饭", LodgingBusiness: "睡觉的地方", TouristDestination: "该看什么", TouristAttraction: "该怎么办", Product: "土特产", Service: "服务", Event: "活动", City: "城市", Wine: "葡萄酒" }, DP = { consult: "查看", thetutorial: "教程" }, PP = { reset: "重置全部", showresults: "显示结果", suggestiontitle: "搜索建议", reminder: `别忘了，
我可以回答你的问题。` }, IP = { listening: "由你決定，我在聽...", correct: "更正", dontknow: "我不知道" }, MP = { allow: "請允許您的瀏覽器訪問麥克風以繼續。", rejected: "您已拒絕麥克風訪問。", instructions: "要使用語音模式，請允許您的瀏覽器訪問麥克風。", listening: "我在听你说话", trigger: "按或说", triggerwithoutname: "點擊以說話" }, jP = { rejected: "您已拒绝访问您的GPS位置。", instructions: "要访问天气数据或交互式地图，请允许您的浏览器访问您的GPS位置。" }, FP = { calltoaction: "按下螢幕開始", emptyveille: "點擊或按下螢幕..." }, $P = { shorttitle: "天气", attribution: "天氣數據由 Open-Meteo.com 提供" }, LP = { title: "處理傳輸給機器人的個人數據", message: `通過接受此對話，您同意將傳輸給聊天機器人的所有數據用於分析工具使用情況和豐富知識庫。

您的對話將保存6個月後刪除。`, link: "查看隱私政策的鏈接", buttonAccept: "我理解並接受", buttonRefuse: "我拒絕", messageAccepted: "您的同意已被記錄", messageRefused: "您的拒絕已被記錄" }, NP = {
  1: "主页",
  2: "实时信息频道",
  3: "天气",
  4: "紧急电话号码",
  1e3: "历史",
  1001: "教程",
  common: vP,
  emergency: yP,
  error: wP,
  history: _P,
  home: kP,
  inputs: xP,
  language: SP,
  link: EP,
  loader: AP,
  menu: TP,
  mobileLandscapePreventer: CP,
  news: RP,
  poi: OP,
  suggestion: DP,
  template: PP,
  anghello: IP,
  microphone: MP,
  position: jP,
  veille: FP,
  weather: $P,
  GDPR: LP
}, h0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ar_AE: m_,
  ar_EG: $_,
  ar_SA: ok,
  ca_ES: Tk,
  cs_CZ: Qk,
  da_DK: bx,
  de_AT: Nx,
  de_CH: sS,
  de_DE: RS,
  en_CA: ZS,
  en_GB: w3,
  en_HK: U3,
  en_IE: fE,
  en_IN: jE,
  en_US: i6,
  es_ES: A6,
  es_MX: K6,
  fi_FI: gA,
  fr_BE: NA,
  fr_CA: uT,
  fr_CH: DT,
  fr_FR: Hr,
  hi_IN: _C,
  hu_HU: UC,
  id_ID: d4,
  it_IT: I4,
  ja_JP: t8,
  ko_KR: x8,
  nb_NO: G8,
  nl_BE: hR,
  nl_NL: jR,
  pl_PL: nO,
  pt_BR: EO,
  pt_PT: HO,
  ru_RU: mD,
  sv_SE: $D,
  th_TH: o5,
  tr_TR: T5,
  zh_CN: Q5,
  zh_HK: bP,
  zh_TW: NP
}, Symbol.toStringTag, { value: "Module" })), BP = {
  ...Ue,
  companyName: "#000",
  loader: {
    animation: Ue.primary,
    background: "rgba(18,18,18,0.7)",
    text: "#FFF",
    toggle: {
      text: "#000",
      background: Ue.primary
    },
    button: {
      background: {
        default: "transparent",
        hover: "transparent"
      },
      border: {
        default: Ue.primary,
        hover: "#FFF"
      },
      text: {
        default: Ue.primary,
        hover: "#FFF"
      }
    }
  },
  card: {
    frame: {
      background: "#2B2B2B",
      border: "transparent",
      text: "#F7F3F6"
    },
    button: {
      background: {
        default: "transparent",
        hover: "transparent"
      },
      border: {
        default: Ue.primary,
        hover: "#FFF"
      },
      text: {
        default: Ue.primary,
        hover: "#FFF"
      }
    },
    discoverButton: {
      background: {
        default: "#eaebf0",
        hover: "transparent"
      },
      border: {
        default: "transparent",
        hover: "#FFF"
      },
      text: {
        default: "#575F6B",
        hover: "#FFF"
      }
    }
  },
  textMode: {
    panel: {
      background: "rgba(255, 255, 255, 0.9)",
      border: "transparent",
      conversationUser: "#FFF",
      conversationBot: "#2C2C2C",
      backgroundUser: Ue.secondary,
      backgroundBot: "#F0F0F0"
    }
  },
  vocalMode: {
    subtitles: {
      text: "#FFF",
      background: "#000"
    }
  },
  formInput: {
    text: {
      default: Ue.secondary,
      hover: "#FFF"
    },
    inputRadioCheckbox: {
      unchecked: {
        background: "#434141",
        border: "#818181"
      },
      checked: {
        background: Ue.primary,
        border: Ue.primary,
        item: "#000"
      }
    },
    inputButton: {
      background: {
        default: Ue.black,
        hover: Ue.primary
      },
      border: {
        default: Ue.primary,
        hover: "#FFF"
      },
      text: {
        default: "#FFF",
        hover: "#FFF"
      }
    },
    likert: {
      default: "transparent",
      hover: "#E8B712"
    }
  }
}, Ou = (e, t) => {
  const r = (n) => n && typeof n == "object";
  if (!r(e) || !r(t))
    return t;
  const i = structuredClone(t);
  return Object.keys(i).forEach((n) => {
    const o = e[n], s = i[n];
    (o || o === !1) && (Array.isArray(o) && Array.isArray(s) ? i[n] = [.../* @__PURE__ */ new Set([...o, ...s])] : r(o) && r(s) ? i[n] = Ou(o, s) : i[n] = o);
  }), i;
}, qP = async (e, t) => {
  const r = `${e}api/integration/framework?culture=${t}`;
  return await fetch(r).then((n) => n.json()).then((n) => {
    var o, s, a, u, l, c;
    return {
      localizedCompanyName: n.companyName,
      localizedSubCompanyMessage: n.subCompanyMessage,
      localizedBannerTitle: (a = (s = (o = n.viewsConfig) == null ? void 0 : o.views) == null ? void 0 : s.news) == null ? void 0 : a.bannerTitle,
      localizedMenus: (u = n.menu) == null ? void 0 : u.categories,
      localizedMapItems: (c = (l = n.mapConfig) == null ? void 0 : l.settings) == null ? void 0 : c.hospitalityCategories
    };
  }).catch(() => null);
}, p0 = {
  baseAddress: "",
  locale: "",
  defaultLocale: "fr-FR",
  supported: [],
  dumpedLanguagesFallback: {},
  replacementLocales: {},
  currentTranslations: structuredClone(Hr),
  isRTL: !1,
  localeForRetorikStudioContent: "",
  localizedCompanyName: void 0,
  localizedSubCompanyMessage: void 0,
  localizedBannerTitle: void 0,
  localizedMenus: []
}, Wg = mt({
  name: "locale",
  initialState: p0,
  reducers: {
    setBaseAddress: (e, t) => {
      e.baseAddress = t.payload;
    },
    setLanguageData: (e, t) => ({
      ...e,
      defaultLocale: t.payload.defaultLocale,
      supported: t.payload.supported
    }),
    addDumpedLanguageFallback: (e, t) => {
      e.dumpedLanguagesFallback = { ...e.dumpedLanguagesFallback, [t.payload.key]: t.payload.value };
    },
    addReplacementLocale: (e, t) => {
      e.replacementLocales[t.payload.key] = t.payload.value;
    },
    resetLocaleStore: () => ({ ...p0 })
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (e) => {
    e.addCase(Hg.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    })).addCase(Kg.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    }));
  }
}), Hg = Ae("locale/setLocale", async (e, t) => {
  var a, u;
  const r = t.getState().localeReducer, i = await qP(r.baseAddress, ((a = r.dumpedLanguagesFallback) == null ? void 0 : a[e]) || e), n = e.split("-")[0], o = structuredClone(h0[e.replace("-", "_")]);
  let s = structuredClone(Hr);
  if (o)
    s = Ou(o, structuredClone(Hr));
  else {
    const l = G2.find((c) => c.split("-")[0] === n);
    l && (s = Ou(structuredClone(h0[l.replace("-", "_")]), structuredClone(Hr)));
  }
  return {
    locale: e,
    isRTL: U2.includes(n),
    localeForRetorikStudioContent: ((u = r.dumpedLanguagesFallback) == null ? void 0 : u[e]) || e,
    currentTranslations: { ...s },
    localizedCompanyName: i == null ? void 0 : i.localizedCompanyName,
    localizedSubCompanyMessage: i == null ? void 0 : i.localizedSubCompanyMessage,
    localizedBannerTitle: i == null ? void 0 : i.localizedBannerTitle,
    localizedMenus: (i == null ? void 0 : i.localizedMenus) || []
  };
}), Kg = Ae("locale/fetchSupportedLanguages", async (e) => await W2(e).then((t) => ({
  defaultLocale: t.default,
  supported: t.all
}))), Qg = Ae("locale/checkDumpedLocaleFallback", async (e, t) => {
  var i;
  const r = t.getState().localeReducer;
  return ((i = r.dumpedLanguagesFallback) == null ? void 0 : i[r.locale]) || r.locale;
}), zP = Wg.reducer, { setBaseAddress: UP, setLanguageData: VP, addDumpedLanguageFallback: GP, addReplacementLocale: WP, resetLocaleStore: HP } = Wg.actions, m0 = {
  restoreInputsState: !1,
  values: {},
  currentId: void 0,
  currentToggleIds: [],
  currentValue: void 0
}, Yg = mt({
  name: "adaptiveCard",
  initialState: m0,
  reducers: {
    setValue: (e, t) => {
      if (t.payload.id === e.currentId) {
        const r = e.values;
        e.restoreInputsState && (r[t.payload.id] = t.payload.value), e.values = r, e.currentValue = { [t.payload.id]: t.payload.value };
      }
    },
    setToggleValue: (e, t) => {
      if (e.currentToggleIds.includes(t.payload.id)) {
        const r = e.values;
        e.restoreInputsState && (r[t.payload.id] = t.payload.value);
        const i = e.currentValue || {};
        e.currentToggleIds.forEach((n) => {
          var o;
          if (n === t.payload.id)
            i[n] = t.payload.value;
          else {
            const s = ((o = e.currentValue) == null ? void 0 : o[n]) || !1;
            i[n] = Array.isArray(s) ? !1 : s;
          }
        }), e.values = r, e.currentValue = i;
      }
    },
    setCurrentId: (e, t) => ({
      ...e,
      currentId: t.payload,
      currentValue: void 0,
      currentToggleIds: []
    }),
    addCurrentToggleId: (e, t) => {
      const r = e.values, i = e.currentToggleIds;
      r[t.payload.id] = t.payload.defaultValue, e.values = r, e.currentToggleIds = [...i, t.payload.id];
    },
    setRestoreInputsState: (e, t) => {
      e.restoreInputsState = t.payload;
    },
    resetAdaptiveCardStore: () => ({ ...m0 })
  }
}), KP = Yg.reducer, { setValue: QP, setToggleValue: YP, setCurrentId: Jg, addCurrentToggleId: JP, setRestoreInputsState: Zg, resetAdaptiveCardStore: ZP } = Yg.actions;
async function XP(e) {
  return await fetch(e).then((r) => r.json()).catch((r) => console.warn(`Retorik Framework > error fetching directline token : ${r}`));
}
var Ie = /* @__PURE__ */ ((e) => (e.UNKNOWN = "DIRECT_LINE/UNKNOWN", e.INCOMING_ACTIVITY = "DIRECT_LINE/INCOMING_ACTIVITY", e.POST_ACTIVITY = "DIRECT_LINE/POST_ACTIVITY", e.POST_ACTIVITY_FULFILLED = "DIRECT_LINE/POST_ACTIVITY_FULFILLED", e.SEND_MESSAGE = "WEB_CHAT/SEND_MESSAGE", e.SEND_EVENT = "WEB_CHAT/SEND_EVENT", e.TYPING = "WEB_CHAT/EMIT_TYPING_INDICATOR", e.MARK = "WEB_CHAT/MARK_ACTIVITY", e.SET_LANGUAGE = "WEB_CHAT/SET_LANGUAGE", e))(Ie || {});
const vc = {
  0: "DIRECT_LINE/CONNECT",
  1: "DIRECT_LINE/CONNECT_PENDING",
  2: "DIRECT_LINE/CONNECT_FULFILLED",
  3: "DIRECT_LINE/EXPIRED_TOKEN",
  4: "DIRECT_LINE/CONNECT_FAILED",
  5: "DIRECT_LINE/CONNECT_ENDED"
}, eI = (e) => {
  var t, r, i;
  return (e == null ? void 0 : e.type) === "message" && ((t = e.attachments) != null && t.length) && e.attachments[0].contentType === "application/vnd.davi.retorik.card.suggestedaction" && ((i = (r = e.attachments[0].content) == null ? void 0 : r.title) == null ? void 0 : i.indexOf(e.text)) > -1 && (e.text = "", e.htmlText = ""), e;
};
function Ls(e, t, r, i) {
  return new (r || (r = Promise))((function(n, o) {
    function s(l) {
      try {
        u(i.next(l));
      } catch (c) {
        o(c);
      }
    }
    function a(l) {
      try {
        u(i.throw(l));
      } catch (c) {
        o(c);
      }
    }
    function u(l) {
      var c;
      l.done ? n(l.value) : (c = l.value, c instanceof r ? c : new r((function(d) {
        d(c);
      }))).then(s, a);
    }
    u((i = i.apply(e, [])).next());
  }));
}
const tI = ["geforce 320m", "geforce 8600", "geforce 8600m gt", "geforce 8800 gs", "geforce 8800 gt", "geforce 9400", "geforce 9400m g", "geforce 9400m", "geforce 9600m gt", "geforce 9600m", "geforce fx go5200", "geforce gt 120", "geforce gt 130", "geforce gt 330m", "geforce gtx 285", "google swiftshader", "intel g41", "intel g45", "intel gma 4500mhd", "intel gma x3100", "intel hd 3000", "intel q45", "legacy", "mali-2", "mali-3", "mali-4", "quadro fx 1500", "quadro fx 4", "quadro fx 5", "radeon hd 2400", "radeon hd 2600", "radeon hd 4670", "radeon hd 4850", "radeon hd 4870", "radeon hd 5670", "radeon hd 5750", "radeon hd 6290", "radeon hd 6300", "radeon hd 6310", "radeon hd 6320", "radeon hd 6490m", "radeon hd 6630m", "radeon hd 6750m", "radeon hd 6770m", "radeon hd 6970m", "sgx 543", "sgx543"];
function g0(e) {
  return e = e.toLowerCase().replace(/.*angle ?\((.+)\)(?: on vulkan [0-9.]+)?$/i, "$1").replace(/\s(\d{1,2}gb|direct3d.+$)|\(r\)| \([^)]+\)$/g, "").replace(/(?:vulkan|opengl) \d+\.\d+(?:\.\d+)?(?: \((.*)\))?/, "$1");
}
const Xg = typeof window > "u", ot = (() => {
  if (Xg) return;
  const { userAgent: e, platform: t, maxTouchPoints: r } = window.navigator, i = /(iphone|ipod|ipad)/i.test(e), n = t === "iPad" || t === "MacIntel" && r > 0 && !window.MSStream;
  return { isIpad: n, isMobile: /android/i.test(e) || i || n, isSafari12: /Version\/12.+Safari/.test(e), isFirefox: /Firefox/.test(e) };
})();
function rI(e, t, r) {
  if (!r) return [t];
  const i = (function(l) {
    const c = `
    precision highp float;
    attribute vec3 aPosition;
    varying float vvv;
    void main() {
      vvv = 0.31622776601683794;
      gl_Position = vec4(aPosition, 1.0);
    }
  `, d = `
    precision highp float;
    varying float vvv;
    void main() {
      vec4 enc = vec4(1.0, 255.0, 65025.0, 16581375.0) * vvv;
      enc = fract(enc);
      enc -= enc.yzww * vec4(1.0 / 255.0, 1.0 / 255.0, 1.0 / 255.0, 0.0);
      gl_FragColor = enc;
    }
  `, h = l.createShader(35633), f = l.createShader(35632), p = l.createProgram();
    if (!(f && h && p)) return;
    l.shaderSource(h, c), l.shaderSource(f, d), l.compileShader(h), l.compileShader(f), l.attachShader(p, h), l.attachShader(p, f), l.linkProgram(p), l.detachShader(p, h), l.detachShader(p, f), l.deleteShader(h), l.deleteShader(f), l.useProgram(p);
    const m = l.createBuffer();
    l.bindBuffer(34962, m), l.bufferData(34962, new Float32Array([-1, -1, 0, 3, -1, 0, -1, 3, 0]), 35044);
    const w = l.getAttribLocation(p, "aPosition");
    l.vertexAttribPointer(w, 3, 5126, !1, 0, 0), l.enableVertexAttribArray(w), l.clearColor(1, 1, 1, 1), l.clear(16384), l.viewport(0, 0, 1, 1), l.drawArrays(4, 0, 3);
    const v = new Uint8Array(4);
    return l.readPixels(0, 0, 1, 1, 6408, 5121, v), l.deleteProgram(p), l.deleteBuffer(m), v.join("");
  })(e), n = "801621810", o = "8016218135", s = "80162181161", a = ot != null && ot.isIpad ? [["a7", s, 12], ["a8", o, 15], ["a8x", o, 15], ["a9", o, 15], ["a9x", o, 15], ["a10", o, 15], ["a10x", o, 15], ["a12", n, 15], ["a12x", n, 15], ["a12z", n, 15], ["a14", n, 15], ["a15", n, 15], ["m1", n, 15], ["m2", n, 15]] : [["a7", s, 12], ["a8", o, 12], ["a9", o, 15], ["a10", o, 15], ["a11", n, 15], ["a12", n, 15], ["a13", n, 15], ["a14", n, 15], ["a15", n, 15], ["a16", n, 15], ["a17", n, 15]];
  let u;
  return i === "80162181255" ? u = a.filter((([, , l]) => l >= 14)) : (u = a.filter((([, l]) => l === i)), u.length || (u = a)), u.map((([l]) => `apple ${l} gpu`));
}
class b0 extends Error {
  constructor(t) {
    super(t), Object.setPrototypeOf(this, new.target.prototype);
  }
}
const Ns = [], v0 = [];
function nI(e, t) {
  if (e === t) return 0;
  const r = e;
  e.length > t.length && (e = t, t = r);
  let i = e.length, n = t.length;
  for (; i > 0 && e.charCodeAt(~-i) === t.charCodeAt(~-n); ) i--, n--;
  let o, s = 0;
  for (; s < i && e.charCodeAt(s) === t.charCodeAt(s); ) s++;
  if (i -= s, n -= s, i === 0) return n;
  let a, u, l = 0, c = 0, d = 0;
  for (; c < i; ) v0[c] = e.charCodeAt(s + c), Ns[c] = ++c;
  for (; d < n; ) for (o = t.charCodeAt(s + d), a = d++, l = d, c = 0; c < i; c++) u = o === v0[c] ? a : a + 1, a = Ns[c], l = Ns[c] = a > l ? u > l ? l + 1 : u : u > a ? a + 1 : u;
  return l;
}
function iI(e) {
  return e != null;
}
const oI = ({ mobileTiers: e = [0, 15, 30, 60], desktopTiers: t = [0, 15, 30, 60], override: r = {}, glContext: i, failIfMajorPerformanceCaveat: n = !1, benchmarksURL: o = "https://unpkg.com/detect-gpu@5.0.70/dist/benchmarks" } = {}) => Ls(void 0, void 0, void 0, (function* () {
  const s = {};
  if (Xg) return { tier: 0, type: "SSR" };
  const { isIpad: a = !!(ot != null && ot.isIpad), isMobile: u = !!(ot != null && ot.isMobile), screenSize: l = window.screen, loadBenchmarks: c = ((k) => Ls(void 0, void 0, void 0, (function* () {
    const y = yield fetch(`${o}/${k}`).then(((x) => x.json()));
    if (parseInt(y.shift().split(".")[0], 10) < 4) throw new b0("Detect GPU benchmark data is out of date. Please update to version 4x");
    return y;
  }))) } = r;
  let { renderer: d } = r;
  const h = (k, y, x, C, I) => ({ device: I, fps: C, gpu: x, isMobile: u, tier: k, type: y });
  let f, p = "";
  if (d) d = g0(d), f = [d];
  else {
    const k = i || (function(x, C = !1) {
      const I = { alpha: !1, antialias: !1, depth: !1, failIfMajorPerformanceCaveat: C, powerPreference: "high-performance", stencil: !1 };
      x && delete I.powerPreference;
      const M = window.document.createElement("canvas"), Q = M.getContext("webgl", I) || M.getContext("experimental-webgl", I);
      return Q ?? void 0;
    })(ot == null ? void 0 : ot.isSafari12, n);
    if (!k) return h(0, "WEBGL_UNSUPPORTED");
    const y = ot != null && ot.isFirefox ? null : k.getExtension("WEBGL_debug_renderer_info");
    if (d = y ? k.getParameter(y.UNMASKED_RENDERER_WEBGL) : k.getParameter(k.RENDERER), !d) return h(1, "FALLBACK");
    p = d, d = g0(d), f = (function(x, C, I) {
      return C === "apple gpu" ? rI(x, C, I) : [C];
    })(k, d, u);
  }
  const m = (yield Promise.all(f.map((function(k) {
    var y;
    return Ls(this, void 0, void 0, (function* () {
      const x = ((oe) => {
        const ie = u ? ["adreno", "apple", "mali-t", "mali", "nvidia", "powervr", "samsung"] : ["intel", "apple", "amd", "radeon", "nvidia", "geforce", "adreno"];
        for (const le of ie) if (oe.includes(le)) return le;
      })(k);
      if (!x) return;
      const C = `${u ? "m" : "d"}-${x}${a ? "-ipad" : ""}.json`, I = s[C] = (y = s[C]) !== null && y !== void 0 ? y : c(C);
      let M;
      try {
        M = yield I;
      } catch (oe) {
        if (oe instanceof b0) throw oe;
        return;
      }
      const Q = (function(oe) {
        var ie;
        const le = (oe = oe.replace(/\([^)]+\)/, "")).match(/\d+/) || oe.match(/(\W|^)([A-Za-z]{1,3})(\W|$)/g);
        return (ie = le == null ? void 0 : le.join("").replace(/\W|amd/g, "")) !== null && ie !== void 0 ? ie : "";
      })(k);
      let H = M.filter((([, oe]) => oe === Q));
      H.length || (H = M.filter((([oe]) => oe.includes(k))));
      const J = H.length;
      if (J === 0) return;
      const W = k.split(/[.,()\[\]/\s]/g).sort().filter(((oe, ie, le) => ie === 0 || oe !== le[ie - 1])).join(" ");
      let P, [R, , , , V] = J > 1 ? H.map(((oe) => [oe, nI(W, oe[2])])).sort((([, oe], [, ie]) => oe - ie))[0][0] : H[0], X = Number.MAX_VALUE;
      const { devicePixelRatio: N } = window, U = l.width * N * l.height * N;
      for (const oe of V) {
        const [ie, le] = oe, he = ie * le, ye = Math.abs(U - he);
        ye < X && (X = ye, P = oe);
      }
      if (!P) return;
      const [, , G, re] = P;
      return [X, G, R, re];
    }));
  })))).filter(iI).sort((([k = Number.MAX_VALUE, y], [x = Number.MAX_VALUE, C]) => k === x ? y - C : k - x));
  if (!m.length) {
    const k = tI.find(((y) => d.includes(y)));
    return k ? h(0, "BLOCKLISTED", k) : h(1, "FALLBACK", `${d} (${p})`);
  }
  const [, w, v, g] = m[0];
  if (w === -1) return h(0, "BLOCKLISTED", v, w, g);
  const A = u ? e : t;
  let b = 0;
  for (let k = 0; k < A.length; k++) w >= A[k] && (b = k);
  return h(b, "BENCHMARK", v, w, g);
})), y0 = async (e) => {
  const t = await fetch(`${e}/manifest.json?v=${Date.now()}`).then((r) => r.json()).then((r) => r).catch((r) => (console.log(r), null));
  return t !== null && (t.url = t.character ? `${e}/${t.character}` : e, t.portrait = e + "/" + t.portrait, t.useBodyEngineThree = !!t.character), t;
}, w0 = {
  configuration: {
    subtitles: !1
  },
  addressData: {},
  canFocusSendBox: !1,
  sendBoxPlaceHolder: void 0,
  fromTextToVocal: !1,
  subtitlesInConfiguration: !1,
  displaySubtitles: !1,
  agentData: void 0,
  gpuData: void 0,
  loaderClosed: !1,
  appAvailable: !1,
  currentLayout: $g.agent,
  userAlreadySet: !1,
  isWaitingForResponse: !1,
  instantIsWaitingForResponse: !1,
  skipLoader: !1,
  displayAgentInNews: !0,
  submitDelayBeforeSendingMessage: void 0,
  environmentPreset: "apartment",
  customScripts: [],
  customCSS: [],
  enabledFeatures: [],
  showPositionModal: !1
};
let Br = setTimeout(() => !0, 1e3);
const aI = `${Gg}/long-shot/zahra`, sI = `${Gg}/long-shot/rowan`, eb = mt({
  name: "retorik",
  initialState: w0,
  reducers: {
    setConfiguration: (e, t) => {
      e.configuration = t.payload;
    },
    setAddressData: (e, t) => {
      e.addressData = t.payload;
    },
    focusSendBox: () => {
      var t;
      const e = document.getElementById("retorik-framework-send-textbox-textarea");
      e && ((t = document.activeElement) == null ? void 0 : t.id) !== e.id && e.focus();
    },
    setCanFocusSendBox: (e, t) => {
      e.canFocusSendBox = t.payload;
    },
    setSendBoxPlaceHolder: (e, t) => {
      e.sendBoxPlaceHolder = t.payload;
    },
    setLayout: (e, t) => {
      e.currentLayout = t.payload;
    },
    setUserAlreadySet: (e, t) => {
      e.userAlreadySet = t.payload;
    },
    setEnvironmentPreset: (e, t) => {
      e.environmentPreset = t.payload;
    },
    setFromTextToVocal: (e, t) => {
      e.fromTextToVocal = t.payload;
    },
    setLoaderClosed: (e, t) => {
      e.loaderClosed = t.payload;
    },
    setAppAvailable: (e, t) => {
      e.appAvailable = t.payload;
    },
    setSubtitlesInConfiguration: (e, t) => {
      e.subtitlesInConfiguration = t.payload, e.displaySubtitles = t.payload;
    },
    setDisplaySubtitles: (e, t) => {
      e.displaySubtitles = t.payload;
    },
    toggleSubtitles: (e) => {
      e.displaySubtitles = !e.displaySubtitles;
    },
    setInternalIsWaitingForResponse: (e, t) => {
      e.isWaitingForResponse = t.payload;
    },
    setInstantIsWaitingForResponse: (e, t) => {
      e.instantIsWaitingForResponse = t.payload;
    },
    setSkipLoader: (e, t) => {
      e.skipLoader = t.payload;
    },
    setDisplayAgentInNews: (e, t) => {
      e.displayAgentInNews = t.payload;
    },
    setSubmitDelayBeforeSendingMessage: (e, t) => {
      e.submitDelayBeforeSendingMessage = t.payload;
    },
    setCustomScripts: (e, t) => {
      e.customScripts = t.payload;
    },
    setCustomCSS: (e, t) => {
      e.customCSS = t.payload;
    },
    setEnabledFeatures: (e, t) => {
      e.enabledFeatures = t.payload;
    },
    setShowPositionModal: (e, t) => {
      e.showPositionModal = t.payload;
    },
    resetRetorikStore: () => ({ ...w0 })
  },
  extraReducers: (e) => {
    e.addCase(tb.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    }));
  }
}), tb = Ae("retorik/setAgentData", async (e) => {
  const t = await oI();
  let r = !1;
  t.tier > 0 && (t.type === "FALLBACK" ? r = !0 : r = t.tier > 1);
  const i = typeof e == "string" ? e : e.url;
  let n = await y0(i);
  return n != null && n.useBodyEngineThree && !r && (console.log("Retorik Framework > graphic capacity too low to use bodyengine, the application will switch to spiritengine"), n = await y0((n == null ? void 0 : n.gender) === "female" ? aI : sI)), n && typeof e != "string" && (e.name && (n.name = e.name), e.animationsUrl && (n.animationsUrl = e.animationsUrl), e.portrait && (n.portrait = e.portrait)), { gpuData: t, agentData: n };
}), Bt = Ae("retorik/setIsWaitingForResponse", async (e, t) => {
  e ? (Br = setTimeout(() => {
    t.dispatch(_0(!0)), Br = null;
  }, 1e3), t.dispatch(k0(!0))) : (Br && clearTimeout(Br), Br = null, t.dispatch(k0(!1)), t.dispatch(_0(!1)));
}), uI = eb.reducer, {
  setConfiguration: cI,
  setAddressData: lI,
  focusSendBox: dI,
  setCanFocusSendBox: fI,
  setSendBoxPlaceHolder: rb,
  setLayout: hI,
  setUserAlreadySet: pI,
  setEnvironmentPreset: mI,
  setFromTextToVocal: gI,
  setLoaderClosed: bI,
  setAppAvailable: vI,
  setSubtitlesInConfiguration: yI,
  setDisplaySubtitles: wI,
  toggleSubtitles: _I,
  setInternalIsWaitingForResponse: _0,
  setInstantIsWaitingForResponse: k0,
  setSkipLoader: kI,
  setDisplayAgentInNews: xI,
  setSubmitDelayBeforeSendingMessage: nb,
  setCustomScripts: SI,
  setCustomCSS: EI,
  setEnabledFeatures: AI,
  setShowPositionModal: TI,
  resetRetorikStore: CI
} = eb.actions, RI = "application/vnd.microsoft.card.adaptive", OI = "application/vnd.microsoft.card.hero", DI = "application/vnd.davi.retorik.card.image", yc = "application/vnd.davi.retorik.card.link", PI = "application/vnd.davi.retorik.card.suggestion", II = "application/vnd.davi.retorik.card.suggestedaction", MI = "application/vnd.davi.retorik.card.counter", jI = "application/vnd.davi.retorik.card.namedlistitem", x0 = {};
function FI(e) {
  let t = x0[e];
  if (t)
    return t;
  t = x0[e] = [];
  for (let r = 0; r < 128; r++) {
    const i = String.fromCharCode(r);
    t.push(i);
  }
  for (let r = 0; r < e.length; r++) {
    const i = e.charCodeAt(r);
    t[i] = "%" + ("0" + i.toString(16).toUpperCase()).slice(-2);
  }
  return t;
}
function Xt(e, t) {
  typeof t != "string" && (t = Xt.defaultChars);
  const r = FI(t);
  return e.replace(/(%[a-f0-9]{2})+/gi, function(i) {
    let n = "";
    for (let o = 0, s = i.length; o < s; o += 3) {
      const a = parseInt(i.slice(o + 1, o + 3), 16);
      if (a < 128) {
        n += r[a];
        continue;
      }
      if ((a & 224) === 192 && o + 3 < s) {
        const u = parseInt(i.slice(o + 4, o + 6), 16);
        if ((u & 192) === 128) {
          const l = a << 6 & 1984 | u & 63;
          l < 128 ? n += "��" : n += String.fromCharCode(l), o += 3;
          continue;
        }
      }
      if ((a & 240) === 224 && o + 6 < s) {
        const u = parseInt(i.slice(o + 4, o + 6), 16), l = parseInt(i.slice(o + 7, o + 9), 16);
        if ((u & 192) === 128 && (l & 192) === 128) {
          const c = a << 12 & 61440 | u << 6 & 4032 | l & 63;
          c < 2048 || c >= 55296 && c <= 57343 ? n += "���" : n += String.fromCharCode(c), o += 6;
          continue;
        }
      }
      if ((a & 248) === 240 && o + 9 < s) {
        const u = parseInt(i.slice(o + 4, o + 6), 16), l = parseInt(i.slice(o + 7, o + 9), 16), c = parseInt(i.slice(o + 10, o + 12), 16);
        if ((u & 192) === 128 && (l & 192) === 128 && (c & 192) === 128) {
          let d = a << 18 & 1835008 | u << 12 & 258048 | l << 6 & 4032 | c & 63;
          d < 65536 || d > 1114111 ? n += "����" : (d -= 65536, n += String.fromCharCode(55296 + (d >> 10), 56320 + (d & 1023))), o += 9;
          continue;
        }
      }
      n += "�";
    }
    return n;
  });
}
Xt.defaultChars = ";/?:@&=+$,#";
Xt.componentChars = "";
const S0 = {};
function $I(e) {
  let t = S0[e];
  if (t)
    return t;
  t = S0[e] = [];
  for (let r = 0; r < 128; r++) {
    const i = String.fromCharCode(r);
    /^[0-9a-z]$/i.test(i) ? t.push(i) : t.push("%" + ("0" + r.toString(16).toUpperCase()).slice(-2));
  }
  for (let r = 0; r < e.length; r++)
    t[e.charCodeAt(r)] = e[r];
  return t;
}
function hn(e, t, r) {
  typeof t != "string" && (r = t, t = hn.defaultChars), typeof r > "u" && (r = !0);
  const i = $I(t);
  let n = "";
  for (let o = 0, s = e.length; o < s; o++) {
    const a = e.charCodeAt(o);
    if (r && a === 37 && o + 2 < s && /^[0-9a-f]{2}$/i.test(e.slice(o + 1, o + 3))) {
      n += e.slice(o, o + 3), o += 2;
      continue;
    }
    if (a < 128) {
      n += i[a];
      continue;
    }
    if (a >= 55296 && a <= 57343) {
      if (a >= 55296 && a <= 56319 && o + 1 < s) {
        const u = e.charCodeAt(o + 1);
        if (u >= 56320 && u <= 57343) {
          n += encodeURIComponent(e[o] + e[o + 1]), o++;
          continue;
        }
      }
      n += "%EF%BF%BD";
      continue;
    }
    n += encodeURIComponent(e[o]);
  }
  return n;
}
hn.defaultChars = ";/?:@&=+$,-_.!~*'()#";
hn.componentChars = "-_.!~*'()";
function wc(e) {
  let t = "";
  return t += e.protocol || "", t += e.slashes ? "//" : "", t += e.auth ? e.auth + "@" : "", e.hostname && e.hostname.indexOf(":") !== -1 ? t += "[" + e.hostname + "]" : t += e.hostname || "", t += e.port ? ":" + e.port : "", t += e.pathname || "", t += e.search || "", t += e.hash || "", t;
}
function qn() {
  this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
const LI = /^([a-z0-9.+-]+:)/i, NI = /:[0-9]*$/, BI = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, qI = ["<", ">", '"', "`", " ", "\r", `
`, "	"], zI = ["{", "}", "|", "\\", "^", "`"].concat(qI), UI = ["'"].concat(zI), E0 = ["%", "/", "?", ";", "#"].concat(UI), A0 = ["/", "?", "#"], VI = 255, T0 = /^[+a-z0-9A-Z_-]{0,63}$/, GI = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, C0 = {
  javascript: !0,
  "javascript:": !0
}, R0 = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
};
function _c(e, t) {
  if (e && e instanceof qn) return e;
  const r = new qn();
  return r.parse(e, t), r;
}
qn.prototype.parse = function(e, t) {
  let r, i, n, o = e;
  if (o = o.trim(), !t && e.split("#").length === 1) {
    const l = BI.exec(o);
    if (l)
      return this.pathname = l[1], l[2] && (this.search = l[2]), this;
  }
  let s = LI.exec(o);
  if (s && (s = s[0], r = s.toLowerCase(), this.protocol = s, o = o.substr(s.length)), (t || s || o.match(/^\/\/[^@\/]+@[^@\/]+/)) && (n = o.substr(0, 2) === "//", n && !(s && C0[s]) && (o = o.substr(2), this.slashes = !0)), !C0[s] && (n || s && !R0[s])) {
    let l = -1;
    for (let p = 0; p < A0.length; p++)
      i = o.indexOf(A0[p]), i !== -1 && (l === -1 || i < l) && (l = i);
    let c, d;
    l === -1 ? d = o.lastIndexOf("@") : d = o.lastIndexOf("@", l), d !== -1 && (c = o.slice(0, d), o = o.slice(d + 1), this.auth = c), l = -1;
    for (let p = 0; p < E0.length; p++)
      i = o.indexOf(E0[p]), i !== -1 && (l === -1 || i < l) && (l = i);
    l === -1 && (l = o.length), o[l - 1] === ":" && l--;
    const h = o.slice(0, l);
    o = o.slice(l), this.parseHost(h), this.hostname = this.hostname || "";
    const f = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!f) {
      const p = this.hostname.split(/\./);
      for (let m = 0, w = p.length; m < w; m++) {
        const v = p[m];
        if (v && !v.match(T0)) {
          let g = "";
          for (let A = 0, b = v.length; A < b; A++)
            v.charCodeAt(A) > 127 ? g += "x" : g += v[A];
          if (!g.match(T0)) {
            const A = p.slice(0, m), b = p.slice(m + 1), k = v.match(GI);
            k && (A.push(k[1]), b.unshift(k[2])), b.length && (o = b.join(".") + o), this.hostname = A.join(".");
            break;
          }
        }
      }
    }
    this.hostname.length > VI && (this.hostname = ""), f && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
  }
  const a = o.indexOf("#");
  a !== -1 && (this.hash = o.substr(a), o = o.slice(0, a));
  const u = o.indexOf("?");
  return u !== -1 && (this.search = o.substr(u), o = o.slice(0, u)), o && (this.pathname = o), R0[r] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
qn.prototype.parseHost = function(e) {
  let t = NI.exec(e);
  t && (t = t[0], t !== ":" && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
};
const WI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: Xt,
  encode: hn,
  format: wc,
  parse: _c
}, Symbol.toStringTag, { value: "Module" })), ib = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, ob = /[\0-\x1F\x7F-\x9F]/, HI = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/, kc = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, ab = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/, sb = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/, KI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any: ib,
  Cc: ob,
  Cf: HI,
  P: kc,
  S: ab,
  Z: sb
}, Symbol.toStringTag, { value: "Module" })), QI = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((e) => e.charCodeAt(0))
), YI = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((e) => e.charCodeAt(0))
);
var Bs;
const JI = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), ZI = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (Bs = String.fromCodePoint) !== null && Bs !== void 0 ? Bs : function(e) {
    let t = "";
    return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | e & 1023), t += String.fromCharCode(e), t;
  }
);
function XI(e) {
  var t;
  return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : (t = JI.get(e)) !== null && t !== void 0 ? t : e;
}
var Fe;
(function(e) {
  e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
})(Fe || (Fe = {}));
const eM = 32;
var At;
(function(e) {
  e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
})(At || (At = {}));
function Du(e) {
  return e >= Fe.ZERO && e <= Fe.NINE;
}
function tM(e) {
  return e >= Fe.UPPER_A && e <= Fe.UPPER_F || e >= Fe.LOWER_A && e <= Fe.LOWER_F;
}
function rM(e) {
  return e >= Fe.UPPER_A && e <= Fe.UPPER_Z || e >= Fe.LOWER_A && e <= Fe.LOWER_Z || Du(e);
}
function nM(e) {
  return e === Fe.EQUALS || rM(e);
}
var Me;
(function(e) {
  e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
})(Me || (Me = {}));
var Et;
(function(e) {
  e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
})(Et || (Et = {}));
class iM {
  constructor(t, r, i) {
    this.decodeTree = t, this.emitCodePoint = r, this.errors = i, this.state = Me.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = Et.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(t) {
    this.decodeMode = t, this.state = Me.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(t, r) {
    switch (this.state) {
      case Me.EntityStart:
        return t.charCodeAt(r) === Fe.NUM ? (this.state = Me.NumericStart, this.consumed += 1, this.stateNumericStart(t, r + 1)) : (this.state = Me.NamedEntity, this.stateNamedEntity(t, r));
      case Me.NumericStart:
        return this.stateNumericStart(t, r);
      case Me.NumericDecimal:
        return this.stateNumericDecimal(t, r);
      case Me.NumericHex:
        return this.stateNumericHex(t, r);
      case Me.NamedEntity:
        return this.stateNamedEntity(t, r);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(t, r) {
    return r >= t.length ? -1 : (t.charCodeAt(r) | eM) === Fe.LOWER_X ? (this.state = Me.NumericHex, this.consumed += 1, this.stateNumericHex(t, r + 1)) : (this.state = Me.NumericDecimal, this.stateNumericDecimal(t, r));
  }
  addToNumericResult(t, r, i, n) {
    if (r !== i) {
      const o = i - r;
      this.result = this.result * Math.pow(n, o) + parseInt(t.substr(r, o), n), this.consumed += o;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(t, r) {
    const i = r;
    for (; r < t.length; ) {
      const n = t.charCodeAt(r);
      if (Du(n) || tM(n))
        r += 1;
      else
        return this.addToNumericResult(t, i, r, 16), this.emitNumericEntity(n, 3);
    }
    return this.addToNumericResult(t, i, r, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(t, r) {
    const i = r;
    for (; r < t.length; ) {
      const n = t.charCodeAt(r);
      if (Du(n))
        r += 1;
      else
        return this.addToNumericResult(t, i, r, 10), this.emitNumericEntity(n, 2);
    }
    return this.addToNumericResult(t, i, r, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(t, r) {
    var i;
    if (this.consumed <= r)
      return (i = this.errors) === null || i === void 0 || i.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (t === Fe.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === Et.Strict)
      return 0;
    return this.emitCodePoint(XI(this.result), this.consumed), this.errors && (t !== Fe.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(t, r) {
    const { decodeTree: i } = this;
    let n = i[this.treeIndex], o = (n & At.VALUE_LENGTH) >> 14;
    for (; r < t.length; r++, this.excess++) {
      const s = t.charCodeAt(r);
      if (this.treeIndex = oM(i, n, this.treeIndex + Math.max(1, o), s), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === Et.Attribute && // We shouldn't have consumed any characters after the entity,
        (o === 0 || // And there should be no invalid characters.
        nM(s)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (n = i[this.treeIndex], o = (n & At.VALUE_LENGTH) >> 14, o !== 0) {
        if (s === Fe.SEMI)
          return this.emitNamedEntityData(this.treeIndex, o, this.consumed + this.excess);
        this.decodeMode !== Et.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var t;
    const { result: r, decodeTree: i } = this, n = (i[r] & At.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(r, n, this.consumed), (t = this.errors) === null || t === void 0 || t.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(t, r, i) {
    const { decodeTree: n } = this;
    return this.emitCodePoint(r === 1 ? n[t] & ~At.VALUE_LENGTH : n[t + 1], i), r === 3 && this.emitCodePoint(n[t + 2], i), i;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var t;
    switch (this.state) {
      case Me.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== Et.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case Me.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case Me.NumericHex:
        return this.emitNumericEntity(0, 3);
      case Me.NumericStart:
        return (t = this.errors) === null || t === void 0 || t.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case Me.EntityStart:
        return 0;
    }
  }
}
function ub(e) {
  let t = "";
  const r = new iM(e, (i) => t += ZI(i));
  return function(n, o) {
    let s = 0, a = 0;
    for (; (a = n.indexOf("&", a)) >= 0; ) {
      t += n.slice(s, a), r.startEntity(o);
      const l = r.write(
        n,
        // Skip the "&"
        a + 1
      );
      if (l < 0) {
        s = a + r.end();
        break;
      }
      s = a + l, a = l === 0 ? s + 1 : s;
    }
    const u = t + n.slice(s);
    return t = "", u;
  };
}
function oM(e, t, r, i) {
  const n = (t & At.BRANCH_LENGTH) >> 7, o = t & At.JUMP_TABLE;
  if (n === 0)
    return o !== 0 && i === o ? r : -1;
  if (o) {
    const u = i - o;
    return u < 0 || u >= n ? -1 : e[r + u] - 1;
  }
  let s = r, a = s + n - 1;
  for (; s <= a; ) {
    const u = s + a >>> 1, l = e[u];
    if (l < i)
      s = u + 1;
    else if (l > i)
      a = u - 1;
    else
      return e[u + n];
  }
  return -1;
}
const aM = ub(QI);
ub(YI);
function cb(e, t = Et.Legacy) {
  return aM(e, t);
}
function sM(e) {
  return Object.prototype.toString.call(e);
}
function xc(e) {
  return sM(e) === "[object String]";
}
const uM = Object.prototype.hasOwnProperty;
function cM(e, t) {
  return uM.call(e, t);
}
function ci(e) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(r) {
    if (r) {
      if (typeof r != "object")
        throw new TypeError(r + "must be object");
      Object.keys(r).forEach(function(i) {
        e[i] = r[i];
      });
    }
  }), e;
}
function lb(e, t, r) {
  return [].concat(e.slice(0, t), r, e.slice(t + 1));
}
function Sc(e) {
  return !(e >= 55296 && e <= 57343 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534 || e >= 0 && e <= 8 || e === 11 || e >= 14 && e <= 31 || e >= 127 && e <= 159 || e > 1114111);
}
function zn(e) {
  if (e > 65535) {
    e -= 65536;
    const t = 55296 + (e >> 10), r = 56320 + (e & 1023);
    return String.fromCharCode(t, r);
  }
  return String.fromCharCode(e);
}
const db = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, lM = /&([a-z#][a-z0-9]{1,31});/gi, dM = new RegExp(db.source + "|" + lM.source, "gi"), fM = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function hM(e, t) {
  if (t.charCodeAt(0) === 35 && fM.test(t)) {
    const i = t[1].toLowerCase() === "x" ? parseInt(t.slice(2), 16) : parseInt(t.slice(1), 10);
    return Sc(i) ? zn(i) : e;
  }
  const r = cb(e);
  return r !== e ? r : e;
}
function pM(e) {
  return e.indexOf("\\") < 0 ? e : e.replace(db, "$1");
}
function er(e) {
  return e.indexOf("\\") < 0 && e.indexOf("&") < 0 ? e : e.replace(dM, function(t, r, i) {
    return r || hM(t, i);
  });
}
const mM = /[&<>"]/, gM = /[&<>"]/g, bM = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;"
};
function vM(e) {
  return bM[e];
}
function Tt(e) {
  return mM.test(e) ? e.replace(gM, vM) : e;
}
const yM = /[.?*+^$[\]\\(){}|-]/g;
function wM(e) {
  return e.replace(yM, "\\$&");
}
function Oe(e) {
  switch (e) {
    case 9:
    case 32:
      return !0;
  }
  return !1;
}
function Zr(e) {
  if (e >= 8192 && e <= 8202)
    return !0;
  switch (e) {
    case 9:
    // \t
    case 10:
    // \n
    case 11:
    // \v
    case 12:
    // \f
    case 13:
    // \r
    case 32:
    case 160:
    case 5760:
    case 8239:
    case 8287:
    case 12288:
      return !0;
  }
  return !1;
}
function Xr(e) {
  return kc.test(e) || ab.test(e);
}
function en(e) {
  switch (e) {
    case 33:
    case 34:
    case 35:
    case 36:
    case 37:
    case 38:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
    case 47:
    case 58:
    case 59:
    case 60:
    case 61:
    case 62:
    case 63:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 124:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function li(e) {
  return e = e.trim().replace(/\s+/g, " "), "ẞ".toLowerCase() === "Ṿ" && (e = e.replace(/ẞ/g, "ß")), e.toLowerCase().toUpperCase();
}
const _M = { mdurl: WI, ucmicro: KI }, kM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayReplaceAt: lb,
  assign: ci,
  escapeHtml: Tt,
  escapeRE: wM,
  fromCodePoint: zn,
  has: cM,
  isMdAsciiPunct: en,
  isPunctChar: Xr,
  isSpace: Oe,
  isString: xc,
  isValidEntityCode: Sc,
  isWhiteSpace: Zr,
  lib: _M,
  normalizeReference: li,
  unescapeAll: er,
  unescapeMd: pM
}, Symbol.toStringTag, { value: "Module" }));
function xM(e, t, r) {
  let i, n, o, s;
  const a = e.posMax, u = e.pos;
  for (e.pos = t + 1, i = 1; e.pos < a; ) {
    if (o = e.src.charCodeAt(e.pos), o === 93 && (i--, i === 0)) {
      n = !0;
      break;
    }
    if (s = e.pos, e.md.inline.skipToken(e), o === 91) {
      if (s === e.pos - 1)
        i++;
      else if (r)
        return e.pos = u, -1;
    }
  }
  let l = -1;
  return n && (l = e.pos), e.pos = u, l;
}
function SM(e, t, r) {
  let i, n = t;
  const o = {
    ok: !1,
    pos: 0,
    str: ""
  };
  if (e.charCodeAt(n) === 60) {
    for (n++; n < r; ) {
      if (i = e.charCodeAt(n), i === 10 || i === 60)
        return o;
      if (i === 62)
        return o.pos = n + 1, o.str = er(e.slice(t + 1, n)), o.ok = !0, o;
      if (i === 92 && n + 1 < r) {
        n += 2;
        continue;
      }
      n++;
    }
    return o;
  }
  let s = 0;
  for (; n < r && (i = e.charCodeAt(n), !(i === 32 || i < 32 || i === 127)); ) {
    if (i === 92 && n + 1 < r) {
      if (e.charCodeAt(n + 1) === 32)
        break;
      n += 2;
      continue;
    }
    if (i === 40 && (s++, s > 32))
      return o;
    if (i === 41) {
      if (s === 0)
        break;
      s--;
    }
    n++;
  }
  return t === n || s !== 0 || (o.str = er(e.slice(t, n)), o.pos = n, o.ok = !0), o;
}
function EM(e, t, r, i) {
  let n, o = t;
  const s = {
    // if `true`, this is a valid link title
    ok: !1,
    // if `true`, this link can be continued on the next line
    can_continue: !1,
    // if `ok`, it's the position of the first character after the closing marker
    pos: 0,
    // if `ok`, it's the unescaped title
    str: "",
    // expected closing marker character code
    marker: 0
  };
  if (i)
    s.str = i.str, s.marker = i.marker;
  else {
    if (o >= r)
      return s;
    let a = e.charCodeAt(o);
    if (a !== 34 && a !== 39 && a !== 40)
      return s;
    t++, o++, a === 40 && (a = 41), s.marker = a;
  }
  for (; o < r; ) {
    if (n = e.charCodeAt(o), n === s.marker)
      return s.pos = o + 1, s.str += er(e.slice(t, o)), s.ok = !0, s;
    if (n === 40 && s.marker === 41)
      return s;
    n === 92 && o + 1 < r && o++, o++;
  }
  return s.can_continue = !0, s.str += er(e.slice(t, o)), s;
}
const AM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  parseLinkDestination: SM,
  parseLinkLabel: xM,
  parseLinkTitle: EM
}, Symbol.toStringTag, { value: "Module" })), ct = {};
ct.code_inline = function(e, t, r, i, n) {
  const o = e[t];
  return "<code" + n.renderAttrs(o) + ">" + Tt(o.content) + "</code>";
};
ct.code_block = function(e, t, r, i, n) {
  const o = e[t];
  return "<pre" + n.renderAttrs(o) + "><code>" + Tt(e[t].content) + `</code></pre>
`;
};
ct.fence = function(e, t, r, i, n) {
  const o = e[t], s = o.info ? er(o.info).trim() : "";
  let a = "", u = "";
  if (s) {
    const c = s.split(/(\s+)/g);
    a = c[0], u = c.slice(2).join("");
  }
  let l;
  if (r.highlight ? l = r.highlight(o.content, a, u) || Tt(o.content) : l = Tt(o.content), l.indexOf("<pre") === 0)
    return l + `
`;
  if (s) {
    const c = o.attrIndex("class"), d = o.attrs ? o.attrs.slice() : [];
    c < 0 ? d.push(["class", r.langPrefix + a]) : (d[c] = d[c].slice(), d[c][1] += " " + r.langPrefix + a);
    const h = {
      attrs: d
    };
    return `<pre><code${n.renderAttrs(h)}>${l}</code></pre>
`;
  }
  return `<pre><code${n.renderAttrs(o)}>${l}</code></pre>
`;
};
ct.image = function(e, t, r, i, n) {
  const o = e[t];
  return o.attrs[o.attrIndex("alt")][1] = n.renderInlineAsText(o.children, r, i), n.renderToken(e, t, r);
};
ct.hardbreak = function(e, t, r) {
  return r.xhtmlOut ? `<br />
` : `<br>
`;
};
ct.softbreak = function(e, t, r) {
  return r.breaks ? r.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
ct.text = function(e, t) {
  return Tt(e[t].content);
};
ct.html_block = function(e, t) {
  return e[t].content;
};
ct.html_inline = function(e, t) {
  return e[t].content;
};
function ur() {
  this.rules = ci({}, ct);
}
ur.prototype.renderAttrs = function(t) {
  let r, i, n;
  if (!t.attrs)
    return "";
  for (n = "", r = 0, i = t.attrs.length; r < i; r++)
    n += " " + Tt(t.attrs[r][0]) + '="' + Tt(t.attrs[r][1]) + '"';
  return n;
};
ur.prototype.renderToken = function(t, r, i) {
  const n = t[r];
  let o = "";
  if (n.hidden)
    return "";
  n.block && n.nesting !== -1 && r && t[r - 1].hidden && (o += `
`), o += (n.nesting === -1 ? "</" : "<") + n.tag, o += this.renderAttrs(n), n.nesting === 0 && i.xhtmlOut && (o += " /");
  let s = !1;
  if (n.block && (s = !0, n.nesting === 1 && r + 1 < t.length)) {
    const a = t[r + 1];
    (a.type === "inline" || a.hidden || a.nesting === -1 && a.tag === n.tag) && (s = !1);
  }
  return o += s ? `>
` : ">", o;
};
ur.prototype.renderInline = function(e, t, r) {
  let i = "";
  const n = this.rules;
  for (let o = 0, s = e.length; o < s; o++) {
    const a = e[o].type;
    typeof n[a] < "u" ? i += n[a](e, o, t, r, this) : i += this.renderToken(e, o, t);
  }
  return i;
};
ur.prototype.renderInlineAsText = function(e, t, r) {
  let i = "";
  for (let n = 0, o = e.length; n < o; n++)
    switch (e[n].type) {
      case "text":
        i += e[n].content;
        break;
      case "image":
        i += this.renderInlineAsText(e[n].children, t, r);
        break;
      case "html_inline":
      case "html_block":
        i += e[n].content;
        break;
      case "softbreak":
      case "hardbreak":
        i += `
`;
        break;
    }
  return i;
};
ur.prototype.render = function(e, t, r) {
  let i = "";
  const n = this.rules;
  for (let o = 0, s = e.length; o < s; o++) {
    const a = e[o].type;
    a === "inline" ? i += this.renderInline(e[o].children, t, r) : typeof n[a] < "u" ? i += n[a](e, o, t, r, this) : i += this.renderToken(e, o, t, r);
  }
  return i;
};
function Ve() {
  this.__rules__ = [], this.__cache__ = null;
}
Ve.prototype.__find__ = function(e) {
  for (let t = 0; t < this.__rules__.length; t++)
    if (this.__rules__[t].name === e)
      return t;
  return -1;
};
Ve.prototype.__compile__ = function() {
  const e = this, t = [""];
  e.__rules__.forEach(function(r) {
    r.enabled && r.alt.forEach(function(i) {
      t.indexOf(i) < 0 && t.push(i);
    });
  }), e.__cache__ = {}, t.forEach(function(r) {
    e.__cache__[r] = [], e.__rules__.forEach(function(i) {
      i.enabled && (r && i.alt.indexOf(r) < 0 || e.__cache__[r].push(i.fn));
    });
  });
};
Ve.prototype.at = function(e, t, r) {
  const i = this.__find__(e), n = r || {};
  if (i === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__[i].fn = t, this.__rules__[i].alt = n.alt || [], this.__cache__ = null;
};
Ve.prototype.before = function(e, t, r, i) {
  const n = this.__find__(e), o = i || {};
  if (n === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(n, 0, {
    name: t,
    enabled: !0,
    fn: r,
    alt: o.alt || []
  }), this.__cache__ = null;
};
Ve.prototype.after = function(e, t, r, i) {
  const n = this.__find__(e), o = i || {};
  if (n === -1)
    throw new Error("Parser rule not found: " + e);
  this.__rules__.splice(n + 1, 0, {
    name: t,
    enabled: !0,
    fn: r,
    alt: o.alt || []
  }), this.__cache__ = null;
};
Ve.prototype.push = function(e, t, r) {
  const i = r || {};
  this.__rules__.push({
    name: e,
    enabled: !0,
    fn: t,
    alt: i.alt || []
  }), this.__cache__ = null;
};
Ve.prototype.enable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  const r = [];
  return e.forEach(function(i) {
    const n = this.__find__(i);
    if (n < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + i);
    }
    this.__rules__[n].enabled = !0, r.push(i);
  }, this), this.__cache__ = null, r;
};
Ve.prototype.enableOnly = function(e, t) {
  Array.isArray(e) || (e = [e]), this.__rules__.forEach(function(r) {
    r.enabled = !1;
  }), this.enable(e, t);
};
Ve.prototype.disable = function(e, t) {
  Array.isArray(e) || (e = [e]);
  const r = [];
  return e.forEach(function(i) {
    const n = this.__find__(i);
    if (n < 0) {
      if (t)
        return;
      throw new Error("Rules manager: invalid rule name " + i);
    }
    this.__rules__[n].enabled = !1, r.push(i);
  }, this), this.__cache__ = null, r;
};
Ve.prototype.getRules = function(e) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[e] || [];
};
function et(e, t, r) {
  this.type = e, this.tag = t, this.attrs = null, this.map = null, this.nesting = r, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
et.prototype.attrIndex = function(t) {
  if (!this.attrs)
    return -1;
  const r = this.attrs;
  for (let i = 0, n = r.length; i < n; i++)
    if (r[i][0] === t)
      return i;
  return -1;
};
et.prototype.attrPush = function(t) {
  this.attrs ? this.attrs.push(t) : this.attrs = [t];
};
et.prototype.attrSet = function(t, r) {
  const i = this.attrIndex(t), n = [t, r];
  i < 0 ? this.attrPush(n) : this.attrs[i] = n;
};
et.prototype.attrGet = function(t) {
  const r = this.attrIndex(t);
  let i = null;
  return r >= 0 && (i = this.attrs[r][1]), i;
};
et.prototype.attrJoin = function(t, r) {
  const i = this.attrIndex(t);
  i < 0 ? this.attrPush([t, r]) : this.attrs[i][1] = this.attrs[i][1] + " " + r;
};
function fb(e, t, r) {
  this.src = e, this.env = r, this.tokens = [], this.inlineMode = !1, this.md = t;
}
fb.prototype.Token = et;
const TM = /\r\n?|\n/g, CM = /\0/g;
function RM(e) {
  let t;
  t = e.src.replace(TM, `
`), t = t.replace(CM, "�"), e.src = t;
}
function OM(e) {
  let t;
  e.inlineMode ? (t = new e.Token("inline", "", 0), t.content = e.src, t.map = [0, 1], t.children = [], e.tokens.push(t)) : e.md.block.parse(e.src, e.md, e.env, e.tokens);
}
function DM(e) {
  const t = e.tokens;
  for (let r = 0, i = t.length; r < i; r++) {
    const n = t[r];
    n.type === "inline" && e.md.inline.parse(n.content, e.md, e.env, n.children);
  }
}
function PM(e) {
  return /^<a[>\s]/i.test(e);
}
function IM(e) {
  return /^<\/a\s*>/i.test(e);
}
function MM(e) {
  const t = e.tokens;
  if (e.md.options.linkify)
    for (let r = 0, i = t.length; r < i; r++) {
      if (t[r].type !== "inline" || !e.md.linkify.pretest(t[r].content))
        continue;
      let n = t[r].children, o = 0;
      for (let s = n.length - 1; s >= 0; s--) {
        const a = n[s];
        if (a.type === "link_close") {
          for (s--; n[s].level !== a.level && n[s].type !== "link_open"; )
            s--;
          continue;
        }
        if (a.type === "html_inline" && (PM(a.content) && o > 0 && o--, IM(a.content) && o++), !(o > 0) && a.type === "text" && e.md.linkify.test(a.content)) {
          const u = a.content;
          let l = e.md.linkify.match(u);
          const c = [];
          let d = a.level, h = 0;
          l.length > 0 && l[0].index === 0 && s > 0 && n[s - 1].type === "text_special" && (l = l.slice(1));
          for (let f = 0; f < l.length; f++) {
            const p = l[f].url, m = e.md.normalizeLink(p);
            if (!e.md.validateLink(m))
              continue;
            let w = l[f].text;
            l[f].schema ? l[f].schema === "mailto:" && !/^mailto:/i.test(w) ? w = e.md.normalizeLinkText("mailto:" + w).replace(/^mailto:/, "") : w = e.md.normalizeLinkText(w) : w = e.md.normalizeLinkText("http://" + w).replace(/^http:\/\//, "");
            const v = l[f].index;
            if (v > h) {
              const k = new e.Token("text", "", 0);
              k.content = u.slice(h, v), k.level = d, c.push(k);
            }
            const g = new e.Token("link_open", "a", 1);
            g.attrs = [["href", m]], g.level = d++, g.markup = "linkify", g.info = "auto", c.push(g);
            const A = new e.Token("text", "", 0);
            A.content = w, A.level = d, c.push(A);
            const b = new e.Token("link_close", "a", -1);
            b.level = --d, b.markup = "linkify", b.info = "auto", c.push(b), h = l[f].lastIndex;
          }
          if (h < u.length) {
            const f = new e.Token("text", "", 0);
            f.content = u.slice(h), f.level = d, c.push(f);
          }
          t[r].children = n = lb(n, s, c);
        }
      }
    }
}
const hb = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, jM = /\((c|tm|r)\)/i, FM = /\((c|tm|r)\)/ig, $M = {
  c: "©",
  r: "®",
  tm: "™"
};
function LM(e, t) {
  return $M[t.toLowerCase()];
}
function NM(e) {
  let t = 0;
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r];
    i.type === "text" && !t && (i.content = i.content.replace(FM, LM)), i.type === "link_open" && i.info === "auto" && t--, i.type === "link_close" && i.info === "auto" && t++;
  }
}
function BM(e) {
  let t = 0;
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r];
    i.type === "text" && !t && hb.test(i.content) && (i.content = i.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—").replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–")), i.type === "link_open" && i.info === "auto" && t--, i.type === "link_close" && i.info === "auto" && t++;
  }
}
function qM(e) {
  let t;
  if (e.md.options.typographer)
    for (t = e.tokens.length - 1; t >= 0; t--)
      e.tokens[t].type === "inline" && (jM.test(e.tokens[t].content) && NM(e.tokens[t].children), hb.test(e.tokens[t].content) && BM(e.tokens[t].children));
}
const zM = /['"]/, O0 = /['"]/g, D0 = "’";
function Tn(e, t, r) {
  return e.slice(0, t) + r + e.slice(t + 1);
}
function UM(e, t) {
  let r;
  const i = [];
  for (let n = 0; n < e.length; n++) {
    const o = e[n], s = e[n].level;
    for (r = i.length - 1; r >= 0 && !(i[r].level <= s); r--)
      ;
    if (i.length = r + 1, o.type !== "text")
      continue;
    let a = o.content, u = 0, l = a.length;
    e:
      for (; u < l; ) {
        O0.lastIndex = u;
        const c = O0.exec(a);
        if (!c)
          break;
        let d = !0, h = !0;
        u = c.index + 1;
        const f = c[0] === "'";
        let p = 32;
        if (c.index - 1 >= 0)
          p = a.charCodeAt(c.index - 1);
        else
          for (r = n - 1; r >= 0 && !(e[r].type === "softbreak" || e[r].type === "hardbreak"); r--)
            if (e[r].content) {
              p = e[r].content.charCodeAt(e[r].content.length - 1);
              break;
            }
        let m = 32;
        if (u < l)
          m = a.charCodeAt(u);
        else
          for (r = n + 1; r < e.length && !(e[r].type === "softbreak" || e[r].type === "hardbreak"); r++)
            if (e[r].content) {
              m = e[r].content.charCodeAt(0);
              break;
            }
        const w = en(p) || Xr(String.fromCharCode(p)), v = en(m) || Xr(String.fromCharCode(m)), g = Zr(p), A = Zr(m);
        if (A ? d = !1 : v && (g || w || (d = !1)), g ? h = !1 : w && (A || v || (h = !1)), m === 34 && c[0] === '"' && p >= 48 && p <= 57 && (h = d = !1), d && h && (d = w, h = v), !d && !h) {
          f && (o.content = Tn(o.content, c.index, D0));
          continue;
        }
        if (h)
          for (r = i.length - 1; r >= 0; r--) {
            let b = i[r];
            if (i[r].level < s)
              break;
            if (b.single === f && i[r].level === s) {
              b = i[r];
              let k, y;
              f ? (k = t.md.options.quotes[2], y = t.md.options.quotes[3]) : (k = t.md.options.quotes[0], y = t.md.options.quotes[1]), o.content = Tn(o.content, c.index, y), e[b.token].content = Tn(
                e[b.token].content,
                b.pos,
                k
              ), u += y.length - 1, b.token === n && (u += k.length - 1), a = o.content, l = a.length, i.length = r;
              continue e;
            }
          }
        d ? i.push({
          token: n,
          pos: c.index,
          single: f,
          level: s
        }) : h && f && (o.content = Tn(o.content, c.index, D0));
      }
  }
}
function VM(e) {
  if (e.md.options.typographer)
    for (let t = e.tokens.length - 1; t >= 0; t--)
      e.tokens[t].type !== "inline" || !zM.test(e.tokens[t].content) || UM(e.tokens[t].children, e);
}
function GM(e) {
  let t, r;
  const i = e.tokens, n = i.length;
  for (let o = 0; o < n; o++) {
    if (i[o].type !== "inline") continue;
    const s = i[o].children, a = s.length;
    for (t = 0; t < a; t++)
      s[t].type === "text_special" && (s[t].type = "text");
    for (t = r = 0; t < a; t++)
      s[t].type === "text" && t + 1 < a && s[t + 1].type === "text" ? s[t + 1].content = s[t].content + s[t + 1].content : (t !== r && (s[r] = s[t]), r++);
    t !== r && (s.length = r);
  }
}
const qs = [
  ["normalize", RM],
  ["block", OM],
  ["inline", DM],
  ["linkify", MM],
  ["replacements", qM],
  ["smartquotes", VM],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  ["text_join", GM]
];
function Ec() {
  this.ruler = new Ve();
  for (let e = 0; e < qs.length; e++)
    this.ruler.push(qs[e][0], qs[e][1]);
}
Ec.prototype.process = function(e) {
  const t = this.ruler.getRules("");
  for (let r = 0, i = t.length; r < i; r++)
    t[r](e);
};
Ec.prototype.State = fb;
function lt(e, t, r, i) {
  this.src = e, this.md = t, this.env = r, this.tokens = i, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
  const n = this.src;
  for (let o = 0, s = 0, a = 0, u = 0, l = n.length, c = !1; s < l; s++) {
    const d = n.charCodeAt(s);
    if (!c)
      if (Oe(d)) {
        a++, d === 9 ? u += 4 - u % 4 : u++;
        continue;
      } else
        c = !0;
    (d === 10 || s === l - 1) && (d !== 10 && s++, this.bMarks.push(o), this.eMarks.push(s), this.tShift.push(a), this.sCount.push(u), this.bsCount.push(0), c = !1, a = 0, u = 0, o = s + 1);
  }
  this.bMarks.push(n.length), this.eMarks.push(n.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
lt.prototype.push = function(e, t, r) {
  const i = new et(e, t, r);
  return i.block = !0, r < 0 && this.level--, i.level = this.level, r > 0 && this.level++, this.tokens.push(i), i;
};
lt.prototype.isEmpty = function(t) {
  return this.bMarks[t] + this.tShift[t] >= this.eMarks[t];
};
lt.prototype.skipEmptyLines = function(t) {
  for (let r = this.lineMax; t < r && !(this.bMarks[t] + this.tShift[t] < this.eMarks[t]); t++)
    ;
  return t;
};
lt.prototype.skipSpaces = function(t) {
  for (let r = this.src.length; t < r; t++) {
    const i = this.src.charCodeAt(t);
    if (!Oe(i))
      break;
  }
  return t;
};
lt.prototype.skipSpacesBack = function(t, r) {
  if (t <= r)
    return t;
  for (; t > r; )
    if (!Oe(this.src.charCodeAt(--t)))
      return t + 1;
  return t;
};
lt.prototype.skipChars = function(t, r) {
  for (let i = this.src.length; t < i && this.src.charCodeAt(t) === r; t++)
    ;
  return t;
};
lt.prototype.skipCharsBack = function(t, r, i) {
  if (t <= i)
    return t;
  for (; t > i; )
    if (r !== this.src.charCodeAt(--t))
      return t + 1;
  return t;
};
lt.prototype.getLines = function(t, r, i, n) {
  if (t >= r)
    return "";
  const o = new Array(r - t);
  for (let s = 0, a = t; a < r; a++, s++) {
    let u = 0;
    const l = this.bMarks[a];
    let c = l, d;
    for (a + 1 < r || n ? d = this.eMarks[a] + 1 : d = this.eMarks[a]; c < d && u < i; ) {
      const h = this.src.charCodeAt(c);
      if (Oe(h))
        h === 9 ? u += 4 - (u + this.bsCount[a]) % 4 : u++;
      else if (c - l < this.tShift[a])
        u++;
      else
        break;
      c++;
    }
    u > i ? o[s] = new Array(u - i + 1).join(" ") + this.src.slice(c, d) : o[s] = this.src.slice(c, d);
  }
  return o.join("");
};
lt.prototype.Token = et;
const WM = 65536;
function zs(e, t) {
  const r = e.bMarks[t] + e.tShift[t], i = e.eMarks[t];
  return e.src.slice(r, i);
}
function P0(e) {
  const t = [], r = e.length;
  let i = 0, n = e.charCodeAt(i), o = !1, s = 0, a = "";
  for (; i < r; )
    n === 124 && (o ? (a += e.substring(s, i - 1), s = i) : (t.push(a + e.substring(s, i)), a = "", s = i + 1)), o = n === 92, i++, n = e.charCodeAt(i);
  return t.push(a + e.substring(s)), t;
}
function HM(e, t, r, i) {
  if (t + 2 > r)
    return !1;
  let n = t + 1;
  if (e.sCount[n] < e.blkIndent || e.sCount[n] - e.blkIndent >= 4)
    return !1;
  let o = e.bMarks[n] + e.tShift[n];
  if (o >= e.eMarks[n])
    return !1;
  const s = e.src.charCodeAt(o++);
  if (s !== 124 && s !== 45 && s !== 58 || o >= e.eMarks[n])
    return !1;
  const a = e.src.charCodeAt(o++);
  if (a !== 124 && a !== 45 && a !== 58 && !Oe(a) || s === 45 && Oe(a))
    return !1;
  for (; o < e.eMarks[n]; ) {
    const b = e.src.charCodeAt(o);
    if (b !== 124 && b !== 45 && b !== 58 && !Oe(b))
      return !1;
    o++;
  }
  let u = zs(e, t + 1), l = u.split("|");
  const c = [];
  for (let b = 0; b < l.length; b++) {
    const k = l[b].trim();
    if (!k) {
      if (b === 0 || b === l.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(k))
      return !1;
    k.charCodeAt(k.length - 1) === 58 ? c.push(k.charCodeAt(0) === 58 ? "center" : "right") : k.charCodeAt(0) === 58 ? c.push("left") : c.push("");
  }
  if (u = zs(e, t).trim(), u.indexOf("|") === -1 || e.sCount[t] - e.blkIndent >= 4)
    return !1;
  l = P0(u), l.length && l[0] === "" && l.shift(), l.length && l[l.length - 1] === "" && l.pop();
  const d = l.length;
  if (d === 0 || d !== c.length)
    return !1;
  if (i)
    return !0;
  const h = e.parentType;
  e.parentType = "table";
  const f = e.md.block.ruler.getRules("blockquote"), p = e.push("table_open", "table", 1), m = [t, 0];
  p.map = m;
  const w = e.push("thead_open", "thead", 1);
  w.map = [t, t + 1];
  const v = e.push("tr_open", "tr", 1);
  v.map = [t, t + 1];
  for (let b = 0; b < l.length; b++) {
    const k = e.push("th_open", "th", 1);
    c[b] && (k.attrs = [["style", "text-align:" + c[b]]]);
    const y = e.push("inline", "", 0);
    y.content = l[b].trim(), y.children = [], e.push("th_close", "th", -1);
  }
  e.push("tr_close", "tr", -1), e.push("thead_close", "thead", -1);
  let g, A = 0;
  for (n = t + 2; n < r && !(e.sCount[n] < e.blkIndent); n++) {
    let b = !1;
    for (let y = 0, x = f.length; y < x; y++)
      if (f[y](e, n, r, !0)) {
        b = !0;
        break;
      }
    if (b || (u = zs(e, n).trim(), !u) || e.sCount[n] - e.blkIndent >= 4 || (l = P0(u), l.length && l[0] === "" && l.shift(), l.length && l[l.length - 1] === "" && l.pop(), A += d - l.length, A > WM))
      break;
    if (n === t + 2) {
      const y = e.push("tbody_open", "tbody", 1);
      y.map = g = [t + 2, 0];
    }
    const k = e.push("tr_open", "tr", 1);
    k.map = [n, n + 1];
    for (let y = 0; y < d; y++) {
      const x = e.push("td_open", "td", 1);
      c[y] && (x.attrs = [["style", "text-align:" + c[y]]]);
      const C = e.push("inline", "", 0);
      C.content = l[y] ? l[y].trim() : "", C.children = [], e.push("td_close", "td", -1);
    }
    e.push("tr_close", "tr", -1);
  }
  return g && (e.push("tbody_close", "tbody", -1), g[1] = n), e.push("table_close", "table", -1), m[1] = n, e.parentType = h, e.line = n, !0;
}
function KM(e, t, r) {
  if (e.sCount[t] - e.blkIndent < 4)
    return !1;
  let i = t + 1, n = i;
  for (; i < r; ) {
    if (e.isEmpty(i)) {
      i++;
      continue;
    }
    if (e.sCount[i] - e.blkIndent >= 4) {
      i++, n = i;
      continue;
    }
    break;
  }
  e.line = n;
  const o = e.push("code_block", "code", 0);
  return o.content = e.getLines(t, n, 4 + e.blkIndent, !1) + `
`, o.map = [t, e.line], !0;
}
function QM(e, t, r, i) {
  let n = e.bMarks[t] + e.tShift[t], o = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4 || n + 3 > o)
    return !1;
  const s = e.src.charCodeAt(n);
  if (s !== 126 && s !== 96)
    return !1;
  let a = n;
  n = e.skipChars(n, s);
  let u = n - a;
  if (u < 3)
    return !1;
  const l = e.src.slice(a, n), c = e.src.slice(n, o);
  if (s === 96 && c.indexOf(String.fromCharCode(s)) >= 0)
    return !1;
  if (i)
    return !0;
  let d = t, h = !1;
  for (; d++, !(d >= r || (n = a = e.bMarks[d] + e.tShift[d], o = e.eMarks[d], n < o && e.sCount[d] < e.blkIndent)); )
    if (e.src.charCodeAt(n) === s && !(e.sCount[d] - e.blkIndent >= 4) && (n = e.skipChars(n, s), !(n - a < u) && (n = e.skipSpaces(n), !(n < o)))) {
      h = !0;
      break;
    }
  u = e.sCount[t], e.line = d + (h ? 1 : 0);
  const f = e.push("fence", "code", 0);
  return f.info = c, f.content = e.getLines(t + 1, d, u, !0), f.markup = l, f.map = [t, e.line], !0;
}
function YM(e, t, r, i) {
  let n = e.bMarks[t] + e.tShift[t], o = e.eMarks[t];
  const s = e.lineMax;
  if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(n) !== 62)
    return !1;
  if (i)
    return !0;
  const a = [], u = [], l = [], c = [], d = e.md.block.ruler.getRules("blockquote"), h = e.parentType;
  e.parentType = "blockquote";
  let f = !1, p;
  for (p = t; p < r; p++) {
    const A = e.sCount[p] < e.blkIndent;
    if (n = e.bMarks[p] + e.tShift[p], o = e.eMarks[p], n >= o)
      break;
    if (e.src.charCodeAt(n++) === 62 && !A) {
      let k = e.sCount[p] + 1, y, x;
      e.src.charCodeAt(n) === 32 ? (n++, k++, x = !1, y = !0) : e.src.charCodeAt(n) === 9 ? (y = !0, (e.bsCount[p] + k) % 4 === 3 ? (n++, k++, x = !1) : x = !0) : y = !1;
      let C = k;
      for (a.push(e.bMarks[p]), e.bMarks[p] = n; n < o; ) {
        const I = e.src.charCodeAt(n);
        if (Oe(I))
          I === 9 ? C += 4 - (C + e.bsCount[p] + (x ? 1 : 0)) % 4 : C++;
        else
          break;
        n++;
      }
      f = n >= o, u.push(e.bsCount[p]), e.bsCount[p] = e.sCount[p] + 1 + (y ? 1 : 0), l.push(e.sCount[p]), e.sCount[p] = C - k, c.push(e.tShift[p]), e.tShift[p] = n - e.bMarks[p];
      continue;
    }
    if (f)
      break;
    let b = !1;
    for (let k = 0, y = d.length; k < y; k++)
      if (d[k](e, p, r, !0)) {
        b = !0;
        break;
      }
    if (b) {
      e.lineMax = p, e.blkIndent !== 0 && (a.push(e.bMarks[p]), u.push(e.bsCount[p]), c.push(e.tShift[p]), l.push(e.sCount[p]), e.sCount[p] -= e.blkIndent);
      break;
    }
    a.push(e.bMarks[p]), u.push(e.bsCount[p]), c.push(e.tShift[p]), l.push(e.sCount[p]), e.sCount[p] = -1;
  }
  const m = e.blkIndent;
  e.blkIndent = 0;
  const w = e.push("blockquote_open", "blockquote", 1);
  w.markup = ">";
  const v = [t, 0];
  w.map = v, e.md.block.tokenize(e, t, p);
  const g = e.push("blockquote_close", "blockquote", -1);
  g.markup = ">", e.lineMax = s, e.parentType = h, v[1] = e.line;
  for (let A = 0; A < c.length; A++)
    e.bMarks[A + t] = a[A], e.tShift[A + t] = c[A], e.sCount[A + t] = l[A], e.bsCount[A + t] = u[A];
  return e.blkIndent = m, !0;
}
function JM(e, t, r, i) {
  const n = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  let o = e.bMarks[t] + e.tShift[t];
  const s = e.src.charCodeAt(o++);
  if (s !== 42 && s !== 45 && s !== 95)
    return !1;
  let a = 1;
  for (; o < n; ) {
    const l = e.src.charCodeAt(o++);
    if (l !== s && !Oe(l))
      return !1;
    l === s && a++;
  }
  if (a < 3)
    return !1;
  if (i)
    return !0;
  e.line = t + 1;
  const u = e.push("hr", "hr", 0);
  return u.map = [t, e.line], u.markup = Array(a + 1).join(String.fromCharCode(s)), !0;
}
function I0(e, t) {
  const r = e.eMarks[t];
  let i = e.bMarks[t] + e.tShift[t];
  const n = e.src.charCodeAt(i++);
  if (n !== 42 && n !== 45 && n !== 43)
    return -1;
  if (i < r) {
    const o = e.src.charCodeAt(i);
    if (!Oe(o))
      return -1;
  }
  return i;
}
function M0(e, t) {
  const r = e.bMarks[t] + e.tShift[t], i = e.eMarks[t];
  let n = r;
  if (n + 1 >= i)
    return -1;
  let o = e.src.charCodeAt(n++);
  if (o < 48 || o > 57)
    return -1;
  for (; ; ) {
    if (n >= i)
      return -1;
    if (o = e.src.charCodeAt(n++), o >= 48 && o <= 57) {
      if (n - r >= 10)
        return -1;
      continue;
    }
    if (o === 41 || o === 46)
      break;
    return -1;
  }
  return n < i && (o = e.src.charCodeAt(n), !Oe(o)) ? -1 : n;
}
function ZM(e, t) {
  const r = e.level + 2;
  for (let i = t + 2, n = e.tokens.length - 2; i < n; i++)
    e.tokens[i].level === r && e.tokens[i].type === "paragraph_open" && (e.tokens[i + 2].hidden = !0, e.tokens[i].hidden = !0, i += 2);
}
function XM(e, t, r, i) {
  let n, o, s, a, u = t, l = !0;
  if (e.sCount[u] - e.blkIndent >= 4 || e.listIndent >= 0 && e.sCount[u] - e.listIndent >= 4 && e.sCount[u] < e.blkIndent)
    return !1;
  let c = !1;
  i && e.parentType === "paragraph" && e.sCount[u] >= e.blkIndent && (c = !0);
  let d, h, f;
  if ((f = M0(e, u)) >= 0) {
    if (d = !0, s = e.bMarks[u] + e.tShift[u], h = Number(e.src.slice(s, f - 1)), c && h !== 1) return !1;
  } else if ((f = I0(e, u)) >= 0)
    d = !1;
  else
    return !1;
  if (c && e.skipSpaces(f) >= e.eMarks[u])
    return !1;
  if (i)
    return !0;
  const p = e.src.charCodeAt(f - 1), m = e.tokens.length;
  d ? (a = e.push("ordered_list_open", "ol", 1), h !== 1 && (a.attrs = [["start", h]])) : a = e.push("bullet_list_open", "ul", 1);
  const w = [u, 0];
  a.map = w, a.markup = String.fromCharCode(p);
  let v = !1;
  const g = e.md.block.ruler.getRules("list"), A = e.parentType;
  for (e.parentType = "list"; u < r; ) {
    o = f, n = e.eMarks[u];
    const b = e.sCount[u] + f - (e.bMarks[u] + e.tShift[u]);
    let k = b;
    for (; o < n; ) {
      const P = e.src.charCodeAt(o);
      if (P === 9)
        k += 4 - (k + e.bsCount[u]) % 4;
      else if (P === 32)
        k++;
      else
        break;
      o++;
    }
    const y = o;
    let x;
    y >= n ? x = 1 : x = k - b, x > 4 && (x = 1);
    const C = b + x;
    a = e.push("list_item_open", "li", 1), a.markup = String.fromCharCode(p);
    const I = [u, 0];
    a.map = I, d && (a.info = e.src.slice(s, f - 1));
    const M = e.tight, Q = e.tShift[u], H = e.sCount[u], J = e.listIndent;
    if (e.listIndent = e.blkIndent, e.blkIndent = C, e.tight = !0, e.tShift[u] = y - e.bMarks[u], e.sCount[u] = k, y >= n && e.isEmpty(u + 1) ? e.line = Math.min(e.line + 2, r) : e.md.block.tokenize(e, u, r, !0), (!e.tight || v) && (l = !1), v = e.line - u > 1 && e.isEmpty(e.line - 1), e.blkIndent = e.listIndent, e.listIndent = J, e.tShift[u] = Q, e.sCount[u] = H, e.tight = M, a = e.push("list_item_close", "li", -1), a.markup = String.fromCharCode(p), u = e.line, I[1] = u, u >= r || e.sCount[u] < e.blkIndent || e.sCount[u] - e.blkIndent >= 4)
      break;
    let W = !1;
    for (let P = 0, R = g.length; P < R; P++)
      if (g[P](e, u, r, !0)) {
        W = !0;
        break;
      }
    if (W)
      break;
    if (d) {
      if (f = M0(e, u), f < 0)
        break;
      s = e.bMarks[u] + e.tShift[u];
    } else if (f = I0(e, u), f < 0)
      break;
    if (p !== e.src.charCodeAt(f - 1))
      break;
  }
  return d ? a = e.push("ordered_list_close", "ol", -1) : a = e.push("bullet_list_close", "ul", -1), a.markup = String.fromCharCode(p), w[1] = u, e.line = u, e.parentType = A, l && ZM(e, m), !0;
}
function ej(e, t, r, i) {
  let n = e.bMarks[t] + e.tShift[t], o = e.eMarks[t], s = t + 1;
  if (e.sCount[t] - e.blkIndent >= 4 || e.src.charCodeAt(n) !== 91)
    return !1;
  function a(g) {
    const A = e.lineMax;
    if (g >= A || e.isEmpty(g))
      return null;
    let b = !1;
    if (e.sCount[g] - e.blkIndent > 3 && (b = !0), e.sCount[g] < 0 && (b = !0), !b) {
      const x = e.md.block.ruler.getRules("reference"), C = e.parentType;
      e.parentType = "reference";
      let I = !1;
      for (let M = 0, Q = x.length; M < Q; M++)
        if (x[M](e, g, A, !0)) {
          I = !0;
          break;
        }
      if (e.parentType = C, I)
        return null;
    }
    const k = e.bMarks[g] + e.tShift[g], y = e.eMarks[g];
    return e.src.slice(k, y + 1);
  }
  let u = e.src.slice(n, o + 1);
  o = u.length;
  let l = -1;
  for (n = 1; n < o; n++) {
    const g = u.charCodeAt(n);
    if (g === 91)
      return !1;
    if (g === 93) {
      l = n;
      break;
    } else if (g === 10) {
      const A = a(s);
      A !== null && (u += A, o = u.length, s++);
    } else if (g === 92 && (n++, n < o && u.charCodeAt(n) === 10)) {
      const A = a(s);
      A !== null && (u += A, o = u.length, s++);
    }
  }
  if (l < 0 || u.charCodeAt(l + 1) !== 58)
    return !1;
  for (n = l + 2; n < o; n++) {
    const g = u.charCodeAt(n);
    if (g === 10) {
      const A = a(s);
      A !== null && (u += A, o = u.length, s++);
    } else if (!Oe(g)) break;
  }
  const c = e.md.helpers.parseLinkDestination(u, n, o);
  if (!c.ok)
    return !1;
  const d = e.md.normalizeLink(c.str);
  if (!e.md.validateLink(d))
    return !1;
  n = c.pos;
  const h = n, f = s, p = n;
  for (; n < o; n++) {
    const g = u.charCodeAt(n);
    if (g === 10) {
      const A = a(s);
      A !== null && (u += A, o = u.length, s++);
    } else if (!Oe(g)) break;
  }
  let m = e.md.helpers.parseLinkTitle(u, n, o);
  for (; m.can_continue; ) {
    const g = a(s);
    if (g === null) break;
    u += g, n = o, o = u.length, s++, m = e.md.helpers.parseLinkTitle(u, n, o, m);
  }
  let w;
  for (n < o && p !== n && m.ok ? (w = m.str, n = m.pos) : (w = "", n = h, s = f); n < o; ) {
    const g = u.charCodeAt(n);
    if (!Oe(g))
      break;
    n++;
  }
  if (n < o && u.charCodeAt(n) !== 10 && w)
    for (w = "", n = h, s = f; n < o; ) {
      const g = u.charCodeAt(n);
      if (!Oe(g))
        break;
      n++;
    }
  if (n < o && u.charCodeAt(n) !== 10)
    return !1;
  const v = li(u.slice(1, l));
  return v ? (i || (typeof e.env.references > "u" && (e.env.references = {}), typeof e.env.references[v] > "u" && (e.env.references[v] = { title: w, href: d }), e.line = s), !0) : !1;
}
const tj = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], rj = "[a-zA-Z_:][a-zA-Z0-9:._-]*", nj = "[^\"'=<>`\\x00-\\x20]+", ij = "'[^']*'", oj = '"[^"]*"', aj = "(?:" + nj + "|" + ij + "|" + oj + ")", sj = "(?:\\s+" + rj + "(?:\\s*=\\s*" + aj + ")?)", pb = "<[A-Za-z][A-Za-z0-9\\-]*" + sj + "*\\s*\\/?>", mb = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", uj = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->", cj = "<[?][\\s\\S]*?[?]>", lj = "<![A-Za-z][^>]*>", dj = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", fj = new RegExp("^(?:" + pb + "|" + mb + "|" + uj + "|" + cj + "|" + lj + "|" + dj + ")"), hj = new RegExp("^(?:" + pb + "|" + mb + ")"), Ht = [
  [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
  [/^<!--/, /-->/, !0],
  [/^<\?/, /\?>/, !0],
  [/^<![A-Z]/, />/, !0],
  [/^<!\[CDATA\[/, /\]\]>/, !0],
  [new RegExp("^</?(" + tj.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0],
  [new RegExp(hj.source + "\\s*$"), /^$/, !1]
];
function pj(e, t, r, i) {
  let n = e.bMarks[t] + e.tShift[t], o = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4 || !e.md.options.html || e.src.charCodeAt(n) !== 60)
    return !1;
  let s = e.src.slice(n, o), a = 0;
  for (; a < Ht.length && !Ht[a][0].test(s); a++)
    ;
  if (a === Ht.length)
    return !1;
  if (i)
    return Ht[a][2];
  let u = t + 1;
  if (!Ht[a][1].test(s)) {
    for (; u < r && !(e.sCount[u] < e.blkIndent); u++)
      if (n = e.bMarks[u] + e.tShift[u], o = e.eMarks[u], s = e.src.slice(n, o), Ht[a][1].test(s)) {
        s.length !== 0 && u++;
        break;
      }
  }
  e.line = u;
  const l = e.push("html_block", "", 0);
  return l.map = [t, u], l.content = e.getLines(t, u, e.blkIndent, !0), !0;
}
function mj(e, t, r, i) {
  let n = e.bMarks[t] + e.tShift[t], o = e.eMarks[t];
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  let s = e.src.charCodeAt(n);
  if (s !== 35 || n >= o)
    return !1;
  let a = 1;
  for (s = e.src.charCodeAt(++n); s === 35 && n < o && a <= 6; )
    a++, s = e.src.charCodeAt(++n);
  if (a > 6 || n < o && !Oe(s))
    return !1;
  if (i)
    return !0;
  o = e.skipSpacesBack(o, n);
  const u = e.skipCharsBack(o, 35, n);
  u > n && Oe(e.src.charCodeAt(u - 1)) && (o = u), e.line = t + 1;
  const l = e.push("heading_open", "h" + String(a), 1);
  l.markup = "########".slice(0, a), l.map = [t, e.line];
  const c = e.push("inline", "", 0);
  c.content = e.src.slice(n, o).trim(), c.map = [t, e.line], c.children = [];
  const d = e.push("heading_close", "h" + String(a), -1);
  return d.markup = "########".slice(0, a), !0;
}
function gj(e, t, r) {
  const i = e.md.block.ruler.getRules("paragraph");
  if (e.sCount[t] - e.blkIndent >= 4)
    return !1;
  const n = e.parentType;
  e.parentType = "paragraph";
  let o = 0, s, a = t + 1;
  for (; a < r && !e.isEmpty(a); a++) {
    if (e.sCount[a] - e.blkIndent > 3)
      continue;
    if (e.sCount[a] >= e.blkIndent) {
      let f = e.bMarks[a] + e.tShift[a];
      const p = e.eMarks[a];
      if (f < p && (s = e.src.charCodeAt(f), (s === 45 || s === 61) && (f = e.skipChars(f, s), f = e.skipSpaces(f), f >= p))) {
        o = s === 61 ? 1 : 2;
        break;
      }
    }
    if (e.sCount[a] < 0)
      continue;
    let h = !1;
    for (let f = 0, p = i.length; f < p; f++)
      if (i[f](e, a, r, !0)) {
        h = !0;
        break;
      }
    if (h)
      break;
  }
  if (!o)
    return !1;
  const u = e.getLines(t, a, e.blkIndent, !1).trim();
  e.line = a + 1;
  const l = e.push("heading_open", "h" + String(o), 1);
  l.markup = String.fromCharCode(s), l.map = [t, e.line];
  const c = e.push("inline", "", 0);
  c.content = u, c.map = [t, e.line - 1], c.children = [];
  const d = e.push("heading_close", "h" + String(o), -1);
  return d.markup = String.fromCharCode(s), e.parentType = n, !0;
}
function bj(e, t, r) {
  const i = e.md.block.ruler.getRules("paragraph"), n = e.parentType;
  let o = t + 1;
  for (e.parentType = "paragraph"; o < r && !e.isEmpty(o); o++) {
    if (e.sCount[o] - e.blkIndent > 3 || e.sCount[o] < 0)
      continue;
    let l = !1;
    for (let c = 0, d = i.length; c < d; c++)
      if (i[c](e, o, r, !0)) {
        l = !0;
        break;
      }
    if (l)
      break;
  }
  const s = e.getLines(t, o, e.blkIndent, !1).trim();
  e.line = o;
  const a = e.push("paragraph_open", "p", 1);
  a.map = [t, e.line];
  const u = e.push("inline", "", 0);
  return u.content = s, u.map = [t, e.line], u.children = [], e.push("paragraph_close", "p", -1), e.parentType = n, !0;
}
const Cn = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  ["table", HM, ["paragraph", "reference"]],
  ["code", KM],
  ["fence", QM, ["paragraph", "reference", "blockquote", "list"]],
  ["blockquote", YM, ["paragraph", "reference", "blockquote", "list"]],
  ["hr", JM, ["paragraph", "reference", "blockquote", "list"]],
  ["list", XM, ["paragraph", "reference", "blockquote"]],
  ["reference", ej],
  ["html_block", pj, ["paragraph", "reference", "blockquote"]],
  ["heading", mj, ["paragraph", "reference", "blockquote"]],
  ["lheading", gj],
  ["paragraph", bj]
];
function di() {
  this.ruler = new Ve();
  for (let e = 0; e < Cn.length; e++)
    this.ruler.push(Cn[e][0], Cn[e][1], { alt: (Cn[e][2] || []).slice() });
}
di.prototype.tokenize = function(e, t, r) {
  const i = this.ruler.getRules(""), n = i.length, o = e.md.options.maxNesting;
  let s = t, a = !1;
  for (; s < r && (e.line = s = e.skipEmptyLines(s), !(s >= r || e.sCount[s] < e.blkIndent)); ) {
    if (e.level >= o) {
      e.line = r;
      break;
    }
    const u = e.line;
    let l = !1;
    for (let c = 0; c < n; c++)
      if (l = i[c](e, s, r, !1), l) {
        if (u >= e.line)
          throw new Error("block rule didn't increment state.line");
        break;
      }
    if (!l) throw new Error("none of the block rules matched");
    e.tight = !a, e.isEmpty(e.line - 1) && (a = !0), s = e.line, s < r && e.isEmpty(s) && (a = !0, s++, e.line = s);
  }
};
di.prototype.parse = function(e, t, r, i) {
  if (!e)
    return;
  const n = new this.State(e, t, r, i);
  this.tokenize(n, n.line, n.lineMax);
};
di.prototype.State = lt;
function pn(e, t, r, i) {
  this.src = e, this.env = r, this.md = t, this.tokens = i, this.tokens_meta = Array(i.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
pn.prototype.pushPending = function() {
  const e = new et("text", "", 0);
  return e.content = this.pending, e.level = this.pendingLevel, this.tokens.push(e), this.pending = "", e;
};
pn.prototype.push = function(e, t, r) {
  this.pending && this.pushPending();
  const i = new et(e, t, r);
  let n = null;
  return r < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), i.level = this.level, r > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], n = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(i), this.tokens_meta.push(n), i;
};
pn.prototype.scanDelims = function(e, t) {
  const r = this.posMax, i = this.src.charCodeAt(e), n = e > 0 ? this.src.charCodeAt(e - 1) : 32;
  let o = e;
  for (; o < r && this.src.charCodeAt(o) === i; )
    o++;
  const s = o - e, a = o < r ? this.src.charCodeAt(o) : 32, u = en(n) || Xr(String.fromCharCode(n)), l = en(a) || Xr(String.fromCharCode(a)), c = Zr(n), d = Zr(a), h = !d && (!l || c || u), f = !c && (!u || d || l);
  return { can_open: h && (t || !f || u), can_close: f && (t || !h || l), length: s };
};
pn.prototype.Token = et;
function vj(e) {
  switch (e) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function yj(e, t) {
  let r = e.pos;
  for (; r < e.posMax && !vj(e.src.charCodeAt(r)); )
    r++;
  return r === e.pos ? !1 : (t || (e.pending += e.src.slice(e.pos, r)), e.pos = r, !0);
}
const wj = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function _j(e, t) {
  if (!e.md.options.linkify || e.linkLevel > 0) return !1;
  const r = e.pos, i = e.posMax;
  if (r + 3 > i || e.src.charCodeAt(r) !== 58 || e.src.charCodeAt(r + 1) !== 47 || e.src.charCodeAt(r + 2) !== 47) return !1;
  const n = e.pending.match(wj);
  if (!n) return !1;
  const o = n[1], s = e.md.linkify.matchAtStart(e.src.slice(r - o.length));
  if (!s) return !1;
  let a = s.url;
  if (a.length <= o.length) return !1;
  let u = a.length;
  for (; u > 0 && a.charCodeAt(u - 1) === 42; )
    u--;
  u !== a.length && (a = a.slice(0, u));
  const l = e.md.normalizeLink(a);
  if (!e.md.validateLink(l)) return !1;
  if (!t) {
    e.pending = e.pending.slice(0, -o.length);
    const c = e.push("link_open", "a", 1);
    c.attrs = [["href", l]], c.markup = "linkify", c.info = "auto";
    const d = e.push("text", "", 0);
    d.content = e.md.normalizeLinkText(a);
    const h = e.push("link_close", "a", -1);
    h.markup = "linkify", h.info = "auto";
  }
  return e.pos += a.length - o.length, !0;
}
function kj(e, t) {
  let r = e.pos;
  if (e.src.charCodeAt(r) !== 10)
    return !1;
  const i = e.pending.length - 1, n = e.posMax;
  if (!t)
    if (i >= 0 && e.pending.charCodeAt(i) === 32)
      if (i >= 1 && e.pending.charCodeAt(i - 1) === 32) {
        let o = i - 1;
        for (; o >= 1 && e.pending.charCodeAt(o - 1) === 32; ) o--;
        e.pending = e.pending.slice(0, o), e.push("hardbreak", "br", 0);
      } else
        e.pending = e.pending.slice(0, -1), e.push("softbreak", "br", 0);
    else
      e.push("softbreak", "br", 0);
  for (r++; r < n && Oe(e.src.charCodeAt(r)); )
    r++;
  return e.pos = r, !0;
}
const Ac = [];
for (let e = 0; e < 256; e++)
  Ac.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(e) {
  Ac[e.charCodeAt(0)] = 1;
});
function xj(e, t) {
  let r = e.pos;
  const i = e.posMax;
  if (e.src.charCodeAt(r) !== 92 || (r++, r >= i)) return !1;
  let n = e.src.charCodeAt(r);
  if (n === 10) {
    for (t || e.push("hardbreak", "br", 0), r++; r < i && (n = e.src.charCodeAt(r), !!Oe(n)); )
      r++;
    return e.pos = r, !0;
  }
  let o = e.src[r];
  if (n >= 55296 && n <= 56319 && r + 1 < i) {
    const a = e.src.charCodeAt(r + 1);
    a >= 56320 && a <= 57343 && (o += e.src[r + 1], r++);
  }
  const s = "\\" + o;
  if (!t) {
    const a = e.push("text_special", "", 0);
    n < 256 && Ac[n] !== 0 ? a.content = o : a.content = s, a.markup = s, a.info = "escape";
  }
  return e.pos = r + 1, !0;
}
function Sj(e, t) {
  let r = e.pos;
  if (e.src.charCodeAt(r) !== 96)
    return !1;
  const n = r;
  r++;
  const o = e.posMax;
  for (; r < o && e.src.charCodeAt(r) === 96; )
    r++;
  const s = e.src.slice(n, r), a = s.length;
  if (e.backticksScanned && (e.backticks[a] || 0) <= n)
    return t || (e.pending += s), e.pos += a, !0;
  let u = r, l;
  for (; (l = e.src.indexOf("`", u)) !== -1; ) {
    for (u = l + 1; u < o && e.src.charCodeAt(u) === 96; )
      u++;
    const c = u - l;
    if (c === a) {
      if (!t) {
        const d = e.push("code_inline", "code", 0);
        d.markup = s, d.content = e.src.slice(r, l).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
      }
      return e.pos = u, !0;
    }
    e.backticks[c] = l;
  }
  return e.backticksScanned = !0, t || (e.pending += s), e.pos += a, !0;
}
function Ej(e, t) {
  const r = e.pos, i = e.src.charCodeAt(r);
  if (t || i !== 126)
    return !1;
  const n = e.scanDelims(e.pos, !0);
  let o = n.length;
  const s = String.fromCharCode(i);
  if (o < 2)
    return !1;
  let a;
  o % 2 && (a = e.push("text", "", 0), a.content = s, o--);
  for (let u = 0; u < o; u += 2)
    a = e.push("text", "", 0), a.content = s + s, e.delimiters.push({
      marker: i,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: e.tokens.length - 1,
      end: -1,
      open: n.can_open,
      close: n.can_close
    });
  return e.pos += n.length, !0;
}
function j0(e, t) {
  let r;
  const i = [], n = t.length;
  for (let o = 0; o < n; o++) {
    const s = t[o];
    if (s.marker !== 126 || s.end === -1)
      continue;
    const a = t[s.end];
    r = e.tokens[s.token], r.type = "s_open", r.tag = "s", r.nesting = 1, r.markup = "~~", r.content = "", r = e.tokens[a.token], r.type = "s_close", r.tag = "s", r.nesting = -1, r.markup = "~~", r.content = "", e.tokens[a.token - 1].type === "text" && e.tokens[a.token - 1].content === "~" && i.push(a.token - 1);
  }
  for (; i.length; ) {
    const o = i.pop();
    let s = o + 1;
    for (; s < e.tokens.length && e.tokens[s].type === "s_close"; )
      s++;
    s--, o !== s && (r = e.tokens[s], e.tokens[s] = e.tokens[o], e.tokens[o] = r);
  }
}
function Aj(e) {
  const t = e.tokens_meta, r = e.tokens_meta.length;
  j0(e, e.delimiters);
  for (let i = 0; i < r; i++)
    t[i] && t[i].delimiters && j0(e, t[i].delimiters);
}
const gb = {
  tokenize: Ej,
  postProcess: Aj
};
function Tj(e, t) {
  const r = e.pos, i = e.src.charCodeAt(r);
  if (t || i !== 95 && i !== 42)
    return !1;
  const n = e.scanDelims(e.pos, i === 42);
  for (let o = 0; o < n.length; o++) {
    const s = e.push("text", "", 0);
    s.content = String.fromCharCode(i), e.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: i,
      // Total length of these series of delimiters.
      //
      length: n.length,
      // A position of the token this delimiter corresponds to.
      //
      token: e.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: n.can_open,
      close: n.can_close
    });
  }
  return e.pos += n.length, !0;
}
function F0(e, t) {
  const r = t.length;
  for (let i = r - 1; i >= 0; i--) {
    const n = t[i];
    if (n.marker !== 95 && n.marker !== 42 || n.end === -1)
      continue;
    const o = t[n.end], s = i > 0 && t[i - 1].end === n.end + 1 && // check that first two markers match and adjacent
    t[i - 1].marker === n.marker && t[i - 1].token === n.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    t[n.end + 1].token === o.token + 1, a = String.fromCharCode(n.marker), u = e.tokens[n.token];
    u.type = s ? "strong_open" : "em_open", u.tag = s ? "strong" : "em", u.nesting = 1, u.markup = s ? a + a : a, u.content = "";
    const l = e.tokens[o.token];
    l.type = s ? "strong_close" : "em_close", l.tag = s ? "strong" : "em", l.nesting = -1, l.markup = s ? a + a : a, l.content = "", s && (e.tokens[t[i - 1].token].content = "", e.tokens[t[n.end + 1].token].content = "", i--);
  }
}
function Cj(e) {
  const t = e.tokens_meta, r = e.tokens_meta.length;
  F0(e, e.delimiters);
  for (let i = 0; i < r; i++)
    t[i] && t[i].delimiters && F0(e, t[i].delimiters);
}
const bb = {
  tokenize: Tj,
  postProcess: Cj
};
function Rj(e, t) {
  let r, i, n, o, s = "", a = "", u = e.pos, l = !0;
  if (e.src.charCodeAt(e.pos) !== 91)
    return !1;
  const c = e.pos, d = e.posMax, h = e.pos + 1, f = e.md.helpers.parseLinkLabel(e, e.pos, !0);
  if (f < 0)
    return !1;
  let p = f + 1;
  if (p < d && e.src.charCodeAt(p) === 40) {
    for (l = !1, p++; p < d && (r = e.src.charCodeAt(p), !(!Oe(r) && r !== 10)); p++)
      ;
    if (p >= d)
      return !1;
    if (u = p, n = e.md.helpers.parseLinkDestination(e.src, p, e.posMax), n.ok) {
      for (s = e.md.normalizeLink(n.str), e.md.validateLink(s) ? p = n.pos : s = "", u = p; p < d && (r = e.src.charCodeAt(p), !(!Oe(r) && r !== 10)); p++)
        ;
      if (n = e.md.helpers.parseLinkTitle(e.src, p, e.posMax), p < d && u !== p && n.ok)
        for (a = n.str, p = n.pos; p < d && (r = e.src.charCodeAt(p), !(!Oe(r) && r !== 10)); p++)
          ;
    }
    (p >= d || e.src.charCodeAt(p) !== 41) && (l = !0), p++;
  }
  if (l) {
    if (typeof e.env.references > "u")
      return !1;
    if (p < d && e.src.charCodeAt(p) === 91 ? (u = p + 1, p = e.md.helpers.parseLinkLabel(e, p), p >= 0 ? i = e.src.slice(u, p++) : p = f + 1) : p = f + 1, i || (i = e.src.slice(h, f)), o = e.env.references[li(i)], !o)
      return e.pos = c, !1;
    s = o.href, a = o.title;
  }
  if (!t) {
    e.pos = h, e.posMax = f;
    const m = e.push("link_open", "a", 1), w = [["href", s]];
    m.attrs = w, a && w.push(["title", a]), e.linkLevel++, e.md.inline.tokenize(e), e.linkLevel--, e.push("link_close", "a", -1);
  }
  return e.pos = p, e.posMax = d, !0;
}
function Oj(e, t) {
  let r, i, n, o, s, a, u, l, c = "";
  const d = e.pos, h = e.posMax;
  if (e.src.charCodeAt(e.pos) !== 33 || e.src.charCodeAt(e.pos + 1) !== 91)
    return !1;
  const f = e.pos + 2, p = e.md.helpers.parseLinkLabel(e, e.pos + 1, !1);
  if (p < 0)
    return !1;
  if (o = p + 1, o < h && e.src.charCodeAt(o) === 40) {
    for (o++; o < h && (r = e.src.charCodeAt(o), !(!Oe(r) && r !== 10)); o++)
      ;
    if (o >= h)
      return !1;
    for (l = o, a = e.md.helpers.parseLinkDestination(e.src, o, e.posMax), a.ok && (c = e.md.normalizeLink(a.str), e.md.validateLink(c) ? o = a.pos : c = ""), l = o; o < h && (r = e.src.charCodeAt(o), !(!Oe(r) && r !== 10)); o++)
      ;
    if (a = e.md.helpers.parseLinkTitle(e.src, o, e.posMax), o < h && l !== o && a.ok)
      for (u = a.str, o = a.pos; o < h && (r = e.src.charCodeAt(o), !(!Oe(r) && r !== 10)); o++)
        ;
    else
      u = "";
    if (o >= h || e.src.charCodeAt(o) !== 41)
      return e.pos = d, !1;
    o++;
  } else {
    if (typeof e.env.references > "u")
      return !1;
    if (o < h && e.src.charCodeAt(o) === 91 ? (l = o + 1, o = e.md.helpers.parseLinkLabel(e, o), o >= 0 ? n = e.src.slice(l, o++) : o = p + 1) : o = p + 1, n || (n = e.src.slice(f, p)), s = e.env.references[li(n)], !s)
      return e.pos = d, !1;
    c = s.href, u = s.title;
  }
  if (!t) {
    i = e.src.slice(f, p);
    const m = [];
    e.md.inline.parse(
      i,
      e.md,
      e.env,
      m
    );
    const w = e.push("image", "img", 0), v = [["src", c], ["alt", ""]];
    w.attrs = v, w.children = m, w.content = i, u && v.push(["title", u]);
  }
  return e.pos = o, e.posMax = h, !0;
}
const Dj = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, Pj = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function Ij(e, t) {
  let r = e.pos;
  if (e.src.charCodeAt(r) !== 60)
    return !1;
  const i = e.pos, n = e.posMax;
  for (; ; ) {
    if (++r >= n) return !1;
    const s = e.src.charCodeAt(r);
    if (s === 60) return !1;
    if (s === 62) break;
  }
  const o = e.src.slice(i + 1, r);
  if (Pj.test(o)) {
    const s = e.md.normalizeLink(o);
    if (!e.md.validateLink(s))
      return !1;
    if (!t) {
      const a = e.push("link_open", "a", 1);
      a.attrs = [["href", s]], a.markup = "autolink", a.info = "auto";
      const u = e.push("text", "", 0);
      u.content = e.md.normalizeLinkText(o);
      const l = e.push("link_close", "a", -1);
      l.markup = "autolink", l.info = "auto";
    }
    return e.pos += o.length + 2, !0;
  }
  if (Dj.test(o)) {
    const s = e.md.normalizeLink("mailto:" + o);
    if (!e.md.validateLink(s))
      return !1;
    if (!t) {
      const a = e.push("link_open", "a", 1);
      a.attrs = [["href", s]], a.markup = "autolink", a.info = "auto";
      const u = e.push("text", "", 0);
      u.content = e.md.normalizeLinkText(o);
      const l = e.push("link_close", "a", -1);
      l.markup = "autolink", l.info = "auto";
    }
    return e.pos += o.length + 2, !0;
  }
  return !1;
}
function Mj(e) {
  return /^<a[>\s]/i.test(e);
}
function jj(e) {
  return /^<\/a\s*>/i.test(e);
}
function Fj(e) {
  const t = e | 32;
  return t >= 97 && t <= 122;
}
function $j(e, t) {
  if (!e.md.options.html)
    return !1;
  const r = e.posMax, i = e.pos;
  if (e.src.charCodeAt(i) !== 60 || i + 2 >= r)
    return !1;
  const n = e.src.charCodeAt(i + 1);
  if (n !== 33 && n !== 63 && n !== 47 && !Fj(n))
    return !1;
  const o = e.src.slice(i).match(fj);
  if (!o)
    return !1;
  if (!t) {
    const s = e.push("html_inline", "", 0);
    s.content = o[0], Mj(s.content) && e.linkLevel++, jj(s.content) && e.linkLevel--;
  }
  return e.pos += o[0].length, !0;
}
const Lj = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, Nj = /^&([a-z][a-z0-9]{1,31});/i;
function Bj(e, t) {
  const r = e.pos, i = e.posMax;
  if (e.src.charCodeAt(r) !== 38 || r + 1 >= i) return !1;
  if (e.src.charCodeAt(r + 1) === 35) {
    const o = e.src.slice(r).match(Lj);
    if (o) {
      if (!t) {
        const s = o[1][0].toLowerCase() === "x" ? parseInt(o[1].slice(1), 16) : parseInt(o[1], 10), a = e.push("text_special", "", 0);
        a.content = Sc(s) ? zn(s) : zn(65533), a.markup = o[0], a.info = "entity";
      }
      return e.pos += o[0].length, !0;
    }
  } else {
    const o = e.src.slice(r).match(Nj);
    if (o) {
      const s = cb(o[0]);
      if (s !== o[0]) {
        if (!t) {
          const a = e.push("text_special", "", 0);
          a.content = s, a.markup = o[0], a.info = "entity";
        }
        return e.pos += o[0].length, !0;
      }
    }
  }
  return !1;
}
function $0(e) {
  const t = {}, r = e.length;
  if (!r) return;
  let i = 0, n = -2;
  const o = [];
  for (let s = 0; s < r; s++) {
    const a = e[s];
    if (o.push(0), (e[i].marker !== a.marker || n !== a.token - 1) && (i = s), n = a.token, a.length = a.length || 0, !a.close) continue;
    t.hasOwnProperty(a.marker) || (t[a.marker] = [-1, -1, -1, -1, -1, -1]);
    const u = t[a.marker][(a.open ? 3 : 0) + a.length % 3];
    let l = i - o[i] - 1, c = l;
    for (; l > u; l -= o[l] + 1) {
      const d = e[l];
      if (d.marker === a.marker && d.open && d.end < 0) {
        let h = !1;
        if ((d.close || a.open) && (d.length + a.length) % 3 === 0 && (d.length % 3 !== 0 || a.length % 3 !== 0) && (h = !0), !h) {
          const f = l > 0 && !e[l - 1].open ? o[l - 1] + 1 : 0;
          o[s] = s - l + f, o[l] = f, a.open = !1, d.end = s, d.close = !1, c = -1, n = -2;
          break;
        }
      }
    }
    c !== -1 && (t[a.marker][(a.open ? 3 : 0) + (a.length || 0) % 3] = c);
  }
}
function qj(e) {
  const t = e.tokens_meta, r = e.tokens_meta.length;
  $0(e.delimiters);
  for (let i = 0; i < r; i++)
    t[i] && t[i].delimiters && $0(t[i].delimiters);
}
function zj(e) {
  let t, r, i = 0;
  const n = e.tokens, o = e.tokens.length;
  for (t = r = 0; t < o; t++)
    n[t].nesting < 0 && i--, n[t].level = i, n[t].nesting > 0 && i++, n[t].type === "text" && t + 1 < o && n[t + 1].type === "text" ? n[t + 1].content = n[t].content + n[t + 1].content : (t !== r && (n[r] = n[t]), r++);
  t !== r && (n.length = r);
}
const Us = [
  ["text", yj],
  ["linkify", _j],
  ["newline", kj],
  ["escape", xj],
  ["backticks", Sj],
  ["strikethrough", gb.tokenize],
  ["emphasis", bb.tokenize],
  ["link", Rj],
  ["image", Oj],
  ["autolink", Ij],
  ["html_inline", $j],
  ["entity", Bj]
], Vs = [
  ["balance_pairs", qj],
  ["strikethrough", gb.postProcess],
  ["emphasis", bb.postProcess],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  ["fragments_join", zj]
];
function mn() {
  this.ruler = new Ve();
  for (let e = 0; e < Us.length; e++)
    this.ruler.push(Us[e][0], Us[e][1]);
  this.ruler2 = new Ve();
  for (let e = 0; e < Vs.length; e++)
    this.ruler2.push(Vs[e][0], Vs[e][1]);
}
mn.prototype.skipToken = function(e) {
  const t = e.pos, r = this.ruler.getRules(""), i = r.length, n = e.md.options.maxNesting, o = e.cache;
  if (typeof o[t] < "u") {
    e.pos = o[t];
    return;
  }
  let s = !1;
  if (e.level < n) {
    for (let a = 0; a < i; a++)
      if (e.level++, s = r[a](e, !0), e.level--, s) {
        if (t >= e.pos)
          throw new Error("inline rule didn't increment state.pos");
        break;
      }
  } else
    e.pos = e.posMax;
  s || e.pos++, o[t] = e.pos;
};
mn.prototype.tokenize = function(e) {
  const t = this.ruler.getRules(""), r = t.length, i = e.posMax, n = e.md.options.maxNesting;
  for (; e.pos < i; ) {
    const o = e.pos;
    let s = !1;
    if (e.level < n) {
      for (let a = 0; a < r; a++)
        if (s = t[a](e, !1), s) {
          if (o >= e.pos)
            throw new Error("inline rule didn't increment state.pos");
          break;
        }
    }
    if (s) {
      if (e.pos >= i)
        break;
      continue;
    }
    e.pending += e.src[e.pos++];
  }
  e.pending && e.pushPending();
};
mn.prototype.parse = function(e, t, r, i) {
  const n = new this.State(e, t, r, i);
  this.tokenize(n);
  const o = this.ruler2.getRules(""), s = o.length;
  for (let a = 0; a < s; a++)
    o[a](n);
};
mn.prototype.State = pn;
function Uj(e) {
  const t = {};
  e = e || {}, t.src_Any = ib.source, t.src_Cc = ob.source, t.src_Z = sb.source, t.src_P = kc.source, t.src_ZPCc = [t.src_Z, t.src_P, t.src_Cc].join("|"), t.src_ZCc = [t.src_Z, t.src_Cc].join("|");
  const r = "[><｜]";
  return t.src_pseudo_letter = "(?:(?!" + r + "|" + t.src_ZPCc + ")" + t.src_Any + ")", t.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", t.src_auth = "(?:(?:(?!" + t.src_ZCc + "|[@/\\[\\]()]).)+@)?", t.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", t.src_host_terminator = "(?=$|" + r + "|" + t.src_ZPCc + ")(?!" + (e["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + t.src_ZPCc + "))", t.src_path = "(?:[/?#](?:(?!" + t.src_ZCc + "|" + r + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + t.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + t.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + t.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + t.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + t.src_ZCc + "|[']).)+\\'|\\'(?=" + t.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + t.src_ZCc + "|[.]|$)|" + (e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + // allow `,,,` in paths
  ",(?!" + t.src_ZCc + "|$)|;(?!" + t.src_ZCc + "|$)|\\!+(?!" + t.src_ZCc + "|[!]|$)|\\?(?!" + t.src_ZCc + "|[?]|$))+|\\/)?", t.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', t.src_xn = "xn--[a-z0-9\\-]{1,59}", t.src_domain_root = // Allow letters & digits (http://test1)
  "(?:" + t.src_xn + "|" + t.src_pseudo_letter + "{1,63})", t.src_domain = "(?:" + t.src_xn + "|(?:" + t.src_pseudo_letter + ")|(?:" + t.src_pseudo_letter + "(?:-|" + t.src_pseudo_letter + "){0,61}" + t.src_pseudo_letter + "))", t.src_host = "(?:(?:(?:(?:" + t.src_domain + ")\\.)*" + t.src_domain + "))", t.tpl_host_fuzzy = "(?:" + t.src_ip4 + "|(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%)))", t.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%))", t.src_host_strict = t.src_host + t.src_host_terminator, t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator, t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator, t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_port_no_ip_fuzzy_strict = t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + t.src_ZPCc + "|>|$))", t.tpl_email_fuzzy = "(^|" + r + '|"|\\(|' + t.src_ZCc + ")(" + t.src_email_name + "@" + t.tpl_host_fuzzy_strict + ")", t.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_fuzzy_strict + t.src_path + ")", t.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_no_ip_fuzzy_strict + t.src_path + ")", t;
}
function Pu(e) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(r) {
    r && Object.keys(r).forEach(function(i) {
      e[i] = r[i];
    });
  }), e;
}
function fi(e) {
  return Object.prototype.toString.call(e);
}
function Vj(e) {
  return fi(e) === "[object String]";
}
function Gj(e) {
  return fi(e) === "[object Object]";
}
function Wj(e) {
  return fi(e) === "[object RegExp]";
}
function L0(e) {
  return fi(e) === "[object Function]";
}
function Hj(e) {
  return e.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
const vb = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function Kj(e) {
  return Object.keys(e || {}).reduce(function(t, r) {
    return t || vb.hasOwnProperty(r);
  }, !1);
}
const Qj = {
  "http:": {
    validate: function(e, t, r) {
      const i = e.slice(t);
      return r.re.http || (r.re.http = new RegExp(
        "^\\/\\/" + r.re.src_auth + r.re.src_host_port_strict + r.re.src_path,
        "i"
      )), r.re.http.test(i) ? i.match(r.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(e, t, r) {
      const i = e.slice(t);
      return r.re.no_http || (r.re.no_http = new RegExp(
        "^" + r.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + r.re.src_domain + ")\\.)+" + r.re.src_domain_root + ")" + r.re.src_port + r.re.src_host_terminator + r.re.src_path,
        "i"
      )), r.re.no_http.test(i) ? t >= 3 && e[t - 3] === ":" || t >= 3 && e[t - 3] === "/" ? 0 : i.match(r.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(e, t, r) {
      const i = e.slice(t);
      return r.re.mailto || (r.re.mailto = new RegExp(
        "^" + r.re.src_email_name + "@" + r.re.src_host_strict,
        "i"
      )), r.re.mailto.test(i) ? i.match(r.re.mailto)[0].length : 0;
    }
  }
}, Yj = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", Jj = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function Zj(e) {
  e.__index__ = -1, e.__text_cache__ = "";
}
function Xj(e) {
  return function(t, r) {
    const i = t.slice(r);
    return e.test(i) ? i.match(e)[0].length : 0;
  };
}
function N0() {
  return function(e, t) {
    t.normalize(e);
  };
}
function Un(e) {
  const t = e.re = Uj(e.__opts__), r = e.__tlds__.slice();
  e.onCompile(), e.__tlds_replaced__ || r.push(Yj), r.push(t.src_xn), t.src_tlds = r.join("|");
  function i(a) {
    return a.replace("%TLDS%", t.src_tlds);
  }
  t.email_fuzzy = RegExp(i(t.tpl_email_fuzzy), "i"), t.link_fuzzy = RegExp(i(t.tpl_link_fuzzy), "i"), t.link_no_ip_fuzzy = RegExp(i(t.tpl_link_no_ip_fuzzy), "i"), t.host_fuzzy_test = RegExp(i(t.tpl_host_fuzzy_test), "i");
  const n = [];
  e.__compiled__ = {};
  function o(a, u) {
    throw new Error('(LinkifyIt) Invalid schema "' + a + '": ' + u);
  }
  Object.keys(e.__schemas__).forEach(function(a) {
    const u = e.__schemas__[a];
    if (u === null)
      return;
    const l = { validate: null, link: null };
    if (e.__compiled__[a] = l, Gj(u)) {
      Wj(u.validate) ? l.validate = Xj(u.validate) : L0(u.validate) ? l.validate = u.validate : o(a, u), L0(u.normalize) ? l.normalize = u.normalize : u.normalize ? o(a, u) : l.normalize = N0();
      return;
    }
    if (Vj(u)) {
      n.push(a);
      return;
    }
    o(a, u);
  }), n.forEach(function(a) {
    e.__compiled__[e.__schemas__[a]] && (e.__compiled__[a].validate = e.__compiled__[e.__schemas__[a]].validate, e.__compiled__[a].normalize = e.__compiled__[e.__schemas__[a]].normalize);
  }), e.__compiled__[""] = { validate: null, normalize: N0() };
  const s = Object.keys(e.__compiled__).filter(function(a) {
    return a.length > 0 && e.__compiled__[a];
  }).map(Hj).join("|");
  e.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + s + ")", "i"), e.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + s + ")", "ig"), e.re.schema_at_start = RegExp("^" + e.re.schema_search.source, "i"), e.re.pretest = RegExp(
    "(" + e.re.schema_test.source + ")|(" + e.re.host_fuzzy_test.source + ")|@",
    "i"
  ), Zj(e);
}
function e9(e, t) {
  const r = e.__index__, i = e.__last_index__, n = e.__text_cache__.slice(r, i);
  this.schema = e.__schema__.toLowerCase(), this.index = r + t, this.lastIndex = i + t, this.raw = n, this.text = n, this.url = n;
}
function Iu(e, t) {
  const r = new e9(e, t);
  return e.__compiled__[r.schema].normalize(r, e), r;
}
function Qe(e, t) {
  if (!(this instanceof Qe))
    return new Qe(e, t);
  t || Kj(e) && (t = e, e = {}), this.__opts__ = Pu({}, vb, t), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = Pu({}, Qj, e), this.__compiled__ = {}, this.__tlds__ = Jj, this.__tlds_replaced__ = !1, this.re = {}, Un(this);
}
Qe.prototype.add = function(t, r) {
  return this.__schemas__[t] = r, Un(this), this;
};
Qe.prototype.set = function(t) {
  return this.__opts__ = Pu(this.__opts__, t), this;
};
Qe.prototype.test = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length)
    return !1;
  let r, i, n, o, s, a, u, l, c;
  if (this.re.schema_test.test(t)) {
    for (u = this.re.schema_search, u.lastIndex = 0; (r = u.exec(t)) !== null; )
      if (o = this.testSchemaAt(t, r[2], u.lastIndex), o) {
        this.__schema__ = r[2], this.__index__ = r.index + r[1].length, this.__last_index__ = r.index + r[0].length + o;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (l = t.search(this.re.host_fuzzy_test), l >= 0 && (this.__index__ < 0 || l < this.__index__) && (i = t.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (s = i.index + i[1].length, (this.__index__ < 0 || s < this.__index__) && (this.__schema__ = "", this.__index__ = s, this.__last_index__ = i.index + i[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (c = t.indexOf("@"), c >= 0 && (n = t.match(this.re.email_fuzzy)) !== null && (s = n.index + n[1].length, a = n.index + n[0].length, (this.__index__ < 0 || s < this.__index__ || s === this.__index__ && a > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = s, this.__last_index__ = a))), this.__index__ >= 0;
};
Qe.prototype.pretest = function(t) {
  return this.re.pretest.test(t);
};
Qe.prototype.testSchemaAt = function(t, r, i) {
  return this.__compiled__[r.toLowerCase()] ? this.__compiled__[r.toLowerCase()].validate(t, i, this) : 0;
};
Qe.prototype.match = function(t) {
  const r = [];
  let i = 0;
  this.__index__ >= 0 && this.__text_cache__ === t && (r.push(Iu(this, i)), i = this.__last_index__);
  let n = i ? t.slice(i) : t;
  for (; this.test(n); )
    r.push(Iu(this, i)), n = n.slice(this.__last_index__), i += this.__last_index__;
  return r.length ? r : null;
};
Qe.prototype.matchAtStart = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length) return null;
  const r = this.re.schema_at_start.exec(t);
  if (!r) return null;
  const i = this.testSchemaAt(t, r[2], r[0].length);
  return i ? (this.__schema__ = r[2], this.__index__ = r.index + r[1].length, this.__last_index__ = r.index + r[0].length + i, Iu(this, 0)) : null;
};
Qe.prototype.tlds = function(t, r) {
  return t = Array.isArray(t) ? t : [t], r ? (this.__tlds__ = this.__tlds__.concat(t).sort().filter(function(i, n, o) {
    return i !== o[n - 1];
  }).reverse(), Un(this), this) : (this.__tlds__ = t.slice(), this.__tlds_replaced__ = !0, Un(this), this);
};
Qe.prototype.normalize = function(t) {
  t.schema || (t.url = "http://" + t.url), t.schema === "mailto:" && !/^mailto:/i.test(t.url) && (t.url = "mailto:" + t.url);
};
Qe.prototype.onCompile = function() {
};
const Qt = 2147483647, st = 36, Tc = 1, tn = 26, t9 = 38, r9 = 700, yb = 72, wb = 128, _b = "-", n9 = /^xn--/, i9 = /[^\0-\x7F]/, o9 = /[\x2E\u3002\uFF0E\uFF61]/g, a9 = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, Gs = st - Tc, ut = Math.floor, Ws = String.fromCharCode;
function St(e) {
  throw new RangeError(a9[e]);
}
function s9(e, t) {
  const r = [];
  let i = e.length;
  for (; i--; )
    r[i] = t(e[i]);
  return r;
}
function kb(e, t) {
  const r = e.split("@");
  let i = "";
  r.length > 1 && (i = r[0] + "@", e = r[1]), e = e.replace(o9, ".");
  const n = e.split("."), o = s9(n, t).join(".");
  return i + o;
}
function xb(e) {
  const t = [];
  let r = 0;
  const i = e.length;
  for (; r < i; ) {
    const n = e.charCodeAt(r++);
    if (n >= 55296 && n <= 56319 && r < i) {
      const o = e.charCodeAt(r++);
      (o & 64512) == 56320 ? t.push(((n & 1023) << 10) + (o & 1023) + 65536) : (t.push(n), r--);
    } else
      t.push(n);
  }
  return t;
}
const u9 = (e) => String.fromCodePoint(...e), c9 = function(e) {
  return e >= 48 && e < 58 ? 26 + (e - 48) : e >= 65 && e < 91 ? e - 65 : e >= 97 && e < 123 ? e - 97 : st;
}, B0 = function(e, t) {
  return e + 22 + 75 * (e < 26) - ((t != 0) << 5);
}, Sb = function(e, t, r) {
  let i = 0;
  for (e = r ? ut(e / r9) : e >> 1, e += ut(e / t); e > Gs * tn >> 1; i += st)
    e = ut(e / Gs);
  return ut(i + (Gs + 1) * e / (e + t9));
}, Eb = function(e) {
  const t = [], r = e.length;
  let i = 0, n = wb, o = yb, s = e.lastIndexOf(_b);
  s < 0 && (s = 0);
  for (let a = 0; a < s; ++a)
    e.charCodeAt(a) >= 128 && St("not-basic"), t.push(e.charCodeAt(a));
  for (let a = s > 0 ? s + 1 : 0; a < r; ) {
    const u = i;
    for (let c = 1, d = st; ; d += st) {
      a >= r && St("invalid-input");
      const h = c9(e.charCodeAt(a++));
      h >= st && St("invalid-input"), h > ut((Qt - i) / c) && St("overflow"), i += h * c;
      const f = d <= o ? Tc : d >= o + tn ? tn : d - o;
      if (h < f)
        break;
      const p = st - f;
      c > ut(Qt / p) && St("overflow"), c *= p;
    }
    const l = t.length + 1;
    o = Sb(i - u, l, u == 0), ut(i / l) > Qt - n && St("overflow"), n += ut(i / l), i %= l, t.splice(i++, 0, n);
  }
  return String.fromCodePoint(...t);
}, Ab = function(e) {
  const t = [];
  e = xb(e);
  const r = e.length;
  let i = wb, n = 0, o = yb;
  for (const u of e)
    u < 128 && t.push(Ws(u));
  const s = t.length;
  let a = s;
  for (s && t.push(_b); a < r; ) {
    let u = Qt;
    for (const c of e)
      c >= i && c < u && (u = c);
    const l = a + 1;
    u - i > ut((Qt - n) / l) && St("overflow"), n += (u - i) * l, i = u;
    for (const c of e)
      if (c < i && ++n > Qt && St("overflow"), c === i) {
        let d = n;
        for (let h = st; ; h += st) {
          const f = h <= o ? Tc : h >= o + tn ? tn : h - o;
          if (d < f)
            break;
          const p = d - f, m = st - f;
          t.push(
            Ws(B0(f + p % m, 0))
          ), d = ut(p / m);
        }
        t.push(Ws(B0(d, 0))), o = Sb(n, l, a === s), n = 0, ++a;
      }
    ++n, ++i;
  }
  return t.join("");
}, l9 = function(e) {
  return kb(e, function(t) {
    return n9.test(t) ? Eb(t.slice(4).toLowerCase()) : t;
  });
}, d9 = function(e) {
  return kb(e, function(t) {
    return i9.test(t) ? "xn--" + Ab(t) : t;
  });
}, Tb = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  version: "2.3.1",
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  ucs2: {
    decode: xb,
    encode: u9
  },
  decode: Eb,
  encode: Ab,
  toASCII: d9,
  toUnicode: l9
}, f9 = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 100
  },
  components: {
    core: {},
    block: {},
    inline: {}
  }
}, h9 = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "text"
      ],
      rules2: [
        "balance_pairs",
        "fragments_join"
      ]
    }
  }
}, p9 = {
  options: {
    // Enable HTML tags in source
    html: !0,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !0,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fence",
        "heading",
        "hr",
        "html_block",
        "lheading",
        "list",
        "reference",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "html_inline",
        "image",
        "link",
        "newline",
        "text"
      ],
      rules2: [
        "balance_pairs",
        "emphasis",
        "fragments_join"
      ]
    }
  }
}, m9 = {
  default: f9,
  zero: h9,
  commonmark: p9
}, g9 = /^(vbscript|javascript|file|data):/, b9 = /^data:image\/(gif|png|jpeg|webp);/;
function v9(e) {
  const t = e.trim().toLowerCase();
  return g9.test(t) ? b9.test(t) : !0;
}
const Cb = ["http:", "https:", "mailto:"];
function y9(e) {
  const t = _c(e, !0);
  if (t.hostname && (!t.protocol || Cb.indexOf(t.protocol) >= 0))
    try {
      t.hostname = Tb.toASCII(t.hostname);
    } catch {
    }
  return hn(wc(t));
}
function w9(e) {
  const t = _c(e, !0);
  if (t.hostname && (!t.protocol || Cb.indexOf(t.protocol) >= 0))
    try {
      t.hostname = Tb.toUnicode(t.hostname);
    } catch {
    }
  return Xt(wc(t), Xt.defaultChars + "%");
}
function Je(e, t) {
  if (!(this instanceof Je))
    return new Je(e, t);
  t || xc(e) || (t = e || {}, e = "default"), this.inline = new mn(), this.block = new di(), this.core = new Ec(), this.renderer = new ur(), this.linkify = new Qe(), this.validateLink = v9, this.normalizeLink = y9, this.normalizeLinkText = w9, this.utils = kM, this.helpers = ci({}, AM), this.options = {}, this.configure(e), t && this.set(t);
}
Je.prototype.set = function(e) {
  return ci(this.options, e), this;
};
Je.prototype.configure = function(e) {
  const t = this;
  if (xc(e)) {
    const r = e;
    if (e = m9[r], !e)
      throw new Error('Wrong `markdown-it` preset "' + r + '", check name');
  }
  if (!e)
    throw new Error("Wrong `markdown-it` preset, can't be empty");
  return e.options && t.set(e.options), e.components && Object.keys(e.components).forEach(function(r) {
    e.components[r].rules && t[r].ruler.enableOnly(e.components[r].rules), e.components[r].rules2 && t[r].ruler2.enableOnly(e.components[r].rules2);
  }), this;
};
Je.prototype.enable = function(e, t) {
  let r = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(n) {
    r = r.concat(this[n].ruler.enable(e, !0));
  }, this), r = r.concat(this.inline.ruler2.enable(e, !0));
  const i = e.filter(function(n) {
    return r.indexOf(n) < 0;
  });
  if (i.length && !t)
    throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + i);
  return this;
};
Je.prototype.disable = function(e, t) {
  let r = [];
  Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function(n) {
    r = r.concat(this[n].ruler.disable(e, !0));
  }, this), r = r.concat(this.inline.ruler2.disable(e, !0));
  const i = e.filter(function(n) {
    return r.indexOf(n) < 0;
  });
  if (i.length && !t)
    throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + i);
  return this;
};
Je.prototype.use = function(e) {
  const t = [this].concat(Array.prototype.slice.call(arguments, 1));
  return e.apply(e, t), this;
};
Je.prototype.parse = function(e, t) {
  if (typeof e != "string")
    throw new Error("Input data should be a String");
  const r = new this.core.State(e, this, t);
  return this.core.process(r), r.tokens;
};
Je.prototype.render = function(e, t) {
  return t = t || {}, this.renderer.render(this.parse(e, t), this.options, t);
};
Je.prototype.parseInline = function(e, t) {
  const r = new this.core.State(e, this, t);
  return r.inlineMode = !0, this.core.process(r), r.tokens;
};
Je.prototype.renderInline = function(e, t) {
  return t = t || {}, this.renderer.render(this.parseInline(e, t), this.options, t);
};
class Rb {
  constructor(t) {
    this.options = t, this.options = t;
  }
  // Adds each element of the array as markdown
  addArray(t, r) {
    for (const i of t)
      this.formatFromAst(i, r);
    return r;
  }
  processAst(t, r) {
    t instanceof Array ? this.addArray(t, r) : this.formatFromAst(t, r);
  }
}
class Ob extends Rb {
  constructor(t) {
    super(t), this.options = t;
  }
  format(t) {
    let r = this.formatFromAst(t, []).join("").trim();
    return r = r.replace(/  +/g, " "), r;
  }
  formatFromAst(t, r = []) {
    switch (t.name) {
      case "document":
        return this.processAst(t.children, r), r;
      case "paragraph":
        return this.processAst(t.children, r), r;
      case "simpleLine":
        return this.processAst(t.children, r), r;
      case "lineEnd":
        return r.push(t.allText), r;
      case "emptyLine":
        return this.options.preserveEmptyLines && r.push(t.allText), r;
      case "plainText":
      case "plainTextSpecialChars":
      case "plainTextEmphasis":
      case "plainTextPhone":
      case "plainTextModifier":
        return r.push(t.allText), r;
      default:
        return this.processAst(t.children, r), r;
    }
  }
}
class Xe {
  constructor(t) {
    this.base = t, this.tags = {}, this.text = "";
  }
  tag(t, r, i = !1, n = this.base.ssmlTagSortOrder) {
    const o = n.indexOf(t);
    this.tags[t] || (this.tags[t] = { sortId: o, attrs: null }), i ? this.tags[t].attrs = { ...this.tags[t].attrs, ...r } : this.tags[t].attrs = r;
  }
  voiceTagNamed(t, r) {
    let i = t && t[r];
    return i ? (typeof i != "object" && (i = {
      voice: { name: r }
    }), Object.keys(i).forEach((n) => {
      const o = i[n];
      this.tag(n, o);
    }), !0) : !1;
  }
  voiceTag(t, r) {
    const i = this.base.sentenceCase(r || "device");
    this.voiceTagNamed(this.base.options && this.base.options.voices, i) || this.voiceTagNamed(this.base.validVoices, i);
  }
}
const Pn = class Gr extends Rb {
  constructor(t) {
    super(t), this.options = t, this.sectionTags = [], this.modifierKeyMappings = {
      chars: "characters",
      cardinal: "number",
      digits: "characters",
      bleep: "expletive",
      phone: "telephone",
      vol: "volume"
    }, this.ssmlTagSortOrder = [
      "emphasis",
      "say-as",
      "prosody",
      "amazon:domain",
      "amazon:effect",
      "amazon:emotion",
      "voice",
      "lang",
      "sub",
      "phoneme"
    ], this.modifierKeyToSsmlTagMappings = {
      emphasis: "emphasis",
      address: "say-as",
      number: "say-as",
      characters: "say-as",
      expletive: "say-as",
      fraction: "say-as",
      interjection: "say-as",
      ordinal: "say-as",
      telephone: "say-as",
      unit: "say-as",
      time: "say-as",
      date: "say-as",
      whisper: null,
      sub: "sub",
      ipa: "phoneme",
      rate: "prosody",
      pitch: "prosody",
      volume: "prosody",
      drc: null,
      timbre: null,
      lang: null,
      voice: null,
      dj: null,
      defaults: null,
      newscaster: null,
      excited: null,
      disappointed: null
    };
  }
  format(t) {
    return this.formatFromAst(t, []).join("");
  }
  addSectionStartTag(t, r, i) {
    this.sectionTags = [...t].reverse();
    for (let n = 0; n < t.length; n++) {
      const o = t[n], s = r.tags[o].attrs;
      i.push(`
`), i.push(this.startTag(o, s, !1));
    }
  }
  addSectionEndTag(t) {
    if (this.sectionTags.length > 0)
      for (let r = 0; r < this.sectionTags.length; r++) {
        const i = this.sectionTags[r];
        t.push(this.endTag(i, !1)), t.push(`
`);
      }
  }
  // Adds tagged content
  addTag(t, r, i, n, o, s) {
    return s.push(this.startTag(t, o, i)), this.processAst(r, s), s.push(this.endTag(t, i)), n && s.push(`
`), s;
  }
  addSpeakTag(t, r, i, n, o) {
    return o.push(this.startTag("speak", n, r)), this.processAst(t, o), this.addSectionEndTag(o), o.push(this.endTag("speak", r)), i && o.push(`
`), o;
  }
  addComment(t, r) {
    return r.push(`<!-- ${t} -->
`), r;
  }
  // Returns the SSML for a start tag
  startTag(t, r, i = !1) {
    let n = "";
    return r && (n = " " + Object.keys(r).map((o) => o + '="' + r[o] + '"').join(" ")), "<" + t + n + ">" + (i ? `
` : "");
  }
  // Returns the SSML for an end tag
  endTag(t, r = !1) {
    return (r ? `
` : "") + "</" + t + ">";
  }
  voidTag(t, r) {
    let i = "";
    return r && (i = " " + Object.keys(r).map((n) => n + '="' + r[n] + '"').join(" ")), "<" + t + i + "/>";
  }
  addTagWithAttrs(t, r, i, n, o = !1) {
    return r || o ? (t.push(this.startTag(i, n)), r && t.push(r), t.push(this.endTag(i, !1))) : t.push(this.voidTag(i, n)), t;
  }
  getTagWithAttrs(t, r, i) {
    let n = [];
    return t ? (n.push(this.startTag(r, i)), n.push(t), n.push(this.endTag(r, !1))) : n.push(this.voidTag(r, i)), n.join("");
  }
  sentenceCase(t) {
    return t.replace(/[a-z]/i, (r) => r.toUpperCase()).trim();
  }
  escapeXmlCharacters(t) {
    let r = `${Object.keys(Gr.XML_UNESCAPE_MAPPING).join("|")}]`, i = t.replace(
      new RegExp(r, "g"),
      (o) => Gr.XML_UNESCAPE_MAPPING[o]
    ), n = `[${Object.keys(Gr.XML_ESCAPE_MAPPING).join("")}]`;
    return i.replace(
      new RegExp(n, "g"),
      (o) => Gr.XML_ESCAPE_MAPPING[o]
    );
  }
};
Pn.XML_ESCAPE_MAPPING = {
  "<": "&lt;",
  ">": "&gt;",
  "&": "&amp;",
  '"': "&quot;",
  "'": "&apos;"
}, Pn.XML_UNESCAPE_MAPPING = (function(e) {
  return Object.keys(e).reduce((t, r) => (t[e[r]] = r, t), {});
})(Pn.XML_ESCAPE_MAPPING);
let cr = Pn;
class _9 extends cr {
  constructor(t) {
    super(t), this.options = t, this.validVoices = {
      Ivy: "en-US",
      Joanna: "en-US",
      Joey: "en-US",
      Justin: "en-US",
      Kendra: "en-US",
      Kimberly: "en-US",
      Matthew: "en-US",
      Salli: "en-US",
      Nicole: "en-AU",
      Russell: "en-AU",
      Amy: "en-GB",
      Brian: "en-GB",
      Emma: "en-GB",
      Aditi: "en-IN",
      Raveena: "en-IN",
      Hans: "de-DE",
      Marlene: "de-DE",
      Vicki: "de-DE",
      Conchita: "es-ES",
      Enrique: "es-ES",
      Carla: "it-IT",
      Giorgio: "it-IT",
      Mizuki: "ja-JP",
      Takumi: "ja-JP",
      Celine: "fr-FR",
      Lea: "fr-FR",
      Mathieu: "fr-FR"
    }, this.validEmotionIntensity = [
      "low",
      "medium",
      "high"
    ], this.modifierKeyToSsmlTagMappings.whisper = "amazon:effect", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyToSsmlTagMappings.voice = "voice", this.modifierKeyToSsmlTagMappings.dj = "amazon:domain", this.modifierKeyToSsmlTagMappings.newscaster = "amazon:domain", this.modifierKeyToSsmlTagMappings.excited = "amazon:emotion", this.modifierKeyToSsmlTagMappings.disappointed = "amazon:emotion";
  }
  // tslint:disable-next-line: max-func-body-length
  getTextModifierObject(t) {
    let r = new Xe(this);
    for (let i = 0; i < t.children.length; i++) {
      const n = t.children[i];
      switch (n.name) {
        case "plainText":
        case "plainTextSpecialChars":
        case "plainTextEmphasis":
        case "plainTextPhone":
        case "plainTextModifier": {
          r.text = n.allText;
          break;
        }
        case "textModifierKeyOptionalValue": {
          let o = n.children[0].allText;
          o = this.modifierKeyMappings[o] || o;
          const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
          switch (o) {
            case "emphasis":
              r.tag(a, { level: s || "moderate" });
              break;
            case "address":
            case "characters":
            case "expletive":
            case "fraction":
            case "interjection":
            case "number":
            case "ordinal":
            case "telephone":
            case "unit":
              r.tag(a, { "interpret-as": o });
              break;
            case "date":
              r.tag(a, { "interpret-as": o, format: s || "ymd" });
              break;
            case "time":
              r.tag(a, { "interpret-as": o, format: s || "hms12" });
              break;
            case "whisper":
              r.tag(a, { name: "whispered" });
              break;
            case "ipa":
              r.tag(a, { alphabet: o, ph: s });
              break;
            case "sub":
              r.tag(a, { alias: s });
              break;
            case "volume":
            case "rate":
            case "pitch": {
              const u = {};
              u[o] = s || "medium", r.tag(a, u, !0);
              break;
            }
            case "lang":
              r.tag(a, { "xml:lang": s });
              break;
            case "voice":
              r.voiceTag(o, s);
              break;
            case "excited":
            case "disappointed": {
              const u = (s || "medium").toLowerCase();
              if (this.validEmotionIntensity.includes(u)) {
                r.tag(a, { name: o, intensity: u });
                break;
              }
              break;
            }
          }
          break;
        }
      }
    }
    return r;
  }
  // tslint:disable-next-line: max-func-body-length
  getSectionObject(t) {
    let r = new Xe(this);
    for (let i = 0; i < t.children.length; i++) {
      const n = t.children[i];
      if (n.name === "sectionModifierKeyOptionalValue") {
        let o = n.children[0].allText;
        const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
        switch (o) {
          case "lang":
            r.tag(a, { "xml:lang": s });
            break;
          case "voice":
            r.voiceTag(o, s);
            break;
          case "dj":
            r.tag(a, { name: "music" });
            break;
          case "newscaster":
            r.tag(a, { name: "news" });
            break;
          case "defaults":
            break;
          case "excited":
          case "disappointed": {
            const u = (s || "medium").toLowerCase();
            if (this.validEmotionIntensity.includes(u)) {
              r.tag(a, { name: o, intensity: u });
              break;
            }
            break;
          }
        }
      }
    }
    return r;
  }
  // tslint:disable-next-line: max-func-body-length
  formatFromAst(t, r = []) {
    switch (t.name) {
      case "document":
        return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Amazon Alexa", r), this.options.includeSpeakTag ? this.addSpeakTag(t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
      case "paragraph":
        return this.options.includeParagraphTag ? this.addTag("p", t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
      case "shortBreak": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, null, "break", { time: i });
      }
      case "break": {
        const i = t.children[0].allText;
        let n = {};
        switch (t.children[0].children[0].name) {
          case "breakStrengthValue":
            n = { strength: i };
            break;
          case "time":
            n = { time: i };
            break;
        }
        return this.addTagWithAttrs(r, null, "break", n);
      }
      case "shortEmphasisModerate": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, i, "emphasis", { level: "moderate" });
      }
      case "shortEmphasisStrong": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, i, "emphasis", { level: "strong" });
      }
      case "shortEmphasisNone": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, i, "emphasis", { level: "none" });
      }
      case "shortEmphasisReduced": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, i, "emphasis", { level: "reduced" });
      }
      case "textModifier": {
        const i = this.getTextModifierObject(t), n = Object.keys(i.tags).sort((s, a) => i.tags[a].sortId - i.tags[s].sortId);
        let o = i.text;
        for (let s = 0; s < n.length; s++) {
          const a = n[s], u = i.tags[a].attrs;
          o = this.getTagWithAttrs(o, a, u);
        }
        return r.push(o), r;
      }
      case "section": {
        const i = this.getSectionObject(t), n = Object.keys(i.tags).sort((o, s) => i.tags[o].sortId - i.tags[s].sortId);
        return this.addSectionEndTag(r), this.addSectionStartTag(n, i, r), r;
      }
      case "audio": {
        const i = t.children[0].allText.replace(/&/g, "&amp;");
        return this.addTagWithAttrs(r, null, "audio", { src: i });
      }
      case "simpleLine":
        return this.processAst(t.children, r), r;
      case "lineEnd":
        return r.push(t.allText), r;
      case "emptyLine":
        return this.options.preserveEmptyLines && r.push(t.allText), r;
      case "plainText":
      case "plainTextSpecialChars": {
        let i = this.options.escapeXmlSymbols ? this.escapeXmlCharacters(t.allText) : t.allText;
        return r.push(i), r;
      }
      default:
        return this.processAst(t.children, r), r;
    }
  }
}
class k9 extends cr {
  constructor(t) {
    super(t), this.options = t, this.modifierKeyToSsmlTagMappings.whisper = "amazon:effect", this.modifierKeyToSsmlTagMappings.timbre = "amazon:effect", this.modifierKeyToSsmlTagMappings.cardinal = "say-as", this.modifierKeyToSsmlTagMappings.digits = "say-as", this.modifierKeyToSsmlTagMappings.drc = "amazon:effect", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyMappings.digits = "digits", this.modifierKeyMappings.cardinal = "cardinal";
  }
  // tslint:disable-next-line: max-func-body-length
  getTextModifierObject(t) {
    let r = new Xe(this);
    for (let i = 0; i < t.children.length; i++) {
      const n = t.children[i];
      switch (n.name) {
        case "plainText":
        case "plainTextSpecialChars":
        case "plainTextEmphasis":
        case "plainTextPhone":
        case "plainTextModifier": {
          r.text = n.allText;
          break;
        }
        case "textModifierKeyOptionalValue": {
          let o = n.children[0].allText;
          o = this.modifierKeyMappings[o] || o;
          const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
          switch (o) {
            case "emphasis":
              r.tag(a, { level: s || "moderate" });
              break;
            case "address":
            case "cardinal":
            case "characters":
            case "digits":
            case "expletive":
            case "fraction":
            case "number":
            case "ordinal":
            case "telephone":
            case "unit":
              r.tag(a, { "interpret-as": o });
              break;
            case "date":
              r.tag(a, { "interpret-as": o, format: s || "ymd" });
              break;
            case "time":
              r.tag(a, { "interpret-as": o, format: s || "hms12" });
              break;
            case "whisper":
              r.tag(a, { name: "whispered" });
              break;
            case "ipa":
              r.tag(a, { alphabet: o, ph: s });
              break;
            case "sub":
              r.tag(a, { alias: s });
              break;
            case "volume":
            case "rate":
            case "pitch": {
              const u = {};
              u[o] = s || "medium", r.tag(a, u, !0);
              break;
            }
            case "timbre":
              r.tag(a, { "vocal-tract-length": s });
              break;
            case "lang":
              r.tag(a, { "xml:lang": s });
              break;
            case "drc":
              r.tag(a, { name: o });
              break;
          }
          break;
        }
      }
    }
    return r;
  }
  // tslint:disable-next-line: max-func-body-length
  getSectionObject(t) {
    let r = new Xe(this);
    for (let i = 0; i < t.children.length; i++) {
      const n = t.children[i];
      if (n.name === "sectionModifierKeyOptionalValue") {
        let o = n.children[0].allText;
        const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
        switch (o) {
          case "lang":
            r.tag(a, { "xml:lang": s });
            break;
        }
      }
    }
    return r;
  }
  // tslint:disable-next-line: max-func-body-length
  formatFromAst(t, r = []) {
    switch (t.name) {
      case "document":
        return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Amazon Alexa", r), this.options.includeSpeakTag ? this.addSpeakTag(t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
      case "paragraph":
        return this.options.includeParagraphTag ? this.addTag("p", t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
      case "shortBreak": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, null, "break", { time: i });
      }
      case "break": {
        const i = t.children[0].allText;
        let n = {};
        switch (t.children[0].children[0].name) {
          case "breakStrengthValue":
            n = { strength: i };
            break;
          case "time":
            n = { time: i };
            break;
        }
        return this.addTagWithAttrs(r, null, "break", n);
      }
      case "markTag": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, null, "mark", { name: i });
      }
      case "shortEmphasisModerate": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, i, "emphasis", { level: "moderate" });
      }
      case "shortEmphasisStrong": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, i, "emphasis", { level: "strong" });
      }
      case "shortEmphasisNone": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, i, "emphasis", { level: "none" });
      }
      case "shortEmphasisReduced": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, i, "emphasis", { level: "reduced" });
      }
      case "textModifier": {
        const i = this.getTextModifierObject(t), n = Object.keys(i.tags).sort((s, a) => i.tags[a].sortId - i.tags[s].sortId);
        let o = i.text;
        for (let s = 0; s < n.length; s++) {
          const a = n[s], u = i.tags[a].attrs;
          o = this.getTagWithAttrs(o, a, u);
        }
        return r.push(o), r;
      }
      case "section": {
        const i = this.getSectionObject(t), n = Object.keys(i.tags).sort((o, s) => i.tags[o].sortId - i.tags[s].sortId);
        return this.addSectionEndTag(r), this.addSectionStartTag(n, i, r), r;
      }
      case "simpleLine":
        return this.processAst(t.children, r), r;
      case "lineEnd":
        return r.push(t.allText), r;
      case "emptyLine":
        return this.options.preserveEmptyLines && r.push(t.allText), r;
      case "plainText":
      case "plainTextSpecialChars":
        return r.push(t.allText), r;
      default:
        return this.processAst(t.children, r), r;
    }
  }
}
class x9 extends cr {
  constructor(t) {
    super(t), this.options = t, this.modifierKeyToSsmlTagMappings.cardinal = "say-as", this.modifierKeyToSsmlTagMappings.digits = "say-as", this.modifierKeyToSsmlTagMappings.drc = "amazon:effect", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyToSsmlTagMappings.newscaster = "amazon:domain", this.modifierKeyMappings.digits = "digits", this.modifierKeyMappings.cardinal = "cardinal";
  }
  // tslint:disable-next-line: max-func-body-length
  getTextModifierObject(t) {
    let r = new Xe(this);
    for (let i = 0; i < t.children.length; i++) {
      const n = t.children[i];
      switch (n.name) {
        case "plainText":
        case "plainTextSpecialChars":
        case "plainTextEmphasis":
        case "plainTextPhone":
        case "plainTextModifier": {
          r.text = n.allText;
          break;
        }
        case "textModifierKeyOptionalValue": {
          let o = n.children[0].allText;
          o = this.modifierKeyMappings[o] || o;
          const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
          switch (o) {
            case "address":
            case "cardinal":
            case "characters":
            case "digits":
            case "expletive":
            case "fraction":
            case "number":
            case "ordinal":
            case "telephone":
            case "unit":
              r.tag(a, { "interpret-as": o });
              break;
            case "date":
              r.tag(a, { "interpret-as": o, format: s || "ymd" });
              break;
            case "time":
              r.tag(a, { "interpret-as": o, format: s || "hms12" });
              break;
            case "ipa":
              r.tag(a, { alphabet: o, ph: s });
              break;
            case "sub":
              r.tag(a, { alias: s });
              break;
            case "volume":
            case "rate": {
              const u = {};
              u[o] = s || "medium", r.tag(a, u, !0);
              break;
            }
            case "lang":
              r.tag(a, { "xml:lang": s });
              break;
            case "drc":
              r.tag(a, { name: o });
              break;
          }
          break;
        }
      }
    }
    return r;
  }
  // tslint:disable-next-line: max-func-body-length
  getSectionObject(t) {
    let r = new Xe(this);
    for (let i = 0; i < t.children.length; i++) {
      const n = t.children[i];
      if (n.name === "sectionModifierKeyOptionalValue") {
        let o = n.children[0].allText;
        const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
        switch (o) {
          case "lang":
            r.tag(a, { "xml:lang": s });
            break;
          case "newscaster":
            r.tag(a, { name: "news" });
            break;
        }
      }
    }
    return r;
  }
  // tslint:disable-next-line: max-func-body-length
  formatFromAst(t, r = []) {
    switch (t.name) {
      case "document":
        return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Amazon Polly", r), this.options.includeSpeakTag ? this.addSpeakTag(t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
      case "paragraph":
        return this.options.includeParagraphTag ? this.addTag("p", t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
      case "shortBreak": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, null, "break", { time: i });
      }
      case "break": {
        const i = t.children[0].allText;
        let n = {};
        switch (t.children[0].children[0].name) {
          case "breakStrengthValue":
            n = { strength: i };
            break;
          case "time":
            n = { time: i };
            break;
        }
        return this.addTagWithAttrs(r, null, "break", n);
      }
      case "markTag": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, null, "mark", { name: i });
      }
      case "textModifier": {
        const i = this.getTextModifierObject(t), n = Object.keys(i.tags).sort((s, a) => i.tags[a].sortId - i.tags[s].sortId);
        let o = i.text;
        for (let s = 0; s < n.length; s++) {
          const a = n[s], u = i.tags[a].attrs;
          o = this.getTagWithAttrs(o, a, u);
        }
        return r.push(o), r;
      }
      case "section": {
        const i = this.getSectionObject(t), n = Object.keys(i.tags).sort((o, s) => i.tags[o].sortId - i.tags[s].sortId);
        return this.addSectionEndTag(r), this.addSectionStartTag(n, i, r), r;
      }
      case "simpleLine":
        return this.processAst(t.children, r), r;
      case "lineEnd":
        return r.push(t.allText), r;
      case "emptyLine":
        return this.options.preserveEmptyLines && r.push(t.allText), r;
      case "shortEmphasisModerate":
      case "shortEmphasisStrong":
      case "shortEmphasisNone":
      case "shortEmphasisReduced":
        return r.push(t.allText.replace(/\+/g, "")), r;
      case "plainText":
      case "plainTextSpecialChars":
        return r.push(t.allText), r;
      default:
        return this.processAst(t.children, r), r;
    }
  }
}
class S9 extends cr {
  constructor(t) {
    super(t), this.options = t, this.validVoices = {
      Ivy: { voice: { gender: "female", variant: 1, language: "en-US" } },
      Joanna: { voice: { gender: "female", variant: 2, language: "en-US" } },
      Joey: { voice: { gender: "male", variant: 1, language: "en-US" } },
      Justin: { voice: { gender: "male", variant: 2, language: "en-US" } },
      Kendra: { voice: { gender: "female", variant: 3, language: "en-US" } },
      Kimberly: { voice: { gender: "female", variant: 4, language: "en-US" } },
      Matthew: { voice: { gender: "male", variant: 3, language: "en-US" } },
      Salli: { voice: { gender: "male", variant: 4, language: "en-US" } },
      Nicole: { voice: { gender: "female", variant: 1, language: "en-AU" } },
      Russell: { voice: { gender: "male", variant: 1, language: "en-AU" } },
      Amy: { voice: { gender: "female", variant: 1, language: "en-GB" } },
      Brian: { voice: { gender: "male", variant: 1, language: "en-GB" } },
      Emma: { voice: { gender: "female", variant: 2, language: "en-GB" } },
      Aditi: { voice: { gender: "female", variant: 1, language: "en-IN" } },
      Raveena: { voice: { gender: "female", variant: 2, language: "en-IN" } },
      Hans: { voice: { gender: "male", variant: 1, language: "de-DE" } },
      Marlene: { voice: { gender: "female", variant: 1, language: "de-DE" } },
      Vicki: { voice: { gender: "female", variant: 2, language: "de-DE" } },
      Conchita: { voice: { gender: "female", variant: 1, language: "es-ES" } },
      Enrique: { voice: { gender: "male", variant: 1, language: "es-ES" } },
      Carla: { voice: { gender: "female", variant: 1, language: "it-IT" } },
      Giorgio: { voice: { gender: "male", variant: 1, language: "it-IT" } },
      Mizuki: { voice: { gender: "female", variant: 1, language: "ja-JP" } },
      Takumi: { voice: { gender: "male", variant: 1, language: "ja-JP" } },
      Celine: { voice: { gender: "female", variant: 1, language: "fr-FR" } },
      Lea: { voice: { gender: "female", variant: 2, language: "fr-FR" } },
      Mathieu: { voice: { gender: "male", variant: 1, language: "fr-FR" } }
    }, this.modifierKeyToSsmlTagMappings.interjection = null, this.modifierKeyToSsmlTagMappings.whisper = "prosody", this.modifierKeyToSsmlTagMappings.lang = "lang";
  }
  // tslint:disable-next-line: max-func-body-length
  getTextModifierObject(t) {
    let r = new Xe(this);
    for (let i = 0; i < t.children.length; i++) {
      const n = t.children[i];
      switch (n.name) {
        case "plainText":
        case "plainTextSpecialChars":
        case "plainTextEmphasis":
        case "plainTextPhone":
        case "plainTextModifier": {
          r.text = n.allText;
          break;
        }
        case "textModifierKeyOptionalValue": {
          let o = n.children[0].allText;
          o = this.modifierKeyMappings[o] || o;
          const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
          switch (o) {
            case "emphasis":
              r.tag(a, { level: s || "moderate" });
              break;
            case "address":
            case "characters":
            case "expletive":
            case "fraction":
            case "number":
            case "ordinal":
            case "telephone":
            case "unit":
              r.tag(a, { "interpret-as": o });
              break;
            case "date":
              r.tag(a, { "interpret-as": o, format: s || "ymd" });
              break;
            case "time":
              r.tag(a, { "interpret-as": o, format: s || "hms12" });
              break;
            case "whisper":
              r.tag(a, { volume: "x-soft", rate: "slow" });
              break;
            case "ipa":
              r.tag(a, { alphabet: o, ph: s });
              break;
            case "sub":
              r.tag(a, { alias: s });
              break;
            case "volume":
            case "rate":
            case "pitch": {
              const u = {};
              u[o] = s || "medium", r.tag(a, u, !0);
              break;
            }
            case "lang":
              r.tag(a, { "xml:lang": s });
              break;
            case "voice":
              r.voiceTag(o, s);
              break;
          }
          break;
        }
      }
    }
    return r;
  }
  // tslint:disable-next-line: max-func-body-length
  getSectionObject(t) {
    let r = new Xe(this);
    for (let i = 0; i < t.children.length; i++) {
      const n = t.children[i];
      if (n.name === "sectionModifierKeyOptionalValue") {
        let o = n.children[0].allText;
        const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
        switch (o) {
          case "lang":
            r.tag(a, { "xml:lang": s });
            break;
          case "voice":
            r.voiceTag(o, s);
            break;
        }
      }
    }
    return r;
  }
  // tslint:disable-next-line: max-func-body-length
  formatFromAst(t, r = []) {
    switch (t.name) {
      case "document":
        return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Google Assistant", r), this.options.includeSpeakTag ? this.addSpeakTag(t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
      case "paragraph":
        return this.options.includeParagraphTag ? this.addTag("p", t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
      case "shortBreak": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, null, "break", { time: i });
      }
      case "break": {
        const i = t.children[0].allText;
        let n = {};
        switch (t.children[0].children[0].name) {
          case "breakStrengthValue":
            n = { strength: i };
            break;
          case "time":
            n = { time: i };
            break;
        }
        return this.addTagWithAttrs(r, null, "break", n);
      }
      case "markTag": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, null, "mark", { name: i });
      }
      case "shortEmphasisModerate": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, i, "emphasis", { level: "moderate" });
      }
      case "shortEmphasisStrong": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, i, "emphasis", { level: "strong" });
      }
      case "shortEmphasisNone": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, i, "emphasis", { level: "none" });
      }
      case "shortEmphasisReduced": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, i, "emphasis", { level: "reduced" });
      }
      case "textModifier": {
        const i = this.getTextModifierObject(t);
        if (i.textOnly)
          return r.push(i.text), r;
        const n = Object.keys(i.tags).sort((s, a) => i.tags[a].sortId - i.tags[s].sortId);
        let o = i.text;
        for (let s = 0; s < n.length; s++) {
          const a = n[s], u = i.tags[a].attrs;
          o = this.getTagWithAttrs(o, a, u);
        }
        return r.push(o), r;
      }
      case "section": {
        const i = this.getSectionObject(t), n = Object.keys(i.tags).sort((o, s) => i.tags[o].sortId - i.tags[s].sortId);
        return this.addSectionEndTag(r), this.addSectionStartTag(n, i, r), r;
      }
      case "audio": {
        const i = t.children[0].allText.replace(/&/g, "&amp;");
        return this.addTagWithAttrs(r, null, "audio", { src: i });
      }
      case "simpleLine":
        return this.processAst(t.children, r), r;
      case "lineEnd":
        return r.push(t.allText), r;
      case "emptyLine":
        return this.options.preserveEmptyLines && r.push(t.allText), r;
      case "plainText":
      case "plainTextSpecialChars":
        return r.push(t.allText), r;
      default:
        return this.processAst(t.children, r), r;
    }
  }
}
class E9 extends cr {
  constructor(t) {
    super(t), this.options = t, this.modifierKeyToSsmlTagMappings.emphasis = null, this.modifierKeyToSsmlTagMappings.address = null, this.modifierKeyToSsmlTagMappings.number = "say-as", this.modifierKeyToSsmlTagMappings.characters = "say-as", this.modifierKeyToSsmlTagMappings.expletive = null, this.modifierKeyToSsmlTagMappings.fraction = "say-as", this.modifierKeyToSsmlTagMappings.interjection = null, this.modifierKeyToSsmlTagMappings.ordinal = "say-as", this.modifierKeyToSsmlTagMappings.telephone = null, this.modifierKeyToSsmlTagMappings.unit = null, this.modifierKeyToSsmlTagMappings.time = null, this.modifierKeyToSsmlTagMappings.date = null, this.modifierKeyToSsmlTagMappings.sub = "sub", this.modifierKeyToSsmlTagMappings.ipa = null, this.modifierKeyToSsmlTagMappings.rate = "prosody", this.modifierKeyToSsmlTagMappings.pitch = "prosody", this.modifierKeyToSsmlTagMappings.volume = "prosody", this.modifierKeyToSsmlTagMappings.whisper = "prosody";
  }
  // tslint:disable-next-line: max-func-body-length
  getTextModifierObject(t) {
    let r = new Xe(this);
    for (let i = 0; i < t.children.length; i++) {
      const n = t.children[i];
      switch (n.name) {
        case "plainText":
        case "plainTextSpecialChars":
        case "plainTextEmphasis":
        case "plainTextPhone":
        case "plainTextModifier": {
          r.text = n.allText;
          break;
        }
        case "textModifierKeyOptionalValue": {
          let o = n.children[0].allText;
          o = this.modifierKeyMappings[o] || o;
          const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
          switch (o) {
            // case 'emphasis': {
            //   if (!textModifierObject.tags[ssmlTag]) {
            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
            //   }
            //   textModifierObject.tags[ssmlTag].attrs = { level: value || 'moderate' };
            //   break;
            // }
            // case 'address':
            // case 'expletive':
            // case 'telephone':
            // case 'unit':
            case "fraction":
            case "ordinal":
              r.tag(a, { "interpret-as": o });
              break;
            case "number":
              r.tag(a, { "interpret-as": "cardinal" });
              break;
            case "characters": {
              let u = "digits";
              isNaN(r.text) && (u = "spell-out"), r.tag(a, { "interpret-as": u });
              break;
            }
            // case 'date': {
            //   if (!textModifierObject.tags[ssmlTag]) {
            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
            //   }
            //   textModifierObject.tags[ssmlTag].attrs = { 'interpret-as': key, format: value || 'ymd' };
            //   break;
            // }
            // case 'time': {
            //   if (!textModifierObject.tags[ssmlTag]) {
            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
            //   }
            //   textModifierObject.tags[ssmlTag].attrs = { 'interpret-as': key, format: value || 'hms12' };
            //   break;
            // }
            case "whisper":
              r.tag(a, { volume: "x-soft", rate: "slow" });
              break;
            // case 'ipa': {
            //   // Google Assistant does not support <phoneme> tag
            //   if (!textModifierObject.tags[ssmlTag]) {
            //     textModifierObject.tags[ssmlTag] = { sortId: sortId, attrs: null };
            //   }
            //   textModifierObject['textOnly'] = true;
            //   break;
            // }
            case "sub":
              r.tag(a, { alias: s });
              break;
            case "volume":
            case "rate":
            case "pitch": {
              const u = {};
              u[o] = s || "medium", r.tag(a, u, !0);
              break;
            }
          }
          break;
        }
      }
    }
    return r;
  }
  // tslint:disable-next-line: max-func-body-length
  formatFromAst(t, r = []) {
    switch (t.name) {
      case "document":
        return this.options.includeFormatterComment && this.addComment("Converted from Speech Markdown to SSML for Samsung Bixby", r), this.options.includeSpeakTag ? this.addSpeakTag(t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
      case "paragraph":
        return this.options.includeParagraphTag ? this.addTag("p", t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
      case "shortBreak": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, null, "break", { time: i });
      }
      case "break": {
        const i = t.children[0].allText;
        let n = {};
        switch (t.children[0].children[0].name) {
          case "breakStrengthValue":
            n = { strength: i };
            break;
          case "time":
            n = { time: i };
            break;
        }
        return this.addTagWithAttrs(r, null, "break", n);
      }
      case "shortEmphasisModerate":
      case "shortEmphasisStrong":
      case "shortEmphasisNone":
      case "shortEmphasisReduced": {
        const i = t.children[0].allText;
        return i && r.push(i), r;
      }
      // case 'shortEmphasisStrong': {
      //   const text = ast.children[0].allText;
      //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'strong' });
      // }
      // case 'shortEmphasisNone': {
      //   const text = ast.children[0].allText;
      //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'none' });
      // }
      // case 'shortEmphasisReduced': {
      //   const text = ast.children[0].allText;
      //   return this.addTagWithAttrs(lines, text, 'emphasis', { level: 'reduced' });
      // }
      // case 'textModifier': {
      //   const tmo = this.getTextModifierObject(ast);
      //   if (tmo.textOnly) {
      //     // Quick return if tag is not supported
      //     lines.push(tmo.text)
      //     return lines
      //   }
      //   const tagsSortedDesc = Object.keys(tmo.tags).sort((a: any, b: any) => { return tmo.tags[b].sortId - tmo.tags[a].sortId });
      //   let inner = tmo.text;
      //   for (let index = 0; index < tagsSortedDesc.length; index++) {
      //     const tag = tagsSortedDesc[index];
      //     const attrs = tmo.tags[tag].attrs;
      //     inner = this.getTagWithAttrs(inner, tag, attrs);
      //   }
      //   lines.push(inner);
      //   return lines;
      // }
      case "textModifier": {
        const i = this.getTextModifierObject(t);
        if (i.textOnly)
          return r.push(i.text), r;
        const n = Object.keys(i.tags).sort((s, a) => i.tags[a].sortId - i.tags[s].sortId);
        let o = i.text;
        for (let s = 0; s < n.length; s++) {
          const a = n[s], u = i.tags[a].attrs;
          o = this.getTagWithAttrs(o, a, u);
        }
        return r.push(o), r;
      }
      case "audio": {
        const i = t.children[0].allText.replace(/&/g, "&amp;");
        return this.addTagWithAttrs(r, null, "audio", { src: i }, !0);
      }
      case "simpleLine":
        return this.processAst(t.children, r), r;
      case "lineEnd":
        return r.push(t.allText), r;
      case "emptyLine":
        return this.options.preserveEmptyLines && r.push(t.allText), r;
      case "plainText":
      case "plainTextSpecialChars":
      case "plainTextEmphasis":
      case "plainTextPhone":
      case "plainTextModifier":
        return r.push(t.allText), r;
      default:
        return this.processAst(t.children, r), r;
    }
  }
}
class A9 extends cr {
  constructor(t) {
    super(t), this.options = t, this.modifierKeyToSsmlTagMappings.emphasis = "emphasis", this.modifierKeyToSsmlTagMappings.address = "say-as", this.modifierKeyToSsmlTagMappings.number = "say-as", this.modifierKeyToSsmlTagMappings.characters = "say-as", this.modifierKeyToSsmlTagMappings.expletive = null, this.modifierKeyToSsmlTagMappings.fraction = "say-as", this.modifierKeyToSsmlTagMappings.interjection = null, this.modifierKeyToSsmlTagMappings.ordinal = "say-as", this.modifierKeyToSsmlTagMappings.telephone = "say-as", this.modifierKeyToSsmlTagMappings.unit = null, this.modifierKeyToSsmlTagMappings.time = "say-as", this.modifierKeyToSsmlTagMappings.date = "say-as", this.modifierKeyToSsmlTagMappings.sub = "sub", this.modifierKeyToSsmlTagMappings.paragraph = "p", this.modifierKeyToSsmlTagMappings.sentence = "s", this.modifierKeyToSsmlTagMappings.lang = "lang", this.modifierKeyToSsmlTagMappings.voice = "voice", this.modifierKeyToSsmlTagMappings.ipa = "phoneme", this.modifierKeyToSsmlTagMappings.sapi = "phoneme", this.modifierKeyToSsmlTagMappings.ups = "phoneme", this.modifierKeyToSsmlTagMappings.pitch = "prosody", this.modifierKeyToSsmlTagMappings.contour = "prosody", this.modifierKeyToSsmlTagMappings.range = "prosody", this.modifierKeyToSsmlTagMappings.rate = "prosody", this.modifierKeyToSsmlTagMappings.volume = "prosody", this.modifierKeyToSsmlTagMappings.whisper = "prosody", this.modifierKeyToSsmlTagMappings.emotion = "mstts:express-as", this.ssmlTagSortOrder = [
      "voice",
      "lang",
      "p",
      "s",
      "emphasis",
      "say-as",
      "mstts:express-as",
      "prosody",
      "sub",
      "phoneme"
    ];
  }
  // tslint:disable-next-line: max-func-body-length
  getTextModifierObject(t) {
    let r = new Xe(this);
    for (let i = 0; i < t.children.length; i++) {
      const n = t.children[i];
      switch (n.name) {
        case "plainText":
        case "plainTextSpecialChars":
        case "plainTextEmphasis":
        case "plainTextPhone":
        case "plainTextModifier": {
          r.text = n.allText;
          break;
        }
        case "textModifierKeyOptionalValue": {
          let o = n.children[0].allText;
          o = this.modifierKeyMappings[o] || o;
          const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
          switch (o) {
            case "address":
            case "fraction":
            case "ordinal":
            case "telephone":
              r.tag(
                a,
                { "interpret-as": o },
                !1,
                this.ssmlTagSortOrder
              );
              break;
            case "number":
              r.tag(
                a,
                { "interpret-as": "cardinal" },
                !1,
                this.ssmlTagSortOrder
              );
              break;
            case "characters": {
              let u = "digits";
              isNaN(r.text) && (u = "characters"), r.tag(
                a,
                { "interpret-as": u },
                !1,
                this.ssmlTagSortOrder
              );
              break;
            }
            case "date":
              r.tag(
                a,
                { "interpret-as": o, format: s || "ymd" },
                !1,
                this.ssmlTagSortOrder
              );
              break;
            case "time":
              r.tag(
                a,
                { "interpret-as": o, format: s || "hms12" },
                !1,
                this.ssmlTagSortOrder
              );
              break;
            case "whisper":
              r.tag(
                a,
                { volume: "x-soft", rate: "slow" },
                !1,
                this.ssmlTagSortOrder
              );
              break;
            case "ipa":
            case "sapi":
            case "ups":
              r.tag(
                a,
                { alphabet: o, ph: s },
                !1,
                this.ssmlTagSortOrder
              );
              break;
            case "sub":
              r.tag(
                a,
                { alias: s },
                !1,
                this.ssmlTagSortOrder
              );
              break;
            case "volume":
            case "rate":
            case "pitch": {
              const u = {};
              u[o] = s || "medium", r.tag(
                a,
                u,
                !0,
                this.ssmlTagSortOrder
              );
              break;
            }
            case "lang":
              r.tag(
                a,
                { "xml:lang": s },
                !1,
                this.ssmlTagSortOrder
              );
              break;
            case "voice": {
              const u = this.sentenceCase(s || "device");
              u != "Device" && r.tag(
                a,
                { name: u },
                !1,
                this.ssmlTagSortOrder
              );
              break;
            }
            case "emotion": {
              const u = s.split(" "), l = {};
              switch (u.length) {
                case 2:
                  const c = parseInt(u[1]);
                  isNaN(c) ? l.role = u[1] : l.styledegree = u[1];
                case 1:
                  l.style = u[0];
                  break;
              }
              r.tag(
                a,
                l,
                !0,
                this.ssmlTagSortOrder
              );
              break;
            }
            case "emphasis":
              r.tag(
                a,
                { level: s },
                !1,
                this.ssmlTagSortOrder
              );
              break;
            case "paragraph":
              r.tag(
                a,
                null,
                !1,
                this.ssmlTagSortOrder
              );
              break;
            case "sentence":
              r.tag(
                a,
                null,
                !1,
                this.ssmlTagSortOrder
              );
              break;
          }
          break;
        }
      }
    }
    return r;
  }
  // tslint:disable-next-line: max-func-body-length
  getSectionObject(t) {
    let r = new Xe(this);
    for (let i = 0; i < t.children.length; i++) {
      const n = t.children[i];
      if (n.name === "sectionModifierKeyOptionalValue") {
        let o = n.children[0].allText;
        const s = n.children.length === 2 ? n.children[1].allText : "", a = this.modifierKeyToSsmlTagMappings[o];
        switch (o) {
          case "voice": {
            const u = this.sentenceCase(s || "device");
            u != "Device" && r.tag(
              a,
              { name: u },
              !1,
              this.ssmlTagSortOrder
            );
            break;
          }
          case "defaults":
            break;
          case "emotion":
            r.tag(
              a,
              { style: s },
              !1,
              this.ssmlTagSortOrder
            );
            break;
        }
      }
    }
    return r;
  }
  // tslint:disable-next-line: max-func-body-length
  formatFromAst(t, r = []) {
    switch (t.name) {
      case "document":
        return this.options.includeFormatterComment && this.addComment(
          "Converted from Speech Markdown to SSML for Microsoft Azure",
          r
        ), this.options.includeSpeakTag ? this.addSpeakTag(t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
      case "paragraph":
        return this.options.includeParagraphTag ? this.addTag("p", t.children, !0, !1, null, r) : (this.processAst(t.children, r), r);
      case "shortBreak": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, null, "break", { time: i });
      }
      case "break": {
        const i = t.children[0].allText;
        let n = {};
        switch (t.children[0].children[0].name) {
          case "breakStrengthValue":
            n = { strength: i };
            break;
          case "time":
            n = { time: i };
            break;
        }
        return this.addTagWithAttrs(r, null, "break", n);
      }
      case "silence": {
        const i = t.children[0].allText.split(" "), n = {
          type: i[0],
          value: i[1]
        };
        return this.addTagWithAttrs(r, null, "mstts:silence", n);
      }
      case "backgroundAudio": {
        const i = t.children[0].allText.split(" ");
        let n = {};
        const o = ["src", "volume", "fadein", "fadeout"];
        for (let s = 0; s < i.length; s++)
          n[o[s]] = i[s];
        return this.addTagWithAttrs(
          r,
          null,
          "mstts:backgroundaudio",
          n
        );
      }
      case "lexicon": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, null, "lexicon", { uri: i });
      }
      case "bookmark": {
        const i = t.children[0].allText;
        return this.addTagWithAttrs(r, null, "bookmark", { mark: i });
      }
      case "shortEmphasisModerate":
      case "shortEmphasisStrong":
      case "shortEmphasisNone":
      case "shortEmphasisReduced": {
        const i = t.children[0].allText;
        return i && r.push(i), r;
      }
      case "textModifier": {
        const i = this.getTextModifierObject(t), n = Object.keys(i.tags).sort((s, a) => i.tags[a].sortId - i.tags[s].sortId);
        let o = i.text;
        for (let s = 0; s < n.length; s++) {
          const a = n[s], u = i.tags[a].attrs;
          if (a === "voice" || a === "lang") {
            const l = s < n.length - 1 ? n[s + 1] : "";
            o = this.getVoiceOrLangTagWithAttrs(
              o,
              a,
              u,
              l
            );
          } else
            o = this.getTagWithAttrs(o, a, u);
        }
        return r.push(o), r;
      }
      case "audio": {
        const i = t.children[0].allText.replace(/&/g, "&amp;");
        return this.addTagWithAttrs(r, null, "audio", { src: i }, !1);
      }
      case "simpleLine":
        return this.processAst(t.children, r), r;
      case "lineEnd":
        return r.push(t.allText), r;
      case "emptyLine":
        return this.options.preserveEmptyLines && r.push(t.allText), r;
      case "plainText":
      case "plainTextSpecialChars":
      case "plainTextEmphasis":
      case "plainTextPhone":
      case "plainTextModifier":
        return r.push(t.allText), r;
      case "section": {
        const i = this.getSectionObject(t), n = Object.keys(i.tags).sort((o, s) => i.tags[o].sortId - i.tags[s].sortId);
        return this.addSectionEndTag(r), this.addSectionStartTag(n, i, r), r;
      }
      default:
        return this.processAst(t.children, r), r;
    }
  }
  getVoiceOrLangTagWithAttrs(t, r, i, n) {
    let o = [];
    return t ? (o.push(this.startVoiceOrLangTag(r, i, n)), o.push(t), o.push(this.endVoiceOrLangTag(r, !1, n))) : o.push(this.voidTag(r, i)), o.join("");
  }
  // Returns the SSML for a start tag
  startVoiceOrLangTag(t, r, i, n = !1) {
    let o = "", s = "";
    switch (t) {
      case "voice":
        this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.voice && (s = "</voice>", this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && (s = "</lang>" + s));
        break;
      case "lang":
        i && i === "voice" || this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && (s = "</lang>");
        break;
    }
    return r && (o = " " + Object.keys(r).map((a) => a + '="' + r[a] + '"').join(" ")), s + "<" + t + o + ">" + (n ? `
` : "");
  }
  // Returns the SSML for an end tag
  endVoiceOrLangTag(t, r = !1, i) {
    let n = "";
    switch (t) {
      case "voice":
        this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.voice && (n = `<voice name="${this.options.globalVoiceAndLang.voice}">`, this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && (n += `<lang xml:lang="${this.options.globalVoiceAndLang.lang}">`));
        break;
      case "lang":
        i && i === "voice" || this.options.globalVoiceAndLang && this.options.globalVoiceAndLang.lang && t === "lang" && (n = `<lang xml:lang="${this.options.globalVoiceAndLang.lang}">`);
        break;
    }
    return (r ? `
` : "") + "</" + t + ">" + n;
  }
}
function T9(e) {
  switch (e.platform) {
    case "amazon-alexa":
      return new _9(e);
    case "amazon-polly":
      return new k9(e);
    case "amazon-polly-neural":
      return new x9(e);
    case "google-assistant":
      return new S9(e);
    case "samsung-bixby":
      return new E9(e);
    case "microsoft-azure":
      return new A9(e);
    default:
      return new Ob(e);
  }
}
function C9(e) {
  return new Ob(e);
}
var In = { exports: {} }, q0 = In.exports, z0;
function R9() {
  return z0 || (z0 = 1, (function(e, t) {
    var r = q0 && q0.__extends || function(n, o) {
      for (var s in o) o.hasOwnProperty(s) && (n[s] = o[s]);
      function a() {
        this.constructor = n;
      }
      n.prototype = o === null ? Object.create(o) : (a.prototype = o.prototype, new a());
    }, i;
    (function(n) {
      var o = (function(q) {
        r(z, q);
        function z(ne) {
          q.call(this, ne), this.type = "ParserError";
        }
        return z;
      })(Error);
      n.ParserError = o, n.grammars = {}, n.allRules = {}, n.parsers = {};
      var s = (function() {
        function q(z, ne) {
          this.input = z, this.index = ne, this.lineNum = 0, this.colNum = 0, this.lineStart = 0, this.lineEnd = 0;
          for (var fe = 0, ce = 1, _e = 0; _e < this.index; ++_e)
            this.input.charCodeAt(_e) == 13 && (this.lineStart = _e, fe++), this.input.charCodeAt(_e) == 10 && (this.lineStart = _e, ce++);
          for (this.lineEnd = this.index; this.lineEnd < this.input.length && !(this.input.charCodeAt(this.lineEnd) == 13 || this.input.charCodeAt(this.lineEnd) == 10); ++this.lineEnd)
            ;
          this.lineNum = fe > ce ? fe : ce, this.colNum = this.index - this.lineStart, this.lineText = this.input.substring(this.lineStart, this.lineEnd), this.pointerText = Array(this.colNum).join(" ") + "^";
        }
        return q.prototype.toString = function() {
          return "Index " + this.index + ", Line " + this.lineNum + ", Column " + this.colNum + `
` + this.lineText + `
` + this.pointerText;
        }, q;
      })();
      n.ParseLocation = s;
      var a = (function() {
        function q(z, ne, fe) {
          this.input = z, this.index = ne, this.nodes = fe, this.length = 0, this.rules = [], this.length = this.input.length;
        }
        return Object.defineProperty(q.prototype, "location", {
          // Returns an object that representation of the location. 
          get: function() {
            return new s(this.input, this.index);
          },
          enumerable: !0,
          configurable: !0
        }), q;
      })();
      n.ParseState = a;
      var u = (function() {
        function q(z, ne, fe, ce) {
          fe === void 0 && (fe = 0), ce === void 0 && (ce = -1), this.rule = z, this.input = ne, this.start = fe, this.end = ce, this.children = null;
        }
        return Object.defineProperty(q.prototype, "name", {
          // Returns the name of the rule associated with this node
          get: function() {
            return this.rule != null ? this.rule.name : "unnamed";
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "fullName", {
          // Returns the name of the rule, preceded by the grammar name, associated with this node
          get: function() {
            return this.rule != null ? this.rule.fullName : "unnamed";
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "allText", {
          // Returns the parsed text associated with this node's start and end locations  
          get: function() {
            return this.input.slice(this.start, this.end);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "isLeaf", {
          // Returns true if this node has no children
          get: function() {
            return this.children == null || this.children.length == 0;
          },
          enumerable: !0,
          configurable: !0
        }), q.prototype.child = function(z) {
          if (this.children)
            for (var ne = 0, fe = this.children; ne < fe.length; ne++) {
              var ce = fe[ne];
              if (ce.name == z)
                return ce;
            }
          return null;
        }, Object.defineProperty(q.prototype, "_firstChildStart", {
          // The position of the first child, or the end position for the entire node if no children 
          get: function() {
            return this.isLeaf ? this.end : this.children[0].start;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "_lastChildEnd", {
          // The end position of the last child, or the end position for the entire node if no children 
          get: function() {
            return this.isLeaf ? this.end : this.children[0].end;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "beforeChildrenText", {
          // Returns the text before the children, or if no children returns the entire text. 
          get: function() {
            return this.input.slice(this.start, this._firstChildStart);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "afterChildrenText", {
          // Returns the text after the children, or if no children returns the empty string.
          get: function() {
            return this.input.slice(this._lastChildEnd, this.end);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "allChildrenText", {
          // Returns the text from the beginning of the first child to the end of the last child.
          get: function() {
            return this.input.slice(this._firstChildStart, this._lastChildEnd);
          },
          enumerable: !0,
          configurable: !0
        }), q.prototype.toString = function() {
          var z = this.isLeaf ? this.allText : this.children.map(function(ne) {
            return ne.toString();
          }).join(" ");
          return "(" + this.rule.name + ": " + z + ")";
        }, q;
      })();
      n.AstNode = u;
      var l = (function() {
        function q(z) {
          this.rules = z, this.name = "", this.grammarName = "", this.type = "", this.className = "Rule", this._createAstNode = !1, this.parser = null, this.lexer = null;
        }
        return q.prototype.node = function(z) {
          z === void 0 && (z = "");
          for (var ne = [], fe = 1; fe < arguments.length; fe++)
            ne[fe - 1] = arguments[fe];
          var ce = new u(this, z, 0, z.length);
          return ce.children = ne, ce;
        }, q.prototype.parse = function(z) {
          return n.parse(this, z);
        }, q.prototype.setName = function(z, ne) {
          return this.grammarName = z, this.name = ne, this;
        }, Object.defineProperty(q.prototype, "definition", {
          // Returns a default definition of the rule
          get: function() {
            return this.className + "(" + this.rules.map(function(z) {
              return z.toString();
            }).join(", ") + ")";
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "fullName", {
          // Returns the name of the rule preceded by the grammar name and a "."
          get: function() {
            return this.grammarName + "." + this.name;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "nameOrDefinition", {
          // Returns either the name of the rule, or it's definition
          get: function() {
            return this.name ? this.fullName : this.definition;
          },
          enumerable: !0,
          configurable: !0
        }), q.prototype.toString = function() {
          return this.nameOrDefinition;
        }, Object.defineProperty(q.prototype, "firstChild", {
          // Returns the first child rule
          get: function() {
            return this.rules[0];
          },
          enumerable: !0,
          configurable: !0
        }), q.prototype.setType = function(z) {
          return this.type = z, this;
        }, q.prototype.cloneImplementation = function() {
          throw new Error("Missing override for cloneImplementation");
        }, Object.defineProperty(q.prototype, "copy", {
          // Returns a copy of this rule with all fields copied.  
          get: function() {
            var z = this.cloneImplementation();
            if (typeof z != typeof this)
              throw new Error("Error in implementation of cloneImplementation: not returning object of correct type");
            return z.name = this.name, z.grammarName = this.grammarName, z._createAstNode = this._createAstNode, z;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "hasAstChildRule", {
          // Returns true if any of the child rules are "ast rules" meaning they create nodes in the parse tree.
          get: function() {
            return this.rules.filter(function(z) {
              return z.createsAstNode;
            }).length > 0;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "createsAstNode", {
          // Returns true if this rule when parsed successfully will create a node in the parse tree. 
          // Some rules will override this function. 
          get: function() {
            return this._createAstNode;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "nonAdvancing", {
          // Returns true if this rule doesn't advance the input
          get: function() {
            return !1;
          },
          enumerable: !0,
          configurable: !0
        }), q.prototype.astRuleDefn = function(z, ne) {
          z === void 0 && (z = !1), ne === void 0 && (ne = !1);
          var fe = this.rules.filter(function(Se) {
            return Se.createsAstNode;
          });
          if (!fe.length)
            return this.name;
          if (fe.length == 1) {
            var ce = fe[0].astRuleNameOrDefn(z, ne);
            return this instanceof f && (ce += "[" + this.min + "," + this.max + "]"), ce;
          }
          if (this instanceof d) {
            var _e = fe.map(function(Se) {
              return Se.astRuleNameOrDefn(!0, !1);
            }).join(",");
            return z ? _e : "seq(" + _e + ")";
          }
          if (this instanceof h) {
            var _e = fe.map(function(Pe) {
              return Pe.astRuleNameOrDefn(!1, !0);
            }).join(",");
            return ne ? _e : "choice(" + _e + ")";
          }
          throw new Error("Internal error: not a valid AST rule");
        }, q.prototype.astRuleNameOrDefn = function(z, ne) {
          return z === void 0 && (z = !1), ne === void 0 && (ne = !1), this._createAstNode ? this.name : this.astRuleDefn(z, ne);
        }, Object.defineProperty(q.prototype, "opt", {
          //======================================================
          // Extensions to support method/property chaining. 
          // This is also known as a fluent API syntax
          get: function() {
            return U(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "zeroOrMore", {
          get: function() {
            return X(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "oneOrMore", {
          get: function() {
            return N(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "at", {
          get: function() {
            return R(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "not", {
          get: function() {
            return P(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "advance", {
          get: function() {
            return this.then(n.advance);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "ws", {
          get: function() {
            return this.then(n.ws);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "all", {
          get: function() {
            return this.then(n.all);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "end", {
          get: function() {
            return this.then(n.end);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "assert", {
          get: function() {
            return Y(this);
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(q.prototype, "ast", {
          get: function() {
            return new c(this);
          },
          enumerable: !0,
          configurable: !0
        }), q.prototype.then = function(z) {
          return H(this, z);
        }, q.prototype.thenAt = function(z) {
          return this.then(R(z));
        }, q.prototype.thenNot = function(z) {
          return this.then(P(z));
        }, q.prototype.or = function(z) {
          return J(this, z);
        }, q.prototype.until = function(z) {
          return Re(this, z);
        }, q.prototype.untilPast = function(z) {
          return te(this, z);
        }, q.prototype.repeat = function(z) {
          return G(this, z);
        }, q.prototype.quantified = function(z, ne) {
          return V(this, z, ne);
        }, q.prototype.delimited = function(z) {
          return we(this, z);
        }, q.prototype.unless = function(z) {
          return ve(this, z);
        }, q;
      })();
      n.Rule = l;
      var c = (function(q) {
        r(z, q);
        function z(ne) {
          var fe = this;
          q.call(this, [ne]), this.r = ne, this.type = "ast", this.className = "AstRule", this._createAstNode = !0, this.parser = function(ce) {
            var _e = ce.index, Se = ce.nodes;
            if (ce.nodes = [], ce.rules.push(fe), ne.parser(ce)) {
              ce.rules.pop();
              var Pe = new u(fe, ce.input, _e, ce.index);
              return Pe.children = ce.nodes, ce.nodes = Se, ce.nodes.push(Pe), !0;
            } else
              return ce.rules.pop(), ce.nodes = Se, ce.index = _e, !1;
          }, this.lexer = ne.lexer;
        }
        return z;
      })(l);
      n.AstRule = c;
      var d = (function(q) {
        r(z, q);
        function z(ne, fe) {
          q.call(this, [ne, fe]), this.rule1 = ne, this.rule2 = fe, this.type = "seq", this.className = "Sequence", this.parser = function(ce) {
            var _e = ce.nodes.length, Se = ce.index;
            return ne.parser(ce) === !1 ? !1 : fe.parser(ce) === !1 ? (ce.nodes.length !== _e && ce.nodes.splice(-1, ce.nodes.length - _e), ce.index = Se, !1) : !0;
          }, this.lexer = function(ce) {
            var _e = ce.index;
            return ne.lexer(ce) === !1 ? !1 : fe.lexer(ce) === !1 ? (ce.index = _e, !1) : !0;
          }, this.createsAstNode || (this.parser = this.lexer);
        }
        return Object.defineProperty(z.prototype, "definition", {
          get: function() {
            var ne = this.rules.map(function(fe) {
              return fe.toString();
            }).join(" ");
            return this.rules.length > 1 && (ne = "(" + ne + ")"), ne;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(z.prototype, "nonAdvancing", {
          get: function() {
            return this.rules.every(function(ne) {
              return ne.nonAdvancing;
            });
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(z.prototype, "createsAstNode", {
          get: function() {
            return this._createAstNode || this.hasAstChildRule;
          },
          enumerable: !0,
          configurable: !0
        }), z.prototype.cloneImplementation = function() {
          return new z(this.rule1, this.rule2);
        }, z;
      })(l);
      n.Sequence = d;
      var h = (function(q) {
        r(z, q);
        function z(ne, fe) {
          q.call(this, [ne, fe]), this.rule1 = ne, this.rule2 = fe, this.type = "choice", this.className = "Choice", this.parser = function(ce) {
            return ne.parser(ce) || fe.parser(ce);
          }, this.lexer = function(ce) {
            return ne.lexer(ce) || fe.lexer(ce);
          }, this.createsAstNode || (this.parser = this.lexer);
        }
        return Object.defineProperty(z.prototype, "definition", {
          get: function() {
            var ne = this.rules.map(function(fe) {
              return fe.toString();
            }).join(" / ");
            return this.rules.length > 1 && (ne = "(" + ne + ")"), ne;
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(z.prototype, "nonAdvancing", {
          get: function() {
            return this.rules.every(function(ne) {
              return ne.nonAdvancing;
            });
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(z.prototype, "createsAstNode", {
          get: function() {
            return this._createAstNode || this.hasAstChildRule;
          },
          enumerable: !0,
          configurable: !0
        }), z.prototype.cloneImplementation = function() {
          return new z(this.rule1, this.rule2);
        }, z;
      })(l);
      n.Choice = h;
      var f = (function(q) {
        r(z, q);
        function z(ne, fe, ce) {
          var _e = this;
          if (fe === void 0 && (fe = 0), ce === void 0 && (ce = 1 / 0), q.call(this, [ne]), this.min = fe, this.max = ce, this.type = "quantified", this.className = "Quantified", ce === 1 / 0 && ne.nonAdvancing)
            throw new Error("Rule would create an infinite loop");
          this.parser = function(Se) {
            for (var Pe = Se.nodes.length, ze = Se.index, dt = 0; dt < ce; ++dt) {
              if (ne.parser(Se) === !1)
                return dt >= fe ? !0 : (Se.nodes.length !== Pe && Se.nodes.splice(-1, Se.nodes.length - Pe), Se.index = ze, !1);
              pi(ce !== 1 / 0 || Se.index !== ze, _e);
            }
            return !0;
          }, this.lexer = function(Se) {
            for (var Pe = Se.index, ze = 0; ze < ce; ++ze) {
              if (ne.lexer(Se) === !1)
                return ze >= fe ? !0 : (Se.index = Pe, !1);
              pi(ce !== 1 / 0 || Se.index !== Pe, _e, "Infinite loop");
            }
            return !0;
          }, this.createsAstNode || (this.parser = this.lexer);
        }
        return Object.defineProperty(z.prototype, "definition", {
          // Used for creating a human readable definition of the grammar.
          get: function() {
            return this.min == 0 && this.max == 1 ? this.firstChild.toString() + "?" : this.min == 0 && this.max == 1 / 0 ? this.firstChild.toString() + "*" : this.min == 1 && this.max == 1 / 0 ? this.firstChild.toString() + "+" : this.firstChild.toString() + "{" + this.min + "," + this.max + "}";
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(z.prototype, "createsAstNode", {
          get: function() {
            return this._createAstNode || this.hasAstChildRule;
          },
          enumerable: !0,
          configurable: !0
        }), z.prototype.cloneImplementation = function() {
          return new z(this.firstChild, this.min, this.max);
        }, z;
      })(l);
      n.Quantified = f;
      var p = (function(q) {
        r(z, q);
        function z(ne) {
          q.call(this, ne, 0, 1), this.type = "optional", this.className = "Optional", this.parser = function(fe) {
            return ne.parser(fe), !0;
          }, this.lexer = function(fe) {
            return ne.lexer(fe), !0;
          }, this.createsAstNode || (this.parser = this.lexer);
        }
        return Object.defineProperty(z.prototype, "definition", {
          // Used for creating a human readable definition of the grammar.
          get: function() {
            return this.firstChild.toString() + "?";
          },
          enumerable: !0,
          configurable: !0
        }), z.prototype.cloneImplementation = function() {
          return new z(this.firstChild);
        }, z;
      })(f);
      n.Optional = p;
      var m = (function(q) {
        r(z, q);
        function z() {
          q.call(this, []), this.type = "advance", this.className = "Advance", this.lexer = function(ne) {
            return ne.index < ne.length ? ++ne.index >= 0 : !1;
          }, this.parser = this.lexer;
        }
        return Object.defineProperty(z.prototype, "definition", {
          get: function() {
            return "<advance>";
          },
          enumerable: !0,
          configurable: !0
        }), z.prototype.cloneImplementation = function() {
          return new z();
        }, z;
      })(l);
      n.Advance = m;
      var w = (function(q) {
        r(z, q);
        function z(ne) {
          q.call(this, [ne]), this.type = "advanceIf", this.className = "AdvanceIf", this.lexer = function(fe) {
            return ne.lexer(fe) && fe.index < fe.length ? ++fe.index !== 0 : !1;
          }, this.parser = this.lexer;
        }
        return Object.defineProperty(z.prototype, "definition", {
          get: function() {
            return "advanceIf(" + this.firstChild.toString() + ")";
          },
          enumerable: !0,
          configurable: !0
        }), z.prototype.cloneImplementation = function() {
          return new z(this.firstChild);
        }, z;
      })(l);
      n.AdvanceIf = w;
      var v = (function(q) {
        r(z, q);
        function z(ne) {
          q.call(this, []), this.text = ne, this.type = "text", this.className = "Text";
          for (var fe = ne.length, ce = [], _e = 0; _e < fe; ++_e)
            ce.push(ne.charCodeAt(_e));
          this.lexer = function(Se) {
            var Pe = Se.index;
            if (Pe + ce.length > Se.input.length)
              return !1;
            for (var ze = 0, dt = ce; ze < dt.length; ze++) {
              var mi = dt[ze];
              if (Se.input.charCodeAt(Pe++) !== mi)
                return !1;
            }
            return Se.index = Pe, !0;
          }, this.parser = this.lexer;
        }
        return Object.defineProperty(z.prototype, "definition", {
          get: function() {
            return '"' + bn(this.text) + '"';
          },
          enumerable: !0,
          configurable: !0
        }), z.prototype.cloneImplementation = function() {
          return new z(this.text);
        }, z;
      })(l);
      n.Text = v;
      var g = (function(q) {
        r(z, q);
        function z(ne) {
          q.call(this, []), this.text = ne, this.type = "anyCaseText", this.className = "AnyCaseText", ne = ne.toLowerCase(), this.text = ne;
          for (var fe = ne.length, ce = [], _e = 0; _e < fe; ++_e)
            ce.push(ne[_e]);
          this.lexer = function(Se) {
            var Pe = Se.index;
            if (Pe + ce.length > Se.input.length)
              return !1;
            for (var ze = 0, dt = ce; ze < dt.length; ze++) {
              var mi = dt[ze];
              if (Se.input[Pe++].toLowerCase() !== mi)
                return !1;
            }
            return Se.index = Pe, !0;
          }, this.parser = this.lexer;
        }
        return Object.defineProperty(z.prototype, "definition", {
          get: function() {
            return 'AnyCase("' + bn(this.text) + '")';
          },
          enumerable: !0,
          configurable: !0
        }), z.prototype.cloneImplementation = function() {
          return new z(this.text);
        }, z;
      })(l);
      n.AnyCaseText = g;
      var A = (function(q) {
        r(z, q);
        function z(ne) {
          q.call(this, []), this.fn = ne, this.type = "delay", this.className = "Delay";
          var fe = null;
          this.parser = function(_e) {
            return (fe || (fe = ne().parser))(_e);
          };
          var ce = null;
          this.lexer = function(_e) {
            return (ce || (ce = ne().lexer))(_e);
          };
        }
        return z.prototype.cloneImplementation = function() {
          return new z(this.fn);
        }, Object.defineProperty(z.prototype, "definition", {
          get: function() {
            return "<delay>";
          },
          enumerable: !0,
          configurable: !0
        }), Object.defineProperty(z.prototype, "createsAstNode", {
          // It is assumed that a delay function creates an AST node,
          get: function() {
            return !0;
          },
          enumerable: !0,
          configurable: !0
        }), z;
      })(l);
      n.Delay = A;
      var b = (function(q) {
        r(z, q);
        function z(ne) {
          q.call(this, ne), this.type = "charSet";
        }
        return Object.defineProperty(z.prototype, "nonAdvancing", {
          get: function() {
            return !0;
          },
          enumerable: !0,
          configurable: !0
        }), z;
      })(l);
      n.NonAdvancingRule = b;
      var k = (function(q) {
        r(z, q);
        function z(ne) {
          q.call(this, []), this.chars = ne, this.type = "charSet", this.className = "CharSet";
          for (var fe = [], ce = ne.length, _e = 0; _e < ce; ++_e)
            fe[_e] = ne.charCodeAt(_e);
          this.lexer = function(Se) {
            return fe.indexOf(Se.input.charCodeAt(Se.index)) >= 0;
          }, this.parser = this.lexer;
        }
        return Object.defineProperty(z.prototype, "definition", {
          get: function() {
            return "[" + bn(this.chars) + "]";
          },
          enumerable: !0,
          configurable: !0
        }), z.prototype.cloneImplementation = function() {
          return new z(this.chars);
        }, z;
      })(b);
      n.CharSet = k;
      var y = (function(q) {
        r(z, q);
        function z(ne, fe) {
          q.call(this, []), this.min = ne, this.max = fe, this.type = "charRange", this.className = "CharRange";
          var ce = ne.charCodeAt(0), _e = fe.charCodeAt(0);
          this.lexer = function(Se) {
            var Pe = Se.input.charCodeAt(Se.index);
            return Pe >= ce && Pe <= _e;
          }, this.parser = this.lexer;
        }
        return Object.defineProperty(z.prototype, "definition", {
          get: function() {
            return "[" + this.min + ".." + this.max + "]";
          },
          enumerable: !0,
          configurable: !0
        }), z.prototype.cloneImplementation = function() {
          return new z(this.min, this.max);
        }, z;
      })(b);
      n.CharRange = y;
      var x = (function(q) {
        r(z, q);
        function z(ne) {
          q.call(this, [ne]), this.type = "not", this.className = "Not";
          var fe = ne.lexer;
          this.lexer = function(ce) {
            if (ce.index >= ce.length)
              return !0;
            var _e = ce.index;
            return fe(ce) === !1 ? !0 : (ce.index = _e, !1);
          }, this.parser = this.lexer;
        }
        return z.prototype.cloneImplementation = function() {
          return new z(this.firstChild);
        }, Object.defineProperty(z.prototype, "definition", {
          get: function() {
            return "!" + this.firstChild.toString();
          },
          enumerable: !0,
          configurable: !0
        }), z;
      })(b);
      n.Not = x;
      var C = (function(q) {
        r(z, q);
        function z(ne) {
          q.call(this, [ne]), this.type = "at", this.className = "At";
          var fe = ne.lexer;
          this.lexer = function(ce) {
            var _e = ce.index;
            return fe(ce) === !1 ? !1 : (ce.index = _e, !0);
          }, this.parser = this.lexer;
        }
        return z.prototype.cloneImplementation = function() {
          return new z(this.firstChild);
        }, Object.defineProperty(z.prototype, "definition", {
          get: function() {
            return "&" + this.firstChild.toString();
          },
          enumerable: !0,
          configurable: !0
        }), z;
      })(b);
      n.At = C;
      var I = (function(q) {
        r(z, q);
        function z(ne) {
          q.call(this, []), this.fn = ne, this.type = "predicate", this.className = "Predicate", this.lexer = ne, this.parser = this.lexer;
        }
        return z.prototype.cloneImplementation = function() {
          return new z(this.fn);
        }, Object.defineProperty(z.prototype, "definition", {
          get: function() {
            return "<predicate>";
          },
          enumerable: !0,
          configurable: !0
        }), z;
      })(b);
      n.Predicate = I;
      function M(q) {
        return new v(q);
      }
      n.text = M;
      function Q(q) {
        return new g(q);
      }
      n.textAnyCase = Q;
      function H() {
        for (var q = [], z = 0; z < arguments.length; z++)
          q[z - 0] = arguments[z];
        var ne = q.map(wt);
        if (ne.length == 0)
          throw new Error("At least one rule is expected when calling `seq`");
        if (ne.length == 1)
          return ne[0];
        var fe = ne[0], ce = H.apply(void 0, ne.slice(1));
        return fe.nonAdvancing && ce instanceof m ? new w(fe) : new d(fe, ce);
      }
      n.seq = H;
      function J() {
        for (var q = [], z = 0; z < arguments.length; z++)
          q[z - 0] = arguments[z];
        var ne = q.map(wt);
        if (ne.length == 0)
          throw new Error("At least one rule is expected when calling `choice`");
        if (ne.length == 1)
          return ne[0];
        var fe = ne[0], ce = J.apply(void 0, ne.slice(1));
        return fe instanceof w && ce instanceof w ? new w(J(fe.firstChild, ce.firstChild)) : new h(fe, ce);
      }
      n.choice = J;
      function W(q) {
        return new A(q);
      }
      n.delay = W;
      function P(q) {
        return new x(wt(q));
      }
      n.not = P;
      function R(q) {
        return new C(wt(q));
      }
      n.at = R;
      function V(q, z, ne) {
        return z === void 0 && (z = 0), ne === void 0 && (ne = 1 / 0), z === 0 && ne === 1 ? new p(wt(q)) : new f(wt(q), z, ne);
      }
      n.quantified = V;
      function X(q) {
        return V(q).setType("zeroOrMore");
      }
      n.zeroOrMore = X;
      function N(q) {
        return V(q, 1).setType("oneOrMore");
      }
      n.oneOrMore = N;
      function U(q) {
        return V(q, 0, 1).setType("optional");
      }
      n.opt = U;
      function G(q, z) {
        return V(q, z, z).setType("repeat");
      }
      n.repeat = G;
      function re(q) {
        return new k(q);
      }
      n.atChar = re;
      function oe(q) {
        return re(q).not;
      }
      n.notAtChar = oe;
      function ie(q) {
        return re(q).advance;
      }
      n.char = ie;
      function le(q) {
        return oe(q).advance;
      }
      n.notChar = le;
      function he(q, z) {
        return new y(q, z);
      }
      n.atRange = he;
      function ye(q, z) {
        return he(q, z).advance;
      }
      n.range = ye;
      function be(q, z) {
        return ye(q, z).not;
      }
      n.notRange = be;
      function we(q, z) {
        return U(H(q, H(z, q).zeroOrMore)).setType("delimitedList");
      }
      n.delimited = we;
      function ve(q, z) {
        return H(P(z), q).setType("unless");
      }
      n.unless = ve;
      function Re(q, z) {
        return ve(q, z).zeroOrMore.setType("repeatWhileNot");
      }
      n.repeatWhileNot = Re;
      function De(q, z) {
        return P(z).then(q).then(Re(q, z)).setType("repeatOneOrMoreWhileNot");
      }
      n.repeatOneOrMoreWhileNot = De;
      function te(q, z) {
        return Re(q, z).then(z).setType("repeatUntilPast");
      }
      n.repeatUntilPast = te;
      function Z(q, z) {
        return P(z).then(q).then(te(q, z)).setType("repeatOneOrMoreUntilPast");
      }
      n.repeatOneOrMoreUntilPast = Z;
      function ue(q) {
        return Re(n.advance, q).setType("advanceWhileNot");
      }
      n.advanceWhileNot = ue;
      function pe(q) {
        return De(n.advance, q).setType("advanceOneOrMoreWhileNot");
      }
      n.advanceOneOrMoreWhileNot = pe;
      function me(q) {
        return te(n.advance, q).setType("advanceUntilPast");
      }
      n.advanceUntilPast = me;
      function L(q) {
        return Z(n.advance, q).setType("advanceOneOrMoreUntilPast");
      }
      n.advanceOneOrMoreUntilPast = L;
      function B(q) {
        return n.advance.unless(q).setType("advanceUnless");
      }
      n.advanceUnless = B;
      function D(q) {
        return new I(q);
      }
      n.predicate = D;
      function E(q) {
        return D(function(z) {
          return q(z), !0;
        }).setType("action");
      }
      n.action = E;
      function T(q) {
        return q === void 0 && (q = ""), E(function(z) {
          console.log(q);
        }).setType("log");
      }
      n.log = T;
      function j(q) {
        return E(function(z) {
          var ne = new o(q + `
` + z.location.toString());
          throw ne;
        }).setType("err");
      }
      n.err = j;
      function Y(q) {
        return J(q, j("Expected: " + wt(q)));
      }
      n.assert = Y;
      function ae(q) {
        for (var z = [], ne = 1; ne < arguments.length; ne++)
          z[ne - 1] = arguments[ne];
        return H(q, H.apply(void 0, z.map(function(fe) {
          return Y(fe);
        }))).setType("guardedSeq");
      }
      n.guardedSeq = ae;
      function se(q) {
        return ae('"', q, Y('"')).setType("doubleQuoted");
      }
      n.doubleQuoted = se;
      function O(q) {
        return se(J(q, le('"').zeroOrMore)).setType("doubleQuotedString");
      }
      n.doubleQuotedString = O;
      function _(q) {
        return ae("'", q, Y("'")).setType("singleQuoted");
      }
      n.singleQuoted = _;
      function S(q) {
        return _(J(q, le("'").zeroOrMore)).setType("singleQuotedString");
      }
      n.singleQuotedString = S;
      function F(q) {
        return ae("(", n.ws, q, n.ws, ")").setType("parenthesized");
      }
      n.parenthesized = F;
      function $(q) {
        return ae("{", n.ws, q, n.ws, "}").setType("braced");
      }
      n.braced = $;
      function K(q) {
        return ae("[", n.ws, q, n.ws, "]").setType("bracketed");
      }
      n.bracketed = K;
      function ee(q) {
        return ae("<", n.ws, q, n.ws, ">").setType("tagged");
      }
      n.tagged = ee;
      function de(q) {
        return H(q, P(n.identifierNext)).setType("keyword");
      }
      n.keyword = de;
      function ge(q) {
        return H(Q(q), P(n.identifierNext)).setType("keywordAnyCase");
      }
      n.keywordAnyCase = ge;
      function ke() {
        for (var q = [], z = 0; z < arguments.length; z++)
          q[z - 0] = arguments[z];
        return J.apply(void 0, q.map(de));
      }
      n.keywords = ke, n.truePredicate = new I(function(q) {
        return !0;
      }), n.falsePredicate = new I(function(q) {
        return !1;
      }), n.end = new I(function(q) {
        return q.index >= q.length;
      }), n.notEnd = new I(function(q) {
        return q.index < q.length;
      }), n.advance = new m(), n.all = n.advance.zeroOrMore, n.atLetterLower = he("a", "z"), n.atLetterUpper = he("A", "Z"), n.atLetter = J(n.atLetterLower, n.atLetterUpper), n.atDigit = he("0", "9"), n.atDigitNonZero = he("1", "9"), n.atHexDigit = J(n.atDigit, he("a", "f"), he("A", "F")), n.atBinaryDigit = re("01"), n.atOctalDigit = he("0", "7"), n.atAlphaNumeric = J(n.atLetter, n.atDigit), n.atUnderscore = re("_"), n.atSpace = re(" "), n.atTab = re("	"), n.atWs = re(` 	\r
 \uFEFF`), n.atIdentifierNext = J(n.atAlphaNumeric, n.atUnderscore), n.letterLower = n.atLetterLower.advance, n.letterUpper = n.atLetterUpper.advance, n.letter = n.atLetter.advance, n.letters = n.letter.oneOrMore, n.digit = n.atDigit.advance, n.digitNonZero = n.atDigitNonZero.advance, n.digits = n.digit.oneOrMore, n.integer = ie("0").or(n.digits), n.hexDigit = n.atHexDigit.advance, n.binaryDigit = n.atBinaryDigit.advance, n.octalDigit = n.atOctalDigit.advance, n.alphaNumeric = n.atAlphaNumeric.advance, n.underscore = n.atUnderscore.advance, n.identifierFirst = J(n.atLetter, n.atUnderscore).advance, n.identifierNext = J(n.atAlphaNumeric, n.atUnderscore).advance, n.identifier = H(n.identifierFirst, n.identifierNext.zeroOrMore), n.hyphen = M("-"), n.crlf = M(`\r
`), n.newLine = J(n.crlf, `
`), n.space = M(" "), n.tab = M("	"), n.ws = n.atWs.advance.zeroOrMore;
      function Ee(q, z) {
        var ne = this.parse(q.ast.zeroOrMore, z);
        return ne ? ne.children : [];
      }
      n.tokenize = Ee;
      function xe(q, z) {
        var ne = new a(z, 0, []);
        return q instanceof c || (q = q.ast), q.parser(ne) && ne && ne.nodes ? ne.nodes[0] : null;
      }
      n.parse = xe;
      function tt(q) {
        return rt(q).filter(function(z) {
          return z._createAstNode;
        });
      }
      n.grammarAstRules = tt;
      function rt(q) {
        return We().filter(function(z) {
          return z.grammarName == q;
        });
      }
      n.grammarRules = rt;
      function We() {
        return Object.keys(n.allRules).sort().map(function(q) {
          return n.allRules[q];
        });
      }
      n.allGrammarRules = We;
      function nt() {
        return Object.keys(n.grammars).sort();
      }
      n.grammarNames = nt;
      function Ut(q) {
        return rt(q).map(function(z) {
          return z.fullName + " <- " + z.definition;
        }).join(`
`);
      }
      n.grammarToString = Ut;
      function Rt(q) {
        return tt(q).map(function(z) {
          return z.name + " <- " + z.astRuleDefn();
        }).join(`
`);
      }
      n.astSchemaToString = Rt;
      function Vt(q, z, ne) {
        for (var fe in z)
          if (z[fe] instanceof l) {
            var ce = z[fe];
            ce.setName(q, fe), n.allRules[ce.fullName] = ce;
          }
        return n.grammars[q] = z, ne && (n.parsers[q] = function(_e) {
          return xe(ne, _e);
        }), z;
      }
      n.registerGrammar = Vt;
      function bn(q) {
        var z = JSON.stringify(q);
        return z.slice(1, z.length - 1);
      }
      n.escapeChars = bn;
      function wt(q) {
        if (q instanceof l)
          return q;
        if (typeof q == "string")
          return M(q);
        if (typeof q == "boolean")
          return q ? n.truePredicate : n.falsePredicate;
        throw new Error("Invalid rule type: " + q);
      }
      n.RuleTypeToRule = wt;
      function pi(q, z, ne) {
        if (!q)
          throw new Error("Error occured while parsing rule: " + z.fullName + " " + (ne || ""));
      }
      n.debugAssert = pi, Vt("core", n, null);
    })(i = t.Myna || (t.Myna = {})), e.exports && (e.exports = i, e.exports.Myna = i);
  })(In, In.exports)), In.exports;
}
var O9 = R9();
function D9(e) {
  const t = e;
  t.parenthesized = (i) => t.seq("(", t.ws, i, t.ws, ")").setType("parenthesized");
  const r = new (function() {
    const i = "[]()", n = "[]()*~`@#\\_!+-", o = t.char(" 	").oneOrMore;
    o.opt, o.or(t.newLine);
    const s = t.notChar(n).unless(t.newLine), a = t.notChar(i).unless(t.newLine);
    t.notChar('"'), this.xsdToken = t.choice(
      t.digits,
      t.letters,
      t.char(n)
    ).oneOrMore.ast, this.plainText = t.choice(
      t.digits,
      t.letters,
      o,
      s
    ).oneOrMore.ast, this.plainTextEmphasis = t.choice(
      t.digits,
      t.letters,
      o,
      s
    ).oneOrMore.ast;
    const u = t.choice(
      t.digits,
      t.letters,
      o,
      a
    );
    this.plainTextModifier = u.oneOrMore.ast, this.plainTextPhone = t.seq(
      t.parenthesized(t.digits),
      u.oneOrMore
    ).ast, this.plainTextSpecialChars = t.choice(
      t.seq("(", u, ") "),
      t.seq("[", u, "] "),
      t.choice(...n.split("")).oneOrMore
    ).oneOrMore.ast, this.urlSpecialChar = t.char(":/.-_~?#[]@!+,;%=()&"), this.url = t.choice(t.digit, t.letter, this.urlSpecialChar).oneOrMore.ast, this.audio = t.seq(
      "![",
      t.choice(t.singleQuoted(this.url), t.doubleQuoted(this.url)),
      "]"
    ).ast, this.timeUnit = t.choice("s", "ms").ast, this.fraction = t.seq(".", t.digit.zeroOrMore), this.number = t.seq(t.integer, this.fraction.opt).ast, this.time = t.seq(this.number, this.timeUnit).ast, this.shortBreak = t.seq("[", this.time, "]").ast, this.silenceTypeValue = t.choice(
      "Leading",
      "Tailing",
      "Sentenceboundary"
    ).ast, this.silenceData = t.seq(this.silenceTypeValue, " ", this.time).ast, this.silence = t.seq(
      "[",
      "silence",
      ":",
      t.choice(
        t.singleQuoted(this.silenceData),
        t.doubleQuoted(this.silenceData)
      ),
      "]"
    ).ast, this.backgroundData = t.seq(" ", this.url), this.backgroundAudio = t.seq(
      "[",
      "backgroundaudio",
      ":",
      t.choice(
        t.singleQuoted(t.seq(this.url, this.backgroundData.zeroOrMore).ast),
        t.doubleQuoted(t.seq(this.url, this.backgroundData.zeroOrMore).ast)
      ),
      "]"
    ).ast, this.lexicon = t.seq(
      "[",
      "lexicon",
      ":",
      t.choice(t.singleQuoted(this.url), t.doubleQuoted(this.url)),
      "]"
    ).ast, this.bookmarkChar = t.char(".-_"), this.bookmarkString = t.choice(
      t.digit,
      t.letter,
      this.bookmarkChar
    ).oneOrMore.ast, this.bookmark = t.seq(
      "[",
      "bookmark",
      ":",
      t.choice(
        t.singleQuoted(this.bookmarkString),
        t.doubleQuoted(this.bookmarkString)
      ),
      "]"
    ).ast;
    const l = t.not(t.letters);
    this.shortEmphasisModerate = t.seq(
      l,
      "+",
      this.plainTextEmphasis,
      "+",
      l
    ).ast, this.shortEmphasisStrong = t.seq(
      l,
      "++",
      this.plainTextEmphasis,
      "++",
      l
    ).ast, this.shortEmphasisNone = t.seq(
      l,
      "~",
      this.plainTextEmphasis,
      "~",
      l
    ).ast, this.shortEmphasisReduced = t.seq(
      l,
      "-",
      this.plainTextEmphasis,
      "-",
      l
    ).ast, this.emphasis = t.choice(
      this.shortEmphasisModerate,
      this.shortEmphasisStrong,
      this.shortEmphasisNone,
      this.shortEmphasisReduced
    );
    const c = t.char(":").ws, d = t.char(";").ws;
    this.textModifierKey = t.keywords(
      "emphasis",
      "address",
      "number",
      "cardinal",
      "characters",
      "chars",
      "digits",
      "drc",
      "expletive",
      "bleep",
      "fraction",
      "interjection",
      "ordinal",
      "telephone",
      "phone",
      "unit",
      "time",
      "date",
      "whisper",
      "ipa",
      "sapi",
      "ups",
      "sub",
      "vol",
      "volume",
      "rate",
      "pitch",
      "contour",
      "range",
      "timbre",
      "lang",
      "voice",
      "excited",
      "disappointed",
      "emotion",
      "paragraph",
      "sentence"
    ).ast;
    const h = [
      // Plosive
      "p",
      "b",
      "t",
      "d",
      "ʈ",
      "ɖ",
      "c",
      "ɟ",
      "k",
      "ɡ",
      "g",
      "q",
      "ɢ",
      "ʔ",
      // Nasal
      "m",
      "ɱ",
      "n",
      "ɳ",
      "ɲ",
      "ŋ",
      "ɴ",
      // Trill
      "ʙ",
      "r",
      "ʀ",
      // Tap or Flap
      "ⱱ",
      "ɾ",
      "ɽ",
      // Fricative
      "ɸ",
      "β",
      "f",
      "v",
      "θ",
      "ð",
      "s",
      "z",
      "ʃ",
      "ʒ",
      "ʂ",
      "ʐ",
      "ç",
      "ʝ",
      "x",
      "ɣ",
      "χ",
      "ʁ",
      "ħ",
      "ʕ",
      "h",
      "ɦ",
      // Lateral fricative
      "ɬ",
      "ɮ",
      // Approximant
      "ʋ",
      "ɹ",
      "ɻ",
      "j",
      "ɰ",
      // Lateral approximant
      "l",
      "ɭ",
      "ʎ",
      "ʟ"
    ], f = [
      // Clicks
      "ʘ",
      "ǀ",
      "ǃ",
      "ǂ",
      "ǁ",
      // Voiced implosive
      "ɓ",
      "ɗ",
      "ʄ",
      "ɠ",
      "ʛ",
      // Ejectives (already existing chars + unicode char \u02BC)
      "ʼ"
    ], p = [
      // Close
      "i",
      "y",
      "ɨ",
      "ʉ",
      "ɯ",
      "u",
      "ɪ",
      "ʏ",
      "ʊ",
      // Close-mid
      "e",
      "ø",
      "ɘ",
      "ɚ",
      "ɵ",
      "ɤ",
      "o",
      "ə",
      // Open-mid
      "ɛ",
      "œ",
      "ɜ",
      "ɝ",
      "ɞ",
      "ʌ",
      "ɔ",
      "æ",
      "ɐ",
      // Open
      "a",
      "ɶ",
      "ɑ",
      "ɒ"
    ], m = [
      "ʍ",
      "w",
      "ɥ",
      "ʜ",
      "ʢ",
      "ʡ",
      "ɕ",
      "ʑ",
      "ɺ",
      "ɧ",
      "͡",
      // char ͡
      "͜"
      // char ͜
    ], w = [
      "̥",
      // char ̥
      "̊",
      // char ̊
      "̬",
      // char ̬
      "ʰ",
      "̹",
      // char ̹
      "̜",
      // char ̜
      "̟",
      // char ̟
      "̠",
      // char ̠
      "̈",
      // char ̈
      "̽",
      // char ̽
      "̩",
      // char ̩
      "̯",
      // char ̯
      "˞",
      // char ˞
      "̤",
      // char ̤
      "̰",
      // char ̰
      "̼",
      // char ̼
      "ʷ",
      "ʲ",
      "ˠ",
      "ˤ",
      "̴",
      // char ̴
      "̝",
      // char ̝
      "̞",
      // char ̞
      "̘",
      // char ̘
      "̙",
      // char ̙
      "̪",
      // char ̪
      "̺",
      // char ̺
      "̻",
      // char ̻
      "̃",
      //char ̃
      "ⁿ",
      "ˡ",
      "̚"
      // char ̚
    ], v = [
      "ˈ",
      "ˌ",
      "ː",
      "ˑ",
      "̆",
      // char ̆
      "|",
      "‖",
      ".",
      "‿"
    ], g = [
      "̋",
      "́",
      "̄",
      "̀",
      "̏",
      "↓",
      "↑",
      "↗",
      "↘",
      "̌",
      "̂"
    ], A = [
      "à",
      "è",
      "ì",
      "ò",
      "ù",
      "À",
      "È",
      "Ì",
      "Ò",
      "Ù",
      "á",
      "é",
      "í",
      "ó",
      "ú",
      "ý",
      "Á",
      "É",
      "Í",
      "Ó",
      "Ú",
      "Ý",
      "â",
      "ê",
      "î",
      "ô",
      "û",
      "Â",
      "Ê",
      "Î",
      "Ô",
      "Û",
      "ä",
      "ë",
      "ï",
      "ö",
      "ü",
      "ÿ",
      "Ä",
      "Ë",
      "Ï",
      "Ö",
      "Ü",
      "Ÿ",
      "ã",
      "ñ",
      "õ",
      "Ã",
      "Ñ",
      "Õ",
      "å",
      "Å"
    ], b = [
      "ɩ",
      "ɫ",
      "ɷ",
      "ɼ",
      "ɿ",
      "ʅ",
      "ʆ",
      "ʇ",
      "ʓ",
      "ʖ",
      "ʗ",
      "ʚ",
      "ʞ",
      "ʠ",
      "ʣ",
      "ʤ",
      "ʥ",
      "ʦ",
      "ʧ",
      "ʨ",
      "ʩ",
      "ʪ",
      "ʫ",
      "ʬ",
      "ʭ",
      "ʮ",
      "ʯ"
    ], k = [
      ...h,
      ...f,
      ...p,
      ...m,
      ...w,
      ...v,
      ...g,
      ...A,
      ...b
    ], y = ["+", t.hyphen, t.digit, "%"];
    this.textModifierText = t.choice(
      t.digit,
      t.letter,
      t.hyphen,
      t.space,
      ...k,
      ...y
    ).oneOrMore.ast, this.textModifierTextDoubleQuote = t.choice(
      t.digit,
      t.letter,
      t.hyphen,
      t.space,
      ...k,
      ...y,
      "'"
    ).oneOrMore.ast, this.textModifierValue = t.seq(
      c,
      t.choice(
        t.singleQuoted(this.textModifierText),
        t.doubleQuoted(this.textModifierTextDoubleQuote)
      )
    ), this.textModifierKeyOptionalValue = t.seq(
      this.textModifierKey,
      this.textModifierValue.opt
    ).ast, this.modifier = t.bracketed(
      t.delimited(this.textModifierKeyOptionalValue.ws, d)
    );
    const x = t.parenthesized(this.plainTextModifier), C = t.parenthesized(this.plainTextPhone);
    this.textModifier = t.seq(
      t.choice(x, C),
      this.modifier
    ).ast, this.sectionModifierKey = t.keywords(
      "lang",
      "voice",
      "defaults",
      "dj",
      "newscaster",
      "excited",
      "disappointed"
    ).ast, this.sectionModifierText = t.choice(
      t.digit,
      t.letter,
      t.hyphen
    ).oneOrMore.ast, this.sectionModifierValue = t.seq(
      c,
      t.choice(
        t.singleQuoted(this.sectionModifierText),
        t.doubleQuoted(this.sectionModifierText)
      )
    ), this.sectionModifierKeyOptionalValue = t.seq(
      this.sectionModifierKey,
      this.sectionModifierValue.opt
    ).ast, this.sectionModifier = t.bracketed(
      t.delimited(this.sectionModifierKeyOptionalValue.ws, d)
    ), this.section = t.seq("#", this.sectionModifier).ast, this.valueNone = "none", this.valueXWeak = "x-weak", this.valueWeak = "weak", this.valueMedium = "medium", this.valueStrong = "strong", this.valueXStrong = "x-strong", this.breakStrengthValue = t.keywords(
      this.valueNone,
      this.valueXWeak,
      this.valueWeak,
      this.valueMedium,
      this.valueStrong,
      this.valueXStrong
    ).ast, this.breakValue = t.choice(this.breakStrengthValue, this.time).ast, this.break = t.seq(
      "[",
      "break",
      ":",
      t.choice(
        t.singleQuoted(this.breakValue),
        t.doubleQuoted(this.breakValue)
      ),
      "]"
    ).ast, this.markTag = t.seq(
      "[",
      "mark",
      ":",
      t.choice(t.singleQuoted(this.xsdToken), t.doubleQuoted(this.xsdToken)),
      "]"
    ).ast, this.any = t.advance, this.inline = t.choice(
      this.backgroundAudio,
      this.lexicon,
      this.bookmark,
      this.textModifier,
      this.emphasis,
      this.shortBreak,
      this.silence,
      this.break,
      this.audio,
      this.markTag,
      this.plainTextSpecialChars,
      this.plainText,
      this.any
    ).unless(t.newLine), this.lineEnd = t.newLine.or(t.assert(t.end)).ast, this.emptyLine = t.char(" 	").zeroOrMore.then(t.newLine).ast, this.restOfLine = t.seq(this.inline.zeroOrMore).then(this.lineEnd), this.simpleLine = t.seq(this.emptyLine.not, t.notEnd, this.restOfLine).ast, this.paragraph = this.simpleLine.oneOrMore.ast, this.content = t.choice(this.section, this.paragraph, this.emptyLine), this.document = this.content.zeroOrMore.ast;
  })();
  return t.registerGrammar("speechmarkdown", r, r.document);
}
class P9 {
  constructor() {
    this.myna = O9.Myna, D9(this.myna), this.parser = this.myna.parsers.speechmarkdown;
  }
  parse(t) {
    return this.parser(t);
  }
}
class I9 {
  constructor(t) {
    this.options = t, this.defaults = {
      includeFormatterComment: !1,
      includeParagraphTag: !1,
      includeSpeakTag: !0,
      platform: "",
      // default - text formatter
      preserveEmptyLines: !0
    }, this.options = {
      ...this.defaults,
      ...t
    };
  }
  get Parser() {
    return this.parser || (this.parser = new P9()), this.parser;
  }
  toText(t, r) {
    const i = {
      ...this.options,
      ...r
    }, n = this.Parser.parse(t);
    return C9(i).format(n);
  }
  toSSML(t, r) {
    const i = {
      ...this.options,
      ...r
    };
    let n = t;
    try {
      do {
        const c = this.Parser.parse(n);
        n = T9(i).format(c);
      } while (n.includes(")["));
      let o = "";
      if (n.includes("<mstts:backgroundaudio")) {
        const c = n.indexOf("<mstts:backgroundaudio"), d = n.substring(c).indexOf("/>") + 2;
        o = n.substring(c, d), n = n.replace(o, "");
      }
      let s = "", a = "";
      i.globalVoiceAndLang && i.globalVoiceAndLang.voice && (s = `<voice name="${i.globalVoiceAndLang.voice}">`, a = "</voice>");
      let u = "", l = "";
      return i.globalVoiceAndLang && i.globalVoiceAndLang.lang && (u = `<lang xml:lang="${i.globalVoiceAndLang.lang}">`, l = "</lang>"), `${o + s + u + n + l + a}`;
    } catch (o) {
      return console.log("Error : ", o), n;
    }
  }
  toAST(t) {
    return this.Parser.parse(t);
  }
  toASTString(t) {
    return this.Parser.parse(t).toString();
  }
}
const U0 = new I9(), Db = (e, t = []) => {
  let r = "";
  if (e.indexOf("-") !== -1) {
    const i = [];
    for (let o = 0; o < e.length; o++)
      if (e[o] === "-") {
        let s = !0;
        t.forEach((a) => {
          (o === a[0] || o === a[1] || o > a[0] && o < a[1]) && (s = !1);
        }), s && i.push(o);
      }
    let n = "";
    if (i.length > 0) {
      for (let o = 0; o < i.length; o++)
        n += o === 0 ? e.substring(0, i[o]) : e.substring(
          i[o - 1] + 1,
          i[o]
        ), n += "1xx1";
      n += e.substring(
        i[i.length - 1] + 1
      );
    }
    r = U0.toText(n), r = r.replaceAll("1xx1", "-");
  } else
    r = U0.toText(e);
  return r = r.replaceAll(/<\/?phoneme?[^>]+>|$/g, ""), r;
}, M9 = (e) => {
  const t = [];
  let r = e, i = [], n = e.indexOf(")[");
  for (; n !== -1; )
    i.push(n), n = e.indexOf(")[", n + 1);
  if (i.length > 0)
    for (let s = 0; s < i.length; s++) {
      const a = j9(e, i[s]), u = e.substring(i[s]).indexOf("]") + i[s], l = {
        // Use string for replacement as : 'replacement1x1'
        replacementString: `replacement${s}x${s}`,
        speechMarkdown: e.substring(
          a,
          u + 1
        )
      };
      t.push(l), r = r.replace(
        l.speechMarkdown,
        l.replacementString
      );
    }
  i = [];
  const o = r;
  for (n = o.indexOf("]"); n !== -1; )
    i.push(n), n = o.indexOf("]", n + 1);
  if (i.length > 0) {
    for (let s = 0; s < i.length; s++)
      if (i[s] === o.length - 1 || o.charAt(i[s] + 1) !== "(") {
        const a = o.substring(0, i[s]).lastIndexOf("["), u = {
          // Use string for replacement as : 'pause1x1'
          replacementString: `pause${s}x${s}`,
          speechMarkdown: o.substring(
            a,
            i[s] + 1
          )
        };
        t.push(u), r = r.replace(
          u.speechMarkdown,
          u.replacementString
        );
      }
  }
  return {
    text: r,
    replacements: t
  };
}, j9 = (e, t) => {
  let r = 0, i = 0;
  for (let n = t; n > 0; n--)
    if (e.charAt(n) === ")")
      i++;
    else if (e.charAt(n) === "(" && (r++, i === r))
      return n;
  return 0;
}, F9 = /<\/?a([^>])+>/g, $9 = /<\/?img([^>])+>/g, Mu = (e, t) => {
  const r = new Je({
    breaks: !0,
    html: !0,
    xhtmlOut: !0,
    typographer: !0,
    quotes: `""''`
  });
  let i = { images: [], urls: [] };
  const n = M9(e);
  if (!t) {
    const u = r.parseInline(n.text);
    u.length && (i = B9(u[0].children));
  }
  const o = r.render(e), s = N9(o), a = [];
  return n.replacements.forEach((u) => {
    const l = e.indexOf(u.speechMarkdown);
    a.push([l, l + u.speechMarkdown.length]);
  }), {
    ...i,
    text: s,
    htmlText: L9(o, a)
  };
}, L9 = (e, t) => {
  let r = e.replaceAll("&quot;", '"');
  return r = r.replaceAll("&lt;", "<"), r = r.replaceAll("&gt;", ">"), r = Db(r, t).replaceAll(F9, ""), r = r.replaceAll($9, ""), r;
}, N9 = (e) => {
  const t = document.createElement("div");
  return t.innerHTML = e, t.textContent && t.textContent !== "" ? t.textContent : "";
}, qr = (e, t) => {
  const r = e == null ? void 0 : e.find((i) => i.length > 1 && i[0] === t && i[1] !== "");
  return r && r.length > 1 ? r[1] : t === "href" ? void 0 : "";
}, B9 = (e) => {
  var i;
  const t = [], r = [];
  if (e != null && e.length)
    for (let n = 0; n < e.length; n++) {
      const o = e[n].attrs;
      switch (e[n].type) {
        case "link_open": {
          const s = qr(o, "href");
          if (s && !r.find((a) => a.url === s)) {
            const a = qr(o, "title") || ((i = e[n + 1]) == null ? void 0 : i.content);
            r.push({
              url: s,
              title: a
            });
          }
          break;
        }
        case "image": {
          const s = qr(o, "src");
          s && !t.find((a) => a.url === s) && t.push({
            url: s,
            title: qr(o, "title"),
            alt: qr(o, "alt")
          });
          break;
        }
      }
    }
  return {
    images: t,
    urls: r
  };
}, Hs = (e, t) => {
  const r = {
    type: "TextBlock",
    text: e,
    size: void 0,
    horizontalAlignment: void 0,
    wrap: !0,
    maxLines: void 0
  };
  switch (t) {
    case "title":
      r.size = "large";
      break;
    case "subtitle":
      r.size = "medium";
      break;
  }
  return r;
}, q9 = (e) => {
  const t = {
    type: "Image",
    url: "",
    size: "Large",
    altText: void 0,
    selectAction: void 0,
    horizontalAlignment: "Center"
  };
  return t.url = e.url, t.altText = e.alt || "image", t.selectAction = e.tap && ju(e.tap), { ...t };
}, ju = (e, t) => {
  const r = {
    type: "Action.Submit",
    title: void 0,
    url: void 0,
    data: void 0,
    fullWidth: void 0,
    position: void 0,
    display: void 0
  };
  for (const n in e)
    e[n] && typeof e[n] == "string" && (e[n] = Db(e[n]));
  e.type === "imBack" || e.type === "messageBack" || e.type === "postBack" || e.type === "signin" && t ? (r.type = "Action.Submit", r.data = e.value || e.title || null, r.title = e.title || "") : (r.type = "Action.OpenUrl", r.title = e.title || "", r.url = e.type === "call" ? `tel:${e.value}` : e.value);
  const i = e.channelData;
  return i && (r.fullWidth = i.fullWidth, r.position = i.position, r.display = i.display), { ...r };
}, z9 = (e) => {
  const t = {
    contentType: RI,
    content: {
      type: "AdaptiveCard",
      $schema: "http://adaptivecards.io/schemas/adaptive-card.json",
      version: "1.5",
      body: [],
      text: void 0,
      speak: void 0,
      selectAction: void 0
    }
  };
  let r = [];
  if (e.title) {
    const o = Hs(e.title, "title");
    r = [...r, { ...o }];
  }
  if (e.subtitle) {
    const o = Hs(e.subtitle, "subtitle");
    r = [...r, { ...o }];
  }
  if (e.text) {
    const o = Hs(e.text, "text");
    r = [...r, { ...o }], t.content.text = e.text;
  }
  (e.speak || e.text) && (t.content.speak = e.speak || e.text), t.content.body = [
    {
      type: "Container",
      items: []
    }
  ], r.length > 0 && (t.content.body[0].items = [...r]);
  let i = [];
  e.images && e.images.forEach((o) => {
    const s = q9(o);
    i = [...i, { ...s }];
  }), i.length > 0 && (t.content.body[0].items = [...t.content.body[0].items, ...i]);
  let n = [];
  if (e.buttons && e.buttons.forEach((o) => {
    const s = ju(o);
    n = [...n, { ...s }];
  }), n.length > 0) {
    const o = {
      type: "ActionSet",
      actions: [...n]
    };
    t.content.body[0].items = [...t.content.body[0].items, { ...o }];
  }
  if (e.tap) {
    const o = ju(e.tap);
    t.content.selectAction = { ...o };
  }
  return { ...t };
}, U9 = (e) => {
  if (e && e.length > 0) {
    let t = [];
    return e.forEach((r) => {
      if (r.contentType === OI) {
        const i = z9({
          ...r.content
        });
        t = [...t, { ...i }];
      } else
        t = [...t, { ...r }];
    }), t;
  }
};
var Kt = {}, Ks, V0;
function V9() {
  return V0 || (V0 = 1, Ks = function() {
    return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
  }), Ks;
}
var Qs = {}, kt = {}, G0;
function qt() {
  if (G0) return kt;
  G0 = 1;
  let e;
  const t = [
    0,
    // Not used
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
  ];
  return kt.getSymbolSize = function(i) {
    if (!i) throw new Error('"version" cannot be null or undefined');
    if (i < 1 || i > 40) throw new Error('"version" should be in range from 1 to 40');
    return i * 4 + 17;
  }, kt.getSymbolTotalCodewords = function(i) {
    return t[i];
  }, kt.getBCHDigit = function(r) {
    let i = 0;
    for (; r !== 0; )
      i++, r >>>= 1;
    return i;
  }, kt.setToSJISFunction = function(i) {
    if (typeof i != "function")
      throw new Error('"toSJISFunc" is not a valid function.');
    e = i;
  }, kt.isKanjiModeEnabled = function() {
    return typeof e < "u";
  }, kt.toSJIS = function(i) {
    return e(i);
  }, kt;
}
var Ys = {}, W0;
function Cc() {
  return W0 || (W0 = 1, (function(e) {
    e.L = { bit: 1 }, e.M = { bit: 0 }, e.Q = { bit: 3 }, e.H = { bit: 2 };
    function t(r) {
      if (typeof r != "string")
        throw new Error("Param is not a string");
      switch (r.toLowerCase()) {
        case "l":
        case "low":
          return e.L;
        case "m":
        case "medium":
          return e.M;
        case "q":
        case "quartile":
          return e.Q;
        case "h":
        case "high":
          return e.H;
        default:
          throw new Error("Unknown EC Level: " + r);
      }
    }
    e.isValid = function(i) {
      return i && typeof i.bit < "u" && i.bit >= 0 && i.bit < 4;
    }, e.from = function(i, n) {
      if (e.isValid(i))
        return i;
      try {
        return t(i);
      } catch {
        return n;
      }
    };
  })(Ys)), Ys;
}
var Js, H0;
function G9() {
  if (H0) return Js;
  H0 = 1;
  function e() {
    this.buffer = [], this.length = 0;
  }
  return e.prototype = {
    get: function(t) {
      const r = Math.floor(t / 8);
      return (this.buffer[r] >>> 7 - t % 8 & 1) === 1;
    },
    put: function(t, r) {
      for (let i = 0; i < r; i++)
        this.putBit((t >>> r - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
      return this.length;
    },
    putBit: function(t) {
      const r = Math.floor(this.length / 8);
      this.buffer.length <= r && this.buffer.push(0), t && (this.buffer[r] |= 128 >>> this.length % 8), this.length++;
    }
  }, Js = e, Js;
}
var Zs, K0;
function W9() {
  if (K0) return Zs;
  K0 = 1;
  function e(t) {
    if (!t || t < 1)
      throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = t, this.data = new Uint8Array(t * t), this.reservedBit = new Uint8Array(t * t);
  }
  return e.prototype.set = function(t, r, i, n) {
    const o = t * this.size + r;
    this.data[o] = i, n && (this.reservedBit[o] = !0);
  }, e.prototype.get = function(t, r) {
    return this.data[t * this.size + r];
  }, e.prototype.xor = function(t, r, i) {
    this.data[t * this.size + r] ^= i;
  }, e.prototype.isReserved = function(t, r) {
    return this.reservedBit[t * this.size + r];
  }, Zs = e, Zs;
}
var Xs = {}, Q0;
function H9() {
  return Q0 || (Q0 = 1, (function(e) {
    const t = qt().getSymbolSize;
    e.getRowColCoords = function(i) {
      if (i === 1) return [];
      const n = Math.floor(i / 7) + 2, o = t(i), s = o === 145 ? 26 : Math.ceil((o - 13) / (2 * n - 2)) * 2, a = [o - 7];
      for (let u = 1; u < n - 1; u++)
        a[u] = a[u - 1] - s;
      return a.push(6), a.reverse();
    }, e.getPositions = function(i) {
      const n = [], o = e.getRowColCoords(i), s = o.length;
      for (let a = 0; a < s; a++)
        for (let u = 0; u < s; u++)
          a === 0 && u === 0 || // top-left
          a === 0 && u === s - 1 || // bottom-left
          a === s - 1 && u === 0 || n.push([o[a], o[u]]);
      return n;
    };
  })(Xs)), Xs;
}
var eu = {}, Y0;
function K9() {
  if (Y0) return eu;
  Y0 = 1;
  const e = qt().getSymbolSize, t = 7;
  return eu.getPositions = function(i) {
    const n = e(i);
    return [
      // top-left
      [0, 0],
      // top-right
      [n - t, 0],
      // bottom-left
      [0, n - t]
    ];
  }, eu;
}
var tu = {}, J0;
function Q9() {
  return J0 || (J0 = 1, (function(e) {
    e.Patterns = {
      PATTERN000: 0,
      PATTERN001: 1,
      PATTERN010: 2,
      PATTERN011: 3,
      PATTERN100: 4,
      PATTERN101: 5,
      PATTERN110: 6,
      PATTERN111: 7
    };
    const t = {
      N1: 3,
      N2: 3,
      N3: 40,
      N4: 10
    };
    e.isValid = function(n) {
      return n != null && n !== "" && !isNaN(n) && n >= 0 && n <= 7;
    }, e.from = function(n) {
      return e.isValid(n) ? parseInt(n, 10) : void 0;
    }, e.getPenaltyN1 = function(n) {
      const o = n.size;
      let s = 0, a = 0, u = 0, l = null, c = null;
      for (let d = 0; d < o; d++) {
        a = u = 0, l = c = null;
        for (let h = 0; h < o; h++) {
          let f = n.get(d, h);
          f === l ? a++ : (a >= 5 && (s += t.N1 + (a - 5)), l = f, a = 1), f = n.get(h, d), f === c ? u++ : (u >= 5 && (s += t.N1 + (u - 5)), c = f, u = 1);
        }
        a >= 5 && (s += t.N1 + (a - 5)), u >= 5 && (s += t.N1 + (u - 5));
      }
      return s;
    }, e.getPenaltyN2 = function(n) {
      const o = n.size;
      let s = 0;
      for (let a = 0; a < o - 1; a++)
        for (let u = 0; u < o - 1; u++) {
          const l = n.get(a, u) + n.get(a, u + 1) + n.get(a + 1, u) + n.get(a + 1, u + 1);
          (l === 4 || l === 0) && s++;
        }
      return s * t.N2;
    }, e.getPenaltyN3 = function(n) {
      const o = n.size;
      let s = 0, a = 0, u = 0;
      for (let l = 0; l < o; l++) {
        a = u = 0;
        for (let c = 0; c < o; c++)
          a = a << 1 & 2047 | n.get(l, c), c >= 10 && (a === 1488 || a === 93) && s++, u = u << 1 & 2047 | n.get(c, l), c >= 10 && (u === 1488 || u === 93) && s++;
      }
      return s * t.N3;
    }, e.getPenaltyN4 = function(n) {
      let o = 0;
      const s = n.data.length;
      for (let u = 0; u < s; u++) o += n.data[u];
      return Math.abs(Math.ceil(o * 100 / s / 5) - 10) * t.N4;
    };
    function r(i, n, o) {
      switch (i) {
        case e.Patterns.PATTERN000:
          return (n + o) % 2 === 0;
        case e.Patterns.PATTERN001:
          return n % 2 === 0;
        case e.Patterns.PATTERN010:
          return o % 3 === 0;
        case e.Patterns.PATTERN011:
          return (n + o) % 3 === 0;
        case e.Patterns.PATTERN100:
          return (Math.floor(n / 2) + Math.floor(o / 3)) % 2 === 0;
        case e.Patterns.PATTERN101:
          return n * o % 2 + n * o % 3 === 0;
        case e.Patterns.PATTERN110:
          return (n * o % 2 + n * o % 3) % 2 === 0;
        case e.Patterns.PATTERN111:
          return (n * o % 3 + (n + o) % 2) % 2 === 0;
        default:
          throw new Error("bad maskPattern:" + i);
      }
    }
    e.applyMask = function(n, o) {
      const s = o.size;
      for (let a = 0; a < s; a++)
        for (let u = 0; u < s; u++)
          o.isReserved(u, a) || o.xor(u, a, r(n, u, a));
    }, e.getBestMask = function(n, o) {
      const s = Object.keys(e.Patterns).length;
      let a = 0, u = 1 / 0;
      for (let l = 0; l < s; l++) {
        o(l), e.applyMask(l, n);
        const c = e.getPenaltyN1(n) + e.getPenaltyN2(n) + e.getPenaltyN3(n) + e.getPenaltyN4(n);
        e.applyMask(l, n), c < u && (u = c, a = l);
      }
      return a;
    };
  })(tu)), tu;
}
var Rn = {}, Z0;
function Pb() {
  if (Z0) return Rn;
  Z0 = 1;
  const e = Cc(), t = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
  ], r = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
  ];
  return Rn.getBlocksCount = function(n, o) {
    switch (o) {
      case e.L:
        return t[(n - 1) * 4 + 0];
      case e.M:
        return t[(n - 1) * 4 + 1];
      case e.Q:
        return t[(n - 1) * 4 + 2];
      case e.H:
        return t[(n - 1) * 4 + 3];
      default:
        return;
    }
  }, Rn.getTotalCodewordsCount = function(n, o) {
    switch (o) {
      case e.L:
        return r[(n - 1) * 4 + 0];
      case e.M:
        return r[(n - 1) * 4 + 1];
      case e.Q:
        return r[(n - 1) * 4 + 2];
      case e.H:
        return r[(n - 1) * 4 + 3];
      default:
        return;
    }
  }, Rn;
}
var ru = {}, zr = {}, X0;
function Y9() {
  if (X0) return zr;
  X0 = 1;
  const e = new Uint8Array(512), t = new Uint8Array(256);
  return (function() {
    let i = 1;
    for (let n = 0; n < 255; n++)
      e[n] = i, t[i] = n, i <<= 1, i & 256 && (i ^= 285);
    for (let n = 255; n < 512; n++)
      e[n] = e[n - 255];
  })(), zr.log = function(i) {
    if (i < 1) throw new Error("log(" + i + ")");
    return t[i];
  }, zr.exp = function(i) {
    return e[i];
  }, zr.mul = function(i, n) {
    return i === 0 || n === 0 ? 0 : e[t[i] + t[n]];
  }, zr;
}
var em;
function J9() {
  return em || (em = 1, (function(e) {
    const t = Y9();
    e.mul = function(i, n) {
      const o = new Uint8Array(i.length + n.length - 1);
      for (let s = 0; s < i.length; s++)
        for (let a = 0; a < n.length; a++)
          o[s + a] ^= t.mul(i[s], n[a]);
      return o;
    }, e.mod = function(i, n) {
      let o = new Uint8Array(i);
      for (; o.length - n.length >= 0; ) {
        const s = o[0];
        for (let u = 0; u < n.length; u++)
          o[u] ^= t.mul(n[u], s);
        let a = 0;
        for (; a < o.length && o[a] === 0; ) a++;
        o = o.slice(a);
      }
      return o;
    }, e.generateECPolynomial = function(i) {
      let n = new Uint8Array([1]);
      for (let o = 0; o < i; o++)
        n = e.mul(n, new Uint8Array([1, t.exp(o)]));
      return n;
    };
  })(ru)), ru;
}
var nu, tm;
function Z9() {
  if (tm) return nu;
  tm = 1;
  const e = J9();
  function t(r) {
    this.genPoly = void 0, this.degree = r, this.degree && this.initialize(this.degree);
  }
  return t.prototype.initialize = function(i) {
    this.degree = i, this.genPoly = e.generateECPolynomial(this.degree);
  }, t.prototype.encode = function(i) {
    if (!this.genPoly)
      throw new Error("Encoder not initialized");
    const n = new Uint8Array(i.length + this.degree);
    n.set(i);
    const o = e.mod(n, this.genPoly), s = this.degree - o.length;
    if (s > 0) {
      const a = new Uint8Array(this.degree);
      return a.set(o, s), a;
    }
    return o;
  }, nu = t, nu;
}
var iu = {}, ou = {}, au = {}, rm;
function Ib() {
  return rm || (rm = 1, au.isValid = function(t) {
    return !isNaN(t) && t >= 1 && t <= 40;
  }), au;
}
var it = {}, nm;
function Mb() {
  if (nm) return it;
  nm = 1;
  const e = "[0-9]+", t = "[A-Z $%*+\\-./:]+";
  let r = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
  r = r.replace(/u/g, "\\u");
  const i = "(?:(?![A-Z0-9 $%*+\\-./:]|" + r + `)(?:.|[\r
]))+`;
  it.KANJI = new RegExp(r, "g"), it.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g"), it.BYTE = new RegExp(i, "g"), it.NUMERIC = new RegExp(e, "g"), it.ALPHANUMERIC = new RegExp(t, "g");
  const n = new RegExp("^" + r + "$"), o = new RegExp("^" + e + "$"), s = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
  return it.testKanji = function(u) {
    return n.test(u);
  }, it.testNumeric = function(u) {
    return o.test(u);
  }, it.testAlphanumeric = function(u) {
    return s.test(u);
  }, it;
}
var im;
function zt() {
  return im || (im = 1, (function(e) {
    const t = Ib(), r = Mb();
    e.NUMERIC = {
      id: "Numeric",
      bit: 1,
      ccBits: [10, 12, 14]
    }, e.ALPHANUMERIC = {
      id: "Alphanumeric",
      bit: 2,
      ccBits: [9, 11, 13]
    }, e.BYTE = {
      id: "Byte",
      bit: 4,
      ccBits: [8, 16, 16]
    }, e.KANJI = {
      id: "Kanji",
      bit: 8,
      ccBits: [8, 10, 12]
    }, e.MIXED = {
      bit: -1
    }, e.getCharCountIndicator = function(o, s) {
      if (!o.ccBits) throw new Error("Invalid mode: " + o);
      if (!t.isValid(s))
        throw new Error("Invalid version: " + s);
      return s >= 1 && s < 10 ? o.ccBits[0] : s < 27 ? o.ccBits[1] : o.ccBits[2];
    }, e.getBestModeForData = function(o) {
      return r.testNumeric(o) ? e.NUMERIC : r.testAlphanumeric(o) ? e.ALPHANUMERIC : r.testKanji(o) ? e.KANJI : e.BYTE;
    }, e.toString = function(o) {
      if (o && o.id) return o.id;
      throw new Error("Invalid mode");
    }, e.isValid = function(o) {
      return o && o.bit && o.ccBits;
    };
    function i(n) {
      if (typeof n != "string")
        throw new Error("Param is not a string");
      switch (n.toLowerCase()) {
        case "numeric":
          return e.NUMERIC;
        case "alphanumeric":
          return e.ALPHANUMERIC;
        case "kanji":
          return e.KANJI;
        case "byte":
          return e.BYTE;
        default:
          throw new Error("Unknown mode: " + n);
      }
    }
    e.from = function(o, s) {
      if (e.isValid(o))
        return o;
      try {
        return i(o);
      } catch {
        return s;
      }
    };
  })(ou)), ou;
}
var om;
function X9() {
  return om || (om = 1, (function(e) {
    const t = qt(), r = Pb(), i = Cc(), n = zt(), o = Ib(), s = 7973, a = t.getBCHDigit(s);
    function u(h, f, p) {
      for (let m = 1; m <= 40; m++)
        if (f <= e.getCapacity(m, p, h))
          return m;
    }
    function l(h, f) {
      return n.getCharCountIndicator(h, f) + 4;
    }
    function c(h, f) {
      let p = 0;
      return h.forEach(function(m) {
        const w = l(m.mode, f);
        p += w + m.getBitsLength();
      }), p;
    }
    function d(h, f) {
      for (let p = 1; p <= 40; p++)
        if (c(h, p) <= e.getCapacity(p, f, n.MIXED))
          return p;
    }
    e.from = function(f, p) {
      return o.isValid(f) ? parseInt(f, 10) : p;
    }, e.getCapacity = function(f, p, m) {
      if (!o.isValid(f))
        throw new Error("Invalid QR Code version");
      typeof m > "u" && (m = n.BYTE);
      const w = t.getSymbolTotalCodewords(f), v = r.getTotalCodewordsCount(f, p), g = (w - v) * 8;
      if (m === n.MIXED) return g;
      const A = g - l(m, f);
      switch (m) {
        case n.NUMERIC:
          return Math.floor(A / 10 * 3);
        case n.ALPHANUMERIC:
          return Math.floor(A / 11 * 2);
        case n.KANJI:
          return Math.floor(A / 13);
        case n.BYTE:
        default:
          return Math.floor(A / 8);
      }
    }, e.getBestVersionForData = function(f, p) {
      let m;
      const w = i.from(p, i.M);
      if (Array.isArray(f)) {
        if (f.length > 1)
          return d(f, w);
        if (f.length === 0)
          return 1;
        m = f[0];
      } else
        m = f;
      return u(m.mode, m.getLength(), w);
    }, e.getEncodedBits = function(f) {
      if (!o.isValid(f) || f < 7)
        throw new Error("Invalid QR Code version");
      let p = f << 12;
      for (; t.getBCHDigit(p) - a >= 0; )
        p ^= s << t.getBCHDigit(p) - a;
      return f << 12 | p;
    };
  })(iu)), iu;
}
var su = {}, am;
function eF() {
  if (am) return su;
  am = 1;
  const e = qt(), t = 1335, r = 21522, i = e.getBCHDigit(t);
  return su.getEncodedBits = function(o, s) {
    const a = o.bit << 3 | s;
    let u = a << 10;
    for (; e.getBCHDigit(u) - i >= 0; )
      u ^= t << e.getBCHDigit(u) - i;
    return (a << 10 | u) ^ r;
  }, su;
}
var uu = {}, cu, sm;
function tF() {
  if (sm) return cu;
  sm = 1;
  const e = zt();
  function t(r) {
    this.mode = e.NUMERIC, this.data = r.toString();
  }
  return t.getBitsLength = function(i) {
    return 10 * Math.floor(i / 3) + (i % 3 ? i % 3 * 3 + 1 : 0);
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(i) {
    let n, o, s;
    for (n = 0; n + 3 <= this.data.length; n += 3)
      o = this.data.substr(n, 3), s = parseInt(o, 10), i.put(s, 10);
    const a = this.data.length - n;
    a > 0 && (o = this.data.substr(n), s = parseInt(o, 10), i.put(s, a * 3 + 1));
  }, cu = t, cu;
}
var lu, um;
function rF() {
  if (um) return lu;
  um = 1;
  const e = zt(), t = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
  ];
  function r(i) {
    this.mode = e.ALPHANUMERIC, this.data = i;
  }
  return r.getBitsLength = function(n) {
    return 11 * Math.floor(n / 2) + 6 * (n % 2);
  }, r.prototype.getLength = function() {
    return this.data.length;
  }, r.prototype.getBitsLength = function() {
    return r.getBitsLength(this.data.length);
  }, r.prototype.write = function(n) {
    let o;
    for (o = 0; o + 2 <= this.data.length; o += 2) {
      let s = t.indexOf(this.data[o]) * 45;
      s += t.indexOf(this.data[o + 1]), n.put(s, 11);
    }
    this.data.length % 2 && n.put(t.indexOf(this.data[o]), 6);
  }, lu = r, lu;
}
var du, cm;
function nF() {
  if (cm) return du;
  cm = 1;
  const e = zt();
  function t(r) {
    this.mode = e.BYTE, typeof r == "string" ? this.data = new TextEncoder().encode(r) : this.data = new Uint8Array(r);
  }
  return t.getBitsLength = function(i) {
    return i * 8;
  }, t.prototype.getLength = function() {
    return this.data.length;
  }, t.prototype.getBitsLength = function() {
    return t.getBitsLength(this.data.length);
  }, t.prototype.write = function(r) {
    for (let i = 0, n = this.data.length; i < n; i++)
      r.put(this.data[i], 8);
  }, du = t, du;
}
var fu, lm;
function iF() {
  if (lm) return fu;
  lm = 1;
  const e = zt(), t = qt();
  function r(i) {
    this.mode = e.KANJI, this.data = i;
  }
  return r.getBitsLength = function(n) {
    return n * 13;
  }, r.prototype.getLength = function() {
    return this.data.length;
  }, r.prototype.getBitsLength = function() {
    return r.getBitsLength(this.data.length);
  }, r.prototype.write = function(i) {
    let n;
    for (n = 0; n < this.data.length; n++) {
      let o = t.toSJIS(this.data[n]);
      if (o >= 33088 && o <= 40956)
        o -= 33088;
      else if (o >= 57408 && o <= 60351)
        o -= 49472;
      else
        throw new Error(
          "Invalid SJIS character: " + this.data[n] + `
Make sure your charset is UTF-8`
        );
      o = (o >>> 8 & 255) * 192 + (o & 255), i.put(o, 13);
    }
  }, fu = r, fu;
}
var hu = { exports: {} }, dm;
function oF() {
  return dm || (dm = 1, (function(e) {
    var t = {
      single_source_shortest_paths: function(r, i, n) {
        var o = {}, s = {};
        s[i] = 0;
        var a = t.PriorityQueue.make();
        a.push(i, 0);
        for (var u, l, c, d, h, f, p, m, w; !a.empty(); ) {
          u = a.pop(), l = u.value, d = u.cost, h = r[l] || {};
          for (c in h)
            h.hasOwnProperty(c) && (f = h[c], p = d + f, m = s[c], w = typeof s[c] > "u", (w || m > p) && (s[c] = p, a.push(c, p), o[c] = l));
        }
        if (typeof n < "u" && typeof s[n] > "u") {
          var v = ["Could not find a path from ", i, " to ", n, "."].join("");
          throw new Error(v);
        }
        return o;
      },
      extract_shortest_path_from_predecessor_list: function(r, i) {
        for (var n = [], o = i; o; )
          n.push(o), r[o], o = r[o];
        return n.reverse(), n;
      },
      find_path: function(r, i, n) {
        var o = t.single_source_shortest_paths(r, i, n);
        return t.extract_shortest_path_from_predecessor_list(
          o,
          n
        );
      },
      /**
       * A very naive priority queue implementation.
       */
      PriorityQueue: {
        make: function(r) {
          var i = t.PriorityQueue, n = {}, o;
          r = r || {};
          for (o in i)
            i.hasOwnProperty(o) && (n[o] = i[o]);
          return n.queue = [], n.sorter = r.sorter || i.default_sorter, n;
        },
        default_sorter: function(r, i) {
          return r.cost - i.cost;
        },
        /**
         * Add a new item to the queue and ensure the highest priority element
         * is at the front of the queue.
         */
        push: function(r, i) {
          var n = { value: r, cost: i };
          this.queue.push(n), this.queue.sort(this.sorter);
        },
        /**
         * Return the highest priority element in the queue.
         */
        pop: function() {
          return this.queue.shift();
        },
        empty: function() {
          return this.queue.length === 0;
        }
      }
    };
    e.exports = t;
  })(hu)), hu.exports;
}
var fm;
function aF() {
  return fm || (fm = 1, (function(e) {
    const t = zt(), r = tF(), i = rF(), n = nF(), o = iF(), s = Mb(), a = qt(), u = oF();
    function l(v) {
      return unescape(encodeURIComponent(v)).length;
    }
    function c(v, g, A) {
      const b = [];
      let k;
      for (; (k = v.exec(A)) !== null; )
        b.push({
          data: k[0],
          index: k.index,
          mode: g,
          length: k[0].length
        });
      return b;
    }
    function d(v) {
      const g = c(s.NUMERIC, t.NUMERIC, v), A = c(s.ALPHANUMERIC, t.ALPHANUMERIC, v);
      let b, k;
      return a.isKanjiModeEnabled() ? (b = c(s.BYTE, t.BYTE, v), k = c(s.KANJI, t.KANJI, v)) : (b = c(s.BYTE_KANJI, t.BYTE, v), k = []), g.concat(A, b, k).sort(function(x, C) {
        return x.index - C.index;
      }).map(function(x) {
        return {
          data: x.data,
          mode: x.mode,
          length: x.length
        };
      });
    }
    function h(v, g) {
      switch (g) {
        case t.NUMERIC:
          return r.getBitsLength(v);
        case t.ALPHANUMERIC:
          return i.getBitsLength(v);
        case t.KANJI:
          return o.getBitsLength(v);
        case t.BYTE:
          return n.getBitsLength(v);
      }
    }
    function f(v) {
      return v.reduce(function(g, A) {
        const b = g.length - 1 >= 0 ? g[g.length - 1] : null;
        return b && b.mode === A.mode ? (g[g.length - 1].data += A.data, g) : (g.push(A), g);
      }, []);
    }
    function p(v) {
      const g = [];
      for (let A = 0; A < v.length; A++) {
        const b = v[A];
        switch (b.mode) {
          case t.NUMERIC:
            g.push([
              b,
              { data: b.data, mode: t.ALPHANUMERIC, length: b.length },
              { data: b.data, mode: t.BYTE, length: b.length }
            ]);
            break;
          case t.ALPHANUMERIC:
            g.push([
              b,
              { data: b.data, mode: t.BYTE, length: b.length }
            ]);
            break;
          case t.KANJI:
            g.push([
              b,
              { data: b.data, mode: t.BYTE, length: l(b.data) }
            ]);
            break;
          case t.BYTE:
            g.push([
              { data: b.data, mode: t.BYTE, length: l(b.data) }
            ]);
        }
      }
      return g;
    }
    function m(v, g) {
      const A = {}, b = { start: {} };
      let k = ["start"];
      for (let y = 0; y < v.length; y++) {
        const x = v[y], C = [];
        for (let I = 0; I < x.length; I++) {
          const M = x[I], Q = "" + y + I;
          C.push(Q), A[Q] = { node: M, lastCount: 0 }, b[Q] = {};
          for (let H = 0; H < k.length; H++) {
            const J = k[H];
            A[J] && A[J].node.mode === M.mode ? (b[J][Q] = h(A[J].lastCount + M.length, M.mode) - h(A[J].lastCount, M.mode), A[J].lastCount += M.length) : (A[J] && (A[J].lastCount = M.length), b[J][Q] = h(M.length, M.mode) + 4 + t.getCharCountIndicator(M.mode, g));
          }
        }
        k = C;
      }
      for (let y = 0; y < k.length; y++)
        b[k[y]].end = 0;
      return { map: b, table: A };
    }
    function w(v, g) {
      let A;
      const b = t.getBestModeForData(v);
      if (A = t.from(g, b), A !== t.BYTE && A.bit < b.bit)
        throw new Error('"' + v + '" cannot be encoded with mode ' + t.toString(A) + `.
 Suggested mode is: ` + t.toString(b));
      switch (A === t.KANJI && !a.isKanjiModeEnabled() && (A = t.BYTE), A) {
        case t.NUMERIC:
          return new r(v);
        case t.ALPHANUMERIC:
          return new i(v);
        case t.KANJI:
          return new o(v);
        case t.BYTE:
          return new n(v);
      }
    }
    e.fromArray = function(g) {
      return g.reduce(function(A, b) {
        return typeof b == "string" ? A.push(w(b, null)) : b.data && A.push(w(b.data, b.mode)), A;
      }, []);
    }, e.fromString = function(g, A) {
      const b = d(g, a.isKanjiModeEnabled()), k = p(b), y = m(k, A), x = u.find_path(y.map, "start", "end"), C = [];
      for (let I = 1; I < x.length - 1; I++)
        C.push(y.table[x[I]].node);
      return e.fromArray(f(C));
    }, e.rawSplit = function(g) {
      return e.fromArray(
        d(g, a.isKanjiModeEnabled())
      );
    };
  })(uu)), uu;
}
var hm;
function sF() {
  if (hm) return Qs;
  hm = 1;
  const e = qt(), t = Cc(), r = G9(), i = W9(), n = H9(), o = K9(), s = Q9(), a = Pb(), u = Z9(), l = X9(), c = eF(), d = zt(), h = aF();
  function f(y, x) {
    const C = y.size, I = o.getPositions(x);
    for (let M = 0; M < I.length; M++) {
      const Q = I[M][0], H = I[M][1];
      for (let J = -1; J <= 7; J++)
        if (!(Q + J <= -1 || C <= Q + J))
          for (let W = -1; W <= 7; W++)
            H + W <= -1 || C <= H + W || (J >= 0 && J <= 6 && (W === 0 || W === 6) || W >= 0 && W <= 6 && (J === 0 || J === 6) || J >= 2 && J <= 4 && W >= 2 && W <= 4 ? y.set(Q + J, H + W, !0, !0) : y.set(Q + J, H + W, !1, !0));
    }
  }
  function p(y) {
    const x = y.size;
    for (let C = 8; C < x - 8; C++) {
      const I = C % 2 === 0;
      y.set(C, 6, I, !0), y.set(6, C, I, !0);
    }
  }
  function m(y, x) {
    const C = n.getPositions(x);
    for (let I = 0; I < C.length; I++) {
      const M = C[I][0], Q = C[I][1];
      for (let H = -2; H <= 2; H++)
        for (let J = -2; J <= 2; J++)
          H === -2 || H === 2 || J === -2 || J === 2 || H === 0 && J === 0 ? y.set(M + H, Q + J, !0, !0) : y.set(M + H, Q + J, !1, !0);
    }
  }
  function w(y, x) {
    const C = y.size, I = l.getEncodedBits(x);
    let M, Q, H;
    for (let J = 0; J < 18; J++)
      M = Math.floor(J / 3), Q = J % 3 + C - 8 - 3, H = (I >> J & 1) === 1, y.set(M, Q, H, !0), y.set(Q, M, H, !0);
  }
  function v(y, x, C) {
    const I = y.size, M = c.getEncodedBits(x, C);
    let Q, H;
    for (Q = 0; Q < 15; Q++)
      H = (M >> Q & 1) === 1, Q < 6 ? y.set(Q, 8, H, !0) : Q < 8 ? y.set(Q + 1, 8, H, !0) : y.set(I - 15 + Q, 8, H, !0), Q < 8 ? y.set(8, I - Q - 1, H, !0) : Q < 9 ? y.set(8, 15 - Q - 1 + 1, H, !0) : y.set(8, 15 - Q - 1, H, !0);
    y.set(I - 8, 8, 1, !0);
  }
  function g(y, x) {
    const C = y.size;
    let I = -1, M = C - 1, Q = 7, H = 0;
    for (let J = C - 1; J > 0; J -= 2)
      for (J === 6 && J--; ; ) {
        for (let W = 0; W < 2; W++)
          if (!y.isReserved(M, J - W)) {
            let P = !1;
            H < x.length && (P = (x[H] >>> Q & 1) === 1), y.set(M, J - W, P), Q--, Q === -1 && (H++, Q = 7);
          }
        if (M += I, M < 0 || C <= M) {
          M -= I, I = -I;
          break;
        }
      }
  }
  function A(y, x, C) {
    const I = new r();
    C.forEach(function(W) {
      I.put(W.mode.bit, 4), I.put(W.getLength(), d.getCharCountIndicator(W.mode, y)), W.write(I);
    });
    const M = e.getSymbolTotalCodewords(y), Q = a.getTotalCodewordsCount(y, x), H = (M - Q) * 8;
    for (I.getLengthInBits() + 4 <= H && I.put(0, 4); I.getLengthInBits() % 8 !== 0; )
      I.putBit(0);
    const J = (H - I.getLengthInBits()) / 8;
    for (let W = 0; W < J; W++)
      I.put(W % 2 ? 17 : 236, 8);
    return b(I, y, x);
  }
  function b(y, x, C) {
    const I = e.getSymbolTotalCodewords(x), M = a.getTotalCodewordsCount(x, C), Q = I - M, H = a.getBlocksCount(x, C), J = I % H, W = H - J, P = Math.floor(I / H), R = Math.floor(Q / H), V = R + 1, X = P - R, N = new u(X);
    let U = 0;
    const G = new Array(H), re = new Array(H);
    let oe = 0;
    const ie = new Uint8Array(y.buffer);
    for (let we = 0; we < H; we++) {
      const ve = we < W ? R : V;
      G[we] = ie.slice(U, U + ve), re[we] = N.encode(G[we]), U += ve, oe = Math.max(oe, ve);
    }
    const le = new Uint8Array(I);
    let he = 0, ye, be;
    for (ye = 0; ye < oe; ye++)
      for (be = 0; be < H; be++)
        ye < G[be].length && (le[he++] = G[be][ye]);
    for (ye = 0; ye < X; ye++)
      for (be = 0; be < H; be++)
        le[he++] = re[be][ye];
    return le;
  }
  function k(y, x, C, I) {
    let M;
    if (Array.isArray(y))
      M = h.fromArray(y);
    else if (typeof y == "string") {
      let P = x;
      if (!P) {
        const R = h.rawSplit(y);
        P = l.getBestVersionForData(R, C);
      }
      M = h.fromString(y, P || 40);
    } else
      throw new Error("Invalid data");
    const Q = l.getBestVersionForData(M, C);
    if (!Q)
      throw new Error("The amount of data is too big to be stored in a QR Code");
    if (!x)
      x = Q;
    else if (x < Q)
      throw new Error(
        `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + Q + `.
`
      );
    const H = A(x, C, M), J = e.getSymbolSize(x), W = new i(J);
    return f(W, x), p(W), m(W, x), v(W, C, 0), x >= 7 && w(W, x), g(W, H), isNaN(I) && (I = s.getBestMask(
      W,
      v.bind(null, W, C)
    )), s.applyMask(I, W), v(W, C, I), {
      modules: W,
      version: x,
      errorCorrectionLevel: C,
      maskPattern: I,
      segments: M
    };
  }
  return Qs.create = function(x, C) {
    if (typeof x > "u" || x === "")
      throw new Error("No input text");
    let I = t.M, M, Q;
    return typeof C < "u" && (I = t.from(C.errorCorrectionLevel, t.M), M = l.from(C.version), Q = s.from(C.maskPattern), C.toSJISFunc && e.setToSJISFunction(C.toSJISFunc)), k(x, M, I, Q);
  }, Qs;
}
var pu = {}, mu = {}, pm;
function jb() {
  return pm || (pm = 1, (function(e) {
    function t(r) {
      if (typeof r == "number" && (r = r.toString()), typeof r != "string")
        throw new Error("Color should be defined as hex string");
      let i = r.slice().replace("#", "").split("");
      if (i.length < 3 || i.length === 5 || i.length > 8)
        throw new Error("Invalid hex color: " + r);
      (i.length === 3 || i.length === 4) && (i = Array.prototype.concat.apply([], i.map(function(o) {
        return [o, o];
      }))), i.length === 6 && i.push("F", "F");
      const n = parseInt(i.join(""), 16);
      return {
        r: n >> 24 & 255,
        g: n >> 16 & 255,
        b: n >> 8 & 255,
        a: n & 255,
        hex: "#" + i.slice(0, 6).join("")
      };
    }
    e.getOptions = function(i) {
      i || (i = {}), i.color || (i.color = {});
      const n = typeof i.margin > "u" || i.margin === null || i.margin < 0 ? 4 : i.margin, o = i.width && i.width >= 21 ? i.width : void 0, s = i.scale || 4;
      return {
        width: o,
        scale: o ? 4 : s,
        margin: n,
        color: {
          dark: t(i.color.dark || "#000000ff"),
          light: t(i.color.light || "#ffffffff")
        },
        type: i.type,
        rendererOpts: i.rendererOpts || {}
      };
    }, e.getScale = function(i, n) {
      return n.width && n.width >= i + n.margin * 2 ? n.width / (i + n.margin * 2) : n.scale;
    }, e.getImageWidth = function(i, n) {
      const o = e.getScale(i, n);
      return Math.floor((i + n.margin * 2) * o);
    }, e.qrToImageData = function(i, n, o) {
      const s = n.modules.size, a = n.modules.data, u = e.getScale(s, o), l = Math.floor((s + o.margin * 2) * u), c = o.margin * u, d = [o.color.light, o.color.dark];
      for (let h = 0; h < l; h++)
        for (let f = 0; f < l; f++) {
          let p = (h * l + f) * 4, m = o.color.light;
          if (h >= c && f >= c && h < l - c && f < l - c) {
            const w = Math.floor((h - c) / u), v = Math.floor((f - c) / u);
            m = d[a[w * s + v] ? 1 : 0];
          }
          i[p++] = m.r, i[p++] = m.g, i[p++] = m.b, i[p] = m.a;
        }
    };
  })(mu)), mu;
}
var mm;
function uF() {
  return mm || (mm = 1, (function(e) {
    const t = jb();
    function r(n, o, s) {
      n.clearRect(0, 0, o.width, o.height), o.style || (o.style = {}), o.height = s, o.width = s, o.style.height = s + "px", o.style.width = s + "px";
    }
    function i() {
      try {
        return document.createElement("canvas");
      } catch {
        throw new Error("You need to specify a canvas element");
      }
    }
    e.render = function(o, s, a) {
      let u = a, l = s;
      typeof u > "u" && (!s || !s.getContext) && (u = s, s = void 0), s || (l = i()), u = t.getOptions(u);
      const c = t.getImageWidth(o.modules.size, u), d = l.getContext("2d"), h = d.createImageData(c, c);
      return t.qrToImageData(h.data, o, u), r(d, l, c), d.putImageData(h, 0, 0), l;
    }, e.renderToDataURL = function(o, s, a) {
      let u = a;
      typeof u > "u" && (!s || !s.getContext) && (u = s, s = void 0), u || (u = {});
      const l = e.render(o, s, u), c = u.type || "image/png", d = u.rendererOpts || {};
      return l.toDataURL(c, d.quality);
    };
  })(pu)), pu;
}
var gu = {}, gm;
function cF() {
  if (gm) return gu;
  gm = 1;
  const e = jb();
  function t(n, o) {
    const s = n.a / 255, a = o + '="' + n.hex + '"';
    return s < 1 ? a + " " + o + '-opacity="' + s.toFixed(2).slice(1) + '"' : a;
  }
  function r(n, o, s) {
    let a = n + o;
    return typeof s < "u" && (a += " " + s), a;
  }
  function i(n, o, s) {
    let a = "", u = 0, l = !1, c = 0;
    for (let d = 0; d < n.length; d++) {
      const h = Math.floor(d % o), f = Math.floor(d / o);
      !h && !l && (l = !0), n[d] ? (c++, d > 0 && h > 0 && n[d - 1] || (a += l ? r("M", h + s, 0.5 + f + s) : r("m", u, 0), u = 0, l = !1), h + 1 < o && n[d + 1] || (a += r("h", c), c = 0)) : u++;
    }
    return a;
  }
  return gu.render = function(o, s, a) {
    const u = e.getOptions(s), l = o.modules.size, c = o.modules.data, d = l + u.margin * 2, h = u.color.light.a ? "<path " + t(u.color.light, "fill") + ' d="M0 0h' + d + "v" + d + 'H0z"/>' : "", f = "<path " + t(u.color.dark, "stroke") + ' d="' + i(c, l, u.margin) + '"/>', p = 'viewBox="0 0 ' + d + " " + d + '"', w = '<svg xmlns="http://www.w3.org/2000/svg" ' + (u.width ? 'width="' + u.width + '" height="' + u.width + '" ' : "") + p + ' shape-rendering="crispEdges">' + h + f + `</svg>
`;
    return typeof a == "function" && a(null, w), w;
  }, gu;
}
var bm;
function lF() {
  if (bm) return Kt;
  bm = 1;
  const e = V9(), t = sF(), r = uF(), i = cF();
  function n(o, s, a, u, l) {
    const c = [].slice.call(arguments, 1), d = c.length, h = typeof c[d - 1] == "function";
    if (!h && !e())
      throw new Error("Callback required as last argument");
    if (h) {
      if (d < 2)
        throw new Error("Too few arguments provided");
      d === 2 ? (l = a, a = s, s = u = void 0) : d === 3 && (s.getContext && typeof l > "u" ? (l = u, u = void 0) : (l = u, u = a, a = s, s = void 0));
    } else {
      if (d < 1)
        throw new Error("Too few arguments provided");
      return d === 1 ? (a = s, s = u = void 0) : d === 2 && !s.getContext && (u = a, a = s, s = void 0), new Promise(function(f, p) {
        try {
          const m = t.create(a, u);
          f(o(m, s, u));
        } catch (m) {
          p(m);
        }
      });
    }
    try {
      const f = t.create(a, u);
      l(null, o(f, s, u));
    } catch (f) {
      l(f);
    }
  }
  return Kt.create = t.create, Kt.toCanvas = n.bind(null, r.render), Kt.toDataURL = n.bind(null, r.renderToDataURL), Kt.toString = n.bind(null, function(o, s, a) {
    return i.render(o, a);
  }), Kt;
}
var dF = lF();
const Fb = /* @__PURE__ */ _y(dF), fF = async ({ url: e, title: t, download: r }) => {
  const i = await Fb.toDataURL(e), n = t && !t.includes("pause0x0") && !t.includes("pause1x1") && !t.includes("pause2x2");
  return {
    contentType: yc,
    content: {
      urlData: {
        url: e,
        title: n ? t : void 0,
        download: r
      },
      qrCode: i
    }
  };
}, hF = async (e) => {
  const t = [];
  for (const r of e) {
    const i = await Fb.toDataURL(r.url), n = {
      contentType: yc,
      content: {
        urlData: {
          url: r.url,
          title: r.title,
          download: r.download
        },
        qrCode: i
      }
    };
    t.push(n);
  }
  return t;
}, pF = async (e) => {
  const t = await mF(e.url);
  let r = !1;
  return t.width === 0 && t.height === 0 ? e = {
    url: `${$2}/no-image.png`,
    alt: "Image no found"
  } : r = t.width < 400 && t.height < 300, {
    contentType: DI,
    content: {
      ...e,
      isMiniature: r
    }
  };
}, mF = async (e) => new Promise((t) => {
  const r = new Image();
  r.onload = () => t({ width: r.naturalWidth, height: r.naturalHeight }), r.onerror = () => {
    t({ width: 0, height: 0 });
  }, r.src = e;
}), gF = (e) => {
  const t = {
    speak: void 0,
    text: void 0,
    htmlText: void 0,
    images: [],
    urls: []
  }, r = [], i = [];
  if (e != null && e.speak) {
    const n = Mu(e.speak);
    t.speak = n.text, t.images = n.images, t.urls = n.urls, n.images.forEach((o) => {
      r.push(o.url);
    }), n.urls.forEach((o) => {
      i.push(o.url);
    });
  }
  if (e != null && e.text) {
    const n = Mu(e.text);
    t.text = n.text, t.htmlText = n.htmlText, n.images.forEach((o) => {
      !r.includes(o.url) && t.images.push(o);
    }), n.urls.forEach((o) => {
      !i.includes(o.url) && t.urls.push(o);
    });
  }
  return t;
}, Fu = {
  activities: [],
  endedActivities: [],
  lastActivity: void 0,
  lastBotActivity: void 0,
  messageActivities: [],
  lastMessageActivity: void 0,
  eventActivities: [],
  lastEventActivity: void 0,
  botMessageActivities: [],
  lastBotMessageActivity: void 0,
  botEventActivities: [],
  lastBotEventActivity: void 0,
  botStreamingActivities: {},
  processedActivity: void 0,
  userMessageActivities: [],
  lastUserMessageActivity: void 0,
  conversationId: null,
  watermark: 0,
  retrievingConversation: !1,
  addRetorikNewsConversationIdInLocalStorage: void 0,
  cookies: [],
  queue: [],
  queueLock: !1
}, bu = /(\{data-command=")[\p{L}\p{N}\p{Po}\p{Pd}\p{Pc}\s\u0027\u2019]+("\})(<br\s\/>)?/gu, $b = mt({
  name: "activity",
  initialState: Fu,
  reducers: {
    addCookie: (e, t) => {
      t.payload && (e.cookies = [...e.cookies, t.payload]);
    },
    setCookiesInBrowser: (e, t) => {
      const r = e.cookies;
      r.length && (r.forEach((i) => {
        if (i.indexOf("<conversationId>") > -1) {
          if (t.payload) {
            const n = i.replace("<conversationId>", t.payload);
            document.cookie = n;
          }
        } else
          document.cookie = i;
      }), e.cookies = []);
    },
    setCurrentQueue: (e, t) => {
      e.queue = t.payload;
    },
    setQueueLock: (e, t) => {
      e.queueLock = t.payload;
    },
    addUserEvent: (e, t) => e.conversationId && t.payload.id.includes(e.conversationId) ? (!z2.find((r) => {
      var i;
      return (i = t.payload.name) == null ? void 0 : i.toLowerCase().includes(r);
    }) && Bt(!0), {
      ...e,
      activities: [...e.activities, t.payload],
      lastActivity: t.payload,
      lastEventActivity: t.payload,
      eventActivities: [...e.eventActivities, t.payload],
      watermark: e.watermark + 1
    }) : { ...e },
    addEndedActivity: (e, t) => {
      e.endedActivities.includes(t.payload) || (e.endedActivities = [...e.endedActivities, t.payload]);
    },
    setRetrievingConversation: (e, t) => {
      e.retrievingConversation = t.payload;
    },
    setAddRetorikNewsConversationIdInLocalStorage: (e, t) => {
      e.addRetorikNewsConversationIdInLocalStorage = t.payload;
    },
    resetProcessedActivity: (e) => {
      e.processedActivity = void 0;
    },
    resetActivityStore: () => ({ ...Fu })
  },
  extraReducers: (e) => {
    e.addCase(Rc.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    })).addCase(gn.fulfilled, (t, r) => r.payload ? {
      ...t,
      ...r.payload
    } : { ...t }).addCase(Oc.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    })).addCase(Dc.fulfilled, (t, r) => r.payload ? {
      ...t,
      ...r.payload
    } : { ...t }).addCase(Pc.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    })).addCase(Ic.fulfilled, (t, r) => r.payload ? {
      ...t,
      ...r.payload
    } : { ...t }).addCase(Mc.fulfilled, (t, r) => r.payload ? {
      ...t,
      ...r.payload
    } : { ...t }).addCase(Lb.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    }));
  }
}), Rc = Ae("activity/checkConversationId", async (e, t) => {
  const r = t.getState().activityReducer;
  let i = {};
  if (r.addRetorikNewsConversationIdInLocalStorage) {
    const n = {
      conversationId: e,
      startedAt: Date.now()
    };
    localStorage.setItem(`Retorik.News.Conversation.${r.addRetorikNewsConversationIdInLocalStorage}`, JSON.stringify(n)), i.addRetorikNewsConversationIdInLocalStorage = void 0;
  }
  return e && e !== r.conversationId && (r.conversationId === null ? i.conversationId = e : i = { ...Fu, conversationId: e }, t.dispatch(Nb(e))), i;
}), gn = Ae("activity/processQueue", async (e, t) => {
  const r = t.getState().activityReducer;
  if (r.queue.length) {
    const i = r.queue[0];
    i.type === "message" ? await t.dispatch(Oc(i)) : await t.dispatch(Pc(i)), t.dispatch(Bb(r.queue.slice(1))), await t.dispatch(gn());
    return;
  } else
    return { queueLock: !1 };
}), Oc = Ae("activity/processAddBotMessage", async (e, t) => {
  t.dispatch(Jg(void 0)), await t.dispatch(Lb(e));
  const r = t.getState().activityReducer, i = structuredClone(r.processedActivity), n = r.retrievingConversation ? void 0 : i;
  return !r.retrievingConversation && i && t.dispatch(Bc(i)), i ? {
    activities: [...r.activities, i],
    lastActivity: n,
    lastBotActivity: n,
    messageActivities: [...r.messageActivities, i],
    botMessageActivities: [...r.botMessageActivities, i],
    lastMessageActivity: n,
    lastBotMessageActivity: n,
    processedActivity: void 0,
    watermark: r.watermark + 1
  } : {
    lastActivity: n,
    lastBotActivity: n,
    lastMessageActivity: n,
    lastBotMessageActivity: n,
    watermark: r.watermark + 1
  };
}), Dc = Ae("activity/addBotMessage", async (e, t) => {
  const r = t.getState().activityReducer;
  if (r.conversationId && e.id.includes(r.conversationId)) {
    if (r.queueLock)
      return { queue: [...r.queue, e] };
    t.dispatch(jc(!0)), await t.dispatch(Oc(e)), t.dispatch(fn()), t.dispatch(Bt(!1)), await t.dispatch(gn());
    return;
  }
}), Pc = Ae("activity/processAddBotEvent", async (e, t) => {
  var n, o;
  const r = t.getState().activityReducer, i = structuredClone(r.botStreamingActivities);
  if (((n = e.name) == null ? void 0 : n.toLowerCase()) === "davi.streammessageactivity" && (o = e.text) != null && o.trim().length && !r.retrievingConversation) {
    const s = Mu(e.text, !0);
    if (e.speak = s.text, e.htmlText = s.htmlText, t.dispatch(Bc(e)), e.replyToId) {
      const a = i[e.replyToId];
      i[e.replyToId] = a ? [...a, e] : [e];
    }
  }
  return {
    activities: [...r.activities, e],
    lastActivity: r.retrievingConversation ? void 0 : e,
    lastBotActivity: r.retrievingConversation ? void 0 : e,
    eventActivities: [...r.eventActivities, e],
    botEventActivities: [...r.botEventActivities, e],
    lastBotEventActivity: e,
    lastEventActivity: e,
    botStreamingActivities: i,
    watermark: r.watermark + 1
  };
}), Ic = Ae("activity/addBotEvent", async (e, t) => {
  var i;
  const r = t.getState().activityReducer;
  if (r.conversationId && e.id.includes(r.conversationId)) {
    if (((i = e.name) == null ? void 0 : i.toLowerCase()) === "switchtotextmode")
      return t.dispatch(Lc(Ft.text)), {
        watermark: r.watermark + 1
      };
    if (r.queueLock)
      return { queue: [...r.queue, e] };
    t.dispatch(jc(!0)), await t.dispatch(Pc(e)), t.dispatch(fn()), t.dispatch(Bt(!1)), t.dispatch(gn());
    return;
  }
}), Mc = Ae("activity/addUserMessage", async (e, t) => {
  const r = t.getState().activityReducer;
  if (r.conversationId && e.id.includes(r.conversationId))
    return t.dispatch(Bt(!0)), {
      activities: [...r.activities, e],
      lastActivity: e,
      messageActivities: [...r.messageActivities, e],
      userMessageActivities: [...r.userMessageActivities, e],
      lastMessageActivity: e,
      lastUserMessageActivity: e,
      watermark: r.watermark + 1
    };
}), Lb = Ae("activity/processBotMessageActivity", async (e, t) => {
  var o, s, a, u, l, c, d, h, f, p, m, w, v, g, A, b, k, y, x, C, I;
  const r = t.getState();
  if (t.dispatch(Zg(!!((o = e == null ? void 0 : e.channelData) != null && o.restoreInputsState))), t.dispatch(rb(((a = (s = e.value) == null ? void 0 : s.retorik) == null ? void 0 : a.placeHolder) || void 0)), t.dispatch(nb((l = (u = e.value) == null ? void 0 : u.retorik) == null ? void 0 : l.submitDelay)), ((c = e.attachmentLayout) == null ? void 0 : c.toLowerCase()) === "namedlist" && ((d = e.attachments) != null && d.length)) {
    const M = (h = e.attachments[0].content) == null ? void 0 : h.value;
    if (Array.isArray(M) && M.length > 12) {
      const Q = (f = e.attachments[0].content) == null ? void 0 : f.title, H = M.pop(), J = Math.ceil(M.length / 11), W = [], P = r.localeReducer.locale || "fr-FR";
      M.forEach((R) => {
        if (R.text) {
          const V = R.text.split(" ");
          V.length > 1 ? R.group = V[1].charAt(0).toLocaleUpperCase(P) : R.group = V[0].charAt(0).toLocaleUpperCase(P);
        }
      });
      for (let R = 0; R < J; R++)
        W.push({
          contentType: jI,
          content: {
            title: Q,
            value: [...M.slice(R * 11, R * 11 + 11), H]
          }
        });
      e.attachments = W;
    }
  }
  if (r.retorikReducer.configuration.isUsedOnBorne && ((p = e.attachments) != null && p.length)) {
    let M = 0;
    const Q = [];
    for (const H of e.attachments)
      if (H.contentType === yc && Array.isArray((m = H.content) == null ? void 0 : m.urlData)) {
        M++;
        const J = await hF(H.content.urlData);
        Q.push(...J);
      } else
        Q.push(H);
    M && (e.attachments = Q), M && e.attachments.length > 1 && (e.attachmentLayout = "carousel");
  }
  const i = gF(e);
  if (i.speak && (e.speak = i.speak), i.text && (e.text = i.text), i.htmlText && (e.htmlText = i.htmlText), i.images.length) {
    e.attachments === void 0 && (e.attachments = []);
    for (const M of i.images) {
      const Q = await pF(M);
      e.attachments.push(Q);
    }
    e.attachments.length > 1 && (e.attachmentLayout = "carousel");
  }
  if (i.urls.length) {
    e.attachments === void 0 && (e.attachments = []);
    for (const M of i.urls) {
      const Q = await fF(M);
      e.attachments.push(Q);
    }
    e.attachments.length > 1 && (e.attachmentLayout = "carousel");
  }
  const n = U9(e.attachments);
  if (n && (e.attachments = [...n]), (w = e.suggestedActions) != null && w.actions && ((v = e.attachmentLayout) == null ? void 0 : v.toLowerCase()) !== "davilist") {
    let M = [];
    e.suggestedActions.actions.forEach((H) => {
      const J = {
        title: H.title,
        action: H.value
      };
      M = [...M, J];
    });
    const Q = {
      contentType: II,
      content: {
        title: e.text || "",
        actions: M
      }
    };
    e.attachments === void 0 ? e.attachments = [Q] : e.attachments.push(Q);
  }
  if (e != null && e.text && e.text.includes("{data-command=")) {
    const M = e.text.split("{data-command="), Q = [];
    for (let H = 1; H < M.length; H++) {
      const J = M[H - 1].substring(M[H - 1].lastIndexOf(`
`) ? M[H - 1].lastIndexOf(`
`) + 1 : 0).trim(), W = M[H].substring(0, M[H].indexOf("}")).replaceAll('"', "");
      Q.push({
        text: J,
        differentTextToSend: W
      }), e.speak && (e.speak = e.speak.replace(J, "")), e.text = e.text.replace(J, ""), e.htmlText = (g = e.htmlText) == null ? void 0 : g.replace(J, "");
    }
    if (Q.length > 0) {
      const H = {
        contentType: PI,
        content: {
          suggestions: Q,
          showTutorial: !1
        }
      };
      e.attachments === void 0 ? e.attachments = [H] : e.attachments.push(H);
    }
    e.speak && (e.speak = e.speak.replaceAll(bu, "")), e.text = e.text.replaceAll(bu, ""), e.htmlText = (A = e.htmlText) == null ? void 0 : A.replaceAll(bu, "");
  }
  if (((k = (b = e.value) == null ? void 0 : b.retorik) != null && k.placeHolder || (x = (y = e.value) == null ? void 0 : y.retorik) != null && x.submitDelay) && !((C = e.attachments) != null && C.length) && (e.attachments = [
    {
      contentType: MI
    }
  ]), (I = r.retorikReducer.configuration.speechRecognitionOptions) != null && I.inputHintBehaviour)
    switch (r.retorikReducer.configuration.speechRecognitionOptions.inputHintBehaviour.toLowerCase()) {
      case Vr.always:
        e.inputHint = "expectingInput";
        break;
      case Vr.ignore:
      case Vr.never:
        e.inputHint = "ignoreInput";
        break;
      case Vr.auto:
    }
  return {
    processedActivity: e
  };
}), bF = $b.reducer, {
  addCookie: vF,
  setCookiesInBrowser: Nb,
  setCurrentQueue: Bb,
  setQueueLock: jc,
  addUserEvent: qb,
  addEndedActivity: yF,
  setRetrievingConversation: zb,
  setAddRetorikNewsConversationIdInLocalStorage: wF,
  resetProcessedActivity: _F,
  resetActivityStore: Ub
} = $b.actions, Vb = {
  directLine: null,
  directLineStatus: Zt.ConnectionStatus.Uninitialized,
  connectionStatusSubscription: null,
  activitySubscription: null,
  userId: "",
  externalActivityHandlers: [],
  paginationToSend: 10,
  positionToSend: void 0,
  activityWatermark: 0,
  conversationPaused: !1,
  typingCount: 0,
  storedVeilleConversationData: void 0,
  version: void 0,
  applicationIsBusy: !1
}, kF = [Ie.SEND_MESSAGE, Ie.SEND_EVENT], xF = ["setuser", "davi.gdprconsent"], It = (e) => (e < 10 ? "0" : "") + e, Gb = (e = /* @__PURE__ */ new Date()) => {
  const t = -e.getTimezoneOffset(), r = t >= 0 ? "+" : "-";
  return e.getFullYear() + "-" + It(e.getMonth() + 1) + "-" + It(e.getDate()) + "T" + It(e.getHours()) + ":" + It(e.getMinutes()) + ":" + It(e.getSeconds()) + r + It(Math.floor(Math.abs(t) / 60)) + ":" + It(Math.abs(t) % 60);
}, SF = (e, t) => {
  const r = e;
  return e.from ? e.from.role || (e.from.id === t ? r.from = { ...r.from, role: "user" } : e.from.id ? r.from = { ...r.from, role: "bot" } : r.from = { ...r.from, role: "channel" }) : r.from = { ...r.from, role: "channel" }, r;
}, tr = (e, t, r) => {
  if (r.length) {
    const i = {
      type: e,
      payload: {
        activity: t
      }
    };
    for (let n = 0; n < r.length; n++) {
      const o = r[n];
      if (o(i))
        return console.log("Retorik Framework > aborted activity"), !0;
    }
  }
  return !1;
}, Wb = (e, t, r, i) => {
  const n = {
    pageSize: e || 10,
    version: r
  };
  return t != null && t.latitude && t.longitude && (n.location = {
    latitude: t.latitude,
    longitude: t.longitude
  }, n.position = {
    latitude: t.latitude,
    longitude: t.longitude
  }), i ? { ...n, ...i } : n;
}, Hb = mt({
  name: "directline",
  initialState: Vb,
  reducers: {
    dispatchStatus: (e, t) => {
      e.directLineStatus = t.payload, e.externalActivityHandlers.forEach((r) => {
        r({
          type: vc[t.payload]
        }), t.payload === Zt.ConnectionStatus.Online && r({
          type: Ie.SET_LANGUAGE
        });
      });
    },
    setActivityWatermark: (e, t) => {
      e.activityWatermark = t.payload;
    },
    unsubscribe: (e) => {
      var t, r;
      (t = e.connectionStatusSubscription) == null || t.unsubscribe(), (r = e.activitySubscription) == null || r.unsubscribe();
    },
    sendTyping: (e) => {
      var t;
      e.conversationPaused || ((t = e.directLine) == null || t.postActivity({
        from: {
          id: e.userId
        },
        type: "typing"
      }).subscribe(), e.typingCount = e.typingCount + 1);
    },
    setPaginationToSend: (e, t) => {
      e.paginationToSend = t.payload;
    },
    addExternalActivityHandler: (e, t) => {
      e.externalActivityHandlers = [...e.externalActivityHandlers, t.payload];
    },
    setExternalActivityHandlers: (e, t) => {
      e.externalActivityHandlers = t.payload;
    },
    setPositionToSend: (e, t) => {
      e.positionToSend = t.payload;
    },
    dispatchMarkActivity: (e, t) => {
      const r = {
        type: Ie.MARK,
        payload: {
          activityID: t.payload.id,
          name: "speak",
          value: t.payload.speaking
        }
      };
      e.externalActivityHandlers.forEach((i) => {
        i(r);
      });
    },
    pauseConversation: (e) => {
      e.conversationPaused = !0;
    },
    resumeConversation: (e) => {
      e.conversationPaused = !1;
    },
    setVersion: (e, t) => {
      e.version = t.payload;
    },
    setStoredVeilleConversationData: (e, t) => {
      e.storedVeilleConversationData = t.payload ? {
        ...e.storedVeilleConversationData,
        id: t.payload
      } : void 0;
    },
    setApplicationIsBusy: (e, t) => {
      e.applicationIsBusy = t.payload;
    }
  },
  extraReducers: (e) => {
    e.addCase(rn.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    })).addCase(Kb.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    })).addCase(Qb.fulfilled, (t, r) => r.payload ? {
      ...t,
      ...r.payload
    } : { ...t }).addCase(Zb.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    }));
  }
}), Fc = Ae("directline/dispatchActivity", async (e, t) => {
  var o, s, a, u, l, c;
  const r = t.getState();
  if (r.directlineReducer.conversationPaused)
    return;
  if (r.activityReducer.retrievingConversation) {
    const d = (o = r.directlineReducer.directLine) == null ? void 0 : o.watermark;
    if (!isNaN(parseInt(d))) {
      const h = r.directlineReducer.activityWatermark + 1;
      h === parseInt(d) ? t.dispatch(zb(!1)) : t.dispatch(ev(h));
    }
  }
  e.conversation && t.dispatch(Rc(e.conversation.id));
  const i = eI(SF(e, r.directlineReducer.userId));
  let n = Ie.UNKNOWN;
  switch (i.type) {
    case "message":
      n = i.from.role === "user" ? Ie.SEND_MESSAGE : Ie.INCOMING_ACTIVITY;
      break;
    case "event":
      n = i.from.role === "user" ? Ie.SEND_EVENT : Ie.INCOMING_ACTIVITY;
      break;
    case "typing":
      n = Ie.TYPING;
      break;
  }
  switch (t.dispatch(iv(i.replyToId)), n) {
    case Ie.SEND_EVENT:
      t.dispatch(qb(i));
      break;
    case Ie.SEND_MESSAGE:
      t.dispatch(Mc(i));
      break;
    case Ie.INCOMING_ACTIVITY: {
      let d = !0;
      tr(n, e, r.directlineReducer.externalActivityHandlers) ? (t.dispatch(Bt(!1)), t.dispatch(fn()), d = !1) : ((s = i.channelData) != null && s.speechRecognitionGrammars && t.dispatch(uv((a = i.channelData) == null ? void 0 : a.speechRecognitionGrammars)), i.type === "event" ? t.dispatch(Ic(i)) : i.type === "message" && (((u = i.label) == null ? void 0 : u.toLowerCase()) === "davi.bringupmessage" && r.directlineReducer.applicationIsBusy ? d = !1 : t.dispatch(Dc(i))), d && ((l = navigator.virtualKeyboard) == null || l.hide(), r.viewReducer.isTactile && ((c = document.getElementById("retorik-framework-send-textbox-textarea")) == null || c.blur())));
      break;
    }
  }
  kF.includes(n) && tr(Ie.POST_ACTIVITY_FULFILLED, e, r.directlineReducer.externalActivityHandlers);
}), rn = Ae("directline/subscribe", async (e, t) => {
  const r = e ? e.connectionStatus$.subscribe((n) => {
    t.dispatch(Xb(n));
  }) : null, i = e ? e.activity$.subscribe((n) => {
    n.type !== "typing" && t.dispatch(Fc(n));
  }) : null;
  return {
    directLine: e,
    connectionStatusSubscription: r,
    activitySubscription: i
  };
}), Kb = Ae("directline/createDirectline", async (e, t) => {
  const i = t.getState().directlineReducer.externalActivityHandlers, n = i.length ? i : e.externalActivityHandler ? [e.externalActivityHandler] : [];
  n.forEach((s) => {
    s({
      type: vc[0]
    });
  });
  const o = new Zt.DirectLine({
    webSocket: !0,
    ...e
  });
  return t.dispatch(rr()), t.dispatch(rn(o)), {
    userId: e.userId || "userId",
    externalActivityHandlers: n
  };
}), Qb = Ae("directline/recreateDirectline", async (e, t) => {
  var i, n, o, s, a, u;
  const r = t.getState().directlineReducer;
  if ((i = e.addressData) != null && i.directline)
    if ((n = e.userId) != null && n.includes("veille_") && ((o = r.storedVeilleConversationData) != null && o.userId) && ((s = r.storedVeilleConversationData) != null && s.id) && ((a = r.storedVeilleConversationData) != null && a.token)) {
      const l = r.storedVeilleConversationData, c = new Zt.DirectLine({
        token: l.token,
        domain: e.addressData.directline.address,
        conversationId: l.id
      });
      return await t.dispatch(rr()), await t.dispatch(rn(c)), {
        userId: e.userId
      };
    } else {
      const l = await XP(e.addressData.directline.tokenEndpoint);
      if (l) {
        const c = e.userId || `defaultId_${Date.now()}`;
        await t.dispatch(Ub()), r.externalActivityHandlers.forEach((h) => {
          h({
            type: vc[0]
          });
        });
        const d = new Zt.DirectLine({
          token: l,
          domain: e.addressData.directline.address
        });
        return await t.dispatch(rr()), await t.dispatch(rn(d)), await t.dispatch(
          $u({
            name: "Davi.GDPRConsent",
            value: {
              userConsent: !0
            },
            callback: () => t.dispatch(
              $u({
                name: "setUser",
                value: {
                  user: {
                    name: "default",
                    id: c,
                    username: "default",
                    nom: "defaultName",
                    prenom: "à vous",
                    email: "",
                    token: "",
                    referrer: "",
                    ipaddress: "",
                    gdprConsent: !0
                  },
                  skipWelcome: !!e.skipWelcome
                }
              })
            )
          })
        ), (u = e.userId) != null && u.includes("veille_") ? {
          userId: c,
          storedVeilleConversationData: { userId: e.userId, token: l }
        } : {
          userId: c
        };
      }
    }
}), $c = Ae("directline/checkMicrophoneAndCancel", async (e, t) => {
  const r = t.getState();
  r.speechReducer.mode === Ft.vocal && r.speechReducer.activeRecognitionState === at.Listening ? t.dispatch(Nc(void 0)) : t.dispatch(Vn());
}), Yb = Ae("directline/sendMessage", async (e, t) => {
  var o;
  const r = t.getState();
  if (r.directlineReducer.conversationPaused)
    return;
  t.dispatch($c());
  const i = await t.dispatch(Qg()), n = {
    from: {
      id: r.directlineReducer.userId
    },
    type: "message",
    channelData: Wb(
      r.directlineReducer.paginationToSend,
      r.directlineReducer.positionToSend,
      r.directlineReducer.version,
      r.retorikReducer.configuration.channelData
    ),
    localTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    localTimestamp: Gb(),
    locale: i.payload
  };
  e.text && (n.text = e.text), e.value && (n.value = e.value), tr(Ie.POST_ACTIVITY, n, r.directlineReducer.externalActivityHandlers) || tr(Ie.SEND_MESSAGE, n, r.directlineReducer.externalActivityHandlers) ? (t.dispatch(Bt(!1)), t.dispatch(fn())) : (o = r.directlineReducer.directLine) == null || o.postActivity(n).subscribe();
}), $u = Ae("directline/sendEvent", async (e, t) => {
  var o;
  const r = t.getState();
  if (r.directlineReducer.conversationPaused)
    return;
  !e.name.toLowerCase().includes("davi.closewindow") && !xF.includes(e.name.toLowerCase()) && t.dispatch($c());
  const i = await t.dispatch(Qg()), n = {
    from: {
      id: r.directlineReducer.userId
    },
    type: "event",
    channelData: Wb(
      r.directlineReducer.paginationToSend,
      r.directlineReducer.positionToSend,
      r.directlineReducer.version,
      r.retorikReducer.configuration.channelData
    ),
    locale: i.payload,
    localTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    localTimestamp: Gb(),
    name: e.name,
    value: e.value
  };
  tr(Ie.POST_ACTIVITY, n, r.directlineReducer.externalActivityHandlers) || tr(Ie.SEND_EVENT, n, r.directlineReducer.externalActivityHandlers) || (o = r.directlineReducer.directLine) == null || o.postActivity(n).subscribe({
    error: (s) => console.log("Retorik Framework > error while sending event : ", s),
    complete: () => {
      var s;
      return (s = e.callback) == null ? void 0 : s.call(e);
    }
  });
}), Jb = Ae("directline/endConversation", async (e, t) => {
  var i;
  t.dispatch(rr()), (i = t.getState().directlineReducer.directLine) == null || i.end();
}), Zb = Ae("directline/resetDirectlineStore", async (e, t) => (t.dispatch(rr()), await t.dispatch(Jb()), { ...Vb })), EF = Ae("directline/sendMessageToChatbot", async (e, t) => {
  const r = t.getState();
  if (e && r.activityReducer.conversationId && r.localeReducer.locale) {
    const i = {
      type: "message",
      conversation: {
        id: r.activityReducer.conversationId
      },
      id: `fake-bot-${r.activityReducer.conversationId}`,
      from: {
        id: "fake-bot-id"
      },
      locale: r.localeReducer.locale,
      text: e,
      speak: e
    };
    t.dispatch(Fc(i));
  }
}), AF = Hb.reducer, {
  dispatchStatus: Xb,
  setActivityWatermark: ev,
  unsubscribe: rr,
  sendTyping: TF,
  setPaginationToSend: CF,
  addExternalActivityHandler: RF,
  setExternalActivityHandlers: OF,
  setPositionToSend: DF,
  dispatchMarkActivity: PF,
  pauseConversation: IF,
  resumeConversation: MF,
  setStoredVeilleConversationData: jF,
  setApplicationIsBusy: FF
} = Hb.actions, $F = async () => {
  try {
    return navigator.mediaDevices.getUserMedia({ audio: !0 }).then(
      (e) => e ? ht.allowed : ht.refused,
      (e) => (console.log(
        "Retorik Framework > microphone permission refused : ",
        e
      ), ht.refused)
    ).catch((e) => (console.log(
      "Retorik Framework > microphone permission refused : ",
      e
    ), ht.error));
  } catch (e) {
    return console.log("Retorik Framework > microphone permission refused : ", e), ht.error;
  }
}, vm = {
  ponyfillCredentials: void 0,
  useContinuousRecognition: !1,
  customVoice: void 0,
  voice: null,
  mode: Ft.text,
  disableSound: !1,
  speaking: !1,
  muted: !1,
  cancel: !1,
  boundaryData: [],
  visemeData: [],
  singleVisemeAdded: null,
  multiVisemesAdded: [],
  streamingReplyToId: null,
  streamingQueue: [],
  streamingReplyToIdToIgnore: null,
  currentOrLastPlayedActivity: void 0,
  isMicrophoneAllowed: !1,
  showMicrophoneModal: !1,
  permissionStatus: ht.waiting,
  activeRecognitionState: at.Closed,
  lastRecognitionInterim: "",
  speechRecognitionDynamicGrammars: [],
  externalTextToSpeech: void 0
}, tv = mt({
  name: "speech",
  initialState: vm,
  reducers: {
    setPonyfillFactoryCredentials: (e, t) => {
      e.ponyfillCredentials = t.payload;
    },
    setUseContinuousRecognition: (e, t) => {
      var r, i;
      if ((r = t.payload.options) != null && r.enableContinuousRecognitionOnAllDevices)
        e.useContinuousRecognition = !0;
      else if ((i = t.payload.options) != null && i.enableContinuousRecognitionOn)
        switch (t.payload.deviceType) {
          case je.mobile:
            e.useContinuousRecognition = !!t.payload.options.enableContinuousRecognitionOn.mobile;
            break;
          case je.widget:
          case je.widgetLandscape:
          case je.widgetBorne:
            e.useContinuousRecognition = !!t.payload.options.enableContinuousRecognitionOn.widget;
            break;
          case je.landscape:
            e.useContinuousRecognition = !!t.payload.options.enableContinuousRecognitionOn.desktop;
            break;
          case je.borne:
            e.useContinuousRecognition = !!t.payload.options.enableContinuousRecognitionOn.borne;
            break;
          default:
            e.useContinuousRecognition = !1;
            break;
        }
      else
        e.useContinuousRecognition = !1;
    },
    setCustomVoice: (e, t) => {
      e.customVoice = t.payload;
    },
    setVoice: (e, t) => {
      e.voice = t.payload;
    },
    setDisableSound: (e, t) => {
      e.disableSound = t.payload;
    },
    setMuted: (e, t) => {
      e.muted = t.payload;
    },
    toggleMuted: (e) => {
      e.muted = !e.muted;
    },
    cancelCurrentUtterance: (e) => {
      e.cancel = !0;
    },
    resetCancelCurrentUtterance: (e) => {
      e.cancel = !1;
    },
    setBoundaryData: (e, t) => {
      e.boundaryData = t.payload;
    },
    setVisemeData: (e, t) => {
      e.visemeData = t.payload, e.multiVisemesAdded = t.payload;
    },
    addViseme: (e, t) => {
      e.visemeData = [...e.visemeData, t.payload], e.singleVisemeAdded = t.payload;
    },
    setIsMicrophoneAllowed: (e, t) => {
      e.isMicrophoneAllowed = t.payload;
    },
    setShowMicrophoneModal: (e, t) => {
      e.showMicrophoneModal = t.payload;
    },
    setActiveRecognitionState: (e, t) => {
      e.activeRecognitionState = t.payload;
    },
    setLastRecognitionInterim: (e, t) => {
      e.lastRecognitionInterim = t.payload;
    },
    setStreamingReplyToId: (e, t) => {
      e.streamingReplyToId = t.payload;
    },
    addToStreamingQueue: (e, t) => {
      t.payload.replyToId ? t.payload.replyToId !== e.streamingReplyToIdToIgnore && (e.streamingReplyToId !== t.payload.replyToId ? (e.streamingReplyToId = t.payload.replyToId, e.streamingQueue = [t.payload]) : e.streamingQueue = [...e.streamingQueue, t.payload]) : e.streamingQueue = [...e.streamingQueue, t.payload];
    },
    // If "twice" parameter is true, let's remove 2 elements instead of one (used with the message at the end of a streaming that should not be spoken)
    removeFirstFromStreamingQueue: (e, t) => {
      e.streamingQueue = e.streamingQueue.slice(t.payload ? 2 : 1);
    },
    killCurrentStreaming: (e) => {
      e.streamingReplyToIdToIgnore = e.streamingReplyToId, e.streamingQueue = [];
    },
    addSpeechRecognitionDynamicGrammar: (e, t) => {
      const r = e.speechRecognitionDynamicGrammars;
      if (Array.isArray(t.payload)) {
        const i = [];
        t.payload.forEach((n) => {
          !r.includes(n) && i.push(n);
        }), i.length && (e.speechRecognitionDynamicGrammars = [...r, ...i]);
      } else
        !r.includes(t.payload) && (e.speechRecognitionDynamicGrammars = [...r, t.payload]);
    },
    playExternalSynthesis: (e, t) => {
      e.externalTextToSpeech = t.payload;
    },
    resetSpeechStore: () => ({ ...vm })
  },
  extraReducers: (e) => {
    e.addCase(Lc.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    })).addCase(rv.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    })).addCase(Lu.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    })).addCase(Lu.rejected, (t) => ({
      ...t,
      permissionStatus: ht.error,
      isMicrophoneAllowed: !1
    })).addCase(nv.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    }));
  }
}), Lc = Ae("speech/setMode", async (e, t) => {
  const r = t.getState();
  return t.dispatch(Bg(void 0)), e !== Ft.text && t.dispatch(Ug(!1)), !r.speechReducer.disableSound && t.dispatch(ov(e === Ft.text)), {
    mode: e
  };
}), rv = Ae("speech/setSpeaking", async (e, t) => (t.dispatch(zg(e ? Ru.SpeechStarted : Ru.SpeechEnded)), e === !1 ? { speaking: e, visemeData: [], singleVisemeAdded: null, multiVisemesAdded: [] } : { speaking: e })), Nc = Ae("speech/toggleMicrophone", async (e, t) => {
  var i, n;
  const r = t.getState();
  if (r.speechReducer.mode === Ft.text)
    t.dispatch(Mn(at.Closed));
  else
    switch (r.speechReducer.activeRecognitionState) {
      // Do nothing if we are in a transition state
      case at.Initializing:
      case at.Closing:
        return;
      case at.Listening: {
        const o = r.speechReducer.lastRecognitionInterim;
        t.dispatch(Mn(at.ForceClosing)), (n = (i = r.retorikReducer.configuration) == null ? void 0 : i.speechRecognitionOptions) != null && n.enableSendMessageOnMicrophoneClose && o ? t.dispatch(Yb({ text: o })) : t.dispatch(Vn());
        break;
      }
      case at.Closed: {
        t.dispatch(Mn(at.Initializing)), !e && t.dispatch(Vn());
        break;
      }
    }
}), Lu = Ae("speech/askPermission", async (e, t) => {
  t.dispatch(av(!0));
  const r = await $F();
  return r === ht.allowed ? (t.dispatch(Nc(void 0)), {
    permissionStatus: r,
    isMicrophoneAllowed: !0,
    showMicrophoneModal: !1
  }) : {
    permissionStatus: r,
    isMicrophoneAllowed: !1
  };
}), nv = Ae("speech/setCurrentOrLastPlayedActivity", async (e, t) => {
  var i;
  const r = t.getState();
  return ((i = e == null ? void 0 : e.attachmentLayout) == null ? void 0 : i.toLowerCase()) === "davilist" && r.utilsReducer.listStatus !== Bn.opened && t.dispatch(qg(Bn.available)), { currentOrLastPlayedActivity: e };
}), iv = Ae("speech/checkActivityReplyToId", async (e, t) => {
  t.getState().speechReducer.streamingReplyToId !== e && t.dispatch(sv());
}), LF = tv.reducer, {
  setPonyfillFactoryCredentials: NF,
  setUseContinuousRecognition: BF,
  setCustomVoice: qF,
  setVoice: zF,
  setDisableSound: UF,
  setMuted: ov,
  toggleMuted: VF,
  cancelCurrentUtterance: Vn,
  resetCancelCurrentUtterance: GF,
  setBoundaryData: WF,
  setVisemeData: HF,
  addViseme: KF,
  setIsMicrophoneAllowed: QF,
  setShowMicrophoneModal: av,
  setActiveRecognitionState: Mn,
  setLastRecognitionInterim: YF,
  setStreamingReplyToId: JF,
  addToStreamingQueue: Bc,
  removeFirstFromStreamingQueue: ZF,
  killCurrentStreaming: sv,
  addSpeechRecognitionDynamicGrammar: uv,
  playExternalSynthesis: XF,
  resetSpeechStore: e$
} = tv.actions, t$ = {
  visibility: "visible",
  currentDeviceType: je.landscape,
  isMobile: !1,
  isWidget: !1,
  isLandscape: !0,
  isBorne: !1,
  themeColors: BP,
  theme: Lg.light,
  configurations: {
    homeRoute: "home",
    views: {
      home: {
        background: {
          image: "",
          style: "image"
        }
      }
    }
  },
  veilleConfiguration: {
    enabled: !1
  },
  mapConfiguration: {
    settings: void 0
  },
  route: gc.Home,
  currentHeight: 1080,
  currentWidth: 1920,
  isTactile: window.matchMedia("(any-pointer: coarse)").matches,
  isMobileLandscape: !1,
  displayControls: !0,
  mediumLandscape: !1,
  characterLoaded: !1,
  calibrationCompleted: !1
}, cv = mt({
  name: "view",
  initialState: t$,
  reducers: {
    setVisibility: (e, t) => {
      e.visibility = t.payload;
    },
    toggleVisibility: (e) => {
      e.visibility = e.visibility === "visible" ? "hidden" : "visible";
    },
    checkMobileLandscape: (e) => {
      e.isMobileLandscape = e.currentDeviceType === je.mobile && e.currentHeight < e.currentWidth;
    },
    setTheme: (e, t) => {
      e.theme = t.payload;
    },
    setThemeColors: (e, t) => {
      e.themeColors = t.payload;
    },
    setViewsConfiguration: (e, t) => {
      e.configurations = t.payload;
    },
    setVeilleConfiguration: (e, t) => {
      e.veilleConfiguration = t.payload;
    },
    setMapConfiguration: (e, t) => {
      e.mapConfiguration = t.payload;
    },
    setDisplayControls: (e, t) => {
      e.displayControls = t.payload;
    },
    setCharacterLoaded: (e, t) => {
      e.characterLoaded = t.payload;
    },
    setCalibrationCompleted: (e, t) => {
      e.calibrationCompleted = t.payload;
    }
  },
  extraReducers: (e) => {
    e.addCase(lv.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    })).addCase(dv.fulfilled, (t, r) => r.payload ? {
      ...t,
      ...r.payload
    } : { ...t }).addCase(fv.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    })).addCase(hv.fulfilled, (t, r) => ({
      ...t,
      ...r.payload
    }));
  }
}), lv = Ae("view/setCurrentDeviceType", async (e, t) => (t.dispatch(hi()), {
  currentDeviceType: e,
  isMobile: L2.includes(e),
  isWidget: N2.includes(e),
  isLandscape: B2.includes(e),
  isBorne: q2.includes(e)
})), dv = Ae("view/setRoute", async (e, t) => {
  let r = !1;
  return e === gc.News ? t.getState().retorikReducer.enabledFeatures.includes("news") ? r = !0 : console.log("Retorik Framework > tried to switch to the news while the feature is not activated in Retorik Studio") : r = !0, r ? {
    route: e
  } : void 0;
}), fv = Ae("view/setCurrentHeight", async (e, t) => (t.dispatch(hi()), {
  currentHeight: e
})), hv = Ae("view/setCurrentWidth", async (e, t) => (t.dispatch(hi()), {
  currentWidth: e,
  mediumLandscape: e < F2
})), r$ = cv.reducer, {
  setVisibility: n$,
  toggleVisibility: i$,
  checkMobileLandscape: hi,
  setTheme: o$,
  setThemeColors: a$,
  setViewsConfiguration: s$,
  setVeilleConfiguration: u$,
  setMapConfiguration: c$,
  setDisplayControls: l$,
  setCharacterLoaded: d$,
  setCalibrationCompleted: f$
} = cv.actions, h$ = wm({ widgetReducer: s2, utilsReducer: h2, localeReducer: zP, adaptiveCardReducer: KP, speechReducer: LF, retorikReducer: uI, viewReducer: r$, activityReducer: bF, directlineReducer: AF }), p$ = ty({
  middleware: (e) => e({
    serializableCheck: !1
  }),
  reducer: h$
}), vu = {
  widget: {
    closeWidget: c2,
    openWidget: u2,
    toggleDisplay: d2,
    toggleWidget: l2
  },
  utils: {
    setFullScreenImage: p2,
    setLastListActivity: Bg,
    setListStatus: qg,
    setCloseList: m2,
    setCurrentSubView: g2,
    setCurrentCustomView: b2,
    setRetorikEvent: zg,
    showAgent: v2,
    hideAgent: y2,
    setRetorikNewsEnded: w2,
    setUserTyping: Ug,
    setUserSwiping: _2,
    askForKioskParametersOpening: k2,
    addDetailedAttachmentTrigger: x2,
    setModalFullscreenContent: S2,
    setModalFullscreenContentFromActivity: E2,
    setGDPRDisplay: A2,
    setGDPRWindowData: T2,
    setGDPRUserConsent: C2,
    lockClickedButton: R2,
    unlockClickedButton: fn,
    setDashboardOpened: O2,
    toggleDashboard: D2,
    setClickedOnUI: f2,
    setCloseDetailedPOI: M2,
    resetUtilsStore: j2
  },
  locale: {
    addDumpedLanguageFallback: GP,
    addReplacementLocale: WP,
    fetchSupportedLanguages: Kg,
    resetLocaleStore: HP,
    setBaseAddress: UP,
    setLanguageData: VP,
    setLocale: Hg
  },
  adaptiveCard: {
    setValue: QP,
    setToggleValue: YP,
    setCurrentId: Jg,
    addCurrentToggleId: JP,
    setRestoreInputsState: Zg,
    resetAdaptiveCardStore: ZP
  },
  speech: {
    setPonyfillFactoryCredentials: NF,
    setUseContinuousRecognition: BF,
    setCustomVoice: qF,
    setVoice: zF,
    setDisableSound: UF,
    setMuted: ov,
    toggleMuted: VF,
    cancelCurrentUtterance: Vn,
    resetCancelCurrentUtterance: GF,
    setBoundaryData: WF,
    setVisemeData: HF,
    addViseme: KF,
    setIsMicrophoneAllowed: QF,
    setShowMicrophoneModal: av,
    setActiveRecognitionState: Mn,
    setLastRecognitionInterim: YF,
    setStreamingReplyToId: JF,
    addToStreamingQueue: Bc,
    removeFirstFromStreamingQueue: ZF,
    killCurrentStreaming: sv,
    addSpeechRecognitionDynamicGrammar: uv,
    playExternalSynthesis: XF,
    resetSpeechStore: e$,
    setMode: Lc,
    setSpeaking: rv,
    toggleMicrophone: Nc,
    askPermission: Lu,
    setCurrentOrLastPlayedActivity: nv,
    checkActivityReplyToId: iv
  },
  retorik: {
    setConfiguration: cI,
    setAddressData: lI,
    focusSendBox: dI,
    setCanFocusSendBox: fI,
    setSendBoxPlaceHolder: rb,
    setLayout: hI,
    setUserAlreadySet: pI,
    setEnvironmentPreset: mI,
    setFromTextToVocal: gI,
    setLoaderClosed: bI,
    setAppAvailable: vI,
    setSubtitlesInConfiguration: yI,
    setDisplaySubtitles: wI,
    toggleSubtitles: _I,
    setSkipLoader: kI,
    setDisplayAgentInNews: xI,
    setSubmitDelayBeforeSendingMessage: nb,
    setCustomScripts: SI,
    setCustomCSS: EI,
    setEnabledFeatures: AI,
    setShowPositionModal: TI,
    resetRetorikStore: CI,
    setAgentData: tb,
    setIsWaitingForResponse: Bt
  },
  view: {
    setVisibility: n$,
    toggleVisibility: i$,
    checkMobileLandscape: hi,
    setTheme: o$,
    setViewsConfiguration: s$,
    setVeilleConfiguration: u$,
    setMapConfiguration: c$,
    setDisplayControls: l$,
    setCharacterLoaded: d$,
    setCalibrationCompleted: f$,
    setCurrentDeviceType: lv,
    setThemeColors: a$,
    setRoute: dv,
    setCurrentHeight: fv,
    setCurrentWidth: hv
  },
  activity: {
    addCookie: vF,
    setCookiesInBrowser: Nb,
    setCurrentQueue: Bb,
    setQueueLock: jc,
    addUserEvent: qb,
    addEndedActivity: yF,
    setRetrievingConversation: zb,
    setAddRetorikNewsConversationIdInLocalStorage: wF,
    resetProcessedActivity: _F,
    resetActivityStore: Ub,
    checkConversationId: Rc,
    processQueue: gn,
    addBotMessage: Dc,
    addBotEvent: Ic,
    addUserMessage: Mc
  },
  directline: {
    dispatchStatus: Xb,
    setActivityWatermark: ev,
    unsubscribe: rr,
    sendTyping: TF,
    setPaginationToSend: CF,
    addExternalActivityHandler: RF,
    setExternalActivityHandlers: OF,
    setPositionToSend: DF,
    dispatchMarkActivity: PF,
    pauseConversation: IF,
    resumeConversation: MF,
    setStoredVeilleConversationData: jF,
    setApplicationIsBusy: FF,
    dispatchActivity: Fc,
    subscribe: rn,
    createDirectline: Kb,
    recreateDirectline: Qb,
    checkMicrophoneAndCancel: $c,
    sendMessage: Yb,
    sendEvent: $u,
    endConversation: Jb,
    sendMessageToChatbot: EF,
    resetDirectlineStore: Zb
  }
}, b$ = Zt.ConnectionStatus;
export {
  b$ as ConnectionStatus,
  p$ as default,
  vu as storeActions
};
